import { FormPropsSchema, FlowPropsSchema, NonEmptyId, SelectOptionValueSchema, SELECT_MAX_OPTIONS, FLOW_MAX_FIELDS_PER_STEP, FLOW_MAX_STEPS, AskQuestionSchema, PresentFlowSchema, normalizeBranchKey, FLOW_MAX_TOTAL_STEPS, FLOW_MAX_TOTAL_FIELDS, FLOW_MAX_BRANCH_CASES, FLOW_MAX_BRANCH_DEPTH } from './chunk-EG6ISLSR.js';
export { ASK_USER_QUESTION_TOOL_NAME, AskQuestionSchema, CLARIFICATION_MAX_OPTIONS, CLARIFICATION_MAX_QUESTIONS, ClarificationOptionSchema, ClarificationQuestionSchema, FLOW_MAX_BRANCH_CASES, FLOW_MAX_BRANCH_DEPTH, FLOW_MAX_FIELDS_PER_STEP, FLOW_MAX_STEPS, FLOW_MAX_TOTAL_FIELDS, FLOW_MAX_TOTAL_STEPS, FLOW_PARSE_DEPTH_CEILING, FlowPropsSchema, FlowStepSchema, FlowSubmissionSchema, FormFieldNameSchema, FormFieldSchema, FormFieldTypeSchema, FormFieldWithRangeCheck, FormPropsSchema, GATHER_INPUTS_TOOL_NAME, NonEmptyId, PRESENT_USER_FLOW_TOOL_NAME, PresentFlowSchema, QuestionAnswerItemSchema, QuestionAnswerSchema, SELECT_MAX_OPTIONS, SelectOptionValueSchema, canonicalFieldKey, flowBranchDepthMessage, measureFlowBranchDepth, normalizeBranchKey, toFormFieldName } from './chunk-EG6ISLSR.js';
import { WidgetThemeConfigSchema, WIDGET_LOADING_ANIMATIONS, WIDGET_ICON_STYLES, CSS_OVERRIDE_MAX_BYTES, WidgetElementColorsSchema, CatalogDesignSchema, sanitizeToolText, redactSecrets, validateCustomCss, GUIDANCE_WEIGHT_MAX } from './chunk-DJ6CXJRM.js';
export { AGENT_TOOL_BUDGET, ARGUMENT_DEFAULT_MAX_JSON_LENGTH, ARGUMENT_KEY_MAX, ARGUMENT_OVERRIDES_MAX, ArgumentOverrideSchema, ArgumentOverridesSchema, BULK_CAPABILITY_IDS_MAX, BulkSetCapabilityOverrideInputSchema, CONFIDENCE_DYNAMIC, CONFIDENCE_HIGH, CONFIDENCE_MEDIUM, CONFIDENCE_STRONG, CONFIDENCE_WEAK, CSS_OVERRIDE_MAX_BYTES, CapabilityEntityEdgeSchema, CapabilityGraphEdgeKindSchema, CapabilityGraphEdgeSchema, CapabilityGraphNodeKindSchema, CapabilityGraphNodeSchema, CapabilityGraphSchema, CapabilityGuidanceInputSchema, CapabilityGuidanceSchema, CapabilityOverrideEditableSchema, CapabilityOverrideSchema, CatalogDesignSchema, CatalogDesignTokenSchema, CatalogEventKindSchema, CatalogEventSchema, CatalogSchema, CatalogSourceMetaSchema, ComponentDiscoverySchema, ComponentPropSchema, ConnectionGraphSchema, DESCRIBE_ENDPOINT_TOOL_NAME, DataModelFieldSchema, DataModelOrmSchema, DataModelSchema, DerivedEntitySchema, DesignDriftReportSchema, DesignTokenChangeSchema, ENRICHMENT_LOCALIZATION_INSTRUCTION, ENRICHMENT_SYNTHETIC_QUERIES_INSTRUCTION, EntityRelationshipSchema, FormFlowSchema, FormFlowStepSchema, FormLibrarySchema, FusedDesignSchema, GOVERNANCE_FILE_VERSION, GOVERNANCE_PRESETS, GOVERNANCE_PRESET_IDS, GOVERNANCE_PRIORITIES, GUIDANCE_BODY_MAX, GUIDANCE_CLAUSES_MAX, GUIDANCE_KINDS, GUIDANCE_SERVING_TOTAL_MAX, GUIDANCE_WEIGHT_MAX, GUIDANCE_WEIGHT_MIN, GovernanceEntrySchema, GovernanceFileSchema, GraphEvidenceSchema, GuidanceKindSchema, GuidanceSurfaceSchema, LANGUAGE_SUBTAG_PATTERN, LanguageSubtagSchema, MAX_DESIGN_TOKENS, MAX_GRAPH_CAPABILITY_EDGES, MAX_GRAPH_ENTITIES, MAX_GRAPH_PAGE_EDGES, MAX_GRAPH_RELATIONSHIPS, MAX_REPORT_PROVENANCE, MAX_REPORT_SNAPS, MAX_REPORT_TOKENS, MODALITY_HINTS, ModalityHintSchema, PageCapabilityEdgeSchema, REQUIREDNESS_CONFIDENCE_BAND, RouteEntrySchema, RouteLivenessReportSchema, RouteSourceSchema, RuleCompareOpSchema, RuleMatchValueSchema, RuleScalarSchema, RuleValueSourceSchema, SCHEMA_TOKEN_WEIGHT_CAP, SIMILARITY_INTERFERENCE_THRESHOLD, SITE_ANALYSIS_CONFIDENCES, ScopeRenamesSchema, ScopeSchema, SetCapabilityGuidanceInputSchema, SetCapabilityOverrideInputSchema, SiteAnalysisReportSchema, SiteAnalysisSnapSchema, SiteAnalysisTokenProvenanceSchema, TOOL_RULE_AUDIENCE_ID_MAX, TOOL_RULE_LOCALE_MAX, TOOL_RULE_MAX_AUDIENCES, TOOL_RULE_MAX_CONDITIONS, TOOL_RULE_MAX_EXPRESSION_DEPTH, TOOL_RULE_MAX_LOCALES, TOOL_RULE_MAX_OPERANDS, TOOL_RULE_MAX_SCOPES, TOOL_RULE_PATH_MAX, TOOL_RULE_STRING_MAX, TOOL_SCHEMA_BOUNDS, TRANSLATE_LOCALIZATION_TOOL_NAME, ToolAvailabilityRuleSchema, ToolRuleConditionSchema, ToolRuleExpressionSchema, UI_UNIT_ID_PATTERN, UI_UNIT_KINDS, UiApiCallKindSchema, UiApiCallSchema, UiComponentApiMapSchema, UiComponentRendersSchema, UiControlKindSchema, UiControlSchema, UiFillUnitSchema, UiHighlightUnitSchema, UiNavigateUnitSchema, UiSignalComponentApiSchema, UiSignalControlSchema, UiSignalFormFlowSchema, UiSignalRouteSchema, UiSignalsSchema, UiUnitSchema, UploadDataModelSchema, UploadDataModelsSchema, UploadEventSchema, UploadEventsSchema, VERSION_NOTE_MAX, VersionNoteSchema, VisitorLocaleConditionSchema, VisitorLocaleExpressionSchema, WIDGET_COLOR_SCHEMES, WIDGET_ICON_STYLES, WIDGET_LOADING_ANIMATIONS, WidgetElementColorsSchema, WidgetThemeConfigSchema, WorkflowProposalSchema, WorkflowStepSchema, applyCustomRedactions, buildCapabilityGraph, buildCatalogUploadBody, buildDescribeEndpointPrompt, buildEnrichmentInputCanonical, buildGovernanceFile, buildTranslateLocalizationPrompt, buildTranslateLocalizationToolJsonSchema, callableCapabilities, canonicalEndpointKey, capabilityDomain, capabilityGroundingContext, capabilityToGraphqlInput, catalogServices, clampToSideEffectFloor, collectPiiFieldNames, correlateControlCapabilities, countRequestArgs, deriveUiUnits, describeEndpointLocalizedSchema, describeEndpointResponseSchema, describeEndpointToolJsonSchema, detectDesignDrift, diffRouteLiveness, emptyConnectionGraph, enrichmentDedupeKey, enrichmentLanguageDirective, estimateSchemaTokens, evaluateEasyToolContract, findGovernancePreset, foldLocalizedResponse, fuseDesign, governanceKey, gradeAgentReadiness, gradeDescriptionSimilarity, gradeRubricCompliance, gradeSchemaTokenWeight, gradeToolCount, hasToolTextInjection, isCallableTool, isCapabilityId, isEnforceableRequired, jaccardSimilarity, maskPiiFields, mergeEnrichment, methodSideEffectFloor, normalizeSideEffect, orderGuidance, parseGovernanceFile, planGovernanceImport, planPreset, prepareUploadCapability, prepareUploadDataModels, prepareUploadEvents, prepareUploadUiSignals, primaryLanguageSubtag, proposeWorkflows, redactPersistedCapabilityText, redactSecrets, repairLocalization, requestSections, resolveLocalizedText, responseSection, ruleMentionsAudience, ruleMentionsLocale, safeParseCapabilityShape, safeParseSiteAnalysisReport, sameEndpoint, sanitizeToolParameters, sanitizeToolSchemaBody, sanitizeToolText, scoreConfidence, serializeCatalogForHash, shouldEnrichCapability, toOneLinePurpose, tokenSet, toolRuleExpressionDepth, translateLocalizationResponseSchema, validateCustomCss, workflowGroundingLine } from './chunk-DJ6CXJRM.js';
import { CurrencyCodeSchema, ChartValueFormatSchema, ChartKindSchema, DataSourceRefSchema, BAND_TONES, CHART_INTERPOLATIONS, ChartSeriesSchema, CHART_MAX_SERIES, ChartDataPointSchema, CHART_MAX_POINTS, WELCOME_DIGEST_SCALES } from './chunk-FOR36YEU.js';
export { BAND_TONES, CHART_INTERPOLATIONS, CHART_MAX_POINTS, CHART_MAX_SERIES, ChartColorSchema, ChartDataPointSchema, ChartKindSchema, ChartSeriesSchema, ChartValueFormatSchema, CurrencyCodeSchema, DESCRIBED_BLOCK_CAP, DataSourceCatalogEntrySchema, DataSourceCatalogParamSchema, DataSourceCatalogSchema, DataSourceRefSchema, FORGET_PREFERENCE_TOOL_NAME, MAX_DATA_SOURCES, PRESENT_COMPOSITION_TOOL_NAME, REMEMBER_PREFERENCE_TOOL_NAME, compositionTranscriptContent, describeCompositionStructure } from './chunk-FOR36YEU.js';
import { LabelSchema, BodyTextSchema, ActionSchema, PRIMITIVE_LIST_MAX_ITEMS, PRIMITIVE_MARKDOWN_MAX, PRIMITIVE_LABEL_MAX, PRIMITIVE_TABLE_MAX_ROWS, PRIMITIVE_TABLE_MAX_COLUMNS, PrimitiveTypeSchema } from './chunk-DEPQ2OSO.js';
export { ACCENT_AWARE_PRIMITIVE_TYPES, ActionSchema, ActionToolCategorySchema, BodyTextSchema, LabelSchema, PRIMITIVE_FORM_MAX_FIELDS, PRIMITIVE_LABEL_MAX, PRIMITIVE_LIST_MAX_ITEMS, PRIMITIVE_MARKDOWN_MAX, PRIMITIVE_STRING_MAX, PRIMITIVE_TABLE_MAX_COLUMNS, PRIMITIVE_TABLE_MAX_ROWS, PRIMITIVE_TYPES, PrimitiveTypeSchema } from './chunk-DEPQ2OSO.js';
import { WalkthroughSchema, ANNOTATION_CONTROL_PATTERN, ANNOTATION_CONTROL_MAX, WALKTHROUGH_MAX_STEPS, TASK_GUIDE_ID_PATTERN, TASK_GUIDE_ID_MAX, ANNOTATION_TEXT_MAX } from './chunk-KR425E5Z.js';
export { ANNOTATION_CONTROL_MAX, ANNOTATION_CONTROL_PATTERN, ANNOTATION_MAX_DURATION_MS, ANNOTATION_SELECTOR_MAX, ANNOTATION_TEXT_MAX, AnnotationKindSchema, AnnotationPayloadSchema, AnnotationSchema, AnnotationTargetSchema, TEXT_REQUIRED_KINDS, WALKTHROUGH_MAX_STEPS, WALKTHROUGH_PERFORM_VALUE_MAX, WALKTHROUGH_ROUTE_ID_MAX, WALKTHROUGH_ROUTE_ID_PATTERN, WALKTHROUGH_TITLE_MAX, WalkthroughPerformSchema, WalkthroughSchema, WalkthroughStepSchema } from './chunk-KR425E5Z.js';
import { CaptureHttpMethodSchema, CaptureRefSchema, CaptureRouteRefSchema, CaptureErrorClassSchema, redactPiiInline } from './chunk-AYGMX5PZ.js';
export { CAPTURE_ERROR_CLASSES, CAPTURE_HTTP_METHODS, CaptureErrorClassSchema, CaptureHttpMethodSchema, CaptureRefSchema, CaptureRouteRefSchema, MAX_CAPTURE_REF_CHARS, PII_REDACTION_PLACEHOLDER, looksLikePii, redactPiiInline, stripUrlToRoute } from './chunk-AYGMX5PZ.js';
import { RestBodyEncodingSchema, GraphqlInputObjectSchema, WsReplySchema, CAPABILITY_ID_PATTERN, CapabilityExampleSchema, MAX_CAPABILITY_EXAMPLES, SideEffectSchema } from './chunk-ZY5LZSWZ.js';
export { ArgSchema, ArgTypeSchema, AuthFlowAnnotationSchema, AuthProviderSchema, AuthStrategySchema, CAPABILITY_ID_PATTERN, CAPABILITY_PROVENANCES, CapabilityExampleSchema, CapabilityExamplesSchema, CapabilityLocalizationSchema, CapabilityPrioritySchema, CapabilityProvenanceSchema, CapabilitySchema, CapabilitySourceSchema, FRONTEND_DERIVED_FRAMEWORKS, FrameworkSchema, GraphQLOpSchema, GraphqlInputObjectSchema, GrpcOpSchema, HttpMethodSchema, JobAnnotationSchema, JobProviderSchema, LatencyMsSchema, LocalizedTextSchema, MAX_CAPABILITY_EXAMPLES, MAX_HANDLER_TEXT_BYTES, MAX_SYNTHETIC_QUERIES, MethodSchema, PaginationAnnotationSchema, PaginationStyleSchema, RateLimitAnnotationSchema, RateLimitSourceSchema, RestBodyEncodingSchema, RiskSchema, SchemaSourceSchema, ShapeSchema, SideEffectSchema, SseOpSchema, StreamingDescriptorSchema, SyntheticQueriesSchema, TrpcOpSchema, WebhookAnnotationSchema, WebhookConfidenceSchema, WebhookKindSchema, WebhookProviderSchema, WsOpSchema, WsReplySchema, collectGraphqlArgTypes, collectGraphqlInputObject, isFrontendDerivedFramework, isPublicCapability } from './chunk-ZY5LZSWZ.js';
import { contentHash } from './chunk-LNHDZZEJ.js';
export { canonicalize, contentHash, fnv1aHex } from './chunk-LNHDZZEJ.js';
import { SUPPORTED_LOCALES, LOCALE_CODES, getLocaleNumberingSystem, DEFAULT_LOCALE, isSupportedLocale } from './chunk-BTYFPOCZ.js';
export { DEFAULT_LOCALE, LOCALE_CODES, LocaleCodeSchema, SUPPORTED_LOCALES, getLocaleDirection, getLocaleMetadata, getLocaleNumberingSystem, isSupportedLocale } from './chunk-BTYFPOCZ.js';
import { ActionEvidenceListSchema, ControlFingerprintSchema, stableDigest, clusterPathTemplate, routeTemplatesMatch, stableId, controlAxisDigest } from './chunk-CE5XPGEA.js';
import { HARVESTED_ROUTE_PATH_PATTERN, MAX_HARVESTED_ROUTE_PATH_CHARS, RuntimeUiCoverageGapsSchema } from './chunk-NOQNWA6J.js';
import { RUNTIME_UI_SIGNATURE_PATTERN } from './chunk-DHOJC3F4.js';
import './chunk-DTQUYCTY.js';
import { z } from 'zod';

// src/errors/syncanix-error.ts
var SyncanixError = class extends Error {
  code;
  details;
  constructor(code, message, details = {}) {
    super(message);
    this.name = this.constructor.name;
    this.code = code;
    this.details = details;
    Object.setPrototypeOf(this, new.target.prototype);
  }
  /** Serialize for the wire / logs. Excludes the stack to avoid leaking internals. */
  toJSON() {
    return { code: this.code, message: this.message, details: this.details };
  }
};
var NotFoundError = class extends SyncanixError {
  constructor(message = "Not found", details = {}) {
    super("NOT_FOUND", message, details);
  }
};
var PermissionError = class extends SyncanixError {
  constructor(message = "Permission denied", details = {}) {
    super("PERMISSION_DENIED", message, details);
  }
};
var ValidationError = class extends SyncanixError {
  constructor(message = "Validation failed", details = {}) {
    super("VALIDATION_FAILED", message, details);
  }
};
var UnauthenticatedError = class extends SyncanixError {
  constructor(message = "Unauthenticated", details = {}) {
    super("UNAUTHENTICATED", message, details);
  }
};
var ConflictError = class extends SyncanixError {
  constructor(message = "Conflict", details = {}) {
    super("CONFLICT", message, details);
  }
};
var RateLimitedError = class extends SyncanixError {
  constructor(message = "Rate limited", details = {}) {
    super("RATE_LIMITED", message, details);
  }
};
var UpgradeRequiredError = class extends SyncanixError {
  constructor(message = "This feature requires a plan upgrade.", details = {}) {
    super("UPGRADE_REQUIRED", message, details);
  }
};
var InternalError = class extends SyncanixError {
  constructor(message = "Internal error", details = {}) {
    super("INTERNAL", message, details);
  }
};
var ACCOUNT_DELETE_SOLE_OWNER = "ACCOUNT_DELETE_SOLE_OWNER";
var AccountDeleteSoleOwnerError = class extends ConflictError {
  constructor(blockingWorkspaces) {
    super("Transfer ownership or delete these workspaces before deleting your account.", {
      domain: "account",
      meta: {
        reason: ACCOUNT_DELETE_SOLE_OWNER,
        blockingWorkspaces: blockingWorkspaces.map((w) => ({ id: w.id, name: w.name }))
      }
    });
  }
};
var isSyncanixError = (value) => value instanceof SyncanixError;
var UPDATE_USER_PROFILE_NAME_MAX = 300;
var UPDATE_USER_PROFILE_EMAIL_MAX = 320;
var UPDATE_USER_PROFILE_PICTURE_MAX = 2048;
var updateUserProfileInputSchema = /* @__PURE__ */ z.object({
  name: z.string().trim().min(1).max(UPDATE_USER_PROFILE_NAME_MAX).optional(),
  email: z.string().trim().email().max(UPDATE_USER_PROFILE_EMAIL_MAX).optional(),
  picture: z.string().trim().url().max(UPDATE_USER_PROFILE_PICTURE_MAX).refine((value) => value.toLowerCase().startsWith("https://"), {
    message: "picture must be an https URL"
  }).optional()
}).strict().refine(
  (value) => value.name !== void 0 || value.email !== void 0 || value.picture !== void 0,
  { message: "at least one field (name, email, or picture) must be provided" }
);

// src/agent-impact/index.ts
var DURATION_MIN_SAMPLES = 10;
var DURATION_MEASURES = ["time_to_resolution", "first_response"];
var DURATION_STATES = ["measured", "accumulating", "not-measured"];

// src/analytics-rooms/index.ts
var ANALYTICS_ROUTE = "/analytics";
var ANALYTICS_ROOM_PARAM = "room";
var ANALYTICS_ROOM_IDS = ["overview", "outcomes", "usage", "demand"];
var DEFAULT_ANALYTICS_ROOM = "overview";
function resolveAnalyticsRoom(value) {
  return ANALYTICS_ROOM_IDS.find((id) => id === value) ?? DEFAULT_ANALYTICS_ROOM;
}
function analyticsRoomPath(room) {
  return room === DEFAULT_ANALYTICS_ROOM ? ANALYTICS_ROUTE : `${ANALYTICS_ROUTE}?${ANALYTICS_ROOM_PARAM}=${room}`;
}

// src/analytics-window/index.ts
var ANALYTICS_WINDOWS = [
  "LAST_7_DAYS",
  "LAST_30_DAYS",
  "LAST_90_DAYS",
  "LAST_365_DAYS"
];
var ANALYTICS_WINDOW_DAYS = {
  LAST_7_DAYS: 7,
  LAST_30_DAYS: 30,
  LAST_90_DAYS: 90,
  LAST_365_DAYS: 365
};
var ANALYTICS_SOURCES = [
  "impact",
  "observability",
  "gapDemand",
  "interactionMap",
  "userInsight",
  "endUserActivity"
];
var ANALYTICS_WINDOW_SUPPORT = {
  // `AgentImpactWindow` — the rollup keeps daily rows, so it reaches a year.
  impact: ANALYTICS_WINDOWS,
  // `InteractionMapWindow` — same four.
  interactionMap: ANALYTICS_WINDOWS,
  // `GapDemandWindow` — same four.
  gapDemand: ANALYTICS_WINDOWS,
  // `ObservabilityRange` {24h, 7d, 30d} — an OPERATOR range, and 30 days is
  // as far back as it reaches. Satisfaction and answer speed ride on it, so
  // both are genuinely unavailable for a quarter or a year.
  observability: ["LAST_7_DAYS", "LAST_30_DAYS"],
  // `EndUserActivityRange` {24h, 7d, 30d} — same ceiling, same reason.
  endUserActivity: ["LAST_7_DAYS", "LAST_30_DAYS"],
  // `UserInsightRange` {7d, 30d, 90d} — reaches a quarter but not a year.
  userInsight: ["LAST_7_DAYS", "LAST_30_DAYS", "LAST_90_DAYS"]
};
function sourceServesWindow(source, window) {
  return ANALYTICS_WINDOW_SUPPORT[source].includes(window);
}
function longestServedWindow(source) {
  const served = ANALYTICS_WINDOW_SUPPORT[source];
  let longest = null;
  for (const w of ANALYTICS_WINDOWS) if (served.includes(w)) longest = w;
  if (longest === null) {
    throw new Error(`analytics-window: source "${source}" serves no window at all`);
  }
  return longest;
}

// src/business-signals/index.ts
var BUSINESS_SIGNALS = [
  "resolvedRate",
  "satisfaction",
  "answerSpeed",
  "conversations",
  "unmetAsks"
];
function isBusinessSignal(value) {
  return BUSINESS_SIGNALS.includes(value);
}
var MONITORING_TARGET_METRICS = ["autoResolved", "satisfaction", "answerSpeedMs"];
var MAX_ANSWER_SPEED_MS = 3e5;
var SATISFACTION_TARGET_DEFAULT = 0.7;
var MONITORING_TARGET_SPECS = {
  /** Share of analysed conversations the agent finished without a person. */
  autoResolved: {
    unit: "fraction",
    direction: "higher-is-better",
    min: 0,
    max: 1,
    integerOnly: false,
    defaultValue: null
  },
  /** Share of rated replies that were positive. 0.70 is the shipped grading threshold. */
  satisfaction: {
    unit: "fraction",
    direction: "higher-is-better",
    min: 0,
    max: 1,
    integerOnly: false,
    defaultValue: SATISFACTION_TARGET_DEFAULT
  },
  /** P95 server answer time. Lower is better; a sub-millisecond goal is noise. */
  answerSpeedMs: {
    unit: "milliseconds",
    direction: "lower-is-better",
    min: 1,
    max: MAX_ANSWER_SPEED_MS,
    integerOnly: true,
    defaultValue: null
  }
};
function isMonitoringTargetMetric(metric) {
  return MONITORING_TARGET_METRICS.includes(metric);
}
function validateMonitoringTargetValue(metric, value) {
  const spec = MONITORING_TARGET_SPECS[metric];
  if (!Number.isFinite(value)) return false;
  if (spec.integerOnly && !Number.isInteger(value)) return false;
  return value >= spec.min && value <= spec.max;
}
var monitoringTargetOverrideSchema = /* @__PURE__ */ z.object({
  metric: z.enum(MONITORING_TARGET_METRICS),
  value: z.number()
}).refine((input) => validateMonitoringTargetValue(input.metric, input.value), {
  message: "value is outside the legal range for this metric",
  path: ["value"]
});
function resolveMonitoringTarget(metric, overrides) {
  let resolved = null;
  for (const override of overrides) {
    if (override.metric !== metric) continue;
    if (!validateMonitoringTargetValue(metric, override.value)) continue;
    resolved = override.value;
  }
  return resolved ?? MONITORING_TARGET_SPECS[metric].defaultValue;
}
function resolveMonitoringTargets(overrides) {
  return {
    autoResolved: resolveMonitoringTarget("autoResolved", overrides),
    satisfaction: resolveMonitoringTarget("satisfaction", overrides),
    answerSpeedMs: resolveMonitoringTarget("answerSpeedMs", overrides)
  };
}

// src/observability/sample-floors.ts
var SATISFACTION_MIN_RATINGS = 20;
var TOOL_ERROR_MIN_CALLS = 40;
var LATENCY_MIN_SAMPLES = 20;

// src/metric-grading/index.ts
var METRIC_DIRECTIONS = ["higher-is-better", "lower-is-better"];
function gradeBand(value, threshold) {
  const { healthy, critical, direction } = threshold;
  if (direction === "higher-is-better") {
    if (value >= healthy) return "success";
    if (critical !== void 0 && value < critical) return "danger";
    return "warning";
  }
  if (value <= healthy) return "success";
  if (critical !== void 0 && value > critical) return "danger";
  return "warning";
}
function gradeMetric(value, threshold) {
  if (value === null || !Number.isFinite(value)) return "neutral";
  return gradeBand(value, threshold);
}
function gradeRate(rate2, sampleSize, threshold) {
  if (rate2 === null || !Number.isFinite(rate2)) return "neutral";
  if (!Number.isFinite(sampleSize) || sampleSize < threshold.minSamples) return "insufficient";
  return gradeBand(rate2, threshold);
}
var SATISFACTION_THRESHOLD = {
  kind: "rate",
  minSamples: SATISFACTION_MIN_RATINGS,
  healthy: SATISFACTION_TARGET_DEFAULT,
  critical: 0.5,
  direction: "higher-is-better"
};
function satisfactionThresholdFor(target) {
  if (typeof target !== "number" || !Number.isFinite(target)) return SATISFACTION_THRESHOLD;
  const floor = SATISFACTION_THRESHOLD.critical ?? SATISFACTION_TARGET_DEFAULT;
  return { ...SATISFACTION_THRESHOLD, healthy: Math.max(target, floor) };
}

// src/business-verdict/business-thresholds.ts
var TARGET_SHORTFALL_CRITICAL_RATIO = 0.75;
var TARGET_OVERSHOOT_CRITICAL_RATIO = 1.5;
var RESOLUTION_MIN_CONVERSATIONS = 20;
var ANSWER_SPEED_MIN_SAMPLES = 50;
var UNMET_ASK_THRESHOLD = {
  kind: "count",
  healthy: 3,
  critical: 15,
  direction: "lower-is-better"
};
var BUSINESS_SIGNALS_REQUIRING_TARGET = ["resolvedRate", "answerSpeed"];
function resolvedRateThresholdFor(target) {
  if (target === null || !Number.isFinite(target) || target <= 0) return null;
  return {
    kind: "rate",
    minSamples: RESOLUTION_MIN_CONVERSATIONS,
    healthy: target,
    critical: target * TARGET_SHORTFALL_CRITICAL_RATIO,
    direction: "higher-is-better"
  };
}
function answerSpeedThresholdFor(targetMs) {
  if (targetMs === null || !Number.isFinite(targetMs) || targetMs <= 0) return null;
  return {
    kind: "rate",
    minSamples: ANSWER_SPEED_MIN_SAMPLES,
    healthy: targetMs,
    critical: targetMs * TARGET_OVERSHOOT_CRITICAL_RATIO,
    direction: "lower-is-better"
  };
}
function businessSatisfactionThresholdFor(target) {
  return satisfactionThresholdFor(target);
}
function resolveBusinessTargets(overrides) {
  return {
    resolvedRate: resolveMonitoringTarget("autoResolved", overrides),
    satisfaction: resolveMonitoringTarget("satisfaction", overrides),
    answerSpeedMs: resolveMonitoringTarget("answerSpeedMs", overrides)
  };
}

// src/business-delta/signal-specs.ts
var SIGNAL_SPECS = {
  resolvedRate: {
    polarity: "up-is-good",
    kind: "rate",
    minSamples: RESOLUTION_MIN_CONVERSATIONS,
    // Three points. Below that a week's resolution rate moves on the mix of
    // questions asked, which is weather rather than a change in the agent.
    materialMove: 0.03
  },
  satisfaction: {
    polarity: "up-is-good",
    kind: "rate",
    minSamples: SATISFACTION_MIN_RATINGS,
    // Five points, higher than resolution's: satisfaction's denominator is a
    // small self-selected sample even above the floor, so it swings further on
    // the same underlying reality.
    materialMove: 0.05
  },
  answerSpeed: {
    polarity: "up-is-bad",
    kind: "relative",
    minSamples: ANSWER_SPEED_MIN_SAMPLES,
    // A fifth. A p95 is an extreme-value estimate and moves with traffic shape
    // alone; anything tighter reports the model provider's afternoon.
    materialMove: 0.2,
    // 250 ms, so a fast workspace improving from 300 ms to 200 ms is not the
    // week's headline over a workspace that added a whole second.
    materialAbsolute: 250
  },
  conversations: {
    // More conversations is not automatically better — it can be a marketing
    // campaign or a broken checkout page. The report says it moved; the reader
    // knows which.
    polarity: "neutral",
    kind: "relative",
    minSamples: 0,
    materialMove: 0.2,
    materialAbsolute: 10
  },
  unmetAsks: {
    polarity: "up-is-bad",
    kind: "relative",
    minSamples: 0,
    materialMove: 0.25,
    materialAbsolute: 3
  }
};

// src/business-delta/index.ts
var MAX_BUSINESS_DELTAS = 3;
function comparablePair(spec, current, previous) {
  if (current === void 0 || previous === void 0) return null;
  const { value: currentValue } = current;
  const { value: previousValue } = previous;
  if (currentValue === null || previousValue === null) return null;
  if (current.samples < spec.minSamples || previous.samples < spec.minSamples) return null;
  return { current: currentValue, previous: previousValue };
}
function toneFor(polarity, direction) {
  if (polarity === "neutral") return "neutral";
  const good = polarity === "up-is-good" ? direction === "up" : direction === "down";
  return good ? "good" : "bad";
}
function computeDelta(signal, spec, current, previous) {
  const pair = comparablePair(spec, current, previous);
  if (pair === null) return null;
  const { current: currentValue, previous: previousValue } = pair;
  const change = currentValue - previousValue;
  const magnitude = Math.abs(change);
  if (magnitude === 0) return null;
  if (spec.kind === "rate") {
    if (magnitude < spec.materialMove) return null;
  } else {
    if (previousValue === 0) return null;
    if (magnitude / Math.abs(previousValue) < spec.materialMove) return null;
    if (spec.materialAbsolute !== void 0 && magnitude < spec.materialAbsolute) return null;
  }
  const direction = change > 0 ? "up" : "down";
  const relativeChange = magnitude / Math.abs(previousValue);
  return {
    signal,
    polarity: spec.polarity,
    direction,
    tone: toneFor(spec.polarity, direction),
    current: currentValue,
    previous: previousValue,
    change,
    relativeChange: spec.kind === "rate" ? null : relativeChange
  };
}
function computeBusinessDeltas(inputs) {
  const scored = [];
  BUSINESS_SIGNALS.forEach((signal, order) => {
    const delta = computeDelta(
      signal,
      SIGNAL_SPECS[signal],
      inputs.current[signal],
      inputs.previous[signal]
    );
    if (delta === null) return;
    scored.push({
      delta,
      // Scored relatively even for rates, where the RENDERED unit stays points.
      // The two jobs are different: points are what a reader should be told,
      // and a common currency is what the ranking needs. `computeDelta` nulls
      // `relativeChange` for a rate, so the score re-derives it here.
      //
      // A rate that moved OFF zero scores 0 rather than Infinity, which is what
      // the pre-split code did (`relativeChange ?? 0`) and is deliberate: every
      // move from zero is infinite, so ranking by it would put whichever signal
      // happened to start at zero at the top of every report forever. It still
      // yields a DELTA — a rate from 0 to 5 points is real and material — it
      // just cannot be scored against signals that have somewhere to have come
      // from. Pinned by test, because the division is one character from the
      // other behaviour.
      score: delta.previous === 0 ? 0 : Math.abs(delta.change) / Math.abs(delta.previous),
      order
    });
  });
  return scored.sort((a, b) => b.score === a.score ? a.order - b.order : b.score - a.score).slice(0, MAX_BUSINESS_DELTAS).map((s) => s.delta);
}

// src/success-metric/success-metric-verdict.ts
var SUCCESS_METRIC_MIN_CONVERSATIONS = 20;
var SUCCESS_METRIC_VERDICT_IDS = [
  "no-conversations",
  "not-enough",
  "no-target",
  "too-close",
  "on-target",
  "off-target"
];
function successMetricVerdict(args) {
  const { numerator, denominator, target, direction } = args;
  const base = { numerator, denominator };
  if (denominator <= 0) return { ...base, id: "no-conversations", rate: null };
  const rate2 = numerator / denominator;
  if (denominator < SUCCESS_METRIC_MIN_CONVERSATIONS) {
    return { ...base, id: "not-enough", rate: rate2 };
  }
  if (target === void 0) return { ...base, id: "no-target", rate: rate2 };
  const towardGood = direction === "higher-is-better" ? rate2 - target : target - rate2;
  if (Math.abs(towardGood) < 1 / denominator) {
    return { ...base, id: "too-close", rate: rate2 };
  }
  return {
    ...base,
    id: towardGood > 0 ? "on-target" : "off-target",
    rate: rate2,
    gapPoints: Math.round(towardGood * 1e3) / 10
  };
}
var VERDICT_ORDER = {
  "off-target": 0,
  "too-close": 1,
  "on-target": 2,
  "no-target": 3,
  "not-enough": 4,
  "no-conversations": 5
};
function compareSuccessMetricVerdicts(a, b) {
  const byState = VERDICT_ORDER[a.id] - VERDICT_ORDER[b.id];
  if (byState !== 0) return byState;
  const sizeA = a.gapPoints === void 0 ? -1 : Math.abs(a.gapPoints);
  const sizeB = b.gapPoints === void 0 ? -1 : Math.abs(b.gapPoints);
  return sizeB - sizeA;
}

// src/business-review/custom-metrics.ts
var GRADED_VERDICTS = /* @__PURE__ */ new Set([
  "on-target",
  "off-target"
]);
function isGradedReviewMetric(id) {
  return GRADED_VERDICTS.has(id);
}
function composeReviewCustomMetrics(metrics) {
  return metrics.map((metric) => {
    const graded = isGradedReviewMetric(metric.verdict.id);
    return {
      name: metric.name,
      verdict: metric.verdict.id,
      rate: graded ? metric.verdict.rate : null,
      conversations: metric.verdict.denominator
    };
  });
}
var REVIEW_CUSTOM_METRIC_VERDICTS = SUCCESS_METRIC_VERDICT_IDS;

// src/business-review/goals.ts
var REVIEW_GOALS = ["resolvedRate", "satisfaction", "answerSpeed"];
var GOAL_MIN_SAMPLES = {
  // The resolution rate rides the conversation analysis count.
  resolvedRate: 30,
  // Satisfaction rides thumb ratings, which are far scarcer than conversations.
  satisfaction: 20,
  // Answer speed rides the latency estimator's own floor — below it a p95 IS
  // the maximum rather than a percentile, which is an arbitrary figure.
  answerSpeed: LATENCY_MIN_SAMPLES
};
var GOAL_DIRECTION = {
  resolvedRate: "higher-is-better",
  satisfaction: "higher-is-better",
  answerSpeed: "lower-is-better"
};
function composeGoalAttainment(input) {
  const readings = {
    resolvedRate: input.resolvedRate,
    satisfaction: input.satisfaction,
    answerSpeed: input.answerSpeed
  };
  return REVIEW_GOALS.map((goal) => {
    const target = targetFor(goal, input.targets);
    const reading = readings[goal];
    if (target === null) {
      return { goal, status: "no-target", target: null, actual: null, samples: reading.samples };
    }
    const enough = reading.value !== null && reading.samples >= GOAL_MIN_SAMPLES[goal];
    if (!enough) {
      return {
        goal,
        status: "not-enough-data",
        target,
        // Withheld rather than reported beside a caveat: a number on the page
        // is a number the reader takes, whatever the label next to it says.
        actual: null,
        samples: reading.samples
      };
    }
    const met = GOAL_DIRECTION[goal] === "higher-is-better" ? reading.value >= target : reading.value <= target;
    return {
      goal,
      status: met ? "met" : "missed",
      target,
      actual: reading.value,
      samples: reading.samples
    };
  });
}
function targetFor(goal, targets) {
  if (goal === "resolvedRate") return targets.resolvedRate;
  if (goal === "satisfaction") return targets.satisfaction;
  return targets.answerSpeedMs;
}
function goalsWithTargets(attainment) {
  return attainment.filter((g) => g.status !== "no-target").length;
}
function goalsMet(attainment) {
  return attainment.filter((g) => g.status === "met").length;
}

// src/report-period/format.ts
function formatReportPeriod(period, locale) {
  const fmt = new Intl.DateTimeFormat(locale, {
    dateStyle: "medium",
    timeZone: "UTC",
    numberingSystem: getLocaleNumberingSystem(locale)
  });
  return fmt.formatRange(utcMidnight(period.startDay), utcMidnight(period.endDay));
}
function utcMidnight(day) {
  const t = Date.parse(`${day}T00:00:00.000Z`);
  if (Number.isNaN(t)) throw new Error(`report-period: not a real day: ${day}`);
  return new Date(t);
}

// src/report-period/index.ts
var dayPattern = /^\d{4}-\d{2}-\d{2}$/;
var reportPeriodSchema = /* @__PURE__ */ z.object({
  startDay: z.string().regex(dayPattern),
  endDay: z.string().regex(dayPattern)
}).refine((p) => p.endDay >= p.startDay, {
  message: "report period endDay must not precede startDay"
});
function utcDay(date) {
  return date.toISOString().slice(0, 10);
}
function dayAfter(day) {
  if (!dayPattern.test(day)) throw new Error(`report-period: not a YYYY-MM-DD day: ${day}`);
  const t = Date.parse(`${day}T00:00:00.000Z`);
  if (Number.isNaN(t)) throw new Error(`report-period: not a real day: ${day}`);
  return new Date(t + 864e5).toISOString().slice(0, 10);
}
function windowPeriod(window, asOf) {
  const days = ANALYTICS_WINDOW_DAYS[window];
  const startMs = asOf.getTime() - (days - 1) * 864e5;
  return { startDay: utcDay(new Date(startMs)), endDay: utcDay(asOf) };
}
function periodDayCount(period) {
  const start = Date.parse(`${period.startDay}T00:00:00.000Z`);
  const end = Date.parse(`${period.endDay}T00:00:00.000Z`);
  if (Number.isNaN(start) || Number.isNaN(end)) {
    throw new Error("report-period: not a real period");
  }
  return Math.round((end - start) / 864e5) + 1;
}
function previousPeriod(period) {
  const days = periodDayCount(period);
  const startMs = Date.parse(`${period.startDay}T00:00:00.000Z`);
  return {
    startDay: utcDay(new Date(startMs - days * 864e5)),
    endDay: utcDay(new Date(startMs - 864e5))
  };
}
function periodBounds(period) {
  return {
    since: `${period.startDay}T00:00:00.000Z`,
    until: `${dayAfter(period.endDay)}T00:00:00.000Z`
  };
}

// src/business-review/volume.ts
var REVIEW_TREND_BUCKET_DAYS = 7;
var REVIEW_TREND_MIN_BUCKETS = 2;
function composeReviewVolume(period, daily) {
  const totalDays = periodDayCount(period);
  if (totalDays < REVIEW_TREND_BUCKET_DAYS * REVIEW_TREND_MIN_BUCKETS) return [];
  const byDay = /* @__PURE__ */ new Map();
  for (const row2 of daily) {
    byDay.set(row2.day, (byDay.get(row2.day) ?? 0) + row2.conversations);
  }
  const points = [];
  let cursor = period.startDay;
  while (cursor <= period.endDay) {
    let conversations = 0;
    let days = 0;
    let day = cursor;
    for (let i = 0; i < REVIEW_TREND_BUCKET_DAYS && day <= period.endDay; i += 1) {
      conversations += byDay.get(day) ?? 0;
      days += 1;
      day = dayAfter(day);
    }
    points.push({
      startDay: cursor,
      endDay: utcDay(new Date(Date.parse(`${day}T00:00:00.000Z`) - 864e5)),
      conversations,
      partial: days < REVIEW_TREND_BUCKET_DAYS,
      days
    });
    cursor = day;
  }
  return points;
}
function reviewVolumePeak(points) {
  let peak = 0;
  for (const p of points) if (p.conversations > peak) peak = p.conversations;
  return peak;
}

// src/business-verdict/business-verdict.types.ts
var CUSTOM_METRIC_SIGNAL = "customMetric";
var BUSINESS_VERDICT_DESTINATIONS = ["metrics", "outcomes", "demand"];
var INSIGHT_OUTCOMES = [
  /** The user's goal was accomplished (a capability ran successfully, or a grounded answer satisfied them). */
  "fulfilled",
  /** Partially accomplished — some sub-goals met, others not. */
  "partial",
  /** Attempted but failed (a tool errored, a denial blocked it, a step-up was abandoned). */
  "failed",
  /** The user wanted something the tenant has NO capability for — the gap case. */
  "unsupported",
  /** The user left before any resolution (no positive outcome, no clear failure). */
  "abandoned",
  /** Informational only — the user asked a question and got an answer; no action intended. */
  "informational"
];
var INSIGHT_FAILURE_REASONS = [
  /** A matched tool ran but the customer's API returned an error. */
  "tool_error",
  /** The end user declined a consent gate, or policy/rate-limit blocked the call. */
  "denied",
  /** A step-up auth challenge was required and never completed. */
  "step_up_abandoned",
  /** No capability matched the intent (pairs with `outcome: 'unsupported'`). */
  "no_capability",
  /** A failure that doesn't fit the buckets above. */
  "other"
];
var INSIGHT_SENTIMENTS = ["positive", "neutral", "negative", "frustrated"];
var INSIGHT_RATIONALE_MAX = 500;
var InsightEvidenceSchema = /* @__PURE__ */ z.object({
  messageSequences: z.array(z.number().int().nonnegative()).default([]),
  rationale: z.string().max(INSIGHT_RATIONALE_MAX).optional()
});
var InsightRecordSchema = /* @__PURE__ */ z.object({
  /**
   * A short human-readable conversation title (≤80 chars), locale-native — the
   * operator-facing headline so a conversation reads as more than a UUID (CL-4).
   * `.nullish()` (nullable + optional) so a pre-CL-4 LLM response, an old
   * persisted row, or a marker record that OMITS it stays valid; consumers
   * coerce `?? null` at the persistence + GraphQL seams.
   */
  title: z.string().max(80).nullish(),
  /** A one-to-two sentence conversation summary, locale-native; null/absent when unset (CL-4). */
  summary: z.string().max(400).nullish(),
  /**
   * CL-7 / Q-CL10-topic-model — the conversation's topic: a stable taxonomy KEY
   * (see `topic-taxonomy.ts`), the catch-all `other`, or null (unclassified).
   * `.nullish()` so a pre-CL-7 LLM response / persisted row / marker record that
   * OMITS it stays valid; the extraction coerces unknown keys via `coerceTopicKey`
   * and consumers read `?? null` at the persistence + GraphQL seams. Bounded to 64
   * chars — a key, never free text.
   */
  topic: z.string().max(64).nullish(),
  /** The user's primary goal, normalized to a short phrase (e.g. "request a refund"). */
  primaryIntent: z.string().min(1).max(280),
  /** A more specific desired action when discernible; null otherwise. */
  desiredAction: z.string().max(280).nullable(),
  outcome: z.enum(INSIGHT_OUTCOMES),
  /** The capability that served the intent (a catalog `capability_id`), or null. */
  matchedCapabilityId: z.string().max(200).nullable(),
  /** True when the user wanted something the tenant has no capability for. */
  gap: z.boolean(),
  /** What the missing capability would be, when `gap` is true; null otherwise. */
  gapDescription: z.string().max(280).nullable(),
  failureReason: z.enum(INSIGHT_FAILURE_REASONS).nullable(),
  sentiment: z.enum(INSIGHT_SENTIMENTS).nullable(),
  /** The model's confidence in this classification, in [0, 1]. */
  confidence: z.number().min(0).max(1),
  evidence: InsightEvidenceSchema
});
function parseInsightRecord(value) {
  return InsightRecordSchema.parse(value);
}

// src/success-metric/success-metric-vocabulary.ts
var MAX_METRIC_NAME_CHARS = 80;
var MAX_METRIC_NAME_UTF16 = MAX_METRIC_NAME_CHARS * 4;
var MAX_SUCCESS_METRICS_PER_TENANT = 20;
var MAX_METRIC_VALUE_CHARS = 200;
var MAX_METRIC_VALUES = 25;
var MAX_METRIC_PREDICATES = 10;
var METRIC_SET_FIELDS = [
  "outcome",
  /**
   * Phase 5.1 — what the customer's BACKEND reported, as distinct from
   * `outcome`, which is what the model INFERRED from the transcript.
   *
   * Its own field rather than more members on `outcome`, and that is the
   * load-bearing choice: they are different facts with different reliability,
   * so folding ground truth into the inferred column would silently change the
   * meaning of every metric already filtering on it — without touching one of
   * those metrics, and with no way for their author to notice. A workspace that
   * wants "the model thought it went well" and one that wants "money changed
   * hands" must be able to say which.
   *
   * TENANT-valued, so it is deliberately absent from `METRIC_CLOSED_VALUES`
   * below: the keys are the customer's own ("purchase", "ticket_closed"), and
   * enumerating them here would break a saved metric the day they add one.
   */
  "reportedOutcome",
  "topic",
  "capability",
  "sentiment",
  "failureReason",
  "audience",
  "rating"
];
var METRIC_FLAG_FIELDS = ["gap"];
var METRIC_RATINGS = ["up", "down"];
var METRIC_CLOSED_VALUES = {
  outcome: INSIGHT_OUTCOMES,
  sentiment: INSIGHT_SENTIMENTS,
  failureReason: INSIGHT_FAILURE_REASONS,
  rating: METRIC_RATINGS
};

// src/text/graphemes.ts
function splitGraphemes(value) {
  if (typeof Intl.Segmenter === "function") {
    return Array.from(
      new Intl.Segmenter(void 0, { granularity: "grapheme" }).segment(value),
      (segment) => segment.segment
    );
  }
  return Array.from(value);
}
function countGraphemes(value) {
  return splitGraphemes(value).length;
}
function capGraphemes(value, max) {
  const clusters = splitGraphemes(value);
  return clusters.length <= max ? value : clusters.slice(0, max).join("");
}

// src/success-metric/success-metric.schema.ts
var setPredicateSchema = /* @__PURE__ */ z.object({
  field: z.enum(METRIC_SET_FIELDS),
  /**
   * `isNoneOf` is not sugar for a negated `isAnyOf`: on a NULLABLE column the
   * two differ on the rows that have no value at all, and a customer asking
   * for "not a refund" means to include the conversations with no topic. The
   * server resolves that explicitly per field rather than leaving it to SQL's
   * three-valued logic, which would silently drop them.
   */
  op: z.enum(["isAnyOf", "isNoneOf"]),
  values: z.array(z.string().trim().min(1).max(MAX_METRIC_VALUE_CHARS)).min(1).max(MAX_METRIC_VALUES)
}).strict().superRefine((predicate, ctx) => {
  const closed = METRIC_CLOSED_VALUES[predicate.field];
  if (closed === void 0) return;
  for (const value of predicate.values) {
    if (closed.includes(value)) continue;
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["values"],
      message: `${predicate.field} does not have a value "${value}"`
    });
  }
});
var flagPredicateSchema = /* @__PURE__ */ z.object({
  field: z.enum(METRIC_FLAG_FIELDS),
  is: z.boolean()
}).strict();
var metricPredicateSchema = /* @__PURE__ */ z.union([setPredicateSchema, flagPredicateSchema]);
var metricNameSchema = /* @__PURE__ */ z.string().trim().min(1).max(MAX_METRIC_NAME_UTF16).refine((name) => countGraphemes(name) <= MAX_METRIC_NAME_CHARS, {
  message: `Must be at most ${String(MAX_METRIC_NAME_CHARS)} characters`
});
var successMetricDefinitionSchema = /* @__PURE__ */ z.object({
  /** @see {@link metricNameSchema} — one rule, shared, never restated. */
  name: metricNameSchema,
  /**
   * Which conversations COUNT — the denominator. Empty means every
   * conversation in the window, which is the right default for a
   * workspace-wide metric like first-contact resolution.
   */
  filter: z.array(metricPredicateSchema).max(MAX_METRIC_PREDICATES).default([]),
  /**
   * Which of those count as a SUCCESS — the numerator. Never empty: a metric
   * with no success condition is 100 % by construction, which is not a
   * measurement and would render as a workspace doing perfectly.
   */
  success: z.array(metricPredicateSchema).min(1).max(MAX_METRIC_PREDICATES),
  /** The share the workspace is aiming for, 0–1. Optional — a metric may be watched without a goal. */
  target: z.number().min(0).max(1).optional(),
  /**
   * Which direction is good news, stated rather than inferred, and taken from
   * the grading KERNEL rather than restated here.
   *
   * "Enterprise escalation rate" is a metric a workspace wants LOW, and a
   * surface that assumed higher-is-better would congratulate them for missing
   * their target — the conflation `Delta` refuses by taking direction and
   * polarity separately (`ui-design.md` §0, principle 03). There is no
   * default: a metric whose author did not say is a metric nobody can judge.
   */
  direction: z.enum(METRIC_DIRECTIONS),
  window: z.enum(ANALYTICS_WINDOWS)
}).strict();

// src/business-review/wire.ts
var verdictIssueBase = {
  id: z.string().min(1),
  tone: z.enum(["warning", "danger"]),
  messageKey: z.string().min(1),
  /** Unformatted numbers — the renderer holds the locale. */
  params: z.record(z.string(), z.number()),
  actionKey: z.string().min(1),
  // DERIVED, like every other vocabulary here. It was restated as a literal
  // list until Phase 4.6 added a fourth destination, at which point the pack
  // would have refused every metric issue at the boundary and rendered a
  // verdict one issue short of the one the hub shows — the exact failure this
  // file's own doc comment warns about, in the one field that had opted out.
  room: z.enum(BUSINESS_VERDICT_DESTINATIONS)
};
var verdictIssueSchema = /* @__PURE__ */ z.discriminatedUnion("signal", [
  z.object({ ...verdictIssueBase, signal: z.enum(BUSINESS_SIGNALS) }),
  z.object({
    ...verdictIssueBase,
    signal: z.literal(CUSTOM_METRIC_SIGNAL),
    /**
     * The customer's own name for the metric, rendered VERBATIM on an
     * unauthenticated page — so it is bounded here rather than trusted.
     *
     * `metricNameSchema` itself, never a restatement of its ceiling: its own
     * doc comment names this exact obligation, and the units differ in a way a
     * copied number cannot track (`.max()` counts UTF-16 code units, so an
     * astral character costs two). One rule, shared.
     */
    nameText: metricNameSchema
  })
]);
var businessVerdictWireSchema = /* @__PURE__ */ z.object({
  level: z.enum(["unmeasured", "healthy", "attention", "at-risk"]),
  gradedSignalCount: z.number().int().nonnegative(),
  issues: z.array(verdictIssueSchema).readonly(),
  hiddenIssueCount: z.number().int().nonnegative(),
  ungradedForMissingTarget: z.array(z.string()).readonly()
});
var businessDeltaWireSchema = /* @__PURE__ */ z.object({
  signal: z.enum(BUSINESS_SIGNALS),
  polarity: z.enum(["up-is-good", "up-is-bad", "neutral"]),
  direction: z.enum(["up", "down"]),
  tone: z.enum(["good", "bad", "neutral"]),
  current: z.number(),
  previous: z.number(),
  change: z.number(),
  /** Null for a signal whose relative move is undefined (a previous of zero). */
  relativeChange: z.number().nullable()
});
var goalAttainmentWireSchema = /* @__PURE__ */ z.object({
  goal: z.enum(REVIEW_GOALS),
  status: z.enum(["met", "missed", "no-target", "not-enough-data"]),
  target: z.number().nullable(),
  /** Null whenever the goal was not graded — never the ungradable figure. */
  actual: z.number().nullable(),
  samples: z.number().int().nonnegative()
});
var reviewCustomMetricWireSchema = /* @__PURE__ */ z.object({
  name: z.string(),
  verdict: z.enum(REVIEW_CUSTOM_METRIC_VERDICTS),
  rate: z.number().nullable(),
  conversations: z.number().int().nonnegative()
});
var reviewVolumePointWireSchema = /* @__PURE__ */ z.object({
  startDay: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  endDay: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  conversations: z.number().int().nonnegative(),
  partial: z.boolean(),
  days: z.number().int().positive()
});
var businessReviewWireSchema = /* @__PURE__ */ z.object({
  verdict: businessVerdictWireSchema,
  goals: z.array(goalAttainmentWireSchema).readonly(),
  /**
   * DEFAULTED rather than required: the public page parses with the same schema
   * the api writes, so a required field would dark every already-shared pack the
   * moment an api rollback stopped sending it — the reasoning `review` itself
   * carries one level up.
   */
  customMetrics: z.array(reviewCustomMetricWireSchema).readonly().default([]),
  deltas: z.array(businessDeltaWireSchema).readonly(),
  hasComparison: z.boolean(),
  volume: z.array(reviewVolumePointWireSchema).readonly(),
  unmetAsks: z.object({
    /**
     * A COUNT and never a list — see `UnmetAskSummary`. There is deliberately
     * no field on this schema an LLM-derived description could travel in, so
     * no downstream consumer has to remember not to render one.
     */
    distinctCount: z.number().int().nonnegative().nullable()
  })
});

// src/hours-saved/index.ts
var MAX_HUMAN_MINUTES_PER_RESOLUTION = 480;
var HOURS_SAVED_BAND_FACTORS = [0.5, 1, 2];
function computeHoursSaved(args) {
  const { resolutions, minutesPerResolution } = args;
  if (minutesPerResolution === null) return null;
  if (!Number.isFinite(minutesPerResolution)) return null;
  if (minutesPerResolution <= 0) return null;
  if (minutesPerResolution > MAX_HUMAN_MINUTES_PER_RESOLUTION) return null;
  if (!Number.isFinite(resolutions) || resolutions < 0) return null;
  return {
    minutesPerResolution,
    resolutions,
    band: HOURS_SAVED_BAND_FACTORS.map((factor) => {
      const minutes = minutesPerResolution * factor;
      return {
        // Rounded so the label reads as an assumption a person would state
        // ("3 min"), not as a derived quantity ("2.5 min") — but the HOURS are
        // computed from the unrounded minutes, so the band's arithmetic stays
        // exactly proportional to its factors.
        minutesPerResolution: Math.round(minutes * 10) / 10,
        hours: Math.round(resolutions * minutes / 60),
        stated: factor === 1
      };
    })
  };
}

// src/business-verdict/custom-metrics.ts
function isJudgedMetric(verdict) {
  return verdict.id === "on-target" || verdict.id === "off-target";
}
function customMetricContribution(metrics) {
  const judged = metrics.filter((m) => isJudgedMetric(m.verdict));
  const offTarget = judged.filter((m) => m.verdict.id === "off-target").sort((a, b) => Math.abs(b.verdict.gapPoints ?? 0) - Math.abs(a.verdict.gapPoints ?? 0));
  const worst = offTarget[0];
  if (worst === void 0) return { gradedCount: judged.length, issue: null };
  const only = offTarget.length === 1;
  return {
    gradedCount: judged.length,
    issue: {
      id: "custom-metric-off-target",
      tone: "warning",
      messageKey: only ? "analytics.verdict.issue.customMetricOffTarget.one" : "analytics.verdict.issue.customMetricOffTarget.other",
      params: only ? { count: 1 } : { count: offTarget.length },
      actionKey: "analytics.verdict.action.reviewMetrics",
      room: "metrics",
      signal: "customMetric",
      nameText: worst.name
    }
  };
}

// src/business-verdict/business-verdict.ts
var MAX_BUSINESS_VERDICT_ISSUES = 3;
var TONE_RANK = { danger: 0, warning: 1 };
function plural(count6, one, other) {
  return count6 === 1 ? one : other;
}
function isActionable(tone) {
  return tone === "warning" || tone === "danger";
}
function isGraded(tone) {
  return tone === "success" || tone === "warning" || tone === "danger";
}
function computeBusinessVerdict(inputs) {
  const windowLimited = new Set(inputs.windowLimited ?? []);
  const issues = [];
  const ungraded = [];
  let gradedSignalCount = 0;
  const resolvedThreshold = resolvedRateThresholdFor(inputs.targets.resolvedRate);
  if (resolvedThreshold === null) {
    if (!windowLimited.has("resolvedRate")) ungraded.push("resolvedRate");
  } else {
    const tone = gradeRate(inputs.resolvedRate, inputs.analyzedCount, resolvedThreshold);
    if (isGraded(tone)) gradedSignalCount += 1;
    if (isActionable(tone) && inputs.resolvedRate !== null) {
      issues.push({
        id: "resolved-below-target",
        tone,
        messageKey: "analytics.verdict.issue.resolvedBelowTarget",
        params: { rate: inputs.resolvedRate, target: resolvedThreshold.healthy },
        actionKey: "analytics.verdict.action.reviewOutcomes",
        room: "outcomes",
        signal: "resolvedRate"
      });
    }
  }
  const satisfactionThreshold = businessSatisfactionThresholdFor(inputs.targets.satisfaction);
  const satisfactionTone = gradeRate(
    inputs.satisfactionRate,
    inputs.satisfactionRatings,
    satisfactionThreshold
  );
  if (isGraded(satisfactionTone)) gradedSignalCount += 1;
  if (isActionable(satisfactionTone) && inputs.satisfactionRate !== null) {
    issues.push({
      id: "satisfaction-below-target",
      tone: satisfactionTone,
      messageKey: "analytics.verdict.issue.satisfactionBelowTarget",
      params: { rate: inputs.satisfactionRate, target: satisfactionThreshold.healthy },
      actionKey: "analytics.verdict.action.reviewFeedback",
      room: "outcomes",
      signal: "satisfaction"
    });
  }
  const speedThreshold = answerSpeedThresholdFor(inputs.targets.answerSpeedMs);
  if (speedThreshold === null) {
    if (!windowLimited.has("answerSpeed")) ungraded.push("answerSpeed");
  } else {
    const tone = gradeRate(inputs.answerSpeedMs, inputs.answerSpeedSamples, speedThreshold);
    if (isGraded(tone)) gradedSignalCount += 1;
    if (isActionable(tone) && inputs.answerSpeedMs !== null) {
      issues.push({
        id: "answer-speed-above-target",
        tone,
        messageKey: "analytics.verdict.issue.answerSpeedAboveTarget",
        params: { ms: inputs.answerSpeedMs, targetMs: speedThreshold.healthy },
        actionKey: "analytics.verdict.action.reviewOutcomes",
        room: "outcomes",
        signal: "answerSpeed"
      });
    }
  }
  const unmetTone = gradeMetric(inputs.unmetAskCount, UNMET_ASK_THRESHOLD);
  if (isGraded(unmetTone)) gradedSignalCount += 1;
  if (isActionable(unmetTone) && inputs.unmetAskCount !== null) {
    issues.push({
      id: "unmet-asks",
      tone: unmetTone,
      messageKey: plural(
        inputs.unmetAskCount,
        "analytics.verdict.issue.unmetAsks.one",
        "analytics.verdict.issue.unmetAsks.other"
      ),
      params: { count: inputs.unmetAskCount },
      actionKey: "analytics.verdict.action.reviewDemand",
      room: "demand",
      signal: "unmetAsks"
    });
  }
  const custom = customMetricContribution(inputs.customMetrics ?? []);
  gradedSignalCount += custom.gradedCount;
  if (custom.issue !== null) issues.push(custom.issue);
  const ranked = [...issues].sort((a, b) => TONE_RANK[a.tone] - TONE_RANK[b.tone]);
  const shown = ranked.slice(0, MAX_BUSINESS_VERDICT_ISSUES);
  const level = ranked.some((i) => i.tone === "danger") ? "at-risk" : ranked.length > 0 ? "attention" : gradedSignalCount > 0 ? "healthy" : "unmeasured";
  return {
    level,
    gradedSignalCount,
    issues: shown,
    hiddenIssueCount: ranked.length - shown.length,
    ungradedForMissingTarget: ungraded
  };
}

// src/business-verdict/destination-path.ts
var SUCCESS_METRICS_ANCHOR = "analytics-success-metrics";
function verdictDestinationPath(destination) {
  if (destination === "metrics") {
    return `${analyticsRoomPath("overview")}#${SUCCESS_METRICS_ANCHOR}`;
  }
  return analyticsRoomPath(destination);
}

// src/business-verdict/regression.ts
var REGRESSION_DROP_POINTS = 10;
var REGRESSION_MIN_SAMPLES = {
  resolution: RESOLUTION_MIN_CONVERSATIONS,
  satisfaction: SATISFACTION_MIN_RATINGS
};
function detectRegression(args) {
  const floor = args.minSamples ?? REGRESSION_MIN_SAMPLES[args.signal];
  const { current, baseline } = args;
  if (current.rate === null || baseline.rate === null) return { kind: "not-measured" };
  if (current.samples < floor || baseline.samples < floor) return { kind: "not-measured" };
  const dropPoints = (baseline.rate - current.rate) * 100;
  if (Math.round(dropPoints * 10) < REGRESSION_DROP_POINTS * 10) {
    return { kind: "steady", dropPoints };
  }
  return { kind: "regressed", dropPoints, current: current.rate, baseline: baseline.rate };
}

// src/persona/rollout-comparison.ts
var MIN_ROLLOUT_ARM_SIZE = 100;
var ROLLOUT_SIGNIFICANCE_P = 0.05;
function compareRolloutArms(treatment, control) {
  const treatmentRate = rate(treatment);
  const controlRate = rate(control);
  if (treatment.rated < MIN_ROLLOUT_ARM_SIZE || control.rated < MIN_ROLLOUT_ARM_SIZE || treatmentRate === null || controlRate === null) {
    return { treatmentRate, controlRate, enoughData: false, pValue: null, significant: false };
  }
  const pooled = (treatment.positive + control.positive) / (treatment.rated + control.rated);
  const se = Math.sqrt(pooled * (1 - pooled) * (1 / treatment.rated + 1 / control.rated));
  if (se === 0) {
    return { treatmentRate, controlRate, enoughData: true, pValue: 1, significant: false };
  }
  const z167 = (treatmentRate - controlRate) / se;
  const pValue = twoTailedP(z167);
  return {
    treatmentRate,
    controlRate,
    enoughData: true,
    pValue,
    significant: pValue < ROLLOUT_SIGNIFICANCE_P
  };
}
function rate(arm) {
  return arm.rated === 0 ? null : arm.positive / arm.rated;
}
function twoTailedP(z167) {
  return 2 * (1 - standardNormalCdf(Math.abs(z167)));
}
function standardNormalCdf(x) {
  const t = 1 / (1 + 0.2316419 * x);
  const poly = t * (0.31938153 + t * (-0.356563782 + t * (1.781477937 + t * (-1.821255978 + t * 1.330274429))));
  const density = Math.exp(-0.5 * x * x) / Math.sqrt(2 * Math.PI);
  return 1 - density * poly;
}

// src/business-verdict/rollout-verdict.ts
var ROLLOUT_VERDICT_IDS = [
  "not-scored",
  "too-early",
  "too-close",
  "ahead",
  "behind"
];
function rolloutVerdict(args) {
  const { treatment, control } = args;
  const comparison = compareRolloutArms(treatment, control);
  const base = {
    treatmentRate: reportableRate(comparison.treatmentRate, treatment),
    controlRate: reportableRate(comparison.controlRate, control),
    treatmentRated: treatment.rated,
    controlRated: control.rated,
    pValue: comparison.pValue
  };
  if (nothingScored(treatment, control)) return { ...base, id: "not-scored" };
  if (!comparison.enoughData) return { ...base, id: "too-early" };
  if (!comparison.significant) return { ...base, id: "too-close" };
  const difference = differencePoints(comparison);
  if (difference === null) return { ...base, id: "too-close" };
  return { ...base, id: difference > 0 ? "ahead" : "behind", differencePoints: difference };
}
function reportableRate(rate2, arm) {
  return arm.rated < MIN_ROLLOUT_ARM_SIZE ? null : rate2;
}
function nothingScored(treatment, control) {
  const served = treatment.conversations > 0 && control.conversations > 0;
  return served && treatment.rated === 0 && control.rated === 0;
}
function differencePoints(comparison) {
  const { treatmentRate, controlRate } = comparison;
  if (treatmentRate === null || controlRate === null) return null;
  return Math.round((treatmentRate - controlRate) * 1e3) / 10;
}
var VERDICT_ORDER2 = {
  behind: 0,
  "not-scored": 1,
  ahead: 2,
  "too-close": 3,
  "too-early": 4
};
function compareRolloutVerdicts(a, b) {
  const byState = VERDICT_ORDER2[a.id] - VERDICT_ORDER2[b.id];
  if (byState !== 0) return byState;
  const sizeA = a.differencePoints === void 0 ? -1 : Math.abs(a.differencePoints);
  const sizeB = b.differencePoints === void 0 ? -1 : Math.abs(b.differencePoints);
  return sizeB - sizeA;
}

// src/success-metric/success-metric-template.types.ts
var METRIC_TEMPLATE_IDS = [
  "first-contact-resolution",
  "satisfaction-rate",
  "frustration-rate",
  "unanswerable-rate",
  "failed-request-rate",
  "topic-resolution",
  "topic-satisfaction",
  "capability-completion"
];
var METRIC_SLOT_FIELDS = ["topic", "capability", "audience", "reportedOutcome"];

// src/success-metric/success-metric-templates.ts
var FULFILLED = { field: "outcome", op: "isAnyOf", values: ["fulfilled"] };
var METRIC_TEMPLATES = [
  {
    // The one number a support organisation is universally measured on: the
    // visitor got what they came for. It also required "and no human was
    // needed" until ADR-0575 removed the handoff surface — with no escalation
    // path, every fulfilled conversation is first-contact by construction.
    id: "first-contact-resolution",
    slot: null,
    filter: [],
    success: [FULFILLED],
    target: 0.7,
    direction: "higher-is-better",
    window: "LAST_30_DAYS"
  },
  {
    // The denominator is the RATED conversations, never all of them. A
    // thumbs-up rate over every conversation measures how many people bothered
    // to rate, which falls as the product gets better at not needing feedback —
    // a satisfaction metric that goes DOWN when satisfaction goes up.
    id: "satisfaction-rate",
    slot: null,
    filter: [{ field: "rating", op: "isAnyOf", values: ["up", "down"] }],
    success: [{ field: "rating", op: "isAnyOf", values: ["up"] }],
    target: 0.85,
    direction: "higher-is-better",
    window: "LAST_30_DAYS"
  },
  {
    // Both unhappy sentiments, not only the extreme one: a workspace watching
    // `frustrated` alone would read as calm while its visitors were merely
    // negative, and the two are one signal for this purpose.
    id: "frustration-rate",
    slot: null,
    filter: [],
    success: [{ field: "sentiment", op: "isAnyOf", values: ["negative", "frustrated"] }],
    target: 0.1,
    direction: "lower-is-better",
    window: "LAST_30_DAYS"
  },
  {
    // The GAP flag rather than `outcome: 'unsupported'`: the flag is the
    // platform's own record that nothing in the catalog could serve the
    // request, which is the actionable half — it names a capability the
    // workspace has not built yet.
    id: "unanswerable-rate",
    slot: null,
    filter: [],
    success: [{ field: "gap", is: true }],
    target: 0.05,
    direction: "lower-is-better",
    window: "LAST_30_DAYS"
  },
  {
    // Distinct from the gap above, and the distinction is what makes it worth
    // watching separately: here the agent HAD the capability and the attempt
    // failed. That is a bug in the workspace's own API, not a missing feature.
    id: "failed-request-rate",
    slot: null,
    filter: [],
    success: [{ field: "outcome", op: "isAnyOf", values: ["failed"] }],
    target: 0.03,
    direction: "lower-is-better",
    window: "LAST_30_DAYS"
  },
  {
    // "Refund resolution rate" and every sibling of it: the workspace names the
    // topics, and renames the metric in their own words.
    id: "topic-resolution",
    slot: "topic",
    filter: [],
    success: [FULFILLED],
    target: 0.8,
    direction: "higher-is-better",
    window: "LAST_30_DAYS"
  },
  {
    // "CSAT for refunds": the satisfaction question asked of one topic. Its
    // filter carries TWO conditions — the operator's topics AND the rated
    // conversations — which is why the compiler adds the slot predicate to the
    // template's own list rather than replacing it.
    id: "topic-satisfaction",
    slot: "topic",
    filter: [{ field: "rating", op: "isAnyOf", values: ["up", "down"] }],
    success: [{ field: "rating", op: "isAnyOf", values: ["up"] }],
    target: 0.85,
    direction: "higher-is-better",
    window: "LAST_30_DAYS"
  },
  {
    // "Booking completion", "Order-change completion" — one capability, and
    // whether the people who reached for it got there.
    id: "capability-completion",
    slot: "capability",
    filter: [],
    success: [FULFILLED],
    target: 0.85,
    direction: "higher-is-better",
    window: "LAST_30_DAYS"
  }
];
var METRIC_TEMPLATE_BY_ID = new Map(
  METRIC_TEMPLATES.map((template2) => [template2.id, template2])
);
function buildMetricFromTemplate(template2, args) {
  const slotValues = args.slotValues ?? [];
  if (template2.slot !== null && slotValues.length === 0) return null;
  const filter = template2.slot === null ? [...template2.filter] : [{ field: template2.slot, op: "isAnyOf", values: [...slotValues] }, ...template2.filter];
  const target = args.target === void 0 ? template2.target : args.target;
  const parsed = successMetricDefinitionSchema.safeParse({
    name: args.name,
    filter,
    success: [...template2.success],
    ...target === null ? {} : { target },
    direction: args.direction ?? template2.direction,
    window: args.window ?? template2.window
  });
  return parsed.success ? parsed.data : null;
}

// src/success-metric/success-metric-alarm.ts
var ALARMING_VERDICT = "off-target";
var UNJUDGED_VERDICTS = [
  "no-conversations",
  "not-enough",
  "no-target"
];
var DEFAULT_METRIC_ALARM = {
  enabled: true,
  snoozedUntil: null,
  lastFiredVerdict: null
};
function shouldFireMetricAlarm(args) {
  const { verdict, state, now } = args;
  if (!state.enabled) return { kind: "suppressed", reason: "disabled" };
  if (state.snoozedUntil !== null && state.snoozedUntil > now) {
    return { kind: "suppressed", reason: "snoozed" };
  }
  if (verdict === "no-target") return { kind: "no-target" };
  if (UNJUDGED_VERDICTS.includes(verdict)) return { kind: "not-measured" };
  if (verdict !== ALARMING_VERDICT) return { kind: "steady" };
  return state.lastFiredVerdict === ALARMING_VERDICT ? { kind: "already-firing" } : { kind: "fire" };
}
function nextFiredVerdict(args) {
  switch (args.decision.kind) {
    case "fire":
    case "already-firing":
    case "steady":
      return args.verdict;
    case "no-target":
    case "not-measured":
    case "suppressed":
      return args.previous;
  }
}
var METRIC_ALARM_VERDICTS = SUCCESS_METRIC_VERDICT_IDS;
var METRIC_ALARM_SNOOZES = ["one-day", "one-week", "one-month"];
var DAY_MS = 24 * 60 * 60 * 1e3;
var SNOOZE_DAYS = {
  "one-day": 1,
  "one-week": 7,
  "one-month": 30
};
function snoozeUntil(snooze, now) {
  return new Date(now.getTime() + SNOOZE_DAYS[snooze] * DAY_MS);
}
var REPORTED_OUTCOME_KEY_PATTERN = /^[a-z][a-z0-9_]{0,63}$/;
var reportedOutcomeKeySchema = /* @__PURE__ */ z.string().regex(REPORTED_OUTCOME_KEY_PATTERN);
var UUID = "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}";
var REPORTED_OUTCOME_CONVERSATION_PATTERN = new RegExp(`^(conv_)?${UUID}$`);
var reportedOutcomeSchema = /* @__PURE__ */ z.object({
  conversationId: z.string().regex(REPORTED_OUTCOME_CONVERSATION_PATTERN),
  outcomeKey: reportedOutcomeKeySchema
}).strict();
var MAX_REPORTED_OUTCOMES_PER_BATCH = 200;
var reportedOutcomeBatchSchema = /* @__PURE__ */ z.object({
  /**
   * Which partition these outcomes belong to. Defaults to `production`.
   *
   * A secret (`gak_`) key is server-held and full-capability, so it keeps the
   * body-driven environment the way the CLI and dashboard paths do
   * (`core/auth/bind-request-environment.ts`) — the publishable-key rebind
   * that pins a widget to production has no purchase here, because there is
   * no public credential involved.
   *
   * The DEFAULT is the debatable half, so the reasoning is written down: an
   * omitted environment means the common case (a production backend
   * reporting production orders), and requiring it would tax every correct
   * integration to catch a rare wrong one. What makes the default safe is
   * that the wrong-environment mistake ANNOUNCES ITSELF — a staging backend
   * reporting into production sends ids production has no conversations for,
   * so every one comes back in `unknownConversations` on the first call
   * rather than landing silently in the wrong partition.
   */
  environment: z.enum(["development", "production"]).default("production"),
  outcomes: z.array(reportedOutcomeSchema).min(1).max(MAX_REPORTED_OUTCOMES_PER_BATCH)
}).strict();

// src/analytics/event-payloads.ts
var WORKSPACE_GROUP_TYPE = "workspace";

// src/analytics/registry.ts
var ANALYTICS_APPS = {
  DASHBOARD: "dashboard",
  MARKETING: "marketing",
  CLI: "cli"
};
var ANALYTICS_EVENTS = {
  // ── Acquisition — marketing site (public, top of funnel) ──────────────────
  /** A "Start free" / "Sign up" CTA was clicked. `location` says which one. */
  MARKETING_SIGNUP_CTA_CLICKED: "marketing_signup_cta_clicked",
  /** A "scan your site" entry link to the public `/scan` funnel was clicked (marketing→scan bridge). `location` says which one. */
  MARKETING_SCAN_CTA_CLICKED: "marketing_scan_cta_clicked",
  /**
   * The non-developer "see it work" CTA was clicked — the landing hero's PRIMARY
   * action since the 2026-07 redesign. Distinguishing it from the signup CTA is
   * the point: the funnel could previously only see engineer-shaped intent
   * (sign up / scan), so a VP Product who watched the demo and left looked
   * identical to a bounce.
   */
  MARKETING_DEMO_CTA_CLICKED: "marketing_demo_cta_clicked",
  /** A "talk to us" / contact CTA was clicked from a marketing surface. */
  MARKETING_CONTACT_CTA_CLICKED: "marketing_contact_cta_clicked",
  /** B20 - the marketing ErrorBoundary caught a render crash (operator visibility). */
  MARKETING_ERROR_BOUNDARY_CAUGHT: "marketing_error_boundary_caught",
  /** The pricing page was viewed (richer than a raw $pageview: carries plan context). */
  MARKETING_PRICING_VIEWED: "marketing_pricing_viewed",
  /** A specific plan's CTA was chosen on the pricing page. */
  MARKETING_PLAN_SELECTED: "marketing_plan_selected",
  /** A `/vs/<rival>` comparison page was viewed. */
  MARKETING_COMPARISON_VIEWED: "marketing_comparison_viewed",
  /** The embedded ROI calculator produced a result. */
  MARKETING_ROI_CALCULATED: "marketing_roi_calculated",
  /**
   * A landing section's "how this actually works" disclosure was opened.
   *
   * The redesign's central bet is layered depth: every section leads in plain
   * language and hides its engineer detail behind one toggle, so a growth lead
   * and a staff engineer can read the same page. This is the only way to find
   * out whether that is true — a disclosure nobody opens is dead weight, and one
   * everybody opens belongs inline.
   */
  MARKETING_DEPTH_DISCLOSED: "marketing_depth_disclosed",
  // ── Activation — discovery CLI (`npx syncanix init`) ──────────────────────
  /** `syncanix init` started (after telemetry consent). */
  CLI_INIT_STARTED: "cli_init_started",
  /** Static capability scan finished — carries detected framework + capability counts. */
  CLI_SCAN_COMPLETED: "cli_scan_completed",
  /** The generated catalog was uploaded to Syncanix cloud — the activation moment. */
  CLI_CATALOG_UPLOADED: "cli_catalog_uploaded",
  /** `syncanix init` failed — carries a coarse error category, never a stack trace. */
  CLI_INIT_FAILED: "cli_init_failed",
  /** The enrichment consent decision — the biggest activation drop-off point. */
  CLI_CONSENT_DECIDED: "cli_consent_decided",
  /** The scan discovered zero capabilities — a top no-findings dead-end. */
  CLI_SCAN_ZERO_FINDINGS: "cli_scan_zero_findings",
  /** The user declined the catalog-upload consent (distinct from `--offline`). */
  CLI_UPLOAD_DECLINED: "cli_upload_declined",
  // ── Activation — the interactive console + kit (ADR-0439 / ADR-0440) ──────
  /** A bare `syncanix` opened the console at a real terminal. */
  CLI_CONSOLE_OPENED: "cli_console_opened",
  /**
   * A console screen was entered. `screen` is the closed `ScreenId` vocabulary
   * (`catalog`, `keys`, …) — never a label, a path, or anything the operator
   * typed, so the property stays low-cardinality and carries no content.
   */
  CLI_CONSOLE_SCREEN_VIEWED: "cli_console_screen_viewed",
  /** The `syncanix/` kit was written — COUNTS only, never file names or bodies. */
  CLI_KIT_GENERATED: "cli_kit_generated",
  // ── Onboarding & lifecycle — dashboard ────────────────────────────────────
  /**
   * An anonymous visitor landed on `/signin` (e.g. from a marketing CTA)
   * BEFORE the Auth0 hosted-login redirect. Captured instantly so the
   * sub-2s auto-redirect can't drop it — this is the dashboard-side bridge
   * of the acquisition funnel that `marketing_signup_cta_clicked` opens.
   */
  SIGNIN_PAGE_VIEWED: "signin_page_viewed",
  USER_SIGNED_IN: "user_signed_in",
  WORKSPACE_CREATED: "workspace_created",
  WORKSPACE_SWITCHED: "workspace_switched",
  // ── Public /scan funnel — dashboard origin, pre-auth (A24/AF-133) ─────────
  /** Anonymous landing on the public `/scan` page (top-of-funnel wow moment). */
  SCAN_PAGE_VIEWED: "scan_page_viewed",
  /** A scan was submitted (after client-side URL validation passed). */
  SCAN_SUBMITTED: "scan_submitted",
  /** The scan returned a result and the themed preview rendered. */
  SCAN_SUCCEEDED: "scan_succeeded",
  /** The scan failed — carries the typed refusal class, never the URL. */
  SCAN_FAILED: "scan_failed",
  /** The visitor copied the embed snippet. */
  SCAN_EMBED_COPIED: "scan_embed_copied",
  /** The visitor clicked the create-workspace CTA from the scan result. */
  SCAN_SIGNUP_CTA_CLICKED: "scan_signup_cta_clicked",
  // ── Configuration / feature adoption — dashboard ──────────────────────────
  CATALOG_VIEWED: "catalog_viewed",
  CAPABILITY_VIEWED: "capability_viewed",
  API_KEY_CREATED: "api_key_created",
  WIDGET_DESIGN_PUBLISHED: "widget_design_published",
  DOCS_SOURCE_CONNECTED: "docs_source_connected",
  /**
   * The empty documentation hub's primary action was taken — DE-306's clock
   * STARTS here.
   *
   * The phase headline is "empty hub to first readable article in fifteen
   * minutes", and for the login-walled ICP that window is exactly when a
   * prospect is deciding: comprehension accrues from in-session harvest and the
   * widget goes live at the END of onboarding, so the hub is empty precisely
   * during evaluation. A claim like that has to be measured on real workspaces
   * rather than asserted from a demo, which is what this pair is for.
   */
  DOCS_FIRST_ARTICLES_STARTED: "docs_first_articles_started",
  /**
   * The hub that was empty now has an article on screen — DE-306's clock STOPS.
   *
   * `elapsed_ms` measures the PLATFORM's part of the promise: from the CTA to
   * an article being readable. It deliberately excludes how long the operator
   * spent inside the walk deciding what to click, because that is their time
   * and folding it in would make the number say something about them rather
   * than about us. `walk_completed` records whether a walk actually ran in
   * between, so a workspace whose articles arrived another way is separable
   * rather than silently inflating the sample.
   */
  DOCS_FIRST_ARTICLES_READY: "docs_first_articles_ready",
  CUSTOM_ENDPOINT_CREATED: "custom_endpoint_created",
  CUSTOM_ENDPOINT_UPDATED: "custom_endpoint_updated",
  PERSONA_SAVED: "persona_saved",
  /** The operator ran the "Check installation" probe — carries the result class, never the URL. */
  INSTALL_CHECK_RUN: "install_check_run",
  // ── Monetization — dashboard ──────────────────────────────────────────────
  BILLING_PORTAL_OPENED: "billing_portal_opened",
  PLAN_CHECKOUT_STARTED: "plan_checkout_started"
};
var EVENT_NAME_SET = new Set(Object.values(ANALYTICS_EVENTS));
function isAnalyticsEventName(candidate) {
  return EVENT_NAME_SET.has(candidate);
}

// src/audit-events/types.ts
var AUDIT_CATEGORIES = [
  "access",
  "change",
  "data-privacy",
  "agent",
  "system"
];
var AUDIT_SEVERITIES = ["info", "notable", "sensitive"];

// src/audit-events/events/access.ts
var ACCESS_EVENTS = [
  {
    actionType: "api-key.issue",
    category: "access",
    severity: "sensitive",
    targetKind: "api-key"
  },
  {
    actionType: "api-key.revoke",
    category: "access",
    severity: "notable",
    targetKind: "api-key"
  },
  {
    // Rotation MINTS a replacement credential and shortens the predecessor
    // (ADR-0364), so it is `sensitive` like `api-key.issue` rather than `notable`
    // like `api-key.revoke`: the outcome is a new key in the world.
    actionType: "api-key.rotate",
    category: "access",
    severity: "sensitive",
    targetKind: "api-key"
  },
  {
    // Rotating the forwarding signing secret. `access` + `sensitive` for the same
    // reason as the reveal below: the secret is what authenticates an outbound
    // payload, so both touching it and replacing it are credential events.
    actionType: "conversation.forwarding.secret.rotated",
    category: "access",
    severity: "sensitive",
    targetKind: "setting"
  },
  {
    // Reading the conversation-forwarding signing secret. `access` rather than
    // `data-privacy` because what was read is a CREDENTIAL, not personal data —
    // and `sensitive` because holding it lets someone forge a forwarded payload,
    // which is the whole reason T6 made the read an audited mutation.
    actionType: "conversation.forwarding.secret.revealed",
    category: "access",
    severity: "sensitive",
    targetKind: "setting"
  },
  {
    actionType: "capability.allow-anonymous-write.set",
    category: "access",
    // Z-5 (ADR-0621) — the broadest write decision on the agent surface: a
    // stranger may now trigger a write, or a destructive, on the customer's site.
    severity: "sensitive",
    targetKind: "capability",
    sentenceArgs: ["to"]
  },
  {
    actionType: "capability.allow-anonymous.set",
    category: "access",
    severity: "sensitive",
    targetKind: "capability",
    sentenceArgs: ["to"]
  },
  {
    // D7 (ADR-0626) — the two-person queue's ANONYMOUS dimension. Its own three
    // action types rather than `capability.enablement.*`, because "someone asked
    // to enable a capability" and "someone asked to open a capability to the
    // public internet" are different facts about different risk, and a reviewer
    // filtering for the second should not have to read a metadata field to tell
    // them apart.
    actionType: "capability.anonymous.approved",
    category: "access",
    severity: "sensitive",
    targetKind: "capability"
  },
  {
    // The REFUSAL of such a request. `notable`, not `sensitive`: nothing was
    // widened, and the sibling `capability.enablement.rejected` takes the same
    // reading.
    actionType: "capability.anonymous.rejected",
    category: "access",
    severity: "notable",
    targetKind: "capability"
  },
  {
    // The request itself — filed, not yet granted, so `notable`.
    actionType: "capability.anonymous.requested",
    category: "access",
    severity: "notable",
    targetKind: "capability"
  },
  {
    actionType: "capability.approval.set",
    category: "access",
    severity: "sensitive",
    targetKind: "capability",
    sentenceArgs: ["to"]
  },
  {
    actionType: "capability.enablement.approved",
    category: "access",
    severity: "sensitive",
    targetKind: "capability"
  },
  {
    actionType: "capability.enablement.rejected",
    category: "access",
    severity: "notable",
    targetKind: "capability"
  },
  {
    actionType: "capability.enablement.requested",
    category: "access",
    severity: "notable",
    targetKind: "capability"
  },
  {
    actionType: "capability.enablement.set",
    category: "access",
    severity: "notable",
    targetKind: "capability",
    sentenceArgs: ["to"]
  },
  {
    // Z-15d (ADR-0624) — a re-walk found a published capability's class ROSE
    // and turned it OFF (keeping the ask). Authored by nobody: the walk is not
    // a person, so `userId` is null and the sentence names the system actor.
    // `notable` rather than `sensitive`: it NARROWS the posture, and the
    // operator-facing notice is the approval screen's callout, not an alert.
    actionType: "capability.escalation.disabled",
    category: "access",
    severity: "notable",
    targetKind: "capability",
    sentenceArgs: ["from", "to"]
  },
  {
    // ADR-0444 — the workspace switched the two-person rule on or off.
    // `sensitive` rather than `notable`, unlike the per-capability toggles
    // above: turning it OFF relaxes the administrative perimeter around EVERY
    // destructive enablement at once, which is a wider change than any single
    // capability. The `to` arg records which direction it moved.
    actionType: "governance.dual-control.set",
    category: "access",
    severity: "sensitive",
    targetKind: "setting",
    sentenceArgs: ["to"]
  },
  {
    actionType: "cli-auth.authorize",
    category: "access",
    severity: "notable",
    targetKind: "member"
  },
  {
    // ADR-0436 — a user-bound CLI session was minted (the `scs_` token the CLI
    // stores). `sensitive` like `api-key.issue`: the outcome is a new live
    // credential in the world that acts as the member.
    actionType: "cli-session.issue",
    category: "access",
    severity: "sensitive",
    targetKind: "member"
  },
  {
    // ADR-0436 — a user-bound CLI session was revoked (logout, the devices
    // panel, or account deletion). `notable` like `api-key.revoke`: access is
    // being taken away, not granted.
    actionType: "cli-session.revoke",
    category: "access",
    severity: "notable",
    targetKind: "member"
  },
  {
    actionType: "member.invite.accept",
    category: "access",
    severity: "notable",
    targetKind: "member"
  },
  {
    actionType: "member.invite.create",
    category: "access",
    severity: "notable",
    targetKind: "member"
  },
  {
    actionType: "member.invite.revoke",
    category: "access",
    severity: "notable",
    targetKind: "member"
  },
  {
    actionType: "member.removed",
    category: "access",
    severity: "sensitive",
    targetKind: "member"
  },
  {
    actionType: "member.role.assign",
    category: "access",
    severity: "sensitive",
    targetKind: "member",
    sentenceArgs: ["from", "to"]
  }
];

// src/audit-events/events/agent.ts
var AGENT_EVENTS = [
  {
    actionType: "conversation.action.rolled_back",
    category: "agent",
    severity: "notable",
    targetKind: "conversation"
  },
  {
    actionType: "conversation.eval_case.promoted",
    category: "agent",
    severity: "info",
    targetKind: "conversation"
  },
  {
    actionType: "conversation.insight.corrected",
    category: "agent",
    severity: "info",
    targetKind: "conversation"
  },
  {
    actionType: "conversation.label.applied",
    category: "agent",
    severity: "info",
    targetKind: "conversation"
  },
  {
    actionType: "conversation.label.removed",
    category: "agent",
    severity: "info",
    targetKind: "conversation"
  },
  {
    actionType: "conversation.review.assigned",
    category: "agent",
    severity: "info",
    targetKind: "conversation"
  },
  {
    actionType: "conversation.review.dismissed",
    category: "agent",
    severity: "info",
    targetKind: "conversation"
  },
  {
    actionType: "conversation.review.restored",
    category: "agent",
    severity: "info",
    targetKind: "conversation"
  },
  {
    actionType: "conversation.review.state_changed",
    category: "agent",
    severity: "info",
    targetKind: "conversation"
  },
  {
    /**
     * plan/agent-engine § 2.8 / D10 — the agent wrote a table out as a file a
     * visitor can download.
     *
     * `agent` rather than `data-privacy`, and the distinction is the ACT rather
     * than the data: nothing left the workspace that the visitor was not already
     * looking at — the file IS the table they were shown, serialized. What the
     * row exists to answer is the operator question "what did we hand this
     * person", which is the same question `mcp.tools_call` below answers about
     * a call.
     *
     * `info`, for the same reason it is not `sensitive`: an export discloses
     * nothing the conversation did not, and marking it notable would push a
     * routine act into the governance view the category is meant to keep clear.
     */
    actionType: "artifact.exported",
    category: "agent",
    severity: "info",
    targetKind: "conversation"
  },
  {
    // The highest-volume type in the system — one row per MCP tools/call, success
    // and error. `agent` is what keeps it out of the governance default view.
    actionType: "mcp.tools_call",
    category: "agent",
    severity: "info",
    targetKind: "tool",
    sentenceArgs: ["outcome"]
  }
];

// src/audit-events/events/change-agent-engine.ts
var AGENT_ENGINE_CHANGE_EVENTS = [
  {
    // plan/agent-engine § 2.5 — what the workspace's agent may ANSWER: its
    // refused topics, its handling of the sensitive domains and of a competitor
    // question, and where a refused visitor is sent instead. `notable` rather
    // than `info`: widening it is the one edit here that changes what an agent
    // will discuss with every visitor of the site.
    actionType: "scope-policy.updated",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    // plan/agent-engine § 2.9 / ADR-0801 — the operator changed this
    // workspace's NEGATIVE-MARGIN THROTTLE: the margin floor below which its
    // turns narrow, and how deep the ladder may go.
    //
    // `notable` rather than `info`, and for the same reason `scope-policy.updated`
    // is: arming it changes what every visitor of the site gets — a cheaper
    // model, no paid rerank, a narrower capability list — and the DEEPEST depth
    // lowers a ceiling a signed-out visitor can meet as a refusal. Disarming it
    // is equally notable from the other side, since it is the control that
    // stops a workspace running underwater.
    actionType: "spend-protection.updated",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  }
];

// src/audit-events/events/change-allowed-sites.ts
var ALLOWED_SITES_CHANGE_EVENTS = [
  {
    // The outbound read allowlist (plan/agent-allowed-sites.md §2.11). Sensitive
    // rather than info: each entry widens where the agent may reach, and the
    // trail is how an operator answers "when did we start reading that site".
    actionType: "allowed-site.create",
    category: "change",
    severity: "sensitive",
    targetKind: "setting"
  },
  {
    actionType: "allowed-site.update",
    category: "change",
    severity: "sensitive",
    targetKind: "setting"
  },
  {
    actionType: "allowed-site.delete",
    category: "change",
    severity: "info",
    targetKind: "setting"
  },
  {
    // R3's public half — an operator spending SERVER-SIDE EGRESS against their
    // own site. Recorded because the refresh record is a single per-tenant row
    // that each read overwrites, so without this the product can say WHAT the
    // last read cost and not WHO asked for it or how often — which is exactly
    // what an operator (or an auditor) asking "why did you request my sitemap
    // twelve times" needs (agent security review LOW-2).
    //
    // `sensitive` rather than `info` on the S1-1 reasoning: it is not a
    // settings edit, it is an outbound request made on the workspace's behalf.
    actionType: "published-routes.refresh",
    category: "change",
    severity: "sensitive",
    targetKind: "setting"
  }
];

// src/audit-events/events/change-capability-dossier.ts
var CAPABILITY_DOSSIER_CHANGE_EVENTS = [
  {
    actionType: "capability.dossier.edited",
    category: "change",
    severity: "sensitive",
    targetKind: "capability"
  },
  {
    actionType: "capability.dossier.unlocked",
    category: "change",
    severity: "notable",
    targetKind: "capability"
  }
];

// src/audit-events/events/change-channels.ts
var CHANNEL_CHANGE_EVENTS = [
  {
    // `sensitive` for the same reason as `conversation.forwarding.set`:
    // enabling the channel makes Meta a sub-processor for end-user transcripts,
    // and the row carries the recorded terms acknowledgment ("who accepted
    // which version") behind that.
    actionType: "channel.whatsapp.enabled",
    category: "change",
    severity: "sensitive",
    targetKind: "setting"
  },
  {
    actionType: "channel.whatsapp.disabled",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    // The SECOND toggle (§19): switching linking on moves the workspace from
    // pseudonymous to identified personal data (§18), under its own terms.
    actionType: "channel.whatsapp.linking.set",
    category: "change",
    severity: "sensitive",
    targetKind: "setting"
  }
];

// src/audit-events/events/change-config-checkpoints.ts
var CONFIG_CHECKPOINT_CHANGE_EVENTS = [
  {
    // An operator saved the whole configuration as a checkpoint on demand.
    // `notable`: a deliberate act worth reading in the trail, and the reference
    // point a later restore names.
    actionType: "config.checkpoint.created",
    category: "change",
    severity: "notable",
    targetKind: "workspace"
  },
  {
    // The configuration was rolled back to a checkpoint. `sensitive`: it
    // rewrites every registered surface (capability enablement included) and
    // takes effect for every visitor at once. The row's metadata names the
    // checkpoint restored, the row appended, and the pre-restore save.
    actionType: "config.checkpoint.restored",
    category: "change",
    severity: "sensitive",
    targetKind: "workspace"
  }
];

// src/audit-events/events/change-docs.ts
var DOCS_CHANGE_EVENTS = [
  {
    // The rung rides in `to` (`internal` / `published` / `approved-external`),
    // because "who approved this, and to what audience" is one question and an
    // auditor should not have to open a payload to answer half of it.
    actionType: "docs.article.approved",
    category: "change",
    severity: "notable",
    targetKind: "document",
    sentenceArgs: ["to"]
  },
  {
    // The reviewer's "no" — the shipped transition returns the article to
    // `draft`. Named `rejected` rather than § 11's word `excluded` because
    // `excluded` is a DIFFERENT status in the ladder, which this mutation does
    // not write; a row saying "excluded" over a draft would be a trail
    // describing something that did not happen.
    actionType: "docs.article.rejected",
    category: "change",
    severity: "notable",
    targetKind: "document"
  },
  {
    // § 11's revert. `notable` rather than `sensitive`, and the bound is what
    // makes that honest rather than convenient: a revert can only restore a
    // version this workspace previously approved, and the service refuses to
    // climb out of `recalled` or `excluded` — so it can never put back content
    // a workspace withdrew or an operator refused. Both statuses ride on the
    // row (`from` / `to`) because a revert IS a transition, and the version
    // number rides in the metadata beside them.
    actionType: "docs.article.reverted",
    category: "change",
    severity: "notable",
    targetKind: "document",
    sentenceArgs: ["from", "to"]
  },
  {
    // An EDIT override replaces the text the agent speaks. The row names the
    // document and the chunk; the replacement text is never in the trail —
    // `audit_log` is readable by every `editor`, is in the CSV export, and is
    // unpurgeable once AL-7's hash chain seals it.
    actionType: "docs.document.edited",
    category: "change",
    severity: "notable",
    targetKind: "document"
  },
  {
    // An EXCLUDE override takes a document out of what the agent may quote.
    // `notable` rather than `sensitive`: it NARROWS, and narrowing is the safe
    // direction. Its removal is the sensitive half.
    actionType: "docs.document.excluded",
    category: "change",
    severity: "notable",
    targetKind: "document"
  },
  {
    actionType: "docs.document.pinned",
    category: "change",
    severity: "info",
    targetKind: "document"
  },
  {
    actionType: "docs.finding.dismissed",
    category: "change",
    severity: "notable",
    targetKind: "document",
    // Dismissal is a BULK decision on the inbox, so the count is the fact —
    // one row saying "dismissed 12" beats twelve rows nobody reads.
    sentenceArgs: ["count"]
  },
  {
    // The inverse of all four kinds above, so `field` names which one was
    // undone. `sensitive` because two of those inverses re-expose: removing an
    // exclusion puts a document back in front of the agent, and removing a
    // relabel restores the source's own — usually wider — label.
    actionType: "docs.override.removed",
    category: "change",
    severity: "sensitive",
    targetKind: "document",
    sentenceArgs: ["field"]
  },
  {
    actionType: "docs.visibility.changed",
    category: "change",
    severity: "sensitive",
    targetKind: "document",
    sentenceArgs: ["from", "to"]
  },
  {
    // DE-010 — recall. `sensitive` rather than `notable`: it removes published
    // content a workspace's visitors could read, and it is the row an auditor
    // reaches for when asked "when did you stop publishing that, and who said
    // so". The release is its pair and carries the same weight, because
    // resuming publication is as much a decision as stopping it.
    actionType: "generated-docs.recall",
    category: "change",
    severity: "sensitive",
    targetKind: "setting",
    sentenceArgs: ["count"]
  },
  {
    actionType: "generated-docs.release",
    category: "change",
    severity: "sensitive",
    targetKind: "setting"
  }
];

// src/audit-events/events/change-experiences.ts
var EXPERIENCE_CHANGE_EVENTS = [
  {
    // A unit is born DRAFT with zero rollout, so a create shows nothing to
    // anybody — hence `info` rather than `notable`. The row that matters is
    // `armed`.
    actionType: "experience.unit.created",
    category: "change",
    severity: "info",
    targetKind: "setting"
  },
  {
    // A content or targeting edit. `notable`: the unit may already be live, so
    // this can change what a visitor reads without any lifecycle row beside it.
    actionType: "experience.unit.updated",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    // The change a visitor actually feels: this unit now renders on the
    // customer's own page. `sensitive` rather than `notable`, and it is the one
    // entry here that is — arming puts interactive content the platform drew
    // onto somebody else's site, which is the boundary this whole surface is
    // governed around (the ASI09 trust line).
    actionType: "experience.unit.armed",
    category: "change",
    severity: "sensitive",
    targetKind: "setting"
  },
  {
    // Stopped showing, by an OPERATOR's decision. Narrows what a visitor sees,
    // so `notable`: worth reading, never alarming.
    //
    // This comment said "or by the anchor-health sweep" until F-5 checked, and
    // the sweep wrote no row at all — the documented-but-absent class, in the
    // registry an auditor reads to learn what is recorded. The sweep now has
    // its own action below, which is the better answer than folding it in here:
    // an auditor asking who pulled a banner has to be able to tell a person
    // from a machine without reading payloads.
    actionType: "experience.unit.paused",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    // The anchor-health sweep pulled a unit whose control vanished from the
    // customer's site.
    //
    // `sensitive`, above the operator's own pause, and the reason is not that
    // it matters more but that NOBODY DECIDED IT. It is the one status change
    // on this surface no human performs, it is triggered by reports arriving on
    // the public widget channel, and it takes a customer's live content down.
    // Its actor is null by construction — there is no member to name — which is
    // exactly the property that makes it worth its own row.
    //
    // Corroboration bounds the trigger (F-2: three DISTINCT observing sessions,
    // not three requests), so this is not a row a loop can mint. The trail is
    // what tells an operator WHICH unit, WHEN, and on what evidence.
    actionType: "experience.unit.anchor-lost",
    category: "change",
    severity: "sensitive",
    targetKind: "setting"
  },
  {
    // ADR-0562 § 2 (F2) — the nightly freshness sweep pulled a unit because the
    // thing it POINTS AT stopped resolving: a deleted guide, a step anchored to
    // a control nobody can find, a CTA naming a capability the workspace no
    // longer serves.
    //
    // Its own row rather than `anchor-lost`, for the reason migration 426 gave
    // the STATUS its own value: a unit whose `start-guide` names a broken guide
    // has a perfectly good anchor, and an auditor reading "anchor lost" would
    // be looking for a redesign that never happened.
    //
    // `sensitive` on the same terms as its sibling: this is a write nobody
    // performed that takes a visitor-facing unit off. The actor is null by
    // construction, and the `after` carries the closed failure vocabulary plus
    // the missing reference — which is what tells an operator WHAT to fix
    // rather than only that something broke.
    actionType: "experience.unit.reference-lost",
    category: "change",
    severity: "sensitive",
    targetKind: "setting"
  },
  {
    actionType: "experience.unit.retired",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    // A saved guide — an operator-authored walkthrough that units point at.
    // `notable` rather than `sensitive`: saving one shows nobody anything, and
    // a guide only ever runs because a unit an operator ARMED launched it. The
    // arming row above is where the visitor-facing change is recorded.
    //
    // Worth its own event rather than folding into `unit.updated`, because a
    // guide edit changes what EVERY unit pointing at it does — so an auditor
    // asking "why did the checkout tour change" would otherwise find no row at
    // all on the unit they were reading.
    actionType: "experience.guide.saved",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    actionType: "experience.guide.deleted",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  }
];

// src/audit-events/events/change-host-component.ts
var HOST_COMPONENT_CHANGE_EVENTS = [
  {
    /** The operator wrote, changed or cleared one component's `useWhen`. */
    actionType: "host_component.use_when.set",
    category: "change",
    severity: "sensitive",
    targetKind: "tool"
  }
];

// src/audit-events/events/change-monitoring.ts
var MONITORING_CHANGE_EVENTS = [
  {
    actionType: "monitoring.drift.accepted",
    category: "change",
    severity: "notable",
    targetKind: "capability"
  },
  {
    actionType: "monitoring.drift.flagCleared",
    category: "change",
    severity: "info",
    targetKind: "capability"
  },
  {
    actionType: "monitoring.drift.flagged",
    category: "change",
    severity: "info",
    targetKind: "capability"
  },
  {
    actionType: "monitoring.target.cleared",
    category: "change",
    severity: "info",
    targetKind: "setting"
  },
  {
    actionType: "monitoring.target.set",
    category: "change",
    severity: "info",
    targetKind: "setting"
  }
];

// src/audit-events/events/change-persona.ts
var PERSONA_CHANGE_EVENTS = [
  {
    actionType: "persona.profile.create",
    category: "change",
    severity: "info",
    targetKind: "persona-profile"
  },
  {
    actionType: "persona.profile.delete",
    category: "change",
    severity: "sensitive",
    targetKind: "persona-profile"
  },
  {
    actionType: "persona.profile.duplicate",
    category: "change",
    severity: "info",
    targetKind: "persona-profile"
  },
  {
    actionType: "persona.profile.rename",
    category: "change",
    severity: "info",
    targetKind: "persona-profile"
  },
  {
    actionType: "persona.profile.restore",
    category: "change",
    severity: "notable",
    targetKind: "persona-profile"
  },
  {
    actionType: "persona.profile.set-active",
    category: "change",
    severity: "notable",
    targetKind: "persona-profile"
  },
  {
    actionType: "persona.profile.set-embed-selection",
    category: "change",
    severity: "notable",
    targetKind: "persona-profile"
  },
  {
    actionType: "persona.profile.set-enabled",
    category: "change",
    severity: "notable",
    targetKind: "persona-profile"
  },
  {
    actionType: "persona.profile.set-targeting",
    category: "change",
    severity: "notable",
    targetKind: "persona-profile"
  },
  {
    actionType: "persona.profile.update",
    category: "change",
    severity: "notable",
    targetKind: "persona-profile"
  },
  {
    actionType: "persona.workspace.update",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  }
];

// src/audit-events/events/change-planner-examples.ts
var PLANNER_EXAMPLE_CHANGE_EVENTS = [
  {
    actionType: "planner_example.promoted",
    category: "change",
    severity: "notable",
    targetKind: "conversation"
  },
  {
    actionType: "planner_example.removed",
    category: "change",
    severity: "notable",
    targetKind: "conversation"
  }
];

// src/audit-events/events/change-site-walk.ts
var SITE_WALK_CHANGE_EVENTS = [
  {
    // WF-4.9 / ADR-0576 — the operator chose LIVE for one guided site walk: the
    // walk's sealed pass may let non-destructive writes reach their own product.
    // `sensitive` because it is a per-run decision that produces real writes,
    // and audit-recorded rather than prevented (ADR-0369's posture): the
    // person is entitled to it, and the trail is what makes it attributable.
    actionType: "site-walk.live-run.start",
    category: "change",
    severity: "sensitive",
    targetKind: "environment"
  },
  {
    // A4 / Z-2 (zero-touch walk) — "Register it and continue": the one press on
    // `/site-walk` that adds an origin to the widget allowlist and starts the
    // walk. The write is `WidgetOriginService.addOrigin`, the same path the
    // `/connect` editor takes; its own type because the trail should say the
    // origin arrived on a walk press. `sensitive` because an allowlist change
    // widens where the widget will run, which is the gate `SECURITY.md` § 1
    // rests on. `setting` because the allowlist is a workspace setting.
    actionType: "site-walk.origin.registered",
    category: "change",
    severity: "sensitive",
    targetKind: "setting"
  }
];

// src/audit-events/events/change-task-guides.ts
var TASK_GUIDE_CHANGE_EVENTS = [
  {
    actionType: "task-guide.archived",
    category: "change",
    severity: "info",
    targetKind: "task-guide"
  },
  {
    actionType: "task-guide.published",
    category: "change",
    severity: "notable",
    targetKind: "task-guide"
  },
  {
    // Z-15a / E4 (ADR-0634) — the one-click undo for an auto-published guide.
    // `notable`, matching its publish sibling rather than its archive one: it
    // changes what a visitor is offered on a live page with no deploy, which is
    // the property that made `published` notable, and the direction of the
    // change does not make it less so. Distinct from `archived` because the two
    // say different things to a later reader — unpublish returns a guide to the
    // review queue, archive says never re-mint it.
    actionType: "task-guide.unpublished",
    category: "change",
    severity: "notable",
    targetKind: "task-guide"
  },
  {
    actionType: "task-guide.renamed",
    category: "change",
    severity: "info",
    targetKind: "task-guide"
  },
  {
    // TG-3a-ii — an operator reordered, removed or re-worded a guide's steps.
    // `notable` rather than `info`, unlike its rename sibling: a rename changes
    // what a guide is CALLED, where this changes what a visitor is walked
    // through — including removing a step from a flow that is already published.
    actionType: "task-guide.steps-edited",
    category: "change",
    severity: "notable",
    targetKind: "task-guide"
  }
];

// src/audit-events/events/change-ugl.ts
var UGL_CHANGE_EVENTS = [
  {
    // UGL-107 — proactive engagement rules. `change` rather than `agent`: these
    // are configuration an operator deliberately authored, not runtime traffic.
    actionType: "engagement_rule.create",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    actionType: "engagement_rule.delete",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    // Arming or disarming a rule is the change a visitor actually feels, so it is
    // separated from a content edit rather than folded into `update`.
    actionType: "engagement_rule.set_status",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    // UGL-302 — a signed operator test link was minted. `sensitive`: the link
    // lets its holder trigger a rule outside its normal eligibility, so an
    // auditor should see it without filtering payloads.
    actionType: "engagement_rule.test_link_minted",
    category: "change",
    severity: "sensitive",
    targetKind: "setting"
  },
  {
    actionType: "engagement_rule.update",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    // UGL-401 — a learning proposal was DRAFTED (machine-authored, awaiting a
    // human). `info`: nothing has changed yet; the accept/reject below is where
    // the durable write happens.
    actionType: "learning-proposal.created",
    category: "change",
    severity: "info",
    targetKind: "setting"
  },
  {
    // The operator's decision on a drafted proposal. `notable` on both arms: an
    // accept changes the agent's voice, and a reject is the record that a
    // proposed change was deliberately declined.
    actionType: "learning-proposal.accepted",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    actionType: "learning-proposal.rejected",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    // UGL-105 — an audience's membership snapshot was recomputed.
    actionType: "user_segment.resnapshot",
    category: "change",
    severity: "info",
    targetKind: "segment"
  }
];

// src/audit-events/events/change-user-segments.ts
var USER_SEGMENT_CHANGE_EVENTS = [
  {
    actionType: "user-segment.create",
    category: "change",
    severity: "info",
    targetKind: "segment"
  },
  {
    actionType: "user-segment.delete",
    category: "change",
    severity: "notable",
    targetKind: "segment"
  },
  {
    actionType: "user-segment.member.remove",
    category: "change",
    severity: "info",
    targetKind: "segment"
  },
  {
    actionType: "user-segment.members.add",
    category: "change",
    severity: "info",
    targetKind: "segment"
  },
  {
    actionType: "user-segment.update",
    category: "change",
    severity: "info",
    targetKind: "segment"
  }
];

// src/audit-events/events/change.ts
var CHANGE_EVENTS = [
  ...ALLOWED_SITES_CHANGE_EVENTS,
  ...CHANNEL_CHANGE_EVENTS,
  ...CAPABILITY_DOSSIER_CHANGE_EVENTS,
  ...HOST_COMPONENT_CHANGE_EVENTS,
  ...CONFIG_CHECKPOINT_CHANGE_EVENTS,
  ...DOCS_CHANGE_EVENTS,
  ...EXPERIENCE_CHANGE_EVENTS,
  ...MONITORING_CHANGE_EVENTS,
  ...PLANNER_EXAMPLE_CHANGE_EVENTS,
  ...UGL_CHANGE_EVENTS,
  {
    actionType: "audience-alarm.delete",
    category: "change",
    severity: "info",
    targetKind: "segment"
  },
  {
    actionType: "audience-alarm.set",
    category: "change",
    severity: "info",
    targetKind: "segment"
  },
  {
    actionType: "byo-routing.opt-in",
    category: "change",
    severity: "sensitive",
    targetKind: "setting"
  },
  {
    actionType: "byo-routing.opt-out",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    actionType: "capability.guidance.removed",
    category: "change",
    severity: "info",
    targetKind: "capability"
  },
  {
    actionType: "capability.guidance.set",
    category: "change",
    severity: "notable",
    targetKind: "capability"
  },
  {
    actionType: "capability.override.set",
    category: "change",
    severity: "notable",
    targetKind: "capability"
  },
  {
    actionType: "capability.version.annotated",
    category: "change",
    severity: "info",
    targetKind: "capability"
  },
  {
    actionType: "compliance-qa.settings.updated",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    // `notable` rather than `info`: this changes what a workspace's visitors meet
    // before they have said a word, and unlike a Labs toggle it has no
    // fleet-level switch above it that would show up in the same trail.
    actionType: "composition.experience.set",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    // Distinct from `composition.style-rules.set` for the same reason that one is
    // distinct from the welcome settings: a HINT is a lean a visitor's own wish
    // outranks, a RULE is enforced by a clamp. "Who told the agent to prefer
    // tables" and "who banned charts" are two questions, and one type answers
    // neither with a filter.
    actionType: "composition.hints.set",
    category: "change",
    severity: "info",
    targetKind: "setting"
  },
  {
    // A SEPARATE type from `composition.experience.set`, not a variant of it:
    // "we changed how a session opens" and "we banned charts" are different
    // questions an auditor asks, and one type covering both makes neither
    // answerable with a filter.
    actionType: "composition.style-rules.set",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    // The ONE composition audit type no operator triggers — the ramp widens a
    // workspace by itself, on a rule (`rampLevel`), and the widen has to be
    // explainable after the fact: "your workspace widened to balanced on the
    // 3rd" is only an answer if the counts that decided it are in the same row.
    // `info` rather than `notable`: it is the system doing exactly what decision
    // 13 says it will, in the direction the operator can already set by hand.
    actionType: "composition.ramp.widened",
    category: "change",
    severity: "info",
    targetKind: "setting",
    // The two levels, which the renderer supplies only because the row changes
    // exactly ONE field. A second field in `before`/`after` would silently blank
    // both halves of the sentence, so the service writes only `rampLevel`.
    sentenceArgs: ["from", "to"]
  },
  {
    actionType: "conversation.settings.updated",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    // `sensitive`, and split from `conversation.settings.updated` on purpose: this is
    // the outbound-data-flow control, so "who repointed our conversation feed" has to
    // be answerable with one filter click rather than buried in a generic settings row.
    actionType: "conversation.forwarding.set",
    category: "change",
    severity: "sensitive",
    targetKind: "setting"
  },
  {
    actionType: "observability.sentry-forwarding.set",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    actionType: "widget.settings.updated",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    actionType: "custom_endpoint.created",
    category: "change",
    severity: "notable",
    targetKind: "custom-endpoint"
  },
  {
    actionType: "custom_endpoint.deleted",
    category: "change",
    severity: "notable",
    targetKind: "custom-endpoint"
  },
  {
    actionType: "custom_endpoint.updated",
    category: "change",
    severity: "notable",
    targetKind: "custom-endpoint"
  },
  {
    actionType: "environment.promote",
    category: "change",
    severity: "notable",
    targetKind: "environment"
  },
  {
    actionType: "experimental.feature.set",
    category: "change",
    severity: "info",
    targetKind: "feature-flag"
  },
  {
    actionType: "frontier.feature.set",
    category: "change",
    severity: "info",
    targetKind: "feature-flag"
  },
  {
    actionType: "page-rule.created",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    actionType: "page-rule.deleted",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  {
    actionType: "page-rule.updated",
    category: "change",
    severity: "notable",
    targetKind: "setting"
  },
  ...AGENT_ENGINE_CHANGE_EVENTS,
  ...TASK_GUIDE_CHANGE_EVENTS,
  {
    actionType: "user-learning.budget.set",
    category: "change",
    severity: "info",
    targetKind: "setting"
  },
  ...SITE_WALK_CHANGE_EVENTS,
  {
    actionType: "user-learning.config.set",
    category: "change",
    severity: "info",
    targetKind: "setting"
  },
  ...USER_SEGMENT_CHANGE_EVENTS,
  ...PERSONA_CHANGE_EVENTS
];

// src/audit-events/events/data-privacy.ts
var DATA_PRIVACY_EVENTS = [
  {
    // UGL-203 — an operator muted a learned insight (it stops being injected but
    // is NOT deleted). Data-privacy, beside the other per-end-user writes: it
    // changes what the agent holds about a specific person.
    actionType: "end-user.insight.mute",
    category: "data-privacy",
    severity: "notable",
    targetKind: "end-user"
  },
  // AL-8 / F-16 — auditing the audit. Who READ the trail, and who took a copy of it
  // away, are themselves access-to-personal-data events: an auditor asking "who has
  // seen this?" was previously answered by silence.
  //
  // `audit-log.exported` is `sensitive`: a copy leaves the platform's control, and
  // that is a materially different act from paging through it in a browser.
  {
    actionType: "audit-log.exported",
    category: "data-privacy",
    severity: "sensitive",
    targetKind: "audit-log",
    sentenceArgs: ["count", "format"]
  },
  // AL-10 — who receives the weekly digest is itself a governance control. An
  // attacker (or a careless admin) who quietly removes the security team from the
  // recipient list blinds exactly the people meant to notice everything else, and
  // without this row that change would leave no trace anywhere. `notable` rather than
  // `sensitive`: it exposes no personal data and is reversible, but it is never
  // routine.
  {
    actionType: "audit-log.digest.set",
    category: "data-privacy",
    severity: "notable",
    targetKind: "audit-log",
    sentenceArgs: ["count", "outcome"]
  },
  {
    actionType: "audit-log.viewed",
    category: "data-privacy",
    severity: "info",
    targetKind: "audit-log"
  },
  {
    actionType: "conversation.export_executed",
    category: "data-privacy",
    severity: "sensitive",
    targetKind: "conversation"
  },
  {
    actionType: "conversation.metadata_export_executed",
    category: "data-privacy",
    severity: "sensitive",
    targetKind: "conversation"
  },
  {
    actionType: "conversation.timeline_exported",
    category: "data-privacy",
    severity: "sensitive",
    targetKind: "conversation"
  },
  {
    actionType: "conversation.timeline_viewed",
    category: "data-privacy",
    severity: "notable",
    targetKind: "conversation"
  },
  {
    actionType: "conversation.transcript_emailed",
    category: "data-privacy",
    severity: "sensitive",
    targetKind: "conversation"
  },
  {
    actionType: "conversation.transcript_viewed",
    category: "data-privacy",
    severity: "notable",
    targetKind: "conversation"
  },
  {
    actionType: "dsar.erasure_executed",
    category: "data-privacy",
    severity: "sensitive",
    targetKind: "subject"
  },
  {
    actionType: "dsar.portability_export_executed",
    category: "data-privacy",
    severity: "sensitive",
    targetKind: "subject"
  },
  {
    actionType: "end-user.attribute.reject",
    category: "data-privacy",
    severity: "info",
    targetKind: "end-user"
  },
  {
    actionType: "end-user.attribute.set",
    category: "data-privacy",
    severity: "notable",
    targetKind: "end-user"
  },
  {
    actionType: "end-user.claim-capture.set",
    category: "data-privacy",
    severity: "sensitive",
    targetKind: "setting"
  },
  {
    actionType: "end-user.erase",
    category: "data-privacy",
    severity: "sensitive",
    targetKind: "end-user"
  },
  {
    actionType: "end-user.export",
    category: "data-privacy",
    severity: "sensitive",
    targetKind: "end-user"
  },
  {
    actionType: "end-user.insight.delete",
    category: "data-privacy",
    severity: "notable",
    targetKind: "end-user"
  },
  {
    actionType: "end-user.insight.upsert",
    category: "data-privacy",
    severity: "notable",
    targetKind: "end-user"
  },
  {
    actionType: "end-user.override.set",
    category: "data-privacy",
    severity: "notable",
    targetKind: "end-user"
  },
  {
    actionType: "end-user.pause",
    category: "data-privacy",
    severity: "notable",
    targetKind: "end-user"
  }
];

// src/audit-events/events/system.ts
var SYSTEM_EVENTS = [
  {
    actionType: "workspace.created",
    category: "system",
    severity: "notable",
    targetKind: "workspace"
  },
  {
    actionType: "workspace.deleted",
    category: "system",
    severity: "sensitive",
    targetKind: "workspace"
  },
  {
    // ADR-0369 — deletion is now a 7-day soft delete, so scheduling it and the
    // purge completing are two different facts. This is the schedule: recoverable,
    // and still `sensitive`, because from this moment the workspace is unbindable
    // on every principal path and every agent surface stops answering for it.
    actionType: "workspace.delete.scheduled",
    category: "system",
    severity: "sensitive",
    targetKind: "workspace"
  },
  {
    // The undo. `notable` rather than `sensitive`: it restores access rather than
    // widening or destroying it, and only an owner can do it.
    actionType: "workspace.restored",
    category: "system",
    severity: "notable",
    targetKind: "workspace"
  },
  {
    actionType: "workspace.member.left",
    category: "system",
    severity: "notable",
    targetKind: "member"
  },
  {
    // ADR-0767 — an OPERATOR moved the workspace to another owner account. Actor
    // is null (the platform operator is not a member); the operator's identity,
    // the reason and the change journal are on the `workspace_migrations` ledger
    // row the metadata names. `sensitive` for the same reason a transfer is:
    // the strongest role in the workspace changed hands.
    actionType: "workspace.migrated",
    category: "system",
    severity: "sensitive",
    targetKind: "workspace"
  },
  {
    // The reversal of the row above. Still `sensitive` — ownership moved again.
    actionType: "workspace.migration.reverted",
    category: "system",
    severity: "sensitive",
    targetKind: "workspace"
  },
  {
    actionType: "workspace.ownership.transferred",
    category: "system",
    severity: "sensitive",
    targetKind: "workspace"
  },
  {
    actionType: "workspace.renamed",
    category: "system",
    severity: "info",
    targetKind: "workspace",
    sentenceArgs: ["from", "to"]
  }
];

// src/audit-events/registry.ts
var AUDIT_EVENTS = [
  ...ACCESS_EVENTS,
  ...CHANGE_EVENTS,
  ...DATA_PRIVACY_EVENTS,
  ...AGENT_EVENTS,
  ...SYSTEM_EVENTS
];
var BY_ACTION_TYPE = new Map(
  AUDIT_EVENTS.map((e) => [e.actionType, e])
);
function auditEvent(actionType) {
  return BY_ACTION_TYPE.get(actionType);
}
function auditActionTypes() {
  return AUDIT_EVENTS.map((e) => e.actionType);
}
function auditActionTypesInCategory(category) {
  return AUDIT_EVENTS.filter((e) => e.category === category).map((e) => e.actionType);
}

// src/audit-events/keys.ts
function auditEventLabelKey(actionType) {
  return `auditEvent.${actionType}.label`;
}
function auditEventSentenceKey(actionType) {
  return `auditEvent.${actionType}.sentence`;
}
function auditCategoryKey(category) {
  return `auditCategory.${category}`;
}
function auditSeverityKey(severity) {
  return `auditSeverity.${severity}`;
}
function prettifyActionType(actionType) {
  const words = actionType.split(/[.\-_]+/).filter((part) => part !== "").join(" ").trim();
  if (words === "") return actionType;
  return words.charAt(0).toUpperCase() + words.slice(1);
}
function isKnownAuditAction(actionType) {
  return auditEvent(actionType) !== void 0;
}

// src/change-timeline/index.ts
var BUSINESS_CHANGE_KINDS = [
  "capability",
  "persona",
  "page-rule",
  "nudge",
  "audience",
  "guidance"
];
var BUSINESS_CHANGE_ACTIONS = {
  // What the agent is allowed to do — the change most likely to move a number.
  "capability.enablement.set": "capability",
  "capability.override.set": "capability",
  "capability.approval.set": "capability",
  "capability.allow-anonymous.set": "capability",
  // How the agent speaks, and which visitors hear which voice.
  "persona.profile.set-active": "persona",
  "persona.profile.update": "persona",
  "persona.profile.set-targeting": "persona",
  "persona.profile.set-enabled": "persona",
  "persona.workspace.update": "persona",
  // Where the agent behaves differently.
  "page-rule.created": "page-rule",
  "page-rule.updated": "page-rule",
  "page-rule.deleted": "page-rule",
  // What the agent says first.
  "engagement_rule.create": "nudge",
  "engagement_rule.update": "nudge",
  "engagement_rule.delete": "nudge",
  "engagement_rule.set_status": "nudge",
  // Who counts as whom.
  "user-segment.create": "audience",
  "user-segment.update": "audience",
  "user-segment.delete": "audience",
  // Operator-authored guidance composed into what the agent is told.
  "capability.guidance.set": "guidance",
  "capability.guidance.removed": "guidance"
};
var BUSINESS_CHANGE_ACTION_TYPES = Object.keys(BUSINESS_CHANGE_ACTIONS);
function businessChangeKind(actionType) {
  return Object.prototype.hasOwnProperty.call(BUSINESS_CHANGE_ACTIONS, actionType) ? BUSINESS_CHANGE_ACTIONS[actionType] ?? null : null;
}
var MAX_CHANGE_MARKERS = 40;

// src/color/color.ts
function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}
function clampChannel(value) {
  return clamp(Math.round(value), 0, 255);
}
function toHexByte(value) {
  return clampChannel(value).toString(16).padStart(2, "0");
}
var HEX_PATTERN = /^#?([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
function parseHex(input) {
  const trimmed = input.trim();
  const match = HEX_PATTERN.exec(trimmed);
  const group = match?.[1];
  if (group === void 0) {
    return null;
  }
  let hex = group;
  if (hex.length === 3 || hex.length === 4) {
    hex = hex.split("").map((c) => c + c).join("");
  }
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const alpha = hex.length === 8 ? parseInt(hex.slice(6, 8), 16) / 255 : 1;
  return { rgb: { r, g, b }, alpha };
}
function formatHex(rgb, alpha) {
  const base = `#${toHexByte(rgb.r)}${toHexByte(rgb.g)}${toHexByte(rgb.b)}`;
  if (alpha === void 0 || alpha >= 1) {
    return base;
  }
  return base + toHexByte(clamp(alpha, 0, 1) * 255);
}
function rgbToHsv(rgb) {
  const r = clamp(rgb.r, 0, 255) / 255;
  const g = clamp(rgb.g, 0, 255) / 255;
  const b = clamp(rgb.b, 0, 255) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const delta = max - min;
  let h = 0;
  if (delta !== 0) {
    if (max === r) {
      h = (g - b) / delta % 6;
    } else if (max === g) {
      h = (b - r) / delta + 2;
    } else {
      h = (r - g) / delta + 4;
    }
    h *= 60;
    if (h < 0) {
      h += 360;
    }
  }
  const s = max === 0 ? 0 : delta / max;
  return { h: Math.round(h), s: Math.round(s * 100), v: Math.round(max * 100) };
}
function hsvToRgb(hsv) {
  const h = (hsv.h % 360 + 360) % 360;
  const s = clamp(hsv.s, 0, 100) / 100;
  const v = clamp(hsv.v, 0, 100) / 100;
  const c = v * s;
  const x = c * (1 - Math.abs(h / 60 % 2 - 1));
  const m = v - c;
  let r = 0;
  let g = 0;
  let b = 0;
  if (h < 60) {
    [r, g, b] = [c, x, 0];
  } else if (h < 120) {
    [r, g, b] = [x, c, 0];
  } else if (h < 180) {
    [r, g, b] = [0, c, x];
  } else if (h < 240) {
    [r, g, b] = [0, x, c];
  } else if (h < 300) {
    [r, g, b] = [x, 0, c];
  } else {
    [r, g, b] = [c, 0, x];
  }
  return {
    r: Math.round((r + m) * 255),
    g: Math.round((g + m) * 255),
    b: Math.round((b + m) * 255)
  };
}
function rgbToHsl(rgb) {
  const r = clamp(rgb.r, 0, 255) / 255;
  const g = clamp(rgb.g, 0, 255) / 255;
  const b = clamp(rgb.b, 0, 255) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const delta = max - min;
  const l = (max + min) / 2;
  let h = 0;
  let s = 0;
  if (delta !== 0) {
    s = delta / (1 - Math.abs(2 * l - 1));
    if (max === r) {
      h = (g - b) / delta % 6;
    } else if (max === g) {
      h = (b - r) / delta + 2;
    } else {
      h = (r - g) / delta + 4;
    }
    h *= 60;
    if (h < 0) {
      h += 360;
    }
  }
  return { h: Math.round(h), s: Math.round(s * 100), l: Math.round(l * 100) };
}
function hslToRgb(hsl) {
  const h = (hsl.h % 360 + 360) % 360;
  const s = clamp(hsl.s, 0, 100) / 100;
  const l = clamp(hsl.l, 0, 100) / 100;
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(h / 60 % 2 - 1));
  const m = l - c / 2;
  let r = 0;
  let g = 0;
  let b = 0;
  if (h < 60) {
    [r, g, b] = [c, x, 0];
  } else if (h < 120) {
    [r, g, b] = [x, c, 0];
  } else if (h < 180) {
    [r, g, b] = [0, c, x];
  } else if (h < 240) {
    [r, g, b] = [0, x, c];
  } else if (h < 300) {
    [r, g, b] = [x, 0, c];
  } else {
    [r, g, b] = [c, 0, x];
  }
  return {
    r: Math.round((r + m) * 255),
    g: Math.round((g + m) * 255),
    b: Math.round((b + m) * 255)
  };
}
function hsvToHsl(hsv) {
  return rgbToHsl(hsvToRgb(hsv));
}
function hslToHsv(hsl) {
  return rgbToHsv(hslToRgb(hsl));
}
function hexToHsv(input) {
  const parsed = parseHex(input);
  return parsed === null ? null : rgbToHsv(parsed.rgb);
}
function hsvToHex(hsv, alpha) {
  return formatHex(hsvToRgb(hsv), alpha);
}
var AppConfigSchema = /* @__PURE__ */ z.object({
  webOrigins: z.array(z.string()),
  webAppUrl: z.string(),
  marketingUrl: z.string(),
  mcpHostUrl: z.string(),
  apiPublicUrl: z.string(),
  auth0Domain: z.string(),
  auth0ClientId: z.string(),
  auth0Audience: z.string(),
  posthogKey: z.string(),
  aiProvenanceKeyId: z.string().min(1).max(64),
  posthogHost: z.string(),
  // CS-015b — CLI telemetry's own PostHog slot so `syncanix` events don't
  // land in the dashboard/dev project. Optional + additive: absent → the CLI
  // falls back to `posthogKey` (keep-on-dev interim until the operator sets a
  // dedicated CLI project key here).
  cliPosthogKey: z.string().optional(),
  cliPosthogHost: z.string().optional(),
  paddleClientToken: z.string(),
  turnstileSiteKey: z.string(),
  widgetPublishableKey: z.string()
});
var APP_CONFIG = {
  development: {
    webOrigins: [
      "https://app.dev.syncanix.com",
      "https://main.d17fq3askm9pfg.amplifyapp.com",
      "https://d17fq3askm9pfg.amplifyapp.com",
      "http://localhost:3000",
      "http://localhost:4173"
    ],
    webAppUrl: "https://app.dev.syncanix.com",
    marketingUrl: "https://main.d2rvam4jzcdkvl.amplifyapp.com",
    // Branded MCP host for dev (PR-9 / ADR-0115) — provisioned by McpEdgeStack.
    mcpHostUrl: "https://mcp.dev.syncanix.com",
    // Public API domain for dev (ADR-0796) — the CloudFront alias ApiStack claims.
    apiPublicUrl: "https://api.dev.syncanix.com",
    auth0Domain: "auth.syncanix.com",
    auth0ClientId: "pjQAA9kfAYhb2yj8CjKAKy72ZZtZE5Kn",
    auth0Audience: "https://api.syncanix.com",
    // PostHog EU project (D10 EU migration). Public write-only key — the
    // dashboard guards against initialising on localhost so `pnpm dev` /
    // e2e never ship events; only the deployed origins do.
    posthogKey: "phc_oMjPcEWWUSfF7kyKW8qAnf7qymuGnGx5eXrNdPqy8FHz",
    aiProvenanceKeyId: "prov-2026-dev-a",
    posthogHost: "https://eu.i.posthog.com",
    // Paddle client-side token (public; ADR-0118, superseding ADR-0092's
    // "one account-level token" detail). SANDBOX `test_` token: dev runs the
    // Paddle SANDBOX (PADDLE_ENV=sandbox, pdl_sdbx_ key — api-stack.ts), so the
    // client token MUST be a sandbox token or Paddle.js would initialise against
    // the LIVE account on dev (real-charge risk). Minted 2026-06-18 via the
    // sandbox Client-Side Token API; the /checkout page derives the sandbox
    // environment from the `test_` prefix.
    paddleClientToken: "test_cbc28da40ba97fc9ff1284fa06e",
    // Turnstile site key (public; C2d). Cloudflare widget "Syncanix Widget (dev)"
    // — dev.* domains; verify secret in /syncanix/development/turnstile.
    turnstileSiteKey: "0x4AAAAAADkghiTYND7p35Or",
    // Dogfood widget key (PUBLIC — safe in page source, gated by the per-workspace
    // widget-origin allowlist). The QA dev tenant was put on Growth (set-tier,
    // 2026-06-17), so its deployed origins (app.dev.syncanix.com + the dev
    // marketing Amplify URL) are allowlisted and this pk_test key is baked into
    // the deployed web + marketing bundles via web.sh / marketing.sh (ADR-0063).
    // The `pk_test_` prefix makes the resolver derive the dev API origin
    // (api.dev.syncanix.com). See docs/runbooks/dogfood-self-integration.md.
    widgetPublishableKey: "pk_test_LJ6PGTM2TU5RPUIWYTI3MFPSBSFGFXOF"
  },
  /**
   * `production` — pre-filled by D1-C (2026-06-12) with the DETERMINED cutover
   * values so deploy day starts config-ready. Per the 2026-06-10 decision,
   * **production takes the real public domains** (the ones `development`
   * serves today); the `development` block moves behind `dev.`-prefixed
   * subdomains **in lane D's cutover commit, not before** — editing it earlier
   * would bake unprovisioned `dev.` domains into the live deployment.
   *
   * `auth0ClientId` — D1 (operator 2026-06-13, "use the same auth0 account as
   * dev"): prod REUSES the dev Auth0 SPA app + client id (one shared callback
   * list). `app.syncanix.com` must be added to that app's callback/logout/
   * origin lists before prod sign-in works (gated Auth0 edit; not needed for
   * the Phase 1 domain-less deploy). `posthogKey` is the PostHog EU project key
   * (D10 EU migration), wired in P0c (2026-06-14). Still operator-pending, NOT
   * gate-required:
   *   - `turnstileSiteKey` — BL-D-TURNSTILE-KEYS (empty = challenge absent).
   * The production Amplify default domain (a deploy artifact) is appended to
   * `webOrigins` in a one-line registry edit post-deploy.
   */
  production: {
    webOrigins: ["https://app.syncanix.com"],
    webAppUrl: "https://app.syncanix.com",
    marketingUrl: "https://www.syncanix.com",
    // Branded MCP host for prod (PR-9 / ADR-0115) — provisioned by McpEdgeStack.
    mcpHostUrl: "https://mcp.syncanix.com",
    // Public API domain for prod (ADR-0796) — the CloudFront alias ApiStack claims.
    apiPublicUrl: "https://api.syncanix.com",
    auth0Domain: "auth.syncanix.com",
    auth0ClientId: "pjQAA9kfAYhb2yj8CjKAKy72ZZtZE5Kn",
    auth0Audience: "https://api.syncanix.com",
    posthogKey: "phc_oMjPcEWWUSfF7kyKW8qAnf7qymuGnGx5eXrNdPqy8FHz",
    aiProvenanceKeyId: "prov-2026-a",
    posthogHost: "https://eu.i.posthog.com",
    // CS-015b — keep-on-dev interim: the CLI slot points at the same project
    // until the operator provisions a dedicated CLI PostHog project + repoints.
    cliPosthogKey: "phc_oMjPcEWWUSfF7kyKW8qAnf7qymuGnGx5eXrNdPqy8FHz",
    cliPosthogHost: "https://eu.i.posthog.com",
    // Paddle client-side token (public; ADR-0118) — LIVE token for the live
    // Paddle account/environment. Dev intentionally differs (sandbox `test_`),
    // since Paddle.js requires the token tier to match the environment.
    paddleClientToken: "live_5a6c08498d1f9f14879286dc45a",
    // Turnstile site key (public; C2d). Cloudflare widget "Syncanix Widget"
    // — apex/www/app/cdn syncanix.com; verify secret in /syncanix/production/turnstile.
    turnstileSiteKey: "0x4AAAAAADkgd3Kq7oqlTBWx",
    // Dogfood widget key (PUBLIC — safe in page source, gated by the per-workspace
    // widget-origin allowlist), baked into the deployed prod web + marketing
    // bundles via web.sh / marketing.sh (ADR-0063). `pk_live_` → the resolver
    // uses the widget default origin (api.syncanix.com).
    //
    // Re-pointed 2026-08-07 (operator directive) from tenant `ec145132-…` to
    // `3553e59a-…`. The old tenant belongs to `exahero+base@gmail.com`, NOT to
    // `admin@syncanix.com` as everyone assumed — two different Auth0 subjects
    // with different emails, so the operator could not administer the widget
    // they owned. The new tenant is admin@syncanix.com's own workspace, on
    // `enterprise` via `set-tier` (a comp — no billing provider, the cost comes
    // back to us) with `https://app.syncanix.com` allow-listed, and carries the
    // reviewed 528-capability catalog (`plan/dogfood-widget-capability-review.md`).
    widgetPublishableKey: "pk_live_OYRFX7UZBFLC63DV7U3E4CWUA3OPCZW3"
  }
};

// src/config/resolve-app-config.ts
function committedOrEnv(committed, envValue) {
  if (committed.length > 0) return committed;
  return envValue?.trim() ?? "";
}
function resolveAppConfig(environment, env = process.env) {
  const target = APP_CONFIG[environment];
  const envOrigins = (env.SYNCANIX_WEB_ORIGINS ?? "").split(",").map((o) => o.trim()).filter((o) => o.length > 0);
  return {
    webOrigins: target.webOrigins.length > 0 ? [...target.webOrigins] : envOrigins,
    webAppUrl: committedOrEnv(target.webAppUrl, env.VITE_AUTH0_REDIRECT_URI),
    marketingUrl: committedOrEnv(target.marketingUrl, env.VITE_MARKETING_URL),
    mcpHostUrl: committedOrEnv(target.mcpHostUrl, env.VITE_MCP_HOST_URL),
    apiPublicUrl: committedOrEnv(target.apiPublicUrl, env.VITE_API_PUBLIC_URL),
    auth0Domain: committedOrEnv(target.auth0Domain, env.AUTH0_DOMAIN),
    auth0ClientId: committedOrEnv(target.auth0ClientId, env.VITE_AUTH0_CLIENT_ID),
    auth0Audience: committedOrEnv(target.auth0Audience, env.AUTH0_AUDIENCE),
    posthogKey: committedOrEnv(target.posthogKey, env.VITE_POSTHOG_KEY),
    aiProvenanceKeyId: target.aiProvenanceKeyId,
    posthogHost: committedOrEnv(target.posthogHost, env.VITE_POSTHOG_HOST),
    paddleClientToken: committedOrEnv(target.paddleClientToken, env.VITE_PADDLE_CLIENT_TOKEN),
    turnstileSiteKey: committedOrEnv(target.turnstileSiteKey, env.TURNSTILE_SITE_KEY),
    widgetPublishableKey: committedOrEnv(target.widgetPublishableKey, env.VITE_SYNCANIX_WIDGET_KEY)
  };
}

// src/config/app-config-validation.ts
function assertProductionConfigReady(config) {
  const problems = [];
  const requiredStrings = [
    ["webAppUrl", config.webAppUrl],
    ["marketingUrl", config.marketingUrl],
    ["mcpHostUrl", config.mcpHostUrl],
    ["apiPublicUrl", config.apiPublicUrl],
    ["auth0Domain", config.auth0Domain],
    ["auth0ClientId", config.auth0ClientId],
    ["auth0Audience", config.auth0Audience],
    ["paddleClientToken", config.paddleClientToken]
  ];
  for (const [name, value] of requiredStrings) {
    if (value.length === 0) problems.push(`${name} is empty (operator-pending)`);
  }
  if (config.webOrigins.length === 0) {
    problems.push("webOrigins is empty");
  }
  for (const origin of config.webOrigins) {
    if (origin === "*" || origin.includes("*")) {
      problems.push(`webOrigins contains a wildcard: "${origin}"`);
    } else if (!origin.startsWith("https://")) {
      problems.push(`webOrigins entry is not https (localhost/http forbidden): "${origin}"`);
    } else if (/localhost|127\.0\.0\.1/.test(origin)) {
      problems.push(`webOrigins entry points at localhost: "${origin}"`);
    }
  }
  for (const [name, value] of [
    ["webAppUrl", config.webAppUrl],
    ["marketingUrl", config.marketingUrl],
    ["mcpHostUrl", config.mcpHostUrl],
    ["apiPublicUrl", config.apiPublicUrl]
  ]) {
    if (value.length > 0 && !value.startsWith("https://")) {
      problems.push(`${name} is not https: "${value}"`);
    }
  }
  if (config.webAppUrl.length > 0 && !config.webOrigins.includes(config.webAppUrl)) {
    problems.push(
      `webAppUrl "${config.webAppUrl}" is not among webOrigins \u2014 the SPA's own CORS would break`
    );
  }
  if (problems.length > 0) {
    throw new Error(
      `Production config is NOT ready to ship (${problems.length} problem${problems.length === 1 ? "" : "s"}):
` + problems.map((p) => `  - ${p}`).join("\n") + "\nFill the committed registry (packages/shared/src/config/app-config.ts) or the documented env seam and re-run."
    );
  }
}

// src/config/local-env.ts
var BLOCK_BEGIN = "# >>> syncanix hydrate (managed \u2014 do not edit) >>>";
var BLOCK_END = "# <<< syncanix hydrate <<<";
var LOCAL_DEV = {
  /** Vite dev server origin — the Auth0 redirect target for local login. */
  webOrigin: "http://localhost:3000",
  /** Relative GraphQL path; the Vite proxy forwards it to apps/api on :3001. */
  graphqlEndpoint: "/graphql"
};
function managedBlock(lines) {
  const body = Object.entries(lines).map(([k, v]) => `${k}=${v}`).join("\n");
  return [
    BLOCK_BEGIN,
    "# Generated by `pnpm hydrate` from @syncanix/shared/config \u2014 non-secret only.",
    body,
    BLOCK_END
  ].join("\n");
}
function buildLocalEnvBlocks(resolved) {
  return {
    web: managedBlock({
      VITE_GRAPHQL_ENDPOINT: LOCAL_DEV.graphqlEndpoint,
      VITE_AUTH0_DOMAIN: resolved.auth0Domain,
      VITE_AUTH0_CLIENT_ID: resolved.auth0ClientId,
      VITE_AUTH0_AUDIENCE: resolved.auth0Audience,
      VITE_AUTH0_REDIRECT_URI: LOCAL_DEV.webOrigin,
      VITE_MARKETING_URL: resolved.marketingUrl
    }),
    api: managedBlock({
      AUTH0_DOMAIN: resolved.auth0Domain,
      AUTH0_AUDIENCE: resolved.auth0Audience,
      CLIENT_URL: LOCAL_DEV.webOrigin
    })
  };
}
function mergeManagedBlock(existing, block) {
  const lines = existing.split("\n");
  const begin = lines.indexOf(BLOCK_BEGIN);
  const end = lines.indexOf(BLOCK_END);
  let preserved;
  if (begin !== -1 && end !== -1 && end >= begin) {
    preserved = [...lines.slice(0, begin), ...lines.slice(end + 1)];
  } else {
    preserved = lines;
  }
  const base = preserved.join("\n").trim();
  return base.length > 0 ? `${base}

${block}
` : `${block}
`;
}

// src/config/secret-env-map.ts
var SECRET_ENV_SOURCES = [
  // /syncanix/<env>/llm
  { envVar: "ANTHROPIC_API_KEY", secret: "llm", jsonKey: "anthropicApiKey" },
  { envVar: "OPENAI_API_KEY", secret: "llm", jsonKey: "openaiApiKey" },
  // /syncanix/<env>/publishable-key-pepper
  { envVar: "PUBLISHABLE_KEY_PEPPER", secret: "publishable-key-pepper", jsonKey: "pepper" },
  // /syncanix/<env>/paddle
  { envVar: "PADDLE_API_KEY", secret: "paddle", jsonKey: "apiKey" },
  { envVar: "PADDLE_WEBHOOK_SECRET", secret: "paddle", jsonKey: "webhookSecret" },
  { envVar: "PADDLE_PRICE_STARTER", secret: "paddle", jsonKey: "priceStarter" },
  { envVar: "PADDLE_PRICE_GROWTH", secret: "paddle", jsonKey: "priceGrowth" },
  { envVar: "PADDLE_PRICE_SCALE", secret: "paddle", jsonKey: "priceScale" },
  // /syncanix/<env>/turnstile
  { envVar: "TURNSTILE_SECRET_KEY", secret: "turnstile", jsonKey: "secretKey" },
  // /syncanix/<env>/cloudflare-turnstile-api-token
  {
    envVar: "TURNSTILE_CF_API_TOKEN",
    secret: "cloudflare-turnstile-api-token",
    jsonKey: "apiToken"
  },
  {
    envVar: "TURNSTILE_CF_ACCOUNT_ID",
    secret: "cloudflare-turnstile-api-token",
    jsonKey: "accountId"
  },
  // /syncanix/<env>/edge-origin
  { envVar: "EDGE_ORIGIN_SECRET", secret: "edge-origin", jsonKey: "secret" }
];
var SECRET_BLOCK_BEGIN = "# >>> syncanix hydrate:secrets (managed \u2014 DEV secrets from the cloud; gitignored; do not edit/commit) >>>";
var SECRET_BLOCK_END = "# <<< syncanix hydrate:secrets <<<";
function buildSecretsEnvBlock(values) {
  const body = SECRET_ENV_SOURCES.filter(
    ({ envVar }) => Object.prototype.hasOwnProperty.call(values, envVar)
  ).map(({ envVar }) => `${envVar}=${values[envVar]}`).join("\n");
  return [
    SECRET_BLOCK_BEGIN,
    "# Generated by `pnpm hydrate:secrets` from AWS Secrets Manager (development tier).",
    body,
    SECRET_BLOCK_END
  ].join("\n");
}
var uniqueSecretNames = () => [
  ...new Set(SECRET_ENV_SOURCES.map((source) => source.secret))
];

// src/demo/fixture-rng.ts
function fnv1a(input) {
  let hash = 2166136261;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}
function createFixtureRng(seed) {
  let state = fnv1a(seed) || 1;
  const next = () => {
    state = state + 1831565813 >>> 0;
    let t = state;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
  return {
    next,
    int: (min, max) => min + Math.floor(next() * (max - min + 1)),
    pick: (items) => {
      if (items.length === 0) throw new Error("fixture-rng: pick from an empty array");
      return items[Math.floor(next() * items.length)];
    }
  };
}

// src/demo/fixture-values.ts
function normalizeFieldType(ormType) {
  const t = ormType.toLowerCase().replace(/field$/, "");
  if (/uuid|guid/.test(t)) return "uuid";
  if (/^(string|str|char|varchar|text|textarea|slug|email|url|citext|nvarchar)/.test(t)) {
    return "string";
  }
  if (/^(int|integer|bigint|smallint|auto|bigauto|serial|number|long|int32|int64|uint)/.test(t)) {
    return "int";
  }
  if (/^(float|double|real)/.test(t)) return "float";
  if (/^(decimal|numeric|money)/.test(t)) return "decimal";
  if (/^(bool|boolean)/.test(t)) return "boolean";
  if (/^(datetime|timestamp)/.test(t)) return "datetime";
  if (/^(date$|dateonly)/.test(t)) return "date";
  if (/^(json|jsonb|map|object)/.test(t)) return "json";
  if (/^(bytes|blob|binary|bytea|buffer)/.test(t)) return "bytes";
  return "unknown";
}
var FIRST_NAMES = [
  "Alex",
  "Sam",
  "Jordan",
  "Casey",
  "Riley",
  "Morgan",
  "Taylor",
  "Avery",
  "Quinn",
  "Rowan"
];
var LAST_NAMES = [
  "Example",
  "Sample",
  "Testwell",
  "Demoson",
  "Placeholder",
  "Mockman",
  "Fixture",
  "Specter"
];
var WORDS = [
  "aurora",
  "basalt",
  "cedar",
  "delta",
  "ember",
  "fjord",
  "garnet",
  "harbor",
  "indigo",
  "juniper",
  "krypton",
  "lumen",
  "meadow",
  "nimbus",
  "onyx",
  "prairie",
  "quartz",
  "reef"
];
var EXAMPLE_DOMAINS = ["example.com", "example.org", "example.net"];
function classifyPii(fieldName) {
  const n = fieldName.toLowerCase();
  if (/e?mail/.test(n)) return "email";
  if (/phone|mobile|tel(ephone)?$/.test(n)) return "phone";
  if (/(^|_)(first|given)_?name$/.test(n)) return "firstName";
  if (/(^|_)(last|family)_?name$/.test(n)) return "lastName";
  if (/(^|_)(user|display|nick)_?name$/.test(n)) return "handle";
  if (/(^|_)(full)?_?name$/.test(n)) return "personName";
  if (/address|street|city|zip|postcode/.test(n)) return "address";
  if (/url|website|homepage|link/.test(n)) return "url";
  return "none";
}
function generateValue(type, ctx) {
  const pii = classifyPii(ctx.fieldName);
  if (type === "string" || type === "unknown") {
    switch (pii) {
      case "email":
        return `${ctx.rng.pick(FIRST_NAMES).toLowerCase()}.${ctx.ordinal}@${ctx.rng.pick(EXAMPLE_DOMAINS)}`;
      case "phone":
        return `+1-202-555-01${String(ctx.ordinal % 100).padStart(2, "0")}`;
      case "firstName":
        return ctx.rng.pick(FIRST_NAMES);
      case "lastName":
        return ctx.rng.pick(LAST_NAMES);
      case "handle":
        return `${ctx.rng.pick(FIRST_NAMES).toLowerCase()}_${ctx.rng.pick(WORDS)}`;
      case "personName":
        return `${ctx.rng.pick(FIRST_NAMES)} ${ctx.rng.pick(LAST_NAMES)}`;
      case "address":
        return `${ctx.rng.int(1, 999)} Example ${ctx.rng.pick(["St", "Ave", "Rd"])}, Sampletown`;
      case "url":
        return `https://${ctx.rng.pick(EXAMPLE_DOMAINS)}/${ctx.rng.pick(WORDS)}`;
      default:
        return `${ctx.rng.pick(WORDS)}-${ctx.rng.pick(WORDS)}`;
    }
  }
  switch (type) {
    case "int":
      return ctx.rng.int(1, 1e4);
    case "float":
      return Math.round(ctx.rng.next() * 1e4) / 100;
    case "decimal":
      return (Math.round(ctx.rng.next() * 1e5) / 100).toFixed(2);
    case "boolean":
      return ctx.rng.next() < 0.5;
    case "datetime": {
      const base = Date.UTC(2026, 0, 1);
      return new Date(
        base + ctx.rng.int(0, 180) * 864e5 + ctx.rng.int(0, 86399) * 1e3
      ).toISOString();
    }
    case "date": {
      const base = Date.UTC(2026, 0, 1);
      return new Date(base + ctx.rng.int(0, 180) * 864e5).toISOString().slice(0, 10);
    }
    case "json":
      return { note: ctx.rng.pick(WORDS) };
    case "bytes":
      return "";
    case "uuid":
      return syntheticUuid(ctx);
    default:
      return null;
  }
}
function syntheticUuid(ctx) {
  const hex = (n) => Array.from({ length: n }, () => ctx.rng.int(0, 15).toString(16)).join("");
  return `${hex(8)}-${hex(4)}-4${hex(3)}-8${hex(3)}-${hex(12)}`;
}

// src/demo/fixture-synthesizer.ts
var FIXTURE_ROWS_PER_MODEL_DEFAULT = 20;
var FIXTURE_ROWS_PER_MODEL_CEILING = 100;
var FIXTURE_MAX_TOTAL_ROWS_DEFAULT = 2e3;
function synthesizeFixtures(models, options) {
  const rowsPerModel = Math.max(
    1,
    Math.min(
      options.rowsPerModel ?? FIXTURE_ROWS_PER_MODEL_DEFAULT,
      FIXTURE_ROWS_PER_MODEL_CEILING
    )
  );
  const maxTotalRows = Math.max(1, options.maxTotalRows ?? FIXTURE_MAX_TOTAL_ROWS_DEFAULT);
  if (models.length === 0) return { seed: options.seed, truncated: false, models: [] };
  const modelNames = new Set(models.map((m) => m.name));
  let remaining = maxTotalRows;
  let truncated = false;
  const rowCounts = /* @__PURE__ */ new Map();
  for (const model of models) {
    const take = Math.min(rowsPerModel, remaining);
    if (take < rowsPerModel) truncated = true;
    rowCounts.set(model.name, take);
    remaining -= take;
  }
  const idPools = /* @__PURE__ */ new Map();
  for (const model of models) {
    const count6 = rowCounts.get(model.name) ?? 0;
    const idField = model.fields.find((f) => f.isId);
    const rng = createFixtureRng(`${options.seed}:${model.name}:ids`);
    const ids = [];
    for (let i = 0; i < count6; i += 1) {
      ids.push(makeId(model.name, idField, i, rng));
    }
    idPools.set(model.name, ids);
  }
  const synthesized = models.map((model) => {
    const count6 = rowCounts.get(model.name) ?? 0;
    const ids = idPools.get(model.name) ?? [];
    const rng = createFixtureRng(`${options.seed}:${model.name}:rows`);
    const rows = [];
    for (let ordinal = 0; ordinal < count6; ordinal += 1) {
      const row2 = {};
      for (const field of model.fields) {
        if (field.isList && modelNames.has(field.type)) continue;
        if (field.isId) {
          row2[field.name] = ids[ordinal];
          continue;
        }
        if (modelNames.has(field.type)) {
          const targets = idPools.get(field.type) ?? [];
          if (targets.length === 0) {
            if (field.required) row2[field.name] = null;
            continue;
          }
          row2[field.name] = rng.pick(targets);
          continue;
        }
        if (!field.required && rng.next() < 0.25) {
          row2[field.name] = null;
          continue;
        }
        row2[field.name] = scalarValue(field, ordinal, rng);
      }
      rows.push(row2);
    }
    return { name: model.name, rows };
  });
  return { seed: options.seed, truncated, models: synthesized };
}
function makeId(modelName, idField, ordinal, rng) {
  const type = idField ? normalizeFieldType(idField.type) : "string";
  if (type === "int" || type === "float" || type === "decimal") return ordinal + 1;
  if (type === "uuid") {
    return syntheticUuid({ fieldName: idField?.name ?? "id", rng });
  }
  return `${modelName.toLowerCase()}-${String(ordinal + 1).padStart(4, "0")}`;
}
function scalarValue(field, ordinal, rng) {
  const type = normalizeFieldType(field.type);
  const value = generateValue(type, { fieldName: field.name, ordinal, rng });
  if (field.isUnique && typeof value === "string" && !field.isId) {
    return uniqueSuffix(value, ordinal);
  }
  if (field.isList) return [value];
  return value;
}
function uniqueSuffix(value, ordinal) {
  const at = value.indexOf("@");
  if (at > 0) return `${value.slice(0, at)}.u${ordinal}${value.slice(at)}`;
  return `${value}-${ordinal}`;
}

// src/discovery/route-key.ts
var PLACEHOLDER = ":x";
function canonicalRoutePath(path) {
  let normalized = path.replace(/\{[^/}]+\}/g, PLACEHOLDER).replace(/<[^/>]+>/g, PLACEHOLDER).replace(/\$[A-Za-z_]\w*/g, PLACEHOLDER).replace(/:[A-Za-z_]\w*/g, PLACEHOLDER).replace(/\/{2,}/g, "/");
  if (normalized.length > 1 && normalized.endsWith("/")) {
    normalized = normalized.slice(0, -1);
  }
  return normalized === "" ? "/" : normalized;
}
function canonicalRouteKey(method, path) {
  return `${method.toLowerCase()} ${canonicalRoutePath(path)}`;
}

// src/discovery/discovery-session.ts
var DISCOVERY_SESSION_STATUSES = [
  "pending",
  "bound",
  "revoked",
  "expired",
  "completed"
];
var LIVE_DISCOVERY_SESSION_STATUSES = /* @__PURE__ */ new Set([
  "pending",
  "bound"
]);

// src/discovery/framework-coverage.ts
var FRAMEWORK_COVERAGE = {
  /** Registered detectors, i.e. frameworks `syncanix init` can scan. */
  frameworks: 39,
  /**
   * Distinct languages those frameworks span. Advertised as "N+" in copy
   * because the exact figure is less interesting than the breadth, and the
   * matrix groups some ecosystems (JS/TS) that copy splits.
   */
  languages: 19
};

// src/discovery/response-signals.ts
var WITNESSED_RESPONSE_HEADERS = [
  "allow",
  "link",
  "www-authenticate",
  "content-range",
  "ratelimit-limit",
  "ratelimit-remaining",
  "ratelimit-reset",
  "deprecation",
  "sunset"
];
var MAX_WITNESSED_HEADER_VALUE_CHARS = 512;
var VERBATIM = new Set(
  WITNESSED_RESPONSE_HEADERS.filter((h) => h !== "www-authenticate")
);
var AUTH_SCHEME_PATTERN = /^([A-Za-z][A-Za-z0-9!#$%&'*+\-.^_`|~]{0,39})(?:\s|$)/;
function harvestResponseSignals(get) {
  const out = {};
  for (const name of WITNESSED_RESPONSE_HEADERS) {
    let raw;
    try {
      raw = get(name);
    } catch {
      continue;
    }
    if (typeof raw !== "string") continue;
    const trimmed = raw.trim();
    if (trimmed === "") continue;
    if (VERBATIM.has(name)) {
      out[name] = trimmed.slice(0, MAX_WITNESSED_HEADER_VALUE_CHARS);
      continue;
    }
    const scheme = AUTH_SCHEME_PATTERN.exec(trimmed)?.[1];
    if (scheme !== void 0) out[name] = scheme;
  }
  return out;
}
var TEACH_CAPTURE_MAX_PATH_CHARS = 2048;
var TEACH_CAPTURE_MAX_BATCH = 50;
var TEACH_MAX_AFFORDANCE_BINDINGS = 40;
var TEACH_AFFORDANCE_NAME_MAX_CHARS = 120;
var TeachCaptureSchema = /* @__PURE__ */ z.object({
  method: CaptureHttpMethodSchema,
  /** The request path (no origin) — the route the schema is inferred for. */
  path: z.string().min(1).max(TEACH_CAPTURE_MAX_PATH_CHARS),
  /** Redacted query params keyed by name, or null when the request had none. */
  query: z.record(z.string(), z.unknown()).nullable(),
  /** HTTP status of the response (0 for a network failure). */
  status: z.number().int().min(0).max(599),
  /** Allowlisted request headers (see `redactCaptureHeaders`). */
  requestHeaders: z.record(z.string(), z.string()),
  /** Allowlisted response headers. */
  responseHeaders: z.record(z.string(), z.string()),
  /** Redacted request body, or null when there was none / it was unreadable. */
  requestBody: z.unknown().nullable(),
  /** Redacted response body, or null. */
  responseBody: z.unknown().nullable()
});
var TeachAffordanceBindingSchema = /* @__PURE__ */ z.object({
  /** The clicked control's accessible name (PII-redacted; enrichment input only). */
  controlName: z.string().min(1).max(TEACH_AFFORDANCE_NAME_MAX_CHARS),
  method: CaptureHttpMethodSchema,
  /** The concrete request path — the server templates it (never stored raw). */
  path: z.string().min(1).max(TEACH_CAPTURE_MAX_PATH_CHARS),
  /** 0..1 — decays with the click→request gap, halved for an ambiguous window. */
  confidence: z.number().min(0).max(1),
  /**
   * How many times the pair recurred (a coincidence does not repeat). Bounded to the
   * `INTEGER` column ceiling (migration 322) so a hostile client cannot push a value
   * that would throw at the affordance insert (self-tenant only, but a robustness
   * belt — MINOR-3 of the ADR-0394 § 4/§ 7 security review).
   */
  seenCount: z.number().int().min(1).max(2147483647)
});
var TeachCaptureBatchSchema = /* @__PURE__ */ z.object({
  captures: z.array(TeachCaptureSchema).min(1).max(TEACH_CAPTURE_MAX_BATCH),
  bindings: z.array(TeachAffordanceBindingSchema).max(TEACH_MAX_AFFORDANCE_BINDINGS).optional()
});
var TEACH_CAPTURE_CREDENTIAL_HEADER = "x-syncanix-teach-credential";
var TeachBindRequestSchema = /* @__PURE__ */ z.object({
  bindToken: z.string().min(1).max(512)
});

// src/discovery/site-walk-reasons.ts
var SITE_WALK_SKIP_REASONS = [
  "risk-refused",
  "off-origin",
  "cap-reached",
  "timeout",
  "duplicate-template",
  "unreachable",
  // WF-4.64 / D-051 — a 200 that rendered the site's own not-found view. Its
  // own reason rather than folded into `unreachable`, because the two have
  // different remedies and only one is the operator's: this says a link in
  // their own build manifest or sitemap points at a page that is gone, which is
  // actionable, where `unreachable` says we could not read a page that may well
  // be fine. Only ever reported when the calibration found a stable
  // discriminator — an abstaining calibration reports none of these, which is
  // the honest answer and NOT a claim that every route exists.
  "soft-not-found",
  // WF-4.17 — the route answered 401 or 403 to the operator's OWN authenticated
  // session. Its own reason for the `soft-not-found` reason, one notch over: a
  // 403 is the site saying "this exists and this session may not have it",
  // which is neither "we could not read a page that may be fine"
  // (`unreachable`) nor "a link points at a page that is gone"
  // (`soft-not-found`) — and it is the only one of the three whose remedy is
  // MAP AS ANOTHER ROLE. Folded into `unreachable` it read as a site that
  // cannot be walked, which is the § I.1 gap arriving as a false alarm.
  //
  // ONE reason for both statuses, deliberately. 401 and 403 have different
  // textbook meanings — signed out versus signed in without permission — and
  // are not reliably distinguishable in the wild, where plenty of apps answer
  // 403 to an unauthenticated request. Two members would claim a precision the
  // data does not support; the signed-out case already has a more reliable
  // signal in the operator's own `signed_in_attested` attestation (UX-7) and in
  // WF-5.5's "a map that DECLARED a role and observed nothing".
  //
  // Never counted as a FAILED VISIT (`site-walk-run-signal.ts`): it is the
  // walker working exactly as designed on a site whose areas are role-gated,
  // and counting it would make a well-governed product look un-walkable.
  "role-gated",
  // A5 / ADR-0597 — a templated route another tab FOUND, whose only navigable
  // exemplar (`/orders/1837` for `/orders/:id`) died with that tab. The server
  // holds templates and never an exemplar (ADR-0449 § 4), so a resumed tab can
  // visit such a template only by finding an exemplar of its own on a page it
  // has not yet read; whatever is still queued when the run ends is retired
  // under this reason rather than `unreachable`, which would claim the page
  // refused to load. A later FULL run re-finds the exemplar; UNVISITED
  // re-queues it, and this is the reason it may keep. Never counted as a
  // FAILED VISIT (`site-walk-run-signal.ts`): nothing was opened.
  "exemplar-lost"
];
var SITE_WALK_UNREACHED_REASONS = [
  ...SITE_WALK_SKIP_REASONS,
  "login-wall",
  "session-expired",
  "bot-challenge",
  "ceiling"
];
var SITE_WALK_REPORTABLE_PAUSE_REASONS = [
  "login-wall",
  "session-expired",
  "bot-challenge",
  "background-tab",
  "ceiling-pages",
  "ceiling-time"
];
var SITE_WALK_PAUSE_REASONS = [
  ...SITE_WALK_REPORTABLE_PAUSE_REASONS,
  "tab-closed"
];

// src/discovery/site-walk-handoff.ts
var SITE_WALK_HANDOFF_FRAGMENT_KEY = "syncanix-walk";
function siteWalkHandoffFragment(bindToken) {
  return `#${SITE_WALK_HANDOFF_FRAGMENT_KEY}=${encodeURIComponent(bindToken)}`;
}
function siteWalkHandoffLink(origin, bindToken) {
  return `${origin}${siteWalkHandoffFragment(bindToken)}`;
}

// src/discovery/site-walk-limits.ts
var SITE_WALK_MAX_QUEUED_ROUTES = 5e3;
var WALK_CONTROLS_PER_PAGE = 400;
var SITE_WALK_MAX_PAGES_PER_FLUSH = 20;
var SITE_WALK_FLUSH_COALESCE_PAGES = 3;
var SITE_WALK_FLUSH_COALESCE_MS = 2e3;
var SITE_WALK_MAX_FLUSH_BYTES = 512e3;
var SITE_WALK_MAX_PATH_CHARS = 512;
var SITE_WALK_ROUTE_TIMEOUT_MS = 8e3;
var SITE_WALK_HEARTBEAT_INTERVAL_MS = 1e4;
var SITE_WALK_CREDENTIAL_RENEWAL_MS = 9e4;
var SITE_WALK_HEARTBEAT_STALE_MS = 6e4;
var SITE_WALK_LOCK_GRACE_MS = 24 * 60 * 60 * 1e3;
var SITE_WALK_FRONTIER_LEASE_MS = 12e4;
var SITE_WALK_FRONTIER_MAX_ATTEMPTS = 3;
var SITE_WALK_NEXT_LIMIT = 20;
var SITE_WALK_MAX_FOUND_PER_REPORT = 400;
var SITE_WALK_REPORTED_PHASES = ["READING", "PRESSING", "PROBING", "FINISHING"];
var SITE_WALK_CREDENTIAL_HEADER = "x-syncanix-site-walk-credential";
var SITE_WALK_OPT_IN_HEADER = "x-syncanix-site-walk-opt-in";
var SITE_WALK_NONCE_MIN_CHARS = 16;
var SITE_WALK_NONCE_MAX_CHARS = 128;
var SITE_WALK_NONCE_PATTERN = /^[A-Za-z0-9_-]+$/;
var SITE_WALK_MAX_API_BASE_URL_CHARS = 2048;
var SITE_WALK_MAX_REVEAL_EDGES_PER_PAGE = 40;
var MAX_WALK_API_CALLS_PER_PAGE = 60;
var MAX_WALK_WITNESSES_PER_PAGE = 40;
var MAX_WALK_BLOCKED_WRITES_PER_PAGE = 40;
var MAX_WALK_PAGE_TEXT_CHARS = 16e3;
var MAX_WALK_PAGE_TITLE_CHARS = 300;
var MAX_WALK_PAGE_HEADINGS = 12;
var MAX_WALK_HEADING_CHARS = 120;
var SITE_WALK_MAX_SIBLING_ORIGINS = 8;
var LAZY_CHUNK_MECHANISMS = [
  "webpack-chunk-map",
  "dynamic-import",
  "vite-deps",
  "next-chunks",
  "route-manifest"
];
var BundleSymbolsFactSchema = /* @__PURE__ */ z.object({
  /** Same-origin `<script src>` bundles the page declared and the walk read. */
  bundles: z.number().int().nonnegative(),
  /** Lazy chunks enumerated from those bundles' data and then read. */
  lazyChunks: z.number().int().nonnegative(),
  /** Which mechanisms yielded at least one chunk on this run. */
  lazyChunkMechanisms: z.array(z.enum(LAZY_CHUNK_MECHANISMS)).max(LAZY_CHUNK_MECHANISMS.length),
  /** Endpoints a source map could NAME, across bundles and chunks. */
  named: z.number().int().nonnegative(),
  /**
   * WF-4.47 — endpoints emitted from a bundle WITHOUT a name (no map, or a
   * map with no segment at the literal's exact column). The Tier-3 rows.
   */
  unnamed: z.number().int().nonnegative()
}).strict();
var CMS_KINDS = ["wordpress", "contentful", "prismic", "directus", "sanity"];
var CMS_EVIDENCE = [
  /** A same-origin GET answered 200 at the platform's own index path. */
  "endpoint",
  /** The rendered DOM carries the platform's own attribute. */
  "dom-attribute",
  /** An asset on the page is served from the platform's own host. */
  "asset-host",
  /** Vercel Content Link stega markers in the rendered text (§ Y.5). */
  "content-source-map",
  /**
   * The page names the platform itself — a `<meta name="generator">` value, or
   * a same-origin asset served from a path the platform owns.
   *
   * The zero-cost fingerprint the ENDPOINT probe is gated on, and evidence in
   * its own right. Both, deliberately: a WordPress host that blocks `/wp-json/`
   * — which many do — would otherwise be reported as running no CMS, which is a
   * wrong fact rather than a missing one.
   */
  "page-marker"
];
var CmsPresenceFactSchema = /* @__PURE__ */ z.object({
  /**
   * What was found. EMPTY is a real result — see the module note: it means
   * the checks ran and matched nothing, which is not the same as not looking.
   *
   * One entry per (platform, evidence) PAIR rather than per platform, so a
   * site recognised two ways reports both. That is what `evidence` is for:
   * F.1 attributes yield per CHECK in order to decide which checks earn their
   * place, and a first-wins dedupe silently credits whichever check happens to
   * run first — under which a check that always fires second measures as
   * worthless however often it is right.
   */
  found: z.array(
    z.object({
      kind: z.enum(CMS_KINDS),
      evidence: z.enum(CMS_EVIDENCE)
    }).strict()
  ).max(CMS_KINDS.length * CMS_EVIDENCE.length),
  /**
   * How many checks actually ran.
   *
   * The denominator, and the field that makes `found: []` readable. A run
   * where the bind grant was declined performs the DOM checks and skips the
   * endpoint ones, so `checked` is lower and the empty result is weaker
   * evidence — which an operator can see rather than having to know.
   */
  checked: z.number().int().nonnegative(),
  /**
   * ET-2 § Y.5's Content Source Map detector: a boolean and a type list, and
   * it stops there.
   *
   * Absent when nothing was decoded. Present-and-empty cannot happen — a
   * marker with no `_type` yields no entry — so absence is the only "no".
   */
  contentTypes: z.array(z.string().min(1).max(64)).max(32).optional()
}).strict();
var CMS_INDEX_PATHS = [
  // Also the WF-4.67 probe target. A 200 here IS the WordPress presence check —
  // there is no separate request for it.
  ["wordpress", "/wp-json/"]
];
var CMS_GENERATOR_MARKERS = [
  ["wordpress", "wordpress"]
];
var CMS_ASSET_PATH_MARKERS = [
  ["wordpress", ["/wp-content/", "/wp-includes/"]]
];
var CMS_DOM_ATTRIBUTES = [
  ["contentful", "data-contentful-field-id"],
  ["sanity", "data-sanity"]
];
var CMS_ASSET_HOSTS = [
  ["prismic", ["prismic.io", "prismic-io.s3.amazonaws.com", "images.prismic.io"]],
  ["contentful", ["ctfassets.net"]],
  ["sanity", ["cdn.sanity.io"]],
  // Directus Cloud. Self-hosted Directus leaves no page tell at all, so this
  // reaches only the hosted tier — stated rather than implied, because it is
  // exactly the kind of partial coverage F.1's prevalence sweep exists to
  // measure and, if it never fires, to retire.
  ["directus", ["directus.app"]]
];
var count = /* @__PURE__ */ z.number().int().nonnegative().max(1e6);
var FrameRefusalFactSchema = /* @__PURE__ */ z.object({
  /** Routes the walk tried to load into an offscreen frame. */
  attempted: count,
  /** Of those, how many handed back no document at all. */
  empty: count,
  /**
   * The verdict: EVERY attempt came back empty, over at least the sample
   * floor. Carried rather than re-derived server-side, because the floor is
   * the widget's own and two implementations of one rule is how they drift.
   *
   * Named for what the evidence supports. It is NOT "this site sets
   * `X-Frame-Options`" — the widget cannot read a response header, and the
   * blocked-frame signature is engine-specific (`frame-refusal.ts` records
   * the Chromium measurement). It is the operator-facing fact: the frames
   * driver reached nothing here, and the remedy is a different driver.
   */
  framesReachedNothing: z.boolean()
}).strict();
var GraphqlIntrospectionFactSchema = /* @__PURE__ */ z.object({
  /** The same-origin path that answered. A conventional path, not a discovered one. */
  path: z.string().min(1).max(256),
  /** How many query fields the schema exposes. */
  queries: z.number().int().nonnegative(),
  /**
   * How many mutation fields it exposes.
   *
   * The number that changes what an operator does, which is why it is separate
   * from `queries` rather than a total: a schema with mutations is a schema
   * where the agent's side-effect gate has work to do.
   */
  mutations: z.number().int().nonnegative(),
  /** How many named types it declares, excluding introspection's own `__` types. */
  types: z.number().int().nonnegative()
}).strict();
var MINIMAL_INTROSPECTION_QUERY = "{__schema{queryType{fields{name}}mutationType{fields{name}}types{name}}}";
function readIntrospectionFact(path, body) {
  const schema = pick(pick(body, "data"), "__schema");
  if (schema === void 0) return void 0;
  const queries = countFields(pick(schema, "queryType"));
  const mutations = countFields(pick(schema, "mutationType"));
  const types = countNamedTypes(pick(schema, "types"));
  if (queries === void 0) return void 0;
  return { path, queries, mutations: mutations ?? 0, types };
}
function pick(value, key) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return void 0;
  return value[key];
}
function countFields(typeNode) {
  const fields = pick(typeNode, "fields");
  if (!Array.isArray(fields)) return void 0;
  return fields.length;
}
function countNamedTypes(types) {
  if (!Array.isArray(types)) return 0;
  return types.filter((t) => {
    const name = pick(t, "name");
    return typeof name === "string" && !name.startsWith("__");
  }).length;
}
var LIVE_WRITE_REFUSALS = [
  /** Not `POST` / `PUT` / `PATCH` — `DELETE`, a custom verb, an empty method. */
  "method",
  /** The path or the control's name is in the destructive vocabulary. */
  "destructive-name",
  /** Money, messages, permissions, credentials or sessions — D10 layer 1's non-destructive classes. */
  "costly-path",
  /** The request's target could not be read. Fail closed. */
  "unreadable",
  /** The page or run ceiling on live writes was reached (a caller's answer). */
  "budget"
];
var MAX_LIVE_WRITES_PER_PAGE = 8;
var MAX_LIVE_WRITES_PER_RUN = 40;
var LIVE_WRITE_MARKER_HEADER = "x-syncanix-walk";
var LIVE_WRITE_MARKER_VALUE = "live";
var LIVE_WRITE_IDEMPOTENCY_HEADER = "idempotency-key";
var LIVE_WRITE_IDEMPOTENCY_PREFIX = "syncanix-walk-";
var count2 = /* @__PURE__ */ z.number().int().min(0).max(1e6);
var SiteWalkLivePageSchema = /* @__PURE__ */ z.object({
  /** Writes the floor let through to the real transport. */
  allowed: count2,
  /** Writes the floor or a ceiling refused (the seal then refused the hop). */
  refused: count2,
  /** `refused`, by reason. Absent reason = zero. */
  refusedBy: z.record(z.enum(LIVE_WRITE_REFUSALS), count2)
}).strict();
var LiveWalkFactSchema = /* @__PURE__ */ z.object({
  pages: count2,
  allowed: count2,
  refused: count2,
  refusedBy: z.record(z.enum(LIVE_WRITE_REFUSALS), count2),
  /** The run ceiling ended live writes before the walk did. */
  capped: z.boolean()
}).strict();
function mergeLiveRefusals(into, from) {
  const out = { ...into };
  for (const reason of LIVE_WRITE_REFUSALS) {
    const add = from[reason] ?? 0;
    if (add > 0) out[reason] = (out[reason] ?? 0) + add;
  }
  return out;
}
var MAX_RECIPE_ENTRIES = 8;
var MAX_RECIPES_PER_RUN = 50;
var MIN_RECIPE_VALUE_BYTES = 8;
var MAX_RECIPE_SOURCE_NAME_CHARS = 256;
var RECIPE_HEADER_NAME_PATTERN = /^[A-Za-z0-9-]{1,64}$/;
var RECIPE_QUERY_NAME_PATTERN = /^[A-Za-z0-9_.[\]-]{1,64}$/;
var RECIPE_JSON_POINTER_PATTERN = /^(?:\/(?:[^~/]|~[01])*)+$/;
var RECIPE_ORIGIN_PATTERN = /^https?:\/\/[A-Za-z0-9.-]+(?::\d{1,5})?$/;
var HTTP_METHODS = ["GET", "HEAD", "POST", "PUT", "PATCH", "DELETE", "OPTIONS"];
var IDENTITY_SHAPED = [
  /\d{6,}/,
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i,
  /[^\s@]+@[^\s@]+\.[^\s@]+/
];
var sourceName = /* @__PURE__ */ z.string().min(1).max(MAX_RECIPE_SOURCE_NAME_CHARS).regex(/^\P{C}+$/u, "control characters are not a name").refine((s) => !IDENTITY_SHAPED.some((p) => p.test(s)), {
  message: "a source name that looks like an identity is refused"
});
var RecipeSourceSchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  /** `<meta name=…>` content. */
  z.object({ kind: z.literal("meta"), name: sourceName }).strict(),
  /** A hidden field's value, addressed by the form's identity and the field name. */
  z.object({ kind: z.literal("hidden-field"), form: sourceName, name: sourceName }).strict(),
  /** A cookie the page can read (an `HttpOnly` one is invisible, so never matched). */
  z.object({ kind: z.literal("cookie"), name: sourceName }).strict(),
  /** A Web Storage item, optionally a JSON pointer into its parsed value. */
  z.object({
    kind: z.literal("storage"),
    area: z.enum(["local", "session"]),
    key: sourceName,
    path: z.string().min(1).max(256).regex(RECIPE_JSON_POINTER_PATTERN).optional()
  }).strict()
]);
var RecipeTargetSchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("header"), name: z.string().regex(RECIPE_HEADER_NAME_PATTERN) }).strict(),
  z.object({ kind: z.literal("query"), name: z.string().regex(RECIPE_QUERY_NAME_PATTERN) }).strict(),
  z.object({
    kind: z.literal("body"),
    path: z.string().min(1).max(256).regex(RECIPE_JSON_POINTER_PATTERN)
  }).strict()
]);
var RecipeEntrySchema = /* @__PURE__ */ z.object({
  target: RecipeTargetSchema,
  source: RecipeSourceSchema,
  /** `bearer` prefixes the value with `Bearer ` — a token, so only onto Authorization. */
  transform: z.enum(["none", "bearer"])
}).strict().superRefine((entry, ctx) => {
  if (entry.transform !== "bearer") return;
  const ontoAuthorization = entry.target.kind === "header" && entry.target.name.toLowerCase() === "authorization";
  if (!ontoAuthorization) {
    ctx.addIssue({ code: "custom", message: "bearer applies only to the Authorization header" });
  }
  if (entry.source.kind === "meta" || entry.source.kind === "hidden-field") {
    ctx.addIssue({ code: "custom", message: "a bearer token is never read from markup" });
  }
});
var endpointTemplate = /* @__PURE__ */ z.string().max(600).refine(
  (t) => {
    const space = t.indexOf(" ");
    if (space === -1) return false;
    const method = t.slice(0, space);
    const path = t.slice(space + 1);
    return HTTP_METHODS.includes(method) && HARVESTED_ROUTE_PATH_PATTERN.test(path);
  },
  { message: 'expected "<METHOD> /templated/path"' }
);
var RequestRecipeSchema = /* @__PURE__ */ z.object({
  endpointTemplate,
  /** The same-site origin the request went to. */
  origin: z.string().regex(RECIPE_ORIGIN_PATTERN),
  entries: z.array(RecipeEntrySchema).min(1).max(MAX_RECIPE_ENTRIES),
  /**
   * How many times this endpoint was seen. CAPPED, not merely positive: the
   * column is a `BIGINT` and an uncapped integer lets a producer send a value
   * Postgres refuses, which the ingest then swallows — a refusal that reads as
   * a store that quietly did nothing. A run cannot honestly observe more than
   * this (the walk's own request budget is orders of magnitude below it).
   */
  observedCount: z.number().int().min(1).max(1e6),
  firstSeenAt: z.string().datetime(),
  lastSeenAt: z.string().datetime()
}).strict().refine((r) => r.firstSeenAt <= r.lastSeenAt, {
  message: "lastSeenAt precedes firstSeenAt",
  path: ["lastSeenAt"]
});
function recipeKey(recipe) {
  return `${recipe.origin} ${recipe.endpointTemplate}`;
}
var SAFE_PROBE_METHODS = ["GET", "OPTIONS"];
var MAX_SAFE_PROBES_PER_PAGE = 8;
var MAX_SAFE_PROBES_PER_RUN = 80;
var SAFE_PROBE_TIMEOUT_MS = 4e3;
var SAFE_PROBE_MARKER_HEADER = "x-syncanix-walk";
var SAFE_PROBE_MARKER_VALUE = "probe";
var count3 = /* @__PURE__ */ z.number().int().min(0).max(1e6);
var SiteWalkProbePageSchema = /* @__PURE__ */ z.object({
  /** Distinct same-origin targets the page offered (pre-boot calls + refused-write hrefs). */
  targets: count3,
  /** Probes actually sent. */
  sent: count3,
  /** Of `sent`, by method. */
  get: count3,
  options: count3,
  /** Targets refused by the walk's own route rules (an unsafe path, an unreadable target). */
  refused: count3,
  /** The page or run ceiling ended probing before every target was reached. */
  capped: z.boolean()
}).strict();
var SafeProbeFactSchema = /* @__PURE__ */ z.object({
  pages: count3,
  targets: count3,
  sent: count3,
  get: count3,
  options: count3,
  refused: count3,
  capped: z.boolean()
}).strict();
var MAX_DECLARED_VARIANTS_PER_FORM = 4;
var MAX_DECLARED_VARIANTS_PER_PAGE = 8;
var MAX_DECLARED_ANCHOR_VIEWS_PER_PAGE = 60;
var MAX_WALK_VARIANT_VISITS = 300;
var MAX_VARIANTS_PER_TEMPLATE = 60;
var FORM_ERROR_STATES = [
  /** The browser's own constraint validation flagged the field. */
  "constraint",
  /** The field carries a non-empty `validationMessage`. */
  "validation-message",
  /** The app marked the field `aria-invalid="true"`. */
  "aria-invalid",
  /** A `role="alert"` / `role="status"` / `aria-live` region APPEARED. */
  "live-region",
  /** The field is `required` and empty — the commonest rule of all. */
  "required"
];
var MAX_FORM_ERROR_MESSAGE_CHARS = 240;
var MAX_FORM_ERROR_MESSAGES = 12;
var MAX_FORM_ERROR_VOCABULARIES = 8;
var MAX_FORM_ERROR_VOCABULARIES_PER_ENVIRONMENT = 500;
var SiteWalkFormErrorVocabularySchema = /* @__PURE__ */ z.object({
  /**
   * The form's own identity — its `name`, else its `id`, else its position on
   * the page. Positional last and deliberately: it is stable within one page
   * load and useless across a redeploy, which is the honest ordering.
   */
  form: z.string().min(1).max(128),
  /**
   * The language the page DECLARED (`<html lang>`), lower-cased, when it
   * declared one.
   *
   * Absent means the page said nothing, which is a different fact from
   * English and must not be recorded as it: lane E localizes against this,
   * and guessing would put a French sentence in an English catalog.
   */
  locale: z.string().min(2).max(35).regex(/^[a-z]{2,3}(?:-[A-Za-z0-9]{2,8})*$/).optional(),
  /** The distinct sentences, `redactSecrets`-screened and deduplicated. */
  messages: z.array(z.string().min(1).max(MAX_FORM_ERROR_MESSAGE_CHARS)).min(1).max(MAX_FORM_ERROR_MESSAGES),
  /** How the app signalled them, as a closed set. */
  states: z.array(z.enum(FORM_ERROR_STATES)).min(1).max(FORM_ERROR_STATES.length)
}).strict();
var SEALED_OPERATION_KINDS = [
  /** A native `<select>`: every enabled option, up to the per-control cap. */
  "select",
  /** `<input type=checkbox>` or `role=checkbox`: both states. */
  "checkbox",
  /** `role=switch`: both states. */
  "switch",
  /** One radio of a group: selected once (each radio is its own control). */
  "radio",
  /** `<input type=range>`: min, mid and max. */
  "slider",
  /** A free-text field (text, email, url, tel, number, a date): the marked value. */
  "text",
  /** `<input type=search>` or `role=searchbox`: the marked value. */
  "search",
  /**
   * A data-entry role the seal has NO driver for (a bare combobox, an option, a
   * contenteditable). Never operated, so it appears in `unexplored` only.
   */
  "other"
];
var SEALED_UNEXPLORED_REASONS = [
  /** The page's operation budget ran out before this control (or its remaining states) was reached. */
  "budget",
  /** A password / payment / one-time-code / government-id field, by type, autocomplete or label. */
  "sensitive",
  "disabled",
  "readonly",
  /** Inside a `blockSelectors` subtree. */
  "masked",
  /** A nested frame the seal does not cover. */
  "unsealed-realm",
  /** Named by the destructive vocabulary — a toggle labelled "Delete all" is not a state to try. */
  "destructive-name",
  /** Named by the session-ending vocabulary. */
  "session-ending",
  /** The widget's own chrome. */
  "widget-surface",
  /** A data-entry role the seal has no driver for (a bare combobox, an option, a contenteditable). */
  "unsupported",
  /** A `<select>` with no enabled option to choose. */
  "no-options",
  /** A `<select>` with more options than the per-control cap; the remainder was not tried. */
  "options-capped",
  /** An operation provoked a write or a navigation; the control is quarantined mid-enumeration. */
  "quarantined",
  /** A host-page accessor threw while the control was classified. */
  "unclassifiable",
  /**
   * B4 / R-5 — the field declares a `pattern` (or a constraint set) the witness
   * solver could not satisfy, so it was left BLANK rather than filled with a
   * value the app would reject. Distinct from `unsupported`, which is about the
   * seal having no driver for the control at all.
   */
  "unsolved",
  /**
   * WF-4.9 / ADR-0576 — a free-text field on a run the operator granted LIVE.
   *
   * On such a run the seal asks the live floor per write and a permitted POST
   * genuinely leaves, so a typed synthetic value is contact detail arriving in
   * the customer's real system. The field is left BLANK and named, which is the
   * same trade `probeFilledSubmit` and the fill ledger already take: a live walk
   * learns less about forms than a safe one, and says so rather than being
   * quietly thinner.
   */
  "live-run"
];
var MAX_SEALED_OPTIONS_PER_CONTROL = 12;
var MIN_SEALED_OPERATIONS_PER_PAGE = 40;
var MAX_SEALED_OPERATIONS_PER_PAGE = 400;
var SEALED_OPERATIONS_PER_CONTROL = 4;
var MIN_SEALED_PRESS_BUDGET = 24;
var MAX_SEALED_PRESS_BUDGET = 160;
function clampCount(value, floor, ceiling) {
  if (!Number.isFinite(value)) return floor;
  return Math.min(ceiling, Math.max(floor, Math.floor(value)));
}
function sealedOperationBudget(operableControls) {
  return clampCount(
    operableControls * SEALED_OPERATIONS_PER_CONTROL,
    MIN_SEALED_OPERATIONS_PER_PAGE,
    MAX_SEALED_OPERATIONS_PER_PAGE
  );
}
function sealedPressBudget(operableControls) {
  return clampCount(operableControls, MIN_SEALED_PRESS_BUDGET, MAX_SEALED_PRESS_BUDGET);
}
var count4 = /* @__PURE__ */ z.number().int().min(0).max(1e5);
var SiteWalkSealedUnexploredSchema = /* @__PURE__ */ z.object({
  kind: z.enum(SEALED_OPERATION_KINDS),
  reason: z.enum(SEALED_UNEXPLORED_REASONS),
  count: z.number().int().min(1).max(1e5)
}).strict();
var SiteWalkSealedOperationsSchema = /* @__PURE__ */ z.object({
  /** Data-entry controls the seal OPERATED at least once. */
  controls: count4,
  /** Operations spent: an option chosen, a state flipped, a value typed. */
  operations: count4,
  /** Of `controls`, how many of each kind. Absent kind = zero. */
  byKind: z.record(z.enum(SEALED_OPERATION_KINDS), count4),
  /** `<select>` options enumerated across the page. */
  options: count4,
  /** Controls that APPEARED because of an operation and joined the press frontier. */
  chained: count4,
  /** Controls quarantined mid-enumeration: an operation provoked a write or a navigation. */
  quarantined: count4,
  /** The operation budget this page was given (scales with its control count). */
  budget: count4,
  /** The budget ended the enumeration before every control was reached. */
  capped: z.boolean(),
  /** Every data-entry control NOT fully explored, by kind and reason. */
  unexplored: z.array(SiteWalkSealedUnexploredSchema).max(SEALED_OPERATION_KINDS.length * SEALED_UNEXPLORED_REASONS.length)
}).strict();
function emptySealedOperations(budget) {
  return {
    controls: 0,
    operations: 0,
    byKind: {},
    options: 0,
    chained: 0,
    quarantined: 0,
    budget,
    capped: false,
    unexplored: []
  };
}
function mergeSealedOperations(into, from) {
  const byKind = { ...into.byKind };
  for (const kind of SEALED_OPERATION_KINDS) {
    const add = from.byKind[kind] ?? 0;
    if (add > 0) byKind[kind] = (byKind[kind] ?? 0) + add;
  }
  const buckets = /* @__PURE__ */ new Map();
  for (const entry of [...into.unexplored, ...from.unexplored]) {
    const key = `${entry.kind} ${entry.reason}`;
    const existing = buckets.get(key);
    buckets.set(
      key,
      existing === void 0 ? { ...entry } : { ...existing, count: existing.count + entry.count }
    );
  }
  return {
    controls: into.controls + from.controls,
    operations: into.operations + from.operations,
    byKind,
    options: into.options + from.options,
    chained: into.chained + from.chained,
    quarantined: into.quarantined + from.quarantined,
    budget: into.budget + from.budget,
    capped: into.capped || from.capped,
    unexplored: [...buckets.values()]
  };
}
var CSS_STATE_KINDS = [
  "error",
  "invalid",
  "warning",
  "success",
  "loading",
  "pending",
  "skeleton",
  "busy",
  "disabled",
  "readonly",
  "empty",
  "expired",
  "offline"
];
var MAX_SEALED_VALIDATION_FORMS = 8;
var SiteWalkValidationSchema = /* @__PURE__ */ z.object({
  /** `<form>` elements the pass considered. */
  forms: z.number().int().min(0).max(1e3),
  /** Of those, how many were empty-submitted (a submit control existed and was admitted). */
  submitted: z.number().int().min(0).max(1e3),
  /** Fields the browser's constraint validation flagged (`validity.valid === false`). */
  invalidFields: z.number().int().min(0).max(1e4),
  /** Of those, how many carry a non-empty `validationMessage` — the words a user sees. */
  messages: z.number().int().min(0).max(1e4),
  /** Fields the APP marked `aria-invalid="true"` after the submit. */
  ariaInvalid: z.number().int().min(0).max(1e4),
  /** Live regions / alerts that APPEARED after the submit — the app's own error UI. */
  alerts: z.number().int().min(0).max(1e4),
  /** The form budget ended the probe before every form was reached. */
  capped: z.boolean()
}).strict();
var SiteWalkCssStatesSchema = /* @__PURE__ */ z.object({
  /** Stylesheets whose rules could be read. */
  sheets: z.number().int().min(0).max(1e3),
  /** Cross-origin or otherwise unreadable stylesheets — counted, never guessed at. */
  sheetsUnreadable: z.number().int().min(0).max(1e3),
  /** Style rules scanned. */
  rules: z.number().int().min(0).max(1e6),
  /** Rules naming each state kind. Absent kind = zero. */
  kinds: z.record(z.enum(CSS_STATE_KINDS), z.number().int().min(0).max(1e6))
}).strict();
var SEALED_SOCKET_KINDS = ["WS_CONNECT", "WS_MESSAGE", "SSE_STREAM"];
var MAX_SEALED_SOCKETS_PER_PAGE = 12;
var MAX_SEALED_SOCKET_PROTOCOLS = 8;
var MAX_SEALED_SOCKET_PROTOCOL_CHARS = 64;
var SiteWalkSealedSocketSchema = /* @__PURE__ */ z.object({
  kind: z.enum(SEALED_SOCKET_KINDS),
  /**
   * The templated path the page asked for, re-refused server-side against the
   * shared closed grammar exactly as a witness path is. `ws:` and `wss:` URLs
   * are resolved and templated on their PATH, so `wss://host/socket/v1` and
   * `https://host/socket/v1` land on one row rather than two.
   */
  path: z.string().min(1).max(SITE_WALK_MAX_PATH_CHARS),
  /**
   * W1-9b's rule, applied here: the first-party origin the socket was aimed
   * at, so two hosts serving `/socket` stay apart. Absent when the URL was
   * relative and no origin resolved — never GUESSED, because a guessed origin
   * is an identity claim the server keys a row on.
   */
  requestOrigin: z.string().max(255).optional(),
  /**
   * The subprotocols the page named (`new WebSocket(url, ['graphql-ws'])`).
   * The single most useful thing about a socket for naming what it does:
   * `graphql-transport-ws` says the command surface is GraphQL, `mqtt` says it
   * is not. Absent on `SSE_STREAM`, which has none.
   */
  protocols: z.array(z.string().min(1).max(MAX_SEALED_SOCKET_PROTOCOL_CHARS)).max(MAX_SEALED_SOCKET_PROTOCOLS).optional(),
  /**
   * `WS_MESSAGE` only — the inferred STRUCTURE of one payload the app tried to
   * send, re-validated server-side with `ShapeSchema`. Never a value.
   */
  shape: z.unknown().nullable(),
  /**
   * A payload WAS sent and could not be shaped — a `Blob`, an `ArrayBuffer`, a
   * protobuf frame. Distinct from `shape: null`, which means there was nothing
   * to shape: one says "it carries something we cannot describe", the other
   * "it carries nothing", and an operator acts differently on each.
   */
  shapeOpaque: z.boolean()
}).strict();
var SiteWalkSealedSocketsSchema = /* @__PURE__ */ z.object({
  observed: z.array(SiteWalkSealedSocketSchema).max(MAX_SEALED_SOCKETS_PER_PAGE),
  truncated: z.number().int().min(0).max(1e5)
}).strict();
function sealedSocketKey(row2) {
  return [
    row2.kind,
    row2.requestOrigin ?? "",
    row2.path,
    row2.shape === null ? "" : JSON.stringify(row2.shape),
    String(row2.shapeOpaque)
  ].join("\0");
}
function mergeSealedSockets(a, b) {
  const seen = /* @__PURE__ */ new Map();
  let overflow = 0;
  for (const row2 of [...a.observed, ...b.observed]) {
    const key = sealedSocketKey(row2);
    if (seen.has(key)) continue;
    if (seen.size >= MAX_SEALED_SOCKETS_PER_PAGE) {
      overflow += 1;
      continue;
    }
    seen.set(key, row2);
  }
  return {
    observed: [...seen.values()],
    truncated: Math.min(a.truncated + b.truncated + overflow, 1e5)
  };
}

// src/discovery/sealed-walk-vocabulary.ts
var SEALED_PRESS_REASONS = [
  // --- the shared activation policy's refusals (ADR-0577), verbatim ---------
  "link",
  "submit-capable",
  "destructive-name",
  "session-ending",
  "file-input",
  "download",
  "data-entry",
  "disabled",
  "masked",
  "widget-surface",
  "not-operable",
  // --- what happened to an ADMITTED press --------------------------------
  /** The handler tried a non-GET request; the seal refused it and the control is quarantined. */
  "sealed-write-blocked",
  /** The handler pushed a route or the frame navigated; refused / observed, quarantined. */
  "navigated",
  /** Pressed, sealed, and the DOM state did not change: not a disclosure. */
  "no-reveal",
  /** A nested frame whose realm the seal does not cover — never pressed. */
  "unsealed-realm",
  /** A host-page accessor threw while the control was classified — never pressed. */
  "unclassifiable",
  /** The page's press budget ended before this control was reached. */
  "budget",
  /**
   * WF-4.9 / ADR-0576 — the handler's write was let THROUGH by the live
   * opt-in (the floor passed it, the ceilings had room), the exchange was
   * witnessed with its real status and response shape, and the control is
   * quarantined exactly like a refused one. Never produced on a sealed run.
   */
  "live-write"
];
var SealedWalkFactSchema = /* @__PURE__ */ z.object({
  /** Pages the sealed pass ran on. */
  pages: z.number().int().min(0).max(1e5),
  pressed: z.number().int().min(0).max(1e6),
  opened: z.number().int().min(0).max(1e6),
  filled: z.number().int().min(0).max(1e6),
  steps: z.number().int().min(0).max(1e6),
  writesRefused: z.number().int().min(0).max(1e6),
  /** `?query` / `#hash` variants visited under the same template. */
  // Bounded by the RUN budget, not by the old sealed cap: the walk may now
  // spend up to MAX_WALK_VARIANT_VISITS, and a fact reporting more than the
  // schema allows is REFUSED - the sealed pass would have gone silent for
  // exactly the large sites this widening exists to reach.
  variantVisits: z.number().int().min(0).max(MAX_WALK_VARIANT_VISITS),
  /**
   * WF-4.17 / ADR-0587 § 7 — of `variantVisits`, how many were DECLARED-value
   * variants the walk composed from a GET form's own `<select>` / radio /
   * `<datalist>` values, rather than links the page carried.
   */
  declaredVariantVisits: z.number().int().min(0).max(MAX_WALK_VARIANT_VISITS),
  named: z.record(z.enum(SEALED_PRESS_REASONS), z.number().int().min(0).max(1e6)),
  /** WF-4.44 — forms empty-submitted across the run, and what they surfaced. */
  validationForms: z.number().int().min(0).max(1e6),
  invalidFields: z.number().int().min(0).max(1e6),
  validationAlerts: z.number().int().min(0).max(1e6),
  /** WF-4.44 — stylesheet state rules found across the run, by kind. */
  cssStates: z.record(z.enum(CSS_STATE_KINDS), z.number().int().min(0).max(1e6)),
  /**
   * Zero-touch B12 / Z-11 — the run's OPERATIONS, summed over every sealed
   * page: controls operated by kind, options enumerated, chains opened, and
   * every data-entry control left unexplored with its reason. Optional:
   * absent when no page on the run met a data-entry control at all, which is
   * a different fact from "operated and found nothing".
   * Appended under `CONTRACTS.md` § 4 (announced in `LANE-B.md`).
   */
  operated: SiteWalkSealedOperationsSchema.optional(),
  /**
   * Zero-touch B12 / R-5 — fields left BLANK across the run because their own
   * declared constraints had no witness the solver could verify. The number
   * R-5 asks for before a model oracle is considered; absent when no field on
   * the run posed the question.
   */
  fillUnsolved: z.number().int().min(0).max(1e6).optional(),
  /**
   * Zero-touch B6 / Z-12 — the run's real-time surface, folded over every
   * sealed page by `mergeSealedSockets`. Absent when no page on the run
   * constructed a socket or an event stream, which is deliberately a
   * different fact from an empty list: the first says nobody asked, the
   * second says we looked and there was nothing.
   * Appended under `CONTRACTS.md` § 4 (announced in `LANE-B.md`).
   */
  sockets: SiteWalkSealedSocketsSchema.optional()
}).strict();
function mergeNamedReasons(into, from) {
  const out = { ...into };
  for (const reason of SEALED_PRESS_REASONS) {
    const add = from[reason] ?? 0;
    if (add > 0) out[reason] = (out[reason] ?? 0) + add;
  }
  return out;
}

// src/discovery/sealed-walk.ts
var MAX_SEALED_PRESSES_PER_PAGE = MIN_SEALED_PRESS_BUDGET;
var MAX_SEALED_DEPTH = 3;
var MAX_SEALED_FILLS_PER_PAGE = 40;
var reasonCount = /* @__PURE__ */ z.number().int().min(0).max(1e5);
var sealedSignature = /* @__PURE__ */ z.string().min(1).max(128);
var SiteWalkSealedPageSchema = /* @__PURE__ */ z.object({
  /** Controls the pass ACTIVATED under the seal. */
  pressed: z.number().int().min(0).max(1e3),
  /** Of `pressed`, how many changed the page's state — a disclosure. */
  opened: z.number().int().min(0).max(1e3),
  /** The deepest reveal chain reached (0 = nothing opened). */
  depth: z.number().int().min(0).max(MAX_SEALED_DEPTH),
  /** Fields written with marked synthetic values before pressing. */
  filled: z.number().int().min(0).max(1e3),
  /** Sensitive / read-only / masked fields the filler declined. COUNT only. */
  fillRefused: z.number().int().min(0).max(1e3),
  /**
   * Zero-touch B4 / R-5 — fields left BLANK because their own declared
   * constraints (a `pattern`, a length window) had no mechanical witness the
   * solver could verify. Optional: absent means no field on the page posed
   * the question, which is a different fact from "every one was solved".
   * Appended under `CONTRACTS.md` § 4 (announced in `LANE-B.md`).
   */
  fillUnsolved: z.number().int().min(0).max(1e3).optional(),
  /** Presses that advanced a filled form unit — a wizard step crossed. */
  steps: z.number().int().min(0).max(1e3),
  /** Non-GET requests the seal refused during the pass. */
  writesRefused: z.number().int().min(0).max(1e3),
  /**
   * SL2 / G5-B3 — worker-class constructions the seal refused: `Worker`,
   * `SharedWorker` and `serviceWorker.register`, each a thread or scope the
   * write sentinel cannot see. Optional: absent means the page reached for
   * none, which is a different fact from zero on a page that tried.
   */
  workersRefused: z.number().int().min(0).max(1e3).optional(),
  /** Every control NOT opened, by reason. Absent reason = zero. */
  named: z.record(z.enum(SEALED_PRESS_REASONS), reasonCount),
  /** The press budget ended the pass before every candidate was reached. */
  capped: z.boolean(),
  /**
   * ADR-0751 — the SIGNATURES of controls the pass pressed under the seal
   * that provoked nothing: no write the seal refused, no route pushed, no
   * navigation, nothing revealed, no state change. Names of the widget's
   * own control identities (the page-act policy's key), never a label or a
   * value; bounded by the press budget. Absent ⇒ none, which is a different
   * fact from "the pass did not run" (`sealed` itself absent).
   */
  silent: z.array(sealedSignature).max(1e3).optional(),
  /**
   * ADR-0751 — pressed controls that changed the page's STATE without
   * revealing a control, sending a write or navigating (a filter that
   * re-rendered its list, a toggle that swapped a class). Same key, same
   * bound, same posture as `silent`; the two are kept apart because "did
   * nothing" and "changed the view" are different facts about a control,
   * and both are no-write facts the page-act gate may run on.
   */
  mutatedView: z.array(sealedSignature).max(1e3).optional(),
  /**
   * WF-4.44 / ADR-0585 — the error surface a deliberate empty submit
   * rendered. Optional: absent when the page had no `<form>` at all, which
   * is a different fact from "forms were submitted and nothing complained".
   */
  validation: SiteWalkValidationSchema.optional(),
  /**
   * Zero-touch walk B5 — the ERROR VOCABULARY the empty submit surfaced: the
   * sentences this page's forms speak when a field is wrong, in the page's
   * own language, `redactSecrets`-screened and deduplicated.
   *
   * The one field on this record that is WORDS rather than a count, and the
   * exception is narrow and stated in `form-error-vocabulary.ts`: a validation
   * message is UI COPY the app renders to every visitor who gets the form
   * wrong — the same class as a button label, which this pipeline has always
   * carried — and never a field value, because the probe submits an EMPTY
   * form and there is nothing typed to leak.
   *
   * Absent when no form complained, which is a different fact from a page
   * with no forms (`validation` above separates those).
   */
  errorVocabulary: z.array(SiteWalkFormErrorVocabularySchema).max(MAX_FORM_ERROR_VOCABULARIES).optional(),
  /** WF-4.44 — the stylesheet state vocabulary. Absent when no sheet was readable. */
  cssStates: SiteWalkCssStatesSchema.optional(),
  /**
   * WF-4.9 / ADR-0576 — this page's LIVE-write accounting, present only on a
   * run the operator opted into live writes (and the server granted). Counts
   * only; the endpoints the writes reached ride `apiWitnesses` with their
   * real status and response shape, which is the whole point of the opt-in.
   */
  live: SiteWalkLivePageSchema.optional(),
  /**
   * Zero-touch B3 / Z-11 — what the seal OPERATED on this page: dropdowns,
   * toggles, radios, sliders, search and text fields, as counts by kind, and
   * every data-entry control left unexplored NAMED by kind and reason.
   * Optional: absent when the page had no data-entry control at all.
   * Appended under `CONTRACTS.md` § 4 (announced in `LANE-B.md`).
   */
  operated: SiteWalkSealedOperationsSchema.optional(),
  /**
   * Zero-touch B6 / Z-12 — the REAL-TIME surface this page has, learned by
   * refusing to open it: the sockets and event streams the app tried to
   * construct, their paths and subprotocols, and the SHAPES of the frames it
   * tried to send. Optional, and absent means "this page constructed none" —
   * which is why the field is a record with its own `truncated` rather than a
   * count: "no sockets" and "twelve of forty" must not read the same, the gap
   * `plan/DEBT.md` D-180 named.
   * Appended under `CONTRACTS.md` § 4 (announced in `LANE-B.md`).
   */
  sockets: SiteWalkSealedSocketsSchema.optional()
}).strict();
var WELL_KNOWN_SPEC_PATHS = [
  "/openapi.json",
  "/openapi.yaml",
  "/openapi.yml",
  "/swagger.json",
  "/api-docs",
  "/v3/api-docs"
];
var ServedSpecFactSchema = /* @__PURE__ */ z.object({
  /** The same-origin path it answered at. */
  path: z.string().min(1).max(128),
  /**
   * `openapi` / `swagger` / `asyncapi` — whichever the document DECLARED.
   * Never sniffed.
   *
   * WIDENED by zero-touch walk B8 (Z-12), which made the walk read AsyncAPI
   * too: the publish lane projects a channel as a `WS_HANDLER` capability,
   * so an AsyncAPI document is a description this store has a reader for and
   * a fact that could not name it would be silent about a run that found one.
   * Every value the field accepted before is still accepted.
   */
  dialect: z.enum(["openapi", "swagger", "asyncapi"]),
  /**
   * The declared version string, when the document carried one.
   *
   * Absent means the document is a description this build could not version —
   * a real answer, and distinct from `dialect` being absent, which would mean
   * it was not a description at all (in which case there is no fact at all).
   */
  version: z.string().min(1).max(32).optional(),
  /**
   * How big the document is, so an operator can judge the import before
   * starting it. Approximate by construction — see `read-origin-spec.ts`.
   */
  bytes: z.number().int().min(0).max(1e9)
}).strict();
var WALK_SERVED_SPEC_KINDS = ["openapi", "swagger", "graphql-schema", "asyncapi"];
var WalkServedSpecKindSchema = /* @__PURE__ */ z.enum(WALK_SERVED_SPEC_KINDS);
var MAX_WALK_SERVED_SPEC_BYTES = 2e6;
var MAX_WALK_SERVED_SPECS_PER_ENVIRONMENT = 24;
var MAX_WALK_SERVED_SPEC_URL_CHARS = 2048;
var SHA256_HEX_PATTERN = /^[0-9a-f]{64}$/;
var SERVED_SPEC_URL_PATTERN = /^https?:\/\/[A-Za-z0-9.-]+(?::\d{1,5})?\/[^\s#]*$/;
var WalkServedSpecSchema = /* @__PURE__ */ z.object({
  kind: WalkServedSpecKindSchema,
  /** The same-site URL that answered. */
  url: z.string().max(MAX_WALK_SERVED_SPEC_URL_CHARS).regex(SERVED_SPEC_URL_PATTERN),
  /** Change detection: an unchanged document is not re-published. */
  digest: z.string().regex(SHA256_HEX_PATTERN),
  /** Size of the document's JSON text, so an operator can judge an import. */
  bytes: z.number().int().min(0).max(MAX_WALK_SERVED_SPEC_BYTES),
  /**
   * The document itself. An OBJECT at the root — every dialect here is one, and
   * an introspection result is `{ __schema: … }`. A string (SDL) or an array
   * is not something this store's readers know how to read, and is refused
   * rather than wrapped.
   */
  document: z.record(z.string(), z.unknown())
}).strict();

// src/discovery/served-spec-payload.ts
var WALK_SERVED_SPEC_FORMATS = ["json", "yaml"];
var MAX_WALK_SERVED_SPECS_PER_RUN = 4;
var MAX_WALK_SERVED_SPEC_WIRE_BYTES = 768e3;
function admitServedSpecs(candidates) {
  const encoder = typeof TextEncoder === "function" ? new TextEncoder() : void 0;
  const specs = [];
  let spent = 0;
  let refused = 0;
  for (const candidate of candidates) {
    if (candidate === void 0) continue;
    if (specs.length >= MAX_WALK_SERVED_SPECS_PER_RUN) {
      refused += 1;
      continue;
    }
    let bytes;
    try {
      const text = JSON.stringify(candidate);
      bytes = encoder === void 0 ? text.length : encoder.encode(text).length;
    } catch {
      refused += 1;
      continue;
    }
    if (bytes > MAX_WALK_SERVED_SPEC_WIRE_BYTES || spent + bytes > MAX_WALK_SERVED_SPEC_WIRE_BYTES) {
      refused += 1;
      continue;
    }
    spent += bytes;
    specs.push(candidate);
  }
  return { specs, refused };
}
var SERVED_SPEC_COMMON = {
  kind: WalkServedSpecKindSchema,
  /** The same-site URL that answered. */
  url: z.string().max(MAX_WALK_SERVED_SPEC_URL_CHARS).regex(/^https?:\/\/[A-Za-z0-9.-]+(?::\d{1,5})?\/[^\s#]*$/),
  /**
   * Bytes of the response as the browser measured it — the operator's import
   * signal, and the number the row records. Reported rather than derived,
   * because the server sees the parsed document and the browser saw the text.
   */
  bytes: z.number().int().min(0).max(MAX_WALK_SERVED_SPEC_BYTES)
};
var JsonServedSpecPayloadSchema = /* @__PURE__ */ z.object({
  ...SERVED_SPEC_COMMON,
  format: z.literal("json"),
  /** An OBJECT at the root: every dialect here is one, and so is `{__schema}`. */
  document: z.record(z.string(), z.unknown())
}).strict();
var YamlServedSpecPayloadSchema = /* @__PURE__ */ z.object({
  ...SERVED_SPEC_COMMON,
  format: z.literal("yaml"),
  /**
   * The document as it was SERVED. Capped in characters at the wire budget
   * rather than the store's, because this string is what the summary carries
   * and the API's body limit is what refuses it.
   */
  text: z.string().min(1).max(MAX_WALK_SERVED_SPEC_WIRE_BYTES)
}).strict();
var WalkServedSpecPayloadSchema = /* @__PURE__ */ z.discriminatedUnion("format", [
  JsonServedSpecPayloadSchema,
  YamlServedSpecPayloadSchema
]);

// src/discovery/site-walk-ceilings.ts
var SITE_WALK_DEFAULT_CEILING_PAGES = 5e3;
var SITE_WALK_DEFAULT_CEILING_SECONDS = 3600;
var SITE_WALK_MIN_CEILING_PAGES = 1;
var SITE_WALK_MAX_CEILING_PAGES = 25e3;
var SITE_WALK_MIN_CEILING_SECONDS = 30;
var SITE_WALK_MAX_CEILING_SECONDS = 6 * 60 * 60;
var SITE_WALK_MIN_PAGE_TIMEOUT_MS = 2e3;
var SITE_WALK_MAX_PAGE_TIMEOUT_MS = 3e5;
var SITE_WALK_SESSION_SETUP_SLACK_MS = 5 * 60 * 1e3;
function siteWalkRunCeilings(override) {
  return {
    maxPages: override?.maxPages ?? SITE_WALK_DEFAULT_CEILING_PAGES,
    maxSeconds: override?.maxSeconds ?? SITE_WALK_DEFAULT_CEILING_SECONDS,
    pageTimeoutMs: override?.pageTimeoutMs ?? null
  };
}
var RANGES = {
  maxPages: [SITE_WALK_MIN_CEILING_PAGES, SITE_WALK_MAX_CEILING_PAGES],
  maxSeconds: [SITE_WALK_MIN_CEILING_SECONDS, SITE_WALK_MAX_CEILING_SECONDS],
  pageTimeoutMs: [SITE_WALK_MIN_PAGE_TIMEOUT_MS, SITE_WALK_MAX_PAGE_TIMEOUT_MS]
};
function readSiteWalkCeilingOverride(raw) {
  if (raw === null || raw === void 0) return { ok: true, value: {} };
  if (typeof raw !== "object" || Array.isArray(raw)) return { ok: false, field: "maxPages" };
  const source = raw;
  const value = {};
  for (const field of ["maxPages", "maxSeconds", "pageTimeoutMs"]) {
    const given = source[field];
    if (given === null || given === void 0) continue;
    if (typeof given !== "number" || !Number.isInteger(given)) return { ok: false, field };
    const [min, max] = RANGES[field];
    if (given < min || given > max) return { ok: false, field };
    value[field] = given;
  }
  return { ok: true, value };
}
function siteWalkSessionWindowMs(ceilings) {
  return ceilings.maxSeconds * 1e3 + SITE_WALK_SESSION_SETUP_SLACK_MS;
}
var MAX_NOMINATION_CANDIDATES = 200;
var MAX_NOMINATIONS = 8;
var MAX_NOMINATION_VISITED = 400;
var routePath = /* @__PURE__ */ z.string().min(1).max(512).regex(HARVESTED_ROUTE_PATH_PATTERN);
var SiteWalkNominateRequestSchema = /* @__PURE__ */ z.object({
  sessionId: z.string().uuid(),
  /** Enumerated and unvisited, in the frontier's own order. */
  candidates: z.array(routePath).max(MAX_NOMINATION_CANDIDATES),
  /** What the mechanical pass covered, so the model reasons about the GAP. */
  visited: z.array(routePath).max(MAX_NOMINATION_VISITED)
}).strict();
var SiteWalkNominateResponseSchema = /* @__PURE__ */ z.object({
  /** A subset of `candidates`, in the model's order, vetted server-side. */
  nominated: z.array(routePath).max(MAX_NOMINATIONS),
  /** Nominations the SERVER refused: not a candidate, or refused by policy. A COUNT. */
  refused: z.number().int().nonnegative(),
  /** Whether a model was asked at all — false when the grant was withheld or nothing was askable. */
  asked: z.boolean()
}).strict();
var WalkNominationsFactSchema = /* @__PURE__ */ z.object({
  /** Unvisited enumerated templates offered to the model. */
  candidates: z.number().int().nonnegative(),
  /** Whether a model call was made. At most one per walk. */
  asked: z.boolean(),
  /** Nominations the server returned after its own vetting. */
  nominated: z.number().int().nonnegative(),
  /** Nominations refused server-side PLUS those the walker's frontier declined. */
  refused: z.number().int().nonnegative(),
  /** Nominated pages the walk then actually visited. */
  visited: z.number().int().nonnegative()
}).strict();
var PAINTED_SURFACE_KINDS = ["canvas", "svg", "icon"];
var PAINTED_CONTROL_KINDS = [
  "button",
  "link",
  "input",
  "toggle",
  "slider",
  "tab",
  "menu",
  "other"
];
var PAINTED_SURFACE_CLASSES = [
  "controls",
  "chart",
  "map",
  "decorative",
  "unknown"
];
var MAX_VISION_IMAGES_PER_REQUEST = 8;
var MAX_VISION_SURFACES_PER_PAGE = 6;
var MAX_VISION_IMAGES_PER_RUN = 40;
var MAX_VISION_IMAGE_SIDE_PX = 512;
var MAX_VISION_IMAGE_BYTES = 2e5;
var MAX_VISION_CONTROLS_PER_IMAGE = 12;
var MAX_VISION_CONTROL_NAME_GRAPHEMES = 64;
var MIN_VISION_SURFACE_PX = 24;
var digest = /* @__PURE__ */ z.string().regex(/^[0-9a-f]{64}$/);
var MAX_VISION_IMAGE_BASE64_CHARS = Math.ceil(MAX_VISION_IMAGE_BYTES / 3) * 4 + 4;
var SiteWalkVisionImageSchema = /* @__PURE__ */ z.object({
  /** SHA-256 of the PNG bytes — the change-detection key and the finding's key. */
  digest,
  surface: z.enum(PAINTED_SURFACE_KINDS),
  mediaType: z.literal("image/png"),
  width: z.number().int().min(1).max(MAX_VISION_IMAGE_SIDE_PX),
  height: z.number().int().min(1).max(MAX_VISION_IMAGE_SIDE_PX),
  data: z.string().min(1).max(MAX_VISION_IMAGE_BASE64_CHARS).regex(/^[A-Za-z0-9+/]+={0,2}$/)
}).strict();
var SiteWalkVisionRequestSchema = /* @__PURE__ */ z.object({
  sessionId: z.string().uuid(),
  images: z.array(SiteWalkVisionImageSchema).min(1).max(MAX_VISION_IMAGES_PER_REQUEST)
}).strict();
var PaintedControlSchema = /* @__PURE__ */ z.object({
  name: z.string().min(1).max(MAX_VISION_CONTROL_NAME_GRAPHEMES * 4),
  kind: z.enum(PAINTED_CONTROL_KINDS),
  confidence: z.number().min(0).max(1)
}).strict();
var SiteWalkVisionFindingSchema = /* @__PURE__ */ z.object({
  digest,
  surfaceClass: z.enum(PAINTED_SURFACE_CLASSES),
  controls: z.array(PaintedControlSchema).max(MAX_VISION_CONTROLS_PER_IMAGE)
}).strict();
var SiteWalkVisionResponseSchema = /* @__PURE__ */ z.object({
  /** One per image the model answered for, keyed by the request's own digests. */
  findings: z.array(SiteWalkVisionFindingSchema).max(MAX_VISION_IMAGES_PER_REQUEST),
  /** Findings or controls the SERVER refused: an unknown image, a value-shaped name, over the cap. A COUNT. */
  refused: z.number().int().nonnegative(),
  /** Whether a model was asked at all — false when the grant was withheld. */
  asked: z.boolean()
}).strict();
var count5 = /* @__PURE__ */ z.number().int().min(0).max(1e5);
var SiteWalkPaintedPageSchema = /* @__PURE__ */ z.object({
  /** Painted surfaces the masked walk found (canvas, inline svg, icon-only controls). */
  surfaces: count5,
  /** Rasterised successfully. */
  captured: count5,
  /** Skipped: bytes identical to a surface already sent this run. */
  identical: count5,
  /** Skipped: rasterised to nothing (a WebGL canvas without `preserveDrawingBuffer` reads blank). */
  blank: count5,
  /** Skipped: a tainted canvas, a cross-origin image, a rasteriser that threw, no digest. */
  unreadable: count5,
  /** Sent to the server. */
  sent: count5,
  /** Model calls the server made for this page (0 or 1). */
  asked: count5,
  /** Findings or names the server refused. */
  refused: count5,
  /** Identity rows appended to the page from the findings. */
  controls: count5,
  /** The per-page or per-run image budget ended the capture early. */
  capped: z.boolean()
}).strict();
var WalkVisionFactSchema = /* @__PURE__ */ z.object({
  pages: count5,
  surfaces: count5,
  captured: count5,
  identical: count5,
  blank: count5,
  unreadable: count5,
  sent: count5,
  asked: count5,
  refused: count5,
  controls: count5,
  capped: z.boolean()
}).strict();

// src/discovery/site-walk-summary.ts
var SiteWalkSummarySchema = /* @__PURE__ */ z.object({
  sessionId: z.string().uuid(),
  /** Routes the frontier held after templating + dedupe. */
  frontierSize: z.number().int().min(0).max(1e6),
  /** Routes actually visited and harvested. */
  visited: z.number().int().min(0).max(SITE_WALK_MAX_CEILING_PAGES),
  /**
   * ADR-0519 — of `visited`, how many were reached by the INERT fallback rather
   * than by the iframe: a same-origin GET parsed with `DOMParser`, used when the
   * route refused to frame itself.
   *
   * A SUBSET of `visited`, not a sibling of it, and reported because the fallback
   * has a cost the visit count alone hides. `DOMParser` runs no script, so on a
   * server-rendered site the document is the whole page and on a CLIENT-rendered
   * one it is an empty shell. A walk of 200 SPA routes reporting `visited: 200`
   * and almost no controls reads as a broken product; the same run reporting
   * `inertVisits: 200` reads as what it is — this site cannot be framed AND is
   * client-rendered — which has a real next step (teach mode) attached to it.
   *
   * Optional so a widget predating the fallback still validates; absent means "no
   * page was read inertly", which for such a widget is true.
   */
  inertVisits: z.number().int().min(0).max(SITE_WALK_MAX_CEILING_PAGES).optional(),
  /**
   * PR-4.2 — pages harvested while STILL CHANGING: the readiness wait hit its
   * ceiling instead of going quiet. A bound on everything harvested from
   * those pages, reported for the same reason `inertVisits` is — a run whose
   * routes all settled and one whose routes were all caught mid-render
   * produce identically-shaped summaries and mean very different things, and
   * only the second has a next step (the page is slow, or it never stops
   * animating).
   */
  unsettledVisits: z.number().int().min(0).max(SITE_WALK_MAX_CEILING_PAGES).optional(),
  /**
   * PR-4.4 — pages the walk VISITED that never reached the server.
   *
   * The third subset of `visited`, and the only one that is a data LOSS rather
   * than a quality caveat. A flush that fails costs those pages and not the
   * run: aborting a twenty-minute walk because one POST returned 502 would be
   * the worse outcome, and `visited` still counts them because the walk really
   * did open them. But without this the loss was invisible — the summary said
   * `visited: 400, truncated: false` and the dashboard printed "Reached every
   * page it found" over a run that delivered 200.
   *
   * Counts PAGES, not failed requests: a batch is split into parts by measured
   * bytes and the parts go out sequentially, so a failure part-way through
   * loses only what came after it, and "3 flushes failed" would say nothing
   * about how much is missing.
   *
   * Optional and omitted when zero, like its two siblings: an explicit 0 on
   * every summary would make the field read as a metric rather than a finding.
   */
  unsentVisits: z.number().int().min(0).max(SITE_WALK_MAX_CEILING_PAGES).optional(),
  /**
   * PR-4.5 — distinct `?query` / `#hash` forms the frontier discarded across
   * the whole run.
   *
   * Not a subset of `visited` and not a refusal: `/orders?page=2` and
   * `/orders#detail` are visited once, as `/orders`, because a fragment is the
   * same document and a query is state the walk was not asked to explore.
   * Correct, and silent — a paginated or hash-routed site reads as fully
   * covered while most of it was never opened. `collapsedVariants: 380` beside
   * `visited: 12` names that, and has a next step attached (a walk cannot
   * follow query state; teach mode can).
   *
   * A COUNT only. The variant strings are deduplicated inside the browser and
   * discarded there — a query string is state and routinely carries somebody's
   * identifier, so nothing but this integer ships (C-21).
   */
  collapsedVariants: z.number().int().min(0).max(1e6).optional(),
  /**
   * WF-4.8 leg (c) / D10 Tier 1.5 — the API description this site publishes,
   * if it publishes one.
   *
   * On the SUMMARY rather than on a page, because it is a per-ORIGIN fact and
   * a page is the wrong unit for one: repeating it on 400 pages would send the
   * same answer 400 times, and attaching it to the landing page alone (the
   * `precache` shape) would make it arrive before the run row it belongs to
   * exists. The summary is the one message a run sends about ITSELF, and the
   * run row is written from it in a single statement.
   *
   * A FACT and never the document — `served-spec.ts` carries the reasoning and
   * the bound. Optional, and absent means one of three things this schema
   * cannot separate: no grant, nothing published, or nothing parseable. The
   * widget does not separate them either, deliberately: reporting *which* miss
   * occurred would say which paths a site 404s, which is a map of the
   * customer's own surface for no operator gain.
   */
  servedSpec: ServedSpecFactSchema.optional(),
  /**
   * WF-4.67 / ADR-0582 — which CMS this origin runs.
   *
   * On the SUMMARY for the same reason as `servedSpec` one field up: a
   * per-ORIGIN fact, sent once. PRESENCE only — a post-type list is a MODEL,
   * and its reader (C.5's speculation-path ingest) does not exist yet.
   *
   * Absent means the probe found nothing to run at all. An EMPTY `found` with
   * a non-zero `checked` is the different and more useful answer: the checks
   * ran and matched nothing, which is what an operator whose CMS we do not
   * recognise should be told rather than "no CMS".
   */
  cmsPresence: CmsPresenceFactSchema.optional(),
  /**
   * WF-4.12 / ADR-0582 § 4 — the SHAPE of this origin's GraphQL API.
   *
   * On the SUMMARY for the same reason as the two fields above: a per-ORIGIN
   * fact, sent once. COUNTS only — an operation name is the customer's own
   * product surface, the same thing `servedSpec` reports a dialect and a byte
   * count rather than a path in order to keep off the wire.
   *
   * Absent is the overwhelmingly common case and covers three states that need
   * no distinguishing: the operator has not turned the probe on (its default),
   * the origin serves no GraphQL, or it serves one with introspection disabled.
   * A zero-count fact would claim the third specifically, which is a claim
   * nobody made.
   */
  graphqlIntrospection: GraphqlIntrospectionFactSchema.optional(),
  /**
   * WF-4.28 / ET-2 § L.5 — what the bundle read did: bundles read, lazy
   * chunks enumerated from their data and read, which mechanisms yielded, and
   * endpoints a map could name.
   *
   * On the SUMMARY for the same reason as its three siblings: a per-ORIGIN
   * fact, sent once. COUNTS and a closed vocabulary — a chunk path is the
   * customer's own build layout, which stays off the wire the way a route
   * template stays off the log line.
   *
   * Present, zeros included, whenever the bundle read was GRANTED — so the
   * opportunistic chunk probe has a denominator (F.1). Absent means the walk
   * had no credentialed-fetch grant and read no bundle at all, which is a
   * different state from "read four bundles and enumerated nothing".
   */
  bundleSymbols: BundleSymbolsFactSchema.optional(),
  /**
   * WF-4.16 / ADR-0579 — what the nomination phase did: how many unvisited
   * templates were offered, whether a model was asked (at most once), how
   * many it nominated, how many were refused, how many were reached.
   *
   * COUNTS only, on the SUMMARY like its siblings. Present whenever the
   * grant was on — zeros included — so the row's "measure a floor"
   * acceptance has a denominator. Absent means the workspace has not opted
   * in, which is the default at both rungs.
   */
  nominations: WalkNominationsFactSchema.optional(),
  /**
   * WF-4.5b / ADR-0584 — what the SEALED pass did across the run: pages it
   * ran on, controls pressed and opened, fields filled, wizard steps crossed,
   * writes the seal refused, variant visits spent, and every un-opened
   * control by reason.
   *
   * COUNTS only, on the SUMMARY like its siblings. Present whenever the grant
   * was on — zeros included — so "opened OR named" is checkable arithmetic and
   * the demo-fleet acceptance has a denominator. Absent means the workspace
   * or the fleet has the sealed pass switched off, and the walk pressed
   * nothing beyond the declared-reveal probe.
   */
  sealed: SealedWalkFactSchema.optional(),
  /**
   * WF-4.13 / ADR-0586 — what the vision leg did across the run: painted
   * surfaces found, captured, skipped by reason, sent, model calls made,
   * findings refused, identity rows produced. COUNTS only; present whenever
   * the grant was on, zeros included, so the acceptance has a denominator.
   */
  vision: WalkVisionFactSchema.optional(),
  /**
   * WF-4.9 / ADR-0576 — what the LIVE opt-in did across the run: pages the
   * sealed pass ran live on, writes the floor let through, writes it
   * refused and why. COUNTS only; present whenever the run was granted live
   * writes, zeros included, so "opted in and wrote nothing" is a fact and
   * not an absence. Absent on every sealed run, which is the default.
   */
  live: LiveWalkFactSchema.optional(),
  /**
   * WF-4.8 leg (b) / ADR-0587 § 6 — what the safe-method probe did across
   * the run: pages, targets, probes sent by method, refusals, the ceiling.
   * COUNTS only; present whenever the grant was on, zeros included.
   */
  probe: SafeProbeFactSchema.optional(),
  /**
   * A10 — whether the SITE refuses to be framed, with the counts behind the
   * verdict. Present once any frame attempt was READABLE; absent on an
   * inert-only run, which is a different fact from "framed everything fine".
   *
   * It is what makes the tab-walk driver choosable: an unframeable site
   * otherwise reports four hundred `unreachable` routes with a true per-route
   * reason and an invisible cause.
   */
  frameRefusal: FrameRefusalFactSchema.optional(),
  /**
   * Zero-touch walk B7 / B8 (Z-12) — the API DESCRIPTIONS this origin serves,
   * as documents rather than as facts.
   *
   * The one field on this summary that carries a customer PAYLOAD, which is
   * why it is bounded three ways rather than one: at most
   * `MAX_WALK_SERVED_SPECS_PER_RUN` entries (a site publishes one description
   * per dialect, so a fifth means a producer is looping), each within
   * `MAX_WALK_SERVED_SPEC_BYTES`, each at a same-site URL the walk actually
   * fetched. `servedSpec` above stays and is unchanged: it is the FACT about
   * the origin's own description, and this is the document behind it, kept
   * apart so a run that found a description too large to carry still says so.
   *
   * A served description is the customer's own published API documentation —
   * the artifact they hand every integrator — and it lands in
   * `walk_served_specs`, which replaces a URL's document on every fetch and
   * leaves with the tenant. It is not visitor data and not operator data, and
   * D's publish lane is its only reader.
   *
   * Absent means no description travelled, which covers a run with no grant,
   * a site that publishes none, one whose document was past the cap, and a
   * GraphQL endpoint whose surface was too large to ask for. The counts on
   * `servedSpec` and `graphqlIntrospection` are what separate those.
   */
  servedSpecs: z.array(WalkServedSpecPayloadSchema).max(MAX_WALK_SERVED_SPECS_PER_RUN).optional(),
  /**
   * Zero-touch walk B9 (Z-8 / ADR-0606) — the REQUEST RECIPES the walk learned
   * from the app's own traffic: "the `X-CSRF-Token` header on
   * `POST /api/orders` comes from the `csrf-token` meta tag".
   *
   * **Shapes and names, never a value.** A recipe carries where a value lives
   * and where it goes; `request-recipe.ts` is `.strict()` at every level so a
   * producer that started carrying one fails its own parse, and migration
   * 498's CHECK refuses the same at the row. The matched value is discarded in
   * the function that matched it (`recipe-no-values.convention.test.ts`).
   *
   * Absent means none was learned, which covers a run with no traffic, an app
   * whose headers are all computed in memory, and a workspace that has the
   * capture switched off. Bounded at `MAX_RECIPES_PER_RUN` endpoints.
   */
  requestRecipes: z.array(RequestRecipeSchema).max(MAX_RECIPES_PER_RUN).optional(),
  /** Per-reason skip counts. A reason absent from the map means zero. */
  skipped: z.record(z.enum(SITE_WALK_SKIP_REASONS), z.number().int().min(0)),
  /** Whether a cap ended the run rather than the frontier being exhausted. */
  truncated: z.boolean(),
  /** Wall clock, so a run that ended early is distinguishable from a fast one. */
  durationMs: z.number().int().min(0).max(SITE_WALK_MAX_CEILING_SECONDS * 1e3 * 2)
}).strict();
var WALKED_PATH = /^[/](?![/\\])/u;
var URL_STRIPPED = /[\t\n\r]/u;
function isWalkedPath(path) {
  return WALKED_PATH.test(path) && !URL_STRIPPED.test(path);
}
var WALKED_PATH_MESSAGE = "a path starts with / and stays on the walked origin";
var WalkedPathSchema = z.string().min(1).max(SITE_WALK_MAX_PATH_CHARS).refine(isWalkedPath, { message: WALKED_PATH_MESSAGE });
var SiteWalkPageTextSchema = z.object({
  title: z.string().max(MAX_WALK_PAGE_TITLE_CHARS),
  body: z.string().min(1).max(MAX_WALK_PAGE_TEXT_CHARS),
  /**
   * The page's own heading outline, in document order, under the same mask as
   * the prose. What a page CALLS itself — which is how a reader tells two
   * pages of one template apart when their `<title>` cannot.
   */
  headings: z.array(z.string().min(1).max(MAX_WALK_HEADING_CHARS)).max(MAX_WALK_PAGE_HEADINGS).optional(),
  /**
   * The other ways a page states what it is, when its headings do not.
   *
   * Headings are the commonest signal and they are not universal: a page can
   * put its subject in a `<div>` and carry no `<h*>` at all, and reading
   * only headings would leave such a site exactly where Champion Motors was.
   * Each of these is an EXPLICIT machine-readable statement of subject, so
   * the server can prefer them over a heading rather than guess.
   */
  identity: z.object({
    /** `og:title` / `twitter:title` — written to name the page when shared. */
    ogTitle: z.string().min(1).max(MAX_WALK_HEADING_CHARS).optional(),
    /** JSON-LD or microdata `name` for the page's main entity. */
    structuredName: z.string().min(1).max(MAX_WALK_HEADING_CHARS).optional(),
    /** The LAST crumb — where the site itself says this page sits. */
    breadcrumb: z.string().min(1).max(MAX_WALK_HEADING_CHARS).optional()
  }).strict().optional(),
  /** The page's REAL path when its `path` is a template: a document per page, not per template. */
  path: WalkedPathSchema.optional()
}).strict();

// src/discovery/page-evidence.ts
var PAGE_FACT_SOURCES = [
  /** schema.org `Product` / `Offer` / `PriceSpecification` / `PropertyValue` in `ld+json`. */
  "json-ld",
  /** A `<dl>`'s `<dt>` / `<dd>` pairs, under the heading that named the entity. */
  "definition-list",
  /** A two-column specification table: one row, one attribute, one scalar value. */
  "spec-table"
];
var PAGE_MEDIUM_SOURCES = ["json-ld"];
var MAX_PAGE_FACT_ENTITY_CHARS = 160;
var MAX_PAGE_FACT_ATTRIBUTE_CHARS = 120;
var MAX_PAGE_FACT_VALUE_CHARS = 240;
var MAX_PAGE_FACT_UNIT_CHARS = 32;
var MAX_PAGE_MEDIUM_ALT_CHARS = 240;
var MAX_PAGE_FACTS_PER_PAGE = 60;
var MAX_PAGE_MEDIA_PER_PAGE = 12;
var MAX_PAGE_ENTITIES_PER_PAGE = 12;
var MAX_PAGE_EVIDENCE_PAGES_PER_ENVIRONMENT = 5e3;
var SiteWalkPageFactSchema = /* @__PURE__ */ z.object({
  /** The thing this is a fact ABOUT, in the page's own words. */
  entity: z.string().min(1).max(MAX_PAGE_FACT_ENTITY_CHARS),
  /**
   * The attribute's label, in the page's own language and never translated.
   * A German page's `Größe` stays `Größe`; the comparison renders the site's
   * own text (`ui-design.md` § 22) and the reply locale governs only OUR
   * words around it.
   */
  attribute: z.string().min(1).max(MAX_PAGE_FACT_ATTRIBUTE_CHARS),
  /** The value as the page renders it — the text node, not a parse of it. */
  value: z.string().min(1).max(MAX_PAGE_FACT_VALUE_CHARS),
  /** A currency code or unit, when the page declared one SEPARATELY. */
  unit: z.string().min(1).max(MAX_PAGE_FACT_UNIT_CHARS).optional(),
  source: z.enum(PAGE_FACT_SOURCES)
}).strict();
var SiteWalkPageMediumSchema = /* @__PURE__ */ z.object({
  entity: z.string().min(1).max(MAX_PAGE_FACT_ENTITY_CHARS),
  /**
   * A ROOT-RELATIVE path on the walked origin. Cross-origin is not
   * representable — see the module header.
   */
  url: WalkedPathSchema,
  /** The page's own alternative text, when it wrote one. */
  alt: z.string().min(1).max(MAX_PAGE_MEDIUM_ALT_CHARS).optional(),
  /** Declared intrinsic dimensions, when the page declared them. */
  width: z.number().int().min(1).max(2e4).optional(),
  height: z.number().int().min(1).max(2e4).optional(),
  source: z.enum(PAGE_MEDIUM_SOURCES)
}).strict();
var SiteWalkPageEvidenceRefusalsSchema = /* @__PURE__ */ z.object({
  /** Values that looked like a person (an address, an account number, a token). */
  pii: z.number().int().min(0).max(1e4),
  /** Declared images on somebody else's origin. Recorded as absent, never fetched. */
  crossOriginMedia: z.number().int().min(0).max(1e4),
  /** Facts and media dropped because the page outran a per-page cap. */
  overCap: z.number().int().min(0).max(1e4),
  /** Candidates the lane could not read as an (attribute, value) pair at all. */
  unreadable: z.number().int().min(0).max(1e4)
}).strict();
var SiteWalkPageEvidenceSchema = /* @__PURE__ */ z.object({
  facts: z.array(SiteWalkPageFactSchema).max(MAX_PAGE_FACTS_PER_PAGE),
  media: z.array(SiteWalkPageMediumSchema).max(MAX_PAGE_MEDIA_PER_PAGE),
  /**
   * The language the page DECLARED (`<html lang>`), when it declared one.
   *
   * Absent means the page said nothing, which is a different fact from
   * English and must never be recorded as it: a comparison renders these
   * values as the site's own text, and mislabelling the language is how a
   * German price ends up announced as English.
   */
  lang: z.string().min(2).max(35).regex(/^[a-z]{2,3}(?:-[A-Za-z0-9]{2,8})*$/).optional(),
  refused: SiteWalkPageEvidenceRefusalsSchema
}).strict();
var SITE_WALK_PAGE_OBSERVATION_SHAPE = {
  /**
   * The same scan rows and sections a `ui_scan` tool result carries, produced
   * by the same `scanOperableControls` on the walked frame's document.
   *
   * `unknown` for the same reason the four harvest legs are: the server reads
   * them with `screenUiScanResult`'s own defensive parsing, and a second shape
   * defined here is a second thing to drift.
   *
   * **Why the walk sends these at all, when the ingest deliberately sent
   * `rows: []` before.** The old comment's reasoning was sound and is now
   * satisfied rather than overruled: it refused to invent a control inventory
   * from a walk because that "would tell the operator a control was seen by a
   * visitor when it was not". A walk observation is not a visitor's, and the
   * thing that says so is `SiteWalkBindRequest`'s declared `observedAudience` —
   * which the ingest already threads to the identity plane, and which the CHAT
   * turn structurally cannot supply (it passes `null` by design). So a walked
   * row is attributable to the operator's declared surface and a chatted one is
   * not, which is strictly MORE honest than the empty set that recorded nothing
   * at all.
   *
   * Both `.optional()`: a page with no operable controls omits them, exactly
   * like an empty harvest leg. Absent is "nothing there or not scanned", and
   * only the server distinguishes those — which is why `[]` is never sent.
   */
  rows: z.unknown().optional(),
  sections: z.unknown().optional(),
  /**
   * C2 — a provably FULL page view. The ONLY signal that lets the server run
   * the identity lifecycle sweep (removal detection); a filtered or paginated
   * subset would wrongly mark unseen controls `missing`. A walk visits a page
   * once with no content filter, so it is the one acquisition path that can
   * honestly claim this — and the server re-verifies it from `truncated` and
   * `appliedFilters` rather than trusting it (the widget is untrusted).
   */
  complete: z.boolean().optional(),
  /** Whether the operable set outran the scan's own per-page cap. */
  truncated: z.boolean().optional(),
  /** The candidate-set size and the number returned, for honest bounds. */
  total: z.number().int().min(0).max(1e5).optional(),
  returned: z.number().int().min(0).max(1e5).optional(),
  /**
   * The scan's own filter bag. Carried because the server's `fullPageView`
   * re-verification reads it for a CONTENT filter — sending it is what lets
   * that check be a real second source rather than a formality.
   */
  appliedFilters: z.unknown().optional(),
  /**
   * The page's declared language, re-judged server-side through the shared
   * closed grammar (ADR-0398: refused, never cleaned). Identity binding never
   * merges across a locale change, so this is load-bearing rather than
   * decorative — a walk that omitted it would make every localized page look
   * like a rename of the last one.
   */
  pageLang: z.string().max(SITE_WALK_MAX_PATH_CHARS).optional()
};
var SiteWalkRevealEdgeSchema = /* @__PURE__ */ z.object({
  revealedByName: z.string().min(1).max(160),
  revealedByRole: z.string().min(1).max(40),
  name: z.string().min(1).max(160),
  role: z.string().min(1).max(40),
  /**
   * WF-4.54 (§ P.6 gap 3) — the activation that produced this edge ALSO made
   * the tenant's own API answer.
   *
   * Two INDEPENDENT families of evidence agreeing — the DOM grew and the
   * network moved — is a stronger claim than either alone, which is WF-4.52's
   * independence model applied to reveals. Absent means only the DOM diff saw
   * it, which is the ordinary case and not a weakness: an edge a DOM diff
   * found is a real edge whether or not anything was fetched.
   *
   * `.optional()` for two reasons rather than one. A widget build predating
   * this field is a real wire case (the CDN serves one artifact; a loaded page
   * holds its own copy), and `.strict()` would otherwise cost a tenant the
   * whole page's edges over a boolean. And the DECLARED leg shares this schema:
   * a markup-declared edge involved no activation at all, so there was no
   * window in which anything could have been observed, and absent is the only
   * honest value it could carry.
   */
  networkCorroborated: z.boolean().optional()
}).strict();
var SiteWalkRevealsSchema = /* @__PURE__ */ z.object({
  probed: z.number().int().min(0).max(100),
  refused: z.number().int().min(0).max(1e4),
  quarantined: z.number().int().min(0).max(100),
  /**
   * WF-4.54 — activations where the tenant's own API answered and the DOM diff
   * saw NOTHING.
   *
   * A COUNT and never an edge, and that limit is the safety argument rather
   * than a simplification. A same-origin GET during an activation is evidence
   * that SOMETHING was fetched, not evidence of WHAT was revealed — there is no
   * revealed control to name. An edge minted with a fabricated name would land
   * in `ui_affordance_edges`, which is the store a guided tour points a visitor
   * AT, so a fabrication here is a wrong place to send somebody rather than a
   * wrong number on a dashboard.
   *
   * `.optional()` because a widget build predating it is a real wire case, and
   * because absent ("this producer does not report it") and `0` ("no activation
   * produced network-only evidence") are different facts. It is a DISCLOSURE
   * rather than a gate, so absent-means-unknown is safe — unlike a machine
   * value that drives a decision, which is refused rather than defaulted
   * (ADR-0398).
   */
  networkOnly: z.number().int().min(0).max(100).optional(),
  capped: z.boolean(),
  edges: z.array(SiteWalkRevealEdgeSchema).max(SITE_WALK_MAX_REVEAL_EDGES_PER_PAGE)
}).strict();
var SiteWalkDeclaredRevealsSchema = /* @__PURE__ */ z.array(SiteWalkRevealEdgeSchema).max(SITE_WALK_MAX_REVEAL_EDGES_PER_PAGE);

// src/intent/wordpress-ajax.ts
var WP_AJAX_METHOD = "WP_AJAX";
var WP_AJAX_ENDPOINT = /\/wp-admin\/admin-(?:ajax|post)\.php$/;
var WP_AJAX_ACTION = /^[A-Za-z0-9_][A-Za-z0-9_-]{0,127}$/;
function isWordPressAjaxPath(pathOrUrl) {
  return WP_AJAX_ENDPOINT.test(pathnameOf(pathOrUrl));
}
function isWordPressAjaxAction(action) {
  return WP_AJAX_ACTION.test(action);
}
function joinWordPressAjaxPath(endpointPath, action) {
  if (!WP_AJAX_ENDPOINT.test(endpointPath) || !WP_AJAX_ACTION.test(action)) return void 0;
  return `${endpointPath}/${action}`;
}
function splitWordPressAjaxPath(pathTemplate) {
  const slash = pathTemplate.lastIndexOf("/");
  if (slash <= 0) return void 0;
  const endpointPath = pathTemplate.slice(0, slash);
  const action = pathTemplate.slice(slash + 1);
  if (!WP_AJAX_ENDPOINT.test(endpointPath) || !WP_AJAX_ACTION.test(action)) return void 0;
  return { endpointPath, action };
}
var READ_PREFIXES = /* @__PURE__ */ new Set([
  "get",
  "check",
  "fetch",
  "search",
  "load",
  "list",
  "query",
  "count",
  "is",
  "has",
  "lookup",
  "find"
]);
var DESTRUCTIVE_PREFIXES = /* @__PURE__ */ new Set(["delete", "remove", "clear"]);
function wordPressAjaxActionFloor(action) {
  const first = action.toLowerCase().split(/[_-]/, 1)[0] ?? "";
  if (DESTRUCTIVE_PREFIXES.has(first)) return "destructive";
  if (READ_PREFIXES.has(first)) return "read";
  return "write";
}
function pathnameOf(pathOrUrl) {
  if (pathOrUrl.startsWith("/")) return pathOrUrl.split(/[?#]/, 1)[0] ?? "";
  try {
    return new URL(pathOrUrl).pathname;
  } catch {
    return "";
  }
}

// src/intent/graphql-document.ts
function graphqlArgsFullyTyped(args, argTypes, inputObject) {
  if (inputObject !== void 0) return true;
  if (argTypes === void 0) return false;
  for (const [key, value] of Object.entries(args)) {
    if (value === void 0) continue;
    const sdlType = argTypes[key];
    if (sdlType === void 0 || sdlType === "") return false;
  }
  return true;
}
function buildTypedGraphqlDocument(args) {
  const entries = Object.entries(args.args).filter(([, value]) => value !== void 0);
  const selection = args.withSelection ? " { __typename }" : "";
  if (args.inputObject !== void 0) {
    const { argName, sdlType } = args.inputObject;
    const inner = {};
    for (const [key, value] of entries) inner[key] = value;
    const query2 = `${args.opType} ($${argName}: ${sdlType}) { ${args.opName}(${argName}: $${argName})${selection} }`;
    return { query: query2, variables: { [argName]: inner } };
  }
  const argTypes = args.argTypes ?? {};
  const variables = {};
  for (const [key, value] of entries) variables[key] = value;
  const varDecls = entries.map(([key]) => `$${key}: ${argTypes[key] ?? "String"}`).join(", ");
  const fieldArgs = entries.map(([key]) => `${key}: $${key}`).join(", ");
  const opHeader = varDecls === "" ? args.opType : `${args.opType} (${varDecls})`;
  const fieldArgsPart = fieldArgs === "" ? "" : `(${fieldArgs})`;
  const query = `${opHeader} { ${args.opName}${fieldArgsPart}${selection} }`;
  return { query, variables };
}

// src/intent/operation.ts
var IntentTransportSchema = /* @__PURE__ */ z.enum(["rest", "graphql", "trpc", "ws", "grpc"]);
var OperationKindSchema = /* @__PURE__ */ z.enum(["query", "mutation", "subscription"]);
var MAX_WITNESS_METHOD_CHARS = 20;
var IntentOperationSchema = /* @__PURE__ */ z.discriminatedUnion("transport", [
  z.object({
    transport: z.literal("rest"),
    method: z.string().min(1),
    path: z.string().min(1),
    /**
     * PR-2.9 (R2-MCP1) — the request body encoding this endpoint expects when it
     * is NOT JSON, populated by the extractors (an OpenAPI `requestBody.content`
     * key, a form's `enctype`). Absent = `json`. Optional + additive: an
     * operation without it executes exactly as before. NOT part of operation
     * identity — see {@link operationsEqual} (the same endpoint at the same
     * method·path is the same operation whatever body it takes).
     */
    bodyEncoding: RestBodyEncodingSchema.optional(),
    /**
     * Zero-touch V4 WP1 (ADR-0740) — body fields the SERVER pins, merged over the
     * model's arguments at execution (pinned wins). WordPress's `action` is the
     * producer: it is the operation's identity, so it must never be something
     * the model chooses. IS part of operation identity — see
     * {@link operationsEqual}: two `WP_AJAX` capabilities share one endpoint path
     * and differ only here, and an intent bound to one must never verify for the
     * other.
     */
    fixedBody: z.record(z.string().min(1), z.string()).optional()
  }),
  z.object({
    transport: z.literal("graphql"),
    opType: OperationKindSchema,
    opName: z.string().min(1),
    /**
     * Per-argument SDL types (arg name → GraphQL type string, e.g. `ID!`,
     * `RefundInput!`, `Int`) captured by the CLI GraphQL extractor (act-as-user
     * PR-17.2). When present, the widget executor builds a typed-variable
     * operation (`mutation ($id: ID!) { refundOrder(id: $id) }` + `variables`)
     * instead of inlining args as literals — which restores GraphQL **mutations**
     * (the intent's `argsHash` binds the variables, closing the confused-deputy
     * gap) and removes the literal-injection surface. Optional + additive: an
     * operation without it falls back to the literal path (queries) / the mutation
     * degrade, exactly as before. NOT part of operation identity — see
     * {@link operationsEqual}.
     */
    argTypes: z.record(z.string().min(1)).optional(),
    /**
     * The GraphQL sole-input-object wrapper (act-as-user PR-17.2 follow-up) — set
     * when the field takes a single input object (`createUser(input: CreateUserInput!)`)
     * whose fields the catalog flattened. The widget rebuilds `mutation ($input:
     * CreateUserInput!) { createUser(input: $input) }` and wraps all call args
     * into `variables.input`, EXECUTING the mutation (the inner fields are
     * validated server-side against the input type, so only this wrapper type is
     * needed — `argTypes` is empty for this idiom). Mutually-exclusive-in-practice
     * with `argTypes` (direct-arg ops use `argTypes`; the idiom uses this).
     * Optional + additive; NOT part of operation identity — see {@link operationsEqual}.
     */
    inputObject: GraphqlInputObjectSchema.optional()
  }),
  z.object({
    transport: z.literal("trpc"),
    opType: OperationKindSchema,
    procedure: z.string().min(1)
  }),
  z.object({
    transport: z.literal("ws"),
    event: z.string().min(1),
    /**
     * WS reply-shape (act-as-user PR-B0), threaded from the catalog capability's
     * {@link WsReplySchema} at descriptor-emit time so the widget / Channel-B
     * executor knows how to await the reply (socket.io ack vs paired response
     * event) — or, for `none`, that the server should degrade with `ws_no_reply`.
     * Optional + additive; NOT part of operation identity (see
     * {@link operationsEqual}, which compares only `event`).
     */
    wsReply: WsReplySchema.optional()
  }),
  z.object({
    transport: z.literal("grpc"),
    service: z.string().min(1),
    method: z.string().min(1)
  })
]);
function operationsEqual(a, b) {
  if (a.transport !== b.transport) return false;
  switch (a.transport) {
    case "rest":
      return b.transport === "rest" && a.method === b.method && a.path === b.path && fixedBodiesEqual(a.fixedBody, b.fixedBody);
    case "graphql":
      return b.transport === "graphql" && a.opType === b.opType && a.opName === b.opName;
    case "trpc":
      return b.transport === "trpc" && a.opType === b.opType && a.procedure === b.procedure;
    case "ws":
      return b.transport === "ws" && a.event === b.event;
    case "grpc":
      return b.transport === "grpc" && a.service === b.service && a.method === b.method;
    default:
      return false;
  }
}
function fixedBodiesEqual(a, b) {
  const ka = Object.keys(a ?? {}).sort();
  const kb = Object.keys(b ?? {}).sort();
  if (ka.length !== kb.length) return false;
  return ka.every((key, i) => key === kb[i] && a?.[key] === b?.[key]);
}
function methodPathToOperation(method, path) {
  if (method === WP_AJAX_METHOD) {
    const split = splitWordPressAjaxPath(path);
    if (split === void 0) {
      throw new Error(
        `a ${WP_AJAX_METHOD} capability's path must be <endpoint>/<action> (ADR-0740); got ${JSON.stringify(path)}`
      );
    }
    return {
      transport: "rest",
      method: "POST",
      path: split.endpointPath,
      bodyEncoding: "form",
      fixedBody: { action: split.action }
    };
  }
  if (method === "GET" || method === "POST" || method === "PUT" || method === "PATCH" || method === "DELETE" || method === "OPTIONS" || method === "HEAD") {
    return { transport: "rest", method, path };
  }
  if (method === "GRAPHQL_QUERY" || method === "GRAPHQL_MUTATION" || method === "GRAPHQL_SUBSCRIPTION") {
    const opType = method === "GRAPHQL_QUERY" ? "query" : method === "GRAPHQL_MUTATION" ? "mutation" : "subscription";
    const dot2 = path.indexOf(".");
    const opName = dot2 >= 0 ? path.slice(dot2 + 1) : path;
    return { transport: "graphql", opType, opName };
  }
  if (method === "TRPC_QUERY" || method === "TRPC_MUTATION" || method === "TRPC_SUBSCRIPTION") {
    const opType = method === "TRPC_QUERY" ? "query" : method === "TRPC_MUTATION" ? "mutation" : "subscription";
    return { transport: "trpc", opType, procedure: path };
  }
  if (method === "WS_HANDLER") {
    return { transport: "ws", event: path };
  }
  if (method === "SSE_STREAM") return { transport: "rest", method: "GET", path };
  if (method === "FUNCTION") {
    throw new Error(
      "internal-function capabilities (method FUNCTION) are not executable via an intent operation \u2014 runtime execution is deferred to SYN-350; they must not be advertised as callable tools until then (ADR-0316)"
    );
  }
  const dot = path.lastIndexOf(".");
  const service = dot >= 0 ? path.slice(0, dot) : path;
  const grpcMethod = dot >= 0 ? path.slice(dot + 1) : path;
  return { transport: "grpc", service, method: grpcMethod };
}
function parseAbsoluteHttpUrl(value) {
  let url;
  try {
    url = new URL(value);
  } catch {
    return null;
  }
  return url.protocol === "https:" || url.protocol === "http:" ? url : null;
}

// src/discovery/witness-kind.ts
var WITNESS_KINDS = [
  /** Method + path, as every row was before this column existed. */
  "HTTP",
  "GRAPHQL_QUERY",
  "GRAPHQL_MUTATION",
  "GRAPHQL_SUBSCRIPTION",
  "TRPC_QUERY",
  "TRPC_MUTATION",
  "JSONRPC",
  /** A server-sent event stream: the `EventSource` URL, never a message. */
  "SSE_STREAM",
  /** A WebSocket the app constructed: URL + protocols, never a payload. */
  "WS_CONNECT",
  /** The SHAPE of a message the app's own `send` carried, never its content. */
  "WS_MESSAGE",
  /** The seal refused this write; its request shape was captured (WF-4.8 leg a). */
  "BLOCKED_WRITE"
];
var WitnessKindSchema = /* @__PURE__ */ z.enum(WITNESS_KINDS);
var MAX_WITNESS_KIND_CHARS = MAX_WITNESS_METHOD_CHARS;
var WIRE_WITNESS_METHODS = [
  "GET",
  "HEAD",
  "POST",
  "PUT",
  "PATCH",
  "DELETE",
  "OPTIONS",
  "GRAPHQL_QUERY",
  "GRAPHQL_MUTATION",
  "GRAPHQL_SUBSCRIPTION",
  "TRPC_QUERY",
  "TRPC_MUTATION",
  "JSONRPC",
  "SSE_STREAM",
  "WS_CONNECT",
  "WS_MESSAGE",
  // Zero-touch V4 WP1 (ADR-0740) — WordPress's `admin-ajax.php` operation. A
  // METHOD token like the GraphQL ones, and deliberately NOT a new witness
  // KIND: `witnessKindFromMethod` maps it to `HTTP` (its path template is a
  // real route, `<endpoint>/<action>`), so `api_witnesses.kind`'s CHECK and the
  // migration it would need are untouched, and nine actions on one endpoint are
  // nine rows because the path differs.
  "WP_AJAX"
];
var MAX_WITNESS_OPERATION_NAME_CHARS = 128;
var WITNESS_OPERATION_NAME_PATTERN = /^(?=.{1,128}$)[A-Za-z_][A-Za-z0-9_]*(?:\.[A-Za-z_][A-Za-z0-9_]*)*$/;
var OPERATION_KINDS = /* @__PURE__ */ new Set([
  "GRAPHQL_QUERY",
  "GRAPHQL_MUTATION",
  "GRAPHQL_SUBSCRIPTION",
  "TRPC_QUERY",
  "TRPC_MUTATION",
  "JSONRPC"
]);
function isOperationWitnessKind(kind) {
  return OPERATION_KINDS.has(kind);
}
var METHOD_TOKEN_KINDS = /* @__PURE__ */ new Set([
  "GRAPHQL_QUERY",
  "GRAPHQL_MUTATION",
  "GRAPHQL_SUBSCRIPTION",
  "TRPC_QUERY",
  "TRPC_MUTATION",
  "JSONRPC",
  "SSE_STREAM",
  "WS_CONNECT",
  "WS_MESSAGE"
]);
function witnessKindFromMethod(method) {
  const token = method.trim().toUpperCase();
  if (METHOD_TOKEN_KINDS.has(token)) return token;
  if (token === "WS") return "WS_CONNECT";
  return "HTTP";
}

// src/discovery/site-walk-traffic.ts
var SiteWalkApiCallSchema = /* @__PURE__ */ z.object({
  /** The templated path. Re-refused server-side against the closed grammar. */
  path: z.string().min(1).max(SITE_WALK_MAX_PATH_CHARS),
  /** How many entries collapsed onto this template. Never zero. */
  seenCount: z.number().int().min(1).max(1e5),
  /**
   * WF-4.64 — the status the browser reported, WHEN it reported one. Absent is
   * a real and common answer (cross-origin, or an engine without the field)
   * and must not be read as a success or as a failure.
   */
  responseStatus: z.number().int().min(100).max(599).optional()
}).strict();
var SiteWalkWitnessSchema = /* @__PURE__ */ z.object({
  method: z.enum(WIRE_WITNESS_METHODS),
  /** The templated path. Re-refused server-side against the closed grammar. */
  path: z.string().min(1).max(SITE_WALK_MAX_PATH_CHARS),
  status: z.number().int().min(100).max(599),
  /** Inferred STRUCTURE, re-validated server-side with `ShapeSchema`. */
  requestShape: z.unknown().nullable(),
  responseShape: z.unknown().nullable(),
  /**
   * W1-9b — the first-party origin this exchange was made against, so a
   * tenant calling both `app.<domain>/v1/track` and `api.<domain>/v1/track`
   * keeps them apart instead of merging their shapes into a wrong answer.
   * Absent when the URL was relative and no origin resolved: the tap refuses
   * to GUESS one, because a guessed origin is an identity claim the server
   * would key a row on.
   */
  requestOrigin: z.string().max(255).optional()
}).strict();
var WALK_CONTROL_ID_PATTERN = /^uic_[0-9a-z]{1,16}$/;
function isWalkControlId(value) {
  return WALK_CONTROL_ID_PATTERN.test(value);
}
var SiteWalkBlockedWriteSchema = /* @__PURE__ */ z.object({
  /**
   * The HTTP verb the sentinel refused — or `WP_AJAX`, the transport token a
   * WordPress `admin-ajax` write carries when the seal could read its `action`
   * (zero-touch V4 #13, extending ADR-0740 to the refused side). The live
   * witness wire already sends `WP_AJAX`; a Safe walk produces a REFUSED write
   * for the same request, and without the token the server keyed nine
   * operations as one `POST` with the write floor. The path is then
   * `<endpoint>/<action>`, re-refused server-side against the closed grammar.
   */
  method: z.enum(["POST", "PUT", "PATCH", "DELETE", "WP_AJAX"]),
  /** The templated path. Re-refused server-side against the closed grammar. */
  path: z.string().min(1).max(SITE_WALK_MAX_PATH_CHARS),
  /** Inferred STRUCTURE, re-validated server-side with `ShapeSchema`. */
  requestShape: z.unknown().nullable(),
  /**
   * W5-7 — a body WAS sent and could not be shaped (form-encoded, protobuf,
   * XML). Distinct from `requestShape: null`, which means there was no body:
   * one says "we know it takes something we cannot describe", the other says
   * "it takes nothing", and an operator acts differently on each.
   */
  shapeOpaque: z.boolean(),
  /**
   * WF-4.8 leg (d) — the CONTROL whose activation provoked this write.
   *
   * The join that turns "this site has `POST /api/orders`" into "the *Place
   * order* button posts to `/api/orders`", which is where a capability's name
   * comes from. Host-page prose, so it is `sanitizeToolText`-screened
   * server-side at the same W5-1 chokepoint every harvested label crosses.
   *
   * Absent when the control had no accessible name — a real case, and a
   * distinct one from an empty string.
   */
  controlName: z.string().max(160).optional(),
  /**
   * Zero-touch B3 (lane F's F2 request) — the pressed control's IDENTITY,
   * the same `uic_` signature the scan mints for `registered_ui_controls`,
   * so the page-act gate's join can move from the screened LABEL to the
   * control itself and a renamed control keeps its verdict. Appended under
   * `CONTRACTS.md` § 4 (announced in `LANE-B.md`). Absent when the control
   * had no name — a nameless control has no signature worth joining on.
   */
  controlId: z.string().regex(WALK_CONTROL_ID_PATTERN).optional()
}).strict();

// src/discovery/page-name.ts
function walkedPageName(title, signals = {}) {
  const named = collapse(title);
  const folded = fold(named);
  const adds = (value) => {
    const text = collapse(value ?? "");
    return text !== "" && !folded.includes(fold(text)) ? text : void 0;
  };
  const identity = signals.identity;
  const subject = adds(identity?.structuredName) ?? adds(identity?.ogTitle) ?? adds(identity?.breadcrumb) ?? (signals.headings ?? []).map((h) => adds(h)).find((h) => h !== void 0);
  if (subject === void 0) return named;
  if (named === "") return subject.slice(0, MAX_WALK_PAGE_TITLE_CHARS);
  return `${named} \u2014 ${subject}`.slice(0, MAX_WALK_PAGE_TITLE_CHARS);
}
function collapse(value) {
  return value.replace(/\s+/gu, " ").trim();
}
function fold(value) {
  return value.toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, " ").trim();
}

// src/discovery/site-walk-page.ts
var SiteWalkPageSchema = /* @__PURE__ */ z.object({
  path: WalkedPathSchema,
  /**
   * The four ADR-0396 harvest legs, in the exact shape `screenUiScanResult`
   * already reads them off a tool result. `unknown` by design — see the module
   * header. `.optional()` because a page legitimately carries none of them.
   */
  forms: z.unknown().optional(),
  routeManifest: z.unknown().optional(),
  anchorGraph: z.unknown().optional(),
  jsonLd: z.unknown().optional(),
  /**
   * R5 — the service worker's precached page inventory, in the same shape the
   * `ui_scan` screen already reads. Carried on the walk rather than on a
   * visitor's chat turn, which is the whole point: the read is Cache Storage
   * access under ePrivacy Art 5(3), and on the walk an admin has explicitly
   * started a banner-visible run on their own site in their own browser —
   * a service they requested — where a visitor asking a chat question has not.
   *
   * Attached to ONE page per run (the landing page), because it is a per-ORIGIN
   * fact rather than a per-page one: repeating it on all 400 pages would send
   * the same inventory 400 times and, worse, make `seen_count` look like
   * corroboration from pages that never reported it.
   */
  precache: z.unknown().optional(),
  /**
   * WF-4.49c-ii — the routes this page's `<script type="speculationrules">`
   * block named, in the same shape `screenUiScanResult` reads the legs above.
   *
   * PER-PAGE rather than per-origin, unlike `precache` one field up, and the
   * difference is a fact about the mechanism: a service worker's precache is
   * one inventory the whole origin shares, while a speculation block is
   * markup — each page declares its own, and a checkout page's block names
   * different destinations from a docs page's. Sending it once would report
   * the landing page's guesses as the site's.
   *
   * No ePrivacy question either, which is why it needs no grant of its own:
   * this is a `<script>` element in the document the walk already loaded, not
   * a browser store.
   */
  speculation: z.unknown().optional(),
  /**
   * WF-4.35 remainder / ET-2 § A.2 — routes this ORIGIN's `.well-known`
   * artifacts declare, in the same shape `screenUiScanResult` reads the legs
   * above.
   *
   * PER-ORIGIN like `precache` and unlike `speculation`, so it is attached to
   * ONE page per run: an AASA is a property of the site, not of the page that
   * happened to be open when the walk started.
   */
  wellKnown: z.unknown().optional(),
  /**
   * WF-4.48b — the edges this page's MARKUP declares (`popovertarget`,
   * `aria-controls` under an `aria-expanded` disclosure, `<summary>` in
   * `<details>`, `commandfor` + a showing `command`).
   *
   * Optional because most pages declare none, and absent is not empty: a page
   * with no declarations and a page the harvest could not read are both
   * silent here, and neither is a claim that the page has no reveals.
   */
  declaredReveals: SiteWalkDeclaredRevealsSchema.optional(),
  /** Cross-origin forms the widget dropped whole, counted (never described). */
  formsCrossOriginDropped: z.number().int().min(0).max(1e4).optional(),
  /**
   * WS-B3 — what the reveal probe found on this page. TYPED rather than
   * `unknown`, unlike the four legs above: those reuse `screenUiScanResult`'s
   * defensive parsing verbatim, while this leg is new and has no second
   * consumer whose shape it must mirror — so the boundary schema is the one
   * place its shape is defined. `.optional()`: absent when the probe did not
   * run (gate off, landing page, pre-probe widget build), which is a
   * different fact from "ran and found nothing".
   */
  reveals: SiteWalkRevealsSchema.optional(),
  /**
   * WF-4.34a — the API endpoints this page's own navigation called.
   *
   * `.optional()`, and absent is NOT empty: a widget build predating this
   * field, a browser without Resource Timing, and a page whose frame was gone
   * before we could read are all silent here, while `[]` says we looked and
   * the page called nothing. The two want opposite readings on a coverage
   * surface, so they stay distinguishable — the same rule
   * `missedApiCallsBeforeBoot` already holds one layer over.
   */
  apiCalls: z.array(SiteWalkApiCallSchema).max(MAX_WALK_API_CALLS_PER_PAGE).optional(),
  /**
   * WF-4.34b — the exchanges the walk WITNESSED on this page, with their
   * methods and inferred shapes.
   *
   * Beside `apiCalls` rather than replacing it, and the PAIR is what makes the
   * post-navigation bound honest. The taps arm after `load` and before the
   * settle, so a call the app issued during its own boot is seen by the timing
   * read and not by the taps. A path that appears in `apiCalls` and not here
   * is exactly that call, and collapsing the two legs would hide the one
   * measurement of what this design gives up.
   *
   * `.optional()`, and absent is not empty: a widget build predating it, a
   * frame whose transports could not be patched, and a page that made no
   * first-party call while we watched are all silent — the last of which `[]`
   * would claim.
   */
  apiWitnesses: z.array(SiteWalkWitnessSchema).max(MAX_WALK_WITNESSES_PER_PAGE).optional(),
  /**
   * WF-4.24 — what this page's harvest could not SEE, in the shape the
   * `ui_scan` screen already reads.
   *
   * The SAME field the chat-turn path carries, deliberately, and it is what
   * makes the walk's accepted bound visible without a line of new server code:
   * `screenScan` already parses `coverageGaps` and already calls
   * `logCoverageGaps` on what it parsed, so a walk page that carries one is
   * reported through the same seam as a visitor's turn.
   *
   * The member that matters here is `missedApiCallsBeforeBoot` — the operator's
   * own wording on the WF-4.24 shim decision, which chose post-navigation taps
   * and asked for the resulting miss to be counted rather than absorbed.
   * `preboot-miss.ts` computes it and carries the reasoning.
   *
   * `.optional()`, and absent is not empty on every member: a widget build
   * predating this, an inert page that ran no script and therefore has no
   * traffic to have missed, and a frame whose timing was gone before we read
   * are all silent — where a zero says we looked and the walk arrived early
   * enough.
   */
  coverageGaps: RuntimeUiCoverageGapsSchema.optional(),
  /**
   * WF-4.8 leg (a) / D10 Tier 0 — the write endpoints this page's probe
   * learned by REFUSING their writes.
   *
   * The third reading beside `apiCalls` and `apiWitnesses`, and the only one
   * that never touched the network: these requests were built by the page's
   * own handlers and stopped at the point they were made. See
   * {@link SiteWalkBlockedWriteSchema} for why it is its own type rather than
   * a witness with an optional status.
   */
  blockedWrites: z.array(SiteWalkBlockedWriteSchema).max(MAX_WALK_BLOCKED_WRITES_PER_PAGE).optional(),
  /**
   * WF-4.5b / ADR-0584 — this page's SEALED pass, as counts: what was
   * pressed, what opened, what was filled, and every control that was NOT
   * opened, named with its reason.
   *
   * Beside `reveals` rather than inside it, and the split is the point: the
   * edges a press produced ride `reveals` in the probe's own shape (one
   * consumer, one store), while this is the ACCOUNTING of the pass — the
   * opened-or-named contract — which has a different reader. `.optional()`:
   * absent when the sealed pass did not run on this page (no grant, an inert
   * document, the landing page), which is a different fact from "ran and
   * pressed nothing".
   */
  sealed: SiteWalkSealedPageSchema.optional(),
  /**
   * WF-4.13 / ADR-0586 — this page's VISION leg, as counts: painted surfaces
   * found, captured, skipped (identical / blank / unreadable), sent, asked
   * about, and how many identity rows the findings became. The rows
   * themselves ride `rows` below — the same store and screen as every DOM
   * control — so nothing here is a name. `.optional()`: absent when the
   * grant was off, the page was inert or the sealed pass did not run here.
   */
  painted: SiteWalkPaintedPageSchema.optional(),
  /**
   * WF-4.8 leg (b) / ADR-0587 § 6 — this page's SAFE-METHOD probe, as counts:
   * targets offered, probes sent by method, targets refused, whether a
   * ceiling ended it. The answers ride `apiWitnesses` with their real status
   * and response shape. `.optional()`: absent when the grant was off, the
   * page was inert, or the sealed pass did not run here.
   */
  probe: SiteWalkProbePageSchema.optional(),
  // PR-4.1 (C3) — the OPERABLE-CONTROL observation (`rows`, `sections`,
  // `complete`, `truncated`, `total`, `returned`, `appliedFilters`,
  // `pageLang`), in its own leaf at the ceiling. Spread rather than nested so
  // this stays ONE `.strict()` object and the wire does not move.
  ...SITE_WALK_PAGE_OBSERVATION_SHAPE,
  /** ADR-0747 — what a visitor can READ on this page; see `SiteWalkPageTextSchema`. */
  text: SiteWalkPageTextSchema.optional(),
  /**
   * P4-A / D7 — the FACTS and MEDIA this page DECLARES about the things on
   * it, so a comparison can be composed from evidence rather than from prose
   * (§ 2.8).
   *
   * The one leg on this wire whose EMPTY form is meaningful, and the
   * asymmetry is deliberate. Every other leg here omits itself when it found
   * nothing, because "found nothing" and "did not look" have the same
   * consumer and the server resolves them. This one's consumer is a
   * comparison's DEGRADATION, which has to choose between two different
   * sentences — "the site does not say" and "we have not read that page" —
   * so `facts: []` with `media: []` is a published silence (ADR-0617's rule)
   * and an absent report is the older widget, the killed lane, or a harvest
   * that threw.
   */
  pageEvidence: SiteWalkPageEvidenceSchema.optional()
}).strict();
var template = /* @__PURE__ */ z.string().min(1).max(SITE_WALK_MAX_PATH_CHARS);
var SiteWalkFrontierPageOutcomeSchema = /* @__PURE__ */ z.discriminatedUnion("outcome", [
  z.object({ template, outcome: z.literal("visited") }).strict(),
  z.object({
    template,
    outcome: z.literal("unreached"),
    reason: z.enum(SITE_WALK_UNREACHED_REASONS)
  }).strict()
]);
var SiteWalkFrontierReportSchema = /* @__PURE__ */ z.object({
  sessionId: z.string().uuid(),
  found: z.array(template).max(SITE_WALK_MAX_FOUND_PER_REPORT).default([]),
  page: SiteWalkFrontierPageOutcomeSchema.optional()
}).strict().refine((r) => r.found.length > 0 || r.page !== void 0, {
  message: "a frontier report carries found templates, a page outcome, or both"
});
var SiteWalkNextRequestSchema = /* @__PURE__ */ z.object({
  sessionId: z.string().uuid(),
  limit: z.number().int().min(1).max(SITE_WALK_NEXT_LIMIT).optional()
}).strict();
var SiteWalkHeartbeatSchema = /* @__PURE__ */ z.object({
  sessionId: z.string().uuid(),
  nonce: z.string().min(SITE_WALK_NONCE_MIN_CHARS).max(SITE_WALK_NONCE_MAX_CHARS).regex(SITE_WALK_NONCE_PATTERN),
  phase: z.enum(SITE_WALK_REPORTED_PHASES).optional(),
  /** The templated route being read. A template, never a concrete path. */
  currentTemplate: template.optional(),
  /**
   * A7 / A9 / R-7 — why this tab is PAUSED, `null` to clear a pause, absent
   * for a build that predates the field.
   *
   * The pause rides the BEAT rather than taking routes of its own, and the
   * three reasons are worth stating because the shape looks like a shortcut:
   * a pause is a fact about a live tab, so it belongs on the one message a
   * live tab already sends every ten seconds; auto-resume (R-7's "resume is
   * AUTOMATIC the moment the widget sees the sign-in") is then the ABSENCE
   * of a pause on the next beat rather than a second call that can be lost;
   * and a tab that dies while paused stops beating, so the server's own
   * `tab-closed` inference takes over with nothing to reconcile.
   *
   * `null` and ABSENT are deliberately different. `null` is a tab saying
   * "the wall is gone" — it clears a stored pause. Absent is a build that
   * has never heard of pauses, and must not clear one somebody else set.
   */
  pause: z.enum(SITE_WALK_REPORTABLE_PAUSE_REASONS).nullable().optional()
}).strict();

// src/discovery/site-walk.ts
var SiteWalkPageBatchSchema = /* @__PURE__ */ z.object({
  sessionId: z.string().uuid(),
  pages: z.array(SiteWalkPageSchema).min(1).max(SITE_WALK_MAX_PAGES_PER_FLUSH)
}).strict();
var SiteWalkBindRequestSchema = /* @__PURE__ */ z.object({
  bindToken: z.string().min(1).max(512),
  /**
   * A5 / SECURITY § 1 — a nonce the tab minted in its own memory. Established
   * on the session ONCE at bind (SHA-256 at rest) and required on every
   * heartbeat, so a credential that leaks out of this tab can post pages
   * until it lapses and can never renew itself. OPTIONAL on the wire because
   * a widget build that predates it sends none — and such a build keeps its
   * fixed credential window exactly as before (ADR-0595). Absent is never
   * coerced into a nonce the server invents: that would give a leaked
   * credential a renewal path the tab never established.
   */
  nonce: z.string().min(SITE_WALK_NONCE_MIN_CHARS).max(SITE_WALK_NONCE_MAX_CHARS).regex(SITE_WALK_NONCE_PATTERN).optional(),
  /**
   * A5 (lane D's Request, Z-10) — the embed's `data-api-base-url`, the
   * CUSTOMER's API where a capability executes, so the witness publish lane
   * can admit witnesses to that DECLARED cross-site origin. Persisted on the
   * walk session as its ORIGIN (scheme + host + port), never the path; the
   * server screens it (`http(s)` only) and stores nothing it cannot parse.
   */
  apiBaseUrl: z.string().min(1).max(SITE_WALK_MAX_API_BASE_URL_CHARS).optional()
}).strict();

// src/discovery/site-walk-scope.ts
var SITE_WALK_SCOPES = ["preview", "full"];
var SITE_WALK_STARTABLE_SCOPE = "full";

// src/discovery/site-walk-page-timeout.ts
var SITE_WALK_PAGE_TIMEOUT_FLOOR_MS = 3e4;
var SITE_WALK_PAGE_TIMEOUT_SAMPLE = 5;
var SITE_WALK_PAGE_TIMEOUT_MULTIPLIER = 3;
var SITE_WALK_BACKGROUND_TIMEOUT_MULTIPLIER = 3;
var SITE_WALK_PAGE_TIMEOUT_CEILING_MS = 10 * 60 * 1e3;
function siteWalkPageTimeoutMs(args) {
  const base = args.overrideMs ?? adaptiveBase(args.durationsMs);
  const multiplied = args.hidden === true ? base * SITE_WALK_BACKGROUND_TIMEOUT_MULTIPLIER : base;
  return Math.min(multiplied, SITE_WALK_PAGE_TIMEOUT_CEILING_MS);
}
function adaptiveBase(durationsMs) {
  const sample = durationsMs.slice(0, SITE_WALK_PAGE_TIMEOUT_SAMPLE);
  if (sample.length < SITE_WALK_PAGE_TIMEOUT_SAMPLE) return SITE_WALK_PAGE_TIMEOUT_FLOOR_MS;
  return Math.max(
    SITE_WALK_PAGE_TIMEOUT_FLOOR_MS,
    Math.round(medianOf(sample) * SITE_WALK_PAGE_TIMEOUT_MULTIPLIER)
  );
}
function medianOf(values) {
  const sorted = [...values].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  const upper = sorted[mid] ?? 0;
  if (sorted.length % 2 === 1) return upper;
  return ((sorted[mid - 1] ?? 0) + upper) / 2;
}

// src/discovery/site-walk-driver.ts
var SITE_WALK_DRIVERS = ["frames", "tab", "live_page"];
var DEFAULT_SITE_WALK_DRIVER = "frames";
function screenSiteWalkDriver(value, only = SITE_WALK_DRIVERS) {
  for (const driver of only) {
    if (value === driver) return driver;
  }
  return DEFAULT_SITE_WALK_DRIVER;
}

// src/discovery/observed-audience.ts
var UNSEGMENTED_AUDIENCE = "~unsegmented";
var UNDECLARED_AUDIENCE = "~undeclared";
var PUBLIC_AUDIENCE = "~public";
var MAX_OBSERVED_AUDIENCE_CHARS = 40;
var OBSERVED_AUDIENCE_PATTERN = /^[\p{L}\p{M}\p{N}][\p{L}\p{M}\p{N} _-]{0,39}$/u;
function normalizeObservedAudience(input) {
  if (typeof input !== "string") return null;
  const trimmed = input.trim();
  if (trimmed.length === 0 || trimmed.length > MAX_OBSERVED_AUDIENCE_CHARS) return null;
  return OBSERVED_AUDIENCE_PATTERN.test(trimmed) ? trimmed : null;
}

// src/discovery/backend-spec-paths.ts
var MAX_SPEC_PROBES_PER_BACKEND = 4;
var GET = (path) => ({ path, method: "GET" });
var MOST_COMMON_SPEC_PROBES = [
  GET("/openapi.json"),
  GET("/swagger.json"),
  GET("/v3/api-docs"),
  GET("/api-docs")
];
var BACKEND_SPEC_PROBES = {
  // The complete REST index, on by default, unauthenticated — R-6 calls it the
  // single highest-yield probe available. `?rest_route=/` is the same index on
  // an install with no pretty permalinks, which is common on shared hosting and
  // is the one case where `/wp-json/` 404s on a site that has the API.
  wordpress: [GET("/wp-json/"), GET("/?rest_route=/")],
  // drf-spectacular, then drf-yasg, which is the order of current adoption —
  // then the OPTIONS metadata every DRF install answers with no add-on at all.
  // The OPTIONS rung is LAST because it yields the least: field names and
  // allowed methods for one route, where the two above yield the whole schema.
  django: [
    GET("/api/schema/"),
    GET("/swagger.json"),
    GET("/swagger/?format=openapi"),
    { path: "/api/", method: "OPTIONS" }
  ],
  rails: [GET("/api-docs/v1/swagger.json"), GET("/api-docs")],
  laravel: [GET("/docs/api.json"), GET("/api/documentation")],
  // NestJS's Swagger module, whose default mount is `/api` with `-json` appended.
  express: [GET("/api-json"), GET("/api/docs-json")],
  aspnet: [GET("/swagger/v1/swagger.json"), GET("/swagger/index.html")],
  // springdoc, then the actuator's own route table where exposure is widened.
  // `/actuator/mappings` is not a spec — it is the live handler table, which is
  // strictly better evidence and strictly worse to parse, so it ranks last.
  spring: [GET("/v3/api-docs"), GET("/swagger-ui/index.html"), GET("/actuator/mappings")],
  // FastAPI and Drupal share this bucket only in that both are commonly behind
  // a bare PHP/Python fingerprint; each path is idiomatic to exactly one.
  php: [GET("/jsonapi"), GET("/rest/schema")],
  nextjs: [GET("/api/openapi.json")],
  // Nitro's `experimental.openAPI` serves the document at `/_openapi.json`;
  // a hand-rolled route handler conventionally lands at `/api/openapi.json`.
  nuxt: [GET("/_openapi.json"), GET("/api/openapi.json")]
};
function boundProbes(probes) {
  return probes.slice(0, MAX_SPEC_PROBES_PER_BACKEND);
}
function dedupe(probes) {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const probe of probes) {
    const key = `${probe.method} ${probe.path}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(probe);
  }
  return out;
}
function gatedSpecProbes(kinds) {
  if (kinds.length === 0) return MOST_COMMON_SPEC_PROBES;
  const probes = [];
  for (const kind of kinds) {
    probes.push(...boundProbes(BACKEND_SPEC_PROBES[kind]));
  }
  return dedupe(probes);
}
function specPathsForBackend(kinds) {
  if (kinds.length === 0) return [];
  const paths = [];
  for (const probe of gatedSpecProbes(kinds)) {
    if (probe.method !== "GET") continue;
    if (!paths.includes(probe.path)) paths.push(probe.path);
  }
  return paths;
}
({
  wordpress: BACKEND_SPEC_PROBES.wordpress.map((probe) => probe.path),
  django: BACKEND_SPEC_PROBES.django.map((probe) => probe.path),
  rails: BACKEND_SPEC_PROBES.rails.map((probe) => probe.path),
  laravel: BACKEND_SPEC_PROBES.laravel.map((probe) => probe.path),
  express: BACKEND_SPEC_PROBES.express.map((probe) => probe.path),
  aspnet: BACKEND_SPEC_PROBES.aspnet.map((probe) => probe.path),
  spring: BACKEND_SPEC_PROBES.spring.map((probe) => probe.path),
  php: BACKEND_SPEC_PROBES.php.map((probe) => probe.path),
  nextjs: BACKEND_SPEC_PROBES.nextjs.map((probe) => probe.path),
  nuxt: BACKEND_SPEC_PROBES.nuxt.map((probe) => probe.path)
});

// src/discovery/backend-fingerprint.ts
var HEADER_SIGNALS = [
  ["x-powered-by", "php", "php"],
  ["x-powered-by", "express", "express"],
  ["x-powered-by", "asp.net", "aspnet"],
  ["x-powered-by", "next.js", "nextjs"],
  ["x-aspnet-version", "", "aspnet"],
  ["x-aspnetmvc-version", "", "aspnet"],
  ["x-drupal-cache", "", "php"],
  ["x-generator", "wordpress", "wordpress"],
  ["server", "microsoft-iis", "aspnet"],
  ["x-runtime", "", "rails"],
  ["x-nextjs-cache", "", "nextjs"],
  // Spring Boot's actuator and Spring Security both set this on their own
  // responses; nothing else in this list does.
  ["x-application-context", "", "spring"]
];
var COOKIE_SIGNALS = [
  ["connect.sid", "express"],
  ["laravel_session", "laravel"],
  ["XSRF-TOKEN", "laravel"],
  ["csrftoken", "django"],
  ["sessionid", "django"],
  ["JSESSIONID", "spring"],
  ["_rails_session", "rails"],
  ["PHPSESSID", "php"],
  ["wordpress_logged_in", "wordpress"],
  ["wp-settings-time", "wordpress"],
  ["ASP.NET_SessionId", "aspnet"],
  [".AspNetCore.Session", "aspnet"]
];
var GENERATOR_SIGNALS = [
  ["wordpress", "wordpress"],
  ["drupal", "php"],
  ["nuxt", "nuxt"],
  ["next.js", "nextjs"]
];
var ASSET_PATH_SIGNALS = [
  ["/wp-content/", "wordpress"],
  ["/wp-includes/", "wordpress"],
  ["/_next/", "nextjs"],
  ["/_nuxt/", "nuxt"],
  ["/sites/default/files/", "php"]
];
function fingerprintBackend(evidence) {
  const found = [];
  const add = (kind) => {
    if (!found.includes(kind)) found.push(kind);
  };
  for (const name of evidence.cookieNames ?? []) {
    for (const [cookie, kind] of COOKIE_SIGNALS) {
      if (name === cookie) add(kind);
    }
  }
  for (const [rawName, rawValue] of evidence.headers ?? []) {
    const name = rawName.toLowerCase();
    const value = rawValue.toLowerCase();
    for (const [header, needle, kind] of HEADER_SIGNALS) {
      if (name !== header) continue;
      if (needle === "" || value.includes(needle)) add(kind);
    }
  }
  for (const raw of evidence.generators ?? []) {
    const content = raw.toLowerCase();
    for (const [needle, kind] of GENERATOR_SIGNALS) {
      if (content.includes(needle)) add(kind);
    }
  }
  for (const raw of evidence.assetPaths ?? []) {
    const path = raw.toLowerCase();
    for (const [needle, kind] of ASSET_PATH_SIGNALS) {
      if (path.includes(needle)) add(kind);
    }
  }
  return found;
}

// src/discovery/well-known-routes.ts
var AASA_PATH = "/.well-known/apple-app-site-association";
var MAX_WELL_KNOWN_ROUTES = 200;
function readAasaRoutes(body) {
  const details = pick2(pick2(body, "applinks"), "details");
  if (!Array.isArray(details)) return { routes: [], refused: 0 };
  const seen = /* @__PURE__ */ new Set();
  const routes = [];
  let refused = 0;
  const consider = (raw) => {
    if (typeof raw !== "string") return;
    const trimmed = raw.trim();
    if (trimmed.startsWith("NOT ") || trimmed.startsWith("NOT	")) return;
    if (!trimmed.startsWith("/")) {
      refused += 1;
      return;
    }
    if (!HARVESTED_ROUTE_PATH_PATTERN.test(trimmed)) {
      refused += 1;
      return;
    }
    if (seen.has(trimmed)) return;
    if (routes.length >= MAX_WELL_KNOWN_ROUTES) {
      refused += 1;
      return;
    }
    seen.add(trimmed);
    routes.push({ path: trimmed });
  };
  for (const detail of details) {
    const paths = pick2(detail, "paths");
    if (Array.isArray(paths)) for (const p of paths) consider(p);
    const components = pick2(detail, "components");
    if (Array.isArray(components)) {
      for (const component of components) {
        consider(pick2(component, "/"));
      }
    }
  }
  return { routes, refused };
}
function routeFromSearchTemplate(template2, origin) {
  let url;
  let base;
  try {
    base = new URL(origin);
    url = new URL(template2, origin);
  } catch {
    return void 0;
  }
  if (url.origin !== base.origin) return void 0;
  if (!HARVESTED_ROUTE_PATH_PATTERN.test(url.pathname)) return void 0;
  return { path: url.pathname };
}
function pick2(value, key) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return void 0;
  return value[key];
}

// src/discovery/sitemap-routes.ts
var SITEMAP_ROOT_PATHS = [
  "/wp-sitemap.xml",
  "/sitemap.xml",
  "/sitemap_index.xml"
];
var MAX_SITEMAP_SUBSITEMAPS = 25;
var MAX_SITEMAP_LOCS_PER_DOCUMENT = 5e3;
var MAX_SITEMAP_SEED_PER_GROUP = 250;
var MAX_SITEMAP_SEED_TOTAL = 1e3;
var LOC_PATTERN = /<loc>\s*([^<\s][^<]*?)\s*<\/loc>/gi;
function parseSitemapDocument(xml) {
  const lower = xml.toLowerCase();
  const kind = lower.includes("<sitemapindex") ? "index" : lower.includes("<urlset") ? "urlset" : void 0;
  if (kind === void 0) return void 0;
  const locs = [];
  LOC_PATTERN.lastIndex = 0;
  let match;
  while ((match = LOC_PATTERN.exec(xml)) !== null) {
    if (locs.length >= MAX_SITEMAP_LOCS_PER_DOCUMENT) break;
    const raw = match[1];
    if (raw === void 0) continue;
    locs.push(decodeXmlEntities(raw.trim()));
  }
  return { kind, locs };
}
function decodeXmlEntities(value) {
  return value.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, "&");
}
function sitemapLocOnOrigin(loc, origin) {
  let base;
  let target;
  try {
    base = new URL(origin);
    target = new URL(loc, origin);
  } catch {
    return void 0;
  }
  if (target.protocol !== "http:" && target.protocol !== "https:") return void 0;
  return `${base.origin}${target.pathname}${target.search}`;
}
function selectSitemapSeeds(groups) {
  const selected = [];
  const seen = /* @__PURE__ */ new Set();
  for (let rank3 = 0; rank3 < MAX_SITEMAP_SEED_PER_GROUP; rank3 += 1) {
    for (const group of groups) {
      if (selected.length >= MAX_SITEMAP_SEED_TOTAL) return selected;
      const url = group[rank3];
      if (url === void 0 || seen.has(url)) continue;
      seen.add(url);
      selected.push(url);
    }
  }
  return selected;
}

// src/discovery/content-search.ts
var TRACKING_PARAM = /^(?:utm_[a-z]+|fbclid|gclid|dclid|gbraid|wbraid|msclkid|yclid|ttclid|igshid|mc_cid|mc_eid|_ga|_gl|_hsenc|_hsmi|ref|ref_src|spm)$/i;
function contentSearch(search) {
  const raw = search.startsWith("?") ? search.slice(1) : search;
  if (raw === "" || raw.length > SITE_WALK_MAX_PATH_CHARS) return "";
  let params;
  try {
    params = new URLSearchParams(raw);
  } catch {
    return "";
  }
  const kept = [];
  for (const [key, value] of params) {
    if (key === "" || TRACKING_PARAM.test(key)) continue;
    kept.push([key, value]);
  }
  if (kept.length === 0) return "";
  kept.sort(([a, av], [b, bv]) => a < b ? -1 : a > b ? 1 : av < bv ? -1 : av > bv ? 1 : 0);
  const canonical = new URLSearchParams();
  for (const [key, value] of kept) canonical.append(key, value);
  const out = canonical.toString();
  return out === "" || out.length > SITE_WALK_MAX_PATH_CHARS ? "" : `?${out}`;
}

// src/discovery/dom-state-nearness.ts
var BITS = 64;
var SHINGLE_K = 3;
var MAX_TERM_VECTOR_TOKENS = 96;
var STATE_NEARNESS_STRATEGIES = ["simhash", "cosine"];
function fnv1a64(text) {
  let hash = 0xcbf29ce484222325n;
  const prime = 0x100000001b3n;
  const mask = 0xffffffffffffffffn;
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash ^ BigInt(text.charCodeAt(i))) & mask;
    hash = hash * prime & mask;
  }
  return hash;
}
function simhash64(tokens) {
  if (tokens.length === 0) return "";
  const lowered = tokens.map((t) => t.toLowerCase());
  const shingles = [];
  for (let i = 0; i <= lowered.length - SHINGLE_K; i += 1) {
    shingles.push(lowered.slice(i, i + SHINGLE_K).join(">"));
  }
  if (shingles.length === 0) shingles.push(lowered.join(">"));
  const weights = new Array(BITS).fill(0);
  for (const shingle of shingles) {
    const h = fnv1a64(shingle);
    for (let bit = 0; bit < BITS; bit += 1) {
      weights[bit] = (weights[bit] ?? 0) + (h >> BigInt(bit) & 1n ? 1 : -1);
    }
  }
  let out = 0n;
  for (let bit = 0; bit < BITS; bit += 1) {
    if ((weights[bit] ?? 0) > 0) out |= 1n << BigInt(bit);
  }
  return out.toString(16).padStart(16, "0");
}
function hammingSimilarity64(a, b) {
  if (a === "" || b === "" || a.length !== b.length) return a === b ? 1 : 0;
  let diff;
  try {
    diff = BigInt(`0x${a}`) ^ BigInt(`0x${b}`);
  } catch {
    return 0;
  }
  let bits = 0;
  while (diff > 0n) {
    if (diff & 1n) bits += 1;
    diff >>= 1n;
  }
  return (BITS - bits) / BITS;
}
function termVector(tokens) {
  const counts = /* @__PURE__ */ new Map();
  for (const token of tokens) {
    const key = token.toLowerCase();
    counts.set(key, (counts.get(key) ?? 0) + 1);
  }
  const top = [...counts.entries()].sort((x, y) => y[1] - x[1] || (x[0] < y[0] ? -1 : 1)).slice(0, MAX_TERM_VECTOR_TOKENS);
  return Object.fromEntries(top);
}
function cosineSimilarity(a, b) {
  let dot = 0;
  let magA = 0;
  let magB = 0;
  for (const [term, count6] of Object.entries(a)) {
    magA += count6 * count6;
    const other = b[term];
    if (other !== void 0) dot += count6 * other;
  }
  for (const count6 of Object.values(b)) magB += count6 * count6;
  if (magA === 0 || magB === 0) return magA === magB ? 1 : 0;
  return dot / Math.sqrt(magA * magB);
}
function allowedBits(tokens) {
  if (tokens < 32) return 2;
  if (tokens < 128) return 6;
  if (tokens < 512) return 6;
  return 8;
}
function nearnessThreshold(tokens) {
  return (BITS - allowedBits(tokens)) / BITS;
}
function cosineThreshold(tokens) {
  if (tokens < 128) return 0.999;
  return 0.995;
}

// src/discovery/dom-state.ts
var DOM_STATE_KEPT_ATTRIBUTES = [
  "role",
  "type",
  "name",
  "href",
  "action",
  "method",
  "aria-expanded",
  "aria-selected",
  "aria-checked",
  "aria-pressed",
  "aria-disabled",
  "aria-invalid",
  "aria-current",
  "aria-modal",
  "aria-haspopup",
  "disabled",
  "open",
  "hidden",
  "checked",
  "selected",
  "readonly",
  "required",
  "popover",
  "inert"
];
var DOM_STATE_OPAQUE_TAGS = ["script", "style", "noscript", "template", "svg"];
var DOM_STATE_MAX_TEXT_CHARS = 64;
var DEFAULT_STATE_EQUIVALENCE_THRESHOLD = 30 / 32;
var DOM_STATE_MIN_TOKENS_FOR_NEARNESS = 12;
function normalizeStateText(text) {
  const folded = text.replace(/[\u200B-\u200F\u2060\uFEFF]/g, "").replace(/\p{Nd}+/gu, "#").replace(/\s+/g, " ").trim().toLowerCase();
  return folded.length > DOM_STATE_MAX_TEXT_CHARS ? folded.slice(0, DOM_STATE_MAX_TEXT_CHARS) : folded;
}
function stateToken(node) {
  const byName = new Map(node.attributes.map(([name, value]) => [name.toLowerCase(), value]));
  const attrs = [];
  for (const name of DOM_STATE_KEPT_ATTRIBUTES) {
    const value = byName.get(name);
    if (value === void 0) continue;
    attrs.push(`${name}=${normalizeStateText(value)}`);
  }
  const text = normalizeStateText(node.text);
  return `${node.tag.toLowerCase()}${attrs.length > 0 ? `[${attrs.join(" ")}]` : ""}${text !== "" ? `{${text}}` : ""}`;
}
function projectionDigest(tokens) {
  return {
    exact: stableDigest(tokens.join("\n")),
    simhash: simhash64(tokens),
    terms: termVector(tokens),
    tokens: tokens.length
  };
}
function statesEquivalent(a, b, options = {}) {
  if (a.exact === b.exact) return true;
  if (a.tokens < DOM_STATE_MIN_TOKENS_FOR_NEARNESS || b.tokens < DOM_STATE_MIN_TOKENS_FOR_NEARNESS) {
    return false;
  }
  const size = Math.max(a.tokens, b.tokens);
  const strategy = options.strategy ?? "simhash";
  if (strategy === "cosine") {
    return cosineSimilarity(a.terms, b.terms) >= (options.threshold ?? cosineThreshold(size));
  }
  return hammingSimilarity64(a.simhash, b.simhash) >= (options.threshold ?? nearnessThreshold(size));
}

// src/discovery/dom-state-merge.ts
var MULTIPLICITY_BUCKETS = [1, 2, 3, 5, 9, 17, 33, 65];
function multiplicityBucket(count6) {
  let lower = MULTIPLICITY_BUCKETS[0];
  for (const bound of MULTIPLICITY_BUCKETS) {
    if (count6 >= bound) lower = bound;
  }
  return lower >= 65 ? "65+" : String(lower);
}
function structuralToken(node) {
  return stateToken({ tag: node.tag, attributes: node.attributes, text: "" });
}
function subtreeEnd(nodes, start) {
  const depth = nodes[start]?.depth ?? 0;
  let i = start + 1;
  while (i < nodes.length && (nodes[i]?.depth ?? 0) > depth) i += 1;
  return i;
}
function subtreeSignature(nodes, start, end) {
  const parts = [];
  for (let i = start; i < end; i += 1) {
    const node = nodes[i];
    if (node === void 0) continue;
    parts.push(`${String(node.depth)}:${structuralToken(node)}`);
  }
  return parts.join("|");
}
function mergedProjectionTokens(nodes) {
  const out = [];
  emitRange(nodes, 0, nodes.length, out);
  return out;
}
function emitRange(nodes, from, to, out) {
  let i = from;
  while (i < to) {
    const node = nodes[i];
    if (node === void 0) {
      i += 1;
      continue;
    }
    const end = Math.min(subtreeEnd(nodes, i), to);
    const signature = subtreeSignature(nodes, i, end);
    const depth = node.depth;
    let count6 = 1;
    let cursor = end;
    while (cursor < to && (nodes[cursor]?.depth ?? -1) === depth) {
      const nextEnd = Math.min(subtreeEnd(nodes, cursor), to);
      if (subtreeSignature(nodes, cursor, nextEnd) !== signature) break;
      count6 += 1;
      cursor = nextEnd;
    }
    if (count6 >= 2) {
      out.push(`\xAB${signature}\xBB\xD7${multiplicityBucket(count6)}`);
      i = cursor;
      continue;
    }
    out.push(stateToken(node));
    emitRange(nodes, i + 1, end, out);
    i = end;
  }
}

// src/discovery/content-source-map.ts
var ZERO_WIDTH_SPACE = "\u200B";
var ZERO_WIDTH_NON_JOINER = "\u200C";
var MAX_CONTENT_TYPES = 32;
var MAX_RUN_LENGTH = 32768;
var MAX_RUNS = 64;
function decodeContentTypes(text) {
  const types = /* @__PURE__ */ new Set();
  for (const run of zeroWidthRuns(text)) {
    const payload = decodeRun(run);
    if (payload === void 0) continue;
    const type = readType(payload);
    if (type !== void 0) types.add(type);
    if (types.size >= MAX_CONTENT_TYPES) break;
  }
  return types.size === 0 ? void 0 : [...types].sort().slice(0, MAX_CONTENT_TYPES);
}
function zeroWidthRuns(text) {
  const runs = [];
  let current = "";
  for (const ch of text) {
    if (ch === ZERO_WIDTH_SPACE || ch === ZERO_WIDTH_NON_JOINER) {
      if (current.length < MAX_RUN_LENGTH) current += ch;
      continue;
    }
    if (current !== "") {
      runs.push(current);
      current = "";
      if (runs.length >= MAX_RUNS) return runs;
    }
  }
  if (current !== "") runs.push(current);
  return runs;
}
function decodeRun(run) {
  if (run.length < 8 || run.length % 8 !== 0) return void 0;
  let base64 = "";
  for (let i = 0; i < run.length; i += 8) {
    let byte = 0;
    for (let bit = 0; bit < 8; bit += 1) {
      byte = byte << 1 | (run[i + bit] === ZERO_WIDTH_NON_JOINER ? 1 : 0);
    }
    if (byte < 32 || byte > 126) return void 0;
    base64 += String.fromCharCode(byte);
  }
  let json;
  try {
    json = JSON.parse(fromBase64(base64));
  } catch {
    return void 0;
  }
  if (typeof json !== "object" || json === null || Array.isArray(json)) return void 0;
  return json;
}
function readType(payload) {
  const nested = payload.sanity;
  const source = typeof nested === "object" && nested !== null ? nested : payload;
  const type = source._type;
  if (typeof type !== "string") return void 0;
  const trimmed = type.trim();
  if (trimmed === "" || trimmed.length > 64) return void 0;
  return trimmed;
}
function fromBase64(value) {
  const globalAtob = globalThis.atob;
  const binary = globalAtob !== void 0 ? globalAtob(value) : globalThis.Buffer?.from(value, "base64").toString("binary");
  if (binary === void 0) throw new Error("no base64 decoder in this runtime");
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

// src/discovery/entity-model.ts
var PARAM_SEGMENT = /^(?::.+|\{.+\})$/u;
var ID_FIELD = /^(.*?)[_-]?(?:id|ids)$/iu;
function segmentsOf(path) {
  return path.split("/").filter((s) => s !== "");
}
function segmentRoles(path) {
  return segmentsOf(path).map((s) => PARAM_SEGMENT.test(s) ? "resource" : "collection");
}
function entityKey(name) {
  const lower = name.toLowerCase();
  if (lower.endsWith("ies") && lower.length > 3) return `${lower.slice(0, -3)}y`;
  if (lower.endsWith("ses") && lower.length > 3) return lower.slice(0, -2);
  if (/(?:ss|us|is)$/u.test(lower)) return lower;
  if (lower.endsWith("s") && lower.length > 1) return lower.slice(0, -1);
  return lower;
}
function inferEntityModel(paths, fieldsByPath = {}) {
  const observedCollections = /* @__PURE__ */ new Set();
  const observedResources = /* @__PURE__ */ new Set();
  const implied = /* @__PURE__ */ new Map();
  for (const path of paths) {
    const segments = segmentsOf(path);
    const roles = segmentRoles(path);
    let prefix = "";
    let parent = null;
    for (const [i, segment] of segments.entries()) {
      if (roles[i] === "resource") {
        if (i === segments.length - 1) observedResources.add(prefix);
        prefix = `${prefix}/${segment}`;
        continue;
      }
      const collectionPath = `${prefix}/${segment}`;
      if (!implied.has(collectionPath)) {
        implied.set(collectionPath, { name: segment, children: /* @__PURE__ */ new Set() });
      }
      if (parent !== null) implied.get(parent)?.children.add(segment);
      if (i === segments.length - 1) observedCollections.add(collectionPath);
      parent = collectionPath;
      prefix = collectionPath;
    }
  }
  const entities = [...implied.entries()].map(([collectionPath, node]) => ({
    name: node.name,
    collectionPath,
    collectionObserved: observedCollections.has(collectionPath),
    resourceObserved: observedResources.has(collectionPath),
    // Zalando — suspect when this entity's own collection route was never
    // observed AND it is not the root of the hierarchy, so the grammar
    // produced it from a deeper path alone.
    suspect: !observedCollections.has(collectionPath) && !observedResources.has(collectionPath),
    children: [...node.children].sort()
  })).sort((a, b) => a.collectionPath < b.collectionPath ? -1 : 1);
  const known = new Set(entities.map((e) => entityKey(e.name)));
  const links = [];
  for (const [path, fields] of Object.entries(fieldsByPath)) {
    for (const field of fields) {
      const match = ID_FIELD.exec(field);
      const stem = match?.[1] ?? "";
      if (stem === "") continue;
      links.push({
        path,
        field,
        entity: stem,
        verdict: known.has(entityKey(stem)) ? "confirmed" : "refuted"
      });
    }
  }
  links.sort((a, b) => a.path + a.field < b.path + b.field ? -1 : 1);
  return { entities, links };
}

// src/discovery/journey-synthesis.ts
var MAX_JOURNEY_DEPTH = 6;
var MAX_JOURNEYS = 25;
var MAX_JOURNEY_NODES = 500;
function synthesiseJourneys(edges, options = {}) {
  const maxDepth = options.maxDepth ?? MAX_JOURNEY_DEPTH;
  const maxJourneys = options.maxJourneys ?? MAX_JOURNEYS;
  const truncated = /* @__PURE__ */ new Set();
  const outgoing = /* @__PURE__ */ new Map();
  const hasIncoming = /* @__PURE__ */ new Set();
  const nodes = /* @__PURE__ */ new Set();
  for (const edge of edges) {
    if (edge.from === "" || edge.to === "" || edge.from === edge.to) continue;
    if (nodes.size >= MAX_JOURNEY_NODES && !nodes.has(edge.from)) {
      truncated.add("nodes");
      continue;
    }
    nodes.add(edge.from);
    nodes.add(edge.to);
    const set2 = outgoing.get(edge.from) ?? /* @__PURE__ */ new Set();
    set2.add(edge.to);
    outgoing.set(edge.from, set2);
    hasIncoming.add(edge.to);
  }
  const entries = [...nodes].filter((n) => !hasIncoming.has(n)).sort().map((route) => ({ route, entry: "unlinked" }));
  if (options.landing !== void 0 && nodes.has(options.landing) && hasIncoming.has(options.landing)) {
    entries.push({ route: options.landing, entry: "landing" });
  }
  const journeys = [];
  const walkFrom = (start, entry) => {
    const stack = [start];
    const visit = (node) => {
      if (journeys.length >= maxJourneys) {
        truncated.add("journeys");
        return;
      }
      const next = [...outgoing.get(node) ?? []].sort().filter((n) => !stack.includes(n));
      if (stack.length >= maxDepth) {
        if (next.length > 0) truncated.add("depth");
        if (stack.length > 1) journeys.push({ routes: [...stack], entry });
        return;
      }
      if (next.length === 0) {
        if (stack.length > 1) journeys.push({ routes: [...stack], entry });
        return;
      }
      for (const child of next) {
        stack.push(child);
        visit(child);
        stack.pop();
      }
    };
    visit(start);
  };
  for (const { route, entry } of entries) {
    if (journeys.length >= maxJourneys) {
      truncated.add("journeys");
      break;
    }
    walkFrom(route, entry);
  }
  return {
    // Longest first: a journey crossing four pages says more about the site than
    // one crossing two, and an operator reading a CAPPED list should be shown
    // the informative ones. Ties keep their deterministic route order.
    journeys: [...journeys].sort(
      (a, b) => b.routes.length - a.routes.length || (a.routes.join(" ") < b.routes.join(" ") ? -1 : 1)
    ),
    truncated: [...truncated].sort(),
    routeCount: nodes.size
  };
}

// src/discovery/system-model.ts
var SYSTEM_RELATIONS = ["partOf", "dependsOn", "callsEndpoint", "operatesOn"];
var CLAIM_SIGNALS = [
  "route-grammar",
  "link-graph",
  "observed-traffic",
  "field-names"
];
var MIN_PROPOSED_AREAS = 8;
var MAX_PROPOSED_AREAS = 12;
function composeSystemModel(input) {
  const entities = inferEntityModel(input.paths, input.fieldsByPath ?? {});
  const journeys = synthesiseJourneys(input.edges ?? []);
  const topLevel = entities.entities.filter((e) => e.collectionPath.split("/").length === 2);
  const operationsFor = (collectionPath) => input.paths.filter((p) => p === collectionPath || p.startsWith(`${collectionPath}/`)).length;
  const ranked = [...topLevel].map((e) => ({
    name: e.name,
    path: e.collectionPath,
    operations: operationsFor(e.collectionPath),
    confirmed: false
  })).sort((a, b) => b.operations - a.operations || (a.path < b.path ? -1 : 1));
  const areas = ranked.slice(0, MAX_PROPOSED_AREAS);
  const deepest = entities.entities.reduce(
    (max, e) => Math.max(max, e.collectionPath.split("/").length - 1),
    0
  );
  const claims = [
    { kind: "entity-count", value: entities.entities.length, derivedFrom: ["route-grammar"] },
    { kind: "nesting-depth", value: deepest, derivedFrom: ["route-grammar"] },
    {
      kind: "unverified-entities",
      value: entities.entities.filter((e) => e.suspect).length,
      derivedFrom: ["route-grammar"]
    },
    {
      kind: "refuted-links",
      value: entities.links.filter((l) => l.verdict === "refuted").length,
      derivedFrom: ["field-names", "route-grammar"]
    },
    {
      kind: "journey-reach",
      value: journeys.journeys.length,
      derivedFrom: ["link-graph"]
    },
    {
      kind: "write-surface",
      value: input.writeOperations ?? 0,
      derivedFrom: ["observed-traffic"]
    }
  ];
  return {
    areas,
    areasTruncated: ranked.length > areas.length,
    entities,
    journeys,
    claims
  };
}

// src/discovery/comprehension.ts
var COMPREHENSION_EVIDENCE = [
  "accessible-name",
  "section-heading",
  "sibling-labels",
  "reveals",
  "endpoint",
  "request-schema",
  "response-schema"
];
var MAX_COMPREHENSION_NAME = 80;
var MAX_COMPREHENSION_DESCRIPTION = 200;
function availableEvidence(bundle) {
  const out = [];
  if (bundle.accessibleName !== "") out.push("accessible-name");
  if (bundle.sectionHeading !== void 0 && bundle.sectionHeading !== "") {
    out.push("section-heading");
  }
  if (bundle.siblingLabels !== void 0 && bundle.siblingLabels.length > 0) {
    out.push("sibling-labels");
  }
  if (bundle.reveals !== void 0 && bundle.reveals.length > 0) out.push("reveals");
  if (bundle.endpoint !== void 0) out.push("endpoint");
  if (bundle.requestFields !== void 0 && bundle.requestFields.length > 0) {
    out.push("request-schema");
  }
  if (bundle.responseFields !== void 0 && bundle.responseFields.length > 0) {
    out.push("response-schema");
  }
  return out;
}
function screenComprehensionProposal(proposal, bundle) {
  if (proposal.controlId !== bundle.controlId) return { ok: false, reason: "wrong-control" };
  if (proposal.name === "" || proposal.group === "" || proposal.description === "") {
    return { ok: false, reason: "empty-field" };
  }
  if (proposal.name.length > MAX_COMPREHENSION_NAME || proposal.group.length > MAX_COMPREHENSION_NAME || proposal.description.length > MAX_COMPREHENSION_DESCRIPTION) {
    return { ok: false, reason: "over-length" };
  }
  if (!Number.isFinite(proposal.confidence) || proposal.confidence < 0 || proposal.confidence > 1) {
    return { ok: false, reason: "confidence-out-of-range" };
  }
  if (proposal.evidence.length === 0) return { ok: false, reason: "no-evidence" };
  const available = new Set(availableEvidence(bundle));
  if (proposal.evidence.some((e) => !available.has(e))) {
    return { ok: false, reason: "unavailable-evidence" };
  }
  return { ok: true };
}
function screenComprehensionCorrection(correction) {
  for (const value of [correction.name, correction.group, correction.description]) {
    if (value !== null && value.trim() === "") return { ok: false, reason: "empty-field" };
  }
  if (correction.name !== null && correction.name.length > MAX_COMPREHENSION_NAME || correction.group !== null && correction.group.length > MAX_COMPREHENSION_NAME || correction.description !== null && correction.description.length > MAX_COMPREHENSION_DESCRIPTION) {
    return { ok: false, reason: "over-length" };
  }
  return { ok: true };
}

// src/discovery/comprehension-localized-prompt.ts
var LOCALIZED_COMPREHENSION_TOOL_NAME = "comprehend_controls_localized";
function buildLocalizedComprehensionPrompt(input) {
  const languages = SUPPORTED_LOCALES.map(
    (l) => `${l.code} \u2014 ${l.displayName} (${l.nativeName})`
  ).join("; ");
  const subject = input.subject ?? "control";
  const framing = subject === "capability" ? [
    `You are explaining the API operations (capabilities) a web product exposes to the people who run it and the people who use it.`,
    `Call the \`${LOCALIZED_COMPREHENSION_TOOL_NAME}\` tool exactly once, with one proposal per capability below.`,
    ``,
    `The developer's own name for a capability is often unhelpful ("orders.x1", "POST /v2/op").`,
    `Read the EVIDENCE around it instead \u2014 the area it belongs to, the operations beside it,`,
    `the request it makes and the field names of that request.`
  ] : [
    `You are explaining the controls of a web product to the people who run it and the people who use it.`,
    `Call the \`${LOCALIZED_COMPREHENSION_TOOL_NAME}\` tool exactly once, with one proposal per control below.`,
    ``,
    `The developer's own name for a control is often unhelpful ("handleOpen", "btn-2").`,
    `Read the EVIDENCE around it instead \u2014 the section it sits in, the controls beside it,`,
    `what it reveals, the request it makes and the field names of that request.`
  ];
  return [
    ...framing,
    ``,
    `Write each proposal's \`text\` natively in every one of these languages, keyed by locale code: ${languages}.`,
    `Natural, fluent copy a reader of that language would recognise \u2014 never a transliteration, never the English`,
    `repeated. Keep \`controlId\` exactly as given: it is a machine identifier.`,
    `In \`evidence\`, cite the bracketed ids of the lines you actually used \u2014 \`[accessible-name]\`, \`[endpoint]\` and so on \u2014`,
    `and only lines that appear under that control. A line it does not have is evidence it does not have; citing one is refused.`,
    ``,
    `Never say what a control is SAFE or DANGEROUS to do. That is decided elsewhere,`,
    `from what the control actually fires, and nothing you write can change it.`,
    ``,
    ...input.bundles.flatMap((b) => renderBundle(b, subject))
  ].join("\n");
}
function renderBundle(bundle, subject) {
  const lines = [
    `${subject === "capability" ? "Capability" : "Control"} ${bundle.controlId}`
  ];
  if (bundle.accessibleName !== "") {
    lines.push(`  [accessible-name] Its own name:  ${bundle.accessibleName}`);
  }
  if (bundle.sectionHeading !== void 0 && bundle.sectionHeading !== "") {
    lines.push(`  [section-heading] In section:    ${bundle.sectionHeading}`);
  }
  if (bundle.siblingLabels !== void 0 && bundle.siblingLabels.length > 0) {
    lines.push(`  [sibling-labels] Beside:        ${bundle.siblingLabels.join(", ")}`);
  }
  if (bundle.reveals !== void 0 && bundle.reveals.length > 0) {
    lines.push(`  [reveals] Reveals:       ${bundle.reveals.join(", ")}`);
  }
  if (bundle.endpoint !== void 0) {
    lines.push(`  [endpoint] Requests:      ${bundle.endpoint.method} ${bundle.endpoint.path}`);
  }
  if (bundle.requestFields !== void 0 && bundle.requestFields.length > 0) {
    lines.push(`  [request-schema] Sending:       ${bundle.requestFields.join(", ")}`);
  }
  if (bundle.responseFields !== void 0 && bundle.responseFields.length > 0) {
    lines.push(`  [response-schema] Receiving:     ${bundle.responseFields.join(", ")}`);
  }
  if (bundle.refusals !== void 0) {
    const { refusalCount, refusesFields } = bundle.refusals;
    const fields = refusesFields.length > 0 ? ` on ${refusesFields.join(", ")}` : "";
    lines.push(`  Refuses:       ${refusalCount} way(s)${fields}`);
  }
  lines.push("");
  return lines;
}

// src/discovery/comprehension-script.ts
var OWN_SCRIPT = {
  en: /\p{Script=Latin}/u,
  es: /\p{Script=Latin}/u,
  fr: /\p{Script=Latin}/u,
  de: /\p{Script=Latin}/u,
  ar: /[\p{Script=Arabic}\p{Script=Latin}]/u,
  he: /[\p{Script=Hebrew}\p{Script=Latin}]/u
};
var LETTER = /\p{L}/u;
function hasForeignScript(locale, text) {
  const own = OWN_SCRIPT[locale];
  for (const ch of text) {
    if (!LETTER.test(ch)) continue;
    if (!own.test(ch)) return true;
  }
  return false;
}

// src/discovery/comprehension-localized.ts
var MAX_LOCALIZED_COMPREHENSION_BATCH = 12;
var COMPREHENSION_LOCALES = SUPPORTED_LOCALES.map((l) => l.code);
var TEXT_JSON_SCHEMA = {
  type: "object",
  properties: {
    name: {
      type: "string",
      maxLength: MAX_COMPREHENSION_NAME,
      description: 'What a person would call this control in this language \u2014 "Refund an order", never "handleOpen".'
    },
    group: {
      type: "string",
      maxLength: MAX_COMPREHENSION_NAME,
      description: "The human area it belongs to, as a noun in this language: Billing, Orders, Settings."
    },
    description: {
      type: "string",
      maxLength: MAX_COMPREHENSION_DESCRIPTION,
      description: "One line, in this language, on what using it does."
    }
  },
  required: ["name", "group", "description"],
  additionalProperties: false
};
function localeProperties() {
  const out = {};
  for (const code of COMPREHENSION_LOCALES) out[code] = TEXT_JSON_SCHEMA;
  return out;
}
var localizedComprehensionToolJsonSchema = {
  name: LOCALIZED_COMPREHENSION_TOOL_NAME,
  description: "Explain a batch of discovered UI controls in plain language, in every listed language, from the evidence given.",
  input_schema: {
    type: "object",
    properties: {
      proposals: {
        type: "array",
        maxItems: MAX_LOCALIZED_COMPREHENSION_BATCH,
        items: {
          type: "object",
          properties: {
            controlId: {
              type: "string",
              description: "Echo the id of the control this proposal is about, exactly."
            },
            confidence: {
              type: "number",
              minimum: 0,
              maximum: 1,
              description: "How sure you are, 0\u20131, about this control as a whole. Shown to the operator, so be honest."
            },
            evidence: {
              type: "array",
              minItems: 1,
              items: { type: "string", enum: [...COMPREHENSION_EVIDENCE] },
              description: "Which of the listed evidence you actually used. Naming evidence that was not given is refused."
            },
            text: {
              type: "object",
              description: "The same proposal written natively in each language, keyed by locale code.",
              properties: localeProperties(),
              required: [...COMPREHENSION_LOCALES],
              additionalProperties: false
            }
          },
          required: ["controlId", "confidence", "evidence", "text"],
          additionalProperties: false
        }
      }
    },
    required: ["proposals"],
    additionalProperties: false
  }
};
var textSchema = /* @__PURE__ */ z.object({
  name: z.string().min(1).max(MAX_COMPREHENSION_NAME),
  group: z.string().min(1).max(MAX_COMPREHENSION_NAME),
  description: z.string().min(1).max(MAX_COMPREHENSION_DESCRIPTION)
});
var localizedComprehensionResponseSchema = /* @__PURE__ */ z.object({
  proposals: z.array(
    z.object({
      controlId: z.string().min(1),
      confidence: z.number().min(0).max(1),
      evidence: z.array(z.enum(COMPREHENSION_EVIDENCE)).min(1),
      text: z.object({
        en: textSchema,
        es: textSchema,
        fr: textSchema,
        de: textSchema,
        ar: textSchema,
        he: textSchema
      })
    })
  ).max(MAX_LOCALIZED_COMPREHENSION_BATCH)
});
function screenLocalizedComprehensionProposal(proposal, bundle) {
  for (const locale of COMPREHENSION_LOCALES) {
    const text = proposal.text[locale];
    if (hasForeignScript(locale, text.name) || hasForeignScript(locale, text.group)) {
      return { ok: false, reason: "foreign-script", locale };
    }
    const screened = screenComprehensionProposal(
      {
        controlId: proposal.controlId,
        name: text.name,
        group: text.group,
        description: text.description,
        confidence: proposal.confidence,
        evidence: proposal.evidence
      },
      bundle
    );
    if (screened.ok) continue;
    const perLocale = screened.reason === "empty-field" || screened.reason === "over-length" || screened.reason === "foreign-script";
    return perLocale ? { ok: false, reason: screened.reason, locale } : { ok: false, reason: screened.reason };
  }
  return { ok: true };
}
var MAX_ICON_CROP_SIDE_PX = 64;
var MAX_ICON_CROP_BYTES = 12e3;
var MAX_ICON_CROPS_PER_REQUEST = 16;
var MAX_ICON_CROPS_PER_RUN = 120;
var MAX_ICON_CROP_NAME_GRAPHEMES = 48;
var ICON_CROP_EVIDENCE_KINDS = [
  "opened-a-dialog",
  "opened-a-menu",
  "revealed-a-section",
  "navigated",
  "fired-an-endpoint",
  "submitted-a-form",
  "changed-nothing-visible"
];
var ICON_CROP_REFUSALS = [
  /** The naming ladder already answered; the crop is for the residual only. */
  "has-accessible-name",
  /** The box contains a rendered text node. The privacy rule, and the commonest refusal. */
  "contains-text",
  /**
   * Part of the box is inside a shadow root we cannot read — a closed root, or a
   * custom element that has not upgraded — so the no-text rule cannot be
   * ESTABLISHED. A camera sees through a shadow boundary and a `TreeWalker` does
   * not, so "found no text" there means "looked in the wrong place".
   */
  "shadow-content",
  /**
   * Part of the box is inside a subtree the operator MASKED (`blockSelectors`).
   * The mask says "never read, never serialise"; a camera would do both, so a
   * masked control is refused rather than photographed around.
   */
  "masked",
  /** No readable `<svg>`/`<img>`/`<canvas>` inside — a CSS background cannot be read honestly. */
  "not-drawn",
  /** Bigger than an icon. A control this size is a panel, and a panel carries content. */
  "too-large",
  /** Not rendered, or zero-sized. */
  "not-visible",
  /** Every sampled pixel identical — a picture of nothing. */
  "blank",
  /** The browser refused the pixel read (a tainted canvas, a cross-origin image). */
  "unreadable",
  /** Over the per-request or per-run cap. */
  "over-cap"
];
var MAX_ICON_CROP_BASE64_CHARS = Math.ceil(MAX_ICON_CROP_BYTES / 3) * 4 + 4;
var ICON_CROP_ENDPOINT_METHODS = [
  "GET",
  "HEAD",
  "POST",
  "PUT",
  "PATCH",
  "DELETE"
];
var IconCropEvidenceSchema = /* @__PURE__ */ z.object({
  kinds: z.array(z.enum(ICON_CROP_EVIDENCE_KINDS)).min(1).max(ICON_CROP_EVIDENCE_KINDS.length),
  /**
   * The templated route the control's request took, e.g.
   * `POST /api/orders/{id}/refund`. Both halves reach the prompt, so both
   * carry a closed grammar rather than a length cap (rule 5): the verbs, and
   * a route-template charset with no whitespace, quotes or newlines — the
   * characters an injected instruction needs to read as one.
   */
  endpoint: z.object({
    method: z.enum(ICON_CROP_ENDPOINT_METHODS),
    path: z.string().min(1).max(200).regex(/^[A-Za-z0-9/_.:{}~%@+-]+$/u)
  }).strict().optional()
}).strict();
var IconCropSchema = /* @__PURE__ */ z.object({
  /**
   * The durable `uic_` signature the name will be filed against — refused
   * against the SAME grammar every other control-signature field uses, both
   * because it reaches the prompt (rule 5) and because a fourth copy of that
   * pattern would be the one that drifts.
   */
  controlId: z.string().regex(RUNTIME_UI_SIGNATURE_PATTERN),
  mediaType: z.literal("image/png"),
  width: z.number().int().min(1).max(MAX_ICON_CROP_SIDE_PX),
  height: z.number().int().min(1).max(MAX_ICON_CROP_SIDE_PX),
  /**
   * The widget's declaration that the box carried NO rendered text. A literal
   * `true`, so the field cannot express the other answer: a producer that
   * stopped screening cannot send a crop at all (rule 2 in the header).
   */
  textFree: z.literal(true),
  evidence: IconCropEvidenceSchema,
  data: z.string().min(1).max(MAX_ICON_CROP_BASE64_CHARS).regex(/^[A-Za-z0-9+/]+={0,2}$/u)
}).strict();
var IconCropRequestSchema = /* @__PURE__ */ z.object({
  sessionId: z.string().uuid(),
  crops: z.array(IconCropSchema).min(1).max(MAX_ICON_CROPS_PER_REQUEST),
  /** Per-reason counts of what was NOT sent. Counts only — never an id. */
  refused: z.record(z.enum(ICON_CROP_REFUSALS), z.number().int().nonnegative()).optional()
}).strict();
var IconCropNameSchema = /* @__PURE__ */ z.object({
  controlId: z.string().regex(RUNTIME_UI_SIGNATURE_PATTERN),
  name: z.string().min(1).max(MAX_ICON_CROP_NAME_GRAPHEMES * 4),
  confidence: z.number().min(0).max(1)
}).strict();
var IconCropResponseSchema = /* @__PURE__ */ z.object({
  names: z.array(IconCropNameSchema).max(MAX_ICON_CROPS_PER_REQUEST),
  /** Answers the SERVER refused — an unknown crop, a value-shaped name. A COUNT. */
  refused: z.number().int().nonnegative(),
  /**
   * Whether a model was asked AT ALL. `false` is the answer to a workspace
   * that has not opted in, and it is a distinct state from "asked and got
   * nothing" — the two look identical in `names` and mean opposite things to
   * an operator reading the run page.
   */
  asked: z.boolean()
}).strict();

// src/discovery/form-refusals.ts
var MAX_REFUSAL_MESSAGES = 12;
var MAX_REFUSAL_MESSAGE_GRAPHEMES = 200;
var MAX_REFUSAL_INVALID_FIELDS = 24;
function screenFormRefusals(row2) {
  const messages = [];
  const seen = /* @__PURE__ */ new Set();
  for (const raw of row2.messages) {
    const clean = capGraphemes(
      sanitizeToolText(redactSecrets(raw)).replace(/\s+/gu, " ").trim(),
      MAX_REFUSAL_MESSAGE_GRAPHEMES
    );
    if (clean === "" || seen.has(clean)) continue;
    seen.add(clean);
    messages.push(clean);
    if (messages.length >= MAX_REFUSAL_MESSAGES) break;
  }
  const invalidFields = [
    ...new Set(row2.invalidFields.map((f) => sanitizeToolText(f).trim()).filter((f) => f !== ""))
  ].sort().slice(0, MAX_REFUSAL_INVALID_FIELDS);
  return { ...row2, messages, invalidFields };
}
function refusalEvidenceOf(row2) {
  if (row2 === void 0) return null;
  const screened = screenFormRefusals(row2);
  if (screened.messages.length === 0 && screened.invalidFields.length === 0) return null;
  return { refusalCount: screened.messages.length, refusesFields: screened.invalidFields };
}
function refusalSentence(row2) {
  const screened = screenFormRefusals(row2);
  return screened.messages.join(" \xB7 ");
}
function refusalMessageCost(message) {
  return countGraphemes(message);
}

// src/discovery/suggested-questions.ts
var SUGGESTED_QUESTION_COUNT = 3;
var MAX_SUGGESTED_QUESTION_GRAPHEMES = 120;
var MAX_SUGGESTED_TERM_GRAPHEMES = 60;
var QUOTES = {
  en: ["\u201C", "\u201D"],
  es: ["\xAB", "\xBB"],
  // French guillemets take a NO-BREAK space, written as an escape so the
  // character is visible in the source: a plain space would let the closing
  // guillemet wrap onto the next line, which is the reason these pairs are
  // per-locale at all rather than one shared pair.
  fr: ["\xAB\xA0", "\xA0\xBB"],
  de: ["\u201E", "\u201C"],
  ar: ["\xAB", "\xBB"],
  he: ['"', '"']
};
var TEMPLATES = {
  capability: {
    en: "Can you help me with {term}?",
    es: "\xBFPuedes ayudarme con {term}?",
    fr: "Peux-tu m\u2019aider avec {term} ?",
    de: "Kannst du mir mit {term} helfen?",
    ar: "\u0647\u0644 \u064A\u0645\u0643\u0646\u0643 \u0645\u0633\u0627\u0639\u062F\u062A\u064A \u0641\u064A {term}\u061F",
    he: "\u05D0\u05EA\u05D4 \u05D9\u05DB\u05D5\u05DC \u05DC\u05E2\u05D6\u05D5\u05E8 \u05DC\u05D9 \u05E2\u05DD {term}?"
  },
  page: {
    en: "Take me to {term}.",
    es: "Ll\xE9vame a {term}.",
    fr: "Emm\xE8ne-moi \xE0 {term}.",
    de: "Bring mich zu {term}.",
    ar: "\u062E\u0630\u0646\u064A \u0625\u0644\u0649 {term}.",
    he: "\u05E7\u05D7 \u05D0\u05D5\u05EA\u05D9 \u05D0\u05DC {term}."
  },
  group: {
    en: "What can I do in {term}?",
    es: "\xBFQu\xE9 puedo hacer en {term}?",
    fr: "Que puis-je faire dans {term} ?",
    de: "Was kann ich in {term} tun?",
    ar: "\u0645\u0627\u0630\u0627 \u064A\u0645\u0643\u0646\u0646\u064A \u0623\u0646 \u0623\u0641\u0639\u0644 \u0641\u064A {term}\u061F",
    he: "\u05DE\u05D4 \u05D0\u05E0\u05D9 \u05D9\u05DB\u05D5\u05DC \u05DC\u05E2\u05E9\u05D5\u05EA \u05D1{term}?"
  }
};
function quotedTerm(raw, locale) {
  const clean = capGraphemes(
    sanitizeToolText(raw).replace(/\s+/gu, " ").trim(),
    MAX_SUGGESTED_TERM_GRAPHEMES
  );
  if (clean === "") return null;
  const [open, close] = QUOTES[locale];
  return `${open}${clean}${close}`;
}
function suggestedQuestion(candidate, locale) {
  const term = quotedTerm(candidate.term, locale);
  if (term === null) return null;
  return capGraphemes(
    TEMPLATES[candidate.kind][locale].replace("{term}", term),
    MAX_SUGGESTED_QUESTION_GRAPHEMES
  );
}
function suggestedQuestions(candidates, locale, limit = SUGGESTED_QUESTION_COUNT) {
  const ranked = [...candidates].sort(
    (a, b) => b.confidence - a.confidence || a.id.localeCompare(b.id)
  );
  const taken = [];
  const usedKinds = /* @__PURE__ */ new Set();
  for (const candidate of ranked) {
    if (taken.length >= limit) break;
    if (usedKinds.has(candidate.kind)) continue;
    usedKinds.add(candidate.kind);
    taken.push(candidate);
  }
  for (const candidate of ranked) {
    if (taken.length >= limit) break;
    if (taken.includes(candidate)) continue;
    taken.push(candidate);
  }
  const questions = [];
  const seen = /* @__PURE__ */ new Set();
  for (const candidate of taken) {
    const question = suggestedQuestion(candidate, locale);
    if (question === null || seen.has(question)) continue;
    seen.add(question);
    questions.push(question);
  }
  return questions;
}

// src/discovery/manual-findings.ts
var MANUAL_PAGE_TYPES = [
  "index",
  "detail",
  "create",
  "edit",
  "checkout",
  "wizard",
  "settings",
  "auth",
  "unknown"
];
var MANUAL_FINDINGS = [
  /**
   * Part of the page is DRAWN and publishes no accessibility semantics — a
   * Flutter canvas with no mirror, a `<canvas>` with no fallback content, a
   * `role="application"` subtree that owns no children. The agent cannot read
   * it, and neither could a screen reader.
   */
  "painted-no-semantics"
];
function isClassifiedPageType(type) {
  return type !== void 0 && type !== "unknown";
}
function pageTypeGroup(type) {
  if (!isClassifiedPageType(type) || type === void 0) return null;
  return `page-type:${type}`;
}
function normalizeFindings(findings) {
  if (findings === void 0 || findings.length === 0) return [];
  const known = new Set(MANUAL_FINDINGS);
  return [...new Set(findings.filter((f) => known.has(f)))].sort();
}

// src/discovery/graphql-schema-document.ts
var FULL_INTROSPECTION_QUERY = "query IntrospectionQuery { __schema { queryType { name kind } mutationType { name kind } subscriptionType { name kind } types { ...FullType } directives { name description locations args { ...InputValue } } } } fragment FullType on __Type { kind name description fields(includeDeprecated: true) { name description args { ...InputValue } type { ...TypeRef } isDeprecated deprecationReason } inputFields { ...InputValue } interfaces { ...TypeRef } enumValues(includeDeprecated: true) { name description isDeprecated deprecationReason } possibleTypes { ...TypeRef } } fragment InputValue on __InputValue { name description type { ...TypeRef } defaultValue } fragment TypeRef on __Type { kind name ofType { name kind ofType { name kind ofType { name kind ofType { name kind ofType { name kind ofType { name kind ofType { name kind ofType { name kind ofType { name kind } } } } } } } } } }";
var MAX_INTROSPECTABLE_TYPES = 800;
function introspectableSurface(fact) {
  return fact.types <= MAX_INTROSPECTABLE_TYPES;
}
function readIntrospectionSchemaDocument(body) {
  const data = pick3(body, "data");
  const schema = pick3(data, "__schema");
  if (typeof schema !== "object" || schema === null || Array.isArray(schema)) return void 0;
  const node = schema;
  const queryType = node.queryType;
  if (typeof queryType !== "object" || queryType === null) return void 0;
  const types = node.types;
  if (!Array.isArray(types) || types.length === 0) return void 0;
  return { __schema: node };
}
function pick3(value, key) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return void 0;
  return value[key];
}

// src/discovery/served-spec-declaration.ts
var MAX_SPEC_VERSION_CHARS = 32;
var MAX_YAML_DECLARATION_LINES = 40;
var DECLARED_KINDS = [
  ["openapi", "openapi"],
  ["swagger", "swagger"],
  ["asyncapi", "asyncapi"]
];
function readJsonSpecDeclaration(body) {
  if (typeof body !== "object" || body === null || Array.isArray(body)) return void 0;
  const doc = body;
  for (const [key, kind] of DECLARED_KINDS) {
    if (!(key in doc)) continue;
    const declared = doc[key];
    return typeof declared === "string" && declared !== "" ? { kind, version: declared.slice(0, MAX_SPEC_VERSION_CHARS) } : { kind };
  }
  return void 0;
}
function readYamlSpecDeclaration(text) {
  let scanned = 0;
  for (const rawLine of text.split("\n")) {
    if (scanned >= MAX_YAML_DECLARATION_LINES) return void 0;
    const line = rawLine.replace(/\r$/, "");
    if (line.trim() === "" || line.startsWith("#") || line.trim() === "---") continue;
    if (/^\s/.test(line) || line.startsWith("- ")) continue;
    scanned += 1;
    const match = /^([A-Za-z]+):(.*)$/.exec(line);
    if (match === null) return void 0;
    const key = match[1]?.toLowerCase() ?? "";
    const found = DECLARED_KINDS.find(([k]) => k === key);
    if (found === void 0) continue;
    const version = (match[2] ?? "").split("#")[0]?.trim().replace(/^['"]|['"]$/g, "");
    return version === void 0 || version === "" ? { kind: found[1] } : { kind: found[1], version: version.slice(0, MAX_SPEC_VERSION_CHARS) };
  }
  return void 0;
}

// src/observability/exec-metric-values.ts
var EXEC_METRIC_IDS = [
  "live",
  "coverage",
  "satisfaction",
  "latency",
  "toolErrors",
  "drift",
  "permissions",
  "needsAttention"
];
function execMetricRawValues(snapshot, external = {}) {
  const { live, coverage, feedback, toolErrorRate, drift, permissionFailures } = snapshot;
  const coverageMeasurable = coverage.available && (coverage.unmeasurable ?? null) === null;
  const toolTotal = toolErrorRate.rows.reduce((sum, r) => sum + r.total, 0);
  const toolErrors = toolErrorRate.rows.reduce((sum, r) => sum + r.errors, 0);
  return {
    live: live.available ? live.totalCount : null,
    coverage: coverageMeasurable ? coverage.coverageRate : null,
    satisfaction: feedback.available && feedback.total >= SATISFACTION_MIN_RATINGS ? feedback.satisfactionRate : null,
    latency: (external.latencySampleCount ?? 0) >= LATENCY_MIN_SAMPLES ? external.latencyMs ?? null : null,
    toolErrors: toolTotal >= TOOL_ERROR_MIN_CALLS ? toolErrors / toolTotal : null,
    drift: drift.available ? drift.criticalCount : null,
    // The permission store is always wired, so an empty log is a REAL zero.
    permissions: permissionFailures.rows.filter((r) => r.suggestsReview).length,
    needsAttention: external.needsAttention ?? null
  };
}
var WINDOW_SCOPED_EXEC_METRICS = [
  "toolErrors",
  "permissions",
  "latency",
  "needsAttention"
];
function isWindowScopedExecMetric(id) {
  return WINDOW_SCOPED_EXEC_METRICS.includes(id);
}

// src/observability/modality-alarm-fields.ts
var READ_ONLY_BIAS = "read_only";
var MODALITY_ALARM_FIELDS = {
  /** On the `MODALITY_TRACE_LOG` payload (`ModalityTrace`). */
  trace: {
    /**
     * `'stream'` | `'resume'`. The detector counts stream legs only: a resume leg
     * exists BECAUSE a tool was already called, so including it would measure
     * acting-by-definition and inflate the rate.
     */
    leg: "leg",
    /**
     * Zero means the turn made no tool call at all. Read instead of `sequence`
     * because the trace sets `sequence: ['text']` precisely WHEN this is zero —
     * the same fact, without depending on CloudWatch's array-matching semantics.
     */
    toolCallCount: "toolCallCount",
    /** Classifier drift: a tool shipped without being mapped. Counted, never alarmed. */
    unclassifiedCount: "unclassifiedCount",
    /** There was something to call at all. */
    catalog: "surface.catalog",
    /** The workspace has not asked the agent to stop acting. */
    executionBias: "surface.executionBias",
    /** `search_capabilities` was reachable, so a rescue was possible. */
    disclosureLadder: "surface.disclosureLadder",
    /**
     * The NEXT STEPS contract applied to this turn — the dead-end DENOMINATOR.
     *
     * Excludes an empty answer (a capped or aborted turn) and a short reply from
     * a turn that did no work (a greeting), so the rate is not dominated by
     * turns that correctly offered nothing.
     */
    nextStepsOwed: "nextStepsOwed",
    /**
     * Calls that left the visitor something to see or tap. Zero is half the
     * dead-end condition, and is NOT the same as `toolCallCount = 0`: fetching
     * and changing data are real work that renders nothing, which is exactly the
     * shape of the turn this detector was built from.
     */
    affordanceCount: "affordanceCount",
    /** The answer materialized chips through the shipped extractor. */
    offeredNextSteps: "offeredNextSteps",
    /**
     * The answer OFFERED a menu — a cue line over a bullet list — and the shipped
     * extractor refused it, so the visitor got prose where a chip row was owed.
     * Counted, never alarmed: it is the dead-end alarm's diagnosis, not a second
     * alarm. The reason rides beside it as `chipParseMissReason` for a Logs
     * Insights `stats count() by` — a closed vocabulary, never a label.
     */
    chipParseMiss: "chipParseMiss"
  },
  /** On the `TOOL_RETRIEVAL_MISS_LOG` payload. */
  retrievalMiss: {
    /** `'rescued'` | `'empty'` — split because they call for opposite fixes. */
    outcome: "outcome",
    /**
     * `'search'` | `'direct-handle'` — WHICH producer emitted the line
     * (SYN-851). The alarms key on `outcome` alone and are unchanged; this
     * field is for Logs Insights when the rescue-rate alarm fires, because the
     * two classes call for different remedies: a `search` rescue means the
     * top-N cut or the scorer is wrong, while a `direct-handle` rescue means
     * the model read a name (the group index, the sticky union, history) and
     * called it without searching — the cut may be perfectly set.
     */
    via: "via"
  }
};
var MODALITY_ALARM_VALUES = {
  streamLeg: "stream",
  readOnlyBias: READ_ONLY_BIAS,
  rescued: "rescued",
  empty: "empty",
  /** SYN-851 — the two producers of the retrieval-miss line (`via`). */
  viaSearch: "search",
  viaDirectHandle: "direct-handle"
};

// src/observability/modality-classes.ts
var MODALITY_CLASSES = [
  // 1 — answer in text
  "text",
  "cite",
  // 3 — render data in chat
  "metric",
  "view-table",
  "view-list",
  "view-card",
  "view-detail",
  "chart-line",
  "chart-bar",
  "chart-pie",
  "funnel",
  "dashboard",
  // Adaptive Compositions B1 — the model chose to answer as a LAID-OUT set of
  // blocks rather than one primitive or one dashboard grid.
  //
  // Its own class rather than a fold into `dashboard`, for the reason the
  // now-removed `split-view` got one: this is the DECISION the program is measured on
  // (§13.1 — composition present WITHOUT displacing the other classes), and
  // folding it into `dashboard` would make the crowding-out signal unreadable
  // precisely when it mattered. The two are also mutually exclusive on a turn
  // (§2.3), so a shared class could never separate "the tenant has compositions
  // on" from "the model likes dashboards".
  "composition",
  "component",
  // 4 — point & teach on the page
  "annotate",
  "walkthrough",
  // 5 — operate the page
  "page-action",
  "ui-copilot",
  "link",
  // 6 — act on the account
  "capability-read",
  "capability-write",
  "plan",
  "rollback",
  // 7 — ask / collect input
  "clarify",
  "flow",
  // 8 — find out what it can do
  //
  // SYN-818 — `search_capabilities` (M-05). Its own class rather than `null`,
  // and rather than a fold into any of the seven above, for two reasons:
  //
  //   - It is not a way of HELPING, so folding it into a neighbour would inflate
  //     a real class with calls that put nothing in front of the visitor. The
  //     nearest candidates are all wrong in the same direction: it is not
  //     `capability-read` (it reads the tenant's tool INDEX, not their data), not
  //     `clarify` (it asks the catalog, not the person), and not `plan`.
  //   - Left at `null` it would be counted as {@link UNCLASSIFIED}, and the
  //     exposure work this instrumentation precedes is expected to make the
  //     rescue tool a routine call. `unclassifiedCount` is the drift detector for
  //     "a tool shipped without being mapped" — a signal that only works while it
  //     is near zero, and a class of call arriving on a large share of turns
  //     would drown it exactly when the mix most needs reading.
  //
  // So the class exists ahead of the flip rather than after it, which also keeps
  // the metric readable ACROSS the transition instead of stepping at the flag.
  "discover",
  // terminal outcomes
  "sign-in",
  "decline"
];
var UNCLASSIFIED = "(unclassified)";
var MODALITY_CLASS_SET = new Set(MODALITY_CLASSES);
function isModalityClass(value) {
  return MODALITY_CLASS_SET.has(value);
}

// src/observability/client-latency-logs.ts
var CHAT_VISITOR_ERROR_RENDERED_LOG = "[client-latency] visitor error rendered";

// src/observability/chat-producer-logs.ts
var TURN_EXPLAIN_WRITE_FAILED_LOG = "[conversation] turn explain write failed \u2014 turn unaffected";
var CHAT_COMPARISON_EVIDENCE_EMPTY_LOG = "[conversations] comparison evidence empty";
var CHAT_COMPARISON_UNGROUNDED_LOG = "[conversations] comparison cell ungrounded";
var CHAT_COMPARISON_VERDICT_REPLACED_LOG = "[conversations] comparison verdict replaced";
var CHAT_PROACTIVE_OFFER_LOG = "[conversation] proactive offer shown";
var CHAT_COMPARE_ON_SELECT_REFUSED_LOG = "[conversations] compare-on-select refused";
var MODEL_CLASS_ELECTED_LOG = "[llm] model class elected";

// src/observability/discovery-alarm-logs.ts
var DISCOVERY_HARVEST_VOLUME_LOG = "[registered-ui] harvest volume high";
var DISCOVERY_HARVEST_VOLUME_THRESHOLD = 60;
var DISCOVERY_INVENTORY_FULL_LOG = "[registered-ui] inventory budget exhausted";

// src/observability/site-walk-alarm-logs.ts
var SITE_WALK_HIGH_REFUSAL_LOG = "[site-walk] run mostly refused";
var SITE_WALK_REFUSAL_SHARE_THRESHOLD = 0.5;
var SITE_WALK_TRUNCATED_LOG = "[site-walk] run truncated at a cap";
var SITE_WALK_PAGES_LOST_LOG = "[site-walk] run lost pages in flight";

// src/observability/turn-alarm-logs.ts
var TURN_REFUSED_IN_FLIGHT_LOG = "[conversations] turn refused: another turn is in flight";
var PROMPT_CACHE_DEGRADED_LOG = "[prompt-cache] anthropic system breakpoints degraded";
var TURN_INVALID_PROVIDER_REQUEST_LOG = "[conversations] turn failed: invalid provider request";
var RESUME_INVALID_PROVIDER_REQUEST_LOG = "[conversations] resume failed: invalid provider request";
var MODALITY_TRACE_LOG = "[conversation] modality trace";
var TOOL_RETRIEVAL_MISS_LOG = "[conversation] tool retrieval miss";
var COMPOSITION_CEILING_UNREADABLE_LOG = "[compositions] composition ceiling unreadable \u2014 proceeding unmetered";
var INTERACTION_LEDGER_WRITE_FAILED_LOG = "[usage] interaction charged but ledger row failed";
var RERANKER_UNAVAILABLE_LOG = "[docs-retrieval] reranker unavailable \u2014 using hybrid-search order";
var TOOL_RESULT_DEADLINE_LOG = "[conversations] tool-result deadline exceeded";
var CHAT_REFUSAL_LOG = "[conversation] turn refused by policy";

// src/observability/chat-engine-metrics.patterns.ts
var TRACE = `$.message = "${MODALITY_TRACE_LOG}"`;
var REFUSAL = `$.message = "${CHAT_REFUSAL_LOG}"`;
var EXPLAIN_WRITE_FAILED = `$.message = "${TURN_EXPLAIN_WRITE_FAILED_LOG}"`;
var VISITOR_ERROR = `$.message = "${CHAT_VISITOR_ERROR_RENDERED_LOG}"`;
var COMPARISON_EVIDENCE_EMPTY = `$.message = "${CHAT_COMPARISON_EVIDENCE_EMPTY_LOG}"`;
var COMPARISON_UNGROUNDED = `$.message = "${CHAT_COMPARISON_UNGROUNDED_LOG}"`;
var COMPARE_ON_SELECT_REFUSED = `$.message = "${CHAT_COMPARE_ON_SELECT_REFUSED_LOG}"`;
var COMPARISON_VERDICT_REPLACED = `$.message = "${CHAT_COMPARISON_VERDICT_REPLACED_LOG}"`;
var PROACTIVE_OFFER = `$.message = "${CHAT_PROACTIVE_OFFER_LOG}"`;
var MODEL_ELECTED = `$.message = "${MODEL_CLASS_ELECTED_LOG}"`;
function engine(field) {
  return `$.engine.${field}`;
}
function pattern(...clauses) {
  return `{ ${clauses.map((clause) => `(${clause})`).join(" && ")} }`;
}

// src/observability/chat-engine-metrics.comparison.ts
var COMPARISON_METRICS = [
  {
    metricName: "ChatComparisonEvidenceEmpty",
    // §2.8 (P4-B) — LIVE. A turn whose realized shape is `comparison`
    // gathered nothing to compose one from and fell open to prose.
    //
    // It does NOT read the trace line, for `ChatVisitorErrorRendered`'s reason:
    // the fact is known inside the evidence pass, stages before the trace is
    // written, so the producer writes its own line.
    //
    // **Not an outage number** — an empty pass is correct for a workspace with
    // no walked corpus and no dossier, and the turn still answers. It measures
    // how often the template cannot be drawn. Undimensioned though the four
    // LANE states are on the line: which lane was silent is a diagnosis Logs
    // Insights reads off `$.lanes.*` for nothing.
    filterPattern: pattern(COMPARISON_EVIDENCE_EMPTY),
    emitter: "live",
    reads: "comparison turns with no evidence to compose from (the turn answered in prose)"
  },
  {
    metricName: "ChatComparisonUngrounded",
    // §2.8 (P4-D) — LIVE. A value the composed template RENDERED did not
    // resolve, byte for byte, to the evidence its source points at, and the
    // whole composition fell CLOSED to the `text_with_chips` degradation.
    //
    // **Dimensioned, and the vocabulary is the payload type's.** The address
    // kinds — `cell`, `image`, `delta` — are fixed by
    // `ComparisonGroundingAddressSchema`, so the cardinality is three whatever
    // the fleet does; a headline fact on a card is a cell drawn on a card and
    // is counted as one. The split matters because each kind is a different
    // repair: a cell is the assembler, an image is a moved file, a delta is
    // arithmetic. One line per KIND per failed composition, never per value.
    //
    // **Not the count of cells a visitor saw wrong.** A failing composition is
    // never rendered with the bad cell blanked — a hole reads as a fact the
    // evidence never made — so this counts tables that could not be shown.
    filterPattern: pattern(COMPARISON_UNGROUNDED),
    emitter: "live",
    reads: "comparison compositions that failed closed to prose because a rendered value had no evidence, by kind",
    dimensions: { Kind: "$.kind" },
    totalTwinMetricName: "ChatComparisonUngroundedTotal"
  },
  {
    metricName: "ChatComparisonVerdictReplaced",
    // §2.8 (P4-D) — LIVE. The model's verdict paragraph named a number, an
    // attribute or a comparative the table does not carry, the one repair
    // attempt (where enabled) did not rescue it, and the ×6 template sentence
    // was placed instead.
    //
    // Undimensioned; the failure kinds and whether the repair was attempted
    // ride the line under `$.kinds.*` and `$.repair`, which Logs Insights reads
    // for nothing. D20's 10 % alarm is NOT wired over this figure — see the
    // registry entry for `ChatShapeRepaired`: that boolean means the M4 table
    // repair fired, and overloading it would make the M4 rate unreadable. A
    // threshold here would be a guessed number (ADR-0513), so none is
    // provisioned; the structural bound is one call per comparison turn on the
    // cheap class, with `CHAT_COMPARISON_VERDICT_REPAIR_ENABLED` the kill.
    filterPattern: pattern(COMPARISON_VERDICT_REPLACED),
    emitter: "live",
    reads: "comparison verdicts the model wrote that were replaced by the template sentence"
  },
  {
    metricName: "ChatCompareOnSelectTurns",
    // §2.8 (P4-E) — LIVE. A turn the visitor did not type: they ticked two to
    // four cards in a rendered grid and asked for the comparison.
    //
    // It reads the TRACE rather than a producer line, unlike its three
    // neighbours, and the difference is real: the other three are facts known
    // inside the comparison path before a trace exists, while this is a fact
    // about how the TURN was started, which is exactly what the trace's
    // `origin` field carries. Reading it here also means the turn's cost and
    // shape are on the same line as its origin, which is the pair § 3.1 exists
    // to make readable.
    //
    // Undimensioned. How MANY entities were compared rides the line for Logs
    // Insights; splitting a metric on a two-to-four range buys a cardinality of
    // three and answers no question anyone has asked.
    filterPattern: pattern(TRACE, `${engine("origin")} = "compare-on-select"`),
    emitter: "live",
    reads: "turns started by a compare-on-select gesture rather than by a typed message"
  },
  {
    metricName: "ChatCompareOnSelectRefused",
    // §2.8 (P4-E) — LIVE. A gesture arrived and did not resolve.
    //
    // **Expected to be zero, and that is what makes it worth a metric.** The
    // affordance exists only where the server minted a stamp, and the widget
    // posts back exactly what it was given, so neither end can produce a
    // refusal in normal operation. A non-zero figure is a crafted body, a
    // render that survived a key rotation, or a defect — three things worth
    // telling apart, which is what the dimension is for.
    //
    // Dimensioned on the REASON, whose vocabulary is closed by
    // `CompareOnSelectRefusal`: `malformed` (the body), `unverified` (a stamp).
    // Cardinality is two whatever the fleet does.
    filterPattern: pattern(COMPARE_ON_SELECT_REFUSED),
    emitter: "live",
    reads: "compare-on-select gestures refused, by reason",
    dimensions: { Reason: "$.reason" },
    totalTwinMetricName: "ChatCompareOnSelectRefusedTotal"
  }
];

// src/observability/chat-engine-metrics.non-spec.ts
var NON_SPEC_CHAT_ENGINE_METRICS = [
  {
    // NOT a §3.1 row in the eleven — § 5's P3 row asks for it by name ("election
    // counters"), and P3-G (ADR-0801) is its emitter.
    //
    // **This is the phase's read-first instrument.** Both cost dials a workspace
    // has — the margin throttle's `escalation` step and the `cost_saver`
    // conversation preference (ADR-0163) — remove the mid class from turns that
    // would otherwise have reached it. Without this series an operator turning
    // either one is guessing what it costs them, and with it the answer is
    // arithmetic: `complexity-escalation` plus `preference-quality-first` is the
    // share of turns that run mid today, and `margin-throttle` is the share the
    // dial has already taken away.
    metricName: "ChatModelClassElected",
    filterPattern: pattern(MODEL_ELECTED),
    emitter: "live",
    reads: "model-class elections, split by the reason the class was chosen",
    // Dimensioned on the REASON's closed eight-member vocabulary
    // (`ConversationModelReason`) — bounded by construction at
    // $0.30/metric/month, the `ChatRefusalsByClass` precedent.
    //
    // **`TenantId` is NOT a dimension, and that is this module's standing rule
    // rather than an omission here.** This fires on every stream turn, so a
    // per-tenant series behind it is the unbounded-cardinality custom metric
    // `.claude/rules/cost-optimization.md` forbids — the reasoning written out
    // in this file's header and enforced by a test in `monitoring-stack.test.ts`.
    // AF-276 attribution is not lost: `tenantId` rides the LINE, which is where
    // Logs Insights reads it and where the invariant is actually satisfied.
    //
    // The model CLASS is on the line too rather than a second dimension: it is a
    // pure function of the reason for seven of the eight members (only an
    // honoured `request-pinned` can be either), so a second dimension would
    // roughly double the series count to say something Logs Insights answers off
    // `$.modelClass` for nothing.
    dimensions: { ElectionReason: "$.reason" },
    totalTwinMetricName: "ChatModelClassElectedTotal"
  },
  {
    // § 2.9's per-tenant control (P3-G, ADR-0801) — how deep the negative-margin
    // throttle went on a turn.
    //
    // It reads the MODALITY TRACE rather than a line of its own, which is this
    // module's own rule about a second per-turn record, and the field is written
    // from `TurnPolicy.spend.marginThrottle`.
    //
    // **One dimensioned series rather than four filters, because the ladder is
    // CUMULATIVE.** `marginThrottleDepth` is the DEEPEST step taken, and a turn
    // at `shortlist` also took `rerank` and `escalation` — so step N's count is
    // the sum of the depths at or past N in the ladder's order (`rerank`,
    // `escalation`, `shortlist`, `anonymous-ceiling`). Four filters would each
    // read a boolean and cost four series to say the same thing.
    //
    // A turn that took NO step writes `marginThrottleAbstained` instead and
    // matches nothing here, which is correct: it is a different fact, it is the
    // fleet's state today, and it is readable off the line.
    metricName: "ChatMarginThrottleStep",
    filterPattern: pattern(TRACE, `${engine("marginThrottleDepth")} = "*"`),
    emitter: "live",
    reads: "turns the negative-margin throttle narrowed, by how deep it went",
    dimensions: { ThrottleStep: "$.engine.marginThrottleDepth" },
    totalTwinMetricName: "ChatMarginThrottleStepTotal"
  },
  {
    // NOT a §3.1 row — the instruments' OWN health signal (ADR-0785).
    //
    // The explain write is fail-quiet by contract, and the cost of that contract
    // is that a store which has stopped recording looks exactly like a fleet
    // with nothing to record. An empty review queue reading as "no bad turns
    // this week" is the most flattering possible reading of a broken pipe, and
    // this is the only number that separates the two.
    metricName: "ChatExplainWriteFailed",
    filterPattern: pattern(EXPLAIN_WRITE_FAILED),
    emitter: "live",
    reads: "turns whose explain record could not be written (the turn was unaffected)"
  },
  {
    metricName: "ChatMidClassEscalation",
    // § 2.9 (D8 / D17, ADR-0810) — the D17 trigger list routed a turn to the
    // mid class.
    //
    // **Dimensioned on WHICH trigger**, over a CLOSED five-member vocabulary
    // (`MID_CLASS_ESCALATION_TRIGGERS`), so the cardinality is fixed by the type
    // at ≤ six series: `ChatRefusalsByClass`'s precedent and its reasoning. A
    // bare count says the fleet escalated four hundred times and cannot say
    // whether that was the plan intent or a shortlist that could not separate
    // its top two — a different bill with a different fix.
    //
    // **LIVE while `MID_CLASS_SONNET5_ENABLED` is OFF, which is NOT this
    // registry's zero-is-a-lie case.** That rule is about a filter over a line
    // NO CODE WRITES. Here the producer exists and is switched off, so zero is
    // the true count of escalations rather than a dead detector reading as
    // health — and provisioning it with the flag still off is the only way the
    // flip has a BEFORE to be read against.
    filterPattern: pattern(TRACE, `${engine("escalationTrigger")} = "*"`),
    emitter: "live",
    reads: "turns the D17 trigger list routed to the mid class, by the trigger that fired",
    dimensions: { EscalationTrigger: "$.engine.escalationTrigger" },
    totalTwinMetricName: "ChatMidClassEscalationTotal"
  }
];

// src/observability/chat-engine-metrics.proactive.ts
var PROACTIVE_METRICS = [
  {
    metricName: "ChatProactiveOffer",
    // § 2.8 (P4-G) — LIVE. The turn ended with a chip the visitor did not ask
    // for, because a behavioural signal on its session-context envelope said
    // they might be stuck.
    //
    // **What this number is FOR.** § 2.8's clause is "reasons to OFFER … never
    // to auto-run", and the risk an offer carries is approval fatigue — ASI09's
    // trust surface, which does not stop mattering because the thing offered is
    // harmless. So the number an operator needs is how often the fleet is
    // INVITING, split by what provoked it: a `dwell` rate climbing while
    // `repeat_failure` stays flat is a threshold set too low, and the two have
    // opposite remedies.
    //
    // **Dimensioned on a CLOSED five-member vocabulary**
    // (`PROACTIVE_OFFER_REASONS`), so the cardinality is five whatever the
    // fleet does — ≤ $1.80/month/environment with the twin. That bound is the
    // only reason a dimension is affordable at all here; the rule and its
    // arithmetic are at `ChatEngineMetric.dimensions`.
    //
    // **NOT a success rate.** Whether the visitor tapped the chip is a
    // different instrument (the chip-tap capture, and `ModalityDeadEndTurns`
    // for turns that ended with nothing to tap), deliberately not folded in: an
    // offer that fires and is ignored is still an offer that fired, and folding
    // the two would make a rising ignore-rate look like a falling offer rate.
    filterPattern: pattern(PROACTIVE_OFFER),
    emitter: "live",
    reads: "turns that ended with an unasked-for next-step chip, by the signal that provoked it",
    dimensions: { Reason: "$.reason" },
    totalTwinMetricName: "ChatProactiveOfferTotal"
  }
];

// src/observability/chat-engine-metrics.ts
var CHAT_ENGINE_METRICS = [
  {
    metricName: "ChatShapeAdherence",
    // The numerator of the adherence rate; `ModalityTraces` is its denominator,
    // already filtered off the same line. Composed as ONE pattern rather than
    // two clauses in the stack, so the numerator cannot drift from a
    // denominator it is divided by.
    //
    // **It reads a BOOLEAN the emitter writes, not a comparison of two fields.**
    // The obvious pattern is `$.engine.plannedShape = $.engine.realizedShape`,
    // and CloudWatch's JSON filter grammar cannot express it: a term compares a
    // field against a LITERAL, never against another field. Such a pattern does
    // not error — it matches nothing, forever, which is the `defaultValue` of
    // zero this module's header is entirely about, and it would have read as a
    // fleet that never once produced the shape it planned. So P1 computes
    // `shapeAdhered` where both values are in hand and writes the answer.
    filterPattern: pattern(TRACE, `${engine("shapeAdhered")} IS TRUE`),
    // LIVE since P1-D1: `buildEngineTrace` writes `shapeAdhered` on every turn
    // that carried a plan, comparing the planned shape THROUGH the shape
    // table's projection onto the realized vocabulary. A plan below §2.3's act
    // floor is measured too — it shaped nothing about the turn, so what the
    // number then says is what the planner would have got right had it been
    // trusted, which is the one reading that can move the floor.
    emitter: "live",
    reads: "turns whose realized shape was the shape the planner asked for"
  },
  {
    metricName: "ChatPlannedRenderTurns",
    // D20's DENOMINATOR: the repair rate is "above 10 % of planned render
    // turns", and `ModalityTraces` — every turn — is the wrong divisor for it.
    // A fleet whose render turns are one in twenty would have to repair half of
    // them before a rate over all turns crossed 10 %.
    //
    // It reads a BOOLEAN the emitter writes rather than a shape comparison, for
    // the same reason `ChatShapeAdherence` does one entry up: "is
    // `plannedShape` one of seven" is not expressible in a grammar that matches
    // a field against ONE literal, and a pattern that cannot match reads as a
    // fleet that never plans a render.
    filterPattern: pattern(TRACE, `${engine("plannedRender")} IS TRUE`),
    emitter: "live",
    reads: "turns whose planner asked for a rendered answer (D20 denominator)"
  },
  {
    metricName: "ChatShapeServerRendered",
    // §2.3 M4's FREE half: the server drew the primitive from the turn's own
    // tool results, with no model call. Readable separately from
    // `ChatShapeRepaired` because the pair is the diagnosis — a rising repair
    // beside a flat server render says renders are being missed on turns that
    // had nothing to draw from, which is a retrieval question and not a prompt
    // one.
    filterPattern: pattern(TRACE, `${engine("shapeServerRendered")} IS TRUE`),
    emitter: "live",
    reads: "turns whose missed render the server drew itself, with no model call"
  },
  {
    metricName: "ChatPlannedRenderRealizedText",
    // The §2.3 M4 defect: a render shape that came back as prose. It is the
    // repair path's TRIGGER, so it must be readable separately from
    // `ChatShapeRepaired` — a rising trigger with a flat repair means the
    // repair stopped firing, and one number cannot say that.
    //
    // **RE-POINTED by P1-D2 onto the two booleans, and the old pattern was
    // wrong in a way worth keeping.** It read `plannedShape != "text"` beside
    // `realizedShape = "informational"`, which is TRUE of a planned `navigate`,
    // a planned `walkthrough` and a planned `file` that all realize as
    // `informational` by the shape table's own projection — none of them a
    // render defect. It was also a two-vocabulary comparison (§2.2's nineteen
    // against §2.3's sixteen) held together by two literals. Both halves are now
    // booleans the emitter writes where the values are in hand, which is this
    // registry's standing answer to a grammar that cannot compare two fields.
    filterPattern: pattern(
      TRACE,
      `${engine("plannedRender")} IS TRUE`,
      `${engine("shapeAdhered")} IS FALSE`
    ),
    emitter: "live",
    reads: "turns the planner asked to render that came back as prose"
  },
  {
    metricName: "ChatRefusalsByClass",
    filterPattern: pattern(REFUSAL),
    emitter: "live",
    reads: "turns refused, split by which rule refused them",
    dimensions: { RefusalClass: "$.refusalClass" },
    totalTwinMetricName: "ChatRefusalsTotal"
  },
  {
    metricName: "ChatScopeEnforcementDegraded",
    // §2.5 — the planner was unavailable and the deterministic backstop
    // enforced instead. Read SEPARATELY from `ChatPlannerUnknown` because they
    // are different facts: one says the planner is down, this says scope is
    // being enforced by the weaker of the two mechanisms while it is.
    //
    // **LIVE since P1-C2, which is the slice that wrote the line.** ADR-0789
    // registered the name and provisioned nothing, on this module's own rule: a
    // filter over a line nobody writes reads zero forever, and that reads as a
    // fleet whose scope enforcement is never degraded when in fact 100 % of it
    // was the degraded path.
    //
    // Dimensioned on the planner's own absence reason, on the
    // `ChatPlannerUnknown` precedent and with the same bounded cardinality:
    // only `degraded IS TRUE` lines mint a datapoint, so the values are the four
    // named absences plus `absent` (the plan stage did not run at all) — five,
    // plus the twin, at $0.30/metric/month. A `timeout` here says the planner is
    // slow and a refusal was taken without it; `disabled` says nobody asked for
    // one and the backstop is the whole mechanism by choice. One undimensioned
    // number cannot separate a temporary outage from a standing configuration.
    filterPattern: pattern(REFUSAL, "$.degraded IS TRUE"),
    emitter: "live",
    reads: "refusals decided by the keyword backstop because the planner produced no plan",
    dimensions: { PlannerSource: "$.plannerSource" },
    totalTwinMetricName: "ChatScopeEnforcementDegradedTotal"
  },
  {
    metricName: "ChatPlannerMs",
    // LIVE since P1-B. Counts a TIMED-OUT call too — its wall clock is the
    // budget, and a rising p99 that excluded the calls which hit the ceiling
    // would flatten exactly as the problem got worse. A `disabled` turn
    // short-circuits before any work and reports ~0, so it does not match.
    filterPattern: pattern(TRACE, `${engine("plannerMs")} > 0`),
    emitter: "live",
    reads: "the planner call\u2019s wall clock, per turn"
  },
  {
    metricName: "ChatPlannerUnknown",
    // **Re-pointed by P1-B, and the old pattern could never have fired.** It
    // read `$.engine.scope = "unknown"`, and `unknown` is not a member of
    // §2.2's scope vocabulary — nothing could write it, so the filter would have
    // reported a permanently healthy planner. What a turn without a plan
    // actually carries is `plannerSource`, which is one of four NAMED absences.
    //
    // Dimensioned by that source, on the `ChatRefusalsByClass` precedent: the
    // four are four different operational facts with four different remedies —
    // `timeout` says the planner is slow, `unavailable` that it is down,
    // `schema` that the model answered with something the closed grammar
    // refuses (a behaviour regression, not an outage), `disabled` that nobody
    // asked. One undimensioned number can only ever be read as an outage. A
    // bounded four-member vocabulary, so the cardinality is fixed.
    //
    // A turn on which the plan STAGE did not run at all carries no
    // `plannerSource` and matches nothing here, which is correct: that is a
    // fifth fact and not one of the four.
    filterPattern: pattern(TRACE, `${engine("plannerSource")} != "planner"`),
    emitter: "live",
    reads: "turns that reached the model with no plan, by the reason there was none",
    dimensions: { PlannerSource: "$.engine.plannerSource" },
    totalTwinMetricName: "ChatPlannerUnknownTotal"
  },
  {
    metricName: "ChatPlannerCostUsd",
    // NOT live after P1-B, deliberately. The planner's TOKEN usage rides
    // `PlanTurnResult`, and turning that into a figure needs the resolved EU
    // inference-profile id in `LLM_PRICING` and a decision about the 1.10×
    // Bedrock multiplier — which belong beside the cost-ledger work, not inside
    // the stage. Provisioning the filter now would put a CloudWatch series over
    // a field nobody writes, which reads zero forever: §7.8.1 finding 2's own
    // shape, and the reason this registry carries an `emitter` at all.
    filterPattern: pattern(TRACE, `${engine("plannerCostUsd")} > 0`),
    emitter: "P1",
    reads: "what the planner call cost, per turn"
  },
  {
    metricName: "ChatShapeRepaired",
    // D20 — the M4 repair fired: ONE structured Haiku call on a turn whose
    // planned render came back as prose AND which had nothing for the server to
    // draw from. LIVE since P1-D2.
    //
    // **The denominator is `ChatPlannedRenderTurns`, not `ModalityTraces`** —
    // D20's ceiling is "10 % of render turns", and the alarm in
    // `infrastructure/lib/monitoring/chat-shape-alarms.ts` divides by that
    // entry. The REASON a missed render was not repaired rides the line as
    // `$.engine.shapeRepairReason` rather than as a dimension, per this
    // module's no-dimension rule.
    filterPattern: pattern(TRACE, `${engine("shapeRepaired")} IS TRUE`),
    emitter: "live",
    reads: "turns whose shape was repaired by the one structured Haiku call"
  },
  {
    metricName: "ChatPreDispatchedRead",
    // LIVE since P2-F. The mechanism reads `pre-dispatch` only where the guard
    // reported the call RAN — savings taken, not savings attempted.
    filterPattern: pattern(TRACE, `${engine("mechanism")} = "pre-dispatch"`),
    emitter: "live",
    reads: "turns whose read was dispatched from the plan before the model was consulted (D3)"
  },
  {
    metricName: "ChatPreDispatchMs",
    // LIVE since P2-F. The EXECUTOR CHAIN's clock, not a round trip (the server
    // never calls a customer's API), in FRACTIONAL milliseconds — that chain can
    // settle inside one, and `> 0` over an integer clock would report the zero
    // this module's header is entirely about.
    filterPattern: pattern(TRACE, `${engine("preDispatchMs")} > 0`),
    emitter: "live",
    reads: "what the pre-dispatched read cost in wall clock (D3)"
  },
  {
    metricName: "ChatVisitorErrorRendered",
    // §2.6 rule 1 — an error alert reached the visitor. LIVE since P0d-B.
    //
    // **It does not read the trace line, and the reason is a correction worth
    // keeping.** This entry was registered against
    // `$.engine.visitorErrorRendered IS TRUE` on the modality trace, on the
    // assumption that the widget would report the fact back into the turn that
    // caused it. It cannot: the beacon is a SEPARATE request that arrives after
    // the turn's own record is written, and — more importantly — an alert can be
    // raised for a turn the server never saw fail at all (a dropped socket, an
    // offline network). So the producer writes its own line, and the pattern
    // reads that.
    //
    // Undimensioned, though the code is on the line. P0a's proof is this number
    // being ZERO on a drive, which is one number; a per-code series would mint a
    // custom metric per code at $0.30/month for a breakdown Logs Insights reads
    // off `$.errorCode` for nothing.
    filterPattern: pattern(VISITOR_ERROR),
    emitter: "live",
    reads: "turns on which a machine identifier or error code reached the visitor"
  },
  // Every row that is NOT a § 3.1 spec metric lives in a sibling module and is
  // spread in here, so this registry stays ONE table and each group keeps its
  // own reasoning beside it.
  //
  // P3's `ChatModelClassElected`, `ChatMarginThrottleStep` and the instruments'
  // own `ChatExplainWriteFailed` health signal (ADR-0785) travel together in
  // `./chat-engine-metrics.non-spec` — which is where the explain row moved, so
  // it is no longer declared inline here.
  ...NON_SPEC_CHAT_ENGINE_METRICS,
  // § 2.8's comparison metrics — the evidence pass, the groundedness check and
  // compare-on-select.
  ...COMPARISON_METRICS,
  // § 2.8's proactive-offer metric — the shape verifier's own line.
  ...PROACTIVE_METRICS
];

// src/observability/chat-engine-metrics.live.ts
function liveChatEngineMetrics() {
  return CHAT_ENGINE_METRICS.filter((metric) => metric.emitter === "live");
}

// src/observability/turn-plan-vocabulary.ts
var TURN_SHAPES = [
  // M0 — model-less. The server composes the whole reply; no provider call.
  "sign_in",
  /**
   * The site's own lead form as the whole reply (ADR-0774).
   *
   * Realized-side note: this and {@link TURN_SHAPES} `form` are the same
   * PRIMITIVE on the wire, and the difference between them is the plan's intent
   * rather than anything the frames carry — so a realized lead form is recorded
   * as `form` until P1's plan says which was asked for.
   */
  "contact_request",
  "navigate",
  "refusal",
  // M1 — server-composed seed; the model enters after the visitor answers.
  "form",
  "funnel",
  "question_card",
  // M2 — one forced provider call, server caption and offers, turn ends.
  "table",
  "detail",
  "card_grid",
  "chart",
  "metric_strip",
  /**
   * A comparison template (P4). Realized-side it is a `present_composition`
   * call like any other, so it is recorded as `composition` until the template
   * id rides on the plan.
   */
  "comparison",
  "composition",
  // M3 — narrowed context plus one shape directive.
  /**
   * A greeting or an aside. NOT derivable from a turn's output — a greeting and
   * an explanation are both plain text — so it is a PLANNED shape only; a text
   * turn realizes as `informational`.
   */
  "smalltalk",
  "informational"
];
var SHAPES = new Set(TURN_SHAPES);
function isTurnShape(value) {
  return SHAPES.has(value);
}
var REFUSAL_CLASSES = [
  /** The operator's `refusedTopics` (politics by default). */
  "refused_topic",
  /** The operator's `sensitiveDomains` — legal, medical, financial advice. */
  "sensitive_domain",
  /** `competitorHandling` — acknowledged and redirected by default. */
  "competitor",
  /** Another customer's data. Always refused; never operator-configurable. */
  "other_customer",
  /** A probe at the platform, the prompt or the tenant's own internals. */
  "internal_probe",
  /** In-domain, but outside what this workspace's agent may answer. */
  "out_of_scope",
  /** The platform AUP floor — ours, not the workspace's. */
  "platform_policy"
];
var REFUSALS = new Set(REFUSAL_CLASSES);
function isRefusalClass(value) {
  return REFUSALS.has(value);
}
var TURN_MECHANISMS = [
  /** ADR-0163 / the semantic response cache. No provider call at all. */
  "cache-hit",
  /**
   * The server composed the whole reply with no provider call and no cache —
   * today the signed-out action gate's sentence, tomorrow every M0 row.
   */
  "server-composed",
  /** One provider call, answered in text, no tool called. */
  "direct-answer",
  /** The agent loop ran at least one tool call. */
  "tool-loop",
  /**
   * §2.4 / D3 — a read dispatched from the plan before the model was consulted.
   * No producer until P1; typed here so the vocabulary the metric filters and
   * the explain record are built against does not change when it lands.
   */
  "pre-dispatch",
  /** The resume leg of a turn that paused for a client tool or a question. */
  "resume"
];
var PROACTIVE_OFFER_REASONS = [
  /** The envelope's `repeat_failure` — one capability failed twice this session. */
  "repeat_failure",
  /** The envelope's `dead_click` — a click that changed nothing on the page. */
  "dead_click",
  /** The envelope's `rage_click` — three or more clicks on one target in a second. */
  "rage_click",
  /** Derived: the visitor went to a route and came straight back (A → B → A). */
  "u_turn",
  /** Derived: `dwellSecondsOnCurrent` past the threshold on the current route. */
  "dwell"
];
var TURN_ORIGINS = [
  /** The visitor typed it. Every turn before P4-E, and almost all of them after. */
  "visitor-message",
  /** §2.8 — the visitor ticked cards in a rendered grid and asked to compare. */
  "compare-on-select"
];
var ActionStepStatusSchema = /* @__PURE__ */ z.enum(["pending", "running", "done", "failed"]);
var ActionProgressStepSchema = /* @__PURE__ */ z.object({
  id: z.string().min(1).max(120),
  label: LabelSchema,
  status: ActionStepStatusSchema,
  /** Optional per-step note (e.g. an error reason when `status` is `failed`). */
  detail: BodyTextSchema.optional()
});
var ActionInProgressPropsSchema = /* @__PURE__ */ z.object({
  title: LabelSchema,
  steps: z.array(ActionProgressStepSchema).min(1).max(20),
  /** 1-based index of the step currently running. Must be within `steps`. */
  currentStep: z.number().int().min(1),
  /** Optional overall completion percentage in [0, 100]. */
  percentComplete: z.number().min(0).max(100).optional()
}).refine((p) => p.currentStep <= p.steps.length, {
  message: "currentStep must be within the steps array",
  path: ["currentStep"]
});
var ActionPlanStepSchema = /* @__PURE__ */ z.object({
  /** Stable id the orchestrator correlates with the executed step. */
  id: z.string().min(1).max(120),
  /** One-line step label (e.g. "Reserve seats D5–D6"). */
  label: LabelSchema,
  /** Optional longer explanation of what the step does. */
  detail: BodyTextSchema.optional()
});
var ActionPlanPropsSchema = /* @__PURE__ */ z.object({
  title: LabelSchema,
  /** What the overall plan accomplishes, in user-facing language. */
  summary: BodyTextSchema.optional(),
  /** Ordered steps the agent will execute on approval. */
  steps: z.array(ActionPlanStepSchema).min(1).max(20),
  /** Fires when the user approves the whole plan. */
  approveAction: ActionSchema,
  /** Optional — lets the user revise the plan before approving. */
  editAction: ActionSchema.optional(),
  /** Optional — dismiss / abort the plan without executing. */
  cancelAction: ActionSchema.optional()
});
var ActionOutcomeSchema = /* @__PURE__ */ z.enum(["success", "failure", "partial"]);
var ActionResultPropsSchema = /* @__PURE__ */ z.object({
  title: LabelSchema,
  outcome: ActionOutcomeSchema,
  /** What happened, in user-facing language. */
  summary: BodyTextSchema,
  /** Concrete side effects the action produced (e.g. "Charged €24.00"). */
  sideEffects: z.array(BodyTextSchema).max(20).optional(),
  /** Audit-trail id for the executed action (links to the forensic log). */
  auditTrailId: z.string().min(1).max(200).optional(),
  /** Present only while the undo window is open. */
  undoAction: ActionSchema.optional(),
  /** ISO-8601 (UTC) expiry of the undo window; paired with `undoAction`. */
  undoExpiresAt: z.string().datetime().optional()
}).refine((p) => p.undoAction === void 0 === (p.undoExpiresAt === void 0), {
  message: "undoAction and undoExpiresAt must be provided together",
  path: ["undoAction"]
});
var ButtonVariantSchema = /* @__PURE__ */ z.enum(["primary", "secondary", "ghost", "destructive"]);
var ButtonPropsSchema = ActionSchema.extend({
  variant: ButtonVariantSchema.default("primary")
});
var CardImageSchema = /* @__PURE__ */ z.object({
  url: z.string().url().max(2e3),
  alt: BodyTextSchema
});
var CardPropsSchema = /* @__PURE__ */ z.object({
  title: LabelSchema,
  body: BodyTextSchema,
  image: CardImageSchema.optional(),
  actions: z.array(ActionSchema).max(3).optional()
});
var PART_OF_WHOLE_KINDS = /* @__PURE__ */ new Set(["pie", "donut"]);
var ChartPropsSchema = /* @__PURE__ */ z.object({
  kind: ChartKindSchema,
  /** Optional chart title — rendered above the chart and used in its aria summary. */
  title: LabelSchema.optional(),
  /** A SINGLE series of data points (the backward-compatible shape). */
  data: z.array(ChartDataPointSchema).min(1).max(CHART_MAX_POINTS).optional(),
  /** One or more named series (multi-series shape). Mutually exclusive with `data`. */
  series: z.array(ChartSeriesSchema).min(1).max(CHART_MAX_SERIES).optional(),
  /** Optional axis captions. */
  xLabel: LabelSchema.optional(),
  yLabel: LabelSchema.optional(),
  /** Value formatting for value labels + the table fallback. Defaults to plain numbers. */
  valueFormat: ChartValueFormatSchema.default("number"),
  /** ISO 4217 currency code for `valueFormat: 'currency'` (defaults to USD). */
  currency: CurrencyCodeSchema.optional(),
  /** Stack multi-series bars/areas instead of grouping them. Ignored for single series. */
  /**
   * Sum the series at each category instead of placing them side by side.
   *
   * `true` stacks the raw values; `'percent'` stacks SHARES — each category
   * is normalised so its stack totals 100, which is Bedrock's "100 % stacked"
   * and the right form when the question is composition rather than
   * magnitude.
   *
   * One prop rather than a `stacked` + `stackMode` pair: they would only ever
   * be read together, and two props for one concept is two things to keep
   * consistent.
   */
  stacked: z.union([z.boolean(), z.literal("percent")]).optional(),
  /**
   * How a line or area gets from one point to the next.
   *
   * `smooth` is the default and is what every line drew before this existed —
   * monotone-cubic, so the curve passes through every point without
   * overshooting. It is right for a quantity that VARIES continuously and
   * wrong for one that CHANGED at known moments: a curve through a price or a
   * headcount claims intermediate values that never existed.
   *
   * `linear` says only what was measured, joined. `stepped` says the value
   * was held and then changed, which for a step function is the only honest
   * shape.
   *
   * Ignored by bar, pie, donut and scatter, which have no between.
   */
  interpolation: z.enum(CHART_INTERPOLATIONS).optional(),
  /**
   * Which way a BAR chart runs. `vertical` is the default and is what every
   * bar drew before this existed.
   *
   * Reach for `horizontal` when the CATEGORY NAMES are the problem: a vertical
   * bar gives each name one column's width, so "Enterprise customers in EMEA"
   * overlaps its neighbours and the renderer thins the labels until most bars
   * are anonymous. Horizontal gives each name a full line. It is also the
   * better shape for many categories (a ranked list of ten or more reads
   * naturally top-to-bottom) and for a ranking generally, where the eye
   * compares lengths from a common left edge.
   *
   * Stays `vertical` for a TIME series whatever the label length — time reads
   * left-to-right, and turning it on its side makes a trend hard to see.
   *
   * Ignored by every other kind: a line, area, pie, donut, scatter or radar
   * has no category axis to trade places with.
   */
  orientation: z.enum(["vertical", "horizontal"]).optional(),
  /**
   * Lines drawn ACROSS the value axis — a target, a threshold, a budget, an
   * average. The mark that turns "we did 412" into "we did 412 against a goal
   * of 500", which is usually the actual question.
   *
   * Capped at three: a fourth is noise, and a chart whose grid competes with
   * its data is harder to read than one with no reference at all. Each may
   * carry a short label, rendered at the end of the line.
   *
   * Not available on pie or donut, which have no value axis to cross.
   */
  /**
   * Qualitative ranges painted BEHIND the data — "under 60 is a problem, over
   * 90 is good". The reading a bare number cannot give.
   *
   * `tone` is a MEANING, never a colour: the four values map to the theme's
   * semantic tokens, which carry the AA contrast work. A free-form colour here
   * would be a channel and would walk straight through it.
   *
   * Bands may be open-ended relative to the scale — a zone running past the
   * last value is the normal case — and are clipped to the plot. Capped at
   * four: a fifth band is a legend, not a background.
   *
   * Not available on pie or donut, which have no value axis to band.
   */
  /**
   * Extend the value axis beyond the data.
   *
   * A gauge is the case that needs it: "210 ms" means nothing without the 500
   * it is measured against, and the scale is a property of the QUESTION rather
   * than of the numbers. Also right for a percentage that should always read
   * 0–100 whatever the values, or for two charts a reader will compare.
   *
   * EXTENDS only — a bound inside the data is ignored rather than honoured.
   * Shrinking the axis would clip marks and quietly hide values, which is the
   * one thing a scale must never do; an axis that is wider than asked for is
   * visibly wider, where a truncated bar looks like a shorter bar.
   */
  scaleMin: z.number().finite().optional(),
  scaleMax: z.number().finite().optional(),
  valueBands: z.array(
    z.object({
      from: z.number().finite(),
      to: z.number().finite(),
      tone: z.enum(BAND_TONES)
    }).strict()
  ).min(1).max(4).optional(),
  referenceLines: z.array(
    z.object({
      value: z.number().finite(),
      label: LabelSchema.optional()
    }).strict()
  ).min(1).max(3).optional(),
  /**
   * Force the legend on/off. When omitted the renderer shows it for radial
   * charts (pie/donut — one key entry per slice) and for multi-series
   * cartesian charts; single-series cartesian charts hide it by default.
   */
  showLegend: z.boolean().optional(),
  /** Render the numeric value next to each bar / point / slice. */
  showValues: z.boolean().optional()
}).superRefine((props, ctx) => {
  const hasData = props.data !== void 0;
  const hasSeries = props.series !== void 0;
  if (hasData === hasSeries) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "provide exactly one of `data` or `series`",
      path: hasData ? ["series"] : ["data"]
    });
    return;
  }
  const allPoints = hasSeries ? (props.series ?? []).flatMap((s) => s.data) : props.data ?? [];
  if (props.kind === "scatter") {
    allPoints.forEach((point, index) => {
      if (point.x === void 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "scatter points require a numeric `x`",
          path: ["data", index, "x"]
        });
      }
    });
  } else {
    allPoints.forEach((point, index) => {
      if (point.label === void 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `${props.kind} points require a \`label\``,
          path: ["data", index, "label"]
        });
      }
    });
  }
  if (PART_OF_WHOLE_KINDS.has(props.kind)) {
    if (hasSeries && (props.series?.length ?? 0) > 1) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `${props.kind} charts show a single series`,
        path: ["series"]
      });
    }
    allPoints.forEach((point, index) => {
      if (point.value < 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `${props.kind} slice values cannot be negative`,
          path: ["data", index, "value"]
        });
      }
    });
  }
  if (props.orientation === "horizontal" && props.kind !== "bar") {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "`orientation` applies to bar \u2014 no other kind has a category axis to turn",
      path: ["orientation"]
    });
  }
  if (props.referenceLines !== void 0 && PART_OF_WHOLE_KINDS.has(props.kind)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `${props.kind} has no value axis for a reference line to cross`,
      path: ["referenceLines"]
    });
  }
  if (props.valueBands !== void 0 && PART_OF_WHOLE_KINDS.has(props.kind)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `${props.kind} has no value axis to band`,
      path: ["valueBands"]
    });
  }
});
var ComponentPropsSchema = /* @__PURE__ */ z.object({
  /**
   * Stable identifier matching the `registerComponent()` first
   * argument. Resolved via the widget's component registry at render
   * time.
   */
  componentId: z.string().min(1).max(120),
  /**
   * Opaque props payload — the registered Zod schema validates this
   * at render time. We accept `z.unknown()` here so the wire schema
   * doesn't need to know about every customer's component prop
   * shapes (impossible — they're customer-supplied).
   */
  componentProps: z.unknown().optional()
});
var ConfirmCardPropsSchema = /* @__PURE__ */ z.object({
  title: LabelSchema,
  /** What the action does, in user-facing language. */
  summary: BodyTextSchema,
  /** Bulleted list of side effects the user should know about. */
  sideEffects: z.array(BodyTextSchema).min(1).max(10),
  /** The action that fires on confirm. Defaults variant = 'primary'. */
  action: ActionSchema,
  /** When true, requires a typed-confirmation phrase before the confirm
   *  button enables. Set by the orchestrator for `destructive` tools. */
  typedConfirmationPhrase: z.string().min(2).max(40).optional()
});
var DetailFieldSchema = /* @__PURE__ */ z.object({
  label: LabelSchema,
  value: BodyTextSchema
});
var DetailPropsSchema = /* @__PURE__ */ z.object({
  fields: z.array(DetailFieldSchema).min(1).max(50)
});
var EMBED_MAX_HEIGHT_PX = 800;
var DEFAULT_EMBED_HEIGHT_PX = 480;
var EmbedPropsSchema = /* @__PURE__ */ z.object({
  /**
   * Full **https** URL of the remote content. The render gate matches its
   * origin against `allowedEmbedOrigins` (default-deny) before framing it.
   */
  src: z.string().url().max(2048).refine(
    (value) => {
      try {
        return new URL(value).protocol === "https:";
      } catch {
        return false;
      }
    },
    { message: "embed src must be an https URL" }
  ),
  /** Required accessible title for the iframe (HTML5 § 4.8.5). */
  title: LabelSchema,
  /** Rendered height in px (capped to prevent viewport theft). */
  heightPx: z.number().int().positive().max(EMBED_MAX_HEIGHT_PX)
});
var EmptyStatePropsSchema = /* @__PURE__ */ z.object({
  title: LabelSchema,
  body: BodyTextSchema.optional(),
  action: ActionSchema.optional()
});
var FUNNEL_MIN_STAGES = 2;
var FUNNEL_MAX_STAGES = 12;
var FunnelStageSchema = /* @__PURE__ */ z.object({
  /** Stage name, e.g. "Visited", "Signed up". */
  label: LabelSchema,
  /** The (non-negative) count at this stage. */
  value: z.number().finite().nonnegative()
});
var FunnelPropsSchema = /* @__PURE__ */ z.object({
  /** Optional title rendered above the funnel + used in the aria summary. */
  title: LabelSchema.optional(),
  stages: z.array(FunnelStageSchema).min(FUNNEL_MIN_STAGES).max(FUNNEL_MAX_STAGES),
  /** How stage values are formatted. Defaults to plain numbers. */
  valueFormat: ChartValueFormatSchema.default("number"),
  /** ISO 4217 currency code for `valueFormat: 'currency'` (defaults to USD). */
  currency: CurrencyCodeSchema.optional()
});
var ALLOWED_ORIGIN_REGEX = /^https?:\/\/[^\s*]+$/;
var FORBIDDEN_ORIGIN_VALUES = ["*", "null"];
var AllowedOriginSchema = /* @__PURE__ */ z.string().min(1).max(2048).refine(
  (value) => !FORBIDDEN_ORIGIN_VALUES.includes(value),
  {
    message: "wildcard or null origins are not permitted in postMessage allow-list"
  }
).refine((value) => ALLOWED_ORIGIN_REGEX.test(value), {
  message: "origin must be a http(s) URL without wildcard characters"
});
var IframePropsSchema = /* @__PURE__ */ z.object({
  /**
   * Raw HTML rendered inside the sandboxed iframe via the `srcdoc`
   * attribute. Bounded so a malformed agent emission can't render
   * megabytes of opaque content.
   */
  srcDoc: z.string().min(1).max(5e4),
  /**
   * Required title for screen-reader accessibility (per HTML5 § 4.8.5
   * — every `<iframe>` SHOULD carry a `title`).
   */
  title: LabelSchema,
  /**
   * Iframe pixel height. The widget caps the visible area so a
   * malicious agent can't render a viewport-stealing iframe.
   */
  heightPx: z.number().int().positive().max(800),
  /**
   * postMessage origin allow-list. Empty / omitted → the widget drops
   * every message from the iframe. Wildcards rejected at parse time.
   */
  allowedOrigins: z.array(AllowedOriginSchema).max(10).optional()
});
var ListItemSchema = /* @__PURE__ */ z.object({
  label: LabelSchema,
  value: BodyTextSchema.optional(),
  icon: z.string().min(1).max(32).optional(),
  action: ActionSchema.optional()
});
var ListPropsSchema = /* @__PURE__ */ z.object({
  items: z.array(ListItemSchema).min(1).max(PRIMITIVE_LIST_MAX_ITEMS)
});
var MarkdownPropsSchema = /* @__PURE__ */ z.object({
  content: z.string().min(1).max(PRIMITIVE_MARKDOWN_MAX)
});
var METRIC_MAX_ITEMS = 6;
var MetricDeltaDirectionSchema = /* @__PURE__ */ z.enum(["up", "down", "flat"]);
var MetricItemSchema = /* @__PURE__ */ z.object({
  /** The KPI name, e.g. "MRR" or "p95 latency". */
  label: LabelSchema,
  /** A number (formatted by `valueFormat`) OR a display-ready string. */
  value: z.union([z.number().finite(), z.string().min(1).max(PRIMITIVE_LABEL_MAX)]),
  /** Format applied only when `value` is a number. */
  valueFormat: ChartValueFormatSchema.optional(),
  /** ISO 4217 currency code for `valueFormat: 'currency'` (defaults to USD). */
  currency: CurrencyCodeSchema.optional(),
  /** Small unit suffix shown next to the value, e.g. "ms", "/mo". */
  unit: z.string().min(1).max(16).optional(),
  /** The change magnitude (e.g. 12 → "+12%" by default). */
  delta: z.number().finite().optional(),
  /** Trend direction; derived from the sign of `delta` when omitted. */
  /**
   * What the value is being compared AGAINST, said in words.
   *
   * `delta` already carries the CHANGE; this carries the baseline it changed
   * from. "+11%" alone leaves the reader asking "since when", and the answer is
   * usually the more useful half — "142, up 11% from 128 last month" is a
   * complete sentence where "142, +11%" is a fragment.
   *
   * Deliberately a LABEL and a VALUE rather than a second full stat: the
   * baseline is context for this number, not a number of its own, and giving it
   * a unit, a delta and a trend of its own would let an author build two
   * competing headlines in one block.
   */
  comparedTo: z.object({
    /** The baseline figure. Formatted with the same `format`/`unit` as `value`. */
    value: z.union([z.number().finite(), z.string().min(1).max(120)]),
    /** What that figure is — "last month", "target", "same week last year". */
    label: LabelSchema
  }).strict().optional(),
  deltaDirection: MetricDeltaDirectionSchema.optional(),
  /** Whether an UP trend is good (drives the delta colour). Defaults to true. */
  deltaIsGood: z.boolean().optional(),
  /** Whether `delta` is a percentage (renders a trailing %). Defaults to true. */
  deltaIsPercent: z.boolean().optional(),
  /** Optional small helper text under the value. */
  caption: BodyTextSchema.optional()
});
var MetricPropsSchema = /* @__PURE__ */ z.object({
  /** Optional strip title rendered above the cards + used in the aria summary. */
  title: LabelSchema.optional(),
  items: z.array(MetricItemSchema).min(1).max(METRIC_MAX_ITEMS)
});
var NavigatePropsSchema = /* @__PURE__ */ z.object({
  /**
   * Destination URL. Absolute (https://example.com/orders/42) or
   * relative (/orders/42) are both valid. Only http(s), mailto, and
   * relative URLs pass `safeUrl`; anything else is rendered as a
   * "blocked navigation" fallback at render time.
   */
  url: z.string().min(1).max(2048),
  /**
   * Button label shown on the confirm action. Lowercase verb-led
   * copy preferred ("take me to my orders"), matching brand voice.
   */
  label: LabelSchema,
  /**
   * Optional human-readable description rendered above the confirm
   * button. Use this to explain where the user is going and why
   * ("I'll take you to your orders page so you can review them.").
   * v1 is mandatory-pre-confirmation, so a one-line description
   * dramatically reduces accidental clicks.
   */
  description: BodyTextSchema.optional()
});
var ONBOARDING_CHECKLIST_MAX_ITEMS = 12;
var ONBOARDING_ID_MAX = 120;
var OnboardingChecklistItemSchema = /* @__PURE__ */ z.object({
  /**
   * Stable identifier completion is persisted against (per verified end user).
   * Must be stable across turns for the SAME checklist so re-presenting the card
   * hydrates prior progress.
   */
  id: z.string().min(1).max(ONBOARDING_ID_MAX),
  /** One-line item label (e.g. "Connect your first data source"). */
  label: LabelSchema,
  /** Optional longer explanation of what completing the item accomplishes. */
  description: BodyTextSchema.optional(),
  /**
   * Optional guided walkthrough for this step. When present, the card shows a
   * "Show me how" affordance that launches the host-page walkthrough overlay;
   * finishing the tour marks the item done. Reuses the exact {@link WalkthroughSchema}
   * the reserved `start_walkthrough` tool already renders.
   */
  walkthrough: WalkthroughSchema.optional()
});
var OnboardingChecklistPropsSchema = /* @__PURE__ */ z.object({
  /**
   * Stable checklist identifier — the persistence key for this whole checklist's
   * per-item completion (scoped per verified end user). Keep it stable across
   * turns for the same onboarding flow.
   */
  checklistId: z.string().min(1).max(ONBOARDING_ID_MAX),
  /** Optional heading shown above the progress indicator. */
  title: LabelSchema.optional(),
  /** Ordered checklist items (at least one). */
  items: z.array(OnboardingChecklistItemSchema).min(1).max(ONBOARDING_CHECKLIST_MAX_ITEMS)
});
var OnboardingProgressSchema = /* @__PURE__ */ z.object({
  /** Whether the tenant enabled the onboarding-checklist feature. */
  enabled: z.boolean(),
  /** Ids of the items the verified caller has already completed. */
  completedItemIds: z.array(z.string().min(1).max(ONBOARDING_ID_MAX)).max(ONBOARDING_CHECKLIST_MAX_ITEMS)
});
var SignInCardPropsSchema = /* @__PURE__ */ z.object({
  /** Headline, e.g. "Sign in to continue". */
  title: LabelSchema,
  /** One or two sentences explaining why signing in is needed. */
  body: BodyTextSchema,
  /** The sign-in button label, e.g. "Sign in". */
  cta: LabelSchema
});
var StatusVariantSchema = /* @__PURE__ */ z.enum(["success", "warning", "error", "info"]);
var StatusPropsSchema = /* @__PURE__ */ z.object({
  label: LabelSchema,
  variant: StatusVariantSchema,
  /** Optional supplementary text rendered below the label. */
  detail: BodyTextSchema.optional()
});
var TableColumnSchema = /* @__PURE__ */ z.object({
  /** Stable column key — used in row cell map. */
  key: z.string().min(1).max(80),
  /** Header label. */
  label: LabelSchema,
  /** Optional alignment hint. */
  align: z.enum(["start", "end", "center"]).optional()
});
var TableCellSchema = /* @__PURE__ */ z.string().max(2e3);
var TableRowSchema = /* @__PURE__ */ z.record(z.string(), TableCellSchema);
var TablePropsSchema = /* @__PURE__ */ z.object({
  columns: z.array(TableColumnSchema).min(1).max(PRIMITIVE_TABLE_MAX_COLUMNS),
  rows: z.array(TableRowSchema).min(0).max(PRIMITIVE_TABLE_MAX_ROWS),
  /** Optional caption rendered above the table. */
  caption: BodyTextSchema.optional(),
  /** Optional row-level actions exposed in the trailing action column. */
  actions: z.array(ActionSchema).max(4).optional()
});
var BoundChartConfigSchema = /* @__PURE__ */ z.object({
  kind: ChartKindSchema,
  title: LabelSchema.optional(),
  xLabel: LabelSchema.optional(),
  yLabel: LabelSchema.optional(),
  valueFormat: ChartValueFormatSchema.default("number"),
  currency: CurrencyCodeSchema.optional(),
  stacked: z.boolean().optional(),
  showLegend: z.boolean().optional(),
  showValues: z.boolean().optional()
});
var BoundMetricConfigSchema = /* @__PURE__ */ z.object({
  title: LabelSchema.optional()
});
var BoundTableConfigSchema = /* @__PURE__ */ z.object({
  columns: z.array(TableColumnSchema).min(1).max(PRIMITIVE_TABLE_MAX_COLUMNS),
  caption: BodyTextSchema.optional(),
  actions: z.array(ActionSchema).max(4).optional()
});
var BoundFunnelConfigSchema = /* @__PURE__ */ z.object({
  title: LabelSchema.optional(),
  valueFormat: ChartValueFormatSchema.default("number"),
  currency: CurrencyCodeSchema.optional()
});

// src/widget/primitives/chart-normalize.ts
function asCategoryShares(series) {
  const nCats = Math.max(0, ...series.map((s) => s.data.length));
  const sums = Array.from(
    { length: nCats },
    (_, i) => series.reduce((acc, s) => acc + Math.max(0, s.data[i]?.value ?? 0), 0)
  );
  return series.map((s) => ({
    ...s,
    data: s.data.map((point, i) => {
      const sum = sums[i] ?? 0;
      return { ...point, value: sum === 0 ? 0 : Math.max(0, point.value) / sum * 100 };
    })
  }));
}
function normalizeChartSeries(props) {
  if (props.series !== void 0) {
    const series = props.series.map((s) => ({
      name: s.name,
      ...s.color !== void 0 ? { color: s.color } : {},
      data: s.data
    }));
    return props.stacked === "percent" ? asCategoryShares(series) : series;
  }
  return [
    {
      ...props.yLabel !== void 0 ? { name: props.yLabel } : {},
      data: props.data ?? []
    }
  ];
}

// src/widget/primitives/sensitive-fields.ts
function collectSensitiveFieldNames(fields) {
  const names2 = [];
  for (const field of fields) {
    if (field.sensitive === true && !names2.includes(field.name)) {
      names2.push(field.name);
    }
  }
  return names2;
}
var SENSITIVE_VALUE_MASK = "\u2022\u2022\u2022";
function maskSensitiveValues(values, sensitiveFields) {
  if (sensitiveFields === void 0 || sensitiveFields.length === 0) {
    return { ...values };
  }
  const masked = { ...values };
  for (const name of sensitiveFields) {
    if (name in masked) {
      masked[name] = SENSITIVE_VALUE_MASK;
    }
  }
  return masked;
}

// src/widget/primitives/flow-tree.ts
function hasAnyBranch(flow) {
  return flattenFlowSteps(flow).some((step) => step.branch !== void 0);
}
function flattenFlowSteps(flow) {
  const out = [];
  const visit = (steps) => {
    for (const step of steps) {
      out.push(step);
      const { branch } = step;
      if (branch === void 0) continue;
      for (const branchCase of branch.cases) visit(branchCase.steps);
      visit(branch.default ?? []);
    }
  };
  visit(flow.steps);
  return out;
}
function collectFlowSensitiveFields(flow) {
  return collectSensitiveFieldNames(flattenFlowSteps(flow).flatMap((step) => step.fields));
}
function resolveFlowPath(flow, values) {
  const path = [];
  const visit = (steps) => {
    for (const step of steps) {
      path.push(step);
      const { branch } = step;
      if (branch === void 0) continue;
      const answer = values[branch.field];
      if (typeof answer !== "string" || answer === "") continue;
      const key = normalizeBranchKey(answer);
      const matched = branch.cases.find(
        (branchCase) => branchCase.values.some((value) => normalizeBranchKey(value) === key)
      );
      visit(matched !== void 0 ? matched.steps : branch.default ?? []);
    }
  };
  visit(flow.steps);
  return path;
}
function projectFlowSubmission(flow, values) {
  const path = resolveFlowPath(flow, values);
  const onPath = new Set(path.flatMap((step) => step.fields).map((field) => field.name));
  const projected = {};
  for (const [name, value] of Object.entries(values)) {
    if (!onPath.has(name) || value === void 0) continue;
    projected[name] = value;
  }
  return { values: projected, path: path.map((step) => step.id) };
}

// src/widget/primitives/index.ts
var PrimitivePayloadSchema = /* @__PURE__ */ z.discriminatedUnion("type", [
  z.object({ type: z.literal("list"), props: ListPropsSchema }),
  z.object({ type: z.literal("table"), props: TablePropsSchema }),
  z.object({ type: z.literal("card"), props: CardPropsSchema }),
  z.object({ type: z.literal("markdown"), props: MarkdownPropsSchema }),
  z.object({ type: z.literal("button"), props: ButtonPropsSchema }),
  z.object({ type: z.literal("detail"), props: DetailPropsSchema }),
  z.object({ type: z.literal("form"), props: FormPropsSchema }),
  z.object({ type: z.literal("status"), props: StatusPropsSchema }),
  z.object({ type: z.literal("emptyState"), props: EmptyStatePropsSchema }),
  z.object({ type: z.literal("confirmCard"), props: ConfirmCardPropsSchema }),
  z.object({ type: z.literal("navigate"), props: NavigatePropsSchema }),
  z.object({ type: z.literal("component"), props: ComponentPropsSchema }),
  z.object({ type: z.literal("iframe"), props: IframePropsSchema }),
  z.object({ type: z.literal("actionPlan"), props: ActionPlanPropsSchema }),
  z.object({ type: z.literal("actionInProgress"), props: ActionInProgressPropsSchema }),
  z.object({ type: z.literal("actionResult"), props: ActionResultPropsSchema }),
  z.object({ type: z.literal("chart"), props: ChartPropsSchema }),
  z.object({ type: z.literal("embed"), props: EmbedPropsSchema }),
  z.object({ type: z.literal("metric"), props: MetricPropsSchema }),
  z.object({ type: z.literal("funnel"), props: FunnelPropsSchema }),
  // SYN-206 — the multi-step input WIZARD (distinct from the funnel CHART).
  z.object({ type: z.literal("flow"), props: FlowPropsSchema }),
  // AVM Phase D — the anonymous → authenticated sign-in conversion handoff.
  z.object({ type: z.literal("signInCard"), props: SignInCardPropsSchema }),
  // W-31 — the assistant-led onboarding checklist (walkthrough-backed steps,
  // persistent per-end-user completion). Labs-gated behind `onboarding-checklist`.
  z.object({ type: z.literal("onboardingChecklist"), props: OnboardingChecklistPropsSchema })
]);
var BoundPrimitivePayloadSchema = /* @__PURE__ */ z.intersection(
  PrimitivePayloadSchema,
  z.object({ dataSource: DataSourceRefSchema.optional() })
);
var DASHBOARD_LAYOUTS = ["grid", "stack", "columns"];
var DashboardLayoutSchema = /* @__PURE__ */ z.enum(DASHBOARD_LAYOUTS);
var MAX_DASHBOARD_ITEMS = 8;
var DashboardCompositionPropsSchema = /* @__PURE__ */ z.object({
  title: LabelSchema.optional(),
  layout: DashboardLayoutSchema.default("grid"),
  items: z.array(BoundPrimitivePayloadSchema).min(1).max(MAX_DASHBOARD_ITEMS)
});
var DashboardPayloadSchema = /* @__PURE__ */ z.object({
  type: z.literal("dashboard"),
  props: DashboardCompositionPropsSchema
});
var PRIMITIVE_SCHEMAS = {
  list: ListPropsSchema,
  table: TablePropsSchema,
  card: CardPropsSchema,
  markdown: MarkdownPropsSchema,
  button: ButtonPropsSchema,
  detail: DetailPropsSchema,
  form: FormPropsSchema,
  status: StatusPropsSchema,
  emptyState: EmptyStatePropsSchema,
  confirmCard: ConfirmCardPropsSchema,
  navigate: NavigatePropsSchema,
  component: ComponentPropsSchema,
  iframe: IframePropsSchema,
  actionPlan: ActionPlanPropsSchema,
  actionInProgress: ActionInProgressPropsSchema,
  actionResult: ActionResultPropsSchema,
  chart: ChartPropsSchema,
  embed: EmbedPropsSchema,
  metric: MetricPropsSchema,
  funnel: FunnelPropsSchema,
  flow: FlowPropsSchema,
  signInCard: SignInCardPropsSchema,
  onboardingChecklist: OnboardingChecklistPropsSchema
};
var FILE_REF_PREFIX = "sxfile_";
var FILE_REF_PATTERN = /^sxfile_[0-9a-f]{32}$/;
var MAX_OFFERED_FILE_BYTES = 50 * 1024 * 1024;
var MAX_OFFERED_FILES = 10;
var MAX_OFFERED_TOTAL_BYTES = 100 * 1024 * 1024;
var MAX_PREVIEW_BYTES = 10 * 1024 * 1024;
var MAX_FILENAME_LENGTH = 200;
var OfferedFileSchema = /* @__PURE__ */ z.object({
  ref: z.string().regex(FILE_REF_PATTERN),
  filename: z.string().min(1).max(MAX_FILENAME_LENGTH),
  contentType: z.string().min(1).max(255),
  sizeBytes: z.number().int().nonnegative().max(MAX_OFFERED_FILE_BYTES)
}).strict();
function isOfferedFile(value) {
  return OfferedFileSchema.safeParse(value).success;
}
var MAX_SCAN_DEPTH = 3;
function scanOfferedFiles(result) {
  const files = [];
  const seen = /* @__PURE__ */ new Set();
  const visited = /* @__PURE__ */ new WeakSet();
  let truncated = false;
  const walk = (node, depth) => {
    if (truncated) return;
    if (node === null || typeof node !== "object") return;
    if (visited.has(node)) return;
    visited.add(node);
    if (isOfferedFile(node)) {
      if (seen.has(node.ref)) return;
      if (files.length >= MAX_OFFERED_FILES) {
        truncated = true;
        return;
      }
      seen.add(node.ref);
      files.push(node);
      return;
    }
    if (depth >= MAX_SCAN_DEPTH) return;
    for (const child of Array.isArray(node) ? node : Object.values(node)) {
      walk(child, depth + 1);
    }
  };
  walk(result, 0);
  return { files, truncated };
}
function findOfferedFiles(result) {
  return scanOfferedFiles(result).files;
}

// src/widget/files/media-type.ts
function normalizeMediaType(raw) {
  const [essence = ""] = raw.split(";");
  return essence.trim().toLowerCase();
}
var PREVIEW_KIND_BY_TYPE = /* @__PURE__ */ new Map([
  ["application/pdf", "pdf"],
  ["image/png", "image"],
  ["image/jpeg", "image"],
  ["image/gif", "image"],
  ["image/webp", "image"],
  ["image/avif", "image"],
  ["image/bmp", "image"],
  ["image/x-icon", "image"],
  ["image/vnd.microsoft.icon", "image"],
  ["text/plain", "text"],
  ["text/csv", "text"],
  ["text/tab-separated-values", "text"],
  ["text/markdown", "text"],
  ["application/json", "text"],
  // Not reachable by the `text/*` rule below, and each one a document type a
  // generated file routinely is. `application/xml` in particular carried an
  // extension mapping and NO classification for as long as this map was closed
  // — saveable, and unpreviewable, with nothing anywhere noticing.
  ["application/xml", "text"],
  ["application/yaml", "text"],
  ["application/x-yaml", "text"],
  ["application/x-ndjson", "text"],
  ["application/jsonl", "text"]
]);
var SCRIPT_CAPABLE_TYPES = /* @__PURE__ */ new Set([
  "text/html",
  "application/xhtml+xml",
  "image/svg+xml"
]);
var MEDIA_TYPE_PATTERN = /^[a-z0-9][a-z0-9!#$&^_.+-]{0,126}\/[a-z0-9][a-z0-9!#$&^_.+-]{0,126}$/;
function isValidMediaType(raw) {
  return MEDIA_TYPE_PATTERN.test(normalizeMediaType(raw));
}
function classifyPreview(contentType) {
  const essence = normalizeMediaType(contentType);
  if (SCRIPT_CAPABLE_TYPES.has(essence)) return "none";
  const exact = PREVIEW_KIND_BY_TYPE.get(essence);
  if (exact !== void 0) return exact;
  if (!MEDIA_TYPE_PATTERN.test(essence)) return "none";
  if (essence.startsWith("text/")) return "text";
  if (essence.endsWith("+json") || essence.endsWith("+xml")) return "text";
  return "none";
}
var NEW_TAB_SAFE_TYPES = /* @__PURE__ */ new Set([
  "application/pdf",
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
  "image/avif",
  "image/bmp",
  "image/x-icon",
  "image/vnd.microsoft.icon",
  "text/plain",
  "text/csv",
  "text/tab-separated-values",
  "text/markdown",
  "application/json"
]);
function mayOpenInNewTab(contentType) {
  const essence = normalizeMediaType(contentType);
  if (SCRIPT_CAPABLE_TYPES.has(essence)) return false;
  return NEW_TAB_SAFE_TYPES.has(essence);
}
var FALLBACK_MEDIA_TYPE = "application/octet-stream";

// src/widget/files/file-extension.ts
var EXTENSION_BY_TYPE = /* @__PURE__ */ new Map([
  ["application/pdf", "pdf"],
  ["image/png", "png"],
  ["image/jpeg", "jpg"],
  ["image/gif", "gif"],
  ["image/webp", "webp"],
  ["image/avif", "avif"],
  ["image/bmp", "bmp"],
  ["image/x-icon", "ico"],
  ["image/vnd.microsoft.icon", "ico"],
  ["image/svg+xml", "svg"],
  ["text/plain", "txt"],
  ["text/csv", "csv"],
  ["text/tab-separated-values", "tsv"],
  ["text/markdown", "md"],
  ["text/html", "html"],
  ["application/json", "json"],
  ["application/yaml", "yaml"],
  ["application/x-yaml", "yaml"],
  ["application/x-ndjson", "ndjson"],
  ["application/jsonl", "jsonl"],
  ["application/xml", "xml"],
  ["text/xml", "xml"],
  ["application/zip", "zip"],
  ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "xlsx"],
  ["application/vnd.openxmlformats-officedocument.wordprocessingml.document", "docx"],
  ["application/vnd.openxmlformats-officedocument.presentationml.presentation", "pptx"]
]);
var ACCEPTED_EXTENSIONS = /* @__PURE__ */ new Map([
  ["image/jpeg", ["jpg", "jpeg", "jpe"]],
  ["image/x-icon", ["ico"]],
  ["image/vnd.microsoft.icon", ["ico"]],
  ["image/tiff", ["tif", "tiff"]],
  ["text/plain", ["txt", "text", "log"]],
  ["text/markdown", ["md", "markdown", "mdown"]],
  ["text/html", ["html", "htm"]],
  ["text/tab-separated-values", ["tsv", "tab"]],
  ["application/yaml", ["yaml", "yml"]],
  ["application/x-yaml", ["yaml", "yml"]],
  ["application/x-ndjson", ["ndjson", "jsonl"]],
  ["application/jsonl", ["jsonl", "ndjson"]]
]);
function isAcceptedExtension(contentType, extension) {
  const essence = normalizeMediaType(contentType);
  const canonical = EXTENSION_BY_TYPE.get(essence);
  if (canonical === void 0) return false;
  const accepted = ACCEPTED_EXTENSIONS.get(essence) ?? [canonical];
  return accepted.includes(extension.toLowerCase());
}
function canonicalExtension(contentType) {
  return EXTENSION_BY_TYPE.get(normalizeMediaType(contentType));
}
var TYPE_BY_EXTENSION = /* @__PURE__ */ new Map([
  ["pdf", "application/pdf"],
  ["png", "image/png"],
  ["jpg", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["gif", "image/gif"],
  ["webp", "image/webp"],
  ["avif", "image/avif"],
  ["bmp", "image/bmp"],
  ["ico", "image/x-icon"],
  ["txt", "text/plain"],
  ["log", "text/plain"],
  ["csv", "text/csv"],
  ["tsv", "text/tab-separated-values"],
  ["md", "text/markdown"],
  ["markdown", "text/markdown"],
  ["json", "application/json"],
  ["xml", "application/xml"],
  ["yaml", "application/yaml"],
  ["yml", "application/yaml"],
  ["ndjson", "application/x-ndjson"],
  ["jsonl", "application/x-ndjson"]
]);
function mediaTypeForFilename(filename) {
  const dot = filename.lastIndexOf(".");
  if (dot <= 0 || dot === filename.length - 1) return void 0;
  return TYPE_BY_EXTENSION.get(filename.slice(dot + 1).toLowerCase());
}

// src/widget/files/download-filename.ts
function charClass(codePoints, flags) {
  const body = codePoints.map(
    (entry) => typeof entry === "number" ? escapeCodePoint(entry) : `${escapeCodePoint(entry[0])}-${escapeCodePoint(entry[1])}`
  ).join("");
  return new RegExp(`[${body}]`, flags);
}
function escapeCodePoint(code) {
  return `\\u${code.toString(16).padStart(4, "0")}`;
}
var BIDI_CONTROLS = charClass(
  [8234, 8235, 8236, 8237, 8238, 8294, 8295, 8296, 8297, 8206, 8207, 1564],
  "g"
);
var CONTROL_CHARS = charClass([[0, 31], 127, [128, 159]], "g");
var FILESYSTEM_UNSAFE = /["*:<>?|]/g;
var RESERVED_DEVICE = /^(con|prn|aux|nul|com[1-9]|lpt[1-9])$/i;
var MAX_NAME_GRAPHEMES = 128;
function graphemes(value) {
  if (typeof Intl.Segmenter === "function") {
    return Array.from(
      new Intl.Segmenter(void 0, { granularity: "grapheme" }).segment(value),
      (segment) => segment.segment
    );
  }
  return Array.from(value);
}
var FALLBACK_STEM = "file";
function splitExtension(name) {
  const dot = name.lastIndexOf(".");
  if (dot <= 0 || dot === name.length - 1) return [name, ""];
  return [name.slice(0, dot), name.slice(dot + 1)];
}
function capGraphemes2(value, max) {
  const clusters = graphemes(value);
  return clusters.length <= max ? value : clusters.slice(0, max).join("");
}
function sanitizeDownloadFilename(raw, contentType) {
  const leaf = raw.split(/[/\\]/).pop() ?? "";
  let cleaned = leaf.replace(BIDI_CONTROLS, "").replace(CONTROL_CHARS, "").replace(FILESYSTEM_UNSAFE, "").replace(/\s+/g, " ").trim();
  cleaned = cleaned.replace(/^[.\s]+/, "").replace(/[. ]+$/, "").trim();
  let [stem, extension] = splitExtension(cleaned);
  stem = stem.trim();
  if (RESERVED_DEVICE.test(stem.split(".")[0] ?? "")) stem = `_${stem}`;
  const canonical = canonicalExtension(contentType);
  if (canonical !== void 0 && !isAcceptedExtension(contentType, extension)) {
    stem = extension === "" ? stem : `${stem}.${extension}`;
    extension = canonical;
  }
  if (stem === "") stem = FALLBACK_STEM;
  const suffix = extension === "" ? "" : `.${extension}`;
  const stemBudget = Math.max(1, MAX_NAME_GRAPHEMES - graphemes(suffix).length);
  return `${capGraphemes2(stem, stemBudget)}${suffix}`;
}

// src/widget/files/preview-refusal-corpus.ts
var SCRIPT_CAPABLE_MEDIA_TYPES = [
  "text/html",
  "application/xhtml+xml",
  "image/svg+xml",
  // Casing and parameters must not be a way around the refusal.
  "TEXT/HTML",
  "text/html; charset=utf-8",
  "Image/SVG+XML"
];
var DOWNLOAD_ONLY_MEDIA_TYPES = [
  "application/zip",
  "application/rtf",
  "application/octet-stream",
  "application/x-msdownload",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "audio/mpeg",
  "video/mp4",
  "image/tiff",
  "image/heic"
];
var MALFORMED_MEDIA_TYPES = [
  "",
  "   ",
  "pdf",
  "application",
  "application/",
  "/pdf",
  "application/pdf\nContent-Type: text/html",
  "../../etc/passwd"
];
var REFUSED_MEDIA_TYPES = [
  ...SCRIPT_CAPABLE_MEDIA_TYPES,
  ...DOWNLOAD_ONLY_MEDIA_TYPES,
  ...MALFORMED_MEDIA_TYPES
];

// src/widget/files/format-file-size.ts
var KIB = 1024;
var UNITS = [
  { divisor: KIB * KIB * KIB, unit: "gigabyte", ascii: "GB" },
  { divisor: KIB * KIB, unit: "megabyte", ascii: "MB" },
  { divisor: KIB, unit: "kilobyte", ascii: "KB" },
  { divisor: 1, unit: "byte", ascii: "B" }
];
function formatFileSize(bytes, locale) {
  const safe = Number.isFinite(bytes) && bytes > 0 ? Math.floor(bytes) : 0;
  const chosen = UNITS.find((candidate) => safe >= candidate.divisor) ?? UNITS[UNITS.length - 1];
  if (chosen === void 0) return String(safe);
  const value = safe / chosen.divisor;
  const fractionDigits = chosen.unit === "byte" || value >= 10 ? 0 : 1;
  const rounded = Number(value.toFixed(fractionDigits));
  try {
    return new Intl.NumberFormat(locale, {
      style: "unit",
      unit: chosen.unit,
      unitDisplay: "short",
      maximumFractionDigits: fractionDigits,
      minimumFractionDigits: 0
    }).format(rounded);
  } catch {
    let digits;
    try {
      digits = rounded.toLocaleString();
    } catch {
      digits = String(rounded);
    }
    return `${digits} ${chosen.ascii}`;
  }
}

// src/widget/bundle-claim.ts
var PUBLIC_WIDGET_LOAD_BUDGET_KB = 30;
var RETIRED_WIDGET_CLAIM_FIGURES = [
  78,
  80,
  82,
  85,
  90,
  91,
  92,
  93,
  94,
  97,
  98,
  99
];

// src/widget/design-parts.ts
var DESIGN_PART_ATTRIBUTE = "data-syncanix-part";
var DESIGN_PARTS = [
  /** The round button visitors see before they open the chat. */
  "launcher",
  /**
   * The panel frame itself — size, layout, resize behaviour. The FALLBACK part:
   * a click on panel chrome that belongs to no more specific part lands here,
   * so a click inside the preview always resolves to something.
   */
  "panel",
  /** The chat header — agent name, avatar, online dot, history button. */
  "header",
  /** The welcome / empty state shown before the first message. */
  "welcome",
  /** The back-and-forth message bubbles. */
  "messages",
  /** The field visitors type into, and the send button. */
  "composer",
  /** The AI notice — first-message banner, compact badge, footer sentence. */
  "disclosure"
];
function isDesignPart(value) {
  return typeof value === "string" && DESIGN_PARTS.includes(value);
}
var WalkthroughAnchorSchema = /* @__PURE__ */ z.object({
  /** Which step this anchor is for. */
  step: z.number().int().min(0).max(WALKTHROUGH_MAX_STEPS - 1),
  /** The durable signature, in the same grammar the `control` anchor takes. */
  control: z.string().regex(ANNOTATION_CONTROL_PATTERN).max(ANNOTATION_CONTROL_MAX),
  /** The templated route this control was documented on. */
  page: z.string().min(1).regex(HARVESTED_ROUTE_PATH_PATTERN)
});
var WALKTHROUGH_MAX_ANCHORS = WALKTHROUGH_MAX_STEPS;

// src/widget/annotation/walkthrough-payload.schema.ts
var WALKTHROUGH_REVEAL_NAME_MAX = 120;
var WALKTHROUGH_REVEAL_ROLE_PATTERN = /^[a-z][a-z0-9-]{0,39}$/;
var WalkthroughRevealSchema = /* @__PURE__ */ z.object({
  /** Which step this hint is for (an index into `walkthrough.steps`). */
  step: z.number().int().min(0).max(WALKTHROUGH_MAX_STEPS - 1),
  /** The observed accessible name of the control that reveals the step's target. */
  name: z.string().min(1).max(WALKTHROUGH_REVEAL_NAME_MAX),
  /** The observed role of that control, refused against the closed grammar. */
  role: z.string().min(1).regex(WALKTHROUGH_REVEAL_ROLE_PATTERN),
  /**
   * SEC-11 — the templated route the edge was OBSERVED on, so the widget can
   * refuse a hint for a page the visitor is not on.
   *
   * Without it, a step could be hinted from any page the tenant's graph
   * covered. Two pages routinely carry the same control name (`/settings` with
   * "More options" → "Export", `/orders` with "Bulk actions" → "Export"), so a
   * cross-page rank hands the `/orders` step the `/settings` revealer — and if
   * `/orders` also has a "More options" that opens something else, PR-1 anchors
   * to it and the tour PRESSES it.
   *
   * The check belongs in the BROWSER rather than the server, and for a
   * vocabulary reason rather than a preference: an edge's page is whatever its
   * producer templated (`/orders/:id`), while the API's own view of the turn is
   * the raw `pagePath`, which templates to `/orders/:param` and would never
   * match. The widget holds the live route in the edges' own vocabulary and is
   * the only party that does.
   *
   * Refused against the same closed grammar every producer writes it under
   * (ADR-0398): a repaired path names a different page.
   */
  page: z.string().min(1).max(MAX_HARVESTED_ROUTE_PATH_CHARS).regex(HARVESTED_ROUTE_PATH_PATTERN)
});
var WALKTHROUGH_MAX_REVEALS = WALKTHROUGH_MAX_STEPS;
var WalkthroughPerformDecisionSchema = /* @__PURE__ */ z.object({
  /** Which step this decision is for (an index into `walkthrough.steps`). */
  step: z.number().int().min(0).max(WALKTHROUGH_MAX_STEPS - 1),
  /**
   * `perform` — the platform can show this is below the consent line.
   * `hand-over` — it is at or above it, or nothing proves it is below.
   */
  decision: z.enum(["perform", "hand-over"]),
  /**
   * WHY, in a closed vocabulary — so the widget can pick the right ×6 sentence
   * without the server sending prose, and so a log line says which rung refused.
   *
   * `unknown-control` is the ADR-0400 rung and is the commonest `hand-over`: the
   * scan returned nothing for this step's anchor, so the platform is declining
   * to guess. It is deliberately not called `no-scan`, because the two cases it
   * covers — a turn with no scan, and a scan that did not contain this control —
   * are the same fact from the widget's side and want the same sentence.
   */
  reason: z.enum([
    "reveals",
    "navigates",
    "read-only",
    "destructive",
    "submits",
    "writes",
    "unknown-control"
  ])
});
var WALKTHROUGH_MAX_PERFORMS = WALKTHROUGH_MAX_STEPS;
var WalkthroughPayloadSchema = /* @__PURE__ */ z.object({
  walkthrough: WalkthroughSchema,
  /**
   * PLAN §4b PR-3c — server-composed reveal hints, at most one per step.
   *
   * ABSENT is the normal state and means exactly what it says: the platform has
   * observed nothing about how this step's target is reached. It is never an
   * error, and a widget that ignores the field entirely behaves as it did
   * before PR-3c.
   *
   * **An invalid member is DROPPED; it never costs the tour.** A hint is
   * advisory — losing one costs a step its class-2 rung, while failing the
   * payload would lose the visitor the whole walkthrough — so the members are
   * filtered before the array is validated rather than the array failing on the
   * first bad one. The member schema is still the strict one, so nothing is
   * repaired: a hint either is one or is gone.
   */
  reveals: z.preprocess(
    (raw) => Array.isArray(raw) ? raw.filter((m) => WalkthroughRevealSchema.safeParse(m).success) : raw,
    z.array(WalkthroughRevealSchema).max(WALKTHROUGH_MAX_REVEALS).optional()
  ),
  /**
   * DE-402 — server-composed documented-control anchors, at most one per step.
   *
   * Filtered like `reveals` rather than refused like `performs`, and the
   * asymmetry is the same safety argument: an anchor is ADVISORY — it says where
   * a step's target is documented, and losing one costs that step its documented
   * identity while the model's own target still resolves. A decision is a
   * permission; this is a suggestion.
   */
  anchors: z.preprocess(
    (raw) => Array.isArray(raw) ? raw.filter((m) => WalkthroughAnchorSchema.safeParse(m).success) : raw,
    z.array(WalkthroughAnchorSchema).max(WALKTHROUGH_MAX_ANCHORS).optional()
  ),
  /**
   * NEXT-LEVEL-PLAN unit D — the server's consent-line decision per step.
   *
   * A dropped member is DELIBERATELY not filtered the way `reveals` is, and the
   * asymmetry is the safety argument rather than an inconsistency. A hint is
   * advisory, so losing one costs a step a rung and the tour survives; a
   * decision is a PERMISSION, and a malformed one must not be repaired into a
   * shape that happens to parse. Refusing the whole payload would cost the
   * visitor the tour, so instead the member schema is strict and a member that
   * does not satisfy it is simply not there — which the widget reads as
   * `hand-over`, the safe direction. Both roads lead to "do not press"; this one
   * also leaves the visitor a tour.
   */
  performs: z.preprocess(
    (raw) => Array.isArray(raw) ? raw.filter((m) => WalkthroughPerformDecisionSchema.safeParse(m).success) : raw,
    z.array(WalkthroughPerformDecisionSchema).max(WALKTHROUGH_MAX_PERFORMS).optional()
  ),
  /**
   * TG-5 — the published Task Guide this tour was materialized from, when it was.
   *
   * **UNAUTHORABLE BY THE MODEL, by the same construction `reveals` uses**, and for
   * the same reason: it rides the RESULT the server composes, not
   * `WalkthroughSchema`, which is what the model's `start_walkthrough` args are
   * validated against. A field ON the walkthrough would let a model attribute its
   * own ad-hoc tour to a guide an operator curated — inflating that guide's adoption
   * with runs it never produced, which is a reporting surface lying about itself.
   * `resolveStartTaskGuide` is the only producer.
   *
   * ABSENT is the normal state and means "not from a guide" — a model-authored
   * walkthrough — never an error. A widget that ignores the field behaves exactly as
   * it did before TG-5.
   *
   * Machine-valued, so REFUSED against the shared grammar rather than repaired
   * (ADR-0398): a cleaned id attributes a run to a DIFFERENT guide, silently, which
   * is the one failure an adoption metric must not have.
   *
   * **An invalid id is DROPPED; it never costs the tour** — the `reveals` rule above,
   * and this field has even less claim to fail a payload, being pure telemetry. Left
   * as a bare optional it did exactly that: a malformed id failed the whole
   * `safeParse`, so `maybeStartWalkthrough` started nothing and the visitor lost a
   * working walkthrough over an attribution nobody would have read. Preprocessed to
   * `undefined` instead, which lands on the same "unattributed run" the absent case
   * already means. Nothing is repaired — an id either is one or is gone.
   */
  guideId: z.preprocess(
    (raw) => typeof raw === "string" && TASK_GUIDE_ID_PATTERN.test(raw) ? raw : void 0,
    z.string().regex(TASK_GUIDE_ID_PATTERN).max(TASK_GUIDE_ID_MAX).optional()
  )
});
var WALKTHROUGH_OUTCOMES = [
  /** The visitor reached the end and pressed Done. */
  "completed",
  /** The visitor closed it (× or Esc) before the end. */
  "dismissed",
  /** A step stayed unresolvable on an unchanged page until the tour gave up. */
  "abandoned-stuck",
  /** The visitor navigated away and the step could not follow. */
  "abandoned-navigated",
  /**
   * The page went away underneath the tour — tab closed, browser quit, hard
   * navigation. Reported on `pagehide` with a keepalive request, so a tour the
   * visitor simply walked out on is COUNTED rather than silently missing from
   * the denominator.
   */
  "abandoned-closed",
  /**
   * The tour never opened: precalculating the plan against the live page
   * (`walkthrough-preflight.ts`) found the FIRST step had nothing real to point
   * at, so showing it would have produced a card promising a highlight that
   * could never arrive.
   *
   * Counted rather than dropped, for the same reason `abandoned-closed` is. A
   * refusal is the resolution layer failing at its earliest and most complete
   * point — the agent planned a tour this page cannot answer at all — and if it
   * went unrecorded, adding the refusal would have RAISED completion rate by
   * removing the worst runs from the denominator. The one number this surface
   * is judged by must not improve because a failure learned to exit sooner.
   *
   * `lastStepIndex` is 0 and both resolution counters are 0: nothing ran.
   */
  "refused-unresolvable"
];
var WALKTHROUGH_MAX_DURATION_MS = 24 * 60 * 60 * 1e3;
var WalkthroughOutcomeSchema = /* @__PURE__ */ z.object({
  /** How many steps the tour had. */
  stepCount: z.number().int().min(1).max(WALKTHROUGH_MAX_STEPS),
  /**
   * The furthest step the visitor reached (0-based). With `stepCount` this is
   * the drop-off point, and across runs the distribution is the drop-off
   * curve — the thing a per-step event stream would otherwise be needed for.
   */
  lastStepIndex: z.number().int().min(0).max(WALKTHROUGH_MAX_STEPS - 1),
  outcome: z.enum(WALKTHROUGH_OUTCOMES),
  durationMs: z.number().int().min(0).max(WALKTHROUGH_MAX_DURATION_MS),
  /**
   * How many steps ever entered the waiting state. This is the measure of the
   * RESOLUTION layer rather than of the visitor: a tenant whose tours are
   * constantly pending has a page our targeting is losing, which completion
   * rate alone cannot show.
   */
  pendingStepCount: z.number().int().min(0).max(WALKTHROUGH_MAX_STEPS),
  /**
   * How many steps had to point at an OPENER instead of their real target
   * (`reveal-path.ts`). A high count means the agent is routinely planning
   * steps into closed drawers — a leading indicator of a tour being wrong
   * rather than merely abandoned.
   */
  revealedStepCount: z.number().int().min(0).max(WALKTHROUGH_MAX_STEPS),
  /**
   * TG-5 — the published Task Guide this tour ran, when it ran one.
   *
   * The whole adoption question (starts / step reach / completion PER GUIDE) is
   * this one field: everything else on this report already measures the run, and
   * without it a curated guide's tour is indistinguishable from a model-authored
   * one. Absent means "not from a guide", which is the normal case.
   *
   * **Echoed by the client, so RE-CHECKED by the server.** It arrives from the
   * payload the server itself composed, but this is the widget channel — a
   * hand-rolled client can send any id — so the ingest confirms the id names a
   * guide this tenant actually has and DROPS the attribution otherwise, keeping
   * the row. Same posture as a `routeId`: the client selects from a set the server
   * knows, and the server re-checks membership rather than trusting the echo.
   *
   * The blast radius of a lie is bounded to the liar's own workspace: skewed
   * adoption counts for the tenant's own guides, on a surface only their operator
   * reads. Value-free — an opaque machine id, no prose, nothing attributable to a
   * visitor, so it changes nothing about what this row discloses.
   */
  guideId: z.string().regex(TASK_GUIDE_ID_PATTERN).max(TASK_GUIDE_ID_MAX).optional()
}).strict().superRefine((v, ctx) => {
  if (v.lastStepIndex >= v.stepCount) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["lastStepIndex"],
      message: "lastStepIndex must be within stepCount"
    });
  }
  for (const key of ["pendingStepCount", "revealedStepCount"]) {
    if (v[key] > v.stepCount) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: [key],
        message: `${key} cannot exceed stepCount`
      });
    }
  }
  if (v.outcome === "completed" && v.lastStepIndex !== v.stepCount - 1) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["outcome"],
      message: "a completed tour must end on its last step"
    });
  }
});
var TOUR_MAX_REVEAL_EDGES = 12;
var TourRevealEdgeSchema = /* @__PURE__ */ z.object({
  revealedByName: z.string().min(1).max(160),
  revealedByRole: z.string().min(1).max(40),
  name: z.string().min(1).max(160),
  role: z.string().min(1).max(40)
}).strict();
var TourRevealReportSchema = /* @__PURE__ */ z.object({
  /**
   * The tour's own normalized route — the templated path, never the concrete
   * one, exactly as the walk reports it.
   *
   * **REFUSED against the shared closed grammar, not merely length-capped.**
   * The first version of this trusted the widget to template it, on the
   * reasoning that the walk does the same. That reasoning does not survive the
   * change of channel: the walk arrives on an operator-minted credential,
   * while this arrives on the PUBLISHABLE key, which is public by design (it
   * is in the customer's embed snippet) and whose origin check a non-browser
   * client can forge. A browser-side guarantee is not a guarantee there — an
   * arbitrary string would land verbatim in a stored column and in the graph a
   * later tour's hints are matched from, taking a concrete order id or a
   * query string carrying a token with it.
   *
   * `HARVESTED_ROUTE_PATH_PATTERN` is the SAME grammar W2-4, W2-5 and the
   * JSON-LD harvest refuse against, so five producers feeding one route
   * inventory cannot disagree about what a path may look like. Refused rather
   * than cleaned (ADR-0398): a repaired path names a different page.
   */
  page: z.string().max(MAX_HARVESTED_ROUTE_PATH_CHARS).regex(HARVESTED_ROUTE_PATH_PATTERN),
  edges: z.array(TourRevealEdgeSchema).min(1).max(TOUR_MAX_REVEAL_EDGES)
}).strict();
var CLIENT_LATENCY_MAX_MS = 6e5;
var VISITOR_ERROR_CODE_MAX_LENGTH = 48;
var VISITOR_ERROR_CODE = new RegExp(
  `^[a-z][a-z0-9_]{0,${String(VISITOR_ERROR_CODE_MAX_LENGTH - 1)}}$`
);
var ClientLatencyReportSchema = /* @__PURE__ */ z.object({
  /** Submit → first `message.delta` or `tool_call.start`, as the widget saw it. */
  firstTokenMs: z.number().int().min(0).max(CLIENT_LATENCY_MAX_MS).optional(),
  /** Whether `firstTokenMs` exceeded the widget's client budget. */
  overBudget: z.boolean().optional(),
  /**
   * `plan/agent-engine` § 2.6 rule 1 — the code of an error alert the shell
   * actually RENDERED for this turn. Never its message.
   */
  errorRendered: z.string().regex(VISITOR_ERROR_CODE).optional()
}).strict().superRefine((report, ctx) => {
  const hasMs = report.firstTokenMs !== void 0;
  const hasVerdict = report.overBudget !== void 0;
  if (hasMs !== hasVerdict) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: [hasMs ? "overBudget" : "firstTokenMs"],
      message: "firstTokenMs and overBudget travel together"
    });
  }
  if (!hasMs && report.errorRendered === void 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["firstTokenMs"],
      message: "a report must carry the latency pair, an error code, or both"
    });
  }
});
var MCP_APPS_VIEW_SPEC_SCRIPT_ID = "syncanix-mcp-apps-view-spec";
var BindingSchema = /* @__PURE__ */ z.object({
  key: z.string().min(1),
  label: z.string().min(1)
});
var FormFieldSchema2 = /* @__PURE__ */ z.object({
  name: z.string().min(1),
  label: z.string().min(1),
  type: z.enum(["string", "number", "boolean", "enum"]),
  required: z.boolean(),
  options: z.array(z.string()).optional()
});
var McpAppsViewSpecSchema = /* @__PURE__ */ z.object({
  version: z.literal(1),
  /** The served (D2-namespaced) tool name this spec was generated for. */
  tool: z.string().min(1),
  view: z.enum(["table", "detail", "form", "markdown"]),
  /** view === 'table' — column bindings (response key → label). */
  columns: z.array(BindingSchema).optional(),
  /** view === 'detail' — field bindings (response key → label). */
  fields: z.array(BindingSchema).optional(),
  /** view === 'form' — input fields + the ADR-0153 confirm affordance. */
  form: z.object({
    confirm: z.boolean(),
    fields: z.array(FormFieldSchema2)
  }).optional(),
  /**
   * SYN-300-forward INERT action affordance: names the host-proxied
   * tools/call a future interactive template would issue. Carried for
   * forward-compatibility; nothing executes it until SYN-300 ships.
   */
  action: z.object({
    kind: z.literal("tools/call"),
    tool: z.string().min(1)
  }).optional()
});
var EmbedOriginSchema = /* @__PURE__ */ z.string().min(1).max(253).regex(
  /^https:\/\/(?:[a-z0-9-]+\.)*[a-z0-9-]+(?::\d{1,5})?$/i,
  'must be an https origin like "https://example.com" (no path, query, or fragment)'
);
var MAX_ALLOWED_EMBED_ORIGINS = 50;
var WidgetRichComponentsConfigSchema = /* @__PURE__ */ z.object({
  /** Customer-registered component names allowed to render. Empty = none gated in. */
  allowList: z.array(z.string().min(1).max(64)).max(200).default([]),
  /**
   * Built-in primitive types the admin has turned OFF. Empty (default) = all
   * primitives render — the backward-compatible default. A listed type renders
   * the safe fallback at the gate (09-b-ii) instead of the component.
   */
  disabledPrimitives: z.array(PrimitiveTypeSchema).max(64).default([]),
  /**
   * Remote-embed origins the admin has opted into (Section 09-c). **Default-deny:**
   * empty (the default) means NO remote embed renders. An embed whose origin is
   * not on this list renders a safe fallback at the gate (09-c-ii), never the
   * remote frame. https-only.
   */
  allowedEmbedOrigins: z.array(EmbedOriginSchema).max(MAX_ALLOWED_EMBED_ORIGINS).default([]),
  /**
   * R3 / ADR-0067 — whether the model's reasoning trace is surfaced in the chat
   * as a collapsed-by-default disclosure. `true` (the default) = collapsed-visible
   * per the product spec; a customer who doesn't want model internals shown to
   * their end users sets this `false` and the trace is never rendered.
   */
  showThinking: z.boolean().default(true)
});
var WIDGET_LOGO_IMAGE_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
  "image/svg+xml"
];
var WIDGET_LOGO_IMAGE_MAX_BYTES = 256 * 1024;
var WIDGET_HEADER_LOGO_IMAGE_MAX_BYTES = 64 * 1024;
var dataUrlMaxChars = (maxBytes) => Math.ceil(maxBytes / 3) * 4 + 64;
var WIDGET_LOGO_IMAGE_DATA_URL_MAX_CHARS = dataUrlMaxChars(WIDGET_LOGO_IMAGE_MAX_BYTES);
var LOGO_IMAGE_DATA_URL_RE = /^data:image\/(?:png|jpeg|gif|webp|svg\+xml);base64,[A-Za-z0-9+/]+={0,2}$/;
function logoImageSrcSchema(maxBytes) {
  return z.string().max(dataUrlMaxChars(maxBytes)).superRefine((value, ctx) => {
    if (LOGO_IMAGE_DATA_URL_RE.test(value)) return;
    if (/^https?:\/\//i.test(value) && value.length <= 2048) {
      try {
        new URL(value);
        return;
      } catch {
      }
    }
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Logo image must be an https URL or an inline image data URL"
    });
  });
}
var WidgetLogoImageSrcSchema = logoImageSrcSchema(WIDGET_LOGO_IMAGE_MAX_BYTES);
var WidgetHeaderLogoImageSrcSchema = logoImageSrcSchema(
  WIDGET_HEADER_LOGO_IMAGE_MAX_BYTES
);
function byLocaleSchema(text) {
  const shape = {
    en: text.optional(),
    es: text.optional(),
    fr: text.optional(),
    de: text.optional(),
    ar: text.optional(),
    he: text.optional()
  };
  return z.object(shape);
}
function customerTextSchema(max) {
  const text = z.string().min(1).max(max);
  return z.union([
    text,
    z.object({
      default: text,
      byLocale: byLocaleSchema(text).optional()
    })
  ]);
}
function resolveCustomerText(value, locale) {
  if (value === void 0) return void 0;
  if (typeof value === "string") return value;
  return value.byLocale?.[locale] ?? value.default;
}
function customerTextDefault(value) {
  if (value === void 0) return void 0;
  return typeof value === "string" ? value : value.default;
}
function setCustomerTextDefault(value, nextDefault) {
  if (value === void 0 || typeof value === "string") return nextDefault;
  return { ...value, default: nextDefault };
}

// src/widget-config/agent-identity.ts
var WidgetAgentConfigSchema = /* @__PURE__ */ z.object({
  /**
   * The agent's name — the default for the header title AND the author label
   * above each answer. Customer free text (their language), so it takes the same
   * `{ default, byLocale }` per-locale shape as every other customer-copy field
   * (ADR-0172 §C2); the caller resolves the active locale.
   */
  name: customerTextSchema(60).optional(),
  /**
   * The agent's face — the default for the launcher bubble, the chat header and
   * every message row. Capped at the header's 64 KB: the biggest surface that
   * renders it is the launcher bubble, still far below the welcome mark's budget,
   * and these bytes ride inline in the config on every widget boot.
   */
  avatarUrl: logoImageSrcSchema(WIDGET_HEADER_LOGO_IMAGE_MAX_BYTES).optional()
});
var set = (value) => value === void 0 || value === "" ? void 0 : value;
function resolveAgentAvatar(base, surface) {
  const override = surface === "header" ? base.chrome?.headerLogoUrl : base.chrome?.messageLogoUrl;
  return set(override) ?? set(base.agent?.avatarUrl);
}
function resolveAgentName(base, surface) {
  const override = surface === "header" ? base.copy?.headerTitle : base.copy?.assistantName;
  return set(override) ?? set(base.agent?.name);
}
var BRAND_MARK = { kind: "icon", icon: "default" };
function resolveLauncherMark(base) {
  const mark = base.launcher?.mark;
  if (mark !== void 0) {
    if (mark.kind === "icon") return { kind: "icon", icon: mark.icon };
    if (mark.kind === "image") return { kind: "image", src: mark.src };
    const agentSrc = set(base.agent?.avatarUrl);
    return agentSrc !== void 0 ? { kind: "image", src: agentSrc } : BRAND_MARK;
  }
  const legacySrc = set(base.launcher?.avatarUrl);
  if (legacySrc !== void 0) return { kind: "image", src: legacySrc };
  const icon = base.launcher?.icon;
  return icon !== void 0 ? { kind: "icon", icon } : BRAND_MARK;
}
var hexColor = /* @__PURE__ */ z.string().regex(/^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/, "must be a 3- or 6-digit hex color");
var radiusScale = /* @__PURE__ */ z.number().min(0).max(4);
var WidgetComponentOverrideSchema = /* @__PURE__ */ z.object({
  backgroundColor: hexColor.optional(),
  foregroundColor: hexColor.optional(),
  accentColor: hexColor.optional(),
  borderColor: hexColor.optional(),
  radiusScale: radiusScale.optional()
});
var componentOverrideSlot = WidgetComponentOverrideSchema.optional();
var WidgetComponentOverridesSchema = /* @__PURE__ */ z.object({
  list: componentOverrideSlot,
  table: componentOverrideSlot,
  card: componentOverrideSlot,
  markdown: componentOverrideSlot,
  button: componentOverrideSlot,
  detail: componentOverrideSlot,
  form: componentOverrideSlot,
  status: componentOverrideSlot,
  emptyState: componentOverrideSlot,
  confirmCard: componentOverrideSlot,
  navigate: componentOverrideSlot,
  component: componentOverrideSlot,
  iframe: componentOverrideSlot,
  actionPlan: componentOverrideSlot,
  actionInProgress: componentOverrideSlot,
  actionResult: componentOverrideSlot,
  chart: componentOverrideSlot,
  embed: componentOverrideSlot,
  metric: componentOverrideSlot,
  funnel: componentOverrideSlot,
  // SYN-206 — the multi-step flow (wizard) primitive.
  flow: componentOverrideSlot,
  // AVM Phase D — the anonymous → authenticated sign-in handoff.
  signInCard: componentOverrideSlot,
  // W-31 — the assistant-led onboarding checklist.
  onboardingChecklist: componentOverrideSlot
});

// src/widget-config/frame-origins.ts
var MAX_FRAME_ORIGINS = 16;
function isValidFrameOrigin(candidate) {
  if (candidate === "" || candidate === "*" || candidate === "null") return false;
  try {
    const url = new URL(candidate);
    if (url.origin !== candidate) return false;
    const isLocalDev = url.hostname === "localhost" || url.hostname === "127.0.0.1";
    return url.protocol === "https:" || isLocalDev;
  } catch {
    return false;
  }
}
function sanitizeFrameOrigins(raw) {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const entry of raw) {
    const candidate = entry.trim();
    if (!isValidFrameOrigin(candidate) || seen.has(candidate)) continue;
    seen.add(candidate);
    out.push(candidate);
    if (out.length >= MAX_FRAME_ORIGINS) break;
  }
  return out;
}
function parseFrameOriginsCsv(raw) {
  return sanitizeFrameOrigins(raw.split(","));
}
var MAX_WIDGET_STARTERS = 6;
var WidgetStarterItemSchema = /* @__PURE__ */ z.object({
  label: customerTextSchema(60),
  prompt: customerTextSchema(280)
});
var WidgetStartersConfigSchema = /* @__PURE__ */ z.object({
  enabled: z.boolean().default(false),
  items: z.array(WidgetStarterItemSchema).max(MAX_WIDGET_STARTERS).default([]),
  /**
   * **Authoring state, not runtime state.** `/engagement`'s "Suggestions pick
   * themselves" card tops the list up from the capability catalog while this is
   * on, so an operator who never opens the editor still ships current openers.
   *
   * The widget never reads it: what reaches a visitor is `items`, exactly as
   * before. Auto-filled entries are ORDINARY starters — that is deliberate, and
   * it is what keeps this a curation convenience rather than a second delivery
   * path with its own failure modes.
   *
   * **Optional rather than defaulted, and the distinction is load-bearing.** A
   * `.default(false)` would make the field REQUIRED on the inferred type, so
   * every literal that constructs a starters config — fixtures, recipes, the
   * widget's own tests — would have to name a flag it does not care about, and
   * every design would gain the key on its next publish. Absence already means
   * exactly what `false` means, so absence is what a design that never touches
   * this feature stores.
   */
  autoFill: z.boolean().optional(),
  /**
   * Capability ids the operator removed from the auto picks. Auto-fill skips
   * them forever, which is what lets the card promise "remove one and we will
   * not offer it again" — without it, the next top-up would put back exactly
   * what the operator just rejected.
   *
   * Capped so a tenant with a large catalog cannot grow the design blob without
   * bound; the UI drops the oldest refusals at the cap, so the worst case is a
   * long-ago-rejected opener being offered once more.
   */
  autoFillDismissed: z.array(z.string().min(1).max(200)).max(200).optional()
});

// src/widget-config/widget-announcements.schema.ts
var WIDGET_ANNOUNCEMENT_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
var WIDGET_ANNOUNCEMENT_TITLE_MAX = 80;
var WIDGET_ANNOUNCEMENT_BODY_MAX = 280;
var WIDGET_MAX_ANNOUNCEMENTS = 20;
var WidgetAnnouncementSchema = /* @__PURE__ */ z.object({
  id: z.string().regex(WIDGET_ANNOUNCEMENT_ID_PATTERN),
  /**
   * Headline — the customer's own copy. Accepts the legacy bare string or the
   * `{ default, byLocale }` per-locale shape (F1-10 / ADR-0172 §C2), resolved to
   * the end-user's locale at render — a multilingual customer can localize the
   * headline just like the CTA chip below.
   */
  title: customerTextSchema(WIDGET_ANNOUNCEMENT_TITLE_MAX),
  /** One-line body describing the new capability (same per-locale shape as `title`). */
  body: customerTextSchema(WIDGET_ANNOUNCEMENT_BODY_MAX),
  /**
   * Optional one-tap CTA to TRY the new capability (reuses the L1 starter
   * `{label, prompt}` shape). Tapping it opens the chat with the prompt.
   */
  cta: WidgetStarterItemSchema.optional()
});
var WidgetAnnouncementsConfigSchema = /* @__PURE__ */ z.object({
  enabled: z.boolean().default(false),
  items: z.array(WidgetAnnouncementSchema).max(WIDGET_MAX_ANNOUNCEMENTS).default([])
});
var WidgetAnonymousSignInPromptSchema = /* @__PURE__ */ z.object({
  /**
   * Render the sign-in handoff (SignInCard, Phase D) when an ask needs an
   * account. Default ON so anonymous mode is a funnel, not a dead end.
   */
  enabled: z.boolean().default(true),
  /**
   * Fire the host page's own sign-in action (`syncanix:signin-requested`) on the
   * CTA click. Default OFF — opt-in, so a page with no sign-in flow degrades to
   * copy-only guidance rather than a dead button.
   */
  hostHook: z.boolean().default(false)
});
var WidgetAnonymousAccessConfigSchema = /* @__PURE__ */ z.object({
  /**
   * Z-5 / ADR-0621 — `qa_plus_tools` for all: the tools-serving mode is what
   * makes walk-published reads reach a signed-out visitor with zero config. A
   * stored `qa` written by an operator stays `qa`. (Q-AVM1 option (a) had this
   * at `qa`; the safety it bought is carried by the per-capability grants.)
   */
  mode: z.enum(["off", "qa", "qa_plus_tools"]).default("qa_plus_tools"),
  signInPrompt: WidgetAnonymousSignInPromptSchema.default({}),
  /**
   * AVM Phase B — the per-tenant anonymous daily TURN budget: a bound on
   * anonymous-visitor LLM spend, counted per tenant per UTC day; on exhaustion
   * an anonymous turn degrades to the localized off-state notice (never an
   * error, never a limits-internals leak). `0` is the KILL SWITCH — blocks all
   * anonymous LLM spend for the tenant. Non-negative integer.
   *
   * **OPTIONAL with NO DEFAULT (zero-touch V4 WP5 / Z-5, ADR-0742).** The
   * 500-turn constant this carried as its default was a bound nobody chose,
   * applied to every workspace; the operator's rule is that no anonymous bound
   * exists unless the customer sets it. ABSENT therefore means "the plan's own
   * limits apply" — `resolveAnonymousTurnCeiling` reads it with `??`, so `0`
   * keeps its meaning and absence falls through to the tier. The only default
   * bound a signed-out visitor meets is the per-visitor flood ceiling
   * (ADR-0621).
   */
  dailyTurnBudget: z.number().int().min(0).optional(),
  /**
   * AVM Phase B — require a Cloudflare Turnstile pass on anonymous turns (the
   * public embed is where bot floods originate). **Default OFF — opt-in per
   * tenant (ADR-0412, reversing the Phase B default-ON).** A bot check that
   * interrupts a visitor's first message is a conversion killer, so it must be
   * a deliberate operator choice (the Design Studio toggle), never ambient.
   * Only effective when a Turnstile secret is provisioned server-side; inert
   * otherwise (documented in ADR-0231 / Phase B). Migration 326 re-baselined
   * rows stored while the default was ON (a stored `true` under a default-ON
   * regime was a form echo, not an opt-in).
   */
  requireTurnstile: z.boolean().default(false),
  /**
   * AUP Phase B (ADR-0432) — gate the pseudonymous visitor identity on the
   * host page's CMP consent signal (`syncanix.setConsent` / TCF, relayed as
   * the `x-syncanix-visitor-consent` header). **Default OFF — the operator's
   * invisible-by-default election (Q-AUP1, 2026-08-01):** with this off, the
   * widget mints/sends the visitor id unconditionally and no consent surface is
   * consulted or rendered, anywhere. A tenant whose own counsel requires a
   * signal opts in; Syncanix never renders a consent UI of its own either way
   * (the interaction-capture doctrine — the CUSTOMER owns the consent moment).
   * When ON, the SERVER enforces the gate (`VisitorIdentityService.resolveForMint`
   * declines to mint without the asserted header), so a forked widget that
   * simply omits the check cannot un-gate a consent-requiring tenant. The
   * consent VALUE, though, is a client-supplied assertion the server trusts per
   * the interaction-capture trust model — it cannot verify the host's CMP truly
   * granted it, only that the widget said so. The `visitor_learning` ladder is
   * the other server-side precondition, without which no id ever mints.
   */
  respectConsentSignals: z.boolean().default(false)
});
var WidgetCopilotModeConfigSchema = /* @__PURE__ */ z.object({
  enabled: z.boolean().default(true),
  /**
   * ADR-0184 — the runtime UI-discovery opt-in (the amendment of ADR-0167 § 1/§ 4).
   * When true (AND `enabled`), the widget advertises the generic runtime verbs
   * (`ui_scan` + `ui_click`/`select`/`set`/`focus`/`scroll`) so the agent can
   * operate ANY approved control auto-discovered on the live DOM — not just the
   * static-scan `ui_navigate`/`highlight`/`fill`.
   *
   * **Default `true` since ADR-0488 (operator decision, 2026-08-13).** It was
   * `false` from ADR-0184 through ADR-0468, and the reason it stayed false is
   * still true and is now an accepted cost rather than a refuted one: these verbs
   * advertise on THIS flag ALONE. The turn resolver builds them without
   * consulting per-unit enablement, because runtime governance is
   * allow-by-default-with-denies — so unlike `enabled`, whose flip moved no
   * exposure (every unit beneath it is strict-absence-OFF), defaulting this on
   * genuinely widens what the agent may reach on a workspace that has configured
   * nothing.
   *
   * What still bounds it is unchanged and is why the decision is defensible: the
   * `runtimeTier` ceiling (default `writes` — destructive controls still ALWAYS
   * confirm), the operator's section/control denies, and above all ADR-0184's
   * server-authoritative `ui_scan` screen, which drops controls the agent may not
   * operate, `sanitizeToolText`-strips every label, and leaves the turn
   * provenance-untrusted so any write confirms. The widening is in what the agent
   * can SEE and REACH, not in what it may do unattended.
   *
   * Two OFF paths, added in the same change as the flip because a default that
   * widens reach needs a switch the customer can find: the `agent-page-control`
   * Labs entry for the workspace, and the `RuntimeControlMasterCard` switch on the
   * Agent UI control page for this surface, which writes `false` here directly.
   */
  runtimeDiscovery: z.boolean().default(true),
  /**
   * ADR-0184 — the runtime write-policy TIER ceiling (allow-by-default model).
   * `reads` = ui_scan/focus/scroll only; `writes` (default) = + reversible fills
   * and non-destructive clicks; `destructive` = + destructive controls (which
   * still ALWAYS confirm). Governance is otherwise allow-by-default: the operator
   * DENIES specific sections/controls to carve them out. Vocabulary matches
   * `UI_CONTROL_TIERS` in `../ui-runtime`.
   */
  runtimeTier: z.enum(["reads", "writes", "destructive"]).default("writes")
});
var WIDGET_PROACTIVE_TRIGGER_TYPES = [
  "dwell",
  "scroll",
  "exitIntent",
  "route",
  "hostEvent",
  "frustration"
];
var WIDGET_PROACTIVE_DWELL_MAX_SECONDS = 3600;
var WIDGET_PROACTIVE_ROUTE_MAX = 200;
var WIDGET_PROACTIVE_EVENT_NAME_MAX = 100;
var WIDGET_PROACTIVE_RESERVED_EVENT_NAMES = ["proactive-armed"];
var WIDGET_PROACTIVE_FRICTION_SIGNALS = [
  "rageClick",
  "deadClick",
  "repeatFailure"
];
var WIDGET_PROACTIVE_FRUSTRATION_THRESHOLD_MAX = 5;
var WidgetProactiveTriggerSchema = /* @__PURE__ */ z.discriminatedUnion("type", [
  z.object({
    type: z.literal("dwell"),
    /** Fire after the visitor has been on the page this many seconds. */
    seconds: z.number().int().min(1).max(WIDGET_PROACTIVE_DWELL_MAX_SECONDS)
  }),
  z.object({
    type: z.literal("scroll"),
    /** Fire once the visitor scrolls past this fraction of the page (1–100%). */
    percent: z.number().int().min(1).max(100)
  }),
  // Fire when the pointer leaves toward the browser chrome (exit-intent).
  z.object({ type: z.literal("exitIntent") }),
  z.object({
    type: z.literal("route"),
    /** Glob matched against the host page path (e.g. `/pricing*`). */
    pattern: z.string().min(1).max(WIDGET_PROACTIVE_ROUTE_MAX)
  }),
  z.object({
    type: z.literal("hostEvent"),
    /** A named signal the host fires via `window.syncanix` (e.g. `cartAbandoned`). */
    name: z.string().min(1).max(WIDGET_PROACTIVE_EVENT_NAME_MAX).refine(
      (name) => !WIDGET_PROACTIVE_RESERVED_EVENT_NAMES.includes(name),
      { message: "this event name is reserved for the widget lifecycle" }
    )
  }),
  // IMP-5 / ADR-0236 — fire when the visitor shows friction (rage/dead click, or
  // a repeated capability failure). CLIENT-ONLY: the detector runs in the browser
  // and emits nothing but the nudge itself.
  z.object({
    type: z.literal("frustration"),
    /** Which friction signals arm this rule; defaults to all of them. */
    signals: z.array(z.enum(WIDGET_PROACTIVE_FRICTION_SIGNALS)).nonempty().default([...WIDGET_PROACTIVE_FRICTION_SIGNALS]),
    /** How many qualifying signals in the session before firing (1..5, default 1). */
    threshold: z.number().int().min(1).max(WIDGET_PROACTIVE_FRUSTRATION_THRESHOLD_MAX).default(1)
  })
]);
var WIDGET_PROACTIVE_VISITOR_TYPES = [
  "all",
  "firstTime",
  "returning",
  "signedIn"
];
var WIDGET_PROACTIVE_LOCALES = ["en", "es", "fr", "de", "ar", "he"];
var WidgetProactiveAudienceSchema = /* @__PURE__ */ z.object({
  visitorType: z.enum(WIDGET_PROACTIVE_VISITOR_TYPES).default("all"),
  /** Restrict to these resolved locales; absent/empty → every locale. */
  locales: z.array(z.enum(WIDGET_PROACTIVE_LOCALES)).max(6).optional()
});
var WIDGET_PROACTIVE_TEXT_MAX = 280;
var WIDGET_PROACTIVE_MAX_CHIPS = 4;
var WidgetProactiveMessageSchema = /* @__PURE__ */ z.object({
  /** The nudge body — the customer's own copy (their language to localize), shown verbatim. */
  text: z.string().min(1).max(WIDGET_PROACTIVE_TEXT_MAX),
  /** Optional one-tap reply chips (reuses the L1 starter `{label, prompt}` shape). */
  chips: z.array(WidgetStarterItemSchema).max(WIDGET_PROACTIVE_MAX_CHIPS).default([])
});
var WidgetProactiveQuietHoursSchema = /* @__PURE__ */ z.object({
  start: z.number().int().min(0).max(23),
  end: z.number().int().min(0).max(23)
});
var WidgetProactiveLimitsSchema = /* @__PURE__ */ z.object({
  /** Max nudges shown in one session (default 1 — "one message, then silence"). */
  maxPerSession: z.number().int().min(1).max(10).default(1),
  /** Max nudges shown to one visitor per rolling 7 days. */
  maxPer7Days: z.number().int().min(1).max(50).default(3),
  /** After a dismiss, suppress this rule for this many hours (default 7 days). */
  cooldownAfterDismissHours: z.number().int().min(0).max(8760).default(168),
  /** Optional quiet hours; absent → no quiet window. */
  quietHours: WidgetProactiveQuietHoursSchema.optional()
});
var WIDGET_PROACTIVE_GOALS = [
  "startedChat",
  "completedAction",
  "resolvedNoHuman"
];
var WIDGET_PROACTIVE_PRESENTATIONS = ["openPanel", "bubble"];
var WIDGET_PROACTIVE_RULE_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
var WIDGET_PROACTIVE_MAX_RULES = 20;
var WidgetProactiveRuleSchema = /* @__PURE__ */ z.object({
  id: z.string().regex(WIDGET_PROACTIVE_RULE_ID_PATTERN),
  name: z.string().min(1).max(60),
  /** Per-rule switch — default off, so a newly-added rule never fires until armed. */
  enabled: z.boolean().default(false),
  trigger: WidgetProactiveTriggerSchema,
  audience: WidgetProactiveAudienceSchema.default({}),
  message: WidgetProactiveMessageSchema,
  limits: WidgetProactiveLimitsSchema.default({}),
  goal: z.enum(WIDGET_PROACTIVE_GOALS).default("startedChat"),
  /** How the fired nudge surfaces. Default `openPanel` (backward-compatible). */
  presentation: z.enum(WIDGET_PROACTIVE_PRESENTATIONS).default("openPanel")
});
var WidgetProactiveConfigSchema = /* @__PURE__ */ z.object({
  enabled: z.boolean().default(false),
  rules: z.array(WidgetProactiveRuleSchema).max(WIDGET_PROACTIVE_MAX_RULES).default([]),
  /**
   * The anti-spam limits a NEW nudge starts with — authoring state, not a
   * runtime policy. Every rule still carries and is evaluated on its OWN
   * `limits`; this is only what gets copied into one when it is created, so a
   * workspace that has decided "never more than one per session" does not have
   * to re-decide it on every nudge somebody adds.
   *
   * Deliberately NOT an evaluation-time fallback. Making it one would mean a
   * rule's behaviour could change without the rule changing, which is precisely
   * the class of surprise the per-rule limits exist to prevent — and it would
   * silently rewrite what every existing nudge does the first time this field
   * was touched.
   *
   * **Optional rather than defaulted**, the same reasoning as
   * `WidgetStartersConfigSchema`'s authoring fields: a `.default({})` makes the
   * key REQUIRED on the inferred type, so every fixture that builds a proactive
   * config would have to name limits it does not care about, and every stored
   * config would gain the key on its next save. Absent means "seed from the
   * schema's own limits", which is exactly what happened before this existed.
   */
  defaultLimits: WidgetProactiveLimitsSchema.optional()
});
var WIDGET_SIZES = ["small", "medium", "large", "fullscreen", "embedded"];
var DEFAULT_WIDGET_SIZE = "medium";
var WIDGET_TEXT_DIRECTIONS = ["ltr", "rtl", "auto"];
var WidgetSizeModeConfigSchema = /* @__PURE__ */ z.object({
  defaultSize: z.enum(WIDGET_SIZES).default(DEFAULT_WIDGET_SIZE)
});

// src/chat-limits/index.ts
var DEFAULT_MESSAGE_MAX_CHARS = 2e3;
var MESSAGE_MAX_CHARS_HARD_CAP = 8e3;
var MESSAGE_MAX_CHARS_MIN = 200;
var DEFAULT_CONTEXT_TOKEN_BUDGET = 32e3;
var HOST_ACTION_TOOL_PREFIX = "host_action__";
var HOST_ACTION_ID_PATTERN = /^[A-Za-z0-9_-]{1,48}$/;
var HOST_ACTION_NAME_PATTERN = /^host_action__[A-Za-z0-9_-]{1,48}$/;
var MAX_HOST_ACTIONS = 64;
var MAX_HOST_ACTION_DESCRIPTION_CHARS = 2e3;
var MAX_HOST_ACTION_TITLE_CHARS = 120;
var MAX_HOST_ACTION_PARAMETERS_CHARS = 8e3;
function isHostActionToolName(name) {
  return HOST_ACTION_NAME_PATTERN.test(name);
}
function isValidHostActionId(id) {
  return HOST_ACTION_ID_PATTERN.test(id);
}
function hostActionToolName(actionId) {
  return `${HOST_ACTION_TOOL_PREFIX}${actionId}`;
}
function hostActionIdFromToolName(name) {
  return name.startsWith(HOST_ACTION_TOOL_PREFIX) ? name.slice(HOST_ACTION_TOOL_PREFIX.length) : name;
}
var HostActionDeclarationSchema = /* @__PURE__ */ z.object({
  name: z.string().regex(
    HOST_ACTION_NAME_PATTERN,
    'A host-action name must be "host_action__" followed by 1\u201348 of [A-Za-z0-9_-].'
  ),
  description: z.string().min(1).max(MAX_HOST_ACTION_DESCRIPTION_CHARS),
  parameters: z.record(z.unknown()).refine((p) => JSON.stringify(p).length <= MAX_HOST_ACTION_PARAMETERS_CHARS, {
    message: `A host-action parameters object must serialize to \u2264 ${String(
      MAX_HOST_ACTION_PARAMETERS_CHARS
    )} characters.`
  }),
  /**
   * SYN-372 (ADR-0202 §4) — provenance marker. `true` when this declaration was
   * discovered by `exposePageActions` (auto-detected, unlabelled) rather than a
   * customer-authored `registerAction`. The SERVER BACKSTOP reads it: an
   * `autoDetected` declaration is DEFAULT-DROPPED from the advertised tool set
   * unless the operator enabled its id — a defense-in-depth layer over the
   * honest widget's own enabled-set filter. (A hand-rolled client that omits
   * this flag on a REPORTED auto-detected id is still dropped: that id has an
   * `active=false` store row, so it is in the SYN-87 inactive-set and filtered
   * on the `registered` path regardless of the flag. A never-reported id
   * declared as `registered` reduces to the pre-existing ADR-0129
   * client-declared surface — client-realm only, no privilege escalation,
   * ADR-0202 §5.) OPTIONAL + back-compat: the widget stamps it only on the
   * enabled auto-detected commands it forwards; a hand-registered command (and
   * a pre-SYN-372 widget) omits it ⇒ treated as `registered`.
   */
  autoDetected: z.boolean().optional(),
  /**
   * SYN-109 — the SERVER-DERIVED confirmation signal. The widget stamps the
   * declared side-effect class (from `registerAction`'s `sideEffect` option, or
   * `write` when the legacy `confirm: true` flag was set) so the SERVER — not
   * the widget's own optional `confirm` flag — decides whether a host-action
   * call must render the enforced ConfirmActionCard. Absent ⇒ `read` (ungated):
   * a benign navigate/refetch stays auto-run; an honest widget labels its
   * write/destructive actions so the server gate can fire.
   *
   * IRREDUCIBLE LIMIT (see ADR-0261): the server never executes a host action,
   * so this signal is only as trustworthy as the widget that declared it — a
   * tampered widget can lie about the class or skip the card entirely. It
   * moves confirm AUTHORITY to the server envelope for the honest widget; the
   * real backstop is the customer API's own authorization.
   */
  sideEffect: SideEffectSchema.optional(),
  /**
   * PLAN-2 §3.11.2b (Phase 4.5) / ADR-0456 — the declaration's KIND, when the
   * widget can name one. Today the only member is `nav`: a route the
   * `exposePageActions` discovery registered, whose handler does nothing but
   * move the page.
   *
   * It exists so the server can COLLAPSE many routes into one
   * `navigate_to { routeId }` tool instead of advertising a definition each.
   * The marker has to be declared rather than inferred: an auto-detected
   * button with no arguments and no side-effect class is byte-identical in
   * every other field, and collapsing one of those into a navigation tool
   * would tell the model a click is a destination.
   *
   * OPTIONAL and back-compatible in the safe direction. A widget that omits
   * it (any build predating this) is simply not collapsed — its routes stay
   * one tool each, which is the pre-Phase-4.5 surface. A hand-rolled client
   * that LIES and stamps `nav` on a write gains nothing: the collapse runs
   * AFTER the SYN-372 active-set filter, so the id must already be one the
   * operator enabled, and the resulting call is translated straight back to
   * that same id's `host_action__` envelope — the same gate, the same
   * executor, the same widget handler it would have reached unstamped.
   */
  kind: z.literal("nav").optional()
}).strict();
var ClientActionsSchema = /* @__PURE__ */ z.array(HostActionDeclarationSchema).max(MAX_HOST_ACTIONS);
var RegisteredAbilitySchema = /* @__PURE__ */ z.object({
  id: z.string().regex(HOST_ACTION_ID_PATTERN, "A registered-ability id must be 1\u201348 of [A-Za-z0-9_-]."),
  description: z.string().min(1).max(MAX_HOST_ACTION_DESCRIPTION_CHARS),
  parameters: z.record(z.unknown()).refine((p) => JSON.stringify(p).length <= MAX_HOST_ACTION_PARAMETERS_CHARS, {
    message: `A registered-ability parameters object must serialize to \u2264 ${String(
      MAX_HOST_ACTION_PARAMETERS_CHARS
    )} characters.`
  }),
  /** Whether the host action requires an explicit user confirmation before it runs. */
  confirm: z.boolean(),
  /**
   * PR-1 (ADR-0482) — the short HUMAN label for this action ("Shopping cart"),
   * as opposed to its `id`, which is a machine identifier.
   *
   * The widget has always had this: `registerAction` takes a `title`, and both
   * `exposePageActions` discovery lanes set one from the route/marker label. It
   * simply never crossed the wire, so the dashboard had nothing to show and fell
   * back to rendering the id — which for a discovered route is a slugified URL.
   * Every other tool family in the hub already resolves a human name before its
   * identifier; this is what lets page actions do the same.
   *
   * OPTIONAL, and it must stay optional: a pre-PR-1 widget omits it, and an
   * action registered without a title has none to send. The consumer falls back
   * to the id, which is exactly today's behaviour.
   */
  title: z.string().min(1).max(MAX_HOST_ACTION_TITLE_CHARS).optional(),
  /**
   * SYN-357 (ADR-0202) — provenance of the command. `registered` = a
   * customer-authored `registerAction` call (labelled, vetted). `auto-detected`
   * = discovered by `exposePageActions` (no customer risk label). The server
   * PERSISTS this provenance (migration 182) and governs an `auto-detected`
   * command as a stricter, OFF-until-reviewed class (SYN-372): it is stored
   * inactive, approved by the operator in the dashboard, and only then
   * delivered back to the widget as callable. OPTIONAL for back-compat: a
   * pre-SYN-357 widget omits it (⇒ `registered` downstream), so `.strict()`
   * still accepts an older report.
   */
  source: z.enum(["registered", "auto-detected"]).optional()
}).strict();
var RegisteredAbilityReportSchema = /* @__PURE__ */ z.array(RegisteredAbilitySchema).max(MAX_HOST_ACTIONS);

// src/widget-config/widget-config-document.ts
var WidgetSessionsConfigSchema = /* @__PURE__ */ z.object({
  historyEnabled: z.boolean().default(true),
  maxStoredConversations: z.number().int().min(1).max(1e3).default(50),
  // ADR-0163 — lowered from 128k so a long conversation stops re-sending an
  // unbounded prefix every turn. Tenant-overridable up to the provider ceiling.
  contextTokenLimit: z.number().int().min(1e3).max(1e6).default(DEFAULT_CONTEXT_TOKEN_BUDGET),
  // ADR-0163 — per-message character cap the composer enforces. Default is the
  // industry norm; a workspace can tune it within the shared bounds (the server
  // still hard-caps at MESSAGE_MAX_CHARS_HARD_CAP regardless).
  maxMessageChars: z.number().int().min(MESSAGE_MAX_CHARS_MIN).max(MESSAGE_MAX_CHARS_HARD_CAP).default(DEFAULT_MESSAGE_MAX_CHARS)
});
var WidgetLocalizationConfigSchema = /* @__PURE__ */ z.object({
  direction: z.enum(WIDGET_TEXT_DIRECTIONS).default("auto")
});
var WidgetDisclosureConfigSchema = /* @__PURE__ */ z.object({
  aiDisclosureText: z.string().min(1).max(280).default("Responses are AI-generated.")
});
var WIDGET_AVAILABILITY_MODES = [
  "normal",
  "hidden",
  "disabled",
  "unavailable_reply"
];
var WIDGET_UNAVAILABLE_MESSAGE_MAX = 280;
var WidgetAvailabilityConfigSchema = /* @__PURE__ */ z.object({
  mode: z.enum(WIDGET_AVAILABILITY_MODES).default("normal"),
  /**
   * Optional customer override for the "not available right now" notice shown in
   * `disabled` / `unavailable_reply` modes. Empty (the default) → the widget
   * renders its built-in, per-locale translated default. A single
   * customer-authored string (not per-locale), mirroring
   * `disclosure.aiDisclosureText`; trimmed-empty is treated as absent at render.
   */
  unavailableMessage: z.string().max(WIDGET_UNAVAILABLE_MESSAGE_MAX).default("")
});
var WIDGET_MAX_DISABLED_ACTIONS = 200;
var WidgetHostActionsConfigSchema = /* @__PURE__ */ z.object({
  enabled: z.boolean().default(true),
  disabledActionIds: z.array(z.string().regex(HOST_ACTION_ID_PATTERN)).max(WIDGET_MAX_DISABLED_ACTIONS).default([])
});
var WidgetFrameAgentConfigSchema = /* @__PURE__ */ z.object({
  origins: z.array(z.string()).default([]).transform((list2) => [...sanitizeFrameOrigins(list2)])
});
var WidgetConfigDocumentSchema = /* @__PURE__ */ z.object({
  theme: WidgetThemeConfigSchema.default({}),
  // The key keeps the `sizeMode` name although the `mode` half went with the
  // split view (ADR-0571) and only `defaultSize` remains. It is a PERSISTED key:
  // renaming it would not be a tidy-up but a migration, and one that silently
  // LOSES every stored value, because `z.object` drops what it does not
  // recognise. The schema's own name mirrors it for the same reason.
  sizeMode: WidgetSizeModeConfigSchema.default({}),
  richComponents: WidgetRichComponentsConfigSchema.default({}),
  hostActions: WidgetHostActionsConfigSchema.default({}),
  copilotMode: WidgetCopilotModeConfigSchema.default({}),
  sessions: WidgetSessionsConfigSchema.default({}),
  localization: WidgetLocalizationConfigSchema.default({}),
  disclosure: WidgetDisclosureConfigSchema.default({}),
  availability: WidgetAvailabilityConfigSchema.default({}),
  proactive: WidgetProactiveConfigSchema.default({}),
  announcements: WidgetAnnouncementsConfigSchema.default({}),
  // AVM Phase A — the anonymous (signed-out visitor) access posture (off / qa /
  // qa_plus_tools). Deny-by-default tool access is enforced server-side
  // regardless; this carries the tenant's authored mode. Default `qa` (Q-AVM1 a).
  anonymousAccess: WidgetAnonymousAccessConfigSchema.default({}),
  // WS-C / ADR-0277 / CHC P5 — the cross-origin frame-agent allow-list (default OFF).
  frameAgent: WidgetFrameAgentConfigSchema.default({})
});
var DEFAULT_WIDGET_CONFIG = WidgetConfigDocumentSchema.parse({});
function parseWidgetConfig(input) {
  return WidgetConfigDocumentSchema.parse(input);
}
function safeParseWidgetConfig(input) {
  return WidgetConfigDocumentSchema.safeParse(input);
}
var WIDGET_HOME_SECTIONS = [
  "greeting",
  "digest",
  "resume",
  "units",
  "starters",
  "announcements",
  "recall"
];
var IDENTITY_HOME_SECTIONS = ["digest", "recall"];
var DEFAULT_HOME_SECTIONS = WIDGET_HOME_SECTIONS;
function isKnownSection(value) {
  return WIDGET_HOME_SECTIONS.includes(value);
}
var sectionList = /* @__PURE__ */ z.array(z.string().max(32)).max(WIDGET_HOME_SECTIONS.length * 2).transform((list2) => {
  const seen = /* @__PURE__ */ new Set();
  for (const raw of list2) {
    if (isKnownSection(raw)) seen.add(raw);
  }
  return [...seen];
});
var WidgetHomeConfigSchema = /* @__PURE__ */ z.object({
  /**
   * Whether the operator has arranged the home at all.
   *
   * Default FALSE, and that is the whole rollout story: until a workspace opts
   * in, the panel composes exactly what it composes today, so this key shipping
   * changes nothing for anybody. `sections` is deliberately allowed to be empty
   * — an operator part-way through arranging has not yet chosen, and an empty
   * arrangement resolves to today's order rather than to a blank panel.
   */
  enabled: z.boolean().default(false),
  /** The arrangement a VERIFIED visitor sees. Empty ⇒ the default reading. */
  sections: sectionList.default([]),
  /**
   * The arrangement a SIGNED-OUT visitor sees.
   *
   * Absent is the common case and means "the same arrangement, minus what a
   * signed-out visitor has none of" — the Intercom Spaces lesson stated as a
   * default rather than as a form field, because the operator who does not care
   * should not have to arrange the home twice. Present, it is taken as the order
   * and still identity-filtered: a visitor arrangement naming `digest` would
   * otherwise be an operator arranging a blank.
   */
  visitorSections: sectionList.optional()
});
function resolveHomeSections(config, options) {
  const chosen = !config?.enabled ? [] : !options.verified && config.visitorSections !== void 0 ? config.visitorSections : config.sections;
  const ordered = [...chosen, ...DEFAULT_HOME_SECTIONS.filter((s) => !chosen.includes(s))];
  return options.verified ? ordered : ordered.filter((section) => !IDENTITY_HOME_SECTIONS.includes(section));
}
var WIDGET_LAUNCHER_SHAPES = ["circle", "rounded", "square"];
var WIDGET_LAUNCHER_ICONS = ["default", "chat", "help", "sparkle", "none"];
var WIDGET_LAUNCHER_POSITIONS = [
  "bottom-end",
  "bottom-start",
  "top-end",
  "top-start"
];
var hexColor2 = /* @__PURE__ */ z.string().regex(/^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/, "must be a 3- or 6-digit hex color");
var WidgetLauncherBadgeSchema = /* @__PURE__ */ z.object({
  enabled: z.boolean().default(true),
  color: hexColor2.optional()
});
var WIDGET_LAUNCHER_BLOCK_SIDES = ["top", "bottom"];
var WIDGET_LAUNCHER_INLINE_SIDES = ["left", "right", "start", "end"];
var WidgetLauncherPlacementSchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("corner"),
    block: z.enum(WIDGET_LAUNCHER_BLOCK_SIDES),
    inline: z.enum(WIDGET_LAUNCHER_INLINE_SIDES)
  })
]);
function isScreenAnchoredPlacement(placement) {
  return placement.inline === "left" || placement.inline === "right";
}
var WIDGET_LAUNCHER_MARK_KINDS = ["icon", "agent", "image"];
var WidgetLauncherMarkSchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("icon"), icon: z.enum(WIDGET_LAUNCHER_ICONS) }),
  z.object({ kind: z.literal("agent") }),
  z.object({ kind: z.literal("image"), src: WidgetHeaderLogoImageSrcSchema })
]);
var WidgetLauncherConfigSchema = /* @__PURE__ */ z.object({
  icon: z.enum(WIDGET_LAUNCHER_ICONS).default("default"),
  shape: z.enum(WIDGET_LAUNCHER_SHAPES).default("circle"),
  position: z.enum(WIDGET_LAUNCHER_POSITIONS).default("bottom-end"),
  /**
   * SYN-746 — where the launcher sits, and whether that corner is a SCREEN
   * corner or a READING side. Supersedes {@link WidgetLauncherConfigSchema.shape.position}
   * as the source of truth; `position` is dual-written for older widget bundles
   * and is now permanent legacy (see the ADR).
   *
   * **Why a new field rather than widening `position`.** The widget re-validates
   * the delivered design and drops the ENTIRE design — colours, fonts, copy,
   * custom CSS — when this schema fails. A widget is cached on the visitor's
   * machine, so widening an existing enum strips branding off live sites for
   * every bundle that has not learned the new value. An unknown KEY is stripped
   * harmlessly; an unknown VALUE is not. That asymmetry is the whole reason for
   * the shape.
   *
   * **Why the anchor lives inside the value.** `inline: 'right'` means the right
   * of the screen; `inline: 'end'` means the side reading finishes on, which is
   * the right on English sites and the left on Hebrew and Arabic ones. A
   * separate "mirror?" flag was considered and rejected: it is meaningless for
   * the positions this union is designed to grow into — a centre-bottom
   * placement mirrors to itself, a docked rail is not a corner, and a pixel
   * offset has no reading side at all.
   *
   * `.catch(undefined)` is the forward-compatibility lever, and it has to be
   * here from the first version: a bundle meeting a future variant degrades to
   * "no placement override" and falls back to `position`, instead of discarding
   * the design.
   */
  placement: WidgetLauncherPlacementSchema.optional().catch(void 0),
  /**
   * SYN-773 — the operator's single choice of what the bubble shows. Absent ⇒ the
   * legacy `avatarUrl`-then-`icon` pair still describes it (see
   * {@link WidgetLauncherMarkSchema} and `resolveLauncherMark`), so a design
   * stored before this key renders exactly as it always did.
   */
  mark: WidgetLauncherMarkSchema.optional().catch(void 0),
  /**
   * Customer-authored launcher label (their own copy — not a catalog key).
   * Bare string or `{ default, byLocale }` per-locale variants (F1-10 /
   * ADR-0172 §C2), like every customer-copy field.
   */
  label: customerTextSchema(60).optional(),
  /**
   * Permanent legacy (SYN-773): dual-written beside {@link mark} so a cached
   * older bundle still renders something sensible. Deliberately NOT widened to
   * the 64 KB logo validator — an oversized value stored here would fail every
   * cached bundle's validation and drop the whole design. The launcher's own
   * upload lives in `mark.image.src` instead.
   */
  avatarUrl: z.string().url().max(2048).optional(),
  /** The unread-badge gate + color (ADR-0147 renderer, authored per design). */
  badge: WidgetLauncherBadgeSchema.default({})
});
var hexColor3 = /* @__PURE__ */ z.string().regex(/^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/, "must be a 3- or 6-digit hex color");
var fontStack = /* @__PURE__ */ z.string().min(1).max(200);
var radiusScale2 = /* @__PURE__ */ z.number().min(0).max(4);
var WidgetSizeOverrideSchema = /* @__PURE__ */ z.object({
  accentColor: hexColor3.optional(),
  radiusScale: radiusScale2.optional(),
  fontFamily: fontStack.optional(),
  aiFontFamily: fontStack.optional(),
  userFontFamily: fontStack.optional(),
  iconStyle: z.enum(WIDGET_ICON_STYLES).optional(),
  loadingAnimation: z.enum(WIDGET_LOADING_ANIMATIONS).optional()
});
var WidgetSizeOverridesSchema = /* @__PURE__ */ z.object({
  small: WidgetSizeOverrideSchema.optional(),
  medium: WidgetSizeOverrideSchema.optional(),
  large: WidgetSizeOverrideSchema.optional(),
  fullscreen: WidgetSizeOverrideSchema.optional(),
  embedded: WidgetSizeOverrideSchema.optional()
});
var WIDGET_THEME_KEY_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;
var WidgetThemeKeySchema = /* @__PURE__ */ z.string().min(1).max(60).regex(WIDGET_THEME_KEY_PATTERN, "theme key must be a lowercase slug (letters, digits, hyphens)");

// src/widget-config/widget-design.schema.ts
var WIDGET_DESIGN_KINDS = ["default-light", "default-dark", "detected", "custom"];
var hexColor4 = /* @__PURE__ */ z.string().regex(/^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/, "must be a 3- or 6-digit hex color");
var fontStack2 = /* @__PURE__ */ z.string().min(1).max(200);
var radiusScale3 = /* @__PURE__ */ z.number().min(0).max(4);
var WidgetCopyConfigSchema = /* @__PURE__ */ z.object({
  /** Empty-state title INSIDE the open panel (the localized default is "How can I help?"). */
  greeting: customerTextSchema(280).optional(),
  /**
   * SYN-594 / ADR-0299 — the launcher **callout**: an invite bubble anchored to
   * the CLOSED launcher, shown once until dismissed. Deliberately its own field
   * rather than a second meaning for {@link greeting} (the panel empty-state
   * title): one string cannot honestly be both an inside-the-panel heading and
   * an outside-the-panel invite. Absent ⇒ **no bubble** — the widget never
   * invents an invite, so proactivity stays opt-in by authoring.
   */
  callout: customerTextSchema(280).optional(),
  placeholder: customerTextSchema(140).optional(),
  emptyState: customerTextSchema(280).optional(),
  /** Header title override (the localized default is "Ask Syncanix"). */
  headerTitle: customerTextSchema(60).optional(),
  /** Header subtitle override (the localized default is "AI assistant"). */
  headerSubtitle: customerTextSchema(60).optional(),
  /**
   * SYN-750 — the author label above each assistant answer. Absent ⇒ the rows
   * inherit `base.agent.name`, and absent that, the localized catalog default.
   * Deliberately NOT inherited from {@link headerTitle}: that is a title ("Ask
   * Acme"), and a title in an author slot reads as a bug.
   */
  assistantName: customerTextSchema(60).optional(),
  /** Send-button accessible-label override (the localized default is "Send"). */
  sendLabel: customerTextSchema(60).optional(),
  /**
   * Persistent AI-disclaimer footer override (the localized default is
   * "AI can be inaccurate. Verify important information.").
   */
  disclaimer: customerTextSchema(200).optional(),
  /**
   * First-interaction disclosure-banner body override (the localized default is
   * the EU AI Act Article 50 "this is a conversation with an AI assistant" copy).
   */
  disclosureBanner: customerTextSchema(400).optional()
});
var WIDGET_EMPTY_LOGO_KINDS = ["brand", "image", "none"];
var WIDGET_EMPTY_LOGO_SIZES = ["sm", "md", "lg", "xl"];
var WidgetEmptyLogoConfigSchema = /* @__PURE__ */ z.object({
  kind: z.enum(WIDGET_EMPTY_LOGO_KINDS).default("brand"),
  imageUrl: WidgetLogoImageSrcSchema.optional(),
  size: z.enum(WIDGET_EMPTY_LOGO_SIZES).default("lg")
});
var WidgetChromeConfigSchema = /* @__PURE__ */ z.object({
  /** Show the header title ("Ask Syncanix" / the `copy.headerTitle` override). */
  headerTitle: z.boolean().default(true),
  /** Show the header subtitle ("AI assistant" / the `copy.headerSubtitle` override). */
  headerSubtitle: z.boolean().default(true),
  /** Show the conversation-history button in the header (when a session backs it). */
  historyButton: z.boolean().default(true),
  /** Show the full persistent "AI can be inaccurate" footer sentence (opt-in). */
  aiDisclaimer: z.boolean().default(false),
  /** Show the first-interaction AI-disclosure banner (EU AI Act Article 50). */
  disclosureBanner: z.boolean().default(true),
  /** Show the compact persistent "AI" indicator (expands to the full notice). */
  aiBadge: z.boolean().default(true),
  /** The empty-state ("How can I help?") logo. */
  emptyLogo: WidgetEmptyLogoConfigSchema.default({}),
  /**
   * SYN-748 — the chat HEADER avatar image (the mark beside the header title,
   * on screen for every turn rather than only the welcome screen). Absent ⇒ the
   * Syncanix brand glyph, which is exactly today's look, so a design stored
   * before this field shipped renders unchanged.
   *
   * A bare optional URL rather than a `kind` enum: the field has exactly two
   * states (an image, or the brand default), and an enum would buy nothing while
   * costing a forward-compat hazard — the widget re-validates the delivered
   * design and drops the ENTIRE design when the schema fails, and bundles are
   * cached on visitor machines. An unknown KEY is stripped harmlessly; an
   * unknown VALUE in an existing enum is not (the same asymmetry that made
   * `launcher.placement` a new key rather than a widened `position`, SYN-746).
   *
   * Capped at {@link WIDGET_HEADER_LOGO_IMAGE_MAX_BYTES} — a quarter of the
   * empty-state cap, because this renders at 2.25rem and the bytes ride inline
   * in the config on every widget boot.
   */
  headerLogoUrl: WidgetHeaderLogoImageSrcSchema.optional(),
  /**
   * SYN-748 — show the presence dot on the header avatar. Its own boolean rather
   * than part of the logo: it signals "the assistant is online", so it is
   * orthogonal to WHICH mark is shown and belongs with the visibility flags it
   * sits beside. Defaults on (today's behaviour).
   */
  headerStatusDot: z.boolean().default(true),
  /**
   * SYN-750 — a per-surface OVERRIDE for the mark beside each answer. Absent ⇒
   * the message rows inherit `base.agent.avatarUrl`, and absent that, the
   * Syncanix brand glyph. Exists for the tenant who genuinely wants the message
   * rows to differ from the header; the default path never asks about it.
   */
  messageLogoUrl: WidgetHeaderLogoImageSrcSchema.optional()
});
var WidgetDesignBaseSchema = /* @__PURE__ */ z.object({
  accentColor: hexColor4.default("#4f46e5"),
  fontFamily: fontStack2.default("inherit"),
  aiFontFamily: fontStack2.optional(),
  userFontFamily: fontStack2.optional(),
  radiusScale: radiusScale3.default(1),
  /**
   * SYN-672 — per-bubble corner-rounding override for the CHAT message bubbles,
   * independent of the global {@link radiusScale}. Scheme-independent (one value
   * for light + dark). **Unset ⇒ the bubbles inherit the global radius** (no
   * token emitted, so the runtime falls back to the fixed `--syncanix-radius-md`
   * / `-sm` — exactly today's look; no migration needed). When set, the widget
   * emits `--syncanix-user-bubble-radius` (main) + `--syncanix-user-bubble-radius-tail`
   * (the squared tail corner), both scaled from this value. Same 0–4 range as
   * `radiusScale`.
   */
  bubbleRadiusScale: radiusScale3.optional(),
  iconStyle: z.enum(WIDGET_ICON_STYLES).default("outline"),
  loadingAnimation: z.enum(WIDGET_LOADING_ANIMATIONS).default("dots"),
  /**
   * SYN-750 — the agent's identity (name + face) that the launcher, the header
   * and the message rows all inherit from. See `./agent-identity` for the
   * override chains and why they live in one place.
   */
  agent: WidgetAgentConfigSchema.default({}),
  launcher: WidgetLauncherConfigSchema.default({}),
  copy: WidgetCopyConfigSchema.default({}),
  starters: WidgetStartersConfigSchema.default({}),
  chrome: WidgetChromeConfigSchema.default({}),
  /**
   * E4 — how the panel's HOME (empty state) is arranged, and whether a
   * signed-out visitor sees a different arrangement. Default-disabled, so a
   * design stored before this field shipped composes exactly what it composes
   * today. See `./widget-home.schema` for why the section list accepts strings
   * rather than an enum.
   */
  home: WidgetHomeConfigSchema.default({}),
  /**
   * Categorical chart palette override — the per-series / per-slice colours the
   * generative-UI `chart` primitive cycles through (`--syncanix-chart-1..8`).
   * Scheme-independent (one ramp for light + dark). Absent → the themed default
   * ramp (`chart-1` tracks the brand accent; 2–8 a balanced default ramp). When
   * set, each entry overrides `--syncanix-chart-{i+1}` in order; fewer than 8
   * entries leave the remaining slots at their defaults. Hex only, max 8.
   */
  chartPalette: z.array(hexColor4).max(8).optional(),
  customCss: z.string().max(CSS_OVERRIDE_MAX_BYTES).optional()
});
var WidgetPaletteSchema = /* @__PURE__ */ z.object({
  backgroundColor: hexColor4.optional(),
  foregroundColor: hexColor4.optional(),
  destructiveColor: hexColor4.optional(),
  elementColors: WidgetElementColorsSchema.default({}),
  componentOverrides: WidgetComponentOverridesSchema.default({}),
  /**
   * Categorical chart palette override — the per-series / per-slice colours the
   * generative-UI `chart` primitive cycles through (`--syncanix-chart-1..8`).
   * When present it WINS over {@link WidgetDesignBase.chartPalette} (the shared
   * ramp). Absent → the base ramp (if any), else the built-in themed default.
   * Hex only, max 8, positional (slot order is the CVD-safety mechanism — never
   * reorder).
   */
  chartPalette: z.array(hexColor4).max(8).optional()
});
var DESIGN_LANGUAGE_FOLLOW_VISITOR = "visitor";
var WIDGET_DESIGN_LANGUAGES = [
  "auto",
  DESIGN_LANGUAGE_FOLLOW_VISITOR,
  ...LOCALE_CODES
];
var WidgetDesignContentSchema = /* @__PURE__ */ z.object({
  base: WidgetDesignBaseSchema.default({}),
  /**
   * The design's ONE palette.
   *
   * This replaced a `light` + `dark` pair selected at runtime by a
   * `schemeStrategy`. A design is now simply the colours it carries: to ship a
   * dark widget you author a dark design, rather than authoring the dark half
   * of every design and hoping the strategy picks it.
   *
   * The consequence is deliberate and worth stating where the field is
   * declared: unset slots fall back to the widget's LIGHT token defaults, so an
   * authored design can no longer follow the host page from light to dark. That
   * axis is gone from the model, not merely defaulted.
   *
   * One carve-out, and it is the design's KIND rather than a scheme anyone
   * chose: a `detected` design carries no palette at all — it mirrors the host
   * site, including the host's own light/dark (`composeTheme`). Pinning it light
   * would render a light widget on a dark site, which is the one thing it exists
   * not to do.
   */
  palette: WidgetPaletteSchema.default({}),
  /**
   * ADR-0271 — forced UI language; `auto` follows the host page (ADR-0411),
   * `visitor` follows the browser (SYN-747), a concrete locale forces.
   *
   * **`.catch` is load-bearing, not defensive padding.** `validateDesign`
   * (`apps/widget/src/config-delivery/parse-delivery.ts`) returns `null` on ANY
   * failure of this schema, which discards the ENTIRE design — colours, fonts,
   * copy, custom CSS — not just this field. Without the catch, the first widget
   * bundle that had not yet learned a newly-added value would strip the design
   * off live customer sites until it refreshed. With it, an unrecognised value
   * degrades to "follow the site", which is the safest of the three modes.
   */
  language: z.enum(WIDGET_DESIGN_LANGUAGES).default("auto").catch("auto"),
  /** ADR-0271 — forced direction, feeding BOTH ADR-0217 frames; `auto` derives. */
  textDirection: z.enum(WIDGET_TEXT_DIRECTIONS).default("auto"),
  sizeOverrides: WidgetSizeOverridesSchema.default({})
});
var WidgetDesignSchema = WidgetDesignContentSchema.extend({
  id: z.string().uuid(),
  name: z.string().min(1).max(60),
  kind: z.enum(WIDGET_DESIGN_KINDS),
  isBuiltIn: z.boolean().default(false),
  themeKey: WidgetThemeKeySchema.nullable().default(null)
  // host-facing key (SYN-6)
});
var DEFAULT_WIDGET_DESIGN_CONTENT = WidgetDesignContentSchema.parse(
  {}
);
function parseWidgetDesign(input) {
  return WidgetDesignSchema.parse(input);
}
function safeParseWidgetDesign(input) {
  return WidgetDesignSchema.safeParse(input);
}
function designContentHash(content) {
  const parsed = WidgetDesignContentSchema.safeParse(content);
  return contentHash(parsed.success ? parsed.data : content);
}

// src/widget-config/detected-design.ts
var HEX = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
function isAdoptableHexColor(value) {
  return HEX.test(value);
}
var BASE_RADIUS_REM = 0.625;
function clamp2(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
function parseRadiusScale(raw) {
  if (raw === void 0) return void 0;
  const match = /^(-?\d*\.?\d+)(rem|px)$/.exec(raw.trim());
  if (match === null) return void 0;
  const value = Number(match[1]);
  if (!Number.isFinite(value)) return void 0;
  const rem = match[2] === "px" ? value / 16 : value;
  return clamp2(rem / BASE_RADIUS_REM, 0, 4);
}
function hasDetectedBrandAccent(report) {
  const value = report.tokens["--syncanix-primary"];
  return value !== void 0 && HEX.test(value);
}
function detectedDesignFromReport(report) {
  const { tokens } = report;
  const hex = (name) => {
    const value = tokens[name];
    return value !== void 0 && HEX.test(value) ? value : void 0;
  };
  const palette = {
    backgroundColor: hex("--syncanix-background"),
    foregroundColor: hex("--syncanix-foreground"),
    destructiveColor: hex("--syncanix-destructive")
  };
  return WidgetDesignContentSchema.parse({
    base: {
      accentColor: hex("--syncanix-primary"),
      fontFamily: tokens["--syncanix-font-family"],
      radiusScale: parseRadiusScale(tokens["--syncanix-radius"]),
      iconStyle: report.iconStyle
    },
    palette,
    sizeOverrides: {}
  });
}

// src/widget-config/detected-suggestions.ts
var DETECTED_SUGGESTION_TOKEN_NAMES = {
  accentColor: "--syncanix-primary",
  backgroundColor: "--syncanix-background",
  foregroundColor: "--syncanix-foreground",
  destructiveColor: "--syncanix-destructive",
  fontFamily: "--syncanix-font-family",
  radiusScale: "--syncanix-radius"
};
var DETECTED_STYLE_DOMAINS = {
  // Colour surface
  "--syncanix-primary": "color",
  "--syncanix-primary-foreground": "color",
  "--syncanix-background": "color",
  "--syncanix-foreground": "color",
  "--syncanix-muted": "color",
  "--syncanix-muted-foreground": "color",
  "--syncanix-border": "color",
  "--syncanix-ring": "color",
  "--syncanix-destructive": "color",
  "--syncanix-destructive-foreground": "color",
  "--syncanix-link": "color",
  // Typography
  "--syncanix-font-family": "typography",
  "--syncanix-font-family-heading": "typography",
  "--syncanix-line-height-base": "typography",
  "--syncanix-letter-spacing-base": "typography",
  "--syncanix-measure": "typography",
  // Shape
  "--syncanix-radius": "shape",
  "--syncanix-radius-sm": "shape",
  "--syncanix-radius-md": "shape",
  "--syncanix-radius-lg": "shape",
  "--syncanix-radius-full": "shape",
  "--syncanix-avatar-radius": "shape",
  // Elevation
  "--syncanix-shadow-lg": "elevation",
  "--syncanix-shadow-xl": "elevation",
  // Spacing
  "--syncanix-spacing": "spacing",
  "--syncanix-spacing-sm": "spacing",
  // Motion
  "--syncanix-motion-duration": "motion",
  "--syncanix-motion-easing": "motion",
  // Icon treatment
  "--syncanix-icon-stroke-width": "icon"
};
function detectedStyleDomain(token) {
  return DETECTED_STYLE_DOMAINS[token];
}
var CUSTOM_PROPERTY_NAME = /^--[a-z][a-z0-9-]*$/i;
var VALUE_BREAKOUT = /[;{}]|\/\*|\*\//;
function adoptedStyleOverrideCss(input) {
  if (!CUSTOM_PROPERTY_NAME.test(input.token)) return void 0;
  const value = input.value.trim();
  if (value === "" || VALUE_BREAKOUT.test(value)) return void 0;
  const comment = input.comment?.replace(/\/\*|\*\//g, " ").replace(/[<>]/g, " ").trim();
  const commentLine = comment !== void 0 && comment !== "" ? `/* ${comment} */
` : "";
  const css = `${commentLine}:host {
  ${input.token}: ${value} !important;
}`;
  return validateCustomCss(css).ok ? css : void 0;
}
function customCssDeclaresToken(css, token) {
  if (css === void 0 || css === "" || !CUSTOM_PROPERTY_NAME.test(token)) return false;
  const escaped = token.replace(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
  return new RegExp(`${escaped}\\s*:`).test(css);
}
var FONT_STACK_MAX = 200;
function isAdoptableFontStack(value) {
  return value.trim().length > 0 && value.length <= FONT_STACK_MAX;
}
function detectedSuggestionsFromTokens(tokens) {
  const first = /* @__PURE__ */ new Map();
  for (const entry of tokens) {
    if (!first.has(entry.token)) first.set(entry.token, entry);
  }
  const suggest = (name, parse2) => {
    const entry = first.get(name);
    if (entry === void 0) return void 0;
    const value = parse2(entry.value);
    if (value === void 0) return void 0;
    return { value, source: entry.source, confidence: entry.confidence };
  };
  const hex = (value) => isAdoptableHexColor(value) ? value : void 0;
  const font = (value) => isAdoptableFontStack(value) ? value : void 0;
  const names2 = DETECTED_SUGGESTION_TOKEN_NAMES;
  const accentColor = suggest(names2.accentColor, hex);
  const backgroundColor = suggest(names2.backgroundColor, hex);
  const foregroundColor = suggest(names2.foregroundColor, hex);
  const destructiveColor = suggest(names2.destructiveColor, hex);
  const fontFamily = suggest(names2.fontFamily, font);
  const radiusScale4 = suggest(names2.radiusScale, parseRadiusScale);
  return {
    ...accentColor !== void 0 ? { accentColor } : {},
    ...backgroundColor !== void 0 ? { backgroundColor } : {},
    ...foregroundColor !== void 0 ? { foregroundColor } : {},
    ...destructiveColor !== void 0 ? { destructiveColor } : {},
    ...fontFamily !== void 0 ? { fontFamily } : {},
    ...radiusScale4 !== void 0 ? { radiusScale: radiusScale4 } : {}
  };
}

// src/widget-config/radius-scale.ts
var BASE_RADIUS_REM2 = 0.625;
var BASE_RADIUS_SM_REM = 0.375;
var BASE_RADIUS_MD_REM = 0.875;
var BASE_RADIUS_LG_REM = 1.25;
var RADIUS_CAP_REM = 1;
var RADIUS_SM_CAP_REM = 0.5;
var RADIUS_MD_CAP_REM = 1.125;
var RADIUS_LG_CAP_REM = 2;
var RADIUS_SCALE_MIN = 0;
var RADIUS_SCALE_MAX = 4;
var RADIUS_SCALE_STEP = 0.25;
function clampScale(scale) {
  if (!Number.isFinite(scale)) return 1;
  return Math.min(Math.max(scale, RADIUS_SCALE_MIN), RADIUS_SCALE_MAX);
}
function scaledRadius(baseRem, scale, capRem) {
  const s = clampScale(scale);
  if (s <= 1) return baseRem * s;
  const cap = Math.max(capRem, baseRem);
  const rem = baseRem + (cap - baseRem) * (1 - Math.exp(-1 * (s - 1)));
  return rem;
}
function scaledRadiusRem(baseRem, scale, capRem) {
  return `${Number(scaledRadius(baseRem, scale, capRem).toFixed(4))}rem`;
}
function cappedExtractedRadiusPx(px, capRem, rootFontSizePx) {
  if (!Number.isFinite(px) || px <= 0) return 0;
  if (!Number.isFinite(capRem) || !Number.isFinite(rootFontSizePx)) return px;
  const capPx = capRem * rootFontSizePx;
  if (capPx <= 0) return px;
  return Math.min(px, capPx);
}

// src/widget-config/embed-origin.ts
function isEmbedOriginAllowed(allowedOrigins, src) {
  const target = normalizeEmbedOrigin(src);
  if (target === null) {
    return false;
  }
  return allowedOrigins.some((allowed) => normalizeEmbedOrigin(allowed) === target);
}
function normalizeEmbedOrigin(value) {
  try {
    const url = new URL(value);
    if (url.protocol !== "https:") return null;
    if (url.username !== "" || url.password !== "") return null;
    return url.origin;
  } catch {
    return null;
  }
}

// src/widget-config/size-meta.ts
var WIDGET_SIZE_META = {
  small: { label: "Compact", summary: "400 \xD7 600 \u2014 a compact panel." },
  medium: { label: "Comfortable", summary: "600 \xD7 720 \u2014 a roomy panel." },
  large: { label: "Expanded", summary: "900 \xD7 820 \u2014 a large panel." },
  fullscreen: { label: "Full screen", summary: "Fills the viewport." },
  embedded: {
    label: "Embedded",
    summary: "Renders inline inside a host element on your page."
  }
};

// src/widget-config/builtin-designs.ts
var SEED_LAUNCHER_PLACEMENT = {
  base: { launcher: { placement: { kind: "corner", block: "bottom", inline: "right" } } }
};
var DARK_SEED_PALETTE = {
  backgroundColor: "#0f172a",
  foregroundColor: "#f9fafb",
  destructiveColor: "#f87171"
};
var DARK_SEED_ACCENT = "#3b82f6";
var BUILTIN_DESIGN_SEEDS = [
  {
    // No palette — the same look it has always had. It carried `force-light`
    // and no colours, so the widget pinned the light token set and let the host
    // cascade through; every non-detected design pins light now, so dropping
    // the strategy leaves this seed rendering exactly what it did.
    name: "Default Light",
    kind: "default-light",
    content: WidgetDesignContentSchema.parse({ ...SEED_LAUNCHER_PLACEMENT })
  },
  {
    // The one seed whose look would otherwise have CHANGED. Its darkness came
    // entirely from `schemeStrategy: 'force-dark'` selecting the dark token set;
    // with that gone, an empty palette renders light. Stating the dark colours
    // is what keeps every live site using this design looking the way it does.
    name: "Default Dark",
    kind: "default-dark",
    content: WidgetDesignContentSchema.parse({
      base: { accentColor: DARK_SEED_ACCENT, ...SEED_LAUNCHER_PLACEMENT.base },
      palette: DARK_SEED_PALETTE
    })
  },
  {
    // No palette either, and what still separates it from `Default Light` is its
    // KIND: a detected design follows the host's own light/dark, where every
    // other design pins light (`composeTheme`).
    name: "Detected",
    kind: "detected",
    content: WidgetDesignContentSchema.parse({
      ...SEED_LAUNCHER_PLACEMENT
    })
  }
];
var IMPORTED_DESIGN_NAME = "Imported";

// src/widget-config/chart-palette-presets.ts
var CHART_PALETTE_SLOTS = 8;
var CHART_PALETTE_PRESET_IDS = ["signal", "aurora", "vivid"];
var SIGNAL_LIGHT = [
  "#2563eb",
  "#1baf7a",
  "#eda100",
  "#008300",
  "#4a3aa7",
  "#e34948",
  "#e87ba4",
  "#eb6834"
];
var SIGNAL_DARK = [
  "#3b82f6",
  "#199e70",
  "#c98500",
  "#008300",
  "#9085e9",
  "#e66767",
  "#d55181",
  "#d95926"
];
var CHART_PALETTE_PRESETS = [
  {
    id: "signal",
    recommended: true,
    light: SIGNAL_LIGHT,
    dark: SIGNAL_DARK
  },
  {
    id: "aurora",
    recommended: false,
    light: ["#7c4dd4", "#0e9f6e", "#e0a500", "#2563eb", "#d4568e", "#b45309", "#0891b2", "#dc2626"],
    dark: ["#8b66e0", "#14a97c", "#c28104", "#3b82f6", "#d15c92", "#d97706", "#0e9ebd", "#e15252"]
  },
  {
    id: "vivid",
    recommended: false,
    light: ["#2563eb", "#f59e0b", "#10b981", "#ec4899", "#8b5cf6", "#06b6d4", "#ef4444", "#84cc16"],
    dark: ["#3b82f6", "#bd8a05", "#10a56f", "#e0559b", "#8f6ce8", "#0aa2c0", "#e35d5d", "#6a9a10"]
  }
];
var DEFAULT_CHART_RAMP_2_TO_8 = {
  light: SIGNAL_LIGHT.slice(1),
  dark: SIGNAL_DARK.slice(1)
};
function rampsEqual(a, b) {
  if (a?.length !== b.length) return false;
  return a.every((hex, index) => hex.toLowerCase() === b[index]?.toLowerCase());
}
function chartRampMatchesPreset(ramp, preset) {
  return rampsEqual(ramp, preset.light);
}
function matchingChartPreset(ramp) {
  return CHART_PALETTE_PRESETS.find((preset) => chartRampMatchesPreset(ramp, preset));
}

// src/widget-config/chart-palette-contrast-audit.ts
var CHART_CONTRAST_FLOOR = 3;
function hexToRgb(hex) {
  const m = /^#([0-9a-f]{6})$/i.exec(hex.trim());
  if (m?.[1] === void 0) return null;
  const n = parseInt(m[1], 16);
  return { r: n >> 16 & 255, g: n >> 8 & 255, b: n & 255 };
}
function channelLinear(c) {
  const s = c / 255;
  return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
}
function relativeLuminance(rgb) {
  return 0.2126 * channelLinear(rgb.r) + 0.7152 * channelLinear(rgb.g) + 0.0722 * channelLinear(rgb.b);
}
function hexContrast(a, b) {
  const ra = hexToRgb(a);
  const rb = hexToRgb(b);
  if (ra === null || rb === null) return null;
  const la = relativeLuminance(ra);
  const lb = relativeLuminance(rb);
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
}
function auditChartPaletteContrast(ramp, background, target = CHART_CONTRAST_FLOOR) {
  const slots = ramp.map((color, i) => {
    const contrast = hexContrast(color, background) ?? 0;
    return { slot: i + 1, color, background, contrast, passes: contrast >= target };
  });
  const failingSlots = slots.filter((s) => !s.passes).map((s) => s.slot);
  return { target, slots, allPass: failingSlots.length === 0, failingSlots };
}
function auditChartPreset(preset, lightBg, darkBg, target = CHART_CONTRAST_FLOOR) {
  const light = auditChartPaletteContrast(preset.light, lightBg, target);
  const dark = auditChartPaletteContrast(preset.dark, darkBg, target);
  return { id: preset.id, light, dark, allPass: light.allPass && dark.allPass };
}
function auditAllChartPresets(lightBg, darkBg, target = CHART_CONTRAST_FLOOR) {
  return CHART_PALETTE_PRESETS.map((p) => auditChartPreset(p, lightBg, darkBg, target));
}

// src/widget-config/widget-config-migration.ts
function legacyConfigToDesignContent(config) {
  const t = config.theme;
  const palette = WidgetDesignContentSchema.shape.palette.parse({
    backgroundColor: t.backgroundColor,
    foregroundColor: t.foregroundColor,
    destructiveColor: t.destructiveColor,
    elementColors: t.elementColors
  });
  return WidgetDesignContentSchema.parse({
    base: {
      accentColor: t.accentColor,
      fontFamily: t.fontFamily,
      aiFontFamily: t.aiFontFamily,
      userFontFamily: t.userFontFamily,
      radiusScale: t.radiusScale,
      iconStyle: t.iconStyle,
      loadingAnimation: t.loadingAnimation,
      customCss: t.customCss
    },
    palette,
    sizeOverrides: {}
  });
}
function legacyConfigToSizing(config) {
  return {
    availableSizes: [...WIDGET_SIZES],
    defaultSize: config.sizeMode.defaultSize
  };
}
var MCP_APPS_THEME_META_KEY = "syncanix/widget-theme";
var McpAppsThemeSchema = /* @__PURE__ */ z.object({
  design: WidgetDesignContentSchema,
  kind: z.enum(WIDGET_DESIGN_KINDS)
});

// src/widget-config/chrome-disclosure-floor.ts
function enforceChromeDisclosureFloor(chrome) {
  const resolved = chrome ?? WidgetChromeConfigSchema.parse({});
  return !resolved.disclosureBanner && !resolved.aiDisclaimer && !resolved.aiBadge ? { ...resolved, aiBadge: true } : resolved;
}
var uuid = /* @__PURE__ */ z.string().uuid();
var WidgetSizeDesignAssignmentsSchema = /* @__PURE__ */ z.object({
  small: uuid.optional(),
  medium: uuid.optional(),
  large: uuid.optional(),
  fullscreen: uuid.optional(),
  embedded: uuid.optional()
});
var WidgetSizingConfigSchema = /* @__PURE__ */ z.object({
  availableSizes: z.array(z.enum(WIDGET_SIZES)).min(1).default([...WIDGET_SIZES]),
  // `medium` (the "Comfortable" size) is the boot default — ADR-0186, shared as
  // `DEFAULT_WIDGET_SIZE` so the widget runtime's own fallback cannot diverge.
  defaultSize: z.enum(WIDGET_SIZES).default(DEFAULT_WIDGET_SIZE)
}).refine((s) => s.availableSizes.includes(s.defaultSize), {
  message: "defaultSize must be one of availableSizes",
  path: ["defaultSize"]
});
var WIDGET_EXPAND_TARGETS = ["fullscreen", "overlay"];
var LEGACY_SPLIT_EXPAND_TARGET = "split";
var WidgetExpandConfigSchema = /* @__PURE__ */ z.object({
  /** Whether the expand affordance is offered at all. Default on. */
  enabled: z.boolean().default(true),
  /** Which surface expanded content opens into. Default `fullscreen` (works everywhere). */
  target: z.preprocess(
    (v) => v === LEGACY_SPLIT_EXPAND_TARGET ? "fullscreen" : v,
    z.enum(WIDGET_EXPAND_TARGETS).default("fullscreen")
  )
});
var WIDGET_TOGGLE_SIZES = ["small", "medium", "large", "fullscreen"];
var WIDGET_TOGGLE_DEFAULT_STATES = ["collapsed", "expanded"];
function toggleSizeRank(size) {
  return WIDGET_TOGGLE_SIZES.indexOf(size);
}
var WidgetVizExpandConfigSchema = /* @__PURE__ */ z.object({
  /** Whether the enlarge-visualization affordance is offered at all. Default on. */
  enabled: z.boolean().default(true)
});
var WidgetDraggableConfigSchema = /* @__PURE__ */ z.object({
  /** Whether the panel can be dragged by its header at all. Default off. */
  enabled: z.boolean().default(false),
  /** Remember the dragged position for the browser session. Default on (when enabled). */
  persist: z.boolean().default(true)
});
var WidgetHeaderToggleConfigSchema = /* @__PURE__ */ z.object({
  /** Whether the top-bar expand/collapse button is offered at all. Default off. */
  enabled: z.boolean().default(false),
  /** The smaller of the two sizes the button toggles between. Default `small`. */
  collapsedSize: z.enum(WIDGET_TOGGLE_SIZES).default("small"),
  /** The larger of the two sizes the button toggles between. Default `large`. */
  expandedSize: z.enum(WIDGET_TOGGLE_SIZES).default("large"),
  /** Which size the widget opens at (the customer-chosen default). Default `collapsed`. */
  defaultState: z.enum(WIDGET_TOGGLE_DEFAULT_STATES).default("collapsed")
}).refine((c) => toggleSizeRank(c.expandedSize) > toggleSizeRank(c.collapsedSize), {
  message: "expandedSize must be larger than collapsedSize",
  path: ["expandedSize"]
});
var WidgetSurfaceSettingsSchema = /* @__PURE__ */ z.object({
  /** The live design; `null` until one is chosen (widget falls back to default-light). */
  activeDesignId: uuid.nullable().default(null),
  sizing: WidgetSizingConfigSchema.default({}),
  /** How oversized rich-content elements expand (iframe/embed/component/image). */
  expand: WidgetExpandConfigSchema.default({}),
  /** Enlarge-to-popover affordance for rendered visualizations (off by default). */
  vizExpand: WidgetVizExpandConfigSchema.default({}),
  /** The top-bar expand/collapse size-toggle button (off by default). */
  headerToggle: WidgetHeaderToggleConfigSchema.default({}),
  /** Drag-to-reposition the floating panel by its header (off by default). */
  draggable: WidgetDraggableConfigSchema.default({}),
  /** Advanced: a different design per size (absent → the active design applies). */
  sizeDesignAssignments: WidgetSizeDesignAssignmentsSchema.optional(),
  /**
   * The tenant's default theme key (SYN-6): the design the delivery endpoint
   * resolves to when an embed requests no key or an unknown one. `null` →
   * fall through to the active design / built-in. One per tenant (this is the
   * singleton settings document).
   */
  defaultThemeKey: WidgetThemeKeySchema.nullable().default(null),
  /**
   * CS-245 — the scan-time design profile the tenant last ADOPTED (framework +
   * tokens), snapshotted on re-adopt or when auto-follow is enabled. `null`
   * until the first adoption. Compared against the latest scan's design by
   * `detectDesignDrift` to flag a stale theme in the Studio.
   */
  adoptedDesignProfile: CatalogDesignSchema.nullable().default(null),
  /**
   * CS-245 — opt-in: the operator accepts tracking the latest scanned design.
   * When on, the Studio suppresses the stale-drift badge and re-adopts on drift
   * rather than nagging. Off by default (adoption stays explicit).
   */
  designAutoFollow: z.boolean().default(false),
  /**
   * SYN-573 — when the operator last EXPLICITLY saved these settings (ISO
   * datetime, stamped server-side on every `updateSurfaceSettings`; any
   * client-supplied value is ignored). Absent on untouched/legacy documents,
   * so the stepper's Global step reads non-null as "✓ configured" and can
   * offer skip. Deliberately optional with NO default: `parse({})` must stay
   * not-configured.
   */
  configuredAt: z.string().datetime().optional()
});
var DEFAULT_SURFACE_SETTINGS = WidgetSurfaceSettingsSchema.parse(
  {}
);
function parseSurfaceSettings(input) {
  return WidgetSurfaceSettingsSchema.parse(input);
}
function safeParseSurfaceSettings(input) {
  return WidgetSurfaceSettingsSchema.safeParse(input);
}

// src/widget-config/widget-page-rule-budget.ts
var MAX_WIDGET_PAGE_RULES_PAYLOAD_BYTES = 128 * 1024;
function widgetPageRulesPayloadBytes(rules) {
  return new TextEncoder().encode(JSON.stringify(rules ?? null)).length;
}
var MAX_WIDGET_PAGE_RULE_URL_PATTERN = 2048;
var WidgetPageRuleUrlPatternSchema = /* @__PURE__ */ z.string().trim().min(1).max(MAX_WIDGET_PAGE_RULE_URL_PATTERN);
var WIDGET_PAGE_RULE_MATCH_OPERATORS = [
  "exact",
  "startsWith",
  "contains",
  "glob"
];
var DEFAULT_WIDGET_PAGE_RULE_MATCH = "glob";
var WidgetPageRuleMatchSchema = /* @__PURE__ */ z.object({
  urlPattern: WidgetPageRuleUrlPatternSchema,
  match: z.enum(WIDGET_PAGE_RULE_MATCH_OPERATORS).default(DEFAULT_WIDGET_PAGE_RULE_MATCH),
  /**
   * Compare letter case. Absent ⇒ `true` for `glob` (legacy), `false` for the
   * plain-language operators — `/Checkout` and `/checkout` are the same page to
   * everyone except a matcher.
   */
  matchCaseSensitive: z.boolean().optional(),
  /**
   * Include the query string in what is matched. Absent ⇒ `true` for `glob`
   * (legacy), `false` for the plain-language operators. This is the single most
   * damaging legacy default: with the query string in the target, `/pricing`
   * stops matching the moment a visitor arrives from an ad carrying `?utm_...`.
   */
  matchIncludeQuery: z.boolean().optional()
});
var MAX_WIDGET_PAGE_RULES = 200;
var WidgetPageRuleOverridesSchema = /* @__PURE__ */ z.object({
  theme: WidgetThemeConfigSchema.optional(),
  /**
   * PROVENANCE for a `theme` snapshotted from a Design Studio design (the
   * create/edit form flattens the picked design into `theme` via
   * `designContentToThemeConfig`). This records WHICH design it came from so the
   * form can re-highlight the selection on edit; the widget/delivery ignores it
   * and applies `theme` directly. Absent → a legacy hand-authored / pre-picker
   * theme. A dangling id (design since deleted) degrades to "no source design",
   * never to a broken override. Only meaningful alongside `theme`.
   */
  themeDesignId: z.string().uuid().optional(),
  availability: WidgetAvailabilityConfigSchema.optional(),
  /**
   * The chips a page rule shows, as a REFERENCE to the design that owns them
   * (ADR-0391) — the same shape as `themeDesignId`, and independent of it, so
   * a rule can borrow one design's chips without its look.
   *
   * Delivery resolves this to that design's `base.starters`. Authoring chips
   * inline on the rule is gone: it produced customer-facing text in ONE
   * language (`label` and `prompt` are `customerTextSchema`, but the rule
   * editor only ever wrote `default` and never `byLocale`), which
   * `quality-bar.md` § "Multilingual Is Part of Done" does not permit for text
   * a visitor reads. A design's chips go through the `/starters` authoring
   * path and are translated across all six locales.
   *
   * A dangling id degrades to the stored `starters` below, then to the
   * workspace default — never to a broken override.
   */
  startersDesignId: z.string().uuid().optional(),
  /**
   * LEGACY inline chips, still delivered and still preserved through an edit
   * (ADR-0384 / F2) so no tenant loses what they authored — but no longer
   * writable from the rule editor. `startersDesignId` supersedes it.
   */
  starters: WidgetStartersConfigSchema.optional(),
  hostActions: WidgetHostActionsConfigSchema.optional(),
  /**
   * A persona-profile id REFERENCE (the widget/delivery resolves it); NOT an
   * inlined persona (that shape lives in the api layer). Bounded here; existence
   * against the tenant's persona profiles is validated by the consuming layer
   * (SYN-384 delivery / SYN-381 widget) — a dangling id degrades to no override.
   */
  personaProfileId: z.string().trim().min(1).max(200).optional(),
  /**
   * Capabilities this rule takes AWAY on matching pages (F31, §2.3).
   *
   * A DENY list, never an allow list, and that is the whole design. Narrowing-
   * only has to be structural rather than enforced by a check somebody can
   * forget: there is no syntax here for "permit", so no page rule — however
   * authored, however malformed, however maliciously crafted — can widen what
   * the agent may do. The worst a bad rule can achieve is denying too much,
   * which is visible and safe.
   *
   * Resolved SERVER-SIDE from the turn's path, like the persona axis and for a
   * stronger reason: a restriction a visitor can lift by editing a variable is
   * not a restriction (`security.md` § ASI02/ASI03).
   *
   * Ids are opaque here (this is the pure package); existence against the
   * tenant's catalog is not required — an id that names nothing simply denies
   * nothing, which is the safe direction for a stale reference.
   */
  tools: z.object({
    deniedCapabilityIds: z.array(z.string().trim().min(1).max(200)).max(200)
  }).optional()
}).strict();
var WidgetPageRuleOverridesReadSchema = /* @__PURE__ */ z.object({
  theme: WidgetThemeConfigSchema.optional().catch(void 0),
  themeDesignId: z.string().uuid().optional().catch(void 0),
  availability: WidgetAvailabilityConfigSchema.optional().catch(void 0),
  startersDesignId: z.string().uuid().optional().catch(void 0),
  starters: WidgetStartersConfigSchema.optional().catch(void 0),
  hostActions: WidgetHostActionsConfigSchema.optional().catch(void 0),
  personaProfileId: z.string().trim().min(1).max(200).optional().catch(void 0),
  tools: z.object({ deniedCapabilityIds: z.array(z.string().trim().min(1).max(200)).max(200) }).optional().catch(void 0)
});
var KNOWN_OVERRIDE_AXES = Object.keys(WidgetPageRuleOverridesReadSchema.shape);
function readWidgetPageRuleOverrides(value) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return { overrides: {}, droppedAxes: [], unknownAxes: [], unreadable: true };
  }
  const input = value;
  const parsed = WidgetPageRuleOverridesReadSchema.safeParse(input);
  const overrides = parsed.success ? parsed.data : {};
  const droppedAxes = [];
  const unknownAxes = [];
  for (const key of Object.keys(input)) {
    if (!KNOWN_OVERRIDE_AXES.includes(key)) {
      unknownAxes.push(key);
      continue;
    }
    if (input[key] !== void 0 && overrides[key] === void 0) {
      droppedAxes.push(key);
    }
  }
  return {
    overrides,
    droppedAxes: droppedAxes.sort(),
    unknownAxes: unknownAxes.sort(),
    unreadable: false
  };
}
var MAX_WIDGET_PAGE_RULE_NAME_CHARS = 120;
var MAX_WIDGET_PAGE_RULE_DESCRIPTION_CHARS = 500;
var WidgetPageRuleInputSchema = WidgetPageRuleMatchSchema.extend({
  /**
   * The operator's own label. Optional, and an empty/whitespace-only string
   * normalizes to `undefined` — an author who clears the field means "unnamed",
   * and storing `''` would make the "has this rule got a name?" question have two
   * different answers depending on how it was cleared.
   */
  name: z.string().trim().max(MAX_WIDGET_PAGE_RULE_NAME_CHARS).optional().transform((value) => value === void 0 || value === "" ? void 0 : value),
  description: z.string().trim().max(MAX_WIDGET_PAGE_RULE_DESCRIPTION_CHARS).optional().transform((value) => value === void 0 || value === "" ? void 0 : value),
  /**
   * Whether the rule ships to the widget. Defaults to `true`, so an older client
   * that predates this field — or a recipe that says nothing about it — creates a
   * LIVE rule. Authoring a rule and silently having it not apply would be the
   * worse default, and it is also what every existing row already means.
   */
  enabled: z.boolean().default(true),
  priority: z.number().int().min(0).max(1e6).default(0),
  overrides: WidgetPageRuleOverridesSchema
});
function sortWidgetPageRulesByPrecedence(rules) {
  return [...rules].sort((a, b) => {
    if (a.priority !== b.priority) return b.priority - a.priority;
    if (a.createdAt !== b.createdAt) return a.createdAt - b.createdAt;
    return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
  });
}

// src/widget-config/widget-page-rule-match.ts
function matchesGlob(pattern2, target) {
  let patternIndex = 0;
  let targetIndex = 0;
  let starIndex = -1;
  let starTargetIndex = 0;
  while (targetIndex < target.length) {
    if (patternIndex < pattern2.length && pattern2[patternIndex] === "*") {
      starIndex = patternIndex;
      starTargetIndex = targetIndex;
      patternIndex += 1;
    } else if (patternIndex < pattern2.length && pattern2[patternIndex] === target[targetIndex] && pattern2[patternIndex] !== "*") {
      patternIndex += 1;
      targetIndex += 1;
    } else if (starIndex !== -1) {
      starTargetIndex += 1;
      patternIndex = starIndex + 1;
      targetIndex = starTargetIndex;
    } else {
      return false;
    }
  }
  while (patternIndex < pattern2.length && pattern2[patternIndex] === "*") {
    patternIndex += 1;
  }
  return patternIndex === pattern2.length;
}
function targetOf(url, pattern2, includeQuery) {
  if (pattern2.includes("://")) return url;
  try {
    const parsed = new URL(url);
    return includeQuery ? `${parsed.pathname}${parsed.search}` : parsed.pathname;
  } catch {
    return url;
  }
}
function withoutTrailingSlash(value) {
  return value.length > 1 && value.endsWith("/") ? value.slice(0, -1) : value;
}
var SEGMENT_BOUNDARIES = ["/", "?", "#"];
function resolveWidgetPageRuleMatchOptions(rule) {
  const named = rule.match;
  const operator = named !== void 0 && WIDGET_PAGE_RULE_MATCH_OPERATORS.includes(named) ? named : DEFAULT_WIDGET_PAGE_RULE_MATCH;
  const legacy = operator === "glob";
  return {
    operator,
    caseSensitive: rule.matchCaseSensitive ?? legacy,
    includeQuery: rule.matchIncludeQuery ?? legacy
  };
}
function matchesWidgetPageRule(rule, url) {
  const { operator, caseSensitive, includeQuery } = resolveWidgetPageRuleMatchOptions(rule);
  const rawTarget = targetOf(url, rule.urlPattern, includeQuery);
  const fold2 = (value) => caseSensitive ? value : value.toLowerCase();
  if (operator === "glob") {
    return matchesGlob(fold2(rule.urlPattern), fold2(rawTarget));
  }
  const target = fold2(rawTarget);
  const pattern2 = fold2(rule.urlPattern);
  if (operator === "contains") {
    return target.includes(pattern2);
  }
  const normalizedTarget = withoutTrailingSlash(target);
  const normalizedPattern = withoutTrailingSlash(pattern2);
  if (operator === "exact") return normalizedTarget === normalizedPattern;
  if (normalizedTarget === normalizedPattern) return true;
  if (!normalizedTarget.startsWith(normalizedPattern)) return false;
  if (normalizedPattern === "/") return true;
  const next = normalizedTarget.charAt(normalizedPattern.length);
  return SEGMENT_BOUNDARIES.includes(next);
}
function matchesWidgetPageRuleUrl(pattern2, url) {
  return matchesWidgetPageRule({ urlPattern: pattern2, match: "glob" }, url);
}

// src/widget-config/widget-page-rule-resolve.ts
function matchWidgetPageRule(rules, url) {
  return rules.find((rule) => matchesWidgetPageRule(rule, url));
}
function matchWidgetPageRules(rules, url) {
  return rules.filter((rule) => matchesWidgetPageRule(rule, url));
}
var OVERRIDE_AXES = [
  "theme",
  "themeDesignId",
  "availability",
  "starters",
  "hostActions",
  "personaProfileId"
];
function resolveWidgetPageRuleAxes(rules, url) {
  const matched = matchWidgetPageRules(rules, url);
  const overrides = {};
  const sources = {};
  for (const rule of matched) {
    const ruleOverrides = rule.overrides;
    for (const axis of OVERRIDE_AXES) {
      if (overrides[axis] === void 0 && ruleOverrides[axis] !== void 0) {
        overrides[axis] = ruleOverrides[axis];
        sources[axis] = rule.id;
      }
    }
  }
  return { overrides, sources, matched };
}
function mergeWidgetPageOverrides(config, overrides) {
  return {
    ...config,
    ...overrides.theme !== void 0 ? { theme: overrides.theme } : {},
    ...overrides.availability !== void 0 ? { availability: overrides.availability } : {},
    ...overrides.hostActions !== void 0 ? { hostActions: overrides.hostActions } : {}
  };
}
function parseDeliveredPageRules(value) {
  if (!Array.isArray(value)) return [];
  const rules = [];
  for (const item of value) {
    if (typeof item !== "object" || item === null) continue;
    const obj = item;
    if (typeof obj.id !== "string" || typeof obj.urlPattern !== "string" || typeof obj.priority !== "number") {
      continue;
    }
    rules.push({
      id: obj.id,
      urlPattern: obj.urlPattern,
      priority: obj.priority,
      overrides: readWidgetPageRuleOverrides(obj.overrides).overrides,
      // The match half is absence-tolerant like everything else on this payload:
      // an older delivery carries none of it and reads as the legacy `glob`, and
      // a value of the wrong TYPE is ignored rather than trusted.
      ...typeof obj.match === "string" ? { match: obj.match } : {},
      ...typeof obj.matchCaseSensitive === "boolean" ? { matchCaseSensitive: obj.matchCaseSensitive } : {},
      ...typeof obj.matchIncludeQuery === "boolean" ? { matchIncludeQuery: obj.matchIncludeQuery } : {}
    });
  }
  return rules;
}
function resolveEffectiveWidgetConfig(config, rules, url) {
  const { config: merged, axes } = resolveEffectivePageState(config, rules, url);
  return { config: merged, matched: axes.matched[0] };
}
function resolveEffectivePageState(config, rules, url) {
  const axes = resolveWidgetPageRuleAxes(rules, url);
  const merged = mergeWidgetPageOverrides(config, axes.overrides);
  return {
    // `mergeWidgetPageOverrides` spreads unconditionally, so identity is
    // compared on the axes it actually touches rather than on the object it
    // returns.
    config: merged.theme === config.theme && merged.availability === config.availability && merged.hostActions === config.hostActions ? config : merged,
    axes
  };
}

// src/widget-config/design-to-theme.ts
function designContentToThemeConfig(content) {
  const parsed = WidgetDesignContentSchema.safeParse(content);
  const safe = parsed.success ? parsed.data : DEFAULT_WIDGET_DESIGN_CONTENT;
  const scheme = "auto";
  const palette = safe.palette;
  const { base } = safe;
  return WidgetThemeConfigSchema.parse({
    colorScheme: scheme,
    accentColor: base.accentColor,
    ...palette.backgroundColor !== void 0 && { backgroundColor: palette.backgroundColor },
    ...palette.foregroundColor !== void 0 && { foregroundColor: palette.foregroundColor },
    ...palette.destructiveColor !== void 0 && { destructiveColor: palette.destructiveColor },
    fontFamily: base.fontFamily,
    ...base.aiFontFamily !== void 0 && { aiFontFamily: base.aiFontFamily },
    ...base.userFontFamily !== void 0 && { userFontFamily: base.userFontFamily },
    radiusScale: base.radiusScale,
    // SYN-672 — carry the per-bubble rounding override only when set (kept sparse,
    // preserving the "record only what's customised" invariant).
    ...base.bubbleRadiusScale !== void 0 && { bubbleRadiusScale: base.bubbleRadiusScale },
    iconStyle: base.iconStyle,
    loadingAnimation: base.loadingAnimation,
    elementColors: palette.elementColors,
    ...base.customCss !== void 0 && { customCss: base.customCss }
  });
}

// src/widget-config/embed-snippet.ts
var WIDGET_SCRIPT_SRC = "https://cdn.syncanix.com/widget.js";
var MCP_APPS_UI_SCRIPT_SRC = "https://cdn.syncanix.com/preview/mcp-apps.js";
var EMBED_LAUNCHER_POSITIONS = [
  "bottom-right",
  "bottom-left",
  "top-right",
  "top-left"
];
var EMBED_ENVIRONMENTS = ["development", "production"];
var EMBED_CONFIG_LOAD_MODES = ["lazy", "eager"];
function escapeAttr(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function buildEmbedSnippet(config) {
  const key = config.key.trim();
  if (key === "") {
    throw new Error("buildEmbedSnippet: `key` is required.");
  }
  const attrs = [
    ["type", "module"],
    ["src", WIDGET_SCRIPT_SRC],
    ["data-key", key]
  ];
  if (config.enabled === false) attrs.push(["data-enabled", "false"]);
  if (config.position !== void 0) attrs.push(["data-position", config.position]);
  if (config.environment !== void 0) attrs.push(["data-env", config.environment]);
  if (config.origin !== void 0 && config.origin.trim() !== "") {
    attrs.push(["data-origin", config.origin.trim()]);
  }
  if (config.theme !== void 0) {
    const themeStr = typeof config.theme === "string" ? config.theme : JSON.stringify(config.theme);
    attrs.push(["data-theme", themeStr]);
  }
  if (config.executorName !== void 0 && config.executorName.trim() !== "") {
    attrs.push(["data-executor", config.executorName.trim()]);
  }
  if (config.clientWitness === true) attrs.push(["data-client-witness", "true"]);
  if (config.size !== void 0) attrs.push(["data-chat-size", config.size]);
  if (config.configLoad !== void 0) attrs.push(["data-config-load", config.configLoad]);
  if (config.promptProfile !== void 0 && config.promptProfile.trim() !== "") {
    attrs.push(["data-prompt-profile", config.promptProfile.trim()]);
  }
  const lines = attrs.map(([name, value]) => `  ${name}="${escapeAttr(value)}"`);
  return `<script
${lines.join("\n")}
></script>`;
}

// src/widget-config/public-api-dts-prelude.ts
var SYNCANIX_PUBLIC_API_DTS_PRELUDE = `/**
 * Type declarations for the Syncanix widget's page API.
 *
 * Generated by \`syncanix generate\` \u2014 re-run it to update.
 * Self-contained: no imports, no packages to install.
 */

/** A React-like component type, kept structural so no React types are needed. */
type SyncanixComponent<P> = (props: P) => unknown;

/** A Zod-like schema, kept structural so no Zod dependency is needed. */
interface SyncanixSchema {
  parse(value: unknown): unknown;
}

export interface SyncanixActionOptions {
  /** JSON-Schema-ish parameter description the agent sees. */
  parameters?: Record<string, unknown>;
  description?: string;
  parameterDescriptions?: Record<string, string>;
  /** Force a confirmation card before this runs. */
  confirm?: boolean;
  sideEffect?: 'read' | 'write' | 'destructive';
  title?: string;
}

export interface SyncanixComponentMeta {
  description?: string;
  propDescriptions?: Record<string, string>;
}

export interface SyncanixDataSourceMeta {
  description?: string;
  paramDescriptions?: Record<string, string>;
  /** Poll interval in ms. Values below 1000 are rejected. */
  pollMs?: number;
}

/** One top-level prop of a registered component, as the agent sees it. */
export interface SyncanixCatalogProp {
  name: string;
  /** \`false\` when the schema accepts the prop being omitted. */
  required: boolean;
  description?: string;
}

/** An entry in the registered-component catalog (\`getComponentCatalog\`). */
export interface SyncanixComponentCatalogEntry {
  componentId: string;
  description?: string;
  props: readonly SyncanixCatalogProp[];
}

/** An entry in the registered-action catalog (\`getActionCatalog\`). */
export interface SyncanixActionCatalogEntry {
  actionId: string;
  description?: string;
  title?: string;
  /** Whether running the action requires explicit end-user confirmation. */
  confirm: boolean;
  sideEffect: 'read' | 'write' | 'destructive';
  /** \`auto-detected\` entries need dashboard approval before the agent can call them. */
  source: 'registered' | 'auto-detected';
}

/** One parameter of a registered data source. */
export interface SyncanixDataSourceCatalogParam {
  name: string;
  description?: string;
}

/** An entry in the registered-data-source catalog (\`getDataSourceCatalog\`). */
export interface SyncanixDataSourceCatalogEntry {
  id: string;
  description?: string;
  params?: readonly SyncanixDataSourceCatalogParam[];
}
`;

// src/widget-config/public-api-queueable.ts
var SYNCANIX_QUEUEABLE_METHODS = [
  "registerComponent",
  "registerElement",
  "registerAction",
  "registerDataSource",
  "registerProviders",
  "exposePageActions",
  "setContext",
  "clearContext",
  "setTokenProvider",
  "setStepUpProvider",
  "setHeadersProvider",
  "setTheme",
  "setConsent",
  "setPosition"
];
var SYNCANIX_QUEUEABLE_NON_VOID = ["exposePageActions"];

// src/widget-config/public-api-dts.ts
var SYNCANIX_PUBLIC_API_DTS = `${SYNCANIX_PUBLIC_API_DTS_PRELUDE}
/** What one token-provider read produced (see \`identity()\`). */
export type SyncanixIdentityOutcome =
  | 'token'
  | 'none'
  | 'threw'
  | 'timeout'
  | 'non-string'
  | 'not-a-function'
  | 'no-provider';

export interface SyncanixGlobal {
  /** Turn the chat off at runtime without unmounting. Idempotent. */
  disable(): void;
  /** Turn the chat back on after \`disable\`. Idempotent. */
  enable(): void;
  /** Whether the chat is enabled right now. */
  readonly enabled: boolean;

  open(): void;
  close(): void;
  toggle(): void;
  readonly isOpen: boolean;

  setPosition(position: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left'): void;
  unmount(): void;

  /** Register a React component the agent may render. */
  registerComponent<P>(
    componentId: string,
    component: SyncanixComponent<P>,
    propsSchema: SyncanixSchema,
    meta?: SyncanixComponentMeta,
  ): void;
  unregisterComponent(componentId: string): boolean;

  /** Register a custom element by tag name \u2014 framework-agnostic. */
  registerElement<P>(
    componentId: string,
    tagName: string,
    propsSchema: SyncanixSchema,
    options?: { events?: string[]; meta?: SyncanixComponentMeta },
  ): void;

  /** Register a function the agent may call on this page. */
  registerAction<A>(
    actionId: string,
    handler: (args: A) => unknown | Promise<unknown>,
    options?: SyncanixActionOptions,
  ): void;
  unregisterAction(actionId: string): boolean;

  /**
   * Offer a file the visitor can save or view, from inside a registered action.
   * Return the handle in your action's result and the chat renders a file card
   * with Download and Show. Nothing is uploaded and nothing downloads on its
   * own \u2014 the widget holds the bytes in this page until the visitor asks.
   * Build a link and click it yourself and you save a file nobody asked for.
   */
  offerFile(
    blob: Blob,
    options: { filename: string; contentType?: string },
  ): { ref: string; filename: string; contentType: string; sizeBytes: number };

  /** Register a live data source the agent may read. */
  registerDataSource(
    id: string,
    fetcher: (params: Record<string, unknown>) => unknown | Promise<unknown>,
    meta?: SyncanixDataSourceMeta,
  ): void;
  unregisterDataSource(id: string): boolean;

  /** Wrap registered components in your app's providers (router, theme, \u2026). */
  registerProviders(Providers: SyncanixComponent<{ children: unknown }>): void;

  /** Bounded JSON describing what the visitor is looking at. Throws if too large. */
  setContext(context: Record<string, unknown>): void;
  clearContext(): void;

  /** Supply the end user's access token so the agent can act as them. */
  setTokenProvider(provider: (() => Promise<string | undefined>) | undefined): void;
  /** Supply a step-up re-authentication handler (RFC 9470). */
  setStepUpProvider(
    provider: ((toolCallId: string) => Promise<unknown>) | undefined,
  ): void;
  /** Supply extra request headers. \`x-syncanix-*\` names are reserved. */
  setHeadersProvider(
    provider: (() => Promise<Record<string, string>>) | undefined,
  ): void;
  /**
   * What the widget currently knows about the visitor's identity, for
   * debugging an act-as-user integration. \`signedIn\` is EVIDENCE \u2014 the most
   * recent token read produced a token \u2014 never the presence of a provider: a
   * registered provider whose backend returns no token reads \`false\` here.
   * \`bootOutcome\` is the runtime-registered provider's read when the session
   * was built; \`lastTurnOutcome\` is the latest turn's.
   */
  identity(): {
    providerRegistered: boolean;
    bootOutcome: SyncanixIdentityOutcome | null;
    lastTurnOutcome: SyncanixIdentityOutcome | null;
    signedInTurns: number;
    signedOutTurns: number;
    signedIn: boolean;
  };

  /**
   * Run one of the workspace's saved guides on this page \u2014 a step-by-step
   * walkthrough your team wrote in the dashboard, highlighted control by
   * control on your own UI.
   *
   * The id SELECTS a published guide; it never describes one, so a hand-typed
   * or tampered id runs nothing. Returns \`false\` when the id names no guide,
   * when the widget has not finished loading, or when the chat is turned off \u2014
   * so you can offer your own fallback rather than watch nothing happen.
   *
   * Deliberately NOT buffered before load: a queued call would have to report
   * \`undefined\` for "did it start", which is the one thing this answer is for.
   *
   * The same guide runs from a \`?syncanix-guide=<id>\` link on any URL of your
   * site, which is what makes one usable from an email or a help article.
   */
  startGuide(guideId: string): boolean;

  /** Switch to a named theme without re-mounting. */
  setTheme(key: string): void;
  /** Record the visitor's analytics / personalization consent. */
  setConsent(signal: { analytics?: boolean; personalization?: boolean }): void;

  /**
   * Tell the agent which routes it may navigate to and which marked controls it
   * may operate. Returns a dispose function that unregisters everything it
   * discovered \u2014 call it on unmount or route teardown.
   *
   * Note the gating differs between the two: a discovered ROUTE is navigated
   * without a confirmation card, a discovered CONTROL always shows one.
   *
   * Controls are opted in by MARKING them \u2014 put \`data-syncanix-action="\u2026"\` on
   * the element and pass \`markers: { scope }\` to bound the search. There is no
   * selector list; \`scope\` should be a region you control, since anything
   * bearing the attribute inside it is discovered.
   *
   * Every route needs an \`id\` (\`[A-Za-z0-9_-]\`, the agent's handle for it) and
   * a \`label\` (what the agent calls the destination out loud), not just an
   * \`href\`.
   *
   * When called before the widget bundle has loaded \u2014 which is what the
   * generated kit's barrel does at module scope \u2014 the call is buffered and the
   * return value is \`undefined\` rather than a disposer. Capture the disposer
   * only if you call this yourself, after load.
   */
  exposePageActions(config: {
    navigate?: (href: string) => void;
    routes?: readonly { id: string; label: string; href: string }[];
    markers?: boolean | { scope?: string };
  }): (() => void) | undefined;

  /** Let the agent see inside a closed shadow root you own. */
  exposeShadowRoot(host: Element, root: ShadowRoot): () => void;

  readonly protocolVersion: number;
  /** Ref-count a second embed of the same key. */
  attachEmbed(): void;

  /** Inspect the registered-component catalog the agent is shown. */
  getComponentCatalog(): readonly SyncanixComponentCatalogEntry[];
  /** Inspect the registered-action catalog the agent is shown. */
  getActionCatalog(): readonly SyncanixActionCatalogEntry[];
  /** Inspect the registered-data-source catalog the agent is shown. */
  getDataSourceCatalog(): readonly SyncanixDataSourceCatalogEntry[];

  /**
   * The prompt profile this page selected via \`data-prompt-profile\` (after
   * normalization), or \`undefined\` when unset/malformed. Read-only \u2014 which
   * profile serves is an embed-time decision, not a runtime setter.
   */
  readonly promptProfile: string | undefined;

  /**
   * Start a teach-mode discovery session from a one-time bind token an operator
   * minted in the dashboard (supplied out-of-band \u2014 never read from a URL or
   * attribute). Resolves \`true\` when the session started, \`false\` when the bind
   * was refused. Lazy-loaded; shows a permanent recording banner while live.
   */
  teach(bindToken: string): Promise<boolean>;
  /** Stop the live teach-mode session (server-side revoke + local teardown). No-op if none. */
  stopTeach(): Promise<void>;

  /**
   * Start a Guided Site Walk \u2014 a bounded, read-only walk that maps this whole
   * site in one pass, run in this browser. Needs only a one-time bind token an
   * operator minted in the dashboard (the embed attribute it used to require is
   * retired; every embed is walkable). Read-only by construction; a visible,
   * abortable banner shows for the whole run.
   */
  mapSite(bindToken: string): Promise<boolean>;
  /** Abort a running site walk before its next navigation. No-op if none. */
  stopSiteWalk(): void;

  /**
   * Start recording a walkthrough \u2014 the operator clicks through a task on this
   * site and the steps seed a guide in the dashboard. Requires a one-time bind
   * token an operator minted there; resolves \`false\` when recording is switched
   * off for the deployment, or when the token is unknown, spent, expired or for
   * the wrong origin (the server gives ONE opaque answer to all of those, so
   * this does too).
   *
   * **It captures nothing to a server.** Each click resolves to a page, a
   * control identity and the control's label IN THIS BROWSER, held in memory
   * and handed to the dashboard tab that started the recording when the
   * operator finishes. The listener is capture-phase and passive, so it never
   * prevents, stops or redirects a click. A visible banner shows throughout.
   */
  recordGuide(bindToken: string): Promise<boolean>;
  /** Finish a running recording and hand its steps to the dashboard. No-op if none. */
  finishGuideRecording(): void;

  /**
   * Report an application event your own page already knows about, so an
   * engagement rule can be triggered by it (\`When: a tracked event\`).
   *
   * Values may be a string, a number or a boolean; anything else is dropped, as
   * is a property past the twelfth. Returns \`false\` when the NAME is unusable
   * (empty, over-long, or carrying anything outside \`A-Za-z0-9_.-\`) or the
   * properties are not a plain object \u2014 the two cases where nothing sensible
   * could be dispatched \u2014 so a caller can notice in development. It never
   * throws: this sits in your own click handler.
   *
   * **The properties never leave the browser.** They are compared against the
   * operator's rule clauses here; what crosses the wire afterwards is the same
   * "this rule fired" every other trigger produces. Nothing is stored or logged.
   */
  track(name: string, properties?: Record<string, string | number | boolean>): boolean;
}

declare global {
  interface Window {
    syncanix?: SyncanixGlobal;
  }
}

export {};
`;

// src/widget-config/self-embed.ts
var WIDGET_DEV_API_ORIGIN = "https://api.dev.syncanix.com";
var WIDGET_PROD_SCRIPT_SRC = "https://cdn.syncanix.com/widget.js";
var WIDGET_DEV_SCRIPT_SRC = "https://cdn.dev.syncanix.com/widget.js";
var PUBLISHABLE_KEY_PREFIX = /^pk_(test|live)_/;
function resolveWidgetEmbed(env) {
  const key = (env.key ?? "").trim();
  if (key === "" || !PUBLISHABLE_KEY_PREFIX.test(key)) return null;
  const scriptSrc = key.startsWith("pk_test_") ? WIDGET_DEV_SCRIPT_SRC : WIDGET_PROD_SCRIPT_SRC;
  const apiBase = (env.apiBaseUrl ?? "").trim();
  const withApiBase = apiBase !== "" ? { apiBaseUrl: apiBase } : {};
  const override = (env.origin ?? "").trim();
  if (override !== "") return { key, origin: override, ...withApiBase, scriptSrc };
  if (key.startsWith("pk_test_")) {
    return { key, origin: WIDGET_DEV_API_ORIGIN, ...withApiBase, scriptSrc };
  }
  return { key, ...withApiBase, scriptSrc };
}

// src/docs/finding-vocabulary.ts
var DOC_FINDING_TYPES = [
  /** A control the document describes is no longer observed on the page. */
  "retired-control",
  /** A control is still there under a different accessible name. */
  "renamed-control",
  /** A route the document links to or describes is no longer observed. */
  "dead-route",
  /** The observed order of controls on a page no longer matches the document. */
  "changed-flow",
  /** The document describes a capability the catalog contradicts. */
  "catalog-contradiction",
  /** Two sources describe the same page differently (§ 3.6's cross-row check). */
  "cross-source-contradiction",
  /** DE-202 — the quality scorer's staleness dimension. */
  "stale-document",
  /** DE-202 — TODO / "coming soon" markers, or a body under the length floor. */
  "incomplete-document",
  /** DE-403 — N thumbs-down on one article in a window. */
  "reader-reported",
  /** DE-403 — a recurring zero-result search, joined to DE-110's coverage. */
  "uncovered-question"
];
var DRIFT_FINDING_TYPES = [
  "retired-control",
  "renamed-control",
  "dead-route",
  "changed-flow",
  "catalog-contradiction",
  "cross-source-contradiction"
];
function isDriftFinding(type) {
  return DRIFT_FINDING_TYPES.includes(type);
}
var DOC_FINDING_STATUSES = [
  "open",
  "snoozed",
  "dismissed",
  "resolved",
  /**
   * The evidence this finding was compared against is GONE, so we can no longer
   * tell whether the drift was fixed.
   *
   * Its own state rather than a flavour of `resolved`, and this is the
   * distinction DE-203 exists to make. The retention purge deletes retired
   * discovery rows, so a finding whose evidence has been purged looks exactly
   * like a finding whose drift was fixed — and closing the first as `resolved`
   * silently clears a TRUE finding while the customer's documentation is still
   * wrong. Two states, two different sentences in the inbox.
   */
  "evidence-gone"
];
function isOpenFindingStatus(status) {
  return status === "open" || status === "snoozed";
}
var DOC_FINDING_RESOLVED_REASONS = [
  /** The next pass did not find the drift again — the document was fixed. */
  "drift-fixed",
  /** The observation it was compared against was purged. See `evidence-gone`. */
  "evidence-purged",
  /** The document itself stopped being produced. */
  "document-gone",
  /** A human decided. */
  "operator"
];
function toDocFindingType(value) {
  return DOC_FINDING_TYPES.includes(value) ? value : null;
}
function toDocFindingStatus(value) {
  return DOC_FINDING_STATUSES.includes(value) ? value : null;
}
function toDocFindingResolvedReason(value) {
  return DOC_FINDING_RESOLVED_REASONS.includes(value) ? value : null;
}
var DOC_REPORT_REASONS = [
  /** It states something that is not true. */
  "wrong",
  /** It was true and no longer is. */
  "outdated",
  /** It did not cover what the visitor actually asked. */
  "incomplete",
  /** Correct, but not an answer to this question — a retrieval complaint. */
  "irrelevant"
];
function toDocReportReason(value) {
  return DOC_REPORT_REASONS.includes(value) ? value : null;
}

// src/wiki/article-vocabulary.ts
var WIKI_ARTICLE_TYPES = [
  "area-overview",
  "page-guide",
  "how-to",
  "faq",
  "component-guide"
];
var WIKI_ARTICLE_STATUSES = [
  /** Rung 1 — `wiki_articles` only, never projected. The operator alone. */
  "draft",
  /** Rung 2 — projected at `restricted`, under its own uri namespace. */
  "internal",
  /** Rung 3 — projected at a visitor-resolvable label, superseding node prose. */
  "published",
  /** Rung 3 + export. Past `published` on the same ladder, not beside it. */
  "approved-external",
  /** Its evidence moved. Withheld until a re-draft or an operator decision. */
  "stale-evidence",
  /** § 12 — the workspace took it back. Never projected, whatever it was. */
  "recalled",
  /** The operator does not want this article to exist. Never projected. */
  "excluded"
];
function wikiArticleRung(status) {
  switch (status) {
    case "internal":
      return 2;
    case "published":
    case "approved-external":
      return 3;
    // `draft`, `stale-evidence`, `recalled` and `excluded` are all rung 1: held,
    // not projected. They are listed rather than defaulted so that adding a
    // status to the set above without deciding its rung fails to compile.
    case "draft":
    case "stale-evidence":
    case "recalled":
    case "excluded":
      return 1;
  }
}
function isProjectableWikiStatus(status) {
  return wikiArticleRung(status) > 1;
}
function isExportableWikiStatus(status) {
  return status === "approved-external";
}
function toWikiArticleStatus(value) {
  return WIKI_ARTICLE_STATUSES.includes(value) ? value : null;
}
function toWikiArticleType(value) {
  return WIKI_ARTICLE_TYPES.includes(value) ? value : null;
}
var WIKI_LOCALE_REVIEW_STATES = [
  /** A human read THIS language and approved it. */
  "approved-read",
  /** Approved because a sibling locale was, and the reader is told so. */
  "approved-by-inheritance"
];
function toWikiLocaleReviewState(value) {
  return WIKI_LOCALE_REVIEW_STATES.includes(value) ? value : null;
}
function isLocaleHumanReviewed(state) {
  return state === "approved-read";
}

// src/wiki/export-articles.ts
function articleSlug(subjectKey) {
  return subjectKey.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
}
function anchors(articles) {
  const used = /* @__PURE__ */ new Set();
  return articles.map((article, index) => {
    const base = articleSlug(article.subjectKey) || `article-${index + 1}`;
    if (!used.has(base)) {
      used.add(base);
      return base;
    }
    return `${base}-${index + 1}`;
  });
}
function escapeHeading(title) {
  return title.replace(/\r?\n/g, " ").trim();
}
function toWikiMarkdown(articles, options) {
  const ids = anchors(articles);
  const parts = [`# ${escapeHeading(options.title)}`];
  if (options.subtitle !== void 0 && options.subtitle.trim() !== "") {
    parts.push(options.subtitle.trim());
  }
  articles.forEach((article, index) => {
    parts.push(`<!-- ${ids[index] ?? ""} -->
## ${escapeHeading(article.title)}`);
    parts.push(article.body.trim());
  });
  return `${parts.join("\n\n")}
`;
}
function toLlmsTxt(articles, options) {
  const base = options.baseUrl.replace(/\/+$/, "");
  const ids = anchors(articles);
  const lines = [`# ${escapeHeading(options.title)}`, ""];
  if (options.subtitle !== void 0 && options.subtitle.trim() !== "") {
    lines.push(`> ${escapeHeading(options.subtitle)}`, "");
  }
  lines.push("## Docs", "");
  articles.forEach((article, index) => {
    lines.push(`- [${escapeHeading(article.title)}](${base}#${ids[index] ?? ""})`);
  });
  return `${lines.join("\n")}
`;
}

// src/wiki/reading-order.ts
var WIKI_READING_ORDER = {
  "area-overview": 0,
  "page-guide": 1,
  "how-to": 2,
  faq: 3,
  "component-guide": 4
};
var WIKI_START_HERE_TYPES = ["area-overview"];
var READING_RANK = WIKI_READING_ORDER;
function rank(articleType) {
  return READING_RANK[articleType] ?? Number.POSITIVE_INFINITY;
}
function orderArticlesForReading(articles) {
  return [...articles].sort((a, b) => {
    const byTier = rank(a.articleType) - rank(b.articleType);
    if (byTier !== 0) return byTier;
    return a.subjectKey < b.subjectKey ? -1 : a.subjectKey > b.subjectKey ? 1 : 0;
  });
}
function splitStartHere(ordered) {
  const startsHere = (a) => WIKI_START_HERE_TYPES.includes(a.articleType);
  return { startHere: ordered.filter(startsHere), rest: ordered.filter((a) => !startsHere(a)) };
}

// src/wiki/editorial-policy.ts
var WIKI_VOICE_TONES = ["warm", "formal", "playful"];
var WIKI_READING_LEVELS = ["plain", "standard", "technical"];
var DEFAULT_WIKI_EDITORIAL_POLICY = {
  voiceTone: "warm",
  readingLevel: "standard",
  glossary: [],
  neverSay: [],
  neverDocument: []
};
function toWikiVoiceTone(value) {
  return WIKI_VOICE_TONES.includes(value ?? "") ? value : DEFAULT_WIKI_EDITORIAL_POLICY.voiceTone;
}
function toWikiReadingLevel(value) {
  return WIKI_READING_LEVELS.includes(value ?? "") ? value : DEFAULT_WIKI_EDITORIAL_POLICY.readingLevel;
}

// src/rollout/stable-bucket.ts
function stableHash(input) {
  let h = 2166136261;
  for (let i = 0; i < input.length; i += 1) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}
var ROLLOUT_BUCKETS = 1e4;
function stableBucket(subject, salt) {
  return stableHash(`${salt}:${subject}`) % ROLLOUT_BUCKETS;
}
function isInRollout(subject, salt, pct) {
  if (!Number.isFinite(pct) || pct <= 0) return false;
  if (pct >= 100) return true;
  const threshold = Math.round(pct * (ROLLOUT_BUCKETS / 100));
  return stableBucket(subject, salt) < threshold;
}

// src/engagement/evaluate-schedule.ts
var DAY_MS2 = 864e5;
function localParts(nowMs, timeZone) {
  try {
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      hour12: false,
      weekday: "short"
    }).formatToParts(new Date(nowMs));
    const get = (type) => parts.find((p) => p.type === type)?.value ?? "";
    const year = get("year");
    const month = get("month");
    const day = get("day");
    const hour = Number(get("hour")) % 24;
    const weekdayMap = {
      Sun: 0,
      Mon: 1,
      Tue: 2,
      Wed: 3,
      Thu: 4,
      Fri: 5,
      Sat: 6
    };
    const weekday = weekdayMap[get("weekday")];
    if (year === "" || month === "" || day === "" || weekday === void 0 || Number.isNaN(hour)) {
      return null;
    }
    return { date: `${year}-${month}-${day}`, hour, weekday };
  } catch {
    return null;
  }
}
function hourInWindow(hour, startHour, endHour) {
  if (!Number.isInteger(startHour) || !Number.isInteger(endHour)) return false;
  if (startHour === endHour) return false;
  return startHour < endHour ? hour >= startHour && hour < endHour : hour >= startHour || hour < endHour;
}
function isIsoDate(value) {
  return typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value);
}
function evaluateSchedule(schedule, ctx) {
  if (!Number.isFinite(ctx.now)) return false;
  if (ctx.quietHours != null) {
    const local = localParts(ctx.now, ctx.visitorTimeZone);
    if (local === null) return false;
    if (hourInWindow(local.hour, ctx.quietHours.startHour, ctx.quietHours.endHour)) {
      return false;
    }
  }
  const lastShownAt = ctx.lastShownAt ?? null;
  switch (schedule.kind) {
    case "always":
      return true;
    case "once_ever":
      return lastShownAt === null;
    case "every_n_days": {
      if (!Number.isFinite(schedule.days) || schedule.days <= 0) return false;
      if (lastShownAt === null) return true;
      return ctx.now - lastShownAt >= schedule.days * DAY_MS2;
    }
    case "date_window": {
      if (!isIsoDate(schedule.startDate) || !isIsoDate(schedule.endDate)) return false;
      const tz = schedule.timeZone ?? ctx.visitorTimeZone;
      const local = localParts(ctx.now, tz);
      if (local === null) return false;
      return local.date >= schedule.startDate && local.date <= schedule.endDate;
    }
    case "recurring": {
      if (!Array.isArray(schedule.daysOfWeek) || schedule.daysOfWeek.length === 0) return false;
      const local = localParts(ctx.now, ctx.visitorTimeZone);
      if (local === null) return false;
      if (!schedule.daysOfWeek.includes(local.weekday)) return false;
      return hourInWindow(local.hour, schedule.startHour, schedule.endHour);
    }
    default:
      return false;
  }
}

// src/engagement/nudge-ref.ts
var VARIANT_SEPARATOR = "#";
var NUDGE_VARIANT_PATTERN = /^[A-Za-z0-9_-]{1,32}$/;
var VARIANT_PATTERN = NUDGE_VARIANT_PATTERN;
function encodeNudgeRef(ruleId, variant) {
  const id = ruleId.trim();
  if (id === "" || id.includes(VARIANT_SEPARATOR)) return null;
  const name = variant?.trim() ?? "";
  if (name === "") return id;
  if (!VARIANT_PATTERN.test(name)) return null;
  return `${id}${VARIANT_SEPARATOR}${name}`;
}
function decodeNudgeRef(ref) {
  const trimmed = ref.trim();
  if (trimmed === "") return null;
  const index = trimmed.indexOf(VARIANT_SEPARATOR);
  if (index === -1) return { ruleId: trimmed, variant: null };
  const ruleId = trimmed.slice(0, index);
  const variant = trimmed.slice(index + 1);
  if (ruleId === "" || !VARIANT_PATTERN.test(variant)) return null;
  return { ruleId, variant };
}
var NO_VARIANT = "(none)";
function variantKey(variant) {
  return variant ?? NO_VARIANT;
}

// src/experiences/experience-content-limits.ts
var EXPERIENCE_HEADING_MAX = 120;
var EXPERIENCE_ACTION_LABEL_MAX = 60;

// src/engagement/engagement-variant.ts
var ENGAGEMENT_MAX_VARIANTS = 4;
var ENGAGEMENT_VARIANT_WEIGHT_MAX = 100;
var ENGAGEMENT_HOLDOUT_MAX_PCT = 50;
var VARIANT_TEXT_MAX = 280;
var EngagementVariantSchema = /* @__PURE__ */ z.object({
  /** Wire-safe arm name. Validated against the ref charset, never a looser one. */
  name: z.string().regex(NUDGE_VARIANT_PATTERN),
  /**
   * This arm's copy, in the ENGAGEMENT surface's spelling.
   *
   * Optional as of ADR-0562 F4, and required back by
   * {@link EngagementVariantsSchema} — so an engagement rule behaves exactly as
   * it did, while a surface with a richer content model can use the slots below
   * instead of carrying a field it does not read.
   *
   * Still a plain string, and that is now the ONE thing on this surface an
   * experiment does not localize.
   *
   * It was deferred by ADR-0562 F4 to "wiring that surface's serving half",
   * which has since landed (D-080, CLOSED): an engagement rule assigns an arm,
   * the arm's copy reaches the visitor, and the funnel attributes it. So a
   * German visitor in the treatment arm now reads this string in whatever
   * language it was authored in, while the control arm reads the rule's own
   * `message.text` — which is equally un-localized, so the two arms are at
   * least comparable. The experiment does not silently un-localize the surface;
   * it inherits an editor that never localized it.
   *
   * Widening to `customerTextSchema` is still correct and is still a change of
   * its own: it is the engagement authoring EDITOR's field, and the serving
   * half it was waiting for turned out to need no authoring change at all.
   */
  message: z.object({ text: z.string().min(1).max(VARIANT_TEXT_MAX) }).optional(),
  /**
   * ADR-0562 § 4 (F4) — what an arm may vary on a surface whose content has
   * more than one slot, and the reason this schema was widened at all.
   *
   * Before F4 an arm carried ONE string, so it could only vary the BODY: *a
   * different headline* and *a different CTA label* — the two experiments people
   * actually run — were not expressible.
   *
   * All three are `customerTextSchema`, so they accept either a bare string or
   * the `{ default, byLocale }` form. That matters more than it looks: without
   * it, running an experiment silently un-localizes the surface, and a German
   * visitor in the treatment arm reads English while the control arm reads
   * German — a regression an operator would attribute to the copy rather than to
   * the experiment.
   *
   * `bullets` are deliberately absent. Nobody has asked to vary a bullet list,
   * and a slot added because it completes the set is a slot with no demand
   * behind it.
   */
  body: customerTextSchema(VARIANT_TEXT_MAX).optional(),
  heading: customerTextSchema(EXPERIENCE_HEADING_MAX).optional(),
  /**
   * Overrides the label of the unit's FIRST action — its primary CTA.
   *
   * The first, not all of them, because "a different CTA label" means the one
   * button an operator is testing. Relabelling every action at once is a
   * different experiment nobody described, and an arm that silently renamed a
   * secondary "Not now" would be changing what it did not claim to change.
   *
   * Whether the unit HAS an action to label is cross-validated on
   * `ExperienceUnitSchema`, the only place both halves are visible at once.
   */
  actionLabel: customerTextSchema(EXPERIENCE_ACTION_LABEL_MAX).optional(),
  /** Relative weight; equal weights split evenly. */
  weight: z.number().int().min(1).max(ENGAGEMENT_VARIANT_WEIGHT_MAX).default(1)
});
function withArmSetRules(arms) {
  return z.array(arms).max(ENGAGEMENT_MAX_VARIANTS).default([]).refine((list2) => list2.length !== 1, {
    message: "an experiment needs at least two variants"
  }).refine(
    (list2) => new Set(list2.map((a) => a.name.toLowerCase())).size === list2.length,
    { message: "variant names must be distinct" }
  );
}
var EngagementVariantsSchema = withArmSetRules(
  EngagementVariantSchema.refine((arm) => arm.message !== void 0, {
    message: "an engagement variant needs its own copy",
    path: ["message"]
  }).refine((arm) => arm.heading === void 0, {
    message: "an engagement nudge has no heading for a variant to override",
    path: ["heading"]
  }).refine((arm) => arm.actionLabel === void 0, {
    message: "an engagement nudge has no action for a variant to label",
    path: ["actionLabel"]
  }).refine((arm) => arm.body === void 0, {
    message: "an engagement variant carries its copy under message.text",
    path: ["body"]
  })
);
var ExperienceVariantsSchema = withArmSetRules(
  EngagementVariantSchema.transform((arm) => {
    const body = arm.body ?? arm.message?.text;
    return {
      name: arm.name,
      weight: arm.weight,
      ...body === void 0 ? {} : { body },
      ...arm.heading === void 0 ? {} : { heading: arm.heading },
      ...arm.actionLabel === void 0 ? {} : { actionLabel: arm.actionLabel }
    };
  }).refine(
    (arm) => arm.body !== void 0 || arm.heading !== void 0 || arm.actionLabel !== void 0,
    {
      message: "a variant must override something \u2014 an arm that changes nothing is not an arm"
    }
  )
);
function holdoutSalt(rolloutSalt) {
  return `${rolloutSalt}:holdout`;
}
function isInHoldout(subject, rolloutSalt, pct) {
  if (!Number.isFinite(pct) || pct <= 0) return false;
  const capped = Math.min(pct, ENGAGEMENT_HOLDOUT_MAX_PCT);
  const threshold = Math.round(capped * (ROLLOUT_BUCKETS / 100));
  return stableBucket(subject, holdoutSalt(rolloutSalt)) < threshold;
}
function assignVariant(subject, rolloutSalt, variants) {
  if (variants.length === 0) return null;
  const total = variants.reduce((sum, v) => sum + v.weight, 0);
  if (total <= 0) return null;
  const bucket = stableBucket(subject, `${rolloutSalt}:variant`);
  const point = bucket / ROLLOUT_BUCKETS * total;
  let cumulative = 0;
  for (const variant of variants) {
    cumulative += variant.weight;
    if (point < cumulative) return variant.name;
  }
  return variants[variants.length - 1]?.name ?? null;
}
function audienceShapeFields(options) {
  return {
    /** Audience segment id (UGL-101 audiences); `null` → no segment restriction. */
    segmentId: z.string().uuid().nullable().default(null),
    /**
     * Whether an ANONYMOUS visitor (no verified sub) is eligible via the
     * fallback path. The one field whose default differs by surface — see the
     * module doc.
     */
    anonymousFallback: z.boolean().default(options.anonymousFallbackDefault),
    /**
     * `all | firstTime | returning | signedIn`. Honored by
     * `evaluate-eligibility`'s `matchesVisitorType`, for BOTH surfaces.
     */
    visitorType: z.enum(WIDGET_PROACTIVE_VISITOR_TYPES).default("all"),
    /**
     * Empty ⇒ every locale, because the schema default must not exclude anyone.
     * Honored by `evaluate-eligibility`, which fails OPEN on a visitor whose
     * locale the host does not report (see the reasoning at that gate).
     */
    locales: z.array(z.enum(WIDGET_PROACTIVE_LOCALES)).max(6).default([])
  };
}
var ENGAGEMENT_TRIGGER_TYPES = [
  "dwell",
  "scroll",
  "exitIntent",
  "route",
  "hostEvent",
  "trackedEvent",
  "formAbandon",
  "frustration"
];
var ENGAGEMENT_ROUTE_MAX = 200;
var ENGAGEMENT_EVENT_NAME_MAX = 100;
var ENGAGEMENT_EVENT_MATCH_MAX = 4;
var ENGAGEMENT_EVENT_KEY_MAX = 40;
var ENGAGEMENT_EVENT_VALUE_MAX = 200;
var ENGAGEMENT_EVENT_KEY_PATTERN = /^[A-Za-z0-9_.-]{1,40}$/;
var ENGAGEMENT_DWELL_MAX_SECONDS = 3600;
var ENGAGEMENT_ABANDON_MAX_SECONDS = 300;
var EngagementEventMatchSchema = /* @__PURE__ */ z.object({
  key: z.string().regex(ENGAGEMENT_EVENT_KEY_PATTERN),
  equals: z.union([z.string().max(ENGAGEMENT_EVENT_VALUE_MAX), z.number(), z.boolean()])
});
var EngagementTriggerSchema = /* @__PURE__ */ z.discriminatedUnion("type", [
  z.object({
    type: z.literal("dwell"),
    seconds: z.number().int().min(1).max(ENGAGEMENT_DWELL_MAX_SECONDS)
  }),
  z.object({ type: z.literal("scroll"), percent: z.number().int().min(1).max(100) }),
  z.object({ type: z.literal("exitIntent") }),
  z.object({ type: z.literal("route"), glob: z.string().min(1).max(ENGAGEMENT_ROUTE_MAX) }),
  z.object({
    type: z.literal("hostEvent"),
    name: z.string().min(1).max(ENGAGEMENT_EVENT_NAME_MAX)
  }),
  // F6(d) — the `syncanix.track` envelope. A SEPARATE type rather than an
  // optional `where` on `hostEvent`, and the reason is forward compatibility in
  // the direction that matters: the widget adapts a delivered trigger from raw
  // JSON, so a bundle predating this field would read the name, ignore the
  // match list, and fire the rule for EVERY value of the property the operator
  // narrowed on — a targeting rule silently widened on exactly the visitors
  // running an older cached bundle. An unrecognised trigger TYPE is already
  // handled: `toArmableTrigger` returns null and the rule is simply not armed,
  // which is the safe direction for a narrowing.
  //
  // It is also honestly a different contract. `hostEvent` matches any
  // `syncanix:<name>` CustomEvent the page dispatches; this one matches the
  // envelope `window.syncanix.track(name, props)` produces, and the properties
  // are compared IN THE BROWSER — nothing about them is ever sent to Syncanix.
  z.object({
    type: z.literal("trackedEvent"),
    name: z.string().min(1).max(ENGAGEMENT_EVENT_NAME_MAX),
    /**
     * Every clause must match for the rule to fire. Empty ⇒ the name alone,
     * which is `hostEvent`'s behaviour and a legitimate thing to want from the
     * `track` API.
     */
    where: z.array(EngagementEventMatchSchema).max(ENGAGEMENT_EVENT_MATCH_MAX).default([])
  }),
  // F6(d) — the visitor started filling something in and stopped.
  //
  // Deliberately ONE sentence an operator can reason about: N seconds after
  // they last typed, IF the page still holds unfinished work and nothing has
  // been submitted. The alternatives were considered and are worse as a first
  // axis — an exit-intent variant fires on a mouse path rather than on a
  // decision, and a `beforeunload` one arrives when there is no time left to
  // show anything.
  //
  // What "unfinished work" means is not this schema's to define: the browser
  // decides it, through the same fail-CLOSED predicate that already stops a
  // guided tour navigating away from a half-filled form (`page-mid-work.ts`).
  // Re-deriving it here would be a second answer to one question, and the two
  // would drift on exactly the surfaces that matter — a rich-text editor, an
  // open shadow root.
  z.object({
    type: z.literal("formAbandon"),
    seconds: z.number().int().min(1).max(ENGAGEMENT_ABANDON_MAX_SECONDS).default(20)
  }),
  // UGL-108 M12 — a faithful superset of the v1 `frustration` trigger: which
  // friction signals arm the rule (`signals[]`, default all) + how many
  // qualifying signals before firing (`threshold`). Reuses the v1 constants so
  // the M12 mapping is a straight copy.
  z.object({
    type: z.literal("frustration"),
    signals: z.array(z.enum(WIDGET_PROACTIVE_FRICTION_SIGNALS)).nonempty().default([...WIDGET_PROACTIVE_FRICTION_SIGNALS]),
    threshold: z.number().int().min(1).max(WIDGET_PROACTIVE_FRUSTRATION_THRESHOLD_MAX).default(1)
  })
]);

// src/engagement/rank-openers.ts
var NO_OPENER_SIGNALS = {
  returning: false,
  hasDislike: false,
  hasCorrection: false,
  audienceIds: []
};
var OPENER_TONES = ["plain", "promotional", "welcomeBack"];
var OPENER_REASONS = [
  "targetedAudience",
  "returningVisitor",
  "avoidedPromotionAfterDislike",
  "avoidedPromotionAfterCorrection",
  "welcomeBackSuppressedForNewVisitor"
];
function rankOpeners(candidates, signals) {
  const scored = [];
  for (const candidate of candidates) {
    if (candidate.tone === "welcomeBack" && !signals.returning) continue;
    const reasons = [];
    let bonus = 0;
    if (candidate.audienceSegmentId !== null && signals.audienceIds.includes(candidate.audienceSegmentId)) {
      bonus += 2;
      reasons.push("targetedAudience");
    }
    if (candidate.tone === "welcomeBack" && signals.returning) {
      bonus += 2;
      reasons.push("returningVisitor");
    }
    if (candidate.tone === "promotional") {
      if (signals.hasDislike) {
        bonus -= 2;
        reasons.push("avoidedPromotionAfterDislike");
      }
      if (signals.hasCorrection) {
        bonus -= 2;
        reasons.push("avoidedPromotionAfterCorrection");
      }
    }
    scored.push({ candidate, reasons, bonus });
  }
  return scored.sort((a, b) => {
    if (a.candidate.priority !== b.candidate.priority) {
      return b.candidate.priority - a.candidate.priority;
    }
    if (a.bonus !== b.bonus) return b.bonus - a.bonus;
    if (a.candidate.createdAt !== b.candidate.createdAt) {
      return a.candidate.createdAt - b.candidate.createdAt;
    }
    return a.candidate.ruleId.localeCompare(b.candidate.ruleId);
  }).map(({ candidate, reasons }) => ({ ...candidate, reasons }));
}
function pickOpener(candidates, signals) {
  return rankOpeners(candidates, signals)[0] ?? null;
}

// src/engagement/engagement-rule.schema.ts
var ENGAGEMENT_RULE_KINDS = ["opener", "nudge", "campaign"];
var ENGAGEMENT_RULE_STATUSES = ["draft", "active", "paused", "archived"];
var ENGAGEMENT_GOALS = ["startedChat", "completedAction", "resolvedNoHuman"];
var ENGAGEMENT_DESKTOP_DISPLAYS = ["bubble", "badge", "open"];
var ENGAGEMENT_MOBILE_DISPLAYS = ["bubble", "badge"];
var ENGAGEMENT_RULE_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
var ENGAGEMENT_NAME_MAX = 80;
var ENGAGEMENT_TEXT_MAX = 280;
var ENGAGEMENT_PRIORITY_MAX = 1e3;
var ENGAGEMENT_ROLLOUT_SALT_MAX = 64;
var IsoDateSchema = /* @__PURE__ */ z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
var HourSchema = /* @__PURE__ */ z.number().int().min(0).max(23);
var DayOfWeekSchema = /* @__PURE__ */ z.number().int().min(0).max(6);
var EngagementScheduleSchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  // UGL-108 M12 — "eligible whenever triggered" (modulo quiet hours); the
  // faithful target for a v1 proactive rule (no schedule concept).
  z.object({ kind: z.literal("always") }),
  z.object({ kind: z.literal("once_ever") }),
  z.object({ kind: z.literal("every_n_days"), days: z.number().int().min(1).max(365) }),
  z.object({
    kind: z.literal("date_window"),
    startDate: IsoDateSchema,
    endDate: IsoDateSchema,
    timeZone: z.string().min(1).max(64).optional()
  }),
  z.object({
    kind: z.literal("recurring"),
    daysOfWeek: z.array(DayOfWeekSchema).min(1).max(7),
    startHour: HourSchema,
    endHour: HourSchema
  })
]);
var QuietHoursSchema = /* @__PURE__ */ z.object({ startHour: HourSchema, endHour: HourSchema });
var EngagementAudienceSchema = /* @__PURE__ */ z.object({
  // F6(b) — the four WHO fields are declared once (`audience-shape.ts`) and
  // composed here. A rule is an INTERRUPTION, so "no verified sub" reads as not
  // eligible; the sibling surface argues its own default at its own call site.
  ...audienceShapeFields({ anonymousFallbackDefault: false })
});
var EngagementMessageSchema = /* @__PURE__ */ z.object({
  text: z.string().min(1).max(ENGAGEMENT_TEXT_MAX)
});
var EngagementLimitsSchema = /* @__PURE__ */ z.object({
  maxPerSession: z.number().int().min(1).max(10).default(1),
  maxPer7Days: z.number().int().min(1).max(50).default(3),
  cooldownAfterDismissHours: z.number().int().min(0).max(8760).default(168),
  quietHours: QuietHoursSchema.optional()
});
var EngagementDisplaySchema = /* @__PURE__ */ z.object({
  desktop: z.enum(ENGAGEMENT_DESKTOP_DISPLAYS).default("bubble"),
  mobile: z.enum(ENGAGEMENT_MOBILE_DISPLAYS).default("bubble")
});
var EngagementRuleSchema = /* @__PURE__ */ z.object({
  id: z.string().regex(ENGAGEMENT_RULE_ID_PATTERN),
  name: z.string().min(1).max(ENGAGEMENT_NAME_MAX),
  kind: z.enum(ENGAGEMENT_RULE_KINDS).default("nudge"),
  status: z.enum(ENGAGEMENT_RULE_STATUSES).default("draft"),
  audience: EngagementAudienceSchema.default({}),
  /** Rollout percentage 0..100 (default 0 — nobody until deliberately ramped). */
  rolloutPct: z.number().int().min(0).max(100).default(0),
  /** Explicit bucketing salt (UGL-106 stableBucket); rotating it re-rolls the population. */
  rolloutSalt: z.string().min(1).max(ENGAGEMENT_ROLLOUT_SALT_MAX),
  trigger: EngagementTriggerSchema,
  schedule: EngagementScheduleSchema.default({ kind: "once_ever" }),
  display: EngagementDisplaySchema.default({}),
  message: EngagementMessageSchema,
  goal: z.enum(ENGAGEMENT_GOALS).default("startedChat"),
  /**
   * UGL-307 (§ 6-B6) — operator-declared tone, used by the opener ranker.
   *
   * OPTIONAL with NO default, deliberately. A default of `'plain'` would claim
   * every existing opener had been classified when none has, and the ranker
   * treats an absent tone as carrying no signal rather than as neutral — an
   * inferred tone is worse than a missing one, because the ranker would then act
   * on a fact the operator never stated. It is an enum rather than something
   * derived from the message text: "is this opener pushy?" must never become a
   * string heuristic over customer copy in six languages.
   */
  tone: z.enum(OPENER_TONES).optional(),
  /**
   * UGL-301b (§ 6-B4) — the declared A/B arms. Empty (the default) means the
   * rule runs no experiment and rolls up under the no-variant sentinel bucket.
   *
   * This closes the half of UGL-304 that shipped without it: the measurement
   * pipeline was variant-capable end to end and no rule could declare an arm.
   * Constraints (two-arm minimum, distinct names, wire-safe charset) live on
   * {@link EngagementVariantsSchema} — see that module for why each one fails
   * silently if skipped.
   */
  variants: EngagementVariantsSchema,
  /**
   * UGL-301b — the share of otherwise-eligible visitors that WOULD be shown
   * NOTHING, so the rule's effect has a counterfactual.
   *
   * **STORED AND NOT ENFORCED (D-053).** This comment described the runtime
   * behaviour in the present tense until 2026-08-28, and there is none:
   * `isInHoldout` has no production caller, so no visitor has ever been held
   * back. The gap is deliberate and its shape is on the ledger — a held-out
   * visitor is shown nothing, so there is no impression beacon and therefore no
   * control-arm denominator; the counterfactual needs a SERVER-side
   * eligible-but-held-back record at decision time, on the hottest public path,
   * with its own retention leg and its own privacy question.
   *
   * The field stays parseable so a value an API client already wrote survives
   * for whenever that lands, and `parseEngagementRuleInput` REFUSES a new
   * non-zero one — the only place the misreading this could cause is
   * reachable. Zero is the only value the product will accept today, and zero
   * is what it honours.
   */
  holdoutPct: z.number().int().min(0).max(ENGAGEMENT_HOLDOUT_MAX_PCT).default(0),
  /** Collision-governor priority (higher wins); default 0. */
  priority: z.number().int().min(0).max(ENGAGEMENT_PRIORITY_MAX).default(0),
  limits: EngagementLimitsSchema.default({})
});
var ENGAGEMENT_SURFACES = ["opener", "nudge", "campaign", "any"];
var RateLimitPolicySchema = /* @__PURE__ */ z.object({
  id: z.string().regex(ENGAGEMENT_RULE_ID_PATTERN),
  name: z.string().min(1).max(ENGAGEMENT_NAME_MAX),
  /** The surface class this policy caps. */
  surface: z.enum(ENGAGEMENT_SURFACES).default("any"),
  /** Max shows per rolling window across the scoped surface. */
  maxPerWindow: z.number().int().min(1).max(1e3),
  windowHours: z.number().int().min(1).max(8760)
});
var TENANT_SPACING_DEFAULT_SECONDS = 300;

// src/engagement/map-proactive-to-engagement.ts
function mapTrigger(trigger) {
  switch (trigger.type) {
    case "dwell":
      return { type: "dwell", seconds: trigger.seconds };
    case "scroll":
      return { type: "scroll", percent: trigger.percent };
    case "exitIntent":
      return { type: "exitIntent" };
    case "route":
      return { type: "route", glob: trigger.pattern };
    case "hostEvent":
      return { type: "hostEvent", name: trigger.name };
    case "frustration":
      return { type: "frustration", signals: trigger.signals, threshold: trigger.threshold };
  }
}
function mapProactiveRuleToEngagement(rule, opts) {
  const mapped = {
    // The v1 id + engagement id/rule_key share the same charset; used verbatim so
    // the migration upsert is idempotent on `(tenant, environment, rule_key)`.
    id: rule.id,
    name: rule.name,
    kind: "nudge",
    status: opts.masterEnabled && rule.enabled ? "active" : "paused",
    audience: {
      // v1 has no audience-segment concept — no segment restriction.
      segmentId: null,
      // `signedIn` ⇒ authed-only ⇒ anon NOT eligible; every other visitorType
      // includes anonymous visitors (the board's documented clean mapping).
      anonymousFallback: rule.audience.visitorType !== "signedIn",
      visitorType: rule.audience.visitorType,
      locales: rule.audience.locales ?? []
    },
    // v1 enabled rules fire for everyone (no rollout gating) → 100%; the id is a
    // stable, deterministic bucketing salt.
    rolloutPct: 100,
    rolloutSalt: rule.id,
    trigger: mapTrigger(rule.trigger),
    // v1 has no schedule concept — eligible whenever triggered (modulo limits).
    schedule: { kind: "always" },
    display: {
      // openPanel → open (assertive), bubble → bubble; mobile never auto-opens.
      desktop: rule.presentation === "openPanel" ? "open" : "bubble",
      mobile: "bubble"
    },
    // `chips` is the one dropped field (see the module doc).
    message: { text: rule.message.text },
    goal: rule.goal,
    // v1 proactive rules have no A/B concept, so an imported rule runs no
    // experiment and holds nobody back. Stated rather than defaulted: the M12
    // import must never invent an arm the operator did not author, and a future
    // reader should see that this is a faithful mapping of "v1 had none" rather
    // than a field someone forgot.
    variants: [],
    holdoutPct: 0,
    priority: opts.priority ?? 0,
    limits: {
      maxPerSession: rule.limits.maxPerSession,
      // CARRIED, and not yet ENFORCED on the v2 surface — stated here because
      // this line is where a reader would otherwise conclude it is (A2-4).
      //
      // v1 enforces this cap in the browser
      // (`apps/widget/src/proactive/frequency-state.ts`, a durable rolling
      // window in `localStorage`). v2 cannot do the same: its source keeps
      // every signal in MEMORY on a cited ePrivacy stance — asserted by
      // `engagement-source.test.ts` § "keeps dismissals in MEMORY only", which
      // covers impressions too — so a seven-day window has nowhere to live on
      // the client. And it cannot yet be done on the server either: engagement
      // has no per-impression report leg at all (the funnel is written by a
      // nightly job from aggregates), so there is nothing to count.
      //
      // The value is carried anyway rather than dropped: dropping it would
      // lose what the operator authored, and the cap becomes enforceable the
      // moment either half exists. The import surface says so, so an operator
      // arming an imported rule is told the weekly cap does not travel yet.
      maxPer7Days: rule.limits.maxPer7Days,
      cooldownAfterDismissHours: rule.limits.cooldownAfterDismissHours,
      ...rule.limits.quietHours ? {
        quietHours: {
          startHour: rule.limits.quietHours.start,
          endHour: rule.limits.quietHours.end
        }
      } : {}
    }
  };
  return EngagementRuleSchema.parse(mapped);
}

// src/engagement/collision-governor.ts
function governCollision(candidates, ctx) {
  if (ctx.alreadyShownThisPageView === true) {
    return { ruleId: null, suppressedBy: "page-view" };
  }
  const spacingMs = (ctx.spacingSeconds ?? TENANT_SPACING_DEFAULT_SECONDS) * 1e3;
  if (ctx.lastSurfaceAt !== null && ctx.now - ctx.lastSurfaceAt < spacingMs) {
    return { ruleId: null, suppressedBy: "spacing" };
  }
  if (candidates.length === 0) return { ruleId: null, suppressedBy: "no-candidates" };
  const winner = [...candidates].sort(compareCandidates)[0];
  return winner === void 0 ? { ruleId: null, suppressedBy: "no-candidates" } : { ruleId: winner.ruleId, suppressedBy: "none" };
}
function compareCandidates(a, b) {
  if (a.priority !== b.priority) return b.priority - a.priority;
  const aSeen = a.lastShownAt !== null;
  const bSeen = b.lastShownAt !== null;
  if (aSeen !== bSeen) return aSeen ? 1 : -1;
  if (aSeen && bSeen && a.lastShownAt !== b.lastShownAt) {
    return a.lastShownAt - b.lastShownAt;
  }
  if (a.createdAt !== b.createdAt) return a.createdAt - b.createdAt;
  return a.ruleId < b.ruleId ? -1 : a.ruleId > b.ruleId ? 1 : 0;
}

// src/engagement/eligible-payload.ts
function toEligiblePayload(rule, createdAt, variant) {
  const arm = variant === null ? void 0 : rule.variants.find((v) => v.name === variant);
  return {
    ruleId: rule.id,
    kind: rule.kind,
    trigger: rule.trigger,
    display: rule.display,
    message: arm?.message ?? rule.message,
    goal: rule.goal,
    priority: rule.priority,
    createdAt,
    ...variant === null ? {} : { variant }
  };
}

// src/engagement/engagement-fatigue.ts
var HOUR_MS = 36e5;
function isUsablePastTimestamp(at, now) {
  return at !== void 0 && Number.isFinite(at) && at <= now;
}
function isInDismissalCooldown(dismissedAt, cooldownHours, now) {
  if (!Number.isFinite(cooldownHours) || cooldownHours <= 0) return false;
  if (!isUsablePastTimestamp(dismissedAt, now)) return false;
  return now - dismissedAt < cooldownHours * HOUR_MS;
}
var ENGAGEMENT_FATIGUE_DEFAULT_POLICY = {
  threshold: 3,
  windowHours: 24
};
function evaluateFatigue(dismissedAt, now, policy = ENGAGEMENT_FATIGUE_DEFAULT_POLICY) {
  const windowMs = policy.windowHours * HOUR_MS;
  const disabled = !Number.isFinite(policy.threshold) || policy.threshold <= 0 || !Number.isFinite(policy.windowHours) || policy.windowHours <= 0;
  let recentDismissals = 0;
  for (const at of dismissedAt.values()) {
    if (!isUsablePastTimestamp(at, now)) continue;
    if (windowMs > 0 && now - at >= windowMs) continue;
    recentDismissals += 1;
  }
  if (disabled) return { suppressed: false, recentDismissals };
  return { suppressed: recentDismissals >= policy.threshold, recentDismissals };
}

// src/engagement/evaluate-eligibility.ts
function matchesVisitorType(visitorType, subject, anonymousFallback) {
  if (visitorType === "all") return true;
  if (visitorType === "signedIn") return subject.verified;
  if (visitorType !== "returning" && visitorType !== "firstTime") {
    return true;
  }
  if (subject.returning === void 0) return anonymousFallback;
  return visitorType === "returning" ? subject.returning : !subject.returning;
}
function baseLanguage(locale) {
  return locale.toLowerCase().split(/[-_]/u)[0] ?? "";
}
function evaluateEligibility(input, subject, ctx) {
  const { rule, audienceSegmentId } = input;
  if (rule.status !== "active") return { eligible: false, reason: "status" };
  if (audienceSegmentId !== null) {
    const member = subject.audienceIds.includes(audienceSegmentId);
    if (!member && !(!subject.verified && rule.audience.anonymousFallback)) {
      return { eligible: false, reason: "audience" };
    }
  }
  if (!matchesVisitorType(rule.audience.visitorType, subject, rule.audience.anonymousFallback)) {
    return { eligible: false, reason: "audience" };
  }
  if (rule.audience.locales.length > 0 && subject.locale !== void 0) {
    const want = new Set(rule.audience.locales.map(baseLanguage));
    if (!want.has(baseLanguage(subject.locale))) {
      return { eligible: false, reason: "audience" };
    }
  }
  if (!isInRollout(subject.bucketKey, rule.rolloutSalt, rule.rolloutPct)) {
    return { eligible: false, reason: "rollout" };
  }
  const lastShownAt = ctx.lastShownAt.get(rule.id);
  const scheduleOk = evaluateSchedule(rule.schedule, {
    now: ctx.now.getTime(),
    // UTC when the visitor's zone is unknown: a schedule evaluated in a GUESSED
    // zone is worse than one evaluated in a stated one, and quiet hours are
    // documented as advisory (§ 6-B2), not a compliance control.
    visitorTimeZone: subject.timeZone ?? "UTC",
    ...lastShownAt === void 0 ? {} : { lastShownAt },
    ...rule.limits.quietHours === void 0 ? {} : { quietHours: rule.limits.quietHours }
  });
  if (!scheduleOk) return { eligible: false, reason: "schedule" };
  if (isInDismissalCooldown(
    ctx.dismissedAt?.get(rule.id),
    rule.limits.cooldownAfterDismissHours,
    ctx.now.getTime()
  )) {
    return { eligible: false, reason: "dismissed" };
  }
  const shown = ctx.shownThisSession?.get(rule.id);
  if (typeof shown === "number" && Number.isFinite(shown) && shown > 0) {
    if (shown >= rule.limits.maxPerSession) {
      return { eligible: false, reason: "frequency" };
    }
  }
  return { eligible: true };
}

// src/engagement/engagement-funnel.ts
var ENGAGEMENT_FUNNEL_STAGES = ["displayed", "engaged", "replied", "goal"];
var FUNNEL_STAGE_BY_EVENT_KIND = {
  nudge_shown: "displayed",
  nudge_accepted: "engaged"
};
var EMPTY_FUNNEL = { displayed: 0, engaged: 0, replied: 0, goal: 0 };
function clampFunnel(counts) {
  const displayed = Math.max(0, counts.displayed);
  const engaged = displayed === 0 ? Math.max(0, counts.engaged) : Math.min(Math.max(0, counts.engaged), displayed);
  const replied = Math.min(Math.max(0, counts.replied), engaged);
  const goal = Math.min(Math.max(0, counts.goal), replied);
  return { displayed, engaged, replied, goal };
}
function impressionsObserved(counts) {
  return counts.displayed > 0;
}
function conversionRate(counts, from, to) {
  const denominator = counts[from];
  if (denominator <= 0) return null;
  return counts[to] / denominator;
}
var MIN_VARIANT_SAMPLE = 100;
function compareVariants(byVariant) {
  const variants = [...byVariant.entries()].sort((a, b) => a[0].localeCompare(b[0])).map(([variant, raw]) => {
    const counts = clampFunnel(raw);
    return {
      variant,
      counts,
      conversion: conversionRate(counts, "displayed", "goal"),
      sufficientSample: counts.displayed >= MIN_VARIANT_SAMPLE
    };
  });
  const baseline = variants[0];
  if (baseline === void 0 || variants.length < 2) {
    return { variants, lift: null, baseline: baseline?.variant ?? null };
  }
  const allSufficient = variants.every((v) => v.sufficientSample);
  const baselineRate = baseline.conversion;
  if (!allSufficient || baselineRate === null || baselineRate <= 0) {
    return { variants, lift: null, baseline: baseline.variant };
  }
  const best = variants.reduce((a, b) => rateOf(b) > rateOf(a) ? b : a);
  return {
    variants,
    lift: (rateOf(best) - baselineRate) / baselineRate,
    baseline: baseline.variant
  };
}
function rateOf(variant) {
  return variant.conversion ?? 0;
}

// src/engagement/business-outcome-verdict.ts
var BUSINESS_OUTCOME_VERDICT_IDS = [
  "not-reporting",
  "too-early",
  "no-outcome-yet",
  "driving"
];
function businessOutcomeVerdict(input) {
  const nudged = clampCount2(input.nudged);
  const withOutcome = Math.min(clampCount2(input.withOutcome), nudged);
  const base = { nudged, withOutcome };
  if (!input.workspaceReporting) return { id: "not-reporting", ...base };
  if (nudged < MIN_VARIANT_SAMPLE) return { id: "too-early", ...base };
  if (withOutcome <= 0) return { id: "no-outcome-yet", ...base };
  return { id: "driving", ...base, rate: withOutcome / nudged };
}
function clampCount2(value) {
  return Number.isFinite(value) && value > 0 ? Math.floor(value) : 0;
}

// src/engagement/engagement-verdict.ts
var ENGAGEMENT_VERDICT_IDS = [
  "impressions-not-captured",
  "too-early",
  "no-goal-yet",
  "converting",
  "arm-ahead"
];
function engagementVerdict(args) {
  const { counts, goal } = args;
  if (!impressionsObserved(counts)) return { id: "impressions-not-captured", goal };
  if (counts.displayed < MIN_VARIANT_SAMPLE) return { id: "too-early", goal };
  const winner = decidedArm(args.comparison);
  if (winner !== null) return { ...winner, goal };
  const rate2 = conversionRate(counts, "displayed", "goal");
  if (rate2 === null || rate2 <= 0) return { id: "no-goal-yet", goal };
  return { id: "converting", goal, rate: rate2 };
}
function decidedArm(comparison) {
  if (comparison === void 0) return null;
  const { lift, baseline } = comparison;
  if (lift === null || lift <= 0 || baseline === null) return null;
  const best = comparison.variants.reduce(
    (a, b) => (b.conversion ?? 0) > (a.conversion ?? 0) ? b : a
  );
  if (best.variant === baseline) return null;
  return {
    id: "arm-ahead",
    arm: best.variant,
    against: baseline,
    lift,
    ...best.conversion === null ? {} : { rate: best.conversion }
  };
}
var VERDICT_ORDER3 = {
  "no-goal-yet": 0,
  converting: 1,
  "arm-ahead": 1,
  "too-early": 2,
  "impressions-not-captured": 3
};
function compareEngagementVerdicts(a, b) {
  const byState = VERDICT_ORDER3[a.id] - VERDICT_ORDER3[b.id];
  if (byState !== 0) return byState;
  const rateA = a.rate ?? Number.POSITIVE_INFINITY;
  const rateB = b.rate ?? Number.POSITIVE_INFINITY;
  return rateA - rateB;
}

// src/engagement/test-mode-param.ts
var ENGAGEMENT_TEST_PARAM = "syncanix-test";
var EXPERIENCE_ACTION_KINDS = [
  "open-chat",
  "start-guide",
  "run-capability",
  "navigate",
  "link",
  "dismiss",
  "snooze"
];
var EXPERIENCE_CHAT_PREFILL_MAX = 280;
var EXPERIENCE_ROUTE_ID_PATTERN = /^[A-Za-z0-9_][A-Za-z0-9_.-]*$/;
var EXPERIENCE_ROUTE_ID_MAX = 128;
var EXPERIENCE_GUIDE_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
var EXPERIENCE_CAPABILITY_ID_MAX = 200;
var EXPERIENCE_SNOOZE_MAX_HOURS = 720;
var LabelSchema2 = /* @__PURE__ */ z.string().min(1).max(EXPERIENCE_ACTION_LABEL_MAX);
var OperatorUrlSchema = /* @__PURE__ */ z.string().max(2048).refine((value) => /^https:\/\/[^\s]+$/.test(value), { message: "https-url-required" });
var ExperienceActionSchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("open-chat"),
    label: LabelSchema2,
    /**
     * The question the visitor is offered, so they land mid-thought rather than
     * at a blank box.
     *
     * **Offered as a one-tap CHIP, not typed into the composer**, and the
     * distinction is the router's own rule rather than an implementation
     * detail: a CTA is a REQUEST, never an execution, so `cta-router.ts` turns
     * this into the same canned `suggestions` event a proactive nudge uses and
     * the visitor presses it themselves. Seeding the composer would put words in
     * their mouth that they then have to delete, and it would be a second way
     * into the agent beside the one everything else is gated through. This line
     * read "seeds the composer" until 2026-08-28, describing behaviour the code
     * has never had — found by the qa acceptance, which asserted the sentence
     * and got an empty composer.
     *
     * FREE TEXT, and it has to be — a sentence is the whole point, so a grammar
     * here would not be a tightening, it would be the field not working. Its
     * sibling `capabilityId` took the opposite treatment (F-8) precisely because
     * it is an ID: a closed grammar costs it nothing.
     *
     * So the boundary this field needs is not in the schema, and saying so is
     * the honest version. Bounded today because only an operator writes units.
     * When ADR-0562's F1 drafter ships, a drafted `prefill` is model-authored
     * text that becomes a user turn one tap away — the drafter must screen it
     * through `screenDraftingInput` like every other conversation-derived
     * source, and the born-draft + explicit-arm gate is the second layer rather
     * than the only one. A drafter that writes this field without the screen is
     * a review finding.
     */
    prefill: z.string().min(1).max(EXPERIENCE_CHAT_PREFILL_MAX).optional()
  }),
  z.object({
    kind: z.literal("start-guide"),
    label: LabelSchema2,
    guideId: z.string().regex(EXPERIENCE_GUIDE_ID_PATTERN)
  }),
  z.object({
    kind: z.literal("run-capability"),
    label: LabelSchema2,
    /**
     * The capability to run. Execution re-enters the FULL existing chain —
     * enablement, side-effect class, ConfirmCard, signed intent, metering — so a
     * unit is a requester and never a bypass. Named here, gated there.
     *
     * REFUSED against the platform's own capability-id grammar (F-8), like both
     * of its siblings in this union. It was `z.string().min(1).max(200)` with no
     * grammar at all, and the value is interpolated into a visitor-tappable
     * prompt (`cta-router.ts`) that becomes a user turn — so an unbounded string
     * here is a free-text channel INTO a turn, one tap away, which is exactly
     * the "a free-text destination is a channel; an id is a choice among things
     * a human approved" distinction this file's own header draws for `navigate`.
     *
     * Bounded to an operator's own workspace today, because there is no
     * non-operator write path (F-16). ADR-0562's F1 drafter is the one that
     * makes it matter: an agent-drafted unit would otherwise carry up to 200
     * characters of model-authored text into a turn. The human review gate is
     * the compensating control and is real; the schema was not doing its share.
     *
     * `CAPABILITY_ID_PATTERN` rather than a local one, so a unit can never name
     * a shape the catalog cannot hold — and note it is deliberately DISJOINT
     * from `ui:` unit ids (`catalog/ui-unit.ts`), so a CTA cannot address a
     * Copilot unit through this field.
     */
    capabilityId: z.string().regex(CAPABILITY_ID_PATTERN).max(EXPERIENCE_CAPABILITY_ID_MAX)
  }),
  z.object({
    kind: z.literal("navigate"),
    label: LabelSchema2,
    routeId: z.string().regex(EXPERIENCE_ROUTE_ID_PATTERN).max(EXPERIENCE_ROUTE_ID_MAX)
  }),
  z.object({ kind: z.literal("link"), label: LabelSchema2, url: OperatorUrlSchema }),
  z.object({ kind: z.literal("dismiss"), label: LabelSchema2 }),
  z.object({
    kind: z.literal("snooze"),
    label: LabelSchema2,
    hours: z.number().int().min(1).max(EXPERIENCE_SNOOZE_MAX_HOURS)
  })
]);
var EXPERIENCE_MAX_ACTIONS = 3;
var ExperienceActionsSchema = /* @__PURE__ */ z.array(ExperienceActionSchema).max(EXPERIENCE_MAX_ACTIONS).default([]);
var EXPERIENCE_PROVENANCES = ["operator", "agent-drafted", "template"];
var OPERATOR_ONLY_ACTION_KINDS = ["link"];
function operatorOnlyActionKinds() {
  return OPERATOR_ONLY_ACTION_KINDS;
}
function actionsAllowedForProvenance(provenance) {
  if (provenance === "operator") return EXPERIENCE_ACTION_KINDS;
  return EXPERIENCE_ACTION_KINDS.filter((kind) => !OPERATOR_ONLY_ACTION_KINDS.includes(kind));
}
function refusedActionsForProvenance(actions, provenance) {
  const allowed = actionsAllowedForProvenance(provenance);
  return actions.filter((action) => !allowed.includes(action.kind)).map((action) => ({ kind: action.kind, reason: "operator-only" }));
}

// src/experiences/checklist.ts
var CHECKLIST_VERIFICATION_KINDS = [
  /**
   * The visitor says so. Honest and weak — kept because some steps genuinely
   * happen outside the product ("invite your team on Slack"), and refusing to
   * model them would push operators back to a competitor's checklist for the
   * whole program.
   */
  "self-reported",
  /** A capability actually ran. Derived from the meter, per verified subject. */
  "capability-called",
  /** The visitor reached a route the operator named. */
  "route-reached",
  /** A saved guide ran to completion — the tour's own outcome, not a click on it. */
  "guide-completed"
];
function isVerifiedByEvidence(kind) {
  return kind !== "self-reported";
}
var ChecklistVerificationSchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("self-reported") }).strict(),
  /**
   * The capability id is the operator's OWN catalog id, resolved server-side.
   * It is never a name the visitor's browser could supply: a checklist that
   * accepted a client-asserted completion would be a click-to-tick checklist
   * wearing a verified one's clothes.
   */
  z.object({ kind: z.literal("capability-called"), capabilityId: z.string().min(1).max(120) }).strict(),
  z.object({ kind: z.literal("route-reached"), routeId: z.string().min(1).max(128) }).strict(),
  z.object({ kind: z.literal("guide-completed"), guideId: z.string().min(1).max(64) }).strict()
]);
var MAX_CHECKLIST_ITEMS = 8;
var ChecklistItemSchema = /* @__PURE__ */ z.object({
  /** Stable per-program key — the progress store's join, and the funnel's. */
  key: z.string().min(1).max(64),
  /** Already resolved for this visitor's locale by the server. */
  label: z.string().min(1).max(120),
  /** Optional one-line "why this matters". */
  detail: z.string().max(280).optional(),
  verification: ChecklistVerificationSchema,
  /**
   * What pressing the item does — tell (open the chat), show (start a guide),
   * or do (run a capability). At most one, because an item that offers three
   * ways to start is an item nobody starts.
   */
  action: ExperienceActionSchema.optional()
}).strict();
var ChecklistItemStateSchema = /* @__PURE__ */ z.object({
  key: z.string().min(1).max(64),
  done: z.boolean(),
  /**
   * How it was completed. Absent while `done` is false, and REQUIRED when it
   * is true — an item that is done for a reason nobody recorded is exactly
   * the claim this surface refuses to make.
   */
  completedBy: z.enum(CHECKLIST_VERIFICATION_KINDS).optional()
}).strict().refine((s) => !s.done || s.completedBy !== void 0, {
  message: "a completed item must say how it was completed",
  path: ["completedBy"]
});
var ServedChecklistSchema = /* @__PURE__ */ z.object({
  items: z.array(ChecklistItemSchema).min(1).max(MAX_CHECKLIST_ITEMS),
  state: z.array(ChecklistItemStateSchema).max(MAX_CHECKLIST_ITEMS).default([]),
  /**
   * Whether the visitor's completions are durable.
   *
   * For a verified subject the server holds the record and a tick survives a
   * new device. For an anonymous one there is no durable subject to hold it
   * against (ADR-0432 — the identity is deliberately pseudonymous and
   * session-scoped), so progress is per-session and the UI SAYS SO rather
   * than letting somebody rebuild the same checklist tomorrow believing it
   * was saved.
   */
  scope: z.enum(["durable", "session"]).default("session")
}).strict();
function checklistProgress(checklist) {
  const keys = new Set(checklist.items.map((item) => item.key));
  const byKey = new Map(checklist.items.map((item) => [item.key, item]));
  let done = 0;
  let verified = 0;
  for (const state of checklist.state) {
    if (!state.done || !keys.has(state.key)) continue;
    done += 1;
    const kind = state.completedBy ?? byKey.get(state.key)?.verification.kind;
    if (kind !== void 0 && isVerifiedByEvidence(kind)) verified += 1;
  }
  return { total: checklist.items.length, done, verified, complete: done === checklist.items.length };
}
function nextChecklistItem(checklist) {
  const doneKeys = new Set(checklist.state.filter((s) => s.done).map((s) => s.key));
  return checklist.items.find((item) => !doneKeys.has(item.key)) ?? null;
}

// src/experiences/experience-placement.ts
var EXPERIENCE_PLACEMENTS = [
  /** A bar across the top or bottom of the host page. */
  "banner",
  /** A centred dialog over the host page — the heaviest interruption available. */
  "modal",
  /** A card anchored to one control, opened on arrival. */
  "popover",
  /** A quiet pulsing marker on one control, opening its card on hover/focus/tap. */
  "hotspot",
  /**
   * A one-step spotlight: dim the page, ring one control, one caption, one CTA.
   * The tour's pointing power without the tour — for feature reveals and
   * "look here" moments, where a multi-step walkthrough is more commitment than
   * the message deserves. Its renderers are the annotation layer's, reused.
   */
  "showcase",
  /** A card mounted INTO the page's own flow, in a slot the customer designated. */
  "inline-card",
  /** A card inside the chat panel's home surface. */
  "panel-card",
  /** A launcher-corner card — the "what's new" surface, re-homed onto this model. */
  "announcement",
  /** A question set: NPS, CSAT, or a short custom set. */
  "survey",
  /** A persistent control that starts a saved guide. */
  "guide-launcher"
];
var PLACEMENT_CLASSES = ["interruptive", "ambient"];
var PLACEMENT_CLASS = {
  banner: "interruptive",
  modal: "interruptive",
  popover: "interruptive",
  showcase: "interruptive",
  survey: "interruptive",
  announcement: "interruptive",
  // A hotspot is a dot on a control until someone chooses to look at it — the
  // whole point of the affordance is that it waits.
  hotspot: "ambient",
  "inline-card": "ambient",
  "panel-card": "ambient",
  "guide-launcher": "ambient"
};
function placementClass(placement) {
  return PLACEMENT_CLASS[placement];
}
function isInterruptive(placement) {
  return placementClass(placement) === "interruptive";
}
var MOBILE_REFUSED = ["modal", "showcase"];
function isPlacementAllowedOnMobile(placement) {
  return !MOBILE_REFUSED.includes(placement);
}
var HOST_PAGE_PLACEMENTS = [
  "banner",
  "modal",
  "popover",
  "hotspot",
  "showcase",
  "inline-card"
];
function rendersOnHostPage(placement) {
  return HOST_PAGE_PLACEMENTS.includes(placement);
}
var ELEMENT_ANCHORED = ["popover", "hotspot", "showcase"];
function requiresElementAnchor(placement) {
  return ELEMENT_ANCHORED.includes(placement);
}
var EXPERIENCE_ANCHOR_KINDS = ["page", "control", "slot", "launcher", "panel"];
var EXPERIENCE_SLOT_PATTERN = /^[a-z0-9][a-z0-9-]{0,47}$/;
var EXPERIENCE_CONTROL_MAX = 40;
var ExperienceAnchorSchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  /**
   * The whole page, matched by the F31 URL vocabulary. Reused rather than
   * re-invented so a unit and a page rule can never disagree about what
   * `/checkout` covers — the segment-aware `startsWith` distinction
   * (`/checkout/cart` yes, `/checkout-express` no) is exactly the kind of
   * subtlety two implementations would get differently.
   */
  z.object({
    kind: z.literal("page"),
    urlPattern: WidgetPageRuleUrlPatternSchema,
    match: z.enum(WIDGET_PAGE_RULE_MATCH_OPERATORS).default("startsWith"),
    matchCaseSensitive: z.boolean().optional(),
    matchIncludeQuery: z.boolean().optional()
  }),
  /**
   * One control, by durable identity. The `page` fields ride along because a
   * control identity is unique per tenant but a control can appear on several
   * pages — pinning the page is how "the Export button on /orders" stays
   * distinct from the identical one on /reports.
   */
  z.object({
    kind: z.literal("control"),
    control: z.string().regex(ANNOTATION_CONTROL_PATTERN).max(EXPERIENCE_CONTROL_MAX),
    urlPattern: WidgetPageRuleUrlPatternSchema.optional(),
    match: z.enum(WIDGET_PAGE_RULE_MATCH_OPERATORS).default("startsWith")
  }),
  /** A customer-designated `data-syncanix-slot` div — the inline placement's home. */
  z.object({
    kind: z.literal("slot"),
    slot: z.string().regex(EXPERIENCE_SLOT_PATTERN),
    urlPattern: WidgetPageRuleUrlPatternSchema.optional(),
    match: z.enum(WIDGET_PAGE_RULE_MATCH_OPERATORS).default("startsWith")
  }),
  /** The launcher corner — where announcements and nudges already live. */
  z.object({ kind: z.literal("launcher") }),
  /** Inside the chat panel's home surface. */
  z.object({ kind: z.literal("panel") })
]);
function anchorResolvesElement(anchor) {
  return anchor.kind === "control";
}
function anchorPageScope(anchor) {
  if (anchor.kind === "launcher" || anchor.kind === "panel") return null;
  if (anchor.urlPattern === void 0) return null;
  return { urlPattern: anchor.urlPattern, match: anchor.match };
}
var EXPERIENCE_SESSION_MAX = 365;
var ExperienceSessionRangeSchema = /* @__PURE__ */ z.object({
  from: z.number().int().min(1).max(EXPERIENCE_SESSION_MAX).default(1),
  to: z.number().int().min(1).max(EXPERIENCE_SESSION_MAX).nullable().default(null)
}).superRefine((range, ctx) => {
  if (range.to !== null && range.to < range.from) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["to"],
      message: "the last session cannot come before the first"
    });
  }
});
var ExperienceTargetingSchema = /* @__PURE__ */ z.object({
  // F6(b) — the four WHO fields are declared once (`audience-shape.ts`) and
  // composed here. A unit is CONTENT on a page the visitor is already looking
  // at, and the commonest one runs on a signed-out page, so anonymous visitors
  // are eligible unless the operator says otherwise; the sibling surface argues
  // its own default at its own call site.
  ...audienceShapeFields({ anonymousFallbackDefault: true }),
  schedule: EngagementScheduleSchema.default({ kind: "always" }),
  quietHours: QuietHoursSchema.optional(),
  /**
   * C5 — show this unit only while a named control is ON THE PAGE.
   *
   * A durable `uic_` identity, the same handle the `control` anchor takes, and
   * for the same reason: it survives a rename, a restyle and a translation.
   *
   * ## Why this is separate from the ANCHOR, which already requires one
   *
   * A control-anchored unit is already invisible when its control is absent —
   * it has nowhere to attach. This is for every OTHER placement: a banner that
   * should only run while the Upgrade button is on the page, a panel card that
   * belongs next to a feature the visitor can actually reach. Without it, the
   * only way to express "when this thing exists" was to make the content point
   * AT the thing, which is a different design decision.
   *
   * ## And why a miss here is not an anchor FAULT
   *
   * The anchor-health sweep pauses a unit after three consecutive `not-found`
   * reports, because an anchor that stopped resolving means a redesign moved
   * the control out from under live content. Here `not-found` is the ordinary
   * NEGATIVE case — the condition simply is not met on this page — so it is
   * evaluated in the widget and never reported as a miss. Feeding it to the
   * sweep would pause every unit whose condition is usually false, which is
   * most of them.
   */
  requiresControl: z.string().regex(ANNOTATION_CONTROL_PATTERN).max(EXPERIENCE_CONTROL_MAX).nullable().default(null),
  /** C5 — the visitor's session window. See {@link ExperienceSessionRangeSchema}. */
  sessions: ExperienceSessionRangeSchema.default({ from: 1, to: null })
});

// src/experiences/experience-unit-status.ts
var EXPERIENCE_UNIT_STATUSES = [
  "draft",
  "active",
  "paused",
  /**
   * The health sweep pulled this unit because its anchor stopped resolving.
   * Distinct from `paused` because the two mean opposite things to an operator:
   * one is a decision they made, the other is a fact about their site they have
   * not yet seen. Collapsing them would turn "your content broke" into "you
   * turned it off", which is how a competitor's guides fail silently.
   */
  "paused_anchor_lost",
  /**
   * ADR-0562 § 2 (F2) — the nightly freshness sweep pulled this unit because
   * the thing it POINTS AT stopped resolving: a guide whose steps no longer
   * name controls the platform can find, or a CTA naming a capability the
   * workspace has since disabled or removed.
   *
   * A separate value from `paused_anchor_lost` for the reason that one is
   * separate from `paused`. A unit whose `start-guide` names a broken guide has
   * a perfectly good ANCHOR; telling an operator its anchor was lost sends them
   * to the anchor picker to fix something that is not broken, and leaves the
   * real cause invisible. Same kind of fact, different shape, so a different
   * word — otherwise the distinction migration 421 drew is preserved in one
   * direction and lost in the other.
   */
  "paused_reference_lost",
  "archived"
];
var SWEEP_ONLY_STATUSES = [
  "paused_anchor_lost",
  "paused_reference_lost"
];
function statusCanServe(status) {
  return status === "active";
}
var SURVEY_QUESTION_TYPES = ["nps", "rating", "select", "text"];
function carriesFreeText(type) {
  return type === "text";
}
var SURVEY_TEXT_MAX = 500;
var MAX_SURVEY_QUESTIONS = 3;
var MAX_SELECT_OPTIONS = 6;
var NPS_MIN = 0;
var NPS_MAX = 10;
var RATING_MIN = 1;
var RATING_MAX = 5;
var PromptSchema = /* @__PURE__ */ z.string().min(1).max(160);
var SurveyQuestionSchema = /* @__PURE__ */ z.discriminatedUnion("type", [
  z.object({ type: z.literal("nps"), key: z.string().min(1).max(48), prompt: PromptSchema }).strict(),
  z.object({ type: z.literal("rating"), key: z.string().min(1).max(48), prompt: PromptSchema }).strict(),
  z.object({
    type: z.literal("select"),
    key: z.string().min(1).max(48),
    prompt: PromptSchema,
    /**
     * The operator's own options, already resolved for this visitor's locale.
     * At most six: a list longer than that is one nobody reads, and it is also
     * how a "select" quietly becomes a free-text field with extra steps.
     */
    options: z.array(z.string().min(1).max(80)).min(2).max(MAX_SELECT_OPTIONS)
  }).strict(),
  z.object({
    type: z.literal("text"),
    key: z.string().min(1).max(48),
    prompt: PromptSchema,
    placeholder: z.string().max(80).optional()
  }).strict()
]);
var ServedSurveySchema = /* @__PURE__ */ z.object({
  questions: z.array(SurveyQuestionSchema).min(1).max(MAX_SURVEY_QUESTIONS),
  /** Localized "thanks" shown after submission. */
  thanks: z.string().min(1).max(160)
}).strict().superRefine((survey, ctx) => {
  const seen = /* @__PURE__ */ new Set();
  for (const question of survey.questions) {
    if (seen.has(question.key)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "two questions share a key, so one answer would overwrite the other",
        path: ["questions"]
      });
    }
    seen.add(question.key);
  }
});
var SurveyAnswerSchema = /* @__PURE__ */ z.object({
  key: z.string().min(1).max(48),
  /**
   * A number for `nps`/`rating`, the chosen option for `select`, the typed
   * string for `text`. Validated against the QUESTION by `validateAnswer`,
   * because the schema alone cannot know which question a key names — and
   * accepting a 47 for an NPS score would put an uncomparable number in the
   * same column as every real one.
   */
  value: z.union([z.number(), z.string().max(SURVEY_TEXT_MAX)])
}).strict();
function validateAnswer(survey, answer) {
  const question = survey.questions.find((q) => q.key === answer.key);
  if (question === void 0) return { ok: false, reason: "unknown-question" };
  switch (question.type) {
    case "nps":
    case "rating": {
      if (typeof answer.value !== "number" || !Number.isInteger(answer.value)) {
        return { ok: false, reason: "wrong-type" };
      }
      const [min, max] = question.type === "nps" ? [NPS_MIN, NPS_MAX] : [RATING_MIN, RATING_MAX];
      return answer.value >= min && answer.value <= max ? { ok: true } : { ok: false, reason: "out-of-range" };
    }
    case "select": {
      if (typeof answer.value !== "string") return { ok: false, reason: "wrong-type" };
      return question.options.includes(answer.value) ? { ok: true } : { ok: false, reason: "not-an-option" };
    }
    case "text": {
      if (typeof answer.value !== "string") return { ok: false, reason: "wrong-type" };
      return answer.value.length <= SURVEY_TEXT_MAX ? { ok: true } : { ok: false, reason: "too-long" };
    }
  }
}
function missingAnswers(survey, answers) {
  const answered = new Set(answers.map((a) => a.key));
  return survey.questions.filter((q) => !answered.has(q.key)).map((q) => q.key);
}
function freeTextKeys(survey) {
  return survey.questions.filter((q) => carriesFreeText(q.type)).map((q) => q.key);
}

// src/experiences/survey-authoring.ts
var AuthoredPromptSchema = customerTextSchema(160);
var AuthoredSurveyQuestionSchema = /* @__PURE__ */ z.discriminatedUnion("type", [
  z.object({
    type: z.literal("nps"),
    key: z.string().min(1).max(48),
    prompt: AuthoredPromptSchema
  }).strict(),
  z.object({
    type: z.literal("rating"),
    key: z.string().min(1).max(48),
    prompt: AuthoredPromptSchema
  }).strict(),
  z.object({
    type: z.literal("select"),
    key: z.string().min(1).max(48),
    prompt: AuthoredPromptSchema,
    options: z.array(customerTextSchema(80)).min(2).max(MAX_SELECT_OPTIONS)
  }).strict(),
  z.object({
    type: z.literal("text"),
    key: z.string().min(1).max(48),
    prompt: AuthoredPromptSchema,
    placeholder: customerTextSchema(80).optional()
  }).strict()
]);
var AuthoredSurveySchema = /* @__PURE__ */ z.object({
  questions: z.array(AuthoredSurveyQuestionSchema).min(1).max(MAX_SURVEY_QUESTIONS),
  thanks: customerTextSchema(160)
}).strict().superRefine((survey, ctx) => {
  const seen = /* @__PURE__ */ new Set();
  for (const question of survey.questions) {
    if (seen.has(question.key)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "two questions share a key, so one answer would overwrite the other",
        path: ["questions"]
      });
    }
    seen.add(question.key);
  }
});
function resolveSurvey(survey, locale) {
  return {
    thanks: resolveCustomerText(survey.thanks, locale),
    questions: survey.questions.map((question) => {
      const prompt = resolveCustomerText(question.prompt, locale);
      switch (question.type) {
        case "nps":
        case "rating":
          return { type: question.type, key: question.key, prompt };
        case "select":
          return {
            type: "select",
            key: question.key,
            prompt,
            options: question.options.map((option) => resolveCustomerText(option, locale))
          };
        case "text": {
          const placeholder = question.placeholder === void 0 ? void 0 : resolveCustomerText(question.placeholder, locale);
          return placeholder === void 0 || placeholder === "" ? { type: "text", key: question.key, prompt } : { type: "text", key: question.key, prompt, placeholder };
        }
      }
    })
  };
}

// src/experiences/experience-unit.schema.ts
var EXPERIENCE_BODY_MAX = 480;
var EXPERIENCE_MAX_BULLETS = 5;
var EXPERIENCE_BULLET_MAX = 120;
var ExperienceContentSchema = /* @__PURE__ */ z.object({
  heading: customerTextSchema(EXPERIENCE_HEADING_MAX).optional(),
  body: customerTextSchema(EXPERIENCE_BODY_MAX).optional(),
  bullets: z.array(customerTextSchema(EXPERIENCE_BULLET_MAX)).max(EXPERIENCE_MAX_BULLETS).default([]),
  actions: ExperienceActionsSchema
});
var ExperienceGoalSchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("opened-chat") }),
  z.object({ kind: z.literal("guide-completed"), guideId: z.string().min(1).max(64) }),
  // F-8 — the same closed grammar the CTA's own `capabilityId` takes. A goal is
  // not interpolated into a prompt, so the channel argument does not apply
  // here; what does is that a unit must never name a capability shape the
  // catalog cannot hold, or the goal can never match anything.
  z.object({
    kind: z.literal("capability-called"),
    capabilityId: z.string().regex(CAPABILITY_ID_PATTERN).max(200)
  }),
  z.object({ kind: z.literal("route-reached"), routeId: z.string().min(1).max(128) }),
  z.object({ kind: z.literal("dismissed-never") })
]);
function goalIsVerifiable(goal) {
  return goal.kind === "capability-called" || goal.kind === "guide-completed";
}
var EXPERIENCE_UNIT_KEY_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;
var EXPERIENCE_UNIT_NAME_MAX = 80;
var EXPERIENCE_PRIORITY_MAX = 1e3;
var EXPERIENCE_MAX_PER_SESSION = 10;
var ExperienceLimitsSchema = /* @__PURE__ */ z.object({
  maxPerSession: z.number().int().min(1).max(EXPERIENCE_MAX_PER_SESSION).default(1),
  cooldownAfterDismissHours: z.number().int().min(0).max(8760).default(168)
});
var ExperienceUnitKeySchema = /* @__PURE__ */ z.string().regex(EXPERIENCE_UNIT_KEY_PATTERN);
var ExperienceUnitSchema = /* @__PURE__ */ z.object({
  /** Author-facing stable key, unique per tenant + environment. */
  key: ExperienceUnitKeySchema,
  /** The operator's own name for it — never shown to a visitor. */
  name: z.string().min(1).max(EXPERIENCE_UNIT_NAME_MAX),
  placement: z.enum(EXPERIENCE_PLACEMENTS),
  status: z.enum(EXPERIENCE_UNIT_STATUSES).default("draft"),
  /**
   * SERVER-SET, never accepted from a client (the ADR-0400 pattern). A client
   * that could claim `operator` could grant itself the `link` action, which is
   * the one field that points off the platform.
   */
  provenance: z.enum(EXPERIENCE_PROVENANCES).default("operator"),
  anchor: ExperienceAnchorSchema,
  content: ExperienceContentSchema,
  goal: ExperienceGoalSchema.default({ kind: "opened-chat" }),
  targeting: ExperienceTargetingSchema.default({}),
  rolloutPct: z.number().int().min(0).max(100).default(0),
  rolloutSalt: z.string().min(1).max(64),
  variants: ExperienceVariantsSchema,
  holdoutPct: z.number().int().min(0).max(ENGAGEMENT_HOLDOUT_MAX_PCT).default(0),
  priority: z.number().int().min(0).max(EXPERIENCE_PRIORITY_MAX).default(0),
  limits: ExperienceLimitsSchema.default({}),
  /**
   * The questions, when this unit's placement is `survey`.
   *
   * On the UNIT rather than in a survey subsystem, because the doctrine at the
   * top of this file is that a placement is a field: who sees it, how often, at
   * what reach and against which goal are all the unit's, unchanged. A separate
   * survey product with its own targeting and its own frequency rules is exactly
   * the sprawl the incumbents are most criticised for.
   *
   * Optional, and deliberately NOT required-when-`placement === 'survey'` at the
   * schema. A survey unit with no questions yet is an ordinary draft — the state
   * an operator is in for as long as it takes them to write the first one — and
   * refusing it here would make the editor unable to save work in progress. What
   * enforces it is the SERVING path, which drops a survey unit carrying no
   * questions rather than mounting an empty card: an unanswerable survey is
   * worse than no survey.
   */
  survey: AuthoredSurveySchema.optional()
}).superRefine((unit, ctx) => {
  if (unit.content.actions.length > 0) return;
  unit.variants.forEach((arm, index) => {
    if (arm.actionLabel === void 0) return;
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["variants", index, "actionLabel"],
      message: "this unit has no action for a variant to label"
    });
  });
});
var MAX_EXPERIENCE_UNITS = 500;

// src/experiences/unit-governor.ts
var MAX_AMBIENT_UNITS_PER_VIEW = 3;
function toCollisionRules(candidates) {
  return candidates.map((c) => ({
    ruleId: c.unitKey,
    priority: c.priority,
    lastShownAt: c.lastShownAt,
    createdAt: c.createdAt
  }));
}
function governUnits(candidates, ctx) {
  const isMobile = ctx.isMobile === true;
  const refusedForViewport = [];
  const allowed = [];
  for (const candidate of candidates) {
    if (isMobile && !isPlacementAllowedOnMobile(candidate.placement)) {
      refusedForViewport.push(candidate.unitKey);
      continue;
    }
    allowed.push(candidate);
  }
  const interruptiveCandidates = allowed.filter((c) => isInterruptive(c.placement));
  const interruptiveRules = toCollisionRules(interruptiveCandidates);
  const decision = governCollision(interruptiveRules, ctx);
  const fatigued = decision.suppressedBy === "page-view" || decision.suppressedBy === "spacing";
  const withheld = fatigued ? governCollision(interruptiveRules, {
    now: ctx.now,
    lastSurfaceAt: null,
    alreadyShownThisPageView: false
  }).ruleId : null;
  const maxAmbient = ctx.maxAmbient ?? MAX_AMBIENT_UNITS_PER_VIEW;
  const ambient = [];
  const ambientPool = allowed.filter((c) => !isInterruptive(c.placement));
  const remaining = new Set(ambientPool.map((c) => c.unitKey));
  while (ambient.length < maxAmbient && remaining.size > 0) {
    const pool = ambientPool.filter((c) => remaining.has(c.unitKey));
    const next = governCollision(
      toCollisionRules(pool),
      // Ambient units answer to neither the page-view slot nor the spacing floor
      // — both are interruption budgets, and an ambient unit does not interrupt.
      // Passing the caller's context here would let one banner silence every
      // hotspot on the page.
      { now: ctx.now, lastSurfaceAt: null, alreadyShownThisPageView: false }
    );
    if (next.ruleId === null) break;
    ambient.push(next.ruleId);
    remaining.delete(next.ruleId);
  }
  return {
    interruptive: decision.ruleId,
    interruptiveSuppressedBy: decision.suppressedBy,
    withheld,
    ambient,
    refusedForViewport
  };
}

// src/experiences/served-field-isolation.ts
var FORBIDDEN_SERVED_FIELDS = [
  "rolloutSalt",
  "rolloutPct",
  "holdoutPct",
  "segmentId",
  "targeting",
  "variants",
  // L-5 — this field stays off the wire; the MARKING it was blocking is served
  // separately as `aiGenerated` below.
  //
  // **A first attempt at this decision was wrong, and the correction is the
  // useful part.** It concluded there is no AI-drafted unit in front of a
  // visitor at all, because "an operator SAVING an agent-drafted unit promotes
  // it to `operator`". Saving does promote (`experience-unit.service.ts`).
  // ARMING does not: `setStatus` moves a unit to `active` and never touches
  // provenance, which is correct — it is a lifecycle act, not an authorship one
  // — and it means the shortest real path is draft → arm, with no edit in
  // between. Such a unit serves, and it is `agent-drafted`.
  //
  // So the true mechanism is STATUS, not provenance: `statusCanServe` admits
  // only `active`, and only an operator can set it. That bounds WHO decided,
  // and says nothing about who WROTE — which is exactly the distinction an Art
  // 50 marking is about.
  //
  // The field itself stays here because it also carries `template`, a
  // client-side seed the server discards, and because a trust class is not a
  // marking. `aiGenerated` is the narrow derivation, below.
  "provenance",
  "status",
  "urlPattern",
  "updatedBy",
  // F-19 — the three the eligibility service's own contract test named and this
  // list did not. They are targeting axes with no rendering half at all, so
  // every one of them is a pure leak: `anonymousFallback` says whether the unit
  // reaches signed-out visitors, `visitorType` says which cohort it is scoped
  // to, and `schedule` says the window an operator picked. Reconciled toward the
  // UNION rather than toward either list, because a field named by one reviewer
  // and not the other is a field somebody has already argued should not be
  // served.
  "anonymousFallback",
  "visitorType",
  "schedule",
  // The remaining two targeting axes, added for the same reason and stated
  // separately because their absence was less obvious than the three above:
  // `locales` says which languages the unit is scoped to, and `sessions` the
  // visit-count window. Neither has a rendering half, and neither key appears
  // anywhere in the served schemas — checked, because a forbidden name the
  // payload legitimately uses would make this walker fail on correct output.
  "locales",
  "sessions",
  // Never served, and named here rather than merely omitted: `ServedGoalSchema`
  // deliberately excludes `capability-called`, and this is what fails a future
  // widening that decided to include it. A page learning which capability the
  // operator counts as success is a hint about the tenant's API surface it has
  // no use for, and the meter settles that goal server-side anyway.
  "capabilityId"
];
function findForbiddenServedFields(serialized) {
  const parsed = JSON.parse(serialized);
  const found = /* @__PURE__ */ new Set();
  const walk = (value) => {
    if (Array.isArray(value)) {
      value.forEach(walk);
      return;
    }
    if (typeof value !== "object" || value === null) return;
    for (const [key, child] of Object.entries(value)) {
      if (FORBIDDEN_SERVED_FIELDS.includes(key)) found.add(key);
      walk(child);
    }
  };
  walk(parsed);
  return [...found];
}

// src/experiences/experience-serving.ts
var ServedContentSchema = /* @__PURE__ */ z.object({
  heading: z.string().optional(),
  body: z.string().optional(),
  bullets: z.array(z.string()).default([]),
  actions: z.array(ExperienceActionSchema).default([])
}).strict();
var ServedAnchorSchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  // Every member is `.strict()`, not just the envelope. A non-strict member is
  // exactly how the URL half leaks back: the mapper spreads the stored anchor,
  // `urlPattern` rides along inside `anchor`, and the outer `.strict()` never
  // sees it because `anchor` itself was an expected key.
  z.object({ kind: z.literal("page") }).strict(),
  z.object({
    kind: z.literal("control"),
    /** The signature the operator anchored to. Unchanged across this field's life. */
    control: z.string().min(1).max(40),
    /**
     * The identity's CURRENT signature, when the platform has re-bound it to
     * a different one — see the block above. Absent means "no translation
     * available", which covers an unchanged control, an identity with no
     * bindings, a retired one, and a server that predates this field.
     */
    controlCurrent: z.string().min(1).max(40).optional()
  }).strict(),
  z.object({ kind: z.literal("slot"), slot: z.string().min(1).max(48) }).strict(),
  z.object({ kind: z.literal("launcher") }).strict(),
  z.object({ kind: z.literal("panel") }).strict()
]);
var ServedGoalSchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("opened-chat") }).strict(),
  z.object({ kind: z.literal("guide-completed"), guideId: z.string().min(1).max(64) }).strict(),
  z.object({ kind: z.literal("route-reached"), routeId: z.string().min(1).max(128) }).strict()
]);
function toServedGoal(goal) {
  switch (goal.kind) {
    case "opened-chat":
      return { kind: "opened-chat" };
    case "guide-completed":
      return { kind: "guide-completed", guideId: goal.guideId };
    case "route-reached":
      return { kind: "route-reached", routeId: goal.routeId };
    // `capability-called` is settled by the METER, from the platform's own
    // record that the action ran — which is the whole reason that goal kind
    // exists. Serving the capability id would tell a page which of the tenant's
    // capabilities the operator counts as success, and would invite a forged
    // report claiming it happened. `dismissed-never` settles by ABSENCE: there
    // is no moment to observe, so there is nothing a browser could ever report.
    //
    // Both comments sit ABOVE the pair rather than one between the labels —
    // eslint's `no-fallthrough` reads an interleaved comment as a break in the
    // group and reports the first label as falling through.
    case "capability-called":
    case "dismissed-never":
      return void 0;
  }
}
var ServedExperienceUnitSchema = /* @__PURE__ */ z.object({
  /** The unit's key — the funnel's join, and the dismissal store's. */
  key: z.string().min(1).max(64),
  placement: z.enum(EXPERIENCE_PLACEMENTS),
  anchor: ServedAnchorSchema,
  content: ServedContentSchema,
  /** Collision-governor inputs. Priority is a RANK, and reveals nothing about who. */
  priority: z.number().int().min(0).max(1e3),
  createdAt: z.number().int().nonnegative(),
  /**
   * L-5 / ADR-0173 — whether the copy in this unit was DRAFTED by the agent.
   *
   * A narrow boolean derived from `provenance`, which stays off the wire: a
   * trust class carries rollout and template facts a page has no business
   * reading, and a marking is one bit.
   *
   * **It exists because the alternative was foreclosing a decision that is
   * not ours.** The shortest real path to a served drafted unit is draft →
   * arm, with no edit in between (`setStatus` is a lifecycle act and does not
   * touch provenance, correctly), so AI-authored copy CAN reach a visitor
   * with a human approving rather than authoring it. Whether EU AI Act Art 50
   * transparency attaches to that is counsel's; what an engineer can do is
   * make sure the answer is not "we cannot, the widget has no way to know".
   *
   * **Absent, not `false`, when the unit is operator-authored.** Sending
   * `false` on every unit would put a field on every wire payload to say
   * nothing, and — the reason that matters — would make an OLDER widget's
   * silence indistinguishable from a new one's negative. Absent means "not
   * marked"; present-and-true is the only claim.
   *
   * Nothing renders it yet, and that is deliberate rather than unfinished:
   * what a marking SAYS is copy in six locales and a placement decision on
   * somebody else's page, and neither should be invented ahead of the ruling.
   * The channel is what had to exist before the first drafter, because
   * retrofitting a wire field onto units already in the wild is the expensive
   * half.
   */
  aiGenerated: z.literal(true).optional(),
  /** Per-visitor caps the browser enforces between server reads. */
  maxPerSession: z.number().int().min(1).max(10),
  cooldownAfterDismissHours: z.number().int().min(0).max(8760),
  /**
   * Which arm this visitor was assigned, for funnel attribution only. The
   * assignment already happened server-side; this is its LABEL, not the salt
   * that produced it — a salt would let a page compute every other visitor's
   * arm.
   *
   * **What an arm may vary (ADR-0562 § 4, F4).** Body, heading and the PRIMARY
   * action's label. That was one string until F4 — the body alone — which
   * made the two experiments an operator most often wants, a different
   * headline and a different CTA label, inexpressible.
   *
   * Bullets and the non-primary actions stay shared across arms, and that is a
   * scope decision rather than an oversight: nobody has asked to vary a bullet
   * list, and an arm that silently relabelled a secondary "Not now" would be
   * changing what it did not claim to change.
   */
  variant: z.string().min(1).max(64).optional(),
  /**
   * What settles this unit, when the browser is the thing that can see it.
   *
   * Absent means "not yours to settle" rather than "no goal": the unit may
   * have a `capability-called` goal the meter settles, or a `dismissed-never`
   * one that settles by absence. Either way the runtime reports nothing and
   * the server counts it from its own records — which is why the absence is
   * silent rather than an error.
   *
   * Without this the `goal` column of every funnel was permanently zero and
   * the hub's headline conversion permanently null, because the widget could
   * report a goal (the event exists) and had no way to know when one happened.
   */
  goal: ServedGoalSchema.optional(),
  /**
   * C5 — a durable `uic_` identity that must be ON THE PAGE for this unit to
   * mount, over and above everything the server already decided.
   *
   * Client-evaluated, because only the browser can see the page — the same
   * division the anchor already uses. Absent means no such condition.
   *
   * It discloses one control identity the operator deliberately targeted,
   * which is strictly less than a `control` ANCHOR already puts on the wire
   * for the same visitor, so it opens no new disclosure. The SESSION half of
   * C5 is deliberately NOT here: it is decided server-side from a count the
   * browser sends, so the window an operator configured never reaches the
   * page and cannot be read off a network tab.
   */
  requiresControl: z.string().min(1).max(64).optional()
}).strict();
var ServedExperienceUnitsSchema = /* @__PURE__ */ z.object({
  units: z.array(ServedExperienceUnitSchema).max(50).default([])
});
var EXPERIENCE_UNIT_EVENTS = [
  "shown",
  "engaged",
  "completed",
  "goal",
  "dismissed",
  "rage-dismissed",
  /**
   * ADR-0562 § 2 (F5) — the platform declined to interrupt with this unit,
   * because it had already interrupted on this page view or the spacing floor
   * had not elapsed.
   *
   * The one event here that is a NON-event, and the only one worth the wire
   * for that reason: every other kind records something a visitor experienced,
   * and this records something they were spared. It is what turns restraint
   * from a promise into a number.
   *
   * Reported per UNIT rather than per slot, because "we withheld something"
   * is not actionable and "we withheld YOUR modal 400 times this week" is —
   * an operator reading that has learned their content is competing with
   * itself, which no other metric on this surface tells them.
   *
   * `no-candidates` is deliberately NOT reported: nothing was suppressed
   * because there was nothing to show, and counting it would make an empty
   * workspace look maximally restrained.
   */
  "suppressed"
];
var ANCHOR_MISS_REASONS = ["not-found", "not-visible", "ambiguous"];
function isDurableAnchorMiss(reason) {
  return reason === "not-found";
}
var LOCALE_CODES2 = SUPPORTED_LOCALES.map((locale) => locale.code);
var UnitKeySchema = /* @__PURE__ */ z.string().min(1).max(64);
var VariantSchema = /* @__PURE__ */ z.string().min(1).max(64);
var MAX_INGEST_EVENTS = 50;
var MAX_INGEST_MISSES = 50;
var ExperienceEventReportSchema = /* @__PURE__ */ z.object({
  events: z.array(
    z.object({
      unitKey: UnitKeySchema,
      event: z.enum(EXPERIENCE_UNIT_EVENTS),
      variant: VariantSchema.optional(),
      /**
       * How many times this happened. Defaults to 1.
       *
       * The wire carries a COUNT rather than one entry per occurrence so
       * the widget can collapse a burst before sending: a hotspot a
       * visitor triggered forty times is one entry, not forty — which
       * matters because the array is capped at
       * {@link MAX_INGEST_EVENTS}, and forty raw entries would push a
       * real page view's other units past the cap and lose them.
       *
       * Bounded, because this is a count a page supplies: a caller can
       * already inflate their own workspace's numbers (the ingest
       * controller says so plainly), and an unbounded integer would let
       * them do it in one request instead of many.
       *
       * `.optional()` rather than `.default(1)`, and the difference is not
       * cosmetic. A default makes the field REQUIRED in the parsed type,
       * so `foldEvents` reads it unguarded — and a caller that builds a
       * report by hand rather than through this schema then folds
       * `undefined` into every total as `NaN`, silently, and writes that
       * into the daily table. Two separate test suites did exactly that
       * before this changed. Optional puts the default in the one place
       * that consumes it, where the guard is visible and load-bearing.
       */
      count: z.number().int().min(1).max(1e3).optional()
    }).strict()
  ).max(MAX_INGEST_EVENTS).default([]),
  misses: z.array(z.object({ unitKey: UnitKeySchema, reason: z.enum(ANCHOR_MISS_REASONS) }).strict()).max(MAX_INGEST_MISSES).default([]),
  /**
   * The reporting SESSION, so an anchor miss can be corroborated by distinct
   * observers rather than by distinct requests (F-2).
   *
   * The same value the delivery endpoint already receives as `bucket`: the
   * anonymous session seed (ephemeral, `sessionStorage`, minted by
   * `engagement-bucket.ts`) or the verified sub. Deliberately NOT a new
   * identity — this channel adds none, and the one it borrows is the one the
   * same page view already sent one request earlier.
   *
   * OPTIONAL, and the direction that costs is the safe one: a report without
   * it can still COUNT (the funnel is unaffected) and can never CORROBORATE a
   * miss, so an older widget build stops being able to pause a unit rather
   * than being able to pause one with less evidence.
   *
   * Never stored. The server derives a keyed, domain-separated token from it
   * (`anchor-observer.ts`) and stores that, so the row holds nothing that
   * names a session.
   */
  session: z.string().min(1).max(64).optional()
}).strict();
var SurveyResponseSubmissionSchema = /* @__PURE__ */ z.object({
  unitKey: UnitKeySchema,
  /**
   * At most one answer per question, and the survey itself caps questions at
   * three — so this is bounded twice, here and by the unit's own question set
   * when the server screens each answer against it.
   */
  answers: z.array(SurveyAnswerSchema).min(1).max(8),
  variant: VariantSchema.optional(),
  /**
   * The locale the survey was SERVED in.
   *
   * Carried here rather than read from `Accept-Language`, because an answer
   * has to be screened against the options as the visitor actually READ them:
   * a `select` answer to a translated question is one of the operator's own
   * options in that language, and validating against a browser header that
   * disagrees with what we rendered would refuse every correct answer.
   *
   * A closed enum, so this is a vocabulary-bound field like everything else on
   * this channel — a page can say which of six languages it was shown, and
   * nothing else.
   */
  locale: z.enum(LOCALE_CODES2).optional()
}).strict();
function foldEvents(report) {
  const byKey = /* @__PURE__ */ new Map();
  for (const event of report.events) {
    const id = `${event.unitKey} ${event.variant ?? ""}`;
    let row2 = byKey.get(id);
    if (row2 === void 0) {
      row2 = {
        unitKey: event.unitKey,
        variant: event.variant,
        delta: {
          displayed: 0,
          engaged: 0,
          completed: 0,
          goal: 0,
          dismissed: 0,
          rageDismissed: 0,
          suppressed: 0
        }
      };
      byKey.set(id, row2);
    }
    const n = event.count ?? 1;
    switch (event.event) {
      case "shown":
        row2.delta.displayed += n;
        break;
      case "engaged":
        row2.delta.engaged += n;
        break;
      case "completed":
        row2.delta.completed += n;
        break;
      case "goal":
        row2.delta.goal += n;
        break;
      case "dismissed":
        row2.delta.dismissed += n;
        break;
      case "rage-dismissed":
        row2.delta.dismissed += n;
        row2.delta.rageDismissed += n;
        break;
      case "suppressed":
        row2.delta.suppressed += n;
        break;
    }
  }
  return [...byKey.values()];
}
var GUIDE_NAME_MAX = 80;
var SavedGuideSchema = /* @__PURE__ */ z.object({
  /**
   * The id a unit's `start-guide` action and `guide-completed` goal name.
   *
   * The SAME grammar `ExperienceActionSchema` already refuses a guide id
   * against, imported rather than restated: two patterns for one identifier is
   * how a guide becomes referenceable from one surface and not the other.
   */
  guideId: z.string().regex(EXPERIENCE_GUIDE_ID_PATTERN),
  name: z.string().min(1).max(GUIDE_NAME_MAX),
  walkthrough: WalkthroughSchema
}).strict();
var ServedGuidesSchema = /* @__PURE__ */ z.record(z.string(), WalkthroughSchema);
var MAX_EXPERIENCE_GUIDES = 200;
function guideIdsReferencedBy(unit) {
  const ids = /* @__PURE__ */ new Set();
  for (const action of unit.content.actions) {
    if (action.kind === "start-guide" && action.guideId !== void 0) ids.add(action.guideId);
  }
  if (unit.goal.kind === "guide-completed" && unit.goal.guideId !== void 0) {
    ids.add(unit.goal.guideId);
  }
  return [...ids];
}
var GUIDE_LAUNCH_SOURCES = [
  /** A unit's `start-guide` CTA — the visitor pressed something we drew. */
  "cta",
  /** `window.syncanix.startGuide(id)` — the customer's own UI asked. */
  "host",
  /** A `?syncanix-guide=<id>` link — an email, a help article, a release note. */
  "permalink"
];
var GuideRunReportSchema = /* @__PURE__ */ z.object({
  guideId: z.string().regex(EXPERIENCE_GUIDE_ID_PATTERN),
  source: z.enum(GUIDE_LAUNCH_SOURCES),
  outcome: z.enum(WALKTHROUGH_OUTCOMES),
  stepCount: z.number().int().min(1).max(WALKTHROUGH_MAX_STEPS),
  /**
   * The furthest step the visitor reached (0-based).
   *
   * With `stepCount` this is the drop-off point, and across runs the
   * distribution IS the drop-off curve — which is the whole reason one
   * terminal event answers what a per-step stream would.
   */
  lastStepIndex: z.number().int().min(0).max(WALKTHROUGH_MAX_STEPS - 1),
  durationMs: z.number().int().min(0).max(WALKTHROUGH_MAX_DURATION_MS)
}).strict().superRefine((v, ctx) => {
  if (v.lastStepIndex >= v.stepCount) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["lastStepIndex"],
      message: "lastStepIndex must be within stepCount"
    });
  }
  if (v.outcome === "completed" && v.lastStepIndex !== v.stepCount - 1) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["outcome"],
      message: "a completed guide must end on its last step"
    });
  }
});
var MAX_GUIDE_RUN_REPORTS = 20;
var GuideRunBatchSchema = /* @__PURE__ */ z.object({ runs: z.array(GuideRunReportSchema).min(1).max(MAX_GUIDE_RUN_REPORTS) }).strict();
function guideRunBucket(outcome) {
  switch (outcome) {
    case "completed":
      return "completed";
    // The visitor closed it on purpose. Distinct from abandonment: they made a
    // decision, and a guide people deliberately close is a different problem
    // from one that loses them.
    case "dismissed":
      return "dismissed";
    // Everything else is the guide failing to hold them — a step that would not
    // resolve, a navigation it could not follow, a page that went away, or a
    // plan the live page could never have answered. Counted rather than
    // dropped: a refusal that went unrecorded would RAISE completion rate by
    // removing the worst runs from the denominator.
    case "abandoned-stuck":
    case "abandoned-navigated":
    case "abandoned-closed":
    case "refused-unresolvable":
      return "abandoned";
  }
}
var GUIDE_RECORDING_MESSAGE_TYPE = "syncanix:guide-recording:v1";
var MAX_RECORDED_GUIDE_STEPS = WALKTHROUGH_MAX_STEPS;
var RecordedGuideStepSchema = /* @__PURE__ */ z.object({
  /**
   * Refused against the SAME closed grammar every route harvest uses
   * (ADR-0398), so five producers cannot disagree about what a route is. A
   * repaired path addresses a page its author never visited.
   */
  page: z.string().regex(HARVESTED_ROUTE_PATH_PATTERN),
  control: z.string().regex(ANNOTATION_CONTROL_PATTERN).max(ANNOTATION_CONTROL_MAX),
  label: z.string().min(1).max(ANNOTATION_TEXT_MAX)
}).strict();
var GuideRecordingMessageSchema = /* @__PURE__ */ z.object({
  type: z.literal(GUIDE_RECORDING_MESSAGE_TYPE),
  sessionId: z.string().uuid(),
  steps: z.array(RecordedGuideStepSchema).min(1).max(MAX_RECORDED_GUIDE_STEPS)
}).strict();
function parseGuideRecordingMessage(raw) {
  const parsed = GuideRecordingMessageSchema.safeParse(raw);
  return parsed.success ? parsed.data : null;
}
var GuideRecordingBindRequestSchema = /* @__PURE__ */ z.object({ bindToken: z.string().min(1).max(512) }).strict();

// src/experiences/anchor-candidates.ts
var ANCHOR_CANDIDATE_STATES = [
  "ready",
  "page-control-off",
  "discovery-off",
  "unavailable"
];

// src/experiences/experiences-kill-policy.ts
var EXPERIENCES_KILL_ENV_VAR = "EXPERIENCES_KILL";
var EXPERIENCES_KILL_ALL = "*";
function experiencesKillableKeys() {
  return [...EXPERIENCE_PLACEMENTS].sort();
}
function parseExperiencesKillPolicy(raw) {
  const tokens = (raw ?? "").split(",").map((token) => token.trim().toLowerCase()).filter((token) => token.length > 0);
  if (tokens.length === 0) return { killAll: false, killedPlacements: [] };
  if (tokens.includes(EXPERIENCES_KILL_ALL)) return { killAll: true, killedPlacements: [] };
  const killable = new Set(experiencesKillableKeys());
  const unknown = tokens.filter((token) => !killable.has(token));
  if (unknown.length > 0) {
    throw new Error(
      `${EXPERIENCES_KILL_ENV_VAR}: unknown placement ${unknown.length === 1 ? "key" : "keys"} ${unknown.join(", ")}. Valid keys: ${experiencesKillableKeys().join(", ")} (or "${EXPERIENCES_KILL_ALL}" to kill every placement).`
    );
  }
  return {
    killAll: false,
    killedPlacements: [...new Set(tokens)].sort()
  };
}
function isPlacementKilled(policy, placement) {
  return policy.killAll || policy.killedPlacements.includes(placement);
}
var DraftedUnitCopySchema = /* @__PURE__ */ z.object({
  /**
   * The operator-facing name, in the workspace's own list. Never rendered to
   * a visitor — it is how a person recognises the draft in a queue of them.
   */
  name: z.string().trim().min(1).max(EXPERIENCE_UNIT_NAME_MAX),
  heading: z.string().trim().min(1).max(EXPERIENCE_HEADING_MAX),
  body: z.string().trim().min(1).max(EXPERIENCE_BODY_MAX),
  /**
   * The CTA's label. What the button DOES is the drafter's to decide from the
   * signal — the model names the button, it does not wire it.
   */
  ctaLabel: z.string().trim().min(1).max(EXPERIENCE_ACTION_LABEL_MAX)
}).strict();
function parseDraftedUnitCopy(raw) {
  const unfenced = raw.trim().replace(/^```(?:json)?\s*/iu, "").replace(/\s*```$/u, "").trim();
  if (unfenced === "") return null;
  let parsed;
  try {
    parsed = JSON.parse(unfenced);
  } catch {
    return null;
  }
  const result = DraftedUnitCopySchema.safeParse(parsed);
  return result.success ? result.data : null;
}
var MAX_WELCOME_BINDINGS = 3;
var WELCOME_BINDING_TITLE_MAX = 80;
var WelcomeDigestBindingSchema = /* @__PURE__ */ z.object({
  /**
   * The served tool name the widget calls. Machine-valued and never shown: a
   * capability id in front of a visitor is the surface leaking its plumbing.
   */
  toolName: z.string().min(1).max(200),
  /** The card's heading, per locale, resolved in the browser. */
  title: customerTextSchema(WELCOME_BINDING_TITLE_MAX),
  transport: IntentTransportSchema.optional(),
  operation: IntentOperationSchema.optional(),
  /**
   * The signed intent the widget sends on `X-Syncanix-Intent`.
   *
   * Optional for the same reason it is optional on a turn's bindings: a tenant
   * with no intent secret configured still gets a working call through their
   * own executor. Its absence is a configuration fact, not a refusal.
   */
  intent: z.string().min(1).optional()
}).strict();
var WelcomeResponseSchema = /* @__PURE__ */ z.object({
  open: z.boolean(),
  refusals: z.array(z.string().min(1)).max(8),
  bindings: z.array(WelcomeDigestBindingSchema).max(MAX_WELCOME_BINDINGS).optional(),
  /**
   * The operator's digest scale, carried so the browser does not INFER it.
   *
   * Strictly redundant for the card COUNT — the server already sized the
   * bindings by it — and sent anyway, because the composed spec records a
   * scale and inferring one from `bindings.length` would label a `set`
   * workspace with a single eligible capability as `single`. Same cards,
   * wrong record, and the record is what a fit-outcome report is read
   * against. Absent on a refusal, like the bindings.
   */
  scale: z.enum(WELCOME_DIGEST_SCALES).optional()
}).strict();

// src/integrate/csp-patch.ts
var CDN = "https://cdn.syncanix.com";
var API = "https://api.syncanix.com";
var API_WSS = "wss://api.syncanix.com";
var SYNCANIX_CSP_ALLOWANCES = {
  "script-src": [CDN],
  "connect-src": [API, CDN, API_WSS],
  "style-src": ["'unsafe-inline'"]
};
function parseCsp(csp) {
  const out = /* @__PURE__ */ new Map();
  for (const segment of csp.split(";")) {
    const tokens = segment.trim().split(/\s+/).filter((t) => t.length > 0);
    const [name, ...sources] = tokens;
    if (name === void 0) continue;
    out.set(name.toLowerCase(), sources);
  }
  return out;
}
function serializeCsp(directives) {
  return [...directives.entries()].map(([name, sources]) => [name, ...sources].join(" ").trim()).join("; ");
}
function patchCspForWidget(existingCsp) {
  const directives = parseCsp(existingCsp ?? "");
  const defaultSrc = directives.get("default-src") ?? [];
  const diff = [];
  for (const [directive, required] of Object.entries(SYNCANIX_CSP_ALLOWANCES)) {
    const present = directives.get(directive);
    const baseline = present ?? [...defaultSrc];
    const existing = new Set(baseline);
    const added = [];
    for (const source of required) {
      if (!existing.has(source)) {
        existing.add(source);
        baseline.push(source);
        added.push(source);
      }
    }
    directives.set(directive, baseline);
    diff.push({ directive, added });
  }
  return { patched: serializeCsp(directives), diff };
}

// src/integrate/identity-snippet.ts
var IDENTITY_IDPS = [
  "auth0",
  "clerk",
  "cognito",
  "workos",
  "firebase",
  "supabase",
  "nextauth",
  "oidc"
];
var TOKEN_ACCESSOR = {
  auth0: {
    note: "Auth0 (@auth0/auth0-react or auth0-spa-js) \u2014 silent access token.",
    body: "return await auth0.getAccessTokenSilently();"
  },
  clerk: {
    note: "Clerk \u2014 the active session JWT (window.Clerk is set by @clerk/clerk-js).",
    body: "return (await window.Clerk?.session?.getToken()) ?? undefined;"
  },
  cognito: {
    note: "AWS Cognito (aws-amplify v6) \u2014 the id token from the current session.",
    body: "return (await fetchAuthSession()).tokens?.idToken?.toString();"
  },
  workos: {
    note: "WorkOS AuthKit (@workos-inc/authkit-react) \u2014 the access token.",
    body: "return (await getAccessToken()) ?? undefined; // from useAuth(): const { getAccessToken } = useAuth()"
  },
  firebase: {
    note: "Firebase Auth \u2014 the current user id token (getAuth().currentUser).",
    body: "return (await getAuth().currentUser?.getIdToken()) ?? undefined;"
  },
  supabase: {
    note: "Supabase \u2014 the current session access token.",
    body: "return (await supabase.auth.getSession()).data.session?.access_token;"
  },
  nextauth: {
    note: "Auth.js / next-auth \u2014 the session access token (client getSession()).",
    body: "return (await getSession())?.accessToken as string | undefined;"
  },
  oidc: {
    note: "Generic OIDC (oidc-client-ts) \u2014 the access token from the stored user.",
    body: "return (await userManager.getUser())?.access_token;"
  }
};
function buildIdentitySnippet(idp) {
  const accessor = TOKEN_ACCESSOR[idp];
  if (accessor === void 0) {
    throw new Error(`buildIdentitySnippet: unsupported IdP "${idp}".`);
  }
  return [
    `// Syncanix identity wiring \u2014 ${accessor.note}`,
    `// The token is a short-lived signed JWT, verified server-side (act-as-user).`,
    `syncanix.setTokenProvider(async () => {`,
    `  try {`,
    `    ${accessor.body}`,
    `  } catch {`,
    `    return undefined; // signed-out / not-ready \u2192 guest (no auth header)`,
    `  }`,
    `});`
  ].join("\n");
}

// src/integrate/page-action-routes.ts
var MAX_ID_LEN = 48;
function isParameterSegment(segment) {
  return segment.startsWith(":") || segment.startsWith("*") || segment.startsWith("[");
}
function decodePath(href) {
  try {
    return decodeURIComponent(href);
  } catch {
    return href;
  }
}
function humanize(segment) {
  const spaced = segment.replace(/[-_+]+/g, " ").replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/\s+/g, " ").trim();
  if (spaced === "") return "";
  return spaced.charAt(0).toLocaleUpperCase() + spaced.slice(1);
}
function asciiSlug(value) {
  return value.replace(/[^A-Za-z0-9_-]+/g, "-").replace(/^-+/, "").slice(0, MAX_ID_LEN).replace(/-+$/, "");
}
function toPageActionRoutes(hrefs) {
  const unique = [...new Set(hrefs.map((h) => h.trim()).filter((h) => h !== ""))].sort();
  const taken = /* @__PURE__ */ new Set();
  return unique.map((href, index) => {
    const decoded = decodePath(href);
    const segments = decoded.split("/").filter((s) => s !== "" && !isParameterSegment(s));
    const label = humanize(segments[segments.length - 1] ?? "");
    return {
      id: allocate(asciiSlug(decoded), index, taken),
      label: label === "" ? href : label,
      href
    };
  });
}
function allocate(preferred, index, taken) {
  const base = preferred === "" ? `route-${String(index + 1)}` : preferred;
  if (!taken.has(base)) {
    taken.add(base);
    return base;
  }
  const stem = base.slice(0, MAX_ID_LEN - 4);
  for (let n = 2; n < 1e3; n += 1) {
    const candidate = `${stem}-${String(n)}`;
    if (!taken.has(candidate)) {
      taken.add(candidate);
      return candidate;
    }
  }
  taken.add(base);
  return base;
}

// src/integrate/integration-plan.ts
var IntegrationChangeKindSchema = /* @__PURE__ */ z.enum([
  "embed",
  "identity",
  "expose-page-actions",
  "register-component",
  "csp",
  "env-var"
]);
var IntegrationChangeSchema = /* @__PURE__ */ z.object({
  kind: IntegrationChangeKindSchema,
  /** One-line description for the per-change approval prompt (blueprint § 4.4). */
  title: z.string().min(1),
  /** Repo-relative file the change targets; `null` for a non-file change. */
  targetFile: z.string().min(1).nullable(),
  /**
   * The exact content to apply, when known at plan time (embed snippet,
   * `exposePageActions` call, env-var line). `null` when a downstream stage
   * generates it: the CSP directive diff (CS-203) and the per-IdP identity
   * snippet (CS-204).
   */
  content: z.string().nullable(),
  /** True when the change writes a SECRET value (drives `.env` + gitignore, ADR-0063). */
  secret: z.boolean(),
  /** Structured per-kind detail (idp / component name / env-var name). */
  detail: z.record(z.string()).optional()
});
var IntegrationPlanSchema = /* @__PURE__ */ z.object({
  version: z.literal(1),
  changes: z.array(IntegrationChangeSchema),
  /** Detected stack, for the wizard's "Detected: …" narration (blueprint § 4.2.2). */
  summary: z.object({
    framework: z.string().nullable(),
    renderMode: z.string().nullable(),
    idp: z.string().nullable(),
    appShellPath: z.string().nullable()
  })
});
var APP_SHELL_FALLBACK = "index.html";
function buildIntegrationPlan(input) {
  const key = input.publishableKey.trim();
  if (key === "") throw new Error("buildIntegrationPlan: `publishableKey` is required.");
  const shell = input.appShellPath ?? APP_SHELL_FALLBACK;
  const changes = [];
  const deferred = input.renderMode !== null && input.renderMode !== "spa";
  const embedSnippet = buildEmbedSnippet({
    key,
    ...input.environment !== void 0 && { environment: input.environment },
    ...input.origin !== void 0 && input.origin.trim() !== "" && { origin: input.origin },
    ...deferred && { configLoad: "lazy" }
  });
  changes.push({
    kind: "embed",
    title: `Embed the Syncanix widget in ${shell}`,
    targetFile: shell,
    content: embedSnippet,
    secret: false
  });
  if (input.idp !== null) {
    const known = IDENTITY_IDPS.includes(input.idp);
    changes.push({
      kind: "identity",
      title: `Wire ${input.idp} identity into the widget`,
      targetFile: shell,
      content: known ? buildIdentitySnippet(input.idp) : null,
      secret: false,
      detail: { idp: input.idp }
    });
  }
  if (input.routes.length > 0 || input.controlSelectors.length > 0) {
    changes.push({
      kind: "expose-page-actions",
      title: "Expose page routes + controls to the agent",
      targetFile: shell,
      content: renderExposePageActions(input.routes, input.controlSelectors),
      secret: false
    });
  }
  for (const component of input.components) {
    changes.push({
      kind: "register-component",
      title: `Propose registering <${component}> as an agent-renderable component`,
      targetFile: shell,
      content: `syncanix.registerComponent(${JSON.stringify(component)}, /* factory */);`,
      secret: false,
      detail: { component }
    });
  }
  if (input.cspSource !== null) {
    const { patched, diff } = patchCspForWidget(input.existingCsp);
    const added = diff.flatMap((d) => d.added);
    changes.push({
      kind: "csp",
      title: `Patch the Content-Security-Policy in ${input.cspSource}`,
      targetFile: input.cspSource,
      content: patched,
      secret: false,
      detail: { added: added.join(" ") }
    });
  }
  for (const envVar of input.envVars) {
    changes.push({
      kind: "env-var",
      title: `Set ${envVar.name}${envVar.secret ? " (secret)" : ""}`,
      targetFile: envVar.targetFile ?? ".env",
      content: null,
      secret: envVar.secret,
      detail: { name: envVar.name }
    });
  }
  return {
    version: 1,
    changes,
    summary: {
      framework: input.framework,
      renderMode: input.renderMode,
      idp: input.idp,
      appShellPath: input.appShellPath
    }
  };
}
function renderExposePageActions(routes, selectors) {
  const seeds = toPageActionRoutes(routes);
  const call = seeds.length === 0 ? "" : `syncanix.exposePageActions(${JSON.stringify({ routes: seeds }, null, 2)});`;
  const uniqSorted = [...new Set(selectors.filter((s) => s.trim() !== ""))].sort();
  if (uniqSorted.length === 0) return call;
  const controls = [
    "// Controls the scan found. This API has no selector list \u2014 mark them in your",
    "// markup with `data-syncanix-action` and pass `markers: { scope }`, or register",
    "// each one explicitly with `syncanix.registerAction(...)`:",
    ...uniqSorted.map((selector) => `//   ${selector}`)
  ].join("\n");
  return call === "" ? controls : `${call}

${controls}`;
}

// src/integrate/dashboard-install-blocks.ts
var isKnownIdp = (idp) => IDENTITY_IDPS.includes(idp);
function buildDashboardInstallBlocks(input) {
  const key = input.publishableKey.trim();
  if (key === "") throw new Error("buildDashboardInstallBlocks: `publishableKey` is required.");
  const blocks = [
    {
      id: "embed",
      language: "html",
      code: buildEmbedSnippet({
        key,
        ...input.environment !== void 0 && { environment: input.environment },
        ...input.origin !== void 0 && input.origin.trim() !== "" && { origin: input.origin }
      })
    }
  ];
  if (input.idp !== void 0 && input.idp !== null && isKnownIdp(input.idp)) {
    blocks.push({ id: "identity", language: "javascript", code: buildIdentitySnippet(input.idp) });
  }
  blocks.push({ id: "csp", language: "text", code: patchCspForWidget(input.existingCsp).patched });
  return blocks;
}

// src/integrate/detect-widget-installation.ts
var WIDGET_HOST = new URL(WIDGET_SCRIPT_SRC).host;
var WIDGET_PATH = new URL(WIDGET_SCRIPT_SRC).pathname;
var WIDGET_SRC_RE = new RegExp(`${escapeRegExp(WIDGET_HOST)}${escapeRegExp(WIDGET_PATH)}`, "i");
var DATA_KEY_RE = /data-key\s*=\s*["']?(pk_(?:test|live)_[A-Za-z0-9]+)["']?/i;
function detectWidgetInstallation(html, expectedKey) {
  const installed = WIDGET_SRC_RE.test(html);
  if (!installed) {
    return { installed: false, detectedKey: null, keyMatches: expectedKey === void 0 };
  }
  const detectedKey = DATA_KEY_RE.exec(html)?.[1] ?? null;
  const expected = expectedKey?.trim();
  const keyMatches = expected === void 0 || expected === "" ? true : detectedKey === expected;
  return { installed: true, detectedKey, keyMatches };
}
function escapeRegExp(text) {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// src/integrate/zip-store.ts
var LOCAL_FILE_HEADER_SIG = 67324752;
var CENTRAL_DIR_HEADER_SIG = 33639248;
var END_OF_CENTRAL_DIR_SIG = 101010256;
var VERSION = 20;
var DOS_TIME = 0;
var DOS_DATE = 33;
var CRC_TABLE = (() => {
  const table = new Uint32Array(256);
  for (let n = 0; n < 256; n += 1) {
    let c = n;
    for (let k = 0; k < 8; k += 1) {
      c = (c & 1) !== 0 ? 3988292384 ^ c >>> 1 : c >>> 1;
    }
    table[n] = c >>> 0;
  }
  return table;
})();
function crc32(bytes) {
  let crc = 4294967295;
  for (const byte of bytes) {
    crc = (CRC_TABLE[(crc ^ byte) & 255] ?? 0) ^ crc >>> 8;
  }
  return (crc ^ 4294967295) >>> 0;
}
function buildStoreZip(entries) {
  const seen = /* @__PURE__ */ new Set();
  for (const entry of entries) {
    if (entry.name.length === 0) throw new Error("buildStoreZip: entry name must be non-empty.");
    if (seen.has(entry.name)) {
      throw new Error(`buildStoreZip: duplicate entry name "${entry.name}".`);
    }
    seen.add(entry.name);
  }
  const encoder = new TextEncoder();
  const localParts2 = [];
  const centralParts = [];
  let offset = 0;
  for (const entry of entries) {
    const nameBytes = encoder.encode(entry.name);
    const crc = crc32(entry.data);
    const size = entry.data.length;
    const local = new Uint8Array(30 + nameBytes.length);
    const lv = new DataView(local.buffer);
    lv.setUint32(0, LOCAL_FILE_HEADER_SIG, true);
    lv.setUint16(4, VERSION, true);
    lv.setUint16(6, 0, true);
    lv.setUint16(8, 0, true);
    lv.setUint16(10, DOS_TIME, true);
    lv.setUint16(12, DOS_DATE, true);
    lv.setUint32(14, crc, true);
    lv.setUint32(18, size, true);
    lv.setUint32(22, size, true);
    lv.setUint16(26, nameBytes.length, true);
    lv.setUint16(28, 0, true);
    local.set(nameBytes, 30);
    localParts2.push(local, entry.data);
    const central = new Uint8Array(46 + nameBytes.length);
    const cv = new DataView(central.buffer);
    cv.setUint32(0, CENTRAL_DIR_HEADER_SIG, true);
    cv.setUint16(4, VERSION, true);
    cv.setUint16(6, VERSION, true);
    cv.setUint16(8, 0, true);
    cv.setUint16(10, 0, true);
    cv.setUint16(12, DOS_TIME, true);
    cv.setUint16(14, DOS_DATE, true);
    cv.setUint32(16, crc, true);
    cv.setUint32(20, size, true);
    cv.setUint32(24, size, true);
    cv.setUint16(28, nameBytes.length, true);
    cv.setUint16(30, 0, true);
    cv.setUint16(32, 0, true);
    cv.setUint16(34, 0, true);
    cv.setUint16(36, 0, true);
    cv.setUint32(38, 0, true);
    cv.setUint32(42, offset, true);
    central.set(nameBytes, 46);
    centralParts.push(central);
    offset += local.length + entry.data.length;
  }
  const centralSize = centralParts.reduce((sum, part) => sum + part.length, 0);
  const centralOffset = offset;
  const end = new Uint8Array(22);
  const ev = new DataView(end.buffer);
  ev.setUint32(0, END_OF_CENTRAL_DIR_SIG, true);
  ev.setUint16(4, 0, true);
  ev.setUint16(6, 0, true);
  ev.setUint16(8, entries.length, true);
  ev.setUint16(10, entries.length, true);
  ev.setUint32(12, centralSize, true);
  ev.setUint32(16, centralOffset, true);
  ev.setUint16(20, 0, true);
  const total = localParts2.reduce((sum, part) => sum + part.length, 0) + centralSize + end.length;
  const out = new Uint8Array(total);
  let cursor = 0;
  for (const part of [...localParts2, ...centralParts, end]) {
    out.set(part, cursor);
    cursor += part.length;
  }
  return out;
}

// src/integrate/mcp-client-install.ts
var MCP_SERVER_ID = "syncanix";
var MCP_SERVER_LABEL = "Syncanix";
var MCP_SERVER_DESCRIPTION = "Syncanix MCP server";
function encodeBase64Utf8(input) {
  const bytes = new TextEncoder().encode(input);
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  let out = "";
  for (let i = 0; i < bytes.length; i += 3) {
    const b0 = bytes[i] ?? 0;
    const b1 = i + 1 < bytes.length ? bytes[i + 1] ?? 0 : 0;
    const b2 = i + 2 < bytes.length ? bytes[i + 2] ?? 0 : 0;
    out += alphabet.charAt(b0 >> 2);
    out += alphabet.charAt((b0 & 3) << 4 | b1 >> 4);
    out += i + 1 < bytes.length ? alphabet.charAt((b1 & 15) << 2 | b2 >> 6) : "=";
    out += i + 2 < bytes.length ? alphabet.charAt(b2 & 63) : "=";
  }
  return out;
}
function assertUrl(url, fn) {
  if (url.trim().length === 0) throw new Error(`${fn}: connection URL is required.`);
}
function buildCursorInstallLink(url) {
  assertUrl(url, "buildCursorInstallLink");
  const config = encodeBase64Utf8(JSON.stringify({ url }));
  const params = new URLSearchParams({ name: MCP_SERVER_ID, config });
  return `cursor://anysphere.cursor-deeplink/mcp/install?${params.toString()}`;
}
function buildVsCodeInstallLink(url, options = {}) {
  assertUrl(url, "buildVsCodeInstallLink");
  const scheme = options.insiders === true ? "vscode-insiders" : "vscode";
  const config = encodeURIComponent(JSON.stringify({ name: MCP_SERVER_ID, type: "http", url }));
  return `${scheme}:mcp/install?${config}`;
}
function buildGooseInstallLink(url) {
  assertUrl(url, "buildGooseInstallLink");
  const params = new URLSearchParams({
    url,
    type: "streamable_http",
    id: MCP_SERVER_ID,
    name: MCP_SERVER_LABEL,
    description: MCP_SERVER_DESCRIPTION,
    timeout: "300"
  });
  return `goose://extension?${params.toString()}`;
}
function buildWindsurfConfig(url) {
  assertUrl(url, "buildWindsurfConfig");
  return JSON.stringify({ mcpServers: { [MCP_SERVER_ID]: { serverUrl: url } } }, null, 2);
}
function buildClaudeDesktopConfig(url) {
  assertUrl(url, "buildClaudeDesktopConfig");
  return JSON.stringify(
    { mcpServers: { [MCP_SERVER_ID]: { command: "npx", args: ["-y", "mcp-remote", url] } } },
    null,
    2
  );
}
function buildClaudeCodeCommand(url) {
  assertUrl(url, "buildClaudeCodeCommand");
  return `claude mcp add --transport http ${MCP_SERVER_ID} ${url}`;
}
var MCPB_ENTRY_POINT = "server/index.js";
function buildMcpbManifest(url) {
  assertUrl(url, "buildMcpbManifest");
  return {
    manifest_version: "0.3",
    name: MCP_SERVER_ID,
    display_name: MCP_SERVER_LABEL,
    version: "1.0.0",
    description: "Connect this desktop app to your Syncanix per-tenant MCP server (remote, OAuth).",
    author: { name: MCP_SERVER_LABEL, url: "https://syncanix.com" },
    server: {
      type: "node",
      entry_point: MCPB_ENTRY_POINT,
      mcp_config: { command: "node", args: [`\${__dirname}/${MCPB_ENTRY_POINT}`] }
    }
  };
}
function buildMcpbServerLauncher(url) {
  assertUrl(url, "buildMcpbServerLauncher");
  return `#!/usr/bin/env node
// Syncanix MCP bundle launcher. Proxies this desktop app's stdio MCP client to
// the per-tenant Syncanix server over HTTP via the mcp-remote package.
'use strict';
const { spawn } = require('node:child_process');

const REMOTE_URL = ${JSON.stringify(url)};
const npx = process.platform === 'win32' ? 'npx.cmd' : 'npx';

const child = spawn(npx, ['-y', 'mcp-remote', REMOTE_URL], { stdio: 'inherit' });

child.on('exit', (code, signal) => {
  if (signal) process.kill(process.pid, signal);
  else process.exit(code == null ? 0 : code);
});
child.on('error', (err) => {
  process.stderr.write('[syncanix] failed to launch mcp-remote: ' + String(err) + '\\n');
  process.exit(1);
});

for (const sig of ['SIGINT', 'SIGTERM']) {
  process.on(sig, () => child.kill(sig));
}
`;
}
var MCPB_FILENAME = "syncanix.mcpb";
function buildMcpbBundle(url) {
  assertUrl(url, "buildMcpbBundle");
  const encoder = new TextEncoder();
  return buildStoreZip([
    {
      name: "manifest.json",
      data: encoder.encode(`${JSON.stringify(buildMcpbManifest(url), null, 2)}
`)
    },
    { name: MCPB_ENTRY_POINT, data: encoder.encode(buildMcpbServerLauncher(url)) }
  ]);
}

// src/compliance/posture-report.ts
var COMPLIANCE_DISCLAIMER = "Statically detected from source, not a pentest or a legal audit. Findings reflect the scan\u2019s auth + PII detection and may under- or over-report; treat as a starting point for review, not a compliance certification.";
var PERSONAL_DATA_PATTERNS = [
  /email/i,
  /phone/i,
  /(^|_|\b)name($|_|\b)/i,
  /first[_-]?name|last[_-]?name|full[_-]?name/i,
  /address/i,
  /\bdob\b|date[_-]?of[_-]?birth|birth/i,
  /ssn|social[_-]?security|national[_-]?id|passport/i,
  /ip[_-]?address/i,
  /gender|ethnicity|nationality/i,
  /credit[_-]?card|card[_-]?number|iban|bank[_-]?account/i,
  /latitude|longitude|geo/i
];
var isPersonalDataField = (name) => PERSONAL_DATA_PATTERNS.some((re) => re.test(name));
function piiFieldsOf(cap) {
  const out = /* @__PURE__ */ new Set();
  const scan = (args) => {
    for (const a of args ?? []) if (a.pii) out.add(a.name);
  };
  scan(cap.body?.shape);
  scan(cap.response?.shape);
  scan(cap.pathParams);
  scan(cap.queryParams);
  return [...out].sort();
}
var isWrite = (cap) => cap.sideEffect === "write" || cap.sideEffect === "destructive";
var findingOf = (cap) => ({
  capabilityId: cap.id,
  method: cap.method,
  path: cap.path,
  file: cap.source.filePath
});
var byCapabilityId = (xs) => [...xs].sort((a, b) => a.capabilityId.localeCompare(b.capabilityId));
function buildCompliancePostureReport(catalog) {
  const caps = catalog.capabilities;
  const piiSurface = byCapabilityId(
    caps.map((cap) => ({ cap, fields: piiFieldsOf(cap) })).filter(({ fields }) => fields.length > 0).map(({ cap, fields }) => ({
      capabilityId: cap.id,
      method: cap.method,
      path: cap.path,
      piiFields: fields
    }))
  );
  const unauthenticatedWrites = byCapabilityId(
    caps.filter((cap) => !cap.requiresAuth && isWrite(cap)).map(findingOf)
  );
  const destructiveInventory = byCapabilityId(
    caps.filter((cap) => cap.sideEffect === "destructive").map(findingOf)
  );
  const ropaStarter = (catalog.dataModels ?? []).map((model) => ({
    entity: model.name,
    personalDataFields: model.fields.filter((f) => isPersonalDataField(f.name)).map((f) => f.name)
  })).filter((e) => e.personalDataFields.length > 0).sort((a, b) => a.entity.localeCompare(b.entity));
  return {
    summary: {
      totalCapabilities: caps.length,
      piiCapabilities: piiSurface.length,
      unauthenticatedWrites: unauthenticatedWrites.length,
      destructiveCapabilities: destructiveInventory.length,
      personalDataEntities: ropaStarter.length
    },
    piiSurface,
    unauthenticatedWrites,
    destructiveInventory,
    ropaStarter,
    disclaimer: COMPLIANCE_DISCLAIMER
  };
}
var COMPLIANCE_SEVERITIES = ["low", "medium", "high", "critical"];
var ComplianceSeveritySchema = /* @__PURE__ */ z.enum(COMPLIANCE_SEVERITIES);
var COMPLIANCE_SCORE_SEVERITIES = ["none", ...COMPLIANCE_SEVERITIES];
var ComplianceScoreSeveritySchema = /* @__PURE__ */ z.enum(COMPLIANCE_SCORE_SEVERITIES);
function severityRank(severity) {
  return COMPLIANCE_SCORE_SEVERITIES.indexOf(severity);
}
function severityAtLeast(a, b) {
  return severityRank(a) >= severityRank(b);
}
var SEVERITY_PENALTY = {
  low: 5,
  medium: 15,
  high: 30,
  critical: 50
};
var COMPLIANCE_CATEGORIES = ["compliance", "fraud"];
var COMPLIANCE_DETECTOR_IDS = [
  "pii-exposure",
  "prohibited-financial-advice",
  "prohibited-medical-advice",
  "unsubstantiated-guarantee",
  "credential-solicitation",
  "payment-redirection",
  "account-takeover-attempt"
];
var ComplianceDetectorIdSchema = /* @__PURE__ */ z.enum(COMPLIANCE_DETECTOR_IDS);
var COMPLIANCE_RUBRIC = [
  { id: "pii-exposure", category: "compliance", severity: "critical" },
  { id: "prohibited-financial-advice", category: "compliance", severity: "high" },
  { id: "prohibited-medical-advice", category: "compliance", severity: "high" },
  { id: "unsubstantiated-guarantee", category: "compliance", severity: "medium" },
  { id: "credential-solicitation", category: "fraud", severity: "critical" },
  { id: "payment-redirection", category: "fraud", severity: "high" },
  { id: "account-takeover-attempt", category: "fraud", severity: "high" }
];
var RUBRIC_BY_ID = new Map(
  COMPLIANCE_RUBRIC.map((c) => [c.id, c])
);
function complianceCriterion(id) {
  const criterion = RUBRIC_BY_ID.get(id);
  if (criterion === void 0) throw new Error(`unknown compliance criterion: ${id}`);
  return criterion;
}
var RUBRIC_VERSION = 1;
var COMPLIANCE_SCHEMA_VERSION = 1;
var MAX_EVIDENCE_PER_FINDING = 8;
var MAX_SEQUENCES_PER_FINDING = 20;
var ComplianceFindingSchema = /* @__PURE__ */ z.object({
  detectorId: ComplianceDetectorIdSchema,
  category: z.enum(COMPLIANCE_CATEGORIES),
  severity: ComplianceSeveritySchema,
  /** How many messages / patterns matched. Always ≥ 1 for a real finding. */
  matchCount: z.number().int().nonnegative(),
  /** Forensic pattern labels — regex sources / category labels, never user text. */
  evidence: z.array(z.string()).max(MAX_EVIDENCE_PER_FINDING),
  /** `conversation_messages.sequence` indices that matched — never content. */
  messageSequences: z.array(z.number().int().nonnegative()).max(MAX_SEQUENCES_PER_FINDING)
});
var ComplianceScorecardSchema = /* @__PURE__ */ z.object({
  rubricVersion: z.number().int().positive(),
  schemaVersion: z.number().int().positive(),
  /** 0–100; 100 = clean, deductions per finding. */
  score: z.number().min(0).max(100),
  highestSeverity: ComplianceScoreSeveritySchema,
  /** Number of triggered criteria (each finding is a criterion violation). */
  violationCount: z.number().int().nonnegative(),
  findings: z.array(ComplianceFindingSchema)
});
function clamp3(v, min, max) {
  return Math.max(min, Math.min(max, v));
}
function scoreFromFindings(findings) {
  let penalty = 0;
  let highest = "none";
  for (const finding of findings) {
    penalty += SEVERITY_PENALTY[finding.severity];
    if (severityAtLeast(finding.severity, highest)) highest = finding.severity;
  }
  return {
    score: clamp3(100 - penalty, 0, 100),
    highestSeverity: highest,
    violationCount: findings.length
  };
}
function buildScorecard(findings) {
  return {
    rubricVersion: RUBRIC_VERSION,
    schemaVersion: COMPLIANCE_SCHEMA_VERSION,
    ...scoreFromFindings(findings),
    findings: [...findings]
  };
}
var CompositionBindingCallSchema = /* @__PURE__ */ z.object({
  elementIds: z.array(NonEmptyId).min(1).max(24),
  toolName: z.string().min(1).max(200),
  args: z.record(z.string(), z.unknown()),
  transport: IntentTransportSchema.optional(),
  operation: IntentOperationSchema.optional(),
  /** The signed intent the widget sends on `X-Syncanix-Intent`. */
  intent: z.string().min(1).optional()
}).strict();
var CompositionBindingsSchema = /* @__PURE__ */ z.object({
  type: z.literal("composition.bindings"),
  /** The `present_composition` call these bindings belong to. */
  toolCallId: NonEmptyId,
  /**
   * Capped at the server's own binding cap. A bound the wire can exceed is not a
   * bound, and this one exists to protect a system we do not own.
   */
  bindings: z.array(CompositionBindingCallSchema).max(6)
});
var EXPORTED_TABLE_NUMBER_FORMATS = ["raw"];
var EXPORTED_FILE_MAX_FILENAME = 200;
var EXPORTED_FILE_MAX_BYTES = 2 * 1024 * 1024;
var EXPORTED_FILE_MAX_PER_CONVERSATION_PER_HOUR = 20;
var EXPORTED_FILE_LINK_TTL_SECONDS = 15 * 60;
var EXPORTED_TABLE_CONTENT_TYPE = "text/csv; charset=utf-8";
var ExportedTableResultSchema = /* @__PURE__ */ z.object({
  type: z.literal("exportedTable"),
  /** The `conversation_artifacts` row id. Stable across re-mints of the link. */
  artifactId: z.string().uuid(),
  filename: z.string().min(1).max(EXPORTED_FILE_MAX_FILENAME),
  contentType: z.string().min(1).max(255),
  byteSize: z.number().int().nonnegative(),
  /** Rows in the FILE, which is rows in the rendered table. */
  rowCount: z.number().int().nonnegative(),
  columnCount: z.number().int().positive(),
  numberFormat: z.enum(EXPORTED_TABLE_NUMBER_FORMATS)
}).strict();
function isExportedTableResult(value) {
  return ExportedTableResultSchema.safeParse(value).success;
}

// src/turn-stream/file-events.ts
var FileReadySchema = /* @__PURE__ */ z.object({
  type: z.literal("file.ready"),
  /**
   * The call this file came out of — the card renders under that tool call's
   * chip, so a turn that exported twice shows two cards in the right places.
   */
  toolCallId: NonEmptyId,
  /** The `conversation_artifacts` row id. Same value the tool result carries. */
  artifactId: z.string().uuid(),
  filename: z.string().min(1).max(EXPORTED_FILE_MAX_FILENAME),
  contentType: z.string().min(1).max(255),
  byteSize: z.number().int().nonnegative(),
  rowCount: z.number().int().nonnegative(),
  /**
   * The presigned GET. `https` only and bounded: the widget navigates the top
   * level to it, so a `javascript:`/`data:` URL here would be a navigation
   * primitive rather than a download. The widget re-checks with `safeUrl`
   * regardless — one boundary is a claim, two is a guarantee.
   */
  url: z.string().url().startsWith("https://").max(2e3),
  /** When the link stops working, ISO-8601. The OBJECT outlives it; the link does not. */
  expiresAt: z.string().datetime()
});
var MessageStartSchema = /* @__PURE__ */ z.object({
  type: z.literal("message.start"),
  messageId: NonEmptyId
});
var MessageDeltaSchema = /* @__PURE__ */ z.object({
  type: z.literal("message.delta"),
  messageId: NonEmptyId,
  delta: z.string().max(2e4)
});
var MessageProvenanceSchema = /* @__PURE__ */ z.object({
  v: z.literal(1),
  kind: z.literal("ai-generated"),
  generator: z.literal("syncanix"),
  contentHash: z.string().regex(/^[0-9a-f]{64}$/),
  /** ISO-8601 UTC timestamp bound into the signature. */
  timestamp: z.string().datetime(),
  /** base64url Ed25519 signature (no padding). */
  sig: z.string().regex(/^[A-Za-z0-9_-]+$/),
  /** Identifies the signing key for rotation; matches the published key set. */
  keyId: z.string().min(1).max(64)
});
var MessageEndSchema = /* @__PURE__ */ z.object({
  type: z.literal("message.end"),
  messageId: NonEmptyId,
  /** Present only on signed LLM-generated messages (ADR-0173 wave 2). */
  provenance: MessageProvenanceSchema.optional()
});
var ThinkingStartSchema = /* @__PURE__ */ z.object({
  type: z.literal("thinking.start"),
  turnId: NonEmptyId
});
var ThinkingDeltaSchema = /* @__PURE__ */ z.object({
  type: z.literal("thinking.delta"),
  turnId: NonEmptyId,
  delta: z.string().max(2e4)
});
var ThinkingEndSchema = /* @__PURE__ */ z.object({
  type: z.literal("thinking.end"),
  turnId: NonEmptyId
});
var ConfirmationRequiredSchema = /* @__PURE__ */ z.object({
  /**
   * The HMAC single-action confirmation token the widget exchanges via
   * `POST /conversations/:id/actions/confirm` for the signed intent. Present for
   * every SERVER-EXECUTABLE (catalog-tool) confirm — the exchange is what mints
   * the intent.
   *
   * SYN-109 — OPTIONAL for a WIDGET-LOCAL confirm (a `host_action__*` call, or a
   * `ui.*` Copilot verb): those run in the browser realm with no signed intent,
   * so there is nothing to exchange the token FOR. The widget renders the SAME
   * ConfirmCard from `message` + `sideEffect` and, on accept, runs the local
   * executor directly (never the exchange). The exchange path fails closed if a
   * token is ever absent there (defensive), so dropping it here can only make a
   * gated call MORE conservative, never bypass a gate.
   */
  token: z.string().min(1).optional(),
  sideEffect: z.enum(["write", "destructive"]),
  message: z.string().min(1),
  /**
   * S3 — the capability's human-readable name, for the card's heading.
   *
   * Distinct from the tool NAME the widget already has on the event: that is the
   * sanitized provider handle (`orders_refund`, `svc__orders_refund`), and a
   * confirmation that says "run orders_refund?" is asking a visitor to approve
   * an identifier. Server-authored from the catalog's own `name`/description
   * (never client-supplied) and, like `message`, already localized.
   *
   * Optional and additive: absent on a producer that predates it, and the widget
   * falls back to the tool name exactly as it does today.
   */
  capabilityName: z.string().min(1).max(200).optional(),
  /**
   * S3 — the arguments the model proposed, REDACTED for display.
   *
   * A confirmation that does not say what will be done with what is asking for a
   * signature on a blank page: "This will make a change" is not a decision a
   * visitor can make. These are the values, run through the platform's
   * write-side redaction (curated secret KEYS masked wholesale, plus the shared
   * value-SHAPE patterns) before they leave the server.
   *
   * **Display only — never execute from these.** What actually runs is bound by
   * `token`'s `argsHash`, which is computed over the RAW arguments (ADR-0153).
   * A redacted value is by definition not the value that will be sent, so a
   * client that substituted these back in would produce a call the token
   * refuses. The field name says so on purpose.
   *
   * Optional and additive; the raw `args` already ride the same event, so this
   * discloses strictly less than the envelope around it.
   */
  redactedArgs: z.record(z.string(), z.unknown()).optional(),
  /**
   * Record-reference labels — for an argument whose value is a record id the
   * conversation's own reads returned, the row's human label (its `title` /
   * `name`, disambiguated where two rows share one), keyed by argument name.
   *
   * A visitor asked to approve "delete `inc_7f3a`" is being asked to approve
   * an identifier they never chose; the label is what they picked. Server-
   * resolved from the read result the id came out of (never client-supplied,
   * already `sanitizeToolText`-stripped), and DISPLAY ONLY exactly like
   * `redactedArgs`: what runs is bound by `token`'s `argsHash` over the raw
   * arguments. Optional and additive — an older producer sends none and the
   * card shows the value alone, as before. Bounded per label because it is
   * host-data prose rendered inside the platform's own approval surface.
   */
  argLabels: z.record(z.string(), z.string().min(1).max(200)).optional(),
  /**
   * F1-1/ADR-0170 — Change Preview instruction. When present, the widget MAY
   * run this read-class leg (the capability's sibling GET, user's own JWT)
   * while the confirm card is open and render the before→after DiffCard from
   * the result. Advisory for rendering only: what EXECUTES is still bound by
   * `token`'s args-hash. `inferred` is the zero-customer-work mode;
   * `first-class` arrives with the mode-bound-intent SDK rollout (ADR-0170 §1).
   */
  preview: z.object({
    mode: z.literal("inferred"),
    method: z.literal("GET"),
    path: z.string().min(1)
  }).optional(),
  /**
   * F1-1/ADR-0170 — connector reliability class (AF-199 FULL/SEND declarations,
   * finally wired). `full` ⇒ the action is compensable and the ActionResult may
   * offer Undo (F1-3); `send` ⇒ sent-is-sent, no Undo ever; absent ⇒ not a
   * first-party connector action (catalog capability — reliability unknown).
   */
  reliability: z.enum(["full", "send"]).optional(),
  /**
   * E10 / ADR-0782 — approval batching. When ONE agent-loop iteration raises
   * two or more confirm-requiring WRITE calls, the server stamps each of their
   * confirmations with the same batch `id` and this call's `index` of `size`,
   * so the widget renders ONE card listing every action instead of a queue of
   * cards the visitor answers one after another.
   *
   * What the stamp does NOT change, stated because the whole slice rests on it:
   * every action keeps its OWN single-use signed `token` (ADR-0153 unchanged),
   * the widget exchanges one token per approved row, and a declined row's
   * token is never exchanged. The batch is a PRESENTATION grouping — there is
   * no batch token, and nothing here can approve a sibling. A `destructive`
   * confirmation is never stamped (it keeps its own card; the agent loop refuses
   * to plan one into a batch, and the widget refuses to group one).
   *
   * Both remaining fields are load-bearing rather than descriptive. `index` is
   * the order the card renders its rows in — the server plans over results it
   * has already sorted by tool-call id, so it is the deterministic order a
   * persisted transcript replays in, and reading it is what keeps the card the
   * visitor approves in the same order as the record of what they approved.
   * `size` is the wire-level guard: a stamp on a lone call is a grouping with
   * nothing to group, so `min(2)` makes one unmintable, and a producer that
   * sends one has its whole confirmation refused at the parse — which fails
   * closed (no confirmation on the event ⇒ no signed intent ⇒ the call is
   * refused downstream), never open.
   *
   * Optional and additive: an older producer omits it and the widget queues
   * cards exactly as before; an older widget ignores it.
   */
  batch: z.object({
    id: z.string().min(1).max(200),
    index: z.number().int().nonnegative(),
    size: z.number().int().min(2)
  }).strict().optional()
});

// src/turn-stream/tool-call-events.ts
var ToolCallStartSchema = /* @__PURE__ */ z.object({
  type: z.literal("tool_call.start"),
  toolCallId: NonEmptyId,
  toolName: z.string().min(1).max(200),
  /**
   * Agent-engine P0a (`plan/agent-engine/AUDIT.md` § 2 L7) — the capability's
   * human name in the REPLY locale, resolved server-side from the catalog
   * (ADR-0477 ladder → `LlmTool.displayName`). The widget's progress chip used
   * to compose its object noun by tokenizing the machine tool name, so a Hebrew
   * or Arabic conversation read a Hebrew verb frame around an English noun
   * ("جارٍ التحقق من invoices…"). With this field the chip shows the served name
   * and falls back to the derivation only when the catalog has none. Absent
   * for platform reserved tools, whose labels are widget catalog copy ×6.
   */
  displayName: z.string().min(1).max(200).optional()
});
var ToolCallArgsDeltaSchema = /* @__PURE__ */ z.object({
  type: z.literal("tool_call.args.delta"),
  toolCallId: NonEmptyId,
  argsDelta: z.string().max(2e4)
});
var ToolCallEndSchema = /* @__PURE__ */ z.object({
  type: z.literal("tool_call.end"),
  toolCallId: NonEmptyId,
  args: z.record(z.string(), z.unknown()),
  /**
   * Act-as-user PR-0b — the execution coordinates the server already resolves
   * for a widget-bound tool call, carried to the widget so its default executor
   * can build the authenticated request itself (instead of the customer
   * hand-mapping tool name → HTTP call). All optional + additive: producers
   * before PR-0b and the widget before PR-3 simply omit/ignore them.
   *
   *   - `transport` / `operation` — the transport-aware coordinate (REST path,
   *     GraphQL operation, tRPC procedure, WS event, gRPC service/method).
   *   - `requiresStepUp` — the catalog flagged this capability as needing a
   *     step-up auth challenge before execution.
   *   - `intent` — the server-signed `X-Syncanix-Intent` token the widget
   *     attaches when calling the customer's API (the customer SDK verifies it).
   */
  transport: IntentTransportSchema.optional(),
  operation: IntentOperationSchema.optional(),
  requiresStepUp: z.boolean().optional(),
  intent: z.string().min(1).optional(),
  confirmationRequired: ConfirmationRequiredSchema.optional(),
  /**
   * AF-180 — present iff this execution is the compensating (undo) operation for
   * a previously-recorded action. Carries the action id being undone so the
   * widget can mark the right action card "undone" when the compensating call
   * succeeds. Declared on BOTH end + execute per the C17 lesson above.
   */
  rollbackOfActionId: NonEmptyId.optional(),
  /**
   * SYN-815 — server bookkeeping for a floored-card RE-DISPATCH. When the resume
   * path detects that a turn is answering a server-composed question card, it
   * SEEDS the agent loop with the reconstructed capability call; the loop
   * synthesizes this `tool_call.end` for that call and stamps these two fields
   * so `accumulate-request-transcript.ts` persists them on the tool-call row.
   * The detector (`floored-card-redispatch.ts`) reads `redispatchDepth` back off
   * that row as its loop guard (refuse a second re-dispatch).
   *
   * Present ONLY on a server-synthesized re-dispatch — never on a model tool
   * call. The widget ignores them (they carry no execution meaning); they exist
   * purely so the persisted transcript can bound the round-trip.
   *
   *   - `redispatchOf` — the ORIGINAL floored capability call's tool-call id.
   *   - `redispatchDepth` — how many re-dispatches deep this one is (always 1;
   *     the detector refuses to seed at depth ≥ 1).
   */
  redispatchOf: NonEmptyId.optional(),
  redispatchDepth: z.number().int().nonnegative().optional()
});
var ToolCallUndoAvailableSchema = /* @__PURE__ */ z.object({
  type: z.literal("tool_call.undo_available"),
  toolCallId: NonEmptyId,
  actionId: z.string().min(1),
  expiresAt: z.string().datetime()
});
var ToolCallDeferredNavigationSchema = /* @__PURE__ */ z.object({
  type: z.literal("tool_call.deferred_navigation"),
  toolCallId: NonEmptyId,
  toolName: z.string().min(1),
  args: z.record(z.unknown())
});
var ToolCallResultSchema = /* @__PURE__ */ z.object({
  type: z.literal("tool_call.result"),
  toolCallId: NonEmptyId,
  result: z.unknown(),
  /**
   * SYN-908 — the VISITOR's copy of this result, when the server composed one.
   *
   * `result` stays the customer API's answer, verbatim. That is deliberate and
   * it is the whole reason this field exists rather than the server simply
   * replacing `result`: a `tool_call.result` is PERSISTED as the `role='tool'`
   * transcript row (the message writer) and that row is what rebuilds the
   * model's memory of the read on EVERY later turn. Overwriting `result` with a
   * presentation would leave the model, one turn on, remembering a list of
   * labels instead of the records — and above the display threshold, where the
   * whole point is that the visitor answers on the NEXT turn, remembering
   * nothing at all.
   *
   * So the split is by consumer, structurally: the widget renders `view` when
   * it is here; the writer, the model context and every existing reader see
   * only `result` and are unchanged. The turn-resume recorder replays the event
   * whole, so a recovered stream keeps the composed surface.
   *
   * Known bound: restoring a conversation from the PERSISTED transcript has no
   * `view` (it was never stored), so an old turn re-renders from the raw result
   * exactly as it did before this field existed.
   */
  view: z.unknown().optional()
});
var ToolCallExecuteSchema = /* @__PURE__ */ z.object({
  type: z.literal("tool_call.execute"),
  toolCallId: NonEmptyId,
  toolName: z.string().min(1).max(200),
  args: z.record(z.string(), z.unknown()),
  // F1-V1a/ADR-0167 — OPTIONAL: a widget-local Copilot Mode `ui.*` execute event
  // carries a `confirmationRequired` but has NO transport operation (it runs in
  // the host DOM, not via the customer's API). Transport (API) tools always
  // populate both; every consumer that reads `.operation`/`.transport` guards
  // the ui.* (undefined) case and routes it to the widget executor instead.
  transport: IntentTransportSchema.optional(),
  operation: IntentOperationSchema.optional(),
  requiresStepUp: z.boolean().optional(),
  intent: z.string().min(1).optional(),
  confirmationRequired: ConfirmationRequiredSchema.optional(),
  /** AF-180 — see {@link ToolCallEndSchema}; the undo handle this call reverses. */
  rollbackOfActionId: NonEmptyId.optional()
});
var TurnLanguageSchema = /* @__PURE__ */ z.object({
  type: z.literal("turn.language"),
  /** A supported locale tag. Validated against the shared vocabulary by the consumer. */
  locale: z.string().min(2).max(16)
});
var TurnPlanFrameSchema = /* @__PURE__ */ z.object({
  type: z.literal("turn.plan"),
  /**
   * A `TurnPlanShape` — validated against the shared vocabulary by the
   * consumer, the way `turn.language`'s locale is. A widget that does not
   * recognise the member paints no skeleton rather than guessing at one.
   */
  shape: z.string().min(2).max(32)
});

// src/turn-stream/turn-status-events.ts
var CitationSchema = /* @__PURE__ */ z.object({
  type: z.literal("citation"),
  messageId: NonEmptyId,
  sourceId: NonEmptyId,
  excerpt: z.string().min(1).max(4e3),
  docUri: z.string().min(1).max(2e3),
  docTitle: z.string().min(1).max(500).optional()
});
var TurnUsageSchema = /* @__PURE__ */ z.object({
  promptTokens: z.number().int().nonnegative(),
  completionTokens: z.number().int().nonnegative(),
  /**
   * ADR-0163 — prompt-cache read tokens (Anthropic `cache_read_input_tokens`),
   * billed at 0.1× input. Optional + back-compat: absent on providers/turns that
   * don't report caching (OpenAI, test mocks). `promptTokens` is the UNCACHED
   * remainder only, so accurate per-turn cost = uncached + 0.1×read + 1.25×write.
   */
  cacheReadTokens: z.number().int().nonnegative().optional(),
  /**
   * ADR-0163 — prompt-cache creation/write tokens (Anthropic
   * `cache_creation_input_tokens`), billed at 1.25× input (2× under the
   * 1-hour TTL). Optional + back-compat.
   */
  cacheCreationTokens: z.number().int().nonnegative().optional(),
  /**
   * ADR-0437 audit — the provider-reported per-TTL write split
   * (`usage.cache_creation.ephemeral_5m_input_tokens` / `_1h_…`). The
   * authority on what was CHARGED: pricing bills each portion at its own
   * rate and ignores the requested-TTL heuristic when these are present.
   * Optional + back-compat; absent when the provider reports no breakdown.
   */
  cacheWrite5mTokens: z.number().int().nonnegative().optional(),
  cacheWrite1hTokens: z.number().int().nonnegative().optional()
});
var TurnStopReasonSchema = /* @__PURE__ */ z.enum(["end", "length", "tool_use", "other"]);
var TurnEndSchema = /* @__PURE__ */ z.object({
  type: z.literal("turn.end"),
  /** Token usage for this turn — optional; populated when the provider reported it. */
  usage: TurnUsageSchema.optional(),
  /** Why the model stopped — optional; populated when the adapter could map it. */
  stopReason: TurnStopReasonSchema.optional(),
  /** Model id (`provider:model`) — optional; required alongside `usage` for cost attribution. */
  model: z.string().min(1).max(120).optional()
});
var TurnStartSchema = /* @__PURE__ */ z.object({
  type: z.literal("turn.start"),
  turnId: NonEmptyId,
  resumeToken: z.string().min(1).max(2048)
});
var ErrorLimitSchema = /* @__PURE__ */ z.object({
  meter: z.enum(["messages", "compute_units", "turns"]),
  used: z.number().int().nonnegative(),
  allowance: z.number().int().nonnegative(),
  /** ISO-8601 instant the allowance resets, when the limit is period-bound. */
  resetsAt: z.string().datetime().optional()
});
var ErrorEventSchema = /* @__PURE__ */ z.object({
  type: z.literal("error"),
  code: z.string().min(1).max(80),
  message: z.string().min(1).max(2e3),
  /**
   * Server-suggested retry delay (quota throttles). Declared here because
   * the widget parses frames with THIS schema and `z.object` strips unknown
   * keys — the field rode the wire undeclared since C2b and was silently
   * dropped client-side (the C17 lesson, caught by C33-4).
   */
  retryAfterMs: z.number().int().positive().optional(),
  limit: ErrorLimitSchema.optional()
});
var SuggestionSchema = /* @__PURE__ */ z.object({
  label: z.string().min(1).max(120),
  prompt: z.string().min(1).max(2e3)
});
var SuggestionsSchema = /* @__PURE__ */ z.object({
  type: z.literal("suggestions"),
  suggestions: z.array(SuggestionSchema).min(1).max(6)
});
var ContextTruncatedSchema = /* @__PURE__ */ z.object({
  type: z.literal("context.truncated"),
  droppedCount: z.number().int().positive()
});

// src/turn-stream/events.schema.ts
var TurnStreamEventSchema = /* @__PURE__ */ z.discriminatedUnion("type", [
  TurnStartSchema,
  TurnLanguageSchema,
  TurnPlanFrameSchema,
  MessageStartSchema,
  MessageDeltaSchema,
  MessageEndSchema,
  ToolCallStartSchema,
  ToolCallArgsDeltaSchema,
  ToolCallEndSchema,
  ToolCallResultSchema,
  ToolCallDeferredNavigationSchema,
  ToolCallUndoAvailableSchema,
  ToolCallExecuteSchema,
  CitationSchema,
  ThinkingStartSchema,
  ThinkingDeltaSchema,
  ThinkingEndSchema,
  TurnEndSchema,
  ErrorEventSchema,
  SuggestionsSchema,
  ContextTruncatedSchema,
  AskQuestionSchema,
  PresentFlowSchema,
  CompositionBindingsSchema,
  FileReadySchema
]);
var TURN_STREAM_EVENT_TYPES = [
  "turn.start",
  "turn.language",
  "turn.plan",
  "message.start",
  "message.delta",
  "message.end",
  "tool_call.start",
  "tool_call.args.delta",
  "tool_call.end",
  "tool_call.result",
  "tool_call.deferred_navigation",
  "tool_call.undo_available",
  "tool_call.execute",
  "citation",
  "thinking.start",
  "thinking.delta",
  "thinking.end",
  "turn.end",
  "error",
  "suggestions",
  "context.truncated",
  "ask_question",
  "present_flow",
  "composition.bindings",
  "file.ready"
];
var NonEmptyId2 = /* @__PURE__ */ z.string().min(1).max(120);
var TOOL_RESULT_DENIAL_REASONS = [
  "user_declined",
  "permission_denied",
  "rate_limited",
  "page_mid_work"
];
var ADJUST_STEER_REASON = "user_requested_adjustment";
var SuccessEnvelopeSchema = /* @__PURE__ */ z.object({
  conversationId: NonEmptyId2,
  toolCallId: NonEmptyId2,
  outcome: z.literal("success"),
  result: z.unknown()
});
var ErrorEnvelopeSchema = /* @__PURE__ */ z.object({
  conversationId: NonEmptyId2,
  toolCallId: NonEmptyId2,
  outcome: z.literal("error"),
  error: z.object({
    code: z.string().min(1).max(80),
    // Empty is legal (SYN-411): over HTTP/2 `statusText` is always '', so
    // real tool failures can arrive message-less. `code` is the required
    // signal; rejecting the envelope turned every such failure into a hung
    // conversation (the agent never received the tool result).
    message: z.string().max(2e3)
  })
});
var DeniedEnvelopeSchema = /* @__PURE__ */ z.object({
  conversationId: NonEmptyId2,
  toolCallId: NonEmptyId2,
  outcome: z.literal("denied"),
  reason: z.enum(TOOL_RESULT_DENIAL_REASONS)
});
var ToolResultEnvelopeSchema = /* @__PURE__ */ z.discriminatedUnion("outcome", [
  SuccessEnvelopeSchema,
  ErrorEnvelopeSchema,
  DeniedEnvelopeSchema
]);
var TOOL_RESULT_OUTCOMES = ["success", "error", "denied"];

// src/turn-stream/heartbeat.ts
var TURN_STREAM_HEARTBEAT_MS = 15e3;
var TURN_STREAM_FIRST_BYTE_TIMEOUT_MS = 65e3;
var TURN_STREAM_INTER_FRAME_TIMEOUT_MS = 3 * TURN_STREAM_HEARTBEAT_MS;

// src/turn-stream/transport-stage.ts
var STREAM_TRANSPORT_STAGES = ["off", "recover", "resume", "all"];
function isStreamTransportStage(value) {
  return typeof value === "string" && STREAM_TRANSPORT_STAGES.includes(value);
}
function parseStreamTransportStage(raw) {
  const value = (raw ?? "").trim();
  if (value === "") return "off";
  if (isStreamTransportStage(value)) return value;
  throw new Error(
    `SYNCANIX_STREAM_TRANSPORT must be one of ${STREAM_TRANSPORT_STAGES.join(" | ")}, got "${raw ?? ""}".`
  );
}
function openedStreamTransportLegs(stage) {
  const order = ["recover", "resume", "all"];
  if (stage === "off") return [];
  return order.slice(0, order.indexOf(stage) + 1);
}

// src/turn-plan/vocabulary.ts
var PLANNER_SCHEMA_VERSION = 1;
var TURN_PLAN_SCOPES = [
  "in_scope",
  "smalltalk",
  "out_of_scope",
  "refused_topic",
  "competitor",
  "sensitive_domain",
  "internal_probe",
  "other_customer",
  "needs_human"
];
var TURN_PLAN_INTENTS = [
  "informational",
  "teach_how_to",
  "locate",
  "navigate",
  "lookup_record",
  "list_records",
  "compare",
  "analyze_metrics",
  "perform_action",
  "multi_step_task",
  "contact_request",
  "needs_account",
  "file_request",
  "clarify",
  "none"
];
var TURN_PLAN_SHAPES = [
  "text",
  "text_with_chips",
  "detail",
  "table",
  "card_grid",
  "chart",
  "metric_strip",
  "comparison",
  "composition",
  "question_card",
  "form",
  "funnel",
  "walkthrough",
  "navigate",
  "component",
  "file",
  "confirm_action",
  "sign_in",
  "refusal"
];
var PLAN_SHAPES = new Set(TURN_PLAN_SHAPES);
function isTurnPlanShape(value) {
  return PLAN_SHAPES.has(value);
}
var TURN_PLAN_MISSING_INPUT_REASONS = [
  "required",
  "disambiguation",
  "preference"
];
var NEGATIVE_SCOPES = [
  "out_of_scope",
  "refused_topic",
  "competitor",
  "sensitive_domain",
  "internal_probe",
  "other_customer",
  "needs_human"
];
var NEGATIVE_SET = new Set(NEGATIVE_SCOPES);
function isNegativeScope(scope) {
  return NEGATIVE_SET.has(scope);
}
var REFUSING_SCOPES = [
  "refused_topic",
  "sensitive_domain",
  "internal_probe",
  "other_customer"
];
var MAX_TURN_PLAN_CAPABILITY_GROUPS = 3;
var MAX_TURN_PLAN_ENTITIES = 6;
var MAX_TURN_PLAN_ENTITY_CHARS = 40;
var MAX_TURN_PLAN_OFFERS = 3;
var MAX_TURN_PLAN_MISSING_INPUTS = 6;
var MAX_TURN_PLAN_NAME_CHARS = 64;
var MAX_TURN_PLAN_GROUP_CHARS = 64;
var ConfidenceSchema = /* @__PURE__ */ z.number().min(0).max(1);
var MissingInputSchema = /* @__PURE__ */ z.object({
  name: z.string().min(1).max(MAX_TURN_PLAN_NAME_CHARS),
  reason: z.enum(TURN_PLAN_MISSING_INPUT_REASONS)
}).strict();
var SecondChoiceSchema = /* @__PURE__ */ z.object({
  shape: z.enum(TURN_PLAN_SHAPES),
  confidence: ConfidenceSchema
}).strict();
var TurnPlanSchema = /* @__PURE__ */ z.object({
  version: z.literal(PLANNER_SCHEMA_VERSION),
  scope: z.enum(TURN_PLAN_SCOPES),
  intent: z.enum(TURN_PLAN_INTENTS),
  shape: z.enum(TURN_PLAN_SHAPES),
  capabilityGroups: z.array(z.string().min(1).max(MAX_TURN_PLAN_GROUP_CHARS)).max(MAX_TURN_PLAN_CAPABILITY_GROUPS),
  entities: z.array(z.string().min(1).max(MAX_TURN_PLAN_ENTITY_CHARS)).max(MAX_TURN_PLAN_ENTITIES),
  templateId: z.string().min(1).max(MAX_TURN_PLAN_NAME_CHARS).optional(),
  missingInputs: z.array(MissingInputSchema).max(MAX_TURN_PLAN_MISSING_INPUTS),
  askFirst: z.boolean(),
  offers: z.array(z.enum(TURN_PLAN_INTENTS)).max(MAX_TURN_PLAN_OFFERS),
  confidence: ConfidenceSchema,
  scopeConfidence: ConfidenceSchema,
  secondChoice: SecondChoiceSchema.optional()
}).strict();
var TURN_PLAN_TOOL_NAME = "plan_turn";
var TURN_PLAN_REQUIRED_FIELDS = [
  "version",
  "scope",
  "intent",
  "shape",
  "capabilityGroups",
  "entities",
  "missingInputs",
  "askFirst",
  "offers",
  "confidence",
  "scopeConfidence"
];
function turnPlanJsonSchema(describe) {
  const enumOf = (values) => ({
    type: "string",
    enum: [...values]
  });
  return {
    type: "object",
    additionalProperties: false,
    required: [...TURN_PLAN_REQUIRED_FIELDS],
    properties: {
      version: { type: "integer", enum: [PLANNER_SCHEMA_VERSION] },
      scope: { ...enumOf(TURN_PLAN_SCOPES), description: describe("scope") },
      intent: { ...enumOf(TURN_PLAN_INTENTS), description: describe("intent") },
      shape: { ...enumOf(TURN_PLAN_SHAPES), description: describe("shape") },
      capabilityGroups: {
        type: "array",
        items: { type: "string" },
        description: describe("capabilityGroups")
      },
      entities: {
        type: "array",
        items: { type: "string" },
        description: describe("entities")
      },
      templateId: {
        type: "string",
        description: describe("templateId")
      },
      missingInputs: {
        type: "array",
        items: {
          type: "object",
          additionalProperties: false,
          required: ["name", "reason"],
          properties: {
            name: { type: "string" },
            reason: enumOf(TURN_PLAN_MISSING_INPUT_REASONS)
          }
        },
        description: describe("missingInputs")
      },
      askFirst: { type: "boolean", description: describe("askFirst") },
      offers: {
        type: "array",
        items: enumOf(TURN_PLAN_INTENTS),
        description: describe("offers")
      },
      confidence: { type: "number", description: describe("confidence") },
      scopeConfidence: {
        type: "number",
        description: describe("scopeConfidence")
      },
      secondChoice: {
        type: "object",
        additionalProperties: false,
        required: ["shape", "confidence"],
        properties: {
          shape: enumOf(TURN_PLAN_SHAPES),
          confidence: { type: "number" }
        },
        description: describe("secondChoice")
      }
    }
  };
}

// src/turn-plan/turn-plan.normalize.ts
function capString(value, max) {
  return typeof value === "string" && value.length > max ? value.slice(0, max) : value;
}
function capArray(value, max) {
  return Array.isArray(value) && value.length > max ? value.slice(0, max) : value;
}
function capStringsIn(value, maxItems, maxChars) {
  const capped = capArray(value, maxItems);
  return Array.isArray(capped) ? capped.map((item) => capString(item, maxChars)) : capped;
}
function clampUnit(value) {
  if (typeof value !== "number" || !Number.isFinite(value)) return value;
  return Math.min(1, Math.max(0, value));
}
function capMissingInput(entry) {
  if (typeof entry !== "object" || entry === null || Array.isArray(entry)) return entry;
  const row2 = entry;
  if (!("name" in row2)) return entry;
  return { ...row2, name: capString(row2.name, MAX_TURN_PLAN_NAME_CHARS) };
}
function normalizeTurnPlanInput(input) {
  if (typeof input !== "object" || input === null || Array.isArray(input)) return input;
  const raw = input;
  const out = { ...raw };
  if ("capabilityGroups" in raw) {
    out.capabilityGroups = capStringsIn(
      raw.capabilityGroups,
      MAX_TURN_PLAN_CAPABILITY_GROUPS,
      MAX_TURN_PLAN_GROUP_CHARS
    );
  }
  if ("entities" in raw) {
    out.entities = capStringsIn(raw.entities, MAX_TURN_PLAN_ENTITIES, MAX_TURN_PLAN_ENTITY_CHARS);
  }
  if ("offers" in raw) out.offers = capArray(raw.offers, MAX_TURN_PLAN_OFFERS);
  if ("missingInputs" in raw) {
    const capped = capArray(raw.missingInputs, MAX_TURN_PLAN_MISSING_INPUTS);
    out.missingInputs = Array.isArray(capped) ? capped.map(capMissingInput) : capped;
  }
  if ("templateId" in raw) out.templateId = capString(raw.templateId, MAX_TURN_PLAN_NAME_CHARS);
  if ("confidence" in raw) out.confidence = clampUnit(raw.confidence);
  if ("scopeConfidence" in raw) out.scopeConfidence = clampUnit(raw.scopeConfidence);
  if ("secondChoice" in raw && typeof raw.secondChoice === "object" && raw.secondChoice !== null && !Array.isArray(raw.secondChoice)) {
    const second = raw.secondChoice;
    if ("confidence" in second) {
      out.secondChoice = { ...second, confidence: clampUnit(second.confidence) };
    }
  }
  return out;
}

// src/turn-plan/turn-plan-prediction.ts
var NO_CAPABILITY = "none";
function toTurnPlanPrediction(plan) {
  return {
    scope: plan.scope,
    intent: plan.intent,
    shape: plan.shape,
    askFirst: plan.askFirst,
    capabilityOrNone: plan.capabilityGroups[0] ?? NO_CAPABILITY,
    confidence: plan.confidence,
    scopeConfidence: plan.scopeConfidence,
    ...plan.templateId !== void 0 ? { templateId: plan.templateId } : {},
    ...plan.secondChoice !== void 0 ? { secondChoice: plan.secondChoice } : {}
  };
}

// src/turn-plan/shape-table.types.ts
var SHAPE_MECHANISMS = ["M0", "M1", "M2", "M3", "M4"];
var RTL_ACCEPTANCES = [
  /** Every rule the shape draws with is logical (`apps/widget/src/rtl.test.tsx`). */
  "logical-properties",
  /** Reading order mirrors: a table's columns, a card row, a step list. */
  "mirrored-order",
  /** A signed delta keeps DIRECTION and POLARITY under mirroring (`Delta`). */
  "delta-direction",
  /** The shape's container never widens the transcript at phone width. */
  "no-overflow",
  /** The shape draws nothing of its own — server-composed text only. */
  "none"
];
var PROSE_BUDGETS = [
  /** One sentence. A navigation, a sign-in, a refusal. */
  "one-sentence",
  /** Two to four sentences. The default text answer. */
  "two-to-four-sentences",
  /** A short paragraph. A comparison verdict, a detail summary. */
  "short-paragraph",
  /** Numbered steps. A teaching turn. */
  "steps",
  /** A caption over something rendered — one line, no restatement of the data. */
  "caption"
];
var OUTPUT_CEILING_TOKENS = 4096;

// src/turn-plan/comparison-trigger.ts
var COMPARISON_TRIGGER = { minEntities: 2, maxEntities: 4 };
function applyComparisonTrigger(intent, shape, entityCount) {
  if (intent !== "compare") return shape;
  return entityCount >= COMPARISON_TRIGGER.minEntities && entityCount <= COMPARISON_TRIGGER.maxEntities ? "comparison" : "text";
}

// src/turn-plan/shape-table.templates.ts
var SHAPE_TEMPLATE = {
  comparison: "comparison",
  detail: "overview",
  metric_strip: "status_report",
  table: "list_with_summary",
  card_grid: "list_with_summary"
};
function templateForShape(shape) {
  return SHAPE_TEMPLATE[shape];
}

// src/turn-plan/shape-table.ts
function row(mechanism, realizedAs, outputBudgetTokens, proseBudget, rtlAcceptance, completesWith) {
  return {
    mechanism,
    realizedAs,
    outputBudgetTokens,
    proseBudget,
    rtlAcceptance,
    ...completesWith !== void 0 ? { completesWith } : {}
  };
}
var SHAPE_TABLE = {
  // Prose. The whole output is what the visitor reads, so the cap is real.
  text: row("M3", "informational", 250, "two-to-four-sentences", ["none"]),
  text_with_chips: row("M3", "informational", 350, "two-to-four-sentences", ["none"]),
  // Rendered data. The model emits the payload on M3, so the cap is the ceiling
  // until P1-D2 forces the call and the server captions it.
  detail: row("M2", "detail", OUTPUT_CEILING_TOKENS, "caption", ["mirrored-order"], "render_view"),
  table: row(
    "M2",
    "table",
    OUTPUT_CEILING_TOKENS,
    "caption",
    ["mirrored-order", "no-overflow"],
    "render_view"
  ),
  card_grid: row(
    "M2",
    "card_grid",
    OUTPUT_CEILING_TOKENS,
    "caption",
    ["mirrored-order"],
    "render_view"
  ),
  chart: row(
    "M2",
    "chart",
    OUTPUT_CEILING_TOKENS,
    "caption",
    ["mirrored-order", "delta-direction"],
    "render_chart"
  ),
  metric_strip: row(
    "M2",
    "metric_strip",
    OUTPUT_CEILING_TOKENS,
    "caption",
    ["delta-direction"],
    "render_metric"
  ),
  // A comparison realizes as a composition until the template id rides on the
  // plan (P4) — `TURN_SHAPES`' own note at the member, not a second opinion.
  comparison: row(
    "M2",
    "composition",
    OUTPUT_CEILING_TOKENS,
    "short-paragraph",
    ["mirrored-order", "delta-direction", "no-overflow"],
    "present_composition"
  ),
  composition: row(
    "M2",
    "composition",
    OUTPUT_CEILING_TOKENS,
    "caption",
    ["mirrored-order", "no-overflow"],
    "present_composition"
  ),
  // Asking. The card is the output; the prose above it is one line.
  //
  // `question_card` is the one shape § 2.3 lists under TWO mechanisms — M1
  // "from an intake spec" and M2 "→ `gather_inputs`" — and which one it takes
  // is a fact about the workspace rather than about the shape: with a spec the
  // server composes the opening card and the model enters afterwards, without
  // one the model asks and the call is forced. In P1 no workspace has a spec —
  // `PlanTurnSurface.declaredTemplates` is empty on every turn and says so at
  // its own declaration, because the dossier is P2 — so the row is M2 and M1
  // claims it back when P2 ships the spec.
  question_card: row(
    "M2",
    "question_card",
    1200,
    "one-sentence",
    ["logical-properties", "mirrored-order"],
    "gather_inputs"
  ),
  form: row("M1", "form", 1200, "one-sentence", ["logical-properties", "mirrored-order"]),
  funnel: row("M1", "funnel", 1500, "one-sentence", ["logical-properties", "mirrored-order"]),
  // Page acts. The visitor is left looking at THEIR page, so the realized shape
  // is what the trace can see rather than what we wish it could.
  walkthrough: row("M3", "informational", 1500, "steps", ["logical-properties"]),
  // P5-D — 450, re-derived from `cost_events`. It was 200 against a MEASURED
  // p99 of 342 and a max of 349 (`shape-output-measured.ts`), so it cut every
  // navigate turn between its p90 and its p99.
  navigate: row("M0", "navigate", 450, "one-sentence", ["none"]),
  component: row("M3", "composition", 1200, "caption", ["logical-properties"]),
  file: row("M3", "informational", 400, "one-sentence", ["none"]),
  confirm_action: row("M3", "informational", 600, "one-sentence", ["logical-properties"]),
  // Terminal — and the comment that stood here said "the server composes the
  // sentence; the model is not consulted", which the measurement REFUTES.
  // `m0ComposerFor` has no production caller (it says so at its own
  // declaration), so the MODEL still emits these calls and pays for their
  // serialized arguments. That is exactly the failure this table's own header
  // warns about for render captions, arriving on the two rows nobody re-read.
  //
  // P5-D — 500 against a measured p50 of 245, p99 374, max 378: the old 150 sat
  // below the MEDIAN observed call. Five calls is a thin sample and the
  // direction is not in doubt.
  sign_in: row("M0", "sign_in", 500, "one-sentence", ["none"]),
  // Left at 200: a refusal turn calls no tool, so the proxy cannot see one and
  // there is no measurement to move it with. A number changed on a neighbour's
  // evidence is a guess wearing a measurement's clothes.
  refusal: row("M0", "refusal", 200, "one-sentence", ["none"])
};
var TURN_PLAN_SHAPE_BLOCK_CLASS = {
  detail: "data",
  table: "data",
  card_grid: "data",
  metric_strip: "data",
  chart: "viz",
  comparison: "layout",
  composition: "layout"
};
var INTENT_OVERRIDES = {
  teach_how_to: {
    text: { outputBudgetTokens: 700, proseBudget: "steps" },
    text_with_chips: { outputBudgetTokens: 700, proseBudget: "steps" }
  }
};
var NARROWED_SHAPE = "text";
function resolveShapeRow(intent, shape, overrides) {
  const banned = overrides?.bannedClasses ?? [];
  const blockClass = TURN_PLAN_SHAPE_BLOCK_CLASS[shape];
  const effective = blockClass !== void 0 && banned.includes(blockClass) ? NARROWED_SHAPE : shape;
  return {
    shape: effective,
    ...SHAPE_TABLE[effective],
    ...INTENT_OVERRIDES[intent]?.[effective] ?? {}
  };
}
function realizedShapeFor(shape) {
  return SHAPE_TABLE[shape].realizedAs;
}

// src/turn-plan/shape-output-measured.ts
var SHAPE_OUTPUT_MEASURED_ON = "2026-09-12";
var SHAPE_OUTPUT_MEASURED = {
  // proxy: `text (no tool call)` — 2 of these 261 calls ended AT 4,096, i.e.
  // were truncated by the leg ceiling. This is the shape § 2.9 asked us to name.
  text: { turns: 395, calls: 261, p50: 177, p90: 347, p99: 1207, max: 4096 },
  text_with_chips: { turns: 395, calls: 261, p50: 177, p90: 347, p99: 1207, max: 4096 },
  // proxy: `asking (gather_inputs)`
  question_card: { turns: 19, calls: 41, p50: 225, p90: 639, p99: 679, max: 679 },
  form: { turns: 19, calls: 41, p50: 225, p90: 639, p99: 679, max: 679 },
  // proxy: `guidance (start_walkthrough)`
  walkthrough: { turns: 4, calls: 9, p50: 271, p90: 543, p99: 548, max: 548 },
  // proxy: `registered component render` — ONE turn, one call. Recorded so the
  // budget is not called unmeasured, and far too thin to move a number on.
  component: { turns: 1, calls: 1, p50: 78, p90: 78, p99: 78, max: 78 },
  // proxy: `reserved (navigate_to)` — the budget was 200 against a p99 of 342.
  navigate: { turns: 11, calls: 26, p50: 90, p90: 193, p99: 342, max: 349 },
  // proxy: `reserved (needs_sign_in)` — the budget was 150 against a p50 of 245,
  // so MORE THAN HALF of the observed calls exceeded it. Five calls is a thin
  // sample and the direction is nonetheless unambiguous.
  sign_in: { turns: 2, calls: 5, p50: 245, p90: 336, p99: 374, max: 378 },
  // proxy: `reserved render (render_chart)` / `(render_metric)` / `(render_view)`.
  // Recorded for completeness; every render row sits at the ceiling, so no
  // budget decision rests on them.
  chart: { turns: 5, calls: 6, p50: 286, p90: 466, p99: 573, max: 585 },
  metric_strip: { turns: 8, calls: 24, p50: 118, p90: 146, p99: 152, max: 152 },
  detail: { turns: 5, calls: 10, p50: 281, p90: 860, p99: 885, max: 888 }
};
var SHAPE_OUTPUT_BUDGET_BELOW_MEASURED = {
  text: "\xA7 2.6's brevity intent \u2014 'a text answer \u2264 250 unless the plan is teach_how_to'. The measured p99 of 1,207 describes UNPLANNED turns, where nothing bounded the answer and no shape directive asked for two-to-four sentences. The AFTER read is what says whether 250 is right once both are in force.",
  text_with_chips: "Same \xA7 2.6 intent as `text`, one step looser at 350."
};

// src/turn-plan/render-shapes.ts
var ASKING_TOOL = "gather_inputs";
var RENDER_SHAPES = TURN_PLAN_SHAPES.filter((shape) => {
  const row2 = SHAPE_TABLE[shape];
  return row2.mechanism === "M2" && row2.completesWith !== ASKING_TOOL;
});
var RENDERING = new Set(RENDER_SHAPES);
function isRenderShape(shape) {
  return shape !== void 0 && RENDERING.has(shape);
}

// src/turn-plan/asking-shapes.ts
var ASKING_SHAPES = ["question_card", "form", "funnel"];
var ASKING = new Set(ASKING_SHAPES);
function isAskingShape(shape) {
  return shape !== void 0 && ASKING.has(shape);
}
var GATHERING_TOOL = "gather_inputs";
function planGathersInput(plan) {
  if (plan === void 0) return false;
  return plan.askFirst || plan.missingInputs.length > 0 || isAskingShape(plan.shape);
}
Object.entries(SHAPE_TABLE).filter(([, row2]) => row2.completesWith === GATHERING_TOOL).map(([shape]) => shape);

// src/turn-plan/mechanism-ladder.ts
var PLAN_ACT_FLOOR = 0.5;
var PLAN_HIGH_CONFIDENCE = 0.8;
var NOTHING = [];
var NARROWING = ["M3", "M4"];
var EVERYTHING = SHAPE_MECHANISMS;
function admittedMechanisms(plan) {
  if (plan === void 0) return NOTHING;
  if (plan.confidence >= PLAN_HIGH_CONFIDENCE) return EVERYTHING;
  if (plan.confidence >= PLAN_ACT_FLOOR) return NARROWING;
  return NOTHING;
}
function admitsMechanism(plan, mechanism) {
  return admittedMechanisms(plan).includes(mechanism);
}
function planIsActionable(plan) {
  return plan !== void 0 && plan.confidence >= PLAN_ACT_FLOOR;
}

// src/turn-plan/m0-dispatch.ts
var M0_COMPOSERS = ["navigate", "sign-in", "contact-request", "refusal"];
var COMPOSER_BY_SHAPE = {
  navigate: "navigate",
  sign_in: "sign-in",
  refusal: "refusal"
};
function m0ComposerFor(plan) {
  if (plan === void 0 || !admitsMechanism(plan, "M0")) return void 0;
  if (plan.intent === "contact_request") return "contact-request";
  if (SHAPE_TABLE[plan.shape].mechanism !== "M0") return void 0;
  return COMPOSER_BY_SHAPE[plan.shape];
}

// src/turn-plan/m2-force.ts
var M2_FALLBACK_REASONS = [
  /** The operator killed the force. Pre-P1-D2 behaviour, by choice. */
  "disabled",
  /** The shape's row is not an M2 row — there is no tool to force. */
  "shape",
  /** The shape's tool is not among the ones THIS turn advertised. */
  "not-advertised",
  /** § 2.3's ladder does not admit M2 for this plan (or there is no plan). */
  "confidence",
  /** The model serving this turn is not one § 2.3 admits for forcing. */
  "provider",
  /** Nothing to lay out: no read has landed in this turn's window. */
  "no-data",
  /** The read cannot be ordered or filtered server-side (§ 2.3's caption rule). */
  "unorderable"
];
var M2_FORCING_MODEL_PREFIXES = ["anthropic:", "bedrock-eu:"];
var M2_ORDER_SENSITIVE_SHAPES = [
  "table",
  "card_grid",
  "chart",
  "comparison"
];
function fallback(reason) {
  return { forced: false, fallbackTo: "M3", reason };
}
function m2ForcesOnModel(modelLabel) {
  return M2_FORCING_MODEL_PREFIXES.some((prefix) => modelLabel.startsWith(prefix));
}
function decideM2Force(input) {
  if (!input.enabled) return fallback("disabled");
  if (input.plan === void 0 || !admitsMechanism(input.plan, "M2")) {
    return fallback("confidence");
  }
  const row2 = input.row;
  const toolName = row2?.mechanism === "M2" ? row2.completesWith : void 0;
  if (row2 === void 0 || toolName === void 0) return fallback("shape");
  if (!input.advertisedTools.includes(toolName)) return fallback("not-advertised");
  if (!m2ForcesOnModel(input.modelLabel)) return fallback("provider");
  if (!input.dataInHand) return fallback("no-data");
  if (M2_ORDER_SENSITIVE_SHAPES.includes(row2.shape) && !input.orderable) {
    return fallback("unorderable");
  }
  return { forced: true, toolName };
}
var INTAKE_FIELD_KINDS = [
  "text",
  "long_text",
  "number",
  "boolean",
  "choice",
  "email",
  "date",
  "date_time"
];
var INTAKE_ASK_IF_CONDITIONS = ["absent"];
var INTAKE_CHOICE_MIN_OPTIONS = 2;
var INTAKE_CHOICE_MAX_OPTIONS = SELECT_MAX_OPTIONS;
var MAX_INTAKE_LABEL_CHARS = PRIMITIVE_LABEL_MAX;
var MAX_INTAKE_SUMMARY_CHARS = PRIMITIVE_LABEL_MAX;
var MAX_INTAKE_HELP_CHARS = 500;
var MAX_INTAKE_FIELD_NAME_CHARS = 120;
var MAX_INTAKE_DEFAULT_CHARS = 500;
var MAX_INTAKE_EXAMPLES = 3;
var MAX_INTAKE_EXAMPLE_CHARS = 120;
var INTAKE_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/u;
var INTAKE_DATE_TIME_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/u;
function intakeLocaleMap(max) {
  const text = z.string().trim().min(1).max(max);
  const shape = Object.fromEntries(LOCALE_CODES.map((code) => [code, text]));
  return z.object(shape).strict();
}
var IntakeFieldNameSchema = /* @__PURE__ */ z.string().min(1).max(MAX_INTAKE_FIELD_NAME_CHARS).regex(/^[^\s\p{C}]+$/u, "a field name carries no whitespace or control characters");
var fieldBase = {
  name: IntakeFieldNameSchema,
  label: intakeLocaleMap(MAX_INTAKE_LABEL_CHARS),
  help: intakeLocaleMap(MAX_INTAKE_HELP_CHARS).optional(),
  sensitive: z.boolean().optional(),
  askIf: z.enum(INTAKE_ASK_IF_CONDITIONS).optional(),
  inputExamples: z.array(z.string().trim().min(1).max(MAX_INTAKE_EXAMPLE_CHARS)).min(1).max(MAX_INTAKE_EXAMPLES).optional()
};
var textDefault = /* @__PURE__ */ z.string().trim().min(1).max(MAX_INTAKE_DEFAULT_CHARS);
var IntakeChoiceOptionSchema = /* @__PURE__ */ z.object({ value: SelectOptionValueSchema, label: intakeLocaleMap(MAX_INTAKE_LABEL_CHARS) }).strict();
var IntakeFieldShapeSchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  z.object({ ...fieldBase, kind: z.literal("text"), default: textDefault.optional() }).strict(),
  z.object({ ...fieldBase, kind: z.literal("long_text"), default: textDefault.optional() }).strict(),
  z.object({ ...fieldBase, kind: z.literal("number"), default: z.number().finite().optional() }).strict(),
  z.object({ ...fieldBase, kind: z.literal("boolean"), default: z.boolean().optional() }).strict(),
  z.object({
    ...fieldBase,
    kind: z.literal("choice"),
    options: z.array(IntakeChoiceOptionSchema).min(INTAKE_CHOICE_MIN_OPTIONS).max(INTAKE_CHOICE_MAX_OPTIONS),
    default: SelectOptionValueSchema.optional()
  }).strict(),
  z.object({ ...fieldBase, kind: z.literal("email"), default: textDefault.optional() }).strict(),
  z.object({
    ...fieldBase,
    kind: z.literal("date"),
    default: z.string().regex(INTAKE_DATE_PATTERN).optional()
  }).strict(),
  z.object({
    ...fieldBase,
    kind: z.literal("date_time"),
    default: z.string().regex(INTAKE_DATE_TIME_PATTERN).optional()
  }).strict()
]);
var IntakeFieldSchema = IntakeFieldShapeSchema.superRefine((field, ctx) => {
  const refuse = (path, message, code) => {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: [path], message, params: { code } });
  };
  if (field.sensitive === true) {
    if (field.default !== void 0) {
      refuse(
        "default",
        `sensitive field "${field.name}" cannot carry a default \u2014 a default is a value`,
        "sensitive-default"
      );
    }
    if (field.inputExamples !== void 0) {
      refuse(
        "inputExamples",
        `sensitive field "${field.name}" cannot carry examples \u2014 an example is a value`,
        "sensitive-example"
      );
    }
  }
  if (field.kind !== "choice") return;
  const values = /* @__PURE__ */ new Set();
  for (const option of field.options) {
    if (values.has(option.value)) {
      refuse("options", `duplicate option value "${option.value}"`, "option-value-duplicate");
    }
    values.add(option.value);
  }
  if (field.default !== void 0 && !values.has(field.default)) {
    refuse("default", `default "${field.default}" is not one of the options`, "default-not-option");
  }
});
function discriminatorOptionKeys(field) {
  if (field.kind === "choice") {
    return field.options.map((option) => normalizeBranchKey(option.value));
  }
  if (field.kind === "boolean") return ["true", "false"];
  return null;
}
function validateIntakeSpecTree(spec, ctx) {
  const stepIds = /* @__PURE__ */ new Set();
  const fieldNames = /* @__PURE__ */ new Set();
  let totalSteps = 0;
  let totalFields = 0;
  const issue = (code, message) => {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["steps"], message, params: { code } });
  };
  const walkStep = (step, depth) => {
    totalSteps += 1;
    totalFields += step.fields.length;
    if (stepIds.has(step.id)) issue("duplicate-step-id", `duplicate step id "${step.id}"`);
    stepIds.add(step.id);
    for (const field of step.fields) {
      if (fieldNames.has(field.name)) {
        issue(
          "duplicate-field-name",
          `duplicate field name "${field.name}" \u2014 values merge into one flat submission`
        );
      }
      fieldNames.add(field.name);
    }
    const { branch } = step;
    if (branch === void 0) return;
    if (depth >= FLOW_MAX_BRANCH_DEPTH) {
      issue(
        "branch-too-deep",
        `step "${step.id}" branches at depth ${String(depth)}, past the maximum of ${String(FLOW_MAX_BRANCH_DEPTH)}`
      );
    }
    const discriminator = step.fields.find((field) => field.name === branch.field);
    let optionKeys = [];
    if (discriminator === void 0) {
      issue(
        "branch-field-missing",
        `branch on step "${step.id}" names "${branch.field}", which is not a field of that step`
      );
    } else {
      const keys = discriminatorOptionKeys(discriminator);
      if (keys === null) {
        issue(
          "branch-field-not-closed",
          `branch on step "${step.id}" names "${branch.field}" of kind "${discriminator.kind}" \u2014 a discriminator is a choice or a boolean`
        );
      } else {
        optionKeys = keys;
      }
    }
    const claimed = /* @__PURE__ */ new Set();
    for (const branchCase of branch.cases) {
      for (const value of branchCase.values) {
        const key = normalizeBranchKey(value);
        if (optionKeys.length > 0 && !optionKeys.includes(key)) {
          issue(
            "branch-case-value-unknown",
            `branch case value "${value}" on step "${step.id}" is not an option of "${branch.field}"`
          );
        }
        if (claimed.has(key)) {
          issue(
            "branch-case-value-duplicate",
            `branch case value "${value}" on step "${step.id}" appears in more than one case`
          );
        }
        claimed.add(key);
      }
    }
    if (branch.default === void 0) {
      const uncovered = optionKeys.filter((option) => !claimed.has(option));
      if (uncovered.length > 0) {
        issue(
          "branch-uncovered",
          `branch on step "${step.id}" has no default and does not cover: ${uncovered.join(", ")}`
        );
      }
    }
    for (const branchCase of branch.cases) {
      for (const child of branchCase.steps) walkStep(child, depth + 1);
    }
    for (const child of branch.default ?? []) walkStep(child, depth + 1);
  };
  for (const step of spec.steps) walkStep(step, 0);
  const longestPath = (steps) => {
    let total = 0;
    for (const step of steps) {
      let deepest = 0;
      if (step.branch !== void 0) {
        for (const branchCase of step.branch.cases) {
          deepest = Math.max(deepest, longestPath(branchCase.steps));
        }
        deepest = Math.max(deepest, longestPath(step.branch.default ?? []));
      }
      total += 1 + deepest;
    }
    return total;
  };
  const pathLength = longestPath(spec.steps);
  if (pathLength > FLOW_MAX_STEPS) {
    issue(
      "path-too-long",
      `the longest path is ${String(pathLength)} steps, past the ${String(FLOW_MAX_STEPS)} a visitor may walk`
    );
  }
  if (totalSteps > FLOW_MAX_TOTAL_STEPS) {
    issue(
      "too-many-steps",
      `${String(totalSteps)} steps in total, past the maximum of ${String(FLOW_MAX_TOTAL_STEPS)}`
    );
  }
  if (totalFields > FLOW_MAX_TOTAL_FIELDS) {
    issue(
      "too-many-fields",
      `${String(totalFields)} fields in total, past the maximum of ${String(FLOW_MAX_TOTAL_FIELDS)}`
    );
  }
}

// src/intake-spec/intake-spec.schema.ts
var INTAKE_SPEC_VERSION = 1;
var INTAKE_STEP_ID_PATTERN = /^[a-z][a-z0-9_-]{0,63}$/u;
var IntakeStepSchema = /* @__PURE__ */ z.lazy(
  () => z.object({
    id: z.string().regex(INTAKE_STEP_ID_PATTERN),
    title: intakeLocaleMap(MAX_INTAKE_LABEL_CHARS).optional(),
    fields: z.array(IntakeFieldSchema).min(1).max(FLOW_MAX_FIELDS_PER_STEP),
    branch: z.object({
      field: IntakeFieldNameSchema,
      cases: z.array(
        z.object({
          values: z.array(SelectOptionValueSchema).min(1).max(SELECT_MAX_OPTIONS),
          steps: z.array(IntakeStepSchema).max(FLOW_MAX_STEPS)
        }).strict()
      ).min(1).max(FLOW_MAX_BRANCH_CASES),
      default: z.array(IntakeStepSchema).max(FLOW_MAX_STEPS).optional()
    }).strict().optional()
  }).strict()
);
var IntakeSpecSchema = /* @__PURE__ */ z.object({
  version: z.literal(INTAKE_SPEC_VERSION),
  /** One sentence naming what the funnel collects — the composed flow's title. */
  summary: intakeLocaleMap(MAX_INTAKE_SUMMARY_CHARS),
  steps: z.array(IntakeStepSchema).min(1).max(FLOW_MAX_STEPS)
}).strict().superRefine(validateIntakeSpecTree);
function parseIntakeSpec(value) {
  const parsed = IntakeSpecSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}

// src/capability-dossier/capability-dossier-parts.ts
var CAPABILITY_DOSSIER_TEXT_MAX = 400;
var CAPABILITY_DOSSIER_WORD_MAX = 80;
var CAPABILITY_DOSSIER_PROMPT_MAX = 200;
var CAPABILITY_DOSSIER_FIELD_NAME_MAX = 128;
var CAPABILITY_DOSSIER_ENUM_VALUE_MAX = 64;
var CAPABILITY_DOSSIER_MATCH_PHRASE_MAX = 120;
var MAX_CAPABILITY_DOSSIER_TEMPLATES = 12;
var MAX_CAPABILITY_DOSSIER_FOLLOW_UPS = 6;
var MAX_CAPABILITY_DOSSIER_ENUMS = 12;
var MAX_CAPABILITY_DOSSIER_ENUM_VALUES = 24;
var MAX_CAPABILITY_DOSSIER_FIELDS = 24;
function localizedWords(max) {
  const word = z.string().min(1).max(max);
  return z.object({ en: word, es: word, fr: word, de: word, ar: word, he: word }).strict();
}
var CapabilityDossierWordsSchema = localizedWords(CAPABILITY_DOSSIER_WORD_MAX);
var UNIT_DIRECTIONS = ["higher_is_better", "lower_is_better", "neutral"];
var ARGUMENT_EXAMPLE_PROVENANCES = ["synthetic", "operator"];
var CAPABILITY_DOSSIER_SLUG_PATTERN = /^[a-z][a-z0-9_-]{0,63}$/;
var capabilityDossierFieldName = /* @__PURE__ */ z.string().min(1).max(CAPABILITY_DOSSIER_FIELD_NAME_MAX);
var capabilityDossierGuidanceText = /* @__PURE__ */ z.string().min(1).max(CAPABILITY_DOSSIER_TEXT_MAX);
var slug = /* @__PURE__ */ z.string().regex(CAPABILITY_DOSSIER_SLUG_PATTERN);
var CapabilityDossierUsageGuidanceSchema = /* @__PURE__ */ z.object({ when: capabilityDossierGuidanceText, whenNot: capabilityDossierGuidanceText }).strict();
var CapabilityDossierTemplateSchema = /* @__PURE__ */ z.object({
  id: slug,
  label: CapabilityDossierWordsSchema,
  /** Argument names the template does NOT fix — what the funnel still asks. */
  leavesOpen: z.array(capabilityDossierFieldName).max(MAX_CAPABILITY_DOSSIER_FIELDS),
  /** Phrases a visitor might use that select this template. */
  matchPhrases: z.array(z.string().min(1).max(CAPABILITY_DOSSIER_MATCH_PHRASE_MAX)).max(MAX_CAPABILITY_DOSSIER_FIELDS)
}).strict();
var CapabilityDossierRecoveredEnumSchema = /* @__PURE__ */ z.object({
  argument: capabilityDossierFieldName,
  values: z.array(z.string().min(1).max(CAPABILITY_DOSSIER_ENUM_VALUE_MAX)).min(1).max(MAX_CAPABILITY_DOSSIER_ENUM_VALUES)
}).strict();
var CapabilityDossierArgumentExampleSchema = CapabilityExampleSchema.extend({
  provenance: z.enum(ARGUMENT_EXAMPLE_PROVENANCES)
}).strict();
var CapabilityDossierUnitDirectionSchema = /* @__PURE__ */ z.object({
  field: capabilityDossierFieldName,
  unit: z.string().min(1).max(32).nullable(),
  direction: z.enum(UNIT_DIRECTIONS)
}).strict();
var CapabilityDossierFollowUpSchema = /* @__PURE__ */ z.object({
  id: slug,
  label: CapabilityDossierWordsSchema,
  prompt: localizedWords(CAPABILITY_DOSSIER_PROMPT_MAX)
}).strict();
var CapabilityDossierDisplayWordsSchema = /* @__PURE__ */ z.object({ name: CapabilityDossierWordsSchema, objectNoun: CapabilityDossierWordsSchema }).strict();
var CapabilityDossierIntakeRecordSchema = IntakeSpecSchema;

// src/capability-dossier/capability-dossier.ts
var CapabilityDossierSchema = /* @__PURE__ */ z.object({
  // Group 1 — its own table, chat only.
  intake: CapabilityDossierIntakeRecordSchema.nullable(),
  templates: z.array(CapabilityDossierTemplateSchema).max(MAX_CAPABILITY_DOSSIER_TEMPLATES),
  preferredShape: z.enum(TURN_PLAN_SHAPES).nullable(),
  comparable: z.boolean(),
  keyFields: z.array(capabilityDossierFieldName).max(MAX_CAPABILITY_DOSSIER_FIELDS),
  imageField: capabilityDossierFieldName.nullable(),
  unitDirections: z.array(CapabilityDossierUnitDirectionSchema).max(MAX_CAPABILITY_DOSSIER_FIELDS),
  sortableBy: z.array(capabilityDossierFieldName).max(MAX_CAPABILITY_DOSSIER_FIELDS),
  filterableBy: z.array(capabilityDossierFieldName).max(MAX_CAPABILITY_DOSSIER_FIELDS),
  followUps: z.array(CapabilityDossierFollowUpSchema).max(MAX_CAPABILITY_DOSSIER_FOLLOW_UPS),
  displayWords: CapabilityDossierDisplayWordsSchema.nullable(),
  // Group 2 — the tools array, chat AND MCP, through the guidance channel.
  usageGuidance: CapabilityDossierUsageGuidanceSchema.nullable(),
  disambiguation: capabilityDossierGuidanceText.nullable(),
  argumentExamples: z.array(CapabilityDossierArgumentExampleSchema).max(MAX_CAPABILITY_EXAMPLES),
  recoveredEnums: z.array(CapabilityDossierRecoveredEnumSchema).max(MAX_CAPABILITY_DOSSIER_ENUMS)
}).strict();
var EMPTY_CAPABILITY_DOSSIER = Object.freeze({
  intake: null,
  templates: [],
  preferredShape: null,
  comparable: false,
  keyFields: [],
  imageField: null,
  unitDirections: [],
  sortableBy: [],
  filterableBy: [],
  followUps: [],
  displayWords: null,
  usageGuidance: null,
  disambiguation: null,
  argumentExamples: [],
  recoveredEnums: []
});
var CAPABILITY_DOSSIER_CHAT_ONLY_FIELDS = [
  "intake",
  "templates",
  "preferredShape",
  "comparable",
  "keyFields",
  "imageField",
  "unitDirections",
  "sortableBy",
  "filterableBy",
  "followUps",
  "displayWords"
];
var CAPABILITY_DOSSIER_TOOL_FIELDS = [
  "usageGuidance",
  "disambiguation",
  "argumentExamples",
  "recoveredEnums"
];
var DOSSIER_FIELDS = /* @__PURE__ */ new Set([
  ...CAPABILITY_DOSSIER_CHAT_ONLY_FIELDS,
  ...CAPABILITY_DOSSIER_TOOL_FIELDS
]);
function isCapabilityDossierField(value) {
  return DOSSIER_FIELDS.has(value);
}
var CAPABILITY_DOSSIER_GUIDANCE_CLAUSE_KINDS = [
  "usage",
  "disambiguation",
  "enums",
  "examples"
];
var CAPABILITY_DOSSIER_GUIDANCE_WEIGHT_BASE = GUIDANCE_WEIGHT_MAX + 1;
var CAPABILITY_DOSSIER_GUIDANCE_MAX = 1200;

// src/capability-dossier/capability-dossier-groups.ts
var CAPABILITY_DOSSIER_GROUPS = [
  "intake",
  "templates",
  "displayWords",
  "followUps",
  "shapeHints",
  "toolFields"
];
var CAPABILITY_DOSSIER_GROUP_FIELDS = {
  /** The questions the funnel asks, in what order — P2-B's `IntakeSpec`. */
  intake: ["intake"],
  /** The phrasings the planner silently selects between. */
  templates: ["templates"],
  /** The plain name and object noun every confirm card and chip uses. */
  displayWords: ["displayWords"],
  /** The chips the server may offer after this capability ran. */
  followUps: ["followUps"],
  /** How the ANSWER is shaped — the shape table's and the caption check's input. */
  shapeHints: [
    "preferredShape",
    "comparable",
    "keyFields",
    "imageField",
    "unitDirections",
    "sortableBy",
    "filterableBy"
  ],
  /**
   * The four fields that reach the served tool DESCRIPTION, on chat AND on
   * MCP. Exactly {@link CAPABILITY_DOSSIER_TOOL_FIELDS}, and the equality is
   * asserted below rather than trusted: this is the one group whose contents
   * are a security boundary (ADR-0792), so a field drifting into it would widen
   * what a Cursor or Claude Desktop client is told.
   */
  toolFields: ["usageGuidance", "disambiguation", "argumentExamples", "recoveredEnums"]
};
var GROUP_OF = new Map(
  CAPABILITY_DOSSIER_GROUPS.flatMap(
    (group) => CAPABILITY_DOSSIER_GROUP_FIELDS[group].map(
      (field) => [field, group]
    )
  )
);
var GROUPS = new Set(CAPABILITY_DOSSIER_GROUPS);
function isCapabilityDossierGroup(value) {
  return GROUPS.has(value);
}
function capabilityDossierGroupOf(field) {
  return GROUP_OF.get(field);
}
function capabilityDossierGroupsOf(lockedFields) {
  const locked = new Set(lockedFields);
  return CAPABILITY_DOSSIER_GROUPS.filter(
    (group) => CAPABILITY_DOSSIER_GROUP_FIELDS[group].some((field) => locked.has(field))
  );
}
var _fieldCount = CAPABILITY_DOSSIER_GROUPS.reduce(
  (total, group) => total + CAPABILITY_DOSSIER_GROUP_FIELDS[group].length,
  0
);
if (_fieldCount !== GROUP_OF.size || _fieldCount !== CAPABILITY_DOSSIER_CHAT_ONLY_FIELDS.length + CAPABILITY_DOSSIER_TOOL_FIELDS.length) {
  throw new Error("capability dossier groups do not partition the record");
}
var DraftIntakeFieldSchema = /* @__PURE__ */ z.object({
  name: IntakeFieldNameSchema,
  kind: z.enum(INTAKE_FIELD_KINDS),
  label: intakeLocaleMap(MAX_INTAKE_LABEL_CHARS),
  help: intakeLocaleMap(MAX_INTAKE_HELP_CHARS).optional(),
  /**
   * The model may only ever mark a field sensitive, which NARROWS what the
   * funnel does with it (a sensitive field refuses a default and examples,
   * and the composer masks it). A mark it gets wrong costs a pre-fill; a mark
   * it cannot make would cost a password in a stored spec.
   */
  sensitive: z.boolean().optional(),
  askIf: z.enum(INTAKE_ASK_IF_CONDITIONS).optional(),
  options: z.array(IntakeChoiceOptionSchema).min(INTAKE_CHOICE_MIN_OPTIONS).max(INTAKE_CHOICE_MAX_OPTIONS).optional(),
  inputExamples: z.array(z.string().trim().min(1).max(MAX_INTAKE_EXAMPLE_CHARS)).min(1).max(MAX_INTAKE_EXAMPLES).optional(),
  /**
   * UNTYPED here on purpose — the mapper types it against `kind` and drops it
   * when the two disagree, so one bad default costs that default rather than
   * the whole answer. `IntakeFieldSchema`'s discriminated union is still the
   * authority; this is the shape that reaches it.
   */
  default: z.union([z.string(), z.number(), z.boolean()]).optional()
}).strict();
var DraftIntakeStepSchema = /* @__PURE__ */ z.object({
  id: z.string().regex(INTAKE_STEP_ID_PATTERN),
  title: intakeLocaleMap(MAX_INTAKE_LABEL_CHARS).optional(),
  fields: z.array(DraftIntakeFieldSchema).min(1).max(FLOW_MAX_FIELDS_PER_STEP)
}).strict();
var DraftIntakeSchema = /* @__PURE__ */ z.object({
  summary: intakeLocaleMap(MAX_INTAKE_SUMMARY_CHARS),
  steps: z.array(DraftIntakeStepSchema).min(1).max(FLOW_MAX_STEPS)
}).strict();

// src/capability-dossier/capability-dossier-draft.ts
var CAPABILITY_DOSSIER_TOOL_NAME = "draft_capability_dossier";
var CAPABILITY_DOSSIER_RESULT_SHAPES = [
  "table",
  "card_grid",
  "detail",
  "metric_strip",
  "comparison",
  "chart",
  "text"
];
var CapabilityDossierDraftSchema = /* @__PURE__ */ z.object({
  usageGuidance: CapabilityDossierUsageGuidanceSchema,
  displayWords: CapabilityDossierDisplayWordsSchema,
  disambiguation: capabilityDossierGuidanceText.optional(),
  // `.strict()` HERE rather than on the shared example schema, which the
  // catalog's own permissive read-back also uses: the claim this refuses is a
  // model writing `provenance: 'operator'` on a value it invented, and that
  // is a fact about THIS contract. The producer stamps `synthetic` regardless,
  // so the strictness is the loud half of a guarantee the mapper already has.
  argumentExamples: z.array(CapabilityExampleSchema.strict()).max(MAX_CAPABILITY_EXAMPLES).optional(),
  recoveredEnums: z.array(CapabilityDossierRecoveredEnumSchema).max(MAX_CAPABILITY_DOSSIER_ENUMS).optional(),
  templates: z.array(CapabilityDossierTemplateSchema).max(MAX_CAPABILITY_DOSSIER_TEMPLATES).optional(),
  followUps: z.array(CapabilityDossierFollowUpSchema).max(MAX_CAPABILITY_DOSSIER_FOLLOW_UPS).optional(),
  preferredShape: z.enum(CAPABILITY_DOSSIER_RESULT_SHAPES).optional(),
  comparable: z.boolean().optional(),
  keyFields: z.array(capabilityDossierFieldName).max(MAX_CAPABILITY_DOSSIER_FIELDS).optional(),
  imageField: capabilityDossierFieldName.optional(),
  unitDirections: z.array(CapabilityDossierUnitDirectionSchema).max(MAX_CAPABILITY_DOSSIER_FIELDS).optional(),
  sortableBy: z.array(capabilityDossierFieldName).max(MAX_CAPABILITY_DOSSIER_FIELDS).optional(),
  filterableBy: z.array(capabilityDossierFieldName).max(MAX_CAPABILITY_DOSSIER_FIELDS).optional(),
  intake: DraftIntakeSchema.optional()
}).strict();

// src/capability-dossier/capability-dossier-draft-intake-map.ts
function typedDefault(field) {
  const value = field.default;
  if (value === void 0) return void 0;
  switch (field.kind) {
    case "number":
      return typeof value === "number" && Number.isFinite(value) ? value : void 0;
    case "boolean":
      return typeof value === "boolean" ? value : void 0;
    case "date":
      return typeof value === "string" && INTAKE_DATE_PATTERN.test(value) ? value : void 0;
    case "date_time":
      return typeof value === "string" && INTAKE_DATE_TIME_PATTERN.test(value) ? value : void 0;
    case "choice":
      return typeof value === "string" ? value : void 0;
    default:
      return typeof value === "string" && value.trim() !== "" ? value : void 0;
  }
}
function mapField(field, pii) {
  const sensitive = field.sensitive === true || pii.has(field.name);
  const value = sensitive ? void 0 : typedDefault(field);
  return {
    name: field.name,
    kind: field.kind,
    label: field.label,
    ...field.help === void 0 ? {} : { help: field.help },
    ...sensitive ? { sensitive: true } : {},
    ...field.askIf === void 0 ? {} : { askIf: field.askIf },
    ...field.options === void 0 ? {} : { options: field.options },
    // A sensitive field carries neither a default nor an example — dropped HERE
    // so the schema's refusal is never reached by a spec we produced, and kept
    // as the schema's refusal so a spec from anywhere else still meets it.
    ...sensitive || field.inputExamples === void 0 ? {} : { inputExamples: field.inputExamples },
    ...value === void 0 ? {} : { default: value }
  };
}
function buildIntakeSpecFromDraft(draft, piiFields = []) {
  const pii = new Set(piiFields);
  const candidate = {
    version: INTAKE_SPEC_VERSION,
    summary: draft.summary,
    steps: draft.steps.map((step) => ({
      id: step.id,
      ...step.title === void 0 ? {} : { title: step.title },
      fields: step.fields.map((field) => mapField(field, pii))
    }))
  };
  return parseIntakeSpec(candidate);
}

// src/capability-dossier/capability-dossier-draft-tool.ts
function localeMap(max, description) {
  return {
    type: "object",
    description,
    properties: Object.fromEntries(
      LOCALE_CODES.map((code) => [code, { type: "string", minLength: 1, maxLength: max }])
    ),
    required: [...LOCALE_CODES],
    additionalProperties: false
  };
}
var names = (max, description) => ({
  type: "array",
  description,
  items: { type: "string", minLength: 1, maxLength: CAPABILITY_DOSSIER_FIELD_NAME_MAX },
  maxItems: max
});
var INTAKE_FIELD = {
  type: "object",
  properties: {
    name: {
      type: "string",
      maxLength: CAPABILITY_DOSSIER_FIELD_NAME_MAX,
      description: "The ARGUMENT KEY exactly as the capability declares it. Never translated."
    },
    kind: { type: "string", enum: [...INTAKE_FIELD_KINDS] },
    label: localeMap(MAX_INTAKE_LABEL_CHARS, "What a visitor is asked, in every locale."),
    help: localeMap(MAX_INTAKE_HELP_CHARS, "One clarifying sentence under the field, or omit."),
    sensitive: {
      type: "boolean",
      description: "True for a password, token, card number, government id or anything else that must never be stored or pre-filled. A sensitive field must carry no default and no inputExamples."
    },
    askIf: { type: "string", enum: [...INTAKE_ASK_IF_CONDITIONS] },
    options: {
      type: "array",
      description: 'REQUIRED for kind "choice": the closed value set, with a \xD76 label each.',
      minItems: INTAKE_CHOICE_MIN_OPTIONS,
      maxItems: INTAKE_CHOICE_MAX_OPTIONS,
      items: {
        type: "object",
        properties: {
          value: { type: "string", minLength: 1 },
          label: localeMap(MAX_INTAKE_LABEL_CHARS, "The option as a visitor reads it.")
        },
        required: ["value", "label"],
        additionalProperties: false
      }
    },
    inputExamples: {
      type: "array",
      description: "Up to three placeholder values. Never a real person\u2019s data.",
      items: { type: "string", maxLength: MAX_INTAKE_EXAMPLE_CHARS },
      maxItems: MAX_INTAKE_EXAMPLES
    },
    default: {
      description: "A safe default the server may apply, typed to match `kind`. Omit unless the API itself documents one."
    }
  },
  required: ["name", "kind", "label"],
  additionalProperties: false
};
var INTAKE = {
  type: "object",
  description: "The funnel this capability needs: what to ask, in what order, in the site\u2019s own words. Emit it ONLY when asked to below.",
  properties: {
    summary: localeMap(MAX_INTAKE_SUMMARY_CHARS, "One sentence naming what the funnel collects."),
    steps: {
      type: "array",
      minItems: 1,
      maxItems: FLOW_MAX_STEPS,
      items: {
        type: "object",
        properties: {
          id: { type: "string", pattern: "^[a-z][a-z0-9_-]{0,63}$" },
          title: localeMap(MAX_INTAKE_LABEL_CHARS, "The step\u2019s heading, or omit."),
          fields: {
            type: "array",
            minItems: 1,
            maxItems: FLOW_MAX_FIELDS_PER_STEP,
            items: INTAKE_FIELD
          }
        },
        required: ["id", "fields"],
        additionalProperties: false
      }
    }
  },
  required: ["summary", "steps"],
  additionalProperties: false
};
var capabilityDossierToolJsonSchema = {
  name: CAPABILITY_DOSSIER_TOOL_NAME,
  description: "Describe one capability so an assistant can choose it correctly and collect what it needs.",
  input_schema: {
    type: "object",
    properties: {
      usageGuidance: {
        type: "object",
        description: "When to use this capability and \u2014 REQUIRED \u2014 when NOT to. The negative half is what stops an assistant choosing between two near-identical tools at random, so it must name a real neighbouring case this capability does not handle.",
        properties: {
          when: { type: "string", minLength: 1, maxLength: CAPABILITY_DOSSIER_TEXT_MAX },
          whenNot: { type: "string", minLength: 1, maxLength: CAPABILITY_DOSSIER_TEXT_MAX }
        },
        required: ["when", "whenNot"],
        additionalProperties: false
      },
      displayWords: {
        type: "object",
        description: "The plain words a person would use, in EVERY locale: the action\u2019s name and the noun for the thing it acts on. These appear on confirmation cards and chips.",
        properties: {
          name: localeMap(CAPABILITY_DOSSIER_WORD_MAX, 'e.g. "Look up a refund".'),
          objectNoun: localeMap(CAPABILITY_DOSSIER_WORD_MAX, 'e.g. "refund".')
        },
        required: ["name", "objectNoun"],
        additionalProperties: false
      },
      disambiguation: {
        type: "string",
        maxLength: CAPABILITY_DOSSIER_TEXT_MAX,
        description: "One sentence separating this capability from the sibling capabilities listed in the prompt. Omit when there are none."
      },
      argumentExamples: {
        type: "array",
        maxItems: MAX_CAPABILITY_EXAMPLES,
        description: "Worked argument sets. INVENT every value \u2014 never copy one from the handler text, and never use a real name, email, phone number or identifier.",
        items: {
          type: "object",
          properties: {
            description: { type: "string", maxLength: 200 },
            args: { type: "object" }
          },
          required: ["args"],
          additionalProperties: false
        }
      },
      recoveredEnums: {
        type: "array",
        maxItems: MAX_CAPABILITY_DOSSIER_ENUMS,
        description: "Closed value sets you can read off the source for an argument whose type is open. Only when the values are stated, never guessed.",
        items: {
          type: "object",
          properties: {
            argument: { type: "string", maxLength: CAPABILITY_DOSSIER_FIELD_NAME_MAX },
            values: {
              type: "array",
              minItems: 1,
              maxItems: MAX_CAPABILITY_DOSSIER_ENUM_VALUES,
              items: { type: "string", maxLength: CAPABILITY_DOSSIER_ENUM_VALUE_MAX }
            }
          },
          required: ["argument", "values"],
          additionalProperties: false
        }
      },
      templates: {
        type: "array",
        maxItems: MAX_CAPABILITY_DOSSIER_TEMPLATES,
        description: "Common ready-made ways to use this capability. Each fixes some arguments and leaves the rest open.",
        items: {
          type: "object",
          properties: {
            id: { type: "string", pattern: "^[a-z][a-z0-9_-]{0,63}$" },
            label: localeMap(CAPABILITY_DOSSIER_WORD_MAX, "The template as a visitor reads it."),
            leavesOpen: names(
              MAX_CAPABILITY_DOSSIER_FIELDS,
              "Arguments the template does NOT fix."
            ),
            matchPhrases: {
              type: "array",
              maxItems: MAX_CAPABILITY_DOSSIER_FIELDS,
              items: { type: "string", maxLength: CAPABILITY_DOSSIER_MATCH_PHRASE_MAX }
            }
          },
          required: ["id", "label", "leavesOpen", "matchPhrases"],
          additionalProperties: false
        }
      },
      followUps: {
        type: "array",
        maxItems: MAX_CAPABILITY_DOSSIER_FOLLOW_UPS,
        description: "What a person usually wants next, as a chip they can tap.",
        items: {
          type: "object",
          properties: {
            id: { type: "string", pattern: "^[a-z][a-z0-9_-]{0,63}$" },
            label: localeMap(CAPABILITY_DOSSIER_WORD_MAX, "The chip\u2019s words."),
            prompt: localeMap(CAPABILITY_DOSSIER_PROMPT_MAX, "What tapping it sends.")
          },
          required: ["id", "label", "prompt"],
          additionalProperties: false
        }
      },
      preferredShape: {
        type: "string",
        description: "How a successful result is best presented.",
        enum: [...CAPABILITY_DOSSIER_RESULT_SHAPES]
      },
      comparable: { type: "boolean", description: "Can two results be put side by side?" },
      keyFields: names(MAX_CAPABILITY_DOSSIER_FIELDS, "Response fields a person reads first."),
      imageField: {
        type: "string",
        maxLength: CAPABILITY_DOSSIER_FIELD_NAME_MAX,
        description: "The response field holding a picture URL, when there is one."
      },
      unitDirections: {
        type: "array",
        maxItems: MAX_CAPABILITY_DOSSIER_FIELDS,
        description: "For each numeric field with a unit, which direction is better.",
        items: {
          type: "object",
          properties: {
            field: { type: "string", maxLength: CAPABILITY_DOSSIER_FIELD_NAME_MAX },
            unit: { type: ["string", "null"], maxLength: 32 },
            direction: { type: "string", enum: [...UNIT_DIRECTIONS] }
          },
          required: ["field", "unit", "direction"],
          additionalProperties: false
        }
      },
      sortableBy: names(MAX_CAPABILITY_DOSSIER_FIELDS, "Response fields results can be sorted by."),
      filterableBy: names(MAX_CAPABILITY_DOSSIER_FIELDS, "Arguments that narrow the result set."),
      intake: INTAKE
    },
    required: ["usageGuidance", "displayWords"],
    additionalProperties: false
  }
};

// src/capability-dossier/capability-dossier-draft-prompt.ts
var LOCALE_ROSTER = SUPPORTED_LOCALES.map(
  (locale) => `${locale.code} = ${locale.displayName} (${locale.nativeName})`
).join(", ");
var CAPABILITY_DOSSIER_LOCALIZATION_INSTRUCTION = `Every localized field is a COMPLETE map over these locales: ${LOCALE_ROSTER}. Fill all of them with natural, fluent text a person of that language would read \u2014 never a copy of the English, never a machine-literal rendering, never an empty string. Argument KEYS and option VALUES are machine identifiers: leave them exactly as given.`;
var CAPABILITY_DOSSIER_SYNTHETIC_INSTRUCTION = "Every example value you write is INVENTED. Never reuse an identifier, name, email, phone number, address or reference that appears anywhere in this prompt, and never write a value that could belong to a real person. Mark any field that would collect a password, token, card number or government identifier as `sensitive`, and give such a field no default and no examples.";
function formatArgs(args) {
  if (args.length === 0) return "(none)";
  return args.map((arg) => {
    const head = `${arg.name}:${arg.type}${arg.required ? "" : "?"}`;
    return arg.description === void 0 || arg.description === "" ? head : `${head} \u2014 ${arg.description}`;
  }).join("\n                  ");
}
function intakeClause(subject) {
  if (!subject.wantsIntake) {
    return [
      "Do NOT emit `intake`. This capability does not need a collection funnel, and one would put questions in front of a person who does not need to answer them."
    ];
  }
  return [
    "Emit `intake`: the funnel that collects what this capability needs, in the order a person would naturally give it. One step per coherent group; ask for a REQUIRED argument in the first step and leave optional ones for later steps. Use the site\u2019s own words rather than the argument keys, and prefer `choice` with real options over free text wherever the value set is closed."
  ];
}
function buildCapabilityDossierPrompt(subject) {
  const siblings = subject.siblings.length === 0 ? "(none \u2014 omit `disambiguation`)" : subject.siblings.map((s) => `${s.capabilityId} (${s.displayName})`).join(", ");
  return [
    `You are documenting one capability of a product so an assistant can choose it correctly and collect what it needs. Call the \`${CAPABILITY_DOSSIER_TOOL_NAME}\` tool exactly once.`,
    ``,
    CAPABILITY_DOSSIER_LOCALIZATION_INSTRUCTION,
    ``,
    CAPABILITY_DOSSIER_SYNTHETIC_INSTRUCTION,
    ``,
    ...intakeClause(subject),
    ``,
    `Capability id:    ${subject.capabilityId}`,
    `Kind:             ${subject.kind === "host-action" ? "an action the site performs in the browser" : "an API capability"}`,
    `Name:             ${subject.displayName}`,
    `What it does:     ${subject.description}`,
    `Effect:           ${subject.sideEffect ?? "unclassified \u2014 treat it as a read"}`,
    ...subject.route === void 0 ? [] : [`Route:            ${subject.route}`],
    `Arguments:        ${formatArgs(subject.args)}`,
    `Response fields:  ${formatArgs(subject.responseFields)}`,
    `Personal-data fields: ${subject.piiFields.length === 0 ? "(none declared)" : subject.piiFields.join(", ")}`,
    `Sibling capabilities: ${siblings}`
  ].join("\n");
}

// src/capability-dossier/intake-production-rule.ts
var INTAKE_READ_FILTER_THRESHOLD = 3;
function shouldProduceIntakeSpec(subject) {
  if (subject.kind === "host-action") return subject.hasParameterSchema;
  if (subject.sideEffect === "write" || subject.sideEffect === "destructive") return true;
  return subject.optionalArgumentCount > INTAKE_READ_FILTER_THRESHOLD;
}

// src/capability-dossier/select-template.ts
function selectCapabilityTemplate(input) {
  const templateId = input.templateId;
  if (templateId === void 0 || templateId === "") return { kind: "none", reason: "unnamed" };
  const matches = input.templates.filter((template2) => template2.id === templateId);
  const first = matches[0];
  if (first === void 0) return { kind: "none", reason: "no-match" };
  if (matches.length > 1) return { kind: "ambiguous", templateId, matches: matches.length };
  return { kind: "selected", template: first };
}

// src/directive-release/vocabulary.ts
var DIRECTIVE_RELEASE_KEYS = [
  /**
   * § 2.10 wave 1, row "modality exemplars" — the six deliberation examples
   * leave a PLANNED turn; the planner's few-shot pool (P1-B, migration 589) is
   * what shows the same choice being made, one stage earlier.
   */
  "retire-modality-exemplars",
  /**
   * § 2.10 wave 1, row "HOW TO HELP ladder" — the MENU, the selection LADDER
   * and the COMPOSITION grammar leave layer 2 and compose into layer 3 on a
   * fail-open turn only. The bias/safety rules and the NEXT STEPS contract are
   * NOT part of this release; see `how-to-help-directive.ts` for why.
   */
  "retire-how-to-help-shape",
  /**
   * § 2.10 wave 1, row "presentation + dashboard arbitration" — the ONE
   * sentence of the presentation directive that decides whether a turn ends in
   * a chart. Its operating half (which kind, never invent data, re-render with
   * the same points) is not under this release and never leaves.
   */
  "retire-presentation-arbitration",
  /**
   * § 2.10 wave 2, row "clarification (`ask_user_question`)" — the GATHERING
   * INPUTS directive leaves layer 2 and composes into layer 3 only on the turns
   * that can still use it: a fail-open turn, and a planned turn whose own plan
   * says it will ask. P5-F, and the first release to ramp by TENANT rather than
   * by visitor — see {@link DirectiveRelease.tenantIds} for why layer 2 cannot
   * be ramped any other way.
   */
  "retire-clarification-directive",
  /**
   * § 2.10 wave 2, row "task-guide catalog" — the published-guide slug list is
   * sent only on the intents that can reach a guide. Nothing REPLACES it: this
   * row is a conditional SEND rather than a retirement, and the block is
   * unchanged on the intents that keep it.
   */
  "retire-task-guide-catalog",
  /**
   * § 2.10 wave 2, row "page index (CS-223) + page awareness (F1-7)" — ONE
   * release over BOTH blocks, because the ledger gives them ONE condition and
   * the rule is that a wrong CONDITION is rolled back alone. Two switches for
   * one decision would leave an operator no way to undo the decision in one
   * move.
   */
  "retire-page-context",
  /**
   * § 2.10 wave 2, row "execution mode" — the act-vs-explain steer is sent only
   * on the intents it can change. Deliberately NARROWER than the ledger's row:
   * the two variants that are CONSTRAINTS rather than hints (`read_only`, the
   * workspace's "change nothing", and SYN-899's `signed_out_goal`) are sent on
   * every turn regardless of the arm — see `conditional-sends.ts`.
   */
  "retire-execution-mode"
];
function isDirectiveReleaseKey(value) {
  return DIRECTIVE_RELEASE_KEYS.includes(value);
}
var DIRECTIVE_RELEASE_STATUSES = [
  "draft",
  "ramping",
  "published",
  "paused",
  "rolled_back"
];
var RAMPING_RELEASE_STATUSES = /* @__PURE__ */ new Set([
  "ramping",
  "published"
]);
var MAX_RELEASE_TENANT_IDS = 25;

// src/directive-release/registry.ts
var DIRECTIVE_RELEASES = {
  /**
   * Cheapest signal first (§ 2.10 rule 2's ordering), and the only row of the
   * three that touches no cached layer: the exemplars are already layer 3, so
   * both arms share one prefix and a 50/50 split costs nothing but the tokens
   * it removes.
   */
  "retire-modality-exemplars": {
    key: "retire-modality-exemplars",
    version: 2,
    status: "ramping",
    rolloutPercent: 50,
    notes: "The six deliberation exemplars are absent from a planned turn; the planner few-shot pool shows the same choice one stage earlier. Roll back by setting this key to 0 if ChatShapeAdherence falls on the new arm.",
    read: 'ChatShapeAdherence by arm, plus the style scorer, plus one drive \u2014 docs/runbooks/directive-releases.md "Reading a ramp".'
  },
  /**
   * One sentence, and it leaves a cached layer — so a second prefix, which is
   * why it is not at 100 on day one. The operating half of the directive (which
   * chart kind, never invent data, re-render with the same points) is NOT part
   * of this release and is still sent on every turn.
   */
  "retire-presentation-arbitration": {
    key: "retire-presentation-arbitration",
    version: 2,
    status: "ramping",
    rolloutPercent: 50,
    notes: "The presentation directive no longer tells a planned turn to end in a chart; the shape table does. Roll back by setting this key to 0 if chart-shaped turns stop rendering.",
    read: 'ChatShapeAdherence by arm, restricted to chart-shaped plans, plus one drive \u2014 docs/runbooks/directive-releases.md "Reading a ramp".'
  },
  /**
   * The ≈ 3,140-token row, ramped last and slowest per § 2.10 rule 2. Ten
   * percent is a readable arm on fleet volumes and one extra cached prefix per
   * busy tenant rather than a second full one.
   */
  "retire-how-to-help-shape": {
    key: "retire-how-to-help-shape",
    version: 2,
    status: "ramping",
    rolloutPercent: 10,
    notes: "The HOW TO HELP menu, ladder and composition grammar leave layer 2 and compose into layer 3 on a fail-open turn only. The bias/safety rules and the NEXT STEPS contract are unchanged. Roll back by setting this key to 0.",
    read: "ChatShapeAdherence by arm, plus the style scorer, plus one drive; watch cache writes per turn on a busy tenant while two prefixes are live \u2014 docs/runbooks/directive-releases.md."
  },
  /**
   * # Wave 2 (§ 2.10, P5-G) — every row ships at 0 %, and that is the GATE
   *
   * § 3.5 reads a release's A/B on `ChatShapeAdherence`, the style scorer and
   * one drive. P1 is not deployed (P5-A: production is at migration 587 and
   * `turn_plans` does not exist there), so wave 1's PRODUCTION readings do not
   * exist yet and neither does the baseline wave 2 would be read against. A
   * release ramped before its baseline exists IS the "no block is removed on
   * reasoning alone" that sentence refuses.
   *
   * So each row below ships at 0 % — the arm is empty, and the prompt is
   * byte-identical to today's for every visitor until an operator says otherwise.
   *
   * `ramping` at 0 rather than `draft`, and the difference is not cosmetic.
   * `rollout-overrides.ts` calls 0 the PAUSE: the status is the OUTER gate, so a
   * `draft` row serves nobody at any percentage and `CHAT_DIRECTIVE_RELEASE_ROLLOUTS`
   * cannot start it — ramping it would need a code deploy, which is the one thing
   * a release exists to avoid. `ramping` at 0 is off for everyone AND startable
   * from the environment, which is what "the operator ramps each one after the
   * deploy" actually requires. It is also what makes the arm reachable in a test
   * at all: a status nothing can turn on is a wiring nothing can prove.
   *
   * # All three are LAYER 3, and that is why a percentage is the right knob here
   *
   * The header above prices a per-visitor ramp on a CACHED layer at two live
   * prefixes per busy tenant. None of these three touches a cached layer: the
   * task-guide list, the page blocks and the execution steer are all layer 3, so
   * both arms share one prefix and a percentage costs nothing but the tokens it
   * removes — the property the `retire-modality-exemplars` row states. § 2.10's
   * one cached wave-2 row (clarification) is deliberately absent; `vocabulary.ts`
   * records why.
   */
  /**
   * A workspace that publishes no Task Guide composes this block empty in both
   * arms, so the row is worth ramping only where guides exist — which the read
   * says, rather than leaving somebody to discover it from a flat graph.
   */
  "retire-task-guide-catalog": {
    key: "retire-task-guide-catalog",
    version: 2,
    status: "ramping",
    rolloutPercent: 0,
    notes: "The published Task Guide slug list is sent only on the intents that can reach a guide (teach_how_to, locate, navigate, multi_step_task). Roll back by setting this key to 0 if start_task_guide calls fall on the new arm.",
    read: "start_task_guide calls per 1,000 turns by arm, on a workspace that has published guides, plus ChatShapeAdherence on walkthrough-shaped plans. A fall on the new arm means an intent the list is reachable from is missing from the set."
  },
  /**
   * ONE release over BOTH page blocks, because the ledger gives them one
   * condition and a wrong CONDITION has to be rollable back in one move.
   *
   * It withholds a THIRD thing, and an operator should know before ramping:
   * `pageKnown` is DERIVED from the page-awareness block, so the two HOW TO HELP
   * page sentences go with it. That is the correct direction — those sentences
   * point at a referent the prompt would no longer carry — and it is asserted
   * rather than left to this comment.
   */
  "retire-page-context": {
    key: "retire-page-context",
    version: 2,
    status: "ramping",
    rolloutPercent: 0,
    notes: "The global page index (CS-223) and the current-path page-awareness block (F1-7) are sent only on the intents that read a page (locate, navigate, informational). Both already compose empty when no page is known. Roll back by setting this key to 0 if navigate_to targets stop resolving or the agent starts describing a page the visitor is not on.",
    read: "ChatPlannedRenderRealizedText and ChatShapeAdherence on navigate- and locate-intent plans by arm, plus the navigate_to refusal count; one drive on a zero-touch site whose walk produced a page index."
  },
  /**
   * The narrowest row of the three, and the one whose ledger condition this
   * branch deliberately does not implement literally: two of the directive's six
   * variants are CONSTRAINTS rather than steers and are sent on every turn in
   * every arm. `conditional-sends.ts` names them and says why.
   */
  "retire-execution-mode": {
    key: "retire-execution-mode",
    version: 2,
    status: "ramping",
    rolloutPercent: 0,
    notes: "The act-vs-explain steer is sent only on the intents it can change (perform_action, multi_step_task, teach_how_to). The read_only variant (the workspace instruction to change nothing) and the signed_out_goal variant (SYN-899) are NOT under this release and are sent on every turn. Roll back by setting this key to 0.",
    read: "The share of turns that call a write capability, by arm and by execution bias, plus the style scorer on informational plans; one drive on an action_first workspace. The two floored variants are asserted by conditional-sends.test.ts rather than read."
  },
  /**
   * P5-F — the first row that ramps by TENANT, and the reason that field exists.
   *
   * `rolloutPercent: 0` here is NOT a pause; it is the FAIL-SAFE. `tenantIds`
   * outranks the percentage, so the zero is what the release falls back to if
   * the allowlist is ever emptied — nobody, rather than the whole fleet.
   * `registry.convention.test.ts` asserts that pair, because the accident it
   * guards against is a one-character edit.
   *
   * One tenant, and it is the operator's OWN workspace (the app.syncanix.com
   * dogfood; `scripts/db/queries/p5/p5-f-01-release-tenant-allowlist.sql` is the
   * read that confirms the id against production). Never a paying customer
   * first: the change moves that tenant's (tenant, locale) prefix once per
   * locale, and the workspace that pays for the first measurement should be the
   * one that asked for it.
   */
  "retire-clarification-directive": {
    key: "retire-clarification-directive",
    version: 2,
    status: "ramping",
    rolloutPercent: 0,
    tenantIds: ["ec145132-05fe-4349-96bb-8303846a0655"],
    notes: "The GATHERING INPUTS directive leaves layer 2 and composes into layer 3 only on a fail-open turn or a planned turn that will ask. Scoped to ONE tenant because layer 2 is the cached prefix and a fleet flip re-keys every workspace at once. Roll back by setting this key to 0, which pauses it with no deploy; widen by adding a tenant id, never by raising the percentage.",
    read: 'Cost per 1,000 turns and the cached vs uncached input-token share of it, by shape, for the allowlisted tenant before and after the flip, taken at least 24 h after it (`scripts/db/queries/p5/p5-f-03-layer2-slim-before-after.sql`), plus the refusal count and the share of turns that raised a gather_inputs card \u2014 the block being moved is the one that teaches the model to ask, so a drop there is the regression this trades against. Thresholds in `plan/agent-engine/MEASUREMENTS.md` \xA7 "P5-F layer-2 slim". P5-G made this field REQUIRED in the same wave; the read already existed and is transcribed here rather than invented.'
  }
};
var ALL_DIRECTIVE_RELEASES = DIRECTIVE_RELEASE_KEYS.map(
  (key) => DIRECTIVE_RELEASES[key]
);

// src/directive-release/conditional-sends.ts
var CONDITIONAL_SEND_KEYS = [
  "retire-task-guide-catalog",
  "retire-page-context",
  "retire-execution-mode"
];
var CONDITIONAL_SEND_INTENTS = {
  "retire-task-guide-catalog": ["teach_how_to", "locate", "navigate", "multi_step_task"],
  "retire-page-context": ["locate", "navigate", "informational"],
  "retire-execution-mode": ["perform_action", "multi_step_task", "teach_how_to"]
};
var EXECUTION_MODE_FLOORED_VARIANTS = ["read_only", "signed_out_goal"];
var FLOORED = new Set(EXECUTION_MODE_FLOORED_VARIANTS);
function isFlooredExecutionVariant(variant) {
  return FLOORED.has(variant);
}
var INTENTS = new Set(TURN_PLAN_INTENTS);
var KEYS = new Set(DIRECTIVE_RELEASE_KEYS);
function conditionalSendAdmitsIntent(key, intent) {
  const row2 = CONDITIONAL_SEND_INTENTS[key];
  return row2 === void 0 || row2.includes(intent);
}
function conditionalSendTableIsWellFormed() {
  return CONDITIONAL_SEND_KEYS.every((key) => KEYS.has(key)) && Object.values(CONDITIONAL_SEND_INTENTS).every(
    (intents) => intents.length > 0 && intents.every((intent) => INTENTS.has(intent))
  );
}

// src/directive-release/rollout-overrides.ts
var NO_DIRECTIVE_RELEASE_ROLLOUTS = {};
function parseDirectiveReleaseRollouts(raw) {
  const out = {};
  for (const entry of raw.split(",")) {
    const [rawKey, rawPercent, ...rest] = entry.split("=");
    if (rawKey === void 0 || rawPercent === void 0 || rest.length > 0) continue;
    const key = rawKey.trim();
    if (!isDirectiveReleaseKey(key) || out[key] !== void 0) continue;
    const percent = Number(rawPercent.trim());
    if (!Number.isInteger(percent) || percent < 0 || percent > 100) continue;
    out[key] = percent;
  }
  return out;
}

// src/persona/bucketing.ts
function rolloutBucket(subjectKey, profileId) {
  return stableHash(`${subjectKey}:${profileId}`) % 100;
}
function isProfileInRollout(subjectKey, profileId, rolloutPercent) {
  if (rolloutPercent >= 100) return true;
  if (rolloutPercent <= 0) return false;
  return rolloutBucket(subjectKey, profileId) < rolloutPercent;
}

// src/directive-release/resolve-arm.ts
var NO_DIRECTIVE_RELEASE_ARMS = /* @__PURE__ */ new Set();
function servesNewVersion(release, subjectKey, subject = {}) {
  if (!RAMPING_RELEASE_STATUSES.has(release.status)) return false;
  if (subject.pausedByEnvironment === true) return false;
  const allowlist = release.tenantIds ?? [];
  if (allowlist.length > 0) {
    return subject.tenantId !== void 0 && allowlist.includes(subject.tenantId);
  }
  if (subjectKey === "") return false;
  const percent = release.status === "published" ? 100 : release.rolloutPercent;
  return isProfileInRollout(subjectKey, release.key, percent);
}
function resolveDirectiveReleaseArms(subjectKey, overrides = {}, tenantId) {
  const arms = /* @__PURE__ */ new Set();
  for (const key of DIRECTIVE_RELEASE_KEYS) {
    const registered = DIRECTIVE_RELEASES[key];
    const override = overrides[key];
    const release = override === void 0 ? registered : { ...registered, rolloutPercent: override };
    const served = servesNewVersion(release, subjectKey, {
      ...tenantId !== void 0 ? { tenantId } : {},
      ...override === 0 ? { pausedByEnvironment: true } : {}
    });
    if (served) arms.add(key);
  }
  return arms;
}
function directiveReleaseIdentity(arms) {
  return [...arms].sort().join(",");
}

// src/intent/graphql-execution.ts
function toGraphqlLiteral(value) {
  if (value === null) return "null";
  switch (typeof value) {
    case "number":
      return Number.isFinite(value) ? String(value) : "null";
    case "boolean":
      return value ? "true" : "false";
    case "string":
      return JSON.stringify(value);
    case "object": {
      if (Array.isArray(value)) {
        return `[${value.map((v) => toGraphqlLiteral(v === void 0 ? null : v)).join(", ")}]`;
      }
      const entries = Object.entries(value).filter(([, v]) => v !== void 0).map(([k, v]) => `${k}: ${toGraphqlLiteral(v)}`);
      return `{ ${entries.join(", ")} }`;
    }
    default:
      return "null";
  }
}
function graphqlOperationExecutable(op, args) {
  if (op.opType === "subscription") return false;
  if (op.opType !== "mutation") return true;
  return graphqlArgsFullyTyped(args, op.argTypes, op.inputObject);
}
function buildGraphqlRequestBody(op, args, withSelection) {
  const typed = graphqlArgsFullyTyped(args, op.argTypes, op.inputObject);
  if (op.opType === "mutation" && !typed) {
    throw new Error(
      "buildGraphqlRequestBody: refusing to build an untyped GraphQL mutation as literals (degrade it via graphqlOperationExecutable first)."
    );
  }
  if (typed && (op.argTypes !== void 0 || op.inputObject !== void 0)) {
    return buildTypedGraphqlDocument({
      opType: op.opType,
      opName: op.opName,
      args,
      withSelection,
      ...op.argTypes !== void 0 ? { argTypes: op.argTypes } : {},
      ...op.inputObject !== void 0 ? { inputObject: op.inputObject } : {}
    });
  }
  const argList = Object.entries(args).filter(([, v]) => v !== void 0).map(([k, v]) => `${k}: ${toGraphqlLiteral(v)}`).join(", ");
  const argsPart = argList === "" ? "" : `(${argList})`;
  const selection = withSelection ? " { __typename }" : "";
  return { query: `${op.opType} { ${op.opName}${argsPart}${selection} }` };
}
var GRAPHQL_SELECTION_REQUIRED = /must have a (sub.?)?selection|selection of subfields/i;
var GRAPHQL_SELECTION_FORBIDDEN = /must not have a (sub.?)?selection|has no subfields/i;
var GRAPHQL_PERMISSION = /unauthenticated|forbidden|not authori[sz]ed|permission/i;
function classifyGraphqlResponse(body) {
  const errors = body?.errors;
  if (Array.isArray(errors) && errors.length > 0) {
    const message = errors.map((e) => e.message ?? "").join("; ");
    if (GRAPHQL_SELECTION_FORBIDDEN.test(message) || GRAPHQL_SELECTION_REQUIRED.test(message)) {
      return { kind: "selection-retry", message };
    }
    if (GRAPHQL_PERMISSION.test(message)) {
      return { kind: "denied", message };
    }
    return { kind: "error", message };
  }
  return { kind: "success", data: body?.data ?? null };
}

// src/i18n/pseudo-localize.ts
var ASCII_TO_PSEUDO = {
  a: "\xE1",
  b: "\u0180",
  c: "\xE7",
  d: "\u0111",
  e: "\xE9",
  f: "\u0192",
  g: "\u01E7",
  h: "\u021F",
  i: "\xED",
  j: "\u01F0",
  k: "\u01E9",
  l: "\u013A",
  m: "\u0271",
  n: "\u0144",
  o: "\xF3",
  p: "\u01A5",
  q: "\u01EB",
  r: "\u0155",
  s: "\u0161",
  t: "\u0167",
  u: "\xFA",
  v: "\u1E7D",
  w: "\u0175",
  x: "\u1E8B",
  y: "\xFD",
  z: "\u017E",
  A: "\xC1",
  B: "\u0181",
  C: "\xC7",
  D: "\u0110",
  E: "\xC9",
  F: "\u0191",
  G: "\u01E6",
  H: "\u021E",
  I: "\xCD",
  J: "J\u030C",
  K: "\u01E8",
  L: "\u0139",
  M: "\u1E3E",
  N: "\u0143",
  O: "\xD3",
  P: "\u01A4",
  Q: "\u01EA",
  R: "\u0154",
  S: "\u0160",
  T: "\u0166",
  U: "\xDA",
  V: "\u1E7C",
  W: "\u0174",
  X: "\u1E8A",
  Y: "\xDD",
  Z: "\u017D"
};
var OPEN_BRACKET = "\u27E6";
var CLOSE_BRACKET = "\u27E7";
function substituteChar(ch) {
  return ASCII_TO_PSEUDO[ch] ?? ch;
}
function transformBody(input) {
  let out = "";
  let braceDepth = 0;
  let inTag = false;
  for (const ch of input) {
    if (inTag) {
      out += ch;
      if (ch === ">") inTag = false;
      continue;
    }
    if (braceDepth > 0) {
      out += ch;
      if (ch === "{") braceDepth += 1;
      else if (ch === "}") braceDepth -= 1;
      continue;
    }
    if (ch === "{") {
      out += ch;
      braceDepth = 1;
      continue;
    }
    if (ch === "<") {
      out += ch;
      inTag = true;
      continue;
    }
    out += substituteChar(ch);
  }
  return out;
}
function pseudoLocalize(input) {
  if (input.length === 0) return "";
  return `${OPEN_BRACKET}${transformBody(input)}${CLOSE_BRACKET}`;
}
var PSEUDO_LOCALIZE_OPEN_BRACKET = OPEN_BRACKET;
var PSEUDO_LOCALIZE_CLOSE_BRACKET = CLOSE_BRACKET;

// src/i18n/detect.ts
function parseQualityValue(spec) {
  const match = /^q=(\d+(?:\.\d+)?)$/i.exec(spec.trim());
  if (match?.[1] === void 0) return Number.NaN;
  const q = Number.parseFloat(match[1]);
  if (!Number.isFinite(q)) return Number.NaN;
  if (q < 0 || q > 1) return Number.NaN;
  return q;
}
function parseHeader(header) {
  const ranges = [];
  const segments = header.split(",");
  for (let i = 0; i < segments.length; i += 1) {
    const segment = segments[i];
    if (segment === void 0) continue;
    const parts = segment.split(";").map((p) => p.trim());
    const rawTag = parts[0];
    if (rawTag === void 0 || rawTag.length === 0) continue;
    const tag = rawTag.toLowerCase();
    let quality = 1;
    let qualityValid = true;
    for (let j = 1; j < parts.length; j += 1) {
      const param = parts[j];
      if (param === void 0 || param.length === 0) continue;
      if (param.toLowerCase().startsWith("q=")) {
        const q = parseQualityValue(param);
        if (Number.isNaN(q)) {
          qualityValid = false;
          break;
        }
        quality = q;
      }
    }
    if (!qualityValid) continue;
    if (quality === 0) continue;
    ranges.push({ tag, quality, index: i });
  }
  ranges.sort((a, b) => {
    if (b.quality !== a.quality) return b.quality - a.quality;
    return a.index - b.index;
  });
  return ranges;
}
function primarySubtag(tag) {
  const dash = tag.indexOf("-");
  return dash === -1 ? tag : tag.slice(0, dash);
}
function detectLocaleFromAcceptLanguage(header) {
  if (typeof header !== "string" || header.length === 0) return DEFAULT_LOCALE;
  const ranges = parseHeader(header);
  for (const range of ranges) {
    if (range.tag === "*") return DEFAULT_LOCALE;
    if (isSupportedLocale(range.tag)) return range.tag;
    const primary = primarySubtag(range.tag);
    if (isSupportedLocale(primary)) return primary;
  }
  return DEFAULT_LOCALE;
}
var ARRAY_WILDCARD = "[]";
function formatPath(path) {
  let out = "";
  for (const segment of path) {
    if (typeof segment === "number") out += `[${segment}]`;
    else if (segment === ARRAY_WILDCARD) out += ARRAY_WILDCARD;
    else out += out === "" ? segment : `.${segment}`;
  }
  return out;
}
function isPlainObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function customerTextNodeMax(schema) {
  if (!(schema instanceof z.ZodUnion)) return void 0;
  const options = schema.options;
  if (options.length !== 2) return void 0;
  const [text, localized] = options;
  if (!(text instanceof z.ZodString) || !(localized instanceof z.ZodObject)) return void 0;
  const shape = localized.shape;
  if (!(shape.default instanceof z.ZodString)) return void 0;
  const declared = shape.byLocale;
  const byLocale = declared instanceof z.ZodOptional ? declared.unwrap() : declared;
  if (!(byLocale instanceof z.ZodObject)) return void 0;
  return text.maxLength ?? void 0;
}
function unwrapSchema(schema) {
  let node = schema;
  for (let depth = 0; depth < 32; depth += 1) {
    if (customerTextNodeMax(node) !== void 0) return node;
    if (node instanceof z.ZodOptional || node instanceof z.ZodNullable) {
      node = node.unwrap();
    } else if (node instanceof z.ZodDefault) {
      node = node.removeDefault();
    } else if (node instanceof z.ZodCatch) {
      node = node.removeCatch();
    } else if (node instanceof z.ZodReadonly) {
      node = node.unwrap();
    } else if (node instanceof z.ZodBranded) {
      node = node.unwrap();
    } else if (node instanceof z.ZodEffects) {
      node = node.innerType();
    } else if (node instanceof z.ZodLazy) {
      node = node.schema;
    } else if (node instanceof z.ZodPipeline) {
      node = node._def.out;
    } else {
      return node;
    }
  }
  return node;
}
function walkCustomerTextValues(schema, value, visit, path = []) {
  const node = unwrapSchema(schema);
  const max = customerTextNodeMax(node);
  if (max !== void 0) return visit(value, path, max);
  if (value === null || value === void 0) return value;
  if (node instanceof z.ZodObject && isPlainObject(value)) {
    const shape = node.shape;
    let changed = false;
    const next = { ...value };
    for (const [key, child] of Object.entries(shape)) {
      if (!(key in value)) continue;
      const before = value[key];
      const after = walkCustomerTextValues(child, before, visit, [...path, key]);
      if (after !== before) {
        next[key] = after;
        changed = true;
      }
    }
    return changed ? next : value;
  }
  if (node instanceof z.ZodArray && Array.isArray(value)) {
    const element = node.element;
    return walkIndexed(value, () => element, visit, path);
  }
  if (node instanceof z.ZodTuple && Array.isArray(value)) {
    const itemSchemas = node.items;
    return walkIndexed(value, (index) => itemSchemas[index], visit, path);
  }
  if (node instanceof z.ZodRecord && isPlainObject(value)) {
    const valueSchema = node.valueSchema;
    let changed = false;
    const next = { ...value };
    for (const [key, child] of Object.entries(value)) {
      const after = walkCustomerTextValues(valueSchema, child, visit, [...path, key]);
      if (after !== child) {
        next[key] = after;
        changed = true;
      }
    }
    return changed ? next : value;
  }
  if (node instanceof z.ZodUnion || node instanceof z.ZodDiscriminatedUnion) {
    for (const option of node.options) {
      if (option.safeParse(value).success) {
        return walkCustomerTextValues(option, value, visit, path);
      }
    }
    return value;
  }
  if (node instanceof z.ZodIntersection) {
    const left = walkCustomerTextValues(node._def.left, value, visit, path);
    return walkCustomerTextValues(node._def.right, left, visit, path);
  }
  return value;
}
function walkIndexed(items, schemaAt, visit, path) {
  let changed = false;
  const next = [...items];
  for (let index = 0; index < items.length; index += 1) {
    const itemSchema = schemaAt(index);
    if (itemSchema === void 0) continue;
    const after = walkCustomerTextValues(itemSchema, items[index], visit, [...path, index]);
    if (after !== items[index]) {
      next[index] = after;
      changed = true;
    }
  }
  return changed ? next : items;
}
function collectCustomerTextPaths(schema) {
  const paths = [];
  const onPath = /* @__PURE__ */ new Set();
  const visit = (candidate, path) => {
    const node = unwrapSchema(candidate);
    if (customerTextNodeMax(node) !== void 0) {
      paths.push(formatPath(path));
      return;
    }
    if (onPath.has(node)) return;
    onPath.add(node);
    try {
      if (node instanceof z.ZodObject) {
        for (const [key, child] of Object.entries(node.shape)) {
          visit(child, [...path, key]);
        }
      } else if (node instanceof z.ZodArray) {
        visit(node.element, [...path, ARRAY_WILDCARD]);
      } else if (node instanceof z.ZodTuple) {
        node.items.forEach((item, index) => {
          visit(item, [...path, index]);
        });
      } else if (node instanceof z.ZodRecord) {
        visit(node.valueSchema, [...path, ARRAY_WILDCARD]);
      } else if (node instanceof z.ZodUnion || node instanceof z.ZodDiscriminatedUnion) {
        for (const option of node.options) visit(option, path);
      } else if (node instanceof z.ZodIntersection) {
        visit(node._def.left, path);
        visit(node._def.right, path);
      }
    } finally {
      onPath.delete(node);
    }
  };
  visit(schema, []);
  return paths;
}

// src/i18n/customer-text-sanitize.ts
var SANCTIONED_JOINER_CODE_POINTS = [8204, 8205];
var SANCTIONED_JOINERS = new RegExp(
  `[${SANCTIONED_JOINER_CODE_POINTS.map((cp) => String.fromCodePoint(cp)).join("")}]`,
  "g"
);
function isCustomerTextClean(text) {
  const probe = text.replace(SANCTIONED_JOINERS, "");
  return sanitizeToolText(probe).trim() === probe.trim();
}
function normalizeLeaf(text, path, max, issues) {
  if (!isCustomerTextClean(text)) {
    issues.push({ path: formatPath(path), reason: "unsafe-characters" });
    return text;
  }
  const trimmed = text.trim();
  if (trimmed.length === 0) {
    issues.push({ path: formatPath(path), reason: "empty-after-trim" });
    return trimmed;
  }
  if (trimmed.length > max) {
    issues.push({ path: formatPath(path), reason: "too-long", max });
    return trimmed;
  }
  return trimmed;
}
function normalizeCustomerText(value, path, max, issues) {
  if (typeof value === "string") return normalizeLeaf(value, path, max, issues);
  if (!isPlainObject(value)) return value;
  let changed = false;
  const next = { ...value };
  const fallback2 = value.default;
  if (typeof fallback2 === "string") {
    const after = normalizeLeaf(fallback2, [...path, "default"], max, issues);
    if (after !== fallback2) {
      next.default = after;
      changed = true;
    }
  }
  const byLocale = value.byLocale;
  if (isPlainObject(byLocale)) {
    let variantsChanged = false;
    const nextVariants = { ...byLocale };
    for (const [locale, variant] of Object.entries(byLocale)) {
      if (typeof variant !== "string") continue;
      const after = normalizeLeaf(variant, [...path, "byLocale", locale], max, issues);
      if (after !== variant) {
        nextVariants[locale] = after;
        variantsChanged = true;
      }
    }
    if (variantsChanged) {
      next.byLocale = nextVariants;
      changed = true;
    }
  }
  return changed ? next : value;
}
function sanitizeCustomerTextTree(schema, value) {
  const issues = [];
  const next = walkCustomerTextValues(
    schema,
    value,
    (leaf, path, max) => normalizeCustomerText(leaf, path, max, issues)
  );
  return { value: next, issues };
}
function collectCustomerTextSchemaPaths(schema) {
  return collectCustomerTextPaths(schema);
}

// src/i18n/load-catalog.ts
var LOCALE_LOADERS = {
  en: () => import('./en-S2WAU4IK.js'),
  es: () => import('./es-3N6H4OJK.js'),
  fr: () => import('./fr-KIDTCV5U.js'),
  de: () => import('./de-AUA37AA6.js'),
  ar: () => import('./ar-D5KU62B2.js'),
  he: () => import('./he-ERKF2PEO.js')
};
async function loadCatalog(locale) {
  const en = (await LOCALE_LOADERS.en()).default;
  if (!isSupportedLocale(locale) || locale === DEFAULT_LOCALE) {
    return en;
  }
  const active = (await LOCALE_LOADERS[locale]()).default;
  return { ...en, ...active };
}

// src/i18n/key-coverage.ts
var I18N_KEY_SOURCE = "[A-Za-z][\\w-]*(?:\\.[A-Za-z0-9][\\w-]*)+";
function escapeRegExp2(literal) {
  return literal.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function extractLiteralKeys(source) {
  const re = new RegExp(`['"\`](${I18N_KEY_SOURCE})['"\`]`, "g");
  const out = /* @__PURE__ */ new Set();
  for (const m of source.matchAll(re)) if (m[1]) out.add(m[1]);
  return out;
}
function extractPluralKeys(source) {
  const re = new RegExp(`pluralKey\\(\\s*['"\`](${I18N_KEY_SOURCE})['"\`]`, "g");
  const out = /* @__PURE__ */ new Set();
  for (const m of source.matchAll(re)) {
    if (m[1] === void 0) continue;
    out.add(`${m[1]}.one`);
    out.add(`${m[1]}.other`);
  }
  return out;
}
function extractDeclaredKeys(source) {
  const re = new RegExp(`\\b\\w*Key\\s*:\\s*['"\`](${I18N_KEY_SOURCE})['"\`]`, "g");
  const out = /* @__PURE__ */ new Set();
  for (const m of source.matchAll(re)) if (m[1]) out.add(m[1]);
  return out;
}
function extractTemplatePrefixes(source) {
  const re = /[`]([A-Za-z][\w.-]*?)\$\{/g;
  const out = /* @__PURE__ */ new Set();
  for (const m of source.matchAll(re)) {
    if (m[1]?.includes(".")) out.add(m[1]);
  }
  return [...out];
}
function extractCalledKeys(source, callees, keyArgIndex = 0) {
  const fn = callees.map(escapeRegExp2).join("|");
  const lead = `(?:[^,()]*,\\s*){${keyArgIndex}}`;
  const re = new RegExp(`\\b(?:${fn})\\(\\s*${lead}['"](${I18N_KEY_SOURCE})['"]`, "g");
  const out = /* @__PURE__ */ new Set();
  for (const m of source.matchAll(re)) if (m[1]) out.add(m[1]);
  return out;
}
function isKeyReachable(key, literals, prefixes) {
  return literals.has(key) || prefixes.some((p) => key.startsWith(p));
}
function findUndefinedCalls(calledKeys, catalog) {
  return [...calledKeys].filter((k) => !catalog.has(k)).sort();
}
function findOrphanKeys(catalogKeys, literals, prefixes, allow = /* @__PURE__ */ new Set()) {
  return [...catalogKeys].filter((k) => !allow.has(k) && !isKeyReachable(k, literals, prefixes)).sort();
}
function extractDynamicKeyFamilies(source) {
  const re = /\bt\(\s*`([^`]*\$\{[^`]*)`/g;
  const out = /* @__PURE__ */ new Set();
  for (const m of blankComments(source).matchAll(re)) {
    const family = (m[1] ?? "").replace(/\$\{[^}]*\}/g, "*");
    if (family.includes(".")) out.add(family);
  }
  return [...out].sort();
}
function blankComments(source) {
  const out = source.split("");
  let mode = "code";
  let i = 0;
  const blank = (from, to) => {
    for (let j = from; j < to; j += 1) if (out[j] !== "\n") out[j] = " ";
  };
  while (i < source.length) {
    const ch = source[i];
    const next = source[i + 1];
    if (mode === "code") {
      if (ch === "/" && next === "/") {
        const end = source.indexOf("\n", i);
        const stop = end === -1 ? source.length : end;
        blank(i, stop);
        i = stop;
        continue;
      }
      if (ch === "/" && next === "*") {
        const end = source.indexOf("*/", i + 2);
        const stop = end === -1 ? source.length : end + 2;
        blank(i, stop);
        i = stop;
        continue;
      }
      if (ch === "'") mode = "single";
      else if (ch === '"') mode = "double";
      else if (ch === "`") mode = "template";
      i += 1;
      continue;
    }
    if (ch === "\\") {
      i += 2;
      continue;
    }
    if (mode === "single" && ch === "'" || mode === "double" && ch === '"' || mode === "template" && ch === "`") {
      mode = "code";
    }
    i += 1;
  }
  return out.join("");
}
function expandFamily(family, vocabulary) {
  const holes = family.split("*").length - 1;
  if (holes !== 1) {
    throw new Error(
      `expandFamily: "${family}" has ${String(holes)} holes; only single-hole families expand from a flat vocabulary`
    );
  }
  return vocabulary.map((member) => family.replace("*", member));
}

// src/i18n/format.ts
function buildNumberFormatOptions(opts) {
  const out = {};
  if (opts === void 0) return out;
  if (opts.numberingSystem !== void 0) out.numberingSystem = opts.numberingSystem;
  if (opts.minimumFractionDigits !== void 0) {
    out.minimumFractionDigits = opts.minimumFractionDigits;
  }
  if (opts.maximumFractionDigits !== void 0) {
    out.maximumFractionDigits = opts.maximumFractionDigits;
  }
  if (opts.useGrouping !== void 0) out.useGrouping = opts.useGrouping;
  if (opts.signDisplay !== void 0) out.signDisplay = opts.signDisplay;
  return out;
}
function formatNumber(value, locale, options) {
  const opts = buildNumberFormatOptions(options);
  opts.numberingSystem ??= getLocaleNumberingSystem(locale);
  return new Intl.NumberFormat(locale, opts).format(value);
}
function formatCurrency(value, currencyCode, locale, options) {
  const baseOptions = {
    ...buildNumberFormatOptions(options),
    style: "currency",
    currency: currencyCode
  };
  baseOptions.numberingSystem ??= getLocaleNumberingSystem(locale);
  if (options?.currencyDisplay !== void 0) baseOptions.currencyDisplay = options.currencyDisplay;
  return new Intl.NumberFormat(locale, baseOptions).format(value);
}
function buildDateFormatOptions(opts) {
  const out = {};
  if (opts === void 0) return out;
  if (opts.dateStyle !== void 0) out.dateStyle = opts.dateStyle;
  if (opts.timeStyle !== void 0) out.timeStyle = opts.timeStyle;
  if (opts.timeZone !== void 0) out.timeZone = opts.timeZone;
  return out;
}
function formatDate(date, locale, options) {
  const opts = buildDateFormatOptions(options);
  if (opts.dateStyle === void 0 && opts.timeStyle === void 0) {
    opts.dateStyle = "medium";
  }
  return new Intl.DateTimeFormat(locale, opts).format(date);
}
function formatRelativeTime(value, unit, locale, options) {
  const opts = {
    numeric: options?.numeric ?? "auto"
  };
  if (options?.style !== void 0) opts.style = options.style;
  return new Intl.RelativeTimeFormat(locale, opts).format(value, unit);
}

// src/persona/limits.ts
var SYSTEM_PROMPT_MAX_CHARS = 2e4;
var PERSONA_MAX_CHARS = 500;
var MAX_PERSONA_PROFILES = 50;
var MAX_PROFILE_NAME_CHARS = 80;
var MAX_PROFILE_DESCRIPTION_CHARS = 280;
var PERSONA_PROFILE_REVISION_LIMIT = 50;
var PERSONA_ENTRY_MAX_CHARS = 200;
var MAX_BRAND_PHRASES = 25;
var MAX_REFUSAL_TOPICS = 50;
var MAX_REFUSAL_STYLES = 25;

// src/persona/starter-templates.ts
var STARTER_TEMPLATE_IDS = ["friendly", "formal", "concise"];
var REGULATED_ADVICE = [
  "legal_advice",
  "medical_advice",
  "financial_advice"
];
var STARTER_TEMPLATES = [
  {
    id: "friendly",
    persona: "Friendly support agent",
    labelKey: "persona.template.friendly.label",
    descriptionKey: "persona.template.friendly.description",
    includesKey: "persona.template.friendly.includes",
    voiceTone: "warm",
    systemPrompt: (
      // "Suggest a human takeover when you can't help" until ADR-0575: the
      // product has no takeover to perform, so that sentence shipped a promise
      // the agent could not keep to every workspace that took this template.
      "You are a helpful AI assistant. Be concise and friendly. When you can't help, say so and tell the visitor how to reach the team."
    ),
    // A consumer-facing desk: the regulated floor, plus the two topics support
    // agents are most often pushed on by a determined customer.
    restrictedTopics: [...REGULATED_ADVICE, "refunds_outside_policy", "guarantees_and_promises"],
    refusalStyleCategories: ["polite", "offer_a_human"],
    fallbackBehavior: "apologize"
  },
  {
    id: "formal",
    persona: "Formal enterprise assistant",
    labelKey: "persona.template.formal.label",
    descriptionKey: "persona.template.formal.description",
    includesKey: "persona.template.formal.includes",
    voiceTone: "formal",
    systemPrompt: "You are a professional AI assistant. Respond with precise, factual information. Cite your sources.",
    // B2B / regulated: the floor, plus the three an enterprise buyer's legal
    // team asks about first — promises, competitor claims, and personal data.
    restrictedTopics: [
      ...REGULATED_ADVICE,
      "guarantees_and_promises",
      "competitor_comparison",
      "personal_data_requests"
    ],
    refusalStyleCategories: ["polite", "explain_why"],
    fallbackBehavior: "apologize"
  },
  {
    id: "concise",
    persona: "Concise technical assistant",
    labelKey: "persona.template.concise.label",
    descriptionKey: "persona.template.concise.description",
    includesKey: "persona.template.concise.includes",
    voiceTone: "playful",
    systemPrompt: "You are a developer-focused assistant. Be terse and direct. Show code over prose when useful.",
    // Developer tooling: the floor still applies, and the two that matter when
    // the audience can ask precise questions about your own infrastructure.
    restrictedTopics: [...REGULATED_ADVICE, "security_credentials", "internal_operations"],
    refusalStyleCategories: ["brief", "suggest_alternative"],
    fallbackBehavior: "clarify"
  }
];
function findStarterTemplate(id) {
  return STARTER_TEMPLATES.find((template2) => template2.id === id);
}
function starterTemplatePatch(template2) {
  return {
    persona: template2.persona,
    voiceTone: template2.voiceTone,
    systemPrompt: template2.systemPrompt,
    restrictedTopics: template2.restrictedTopics,
    refusalStyleCategories: template2.refusalStyleCategories,
    fallbackBehavior: template2.fallbackBehavior
  };
}
var EMPHASIS_CHIPS = [
  "proactive_help",
  "concrete_examples",
  "confirm_before_acting",
  "cite_sources",
  "offer_next_step"
];
var AVOID_CHIPS = [
  "speculation",
  "upselling",
  "jargon",
  "long_preamble",
  "overpromising"
];
var CLARIFY_CHIPS = [
  "ambiguous_request",
  "missing_details",
  "high_impact_action",
  "multiple_interpretations"
];
var ESCALATE_CHIPS = [
  "user_frustrated",
  "repeated_failure",
  "explicit_human_request",
  "out_of_scope",
  "sensitive_topic"
];
var TONE_NUDGES = ["warmer", "neutral", "more_formal"];
var ANSWER_LENGTHS = ["concise", "standard", "thorough"];
var guidanceSchema = /* @__PURE__ */ z.object({
  emphasize: z.array(z.enum(EMPHASIS_CHIPS)).max(EMPHASIS_CHIPS.length).default([]),
  avoid: z.array(z.enum(AVOID_CHIPS)).max(AVOID_CHIPS.length).default([]),
  clarifyWhen: z.array(z.enum(CLARIFY_CHIPS)).max(CLARIFY_CHIPS.length).default([]),
  escalateWhen: z.array(z.enum(ESCALATE_CHIPS)).max(ESCALATE_CHIPS.length).default([]),
  tone: z.enum(TONE_NUDGES).nullable().default(null),
  answerLength: z.enum(ANSWER_LENGTHS).nullable().default(null)
}).strict().transform((g) => ({
  ...g,
  emphasize: [...new Set(g.emphasize)],
  avoid: [...new Set(g.avoid)],
  clarifyWhen: [...new Set(g.clarifyWhen)],
  escalateWhen: [...new Set(g.escalateWhen)]
}));
var EMPTY_GUIDANCE = {
  emphasize: [],
  avoid: [],
  clarifyWhen: [],
  escalateWhen: [],
  tone: null,
  answerLength: null
};
function isGuidanceEmpty(g) {
  return g.emphasize.length === 0 && g.avoid.length === 0 && g.clarifyWhen.length === 0 && g.escalateWhen.length === 0 && (g.tone === null || g.tone === "neutral") && (g.answerLength === null || g.answerLength === "standard");
}
function parseGuidanceJson(value, domain) {
  if (value === null || value === void 0 || value.trim() === "") return EMPTY_GUIDANCE;
  let raw;
  try {
    raw = JSON.parse(value);
  } catch {
    throw new ValidationError("invalid guidance JSON", { domain });
  }
  const parsed = guidanceSchema.safeParse(raw);
  if (!parsed.success) {
    throw new ValidationError("invalid guidance", { domain });
  }
  return parsed.data;
}

// src/persona/diff.ts
var PERSONA_DIFF_FIELDS = [
  "name",
  "description",
  "persona",
  "voiceTone",
  "brandPhrases",
  "systemPrompt",
  "fallbackBehavior",
  "restrictedTopics",
  "refusalTopics",
  "refusalStyleCategories",
  "refusalStyle",
  "language.mode",
  "language.pinned",
  "language.priority",
  "guidance.emphasize",
  "guidance.avoid",
  "guidance.clarifyWhen",
  "guidance.escalateWhen",
  "guidance.tone",
  "guidance.answerLength"
];
function scalar(field, before, after) {
  const a = before === "" ? null : before;
  const b = after === "" ? null : after;
  return a === b ? null : { field, kind: "scalar", before: a, after: b };
}
function list(field, before, after) {
  const beforeSet = new Set(before);
  const afterSet = new Set(after);
  const added = after.filter((v) => !beforeSet.has(v));
  const removed = before.filter((v) => !afterSet.has(v));
  if (added.length === 0 && removed.length === 0) return null;
  return { field, kind: "list", added, removed };
}
function orderedList(field, before, after) {
  if (before.length === after.length && before.every((v, i) => v === after[i])) return null;
  return { field, kind: "list", added: [...after], removed: [...before] };
}
function diffPersonaConfig(before, after) {
  const g1 = before.guidance ?? EMPTY_GUIDANCE;
  const g2 = after.guidance ?? EMPTY_GUIDANCE;
  const changes = [
    before.name !== void 0 && after.name !== void 0 ? scalar("name", before.name, after.name) : null,
    before.description !== void 0 && after.description !== void 0 ? scalar("description", before.description, after.description) : null,
    scalar("persona", before.persona, after.persona),
    scalar("voiceTone", before.voiceTone, after.voiceTone),
    list("brandPhrases", before.brandPhrases, after.brandPhrases),
    scalar("systemPrompt", before.systemPrompt, after.systemPrompt),
    scalar("fallbackBehavior", before.fallbackBehavior, after.fallbackBehavior),
    list("restrictedTopics", before.restrictedTopics ?? [], after.restrictedTopics ?? []),
    list("refusalTopics", before.refusalTopics, after.refusalTopics),
    list(
      "refusalStyleCategories",
      before.refusalStyleCategories ?? [],
      after.refusalStyleCategories ?? []
    ),
    list("refusalStyle", before.refusalStyle, after.refusalStyle),
    scalar("language.mode", before.language.mode, after.language.mode),
    scalar("language.pinned", before.language.pinned, after.language.pinned),
    orderedList("language.priority", before.language.priority, after.language.priority),
    list("guidance.emphasize", g1.emphasize, g2.emphasize),
    list("guidance.avoid", g1.avoid, g2.avoid),
    list("guidance.clarifyWhen", g1.clarifyWhen, g2.clarifyWhen),
    list("guidance.escalateWhen", g1.escalateWhen, g2.escalateWhen),
    scalar("guidance.tone", g1.tone, g2.tone),
    scalar("guidance.answerLength", g1.answerLength, g2.answerLength)
  ];
  return changes.filter((c) => c !== null);
}
function changedPersonaFields(before, after) {
  return diffPersonaConfig(before, after).map((c) => c.field);
}

// src/persona/embed-key.ts
var EMBED_KEY_MAX_LENGTH = 63;
var EMBED_KEY_PATTERN = /^[a-z0-9][a-z0-9-]{0,62}$/;
function normalizeEmbedKey(raw) {
  if (raw === void 0 || raw === null) return null;
  const trimmed = raw.trim().toLowerCase();
  if (trimmed === "" || trimmed.length > EMBED_KEY_MAX_LENGTH) return null;
  return EMBED_KEY_PATTERN.test(trimmed) ? trimmed : null;
}

// src/persona/language.ts
var LANGUAGE_MODES = ["follow_visitor", "priority_list", "pinned"];
var MAX_LANGUAGE_PRIORITY = SUPPORTED_LOCALES.length;
var DEFAULT_PERSONA_LANGUAGE = {
  mode: "follow_visitor",
  priority: [],
  pinned: null
};
function isLocale(value) {
  return typeof value === "string" && SUPPORTED_LOCALES.some((m) => m.code === value);
}
function parsePersonaLanguage(value) {
  const raw = value ?? {};
  const mode = LANGUAGE_MODES.includes(raw.mode) ? raw.mode : "follow_visitor";
  if (mode === "pinned") {
    const pinned = isLocale(raw.pinned) ? raw.pinned : null;
    return pinned === null ? DEFAULT_PERSONA_LANGUAGE : { mode: "pinned", priority: [], pinned };
  }
  if (mode === "priority_list") {
    const seen = /* @__PURE__ */ new Set();
    const priority = [];
    for (const entry of Array.isArray(raw.priority) ? raw.priority : []) {
      if (isLocale(entry) && !seen.has(entry)) {
        seen.add(entry);
        priority.push(entry);
      }
    }
    return priority.length === 0 ? DEFAULT_PERSONA_LANGUAGE : { mode: "priority_list", priority, pinned: null };
  }
  return DEFAULT_PERSONA_LANGUAGE;
}
function resolvePriorityLocale(priority, visitorLocale) {
  if (priority.length === 0) return null;
  if (isLocale(visitorLocale) && priority.includes(visitorLocale)) return visitorLocale;
  return priority[0] ?? null;
}
function personaLanguageFromLegacy(languageTone, fixedResponseLocale) {
  if (isLocale(fixedResponseLocale)) {
    return { mode: "pinned", priority: [], pinned: fixedResponseLocale };
  }
  if (languageTone === "english") {
    return { mode: "pinned", priority: [], pinned: "en" };
  }
  return DEFAULT_PERSONA_LANGUAGE;
}
function personaLanguageToLegacy(language) {
  if (language.mode === "pinned" && language.pinned !== null) {
    return {
      languageTone: language.pinned === "en" ? "english" : "match",
      fixedResponseLocale: language.pinned
    };
  }
  if (language.mode === "priority_list" && language.priority.length === 1) {
    const only = language.priority[0] ?? null;
    return { languageTone: only === "en" ? "english" : "match", fixedResponseLocale: only };
  }
  return { languageTone: "match", fixedResponseLocale: null };
}
var RESTRICTED_TOPICS = [
  "legal_advice",
  "medical_advice",
  "financial_advice",
  "competitor_comparison",
  "pricing_negotiation",
  "personal_data_requests",
  "employment_decisions",
  "political_content",
  "adult_content",
  "security_credentials",
  "refunds_outside_policy",
  "guarantees_and_promises",
  "internal_operations"
];
var REFUSAL_STYLE_CATEGORIES = [
  "polite",
  "brief",
  "offer_a_human",
  "explain_why",
  "suggest_alternative"
];
var dedupe2 = (values) => [...new Set(values)];
var restrictedTopicsSchema = /* @__PURE__ */ z.array(z.enum(RESTRICTED_TOPICS)).default([]).transform(dedupe2);
var refusalStyleCategoriesSchema = /* @__PURE__ */ z.array(z.enum(REFUSAL_STYLE_CATEGORIES)).default([]).transform(dedupe2);
function parseRestrictedTopics(raw) {
  return filterKnown(raw, RESTRICTED_TOPICS);
}
function parseRefusalStyleCategories(raw) {
  return filterKnown(raw, REFUSAL_STYLE_CATEGORIES);
}
function filterKnown(raw, vocabulary) {
  if (!Array.isArray(raw)) return [];
  const known = new Set(vocabulary);
  return dedupe2(raw.filter((entry) => typeof entry === "string" && known.has(entry)));
}
var TOOL_SCOPE_SIDE_EFFECTS = ["read", "write", "destructive"];
var MAX_TOOL_SCOPE_CAPABILITIES = 200;
var MAX_TOOL_SCOPE_SERVICES = 50;
var toolScopeSchema = /* @__PURE__ */ z.discriminatedUnion("mode", [
  z.object({ mode: z.literal("all") }),
  z.object({
    mode: z.literal("services"),
    services: z.array(z.string().min(1).max(200)).min(1).max(MAX_TOOL_SCOPE_SERVICES)
  }),
  z.object({
    mode: z.literal("side_effects"),
    sideEffects: z.array(z.enum(TOOL_SCOPE_SIDE_EFFECTS)).min(1).max(3)
  }),
  z.object({
    mode: z.literal("capabilities"),
    capabilityIds: z.array(z.string().min(1).max(300)).min(1).max(MAX_TOOL_SCOPE_CAPABILITIES)
  })
]);
var ALL_TOOLS = { mode: "all" };
function parseToolScope(value) {
  const parsed = toolScopeSchema.safeParse(value);
  return parsed.success ? parsed.data : ALL_TOOLS;
}
function toolScopeMatches(scope, capabilities) {
  switch (scope.mode) {
    case "all":
      return true;
    case "services": {
      const wanted = new Set(scope.services);
      return capabilities.some((c) => wanted.has(c.service));
    }
    case "side_effects": {
      const wanted = new Set(scope.sideEffects);
      return capabilities.some((c) => wanted.has(c.sideEffect));
    }
    case "capabilities": {
      const wanted = new Set(scope.capabilityIds);
      return capabilities.some((c) => wanted.has(c.capabilityId));
    }
  }
}
function isUnscoped(scope) {
  return scope.mode === "all";
}

// src/persona/targeting.ts
var MAX_TARGET_AUDIENCES = 25;
var MAX_TARGET_END_USER_SUBS = 100;
var TARGETING_SPECIFICITY = {
  /** Named an individual. */
  endUserSub: 400,
  /** Named a group — an audience, or "signed-out visitors". */
  audience: 300,
  /** Named a situation — which tools this turn can reach. */
  toolScope: 200,
  /** Named nobody: the profile matches every turn. */
  untargeted: 100
};
var personaTargetingSchema = /* @__PURE__ */ z.object({
  audienceIds: z.array(z.string().min(1).max(200)).max(MAX_TARGET_AUDIENCES).default([]),
  endUserSubs: z.array(z.string().min(1).max(255)).max(MAX_TARGET_END_USER_SUBS).default([]),
  targetsAnonymous: z.boolean().default(false),
  toolScope: toolScopeSchema.default(ALL_TOOLS)
});
var NO_TARGETING = {
  audienceIds: [],
  endUserSubs: [],
  targetsAnonymous: false,
  toolScope: ALL_TOOLS
};
function parsePersonaTargeting(value) {
  const raw = value ?? {};
  const parsed = personaTargetingSchema.safeParse({
    audienceIds: dedupeStrings(raw.audienceIds, MAX_TARGET_AUDIENCES),
    endUserSubs: dedupeStrings(raw.endUserSubs, MAX_TARGET_END_USER_SUBS),
    targetsAnonymous: raw.targetsAnonymous === true,
    toolScope: parseToolScope(raw.toolScope)
  });
  return parsed.success ? parsed.data : NO_TARGETING;
}
function dedupeStrings(value, cap) {
  if (!Array.isArray(value)) return [];
  const seen = /* @__PURE__ */ new Set();
  for (const entry of value) {
    if (typeof entry !== "string") continue;
    const trimmed = entry.trim();
    if (trimmed !== "") seen.add(trimmed);
    if (seen.size >= cap) break;
  }
  return [...seen];
}
function isUntargeted(targeting) {
  return targeting.audienceIds.length === 0 && targeting.endUserSubs.length === 0 && !targeting.targetsAnonymous && isUnscoped(targeting.toolScope);
}
function isIdentityBound(targeting) {
  return targeting.audienceIds.length > 0 || targeting.endUserSubs.length > 0;
}
function withoutEndUserSub(targeting, sub) {
  if (!targeting.endUserSubs.includes(sub)) return null;
  return { ...targeting, endUserSubs: targeting.endUserSubs.filter((s) => s !== sub) };
}
var PROFILE_TRANSFER_KIND = "syncanix.prompt-profile";
var PROFILE_TRANSFER_VERSION = 1;
var profileTransferSchema = /* @__PURE__ */ z.object({
  kind: z.literal(PROFILE_TRANSFER_KIND),
  version: z.number().int().positive(),
  name: z.string().trim().min(1).max(80),
  description: z.string().max(500).default(""),
  profile: z.object({
    persona: z.string().max(2e3).default(""),
    voiceTone: z.enum(["warm", "formal", "playful", "custom"]).default("warm"),
    brandPhrases: z.array(z.string().max(200)).max(MAX_BRAND_PHRASES).default([]),
    systemPrompt: z.string().max(SYSTEM_PROMPT_MAX_CHARS).default(""),
    fallbackBehavior: z.enum(["apologize", "clarify", "escalate", "suggest"]).default("apologize"),
    refusalTopics: z.array(z.string().max(200)).max(MAX_REFUSAL_TOPICS).default([]),
    refusalStyle: z.array(z.string().max(200)).max(MAX_REFUSAL_STYLES).default([]),
    // M12 categories DO travel — unlike targeting, an id means the same
    // thing in every workspace. Filtering rather than strict for the same
    // reason `.strip()` is: a file written by a newer deploy may name a
    // category this one has not heard of, and losing that one entry beats
    // refusing the whole profile.
    restrictedTopics: z.unknown().transform(parseRestrictedTopics),
    refusalStyleCategories: z.unknown().transform(parseRefusalStyleCategories),
    // Total + normalizing rather than strict: `parsePersonaLanguage`
    // already coerces any incoherent combination into a coherent one, and
    // refusing an import over a language mode nobody typed by hand would
    // fail the file for the wrong reason.
    language: z.unknown().transform((v) => parsePersonaLanguage(v)),
    guidance: guidanceSchema.default(EMPTY_GUIDANCE)
  }).strip()
}).strip();
function parseProfileTransfer(raw) {
  const parsed = profileTransferSchema.safeParse(raw);
  if (parsed.success) return { ok: true, value: parsed.data };
  const first = parsed.error.issues[0];
  return { ok: false, issue: first === void 0 ? "" : first.path.join(".") };
}
function buildProfileTransfer(input) {
  return {
    kind: PROFILE_TRANSFER_KIND,
    version: PROFILE_TRANSFER_VERSION,
    name: input.name,
    description: input.description,
    profile: input.profile
  };
}

// src/pricing/llm-price-table.ts
var LLM_LIST_PRICING = {
  "anthropic:claude-sonnet-4-5": { inputPerMillion: 3, outputPerMillion: 15 },
  "anthropic:claude-haiku-4-5": { inputPerMillion: 1, outputPerMillion: 5 },
  "bedrock-eu:claude-haiku-4-5": { inputPerMillion: 1, outputPerMillion: 5 },
  "bedrock-eu:claude-sonnet-4-5": { inputPerMillion: 3, outputPerMillion: 15 },
  "openai:gpt-5-mini": { inputPerMillion: 0.25, outputPerMillion: 2 },
  "openai:gpt-4o-mini": { inputPerMillion: 0.15, outputPerMillion: 0.6 }
};
var BEDROCK_EU_CRIS_MULTIPLIER = 1.1;
var BEDROCK_EU_MODEL_ID_PREFIX = "bedrock-eu:";
function isBedrockEuPricedModelId(modelId) {
  return modelId.startsWith(BEDROCK_EU_MODEL_ID_PREFIX);
}
function toRate(value) {
  return Math.round(value * 1e6) / 1e6;
}
var LLM_PRICING = Object.freeze(
  Object.fromEntries(
    Object.entries(LLM_LIST_PRICING).map(([modelId, list2]) => [
      modelId,
      isBedrockEuPricedModelId(modelId) ? {
        inputPerMillion: toRate(list2.inputPerMillion * BEDROCK_EU_CRIS_MULTIPLIER),
        outputPerMillion: toRate(list2.outputPerMillion * BEDROCK_EU_CRIS_MULTIPLIER)
      } : list2
    ])
  )
);

// src/pricing/llm-pricing.ts
var CACHE_READ_MULTIPLIER = 0.1;
var CACHE_WRITE_MULTIPLIER = 1.25;
var CACHE_WRITE_MULTIPLIER_1H = 2;
var UnknownModelError = class extends RangeError {
  constructor(modelId) {
    super(
      `Unknown LLM model id "${modelId}". Add it to LLM_PRICING in packages/shared/src/pricing/llm-pricing.ts.`
    );
    this.name = "UnknownModelError";
  }
};
function computeCostUsd(input) {
  validateTokens("promptTokens", input.promptTokens);
  validateTokens("completionTokens", input.completionTokens);
  const cacheReadTokens = input.cacheReadTokens ?? 0;
  const cacheCreationTokens = input.cacheCreationTokens ?? 0;
  validateTokens("cacheReadTokens", cacheReadTokens);
  validateTokens("cacheCreationTokens", cacheCreationTokens);
  const lookup = LLM_PRICING;
  const price = lookup[input.modelId];
  if (!price) {
    throw new UnknownModelError(input.modelId);
  }
  const hasSplit = input.cacheWrite5mTokens !== void 0 || input.cacheWrite1hTokens !== void 0;
  const cacheWrite5m = input.cacheWrite5mTokens ?? 0;
  const cacheWrite1h = input.cacheWrite1hTokens ?? 0;
  if (hasSplit) {
    validateTokens("cacheWrite5mTokens", cacheWrite5m);
    validateTokens("cacheWrite1hTokens", cacheWrite1h);
  }
  const cacheWriteMultiplier = input.cacheWriteTtl === "1h" ? CACHE_WRITE_MULTIPLIER_1H : CACHE_WRITE_MULTIPLIER;
  const writeCost = hasSplit ? cacheWrite5m * price.inputPerMillion * CACHE_WRITE_MULTIPLIER + cacheWrite1h * price.inputPerMillion * CACHE_WRITE_MULTIPLIER_1H : cacheCreationTokens * price.inputPerMillion * cacheWriteMultiplier;
  return (input.promptTokens * price.inputPerMillion + cacheReadTokens * price.inputPerMillion * CACHE_READ_MULTIPLIER + writeCost + input.completionTokens * price.outputPerMillion) / 1e6;
}
function validateTokens(field, value) {
  if (!Number.isFinite(value) || !Number.isInteger(value) || value < 0) {
    throw new RangeError(`${field} must be a non-negative integer, got ${String(value)}`);
  }
}

// src/pricing/llm-model-limits.ts
var DEFAULT_OUTPUT_RESERVE_TOKENS = 4096;
var LLM_MODEL_LIMITS = {
  "anthropic:claude-sonnet-4-5": {
    contextWindowTokens: 2e5,
    defaultOutputReserveTokens: DEFAULT_OUTPUT_RESERVE_TOKENS
  },
  "anthropic:claude-haiku-4-5": {
    contextWindowTokens: 2e5,
    defaultOutputReserveTokens: DEFAULT_OUTPUT_RESERVE_TOKENS
  },
  // Bedrock-EU (ADR-0111) — same Claude models, same 200k window.
  "bedrock-eu:claude-haiku-4-5": {
    contextWindowTokens: 2e5,
    defaultOutputReserveTokens: DEFAULT_OUTPUT_RESERVE_TOKENS
  },
  "bedrock-eu:claude-sonnet-4-5": {
    contextWindowTokens: 2e5,
    defaultOutputReserveTokens: DEFAULT_OUTPUT_RESERVE_TOKENS
  },
  "openai:gpt-5-mini": {
    contextWindowTokens: 128e3,
    defaultOutputReserveTokens: DEFAULT_OUTPUT_RESERVE_TOKENS
  },
  "openai:gpt-4o-mini": {
    contextWindowTokens: 128e3,
    defaultOutputReserveTokens: DEFAULT_OUTPUT_RESERVE_TOKENS
  }
};
var FALLBACK_MODEL_LIMITS = {
  contextWindowTokens: 128e3,
  defaultOutputReserveTokens: DEFAULT_OUTPUT_RESERVE_TOKENS
};
function providerFamilyForModel(model) {
  const lower = model.toLowerCase();
  if (lower.startsWith("openai:") || lower.startsWith("gpt") || lower.startsWith("o1")) {
    return "openai";
  }
  return "anthropic";
}
function resolveModelLimits(model) {
  const table = LLM_MODEL_LIMITS;
  const exact = table[model];
  if (exact !== void 0) {
    return exact;
  }
  if (!model.includes(":")) {
    const prefixed = `${providerFamilyForModel(model)}:${model}`;
    const viaPrefix = table[prefixed];
    if (viaPrefix !== void 0) {
      return viaPrefix;
    }
  }
  return FALLBACK_MODEL_LIMITS;
}

// src/pricing/usage-credits.ts
var UC_TOKEN_COGS_ANCHOR_USD = 16e-4;
var UC_PER_MESSAGE = 2;
var UC_PER_MCP_CALL = 2;
var UC_PER_ENDPOINT_CALL = 1;
var UC_PER_INSIGHT = 5;
var UC_PER_ENRICHMENT = 1;
var ENRICHMENT_UC_MONTHLY_ALLOWANCE = 2e4;
var ANALYSIS_UC_MONTHLY_ALLOWANCE = 4e4;
var UC_MARGIN_FLOOR = 0.8;
var UC_MIN_COGS_MULTIPLE = 5;
var UC_PAYG_RATE_USD = 0.012;
var UC_INCLUDED_RATE_USD = {
  starter: 0.01,
  growth: 91e-4,
  scale: 83e-4,
  enterprise: 8e-3
};
var UC_FLOOR_RATE_USD = UC_INCLUDED_RATE_USD.enterprise;
function assertNonNegative(field, value, integer) {
  if (!Number.isFinite(value) || value < 0 || integer && !Number.isInteger(value)) {
    throw new RangeError(
      `${field} must be a ${integer ? "non-negative integer" : "non-negative number"}, got ${String(
        value
      )}`
    );
  }
}
function computeTurnUsageCredits(input) {
  assertNonNegative("tokenCostUsd", input.tokenCostUsd, false);
  const messages = input.messages ?? 0;
  const mcpCalls = input.mcpCalls ?? 0;
  const endpointCalls = input.endpointCalls ?? 0;
  const insights = input.insights ?? 0;
  const enrichments = input.enrichments ?? 0;
  assertNonNegative("messages", messages, true);
  assertNonNegative("mcpCalls", mcpCalls, true);
  assertNonNegative("endpointCalls", endpointCalls, true);
  assertNonNegative("insights", insights, true);
  assertNonNegative("enrichments", enrichments, true);
  const tokenUc = input.byok === true ? 0 : input.tokenCostUsd / UC_TOKEN_COGS_ANCHOR_USD;
  const platformUc = messages * UC_PER_MESSAGE + mcpCalls * UC_PER_MCP_CALL + endpointCalls * UC_PER_ENDPOINT_CALL + insights * UC_PER_INSIGHT + enrichments * UC_PER_ENRICHMENT;
  return tokenUc + platformUc;
}
function grossMarginAtRate(turnCogsUsd, uc, ratePerUc) {
  const revenue = uc * ratePerUc;
  if (revenue <= 0) {
    return 0;
  }
  return (revenue - turnCogsUsd) / revenue;
}

// src/pricing/posted-price.ts
var POSTED_ANSWER_UC = 6;
var POSTED_ACTED_ONLY_UC = 15;
var POSTED_LOOKED_UP_ONLY_UC = 18;
var POSTED_ACTED_AND_LOOKED_UP_UC = 30;
var POSTED_PRICE_TABLE = {
  answer: POSTED_ANSWER_UC,
  acted: POSTED_ACTED_ONLY_UC,
  lookedUp: POSTED_LOOKED_UP_ONLY_UC,
  both: POSTED_ACTED_AND_LOOKED_UP_UC
};
var POSTED_STANDALONE_TOOL_CALL_UC = POSTED_ANSWER_UC;
var POSTED_PRICE_SET = [
  POSTED_ANSWER_UC,
  POSTED_ACTED_ONLY_UC,
  POSTED_LOOKED_UP_ONLY_UC,
  POSTED_ACTED_AND_LOOKED_UP_UC
];
function postedRungId(flags) {
  if (flags.acted) return flags.lookedUp ? "both" : "acted";
  return flags.lookedUp ? "lookedUp" : "answer";
}
function postedInteractionPrice(flags) {
  return POSTED_PRICE_TABLE[postedRungId(flags)];
}
var POSTED_MIX_MEASURED_2026_09_10 = {
  answer: 281,
  acted: 725,
  lookedUp: 114,
  both: 56
};
function postedBlendedAverageUc(mix) {
  let interactions = 0;
  let credits = 0;
  for (const rung of Object.keys(POSTED_PRICE_TABLE)) {
    const count6 = Math.max(0, mix[rung]);
    if (!Number.isFinite(count6)) continue;
    interactions += count6;
    credits += count6 * POSTED_PRICE_TABLE[rung];
  }
  return interactions > 0 ? credits / interactions : 0;
}
var POSTED_BLENDED_AVERAGE_UC = Math.round(
  postedBlendedAverageUc(POSTED_MIX_MEASURED_2026_09_10)
);
function postedInteractionsForUsageCredits(allowanceUc) {
  const uc = Number.isFinite(allowanceUc) && allowanceUc > 0 ? allowanceUc : 0;
  return {
    simple: Math.floor(uc / Math.min(...POSTED_PRICE_SET)),
    full: Math.floor(uc / Math.max(...POSTED_PRICE_SET))
  };
}

// src/pricing/uc-overflow.ts
function resolveUcGateOutcome(input) {
  if (input.allowanceUsageCredits < 0) return "within";
  if (input.usedUsageCredits < input.allowanceUsageCredits) return "within";
  return input.overageOptIn ? "overage" : "paused";
}
function overageUsageCredits(usedUsageCredits, allowanceUsageCredits) {
  if (allowanceUsageCredits < 0) return 0;
  return Math.max(0, usedUsageCredits - allowanceUsageCredits);
}
function computeOverageUsd(overage, rateUsd = UC_PAYG_RATE_USD) {
  if (!Number.isFinite(overage) || overage <= 0) return 0;
  return Math.round(overage * rateUsd * 100) / 100;
}

// src/pricing/uc-overage-alarms.ts
var UC_OVERAGE_SWEEP_CHARGED_UNRECORDED_LOG = "[billing] cu-overage sweep \u2014 charged-unrecorded rows need operator reconciliation";
var UC_OVERAGE_SWEEP_FAILED_LOG = "[billing] cu-overage sweep failed";
var UC_OVERAGE_SWEEP_OVER_CAP_LOG = "[billing] cu-overage sweep \u2014 over-cap charges need operator approval";

// src/pricing/uc-tiers.ts
var UC_TIERS = {
  starter: {
    tier: "starter",
    displayName: "Starter",
    monthlyPriceUsd: 299,
    includedUsageCredits: 3e4,
    seatCap: 5
  },
  growth: {
    tier: "growth",
    displayName: "Growth",
    monthlyPriceUsd: 999,
    includedUsageCredits: 11e4,
    seatCap: 10
  },
  scale: {
    tier: "scale",
    displayName: "Scale",
    monthlyPriceUsd: 2999,
    includedUsageCredits: 36e4,
    seatCap: 25
  },
  enterprise: {
    tier: "enterprise",
    displayName: "Enterprise",
    monthlyPriceUsd: null,
    includedUsageCredits: -1,
    seatCap: -1
  }
};
var UC_TIER_IDS = ["starter", "growth", "scale", "enterprise"];
function getUcTier(tier) {
  if (!(tier in UC_TIERS)) {
    throw new Error(`Unknown UC tier: ${tier}`);
  }
  return UC_TIERS[tier];
}
function effectiveIncludedRateUsd(tier) {
  const t = getUcTier(tier);
  if (t.monthlyPriceUsd === null || t.includedUsageCredits <= 0) {
    return null;
  }
  return t.monthlyPriceUsd / t.includedUsageCredits;
}

// src/pricing/usage-log-kinds.ts
var RESOLUTION_BILLING_KIND = "resolution_billing";
function isResolutionBillingMetadata(metadata) {
  return typeof metadata === "object" && metadata !== null && !Array.isArray(metadata) && metadata.kind === RESOLUTION_BILLING_KIND;
}

// src/pricing/trial-grant.ts
function resolveGrantState(grant, nowMs) {
  if (grant === null) return "none";
  if (grant.revokedAtMs !== null && grant.revokedAtMs <= nowMs) return "revoked";
  return grant.expiresAtMs > nowMs ? "active" : "expired";
}
function grantDaysLeft(grant, nowMs) {
  if (resolveGrantState(grant, nowMs) !== "active" || grant === null) return 0;
  const MS_PER_DAY = 864e5;
  return Math.max(1, Math.ceil((grant.expiresAtMs - nowMs) / MS_PER_DAY));
}

// src/pricing/workspace-access.ts
function lockedReasonForGrant(state, subscription) {
  if (subscription === "ended") return "subscription-canceled";
  if (state === "expired") return "grant-expired";
  if (state === "revoked") return "grant-revoked";
  return "no-entitlement";
}
function resolveWorkspaceAccess(input) {
  if (input.subscription === "paying") {
    return { locked: false, reason: "subscribed" };
  }
  const grantState = resolveGrantState(input.grant, input.nowMs);
  if (grantState === "active") {
    return { locked: false, reason: "granted-trial" };
  }
  return { locked: true, reason: lockedReasonForGrant(grantState, input.subscription) };
}

// src/pricing/discount-eligibility.ts
var ANNUAL_PREPAY_DISCOUNT_FRACTION = 0.1;

// src/pricing/payment-rail.ts
var PADDLE_RAIL_FEE = {
  /** Share of collected revenue the rail keeps (0.05 = 5%). */
  rate: 0.05,
  /** Flat fee per settled transaction, USD. */
  fixedPerTransactionUsd: 0.5
};
function railFeeUsd(revenueUsd, transactions) {
  if (revenueUsd < 0 || transactions < 0) {
    throw new Error(
      `railFeeUsd: negative input (revenueUsd=${revenueUsd}, transactions=${transactions}) \u2014 a fee can never be a refund`
    );
  }
  return PADDLE_RAIL_FEE.rate * revenueUsd + PADDLE_RAIL_FEE.fixedPerTransactionUsd * transactions;
}

// src/pricing/tier-entitlements.ts
var TIER_ENTITLEMENTS = {
  starter: {
    brandingRemoval: false,
    channelB: false,
    conversationRetentionDays: 30,
    enrichment: true,
    customDomain: false
  },
  growth: {
    brandingRemoval: true,
    channelB: true,
    conversationRetentionDays: 90,
    enrichment: true,
    customDomain: true
  },
  scale: {
    brandingRemoval: true,
    channelB: true,
    conversationRetentionDays: 365,
    enrichment: true,
    customDomain: true
  },
  enterprise: {
    brandingRemoval: true,
    channelB: true,
    conversationRetentionDays: 90,
    enrichment: true,
    customDomain: true
  }
};
function entitlementsFor(tier) {
  return TIER_ENTITLEMENTS[tier];
}
var FRONTIER_FEATURE_CLASSES = ["tier_on", "opt_in", "opt_in_free"];
var FRONTIER_OUTCOME_SURFACES = [
  "actions_completed",
  "dashboards_pinned",
  "automations_run"
];
var FRONTIER_FEATURE_KEY_PATTERN = /^[a-z][a-z0-9]*(?:_[a-z0-9]+)*$/;
var FRONTIER_FEATURE_KEY_MAX_LENGTH = 64;
var frontierFeatureDefinitionSchema = /* @__PURE__ */ z.object({
  /** Stable snake_case key — the flag key in `frontier_feature_state` and the env-kill-var stem. */
  key: z.string().min(1).max(FRONTIER_FEATURE_KEY_MAX_LENGTH).regex(FRONTIER_FEATURE_KEY_PATTERN),
  /** Cost class — decides whether a budget cap exists. Never the default state. */
  class: z.enum(FRONTIER_FEATURE_CLASSES),
  /**
   * The state the resolution ladder returns when the tenant has NO
   * `frontier_feature_state` row (ADR-0334). Required and explicit — a feature
   * may never inherit its default from its cost class. `true` means the
   * customer's switch is the OFF path; kills at every rung still win.
   */
  defaultEnabled: z.boolean(),
  /**
   * Registry default for the per-feature monthly budget cap (USD).
   * REQUIRED for `opt_in` (a cost-heavy feature without a cap is a spend
   * hole); FORBIDDEN for `tier_on` (nothing to cap — declaring one would
   * imply cost machinery that does not exist).
   */
  defaultMonthlyBudgetUsd: z.number().positive().optional(),
  /** Which outcome counters the feature emits (reported, not billed). */
  outcomeSurfaces: z.array(z.enum(FRONTIER_OUTCOME_SURFACES)).readonly()
}).refine((f) => f.class === "opt_in" === (f.defaultMonthlyBudgetUsd !== void 0), {
  message: "opt_in features require defaultMonthlyBudgetUsd; tier_on/opt_in_free features must not declare one"
});
var FRONTIER_FEATURES = [
  // F1-4/F1-5/F1-6 (ADR-0167) — Copilot Mode: the ui.* tool family (navigate /
  // highlight / fill derived from the authored catalog). tier_on: derivation +
  // execution add no LLM cost machinery of their own; the safety ladder
  // (per-surface opt-in, capability enablement, confirm gates, provenance
  // invariant) governs exposure — not a budget.
  {
    key: "copilot_mode",
    class: "tier_on",
    defaultEnabled: true,
    outcomeSurfaces: ["actions_completed"]
  },
  // F2-6 (ADR-0169 § 3) — WebMCP surface: the widget declares catalog tools on
  // document.modelContext for browser agents. Execution rides the existing
  // widget tool seam (its metering/caps), so the feature itself has no cost
  // machinery — hence opt_in_free, not opt_in. ADR-0334 reverses the ADR-0169 §3
  // default-OFF lock: the manifest ships by default and the customer switch (or
  // any kill rung) is the OFF path. Declared tools are still filtered by
  // capability enablement, and invocation still runs the full side-effect gate.
  {
    key: "webmcp",
    class: "opt_in_free",
    defaultEnabled: true,
    outcomeSurfaces: ["actions_completed"]
  },
  // F4-5 (ADR-0192) — User Learning: per-end-user learned memory + personalization.
  // opt_in: the nightly batch extraction is real LLM spend, so a monthly budget
  // cap gates the extraction submit leg (injection itself adds no LLM calls).
  // Learning only ever activates for VERIFIED end users (turnAuth.sub !== '') —
  // the budget is the cost ceiling, the identity gate is the privacy ceiling.
  // ADR-0334 defaults it ON: the cap, not a missing row, is what bounds spend.
  // NOTE (ADR-0334 § Consequences): this is the one entry whose default-ON has a
  // controller-side privacy consequence, so the operator accepted it explicitly;
  // the end-user-facing memory transparency panel stays counsel-gated (PR-15).
  {
    key: "user_learning",
    class: "opt_in",
    defaultEnabled: true,
    defaultMonthlyBudgetUsd: 25,
    outcomeSurfaces: []
  },
  // AUP (ADR-0432) — Visitor Learning: pseudonymous identity + per-visitor
  // learned memory/personalization for SIGNED-OUT visitors (the anon:<uuid>
  // subject class). opt_in: visitor extraction is real LLM spend over an
  // unbounded population, so it carries its OWN monthly budget cap — a
  // farming attack exhausts the visitor budget, never the verified users'
  // `user_learning` cap. defaultEnabled: true is the operator's explicit
  // default-ON-at-ship election (decision batch 2026-08-01(b), risk
  // acceptance recorded in ADR-0432 § Consequences); the customer's Users →
  // Settings switch is the OFF path, and `FRONTIER_KILL=visitor_learning` is
  // the fleet-wide incident/counsel-remedy lever (ADR-0468 — the key is
  // unchanged; only the variable carrying it merged). The action plane is
  // untouched either way — a visitor sub never confirms, never holds scopes
  // (subject-class guards, Phase A).
  {
    key: "visitor_learning",
    class: "opt_in",
    defaultEnabled: true,
    defaultMonthlyBudgetUsd: 10,
    outcomeSurfaces: []
  },
  // F3-1b (SYN-431) — Generative dashboards: the reserved `present_dashboard`
  // tool lets the agent compose several existing presentation primitives
  // (chart/metric/funnel/…) into one dashboard. opt_in_free: it is
  // presentation-only and its multi-read planning rides the EXISTING per-turn
  // metering + spend caps + the ≤8-item composition bound, so the feature has no
  // cost machinery of its own — no budget. The `dashboards_pinned` outcome
  // surface belongs to the F3-1c pinning sibling; this mechanism slice emits none.
  { key: "generative_dashboards", class: "opt_in_free", defaultEnabled: true, outcomeSurfaces: [] },
  // UGL-107 (§ B2 / § 9.1) — Engagement AI: the LLM-composed campaign copy that
  // drafts localized proactive nudge/campaign messages (B6b). opt_in: real LLM
  // spend, so the $50 monthly budget caps the compose leg. `automations_run` is
  // the proactive-fire outcome surface it reports on.
  //
  // The three UGL entries below all declare `defaultEnabled: true` per ADR-0334.
  // This registry decides only whether a Frontier tenant HAS the feature; the
  // NIGHTLY PASSES are gated separately by their own env vars
  // (`LEARNING_PROPOSAL_DRAFTER_ENABLED`, `AUDIENCE_PROPOSAL_DRAFTER_ENABLED`,
  // `GLOBAL_CLUSTER_DRAFTER_ENABLED`, `QUALITY_EVAL_ENABLED`), which ADR-0508
  // flipped default-ON — each var is now the KILL rather than the enabler, and
  // `CANARY_ROLLBACK_ENABLED` is the one that stays default-OFF. So what bounds
  // the spend is the budget cap, not a dark flag and not a missing row, exactly
  // as main's `user_learning` entry reasons. (These lines cited a "every
  // learning loop is default-OFF" stance in `.claude/rules/security.md` until
  // 2026-08-18; that document had already been swept to the ADR-0508 state, so
  // the citation was stale in its claim AND in its attribution.)
  {
    key: "engagement_ai",
    class: "opt_in",
    defaultEnabled: true,
    defaultMonthlyBudgetUsd: 50,
    outcomeSurfaces: ["automations_run"]
  },
  // UGL-107 (§ 7 / § 9.1) — Reactive learning loop: the nightly analysis that
  // turns conversation outcomes into catalog/prompt improvement proposals.
  // opt_in: the batch analysis is real LLM spend, budget-capped at $50/mo. Emits
  // no outcome counter of its own (its output is the proposal queue, not a fire
  // count). The nightly pass itself rides `LEARNING_PROPOSAL_DRAFTER_ENABLED`,
  // default-ON since ADR-0508 and bounded by this entry's budget cap.
  {
    key: "learning_loop",
    class: "opt_in",
    defaultEnabled: true,
    defaultMonthlyBudgetUsd: 50,
    outcomeSurfaces: []
  },
  // Business Success Visibility 4.3 — the NL→success-metric compiler: an
  // operator describes a business metric in their own words and gets back a
  // REVIEWABLE, schema-valid definition to edit and save.
  //
  // Its OWN entry rather than a rung on `learning_loop`, whose domain (nightly
  // conversation analysis → operator proposals) is the closest match. ADR-0458
  // § 7 is why: that feature's $50 cap is DECLARED and read by nothing, because
  // no lane meters spend under its key — and the ADR states the trap outright,
  // that a gate landing before the meter "would evaluate `0 < 50` forever, pass
  // every test, and look exactly like enforcement". Metering only this consumer
  // under a shared key would be that shape one step along: a cap reading
  // "the feature's monthly spend" while measuring one of its spenders.
  //
  // Reusing `user_learning` — the audience compiler's precedent — is wrong for
  // a different reason. That switch is a PRIVACY decision about end users'
  // learned memory (its entry above records the controller-side consequence the
  // operator accepted explicitly), so an operator turning it off to stop storing
  // memory would silently lose an unrelated authoring aid.
  //
  // opt_in: one cheap-class completion per operator click is small, and small is
  // not bounded — an authoring surface with a button has no natural ceiling. The
  // budget is deliberately modest: thousands of compiles at this size, and a
  // number an operator can read as "this cannot surprise me".
  {
    key: "metric_compiler",
    class: "opt_in",
    defaultEnabled: true,
    defaultMonthlyBudgetUsd: 10,
    outcomeSurfaces: []
  },
  // UGL-107 (§ 9 / C-21-adjacent) — Quality monitoring: the always-on LLM-judge
  // augmentation lane over the shipped precision-first detectors. opt_in: the
  // judge pass is real inference spend, $50/mo budget-capped. A DETECTION
  // surface — no fire/outcome counter. Its grading pass stays behind
  // `QUALITY_EVAL_ENABLED`.
  {
    key: "quality_monitoring",
    class: "opt_in",
    defaultEnabled: true,
    defaultMonthlyBudgetUsd: 50,
    outcomeSurfaces: []
  }
];
function findFrontierFeature(key) {
  return FRONTIER_FEATURES.find((f) => f.key === key);
}

// src/pricing/frontier-kill-policy.ts
var FRONTIER_KILL_ENV_VAR = "FRONTIER_KILL";
var FRONTIER_KILL_ALL = "*";
var FRONTIER_NON_REGISTRY_KILL_KEYS = ["mcp_apps"];
function frontierKillableKeys() {
  return [...FRONTIER_FEATURES.map((f) => f.key), ...FRONTIER_NON_REGISTRY_KILL_KEYS].sort();
}
function legacyFrontierKillVars() {
  return frontierKillableKeys().map((key) => `FRONTIER_${key.toUpperCase()}_ENABLED`);
}
function parseFrontierKillPolicy(raw) {
  const tokens = (raw ?? "").split(",").map((token) => token.trim().toLowerCase()).filter((token) => token.length > 0);
  if (tokens.length === 0) return { killAll: false, killedKeys: [] };
  if (tokens.includes(FRONTIER_KILL_ALL)) return { killAll: true, killedKeys: [] };
  const killable = new Set(frontierKillableKeys());
  const unknown = tokens.filter((token) => !killable.has(token));
  if (unknown.length > 0) {
    throw new Error(
      `${FRONTIER_KILL_ENV_VAR}: unknown Frontier feature ${unknown.length === 1 ? "key" : "keys"} ${unknown.join(", ")}. Valid keys: ${frontierKillableKeys().join(", ")} (or "${FRONTIER_KILL_ALL}" to kill the whole layer).`
    );
  }
  return { killAll: false, killedKeys: [...new Set(tokens)].sort() };
}
function isFrontierKilled(policy, featureKey) {
  return policy.killAll || policy.killedKeys.includes(featureKey);
}

// src/scheduling/docs-sync-sweep.ts
var DOCS_SYNC_SWEEP_EVENT_KIND = "syncanix.docs.sync-sweep";

// src/scheduling/lambda-handler-manifest.ts
var LAMBDA_HANDLERS = Object.freeze([
  {
    module: "main",
    source: "src/main.ts",
    functionSuffix: "api",
    trigger: "http",
    description: "The NestJS + Apollo API behind the Lambda Function URL."
  },
  {
    module: "stream",
    source: "src/stream.ts",
    functionSuffix: "api-stream",
    trigger: "http",
    description: "The same NestJS app behind a RESPONSE_STREAM Function URL, serving only the three conversation stream routes (plan/response-streaming)."
  },
  {
    module: "probe-handler",
    source: "src/probes/probe-handler.ts",
    functionSuffix: "probe",
    trigger: "scheduled",
    description: "AF-282 nightly cross-tenant isolation probe matrix."
  },
  {
    module: "mv-refresh-handler",
    source: "src/mv-refresh-handler.ts",
    functionSuffix: "mv-refresh",
    trigger: "scheduled",
    description: "AF-371 five-minute analytics materialized-view refresh."
  },
  {
    module: "anomaly-sweep-handler",
    source: "src/probes/anomaly-sweep-handler.ts",
    functionSuffix: "anomaly-sweep",
    trigger: "scheduled",
    description: "C2e/AF-186 hourly per-tenant cost-anomaly sweep."
  },
  {
    module: "margin-report-handler",
    source: "src/probes/margin-report-handler.ts",
    functionSuffix: "margin-report",
    trigger: "scheduled",
    description: "C3/AF-244 daily gross-margin report."
  },
  {
    module: "insights-handler",
    source: "src/insights-handler.ts",
    functionSuffix: "insights",
    trigger: "scheduled",
    description: "Conversation-insights nightly fan-out (submit/poll/digest)."
  },
  {
    module: "dsar-fulfillment-handler",
    source: "src/probes/dsar-fulfillment-handler.ts",
    functionSuffix: "dsar-fulfillment",
    trigger: "scheduled",
    description: "C26 daily DSAR fulfilment drain."
  },
  {
    module: "demo-reaper-handler",
    source: "src/demo-reaper-handler.ts",
    functionSuffix: "demo-reaper",
    trigger: "scheduled",
    description: "SYN-271 daily demo-tenant TTL reaper."
  },
  {
    module: "overage-charge-handler",
    source: "src/probes/overage-charge-handler.ts",
    functionSuffix: "overage-charge",
    trigger: "scheduled",
    description: "SYN-342 month-end usage-credit overage charge sweep.",
    invocationCadence: "monthly"
  },
  {
    module: "mcp-task-reaper-handler",
    source: "src/mcp-task-reaper-handler.ts",
    functionSuffix: "mcp-task-reaper",
    trigger: "scheduled",
    description: "Reaps abandoned long-running MCP tasks."
  },
  {
    module: "monitoring-metric-snapshot-handler",
    source: "src/monitoring-metric-snapshot-handler.ts",
    functionSuffix: "metric-snapshot",
    trigger: "scheduled",
    description: "W10a nightly exec-report metric snapshot."
  },
  {
    module: "workspace-purge-handler",
    source: "src/probes/workspace-purge-handler.ts",
    functionSuffix: "workspace-purge",
    trigger: "scheduled",
    description: "T21 soft-deleted workspace purge after the restore window."
  },
  {
    module: "catalog-seed-handler",
    source: "src/catalog-seed-handler.ts",
    functionSuffix: "catalog-seed",
    trigger: "scheduled",
    description: "SYN-793 nightly most-used-tool seed recompute."
  },
  {
    module: "workspace-migration-handler",
    source: "src/workspace-migration-handler.ts",
    functionSuffix: "workspace-migration",
    trigger: "manual",
    description: "ADR-0767 operator-run workspace migration between owner accounts (plan/execute/verify/rollback/list/scrub)."
  },
  {
    module: "interaction-ingest-handler",
    source: "src/interaction-ingest-handler.ts",
    functionSuffix: "telemetry-ingest",
    trigger: "event",
    description: "Drains the interaction-capture SQS queue into Aurora."
  },
  {
    module: "interaction-rollup-handler",
    source: "src/interaction-rollup-handler.ts",
    functionSuffix: "telemetry-rollup",
    trigger: "scheduled",
    description: "Folds the prior day of captured interactions per tenant."
  },
  {
    module: "interaction-profile-handler",
    source: "src/interaction-profile-handler.ts",
    functionSuffix: "telemetry-profile",
    trigger: "scheduled",
    description: "Rebuilds per-tenant interaction profiles from the rollups."
  }
]);
function lambdaHandlerString(entry) {
  return `${entry.module}.handler`;
}
function lambdaFunctionName(entry, environment) {
  return `syncanix-${entry.functionSuffix}-${environment}`;
}
var REVIEW_PROMPT_RESOLUTION_THRESHOLD = 100;
var REVIEW_PROMPT_COOLDOWN_DAYS = 30;
var REVIEW_PROMPT_MAX_DISMISSALS = 2;
var ReviewPlatformSchema = /* @__PURE__ */ z.enum(["g2", "capterra"]);
var REVIEW_PLATFORMS = {
  g2: {
    id: "g2",
    label: "G2",
    categories: ["Conversational AI Platforms", "Chatbots"]
  },
  capterra: {
    id: "capterra",
    label: "Capterra",
    categories: ["Conversational AI Platforms", "Chatbots"]
  }
};
var REVIEW_INCENTIVE = {
  amountUsd: 50,
  rewardLabel: "$50 Amazon gift card + Syncanix swag",
  /** Reward is conditioned on a *verified* review, never on a positive one. */
  requiresVerifiedReview: true
};
var ReviewPromptStateSchema = /* @__PURE__ */ z.object({
  /** Lifetime resolved-conversation count for the workspace. */
  resolutionsCount: z.number().int().nonnegative(),
  /** True once the workspace has left a review on any platform. */
  hasReviewed: z.boolean(),
  /** How many times the prompt has been shown + dismissed. */
  dismissedCount: z.number().int().nonnegative(),
  /** ISO-8601 of the last time the prompt was shown; absent if never. */
  lastPromptedAtIso: z.string().datetime().optional(),
  /** Platforms the workspace has already reviewed on (skip those). */
  reviewedPlatforms: z.array(ReviewPlatformSchema).default([]),
  /** Current time (injected — module stays clock-free). */
  nowIso: z.string().datetime()
});
function daysBetween(fromIso, toIso) {
  return (Date.parse(toIso) - Date.parse(fromIso)) / (1e3 * 60 * 60 * 24);
}
function evaluateReviewPrompt(input) {
  const state = ReviewPromptStateSchema.parse(input);
  const remaining = Object.keys(REVIEW_PLATFORMS).filter(
    (p) => !state.reviewedPlatforms.includes(p)
  );
  if (state.hasReviewed && remaining.length === 0) {
    return { shouldPrompt: false, reason: "already reviewed on every platform" };
  }
  if (remaining.length === 0) {
    return { shouldPrompt: false, reason: "no remaining platforms to review on" };
  }
  if (state.resolutionsCount < REVIEW_PROMPT_RESOLUTION_THRESHOLD) {
    return {
      shouldPrompt: false,
      reason: `below the ${String(REVIEW_PROMPT_RESOLUTION_THRESHOLD)}-resolution threshold`
    };
  }
  if (state.dismissedCount >= REVIEW_PROMPT_MAX_DISMISSALS) {
    return { shouldPrompt: false, reason: "dismissal cap reached (anti-nag)" };
  }
  if (state.lastPromptedAtIso !== void 0 && daysBetween(state.lastPromptedAtIso, state.nowIso) < REVIEW_PROMPT_COOLDOWN_DAYS) {
    return { shouldPrompt: false, reason: "within the cooldown window since the last prompt" };
  }
  const platform = remaining.includes("g2") ? "g2" : remaining[0];
  if (platform === void 0) {
    return { shouldPrompt: false, reason: "no remaining platforms to review on" };
  }
  return {
    shouldPrompt: true,
    platform,
    reason: `eligible: ${String(state.resolutionsCount)} resolutions, past cooldown`
  };
}

// src/schema-infer/infer-json-schema.ts
function inferJsonSchema(value) {
  if (value === null) return { type: "null" };
  if (Array.isArray(value)) {
    if (value.length === 0) return { type: "array" };
    return { type: "array", items: mergeSchemas(value.map((item) => inferJsonSchema(item))) };
  }
  const kind = typeof value;
  if (kind === "object") {
    const obj = value;
    const keys = Object.keys(obj);
    const properties = {};
    for (const key of keys) properties[key] = inferJsonSchema(obj[key]);
    return keys.length > 0 ? { type: "object", properties, required: keys } : { type: "object", properties };
  }
  if (kind === "number") return { type: Number.isInteger(value) ? "integer" : "number" };
  if (kind === "boolean") return { type: "boolean" };
  if (kind === "string") return { type: "string" };
  return {};
}
function inferJsonSchemaFromText(text) {
  let parsed;
  try {
    parsed = JSON.parse(text);
  } catch {
    return null;
  }
  return JSON.stringify(inferJsonSchema(parsed), null, 2);
}
function mergeSchemas(schemas) {
  const first = schemas[0];
  if (first === void 0) return {};
  if (schemas.every((schema) => schema.type === "object")) {
    return mergeObjectSchemas(schemas);
  }
  const types = new Set(schemas.map((schema) => schema.type));
  if (types.size === 1) return first.type === void 0 ? {} : { type: first.type };
  if (types.size === 2 && types.has("integer") && types.has("number")) return { type: "number" };
  return {};
}
function mergeObjectSchemas(schemas) {
  const properties = {};
  for (const schema of schemas) {
    for (const [key, propSchema] of Object.entries(schema.properties ?? {})) {
      properties[key] ??= propSchema;
    }
  }
  const required = Object.keys(properties).filter(
    (key) => schemas.every((schema) => (schema.required ?? []).includes(key))
  );
  return required.length > 0 ? { type: "object", properties, required } : { type: "object", properties };
}

// src/scope/scope-policy.ts
var PLATFORM_SCOPE_RULE_IDS = [
  "otherCustomers",
  "internalProbes",
  "selfDisclosure"
];
var SENSITIVE_DOMAINS = ["legal", "medical", "financial_advice"];
var SENSITIVE_DOMAIN_HANDLINGS = [
  /** D18's default — decline, and offer the escalation instead. */
  "refuse_with_offer",
  /** Answer, but say plainly that it is not professional advice. */
  "answer_with_disclaimer",
  /** The workspace IS in this domain (a law firm's own agent). Answer normally. */
  "allow"
];
var COMPETITOR_HANDLINGS = [
  /** D18's default — acknowledge the question, redirect to this workspace. */
  "acknowledge_and_redirect",
  /** Decline to discuss another company at all. */
  "refuse",
  /** Answer from the workspace's own published material only. */
  "answer_factually"
];
var ESCALATION_KINDS = [
  /** The site's own lead form, mirrored as a card (ADR-0774). */
  "lead_form",
  /** A route on the site — a contact page, a help centre. */
  "contact_route",
  /** The workspace's own registered host action. */
  "human_hook",
  /** Nothing to offer. The refusal stands alone; the operator chose this. */
  "none"
];
var DEFAULT_SCOPE_POLICY = {
  allowedTopics: [],
  refusedTopics: ["politics"],
  sensitiveDomains: {
    legal: "refuse_with_offer",
    medical: "refuse_with_offer",
    financial_advice: "refuse_with_offer"
  },
  competitorHandling: "acknowledge_and_redirect",
  escalation: { kind: "none", target: "" }
};
var MAX_SCOPE_TOPICS = 25;
var MAX_SCOPE_TOPIC_GRAPHEMES = 64;
var MAX_ESCALATION_TARGET_GRAPHEMES = 200;
function validateScopeTopics(field, topics) {
  const problems = [];
  if (topics.length > MAX_SCOPE_TOPICS) problems.push({ field, reason: "too_many", index: -1 });
  const seen = /* @__PURE__ */ new Set();
  topics.forEach((topic, index) => {
    const trimmed = topic.trim();
    if (trimmed.length === 0) {
      problems.push({ field, reason: "empty", index });
      return;
    }
    if (countGraphemes(trimmed) > MAX_SCOPE_TOPIC_GRAPHEMES) {
      problems.push({ field, reason: "too_long", index });
    }
    const key = trimmed.toLocaleLowerCase();
    if (seen.has(key)) problems.push({ field, reason: "duplicate", index });
    seen.add(key);
  });
  return problems;
}
function validateScopeEscalation(escalation) {
  const target = escalation.target.trim();
  if (escalation.kind === "none") return [];
  if (target.length === 0) {
    return [{ field: "escalation", reason: "target_required", index: -1 }];
  }
  if (countGraphemes(target) > MAX_ESCALATION_TARGET_GRAPHEMES) {
    return [{ field: "escalation", reason: "too_long", index: -1 }];
  }
  return [];
}
function validateScopePolicy(policy) {
  return [
    ...validateScopeTopics("allowedTopics", policy.allowedTopics),
    ...validateScopeTopics("refusedTopics", policy.refusedTopics),
    ...validateScopeEscalation(policy.escalation)
  ];
}
var DOMAINS = new Set(SENSITIVE_DOMAINS);
var DOMAIN_HANDLINGS = new Set(SENSITIVE_DOMAIN_HANDLINGS);
var COMPETITORS = new Set(COMPETITOR_HANDLINGS);
var ESCALATIONS = new Set(ESCALATION_KINDS);
function isSensitiveDomain(value) {
  return DOMAINS.has(value);
}
function isSensitiveDomainHandling(value) {
  return DOMAIN_HANDLINGS.has(value);
}
function isCompetitorHandling(value) {
  return COMPETITORS.has(value);
}
function isEscalationKind(value) {
  return ESCALATIONS.has(value);
}

// src/mcp/protocol-version.ts
var MCP_PROTOCOL_VERSION_LEGACY = "2025-11-25";
var MCP_PROTOCOL_VERSION_STATELESS = "2026-07-28";
var SUPPORTED_MCP_PROTOCOL_VERSIONS = [
  MCP_PROTOCOL_VERSION_LEGACY,
  MCP_PROTOCOL_VERSION_STATELESS
];
var LATEST_MCP_PROTOCOL_VERSION = SUPPORTED_MCP_PROTOCOL_VERSIONS[SUPPORTED_MCP_PROTOCOL_VERSIONS.length - 1] ?? MCP_PROTOCOL_VERSION_STATELESS;

// src/secrets/tenant-secret-path.ts
function tenantSecretPath(env, tenantId, name) {
  if (env === "") {
    throw new Error("tenantSecretPath: env must not be empty");
  }
  if (tenantId === "") {
    throw new Error("tenantSecretPath: tenantId must not be empty");
  }
  if (name === "") {
    throw new Error("tenantSecretPath: name must not be empty");
  }
  return `/syncanix/${env}/tenant/${tenantId}/secret/${name}`;
}

// src/identity/subject-class.ts
var ANONYMOUS_SUB_PREFIX = "anon:";
function subjectClass(sub) {
  if (sub === "") return "none";
  if (sub.startsWith(ANONYMOUS_SUB_PREFIX)) return "pseudonymous";
  return "verified";
}
function isPseudonymousSub(sub) {
  return subjectClass(sub) === "pseudonymous";
}
var VISITOR_SUB_PATTERN = /^anon:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
function isVisitorSubShape(value) {
  return VISITOR_SUB_PATTERN.test(value);
}

// src/security/ssrf-classifier.ts
function isPrivateOrReservedIPv4(ip) {
  const parts = ip.split(".");
  if (parts.length !== 4) return true;
  const octets = parts.map((p) => Number(p));
  if (octets.some((o) => !Number.isInteger(o) || o < 0 || o > 255)) return true;
  const [a, b, c] = octets;
  if (a === 0) return true;
  if (a === 10) return true;
  if (a === 127) return true;
  if (a === 169 && b === 254) return true;
  if (a === 172 && b >= 16 && b <= 31) return true;
  if (a === 192 && b === 0 && c === 0) return true;
  if (a === 192 && b === 88 && c === 99) return true;
  if (a === 192 && b === 168) return true;
  if (a === 198 && (b === 18 || b === 19)) return true;
  if (a === 100 && b >= 64 && b <= 127) return true;
  if (a >= 224 && a <= 239) return true;
  if (a >= 240) return true;
  return false;
}
function isPrivateOrReservedIPv6(ip) {
  const parsed = ipv6ToHextets(ip);
  if (parsed === null) return true;
  const [h0, h1, h2, h3, h4, h5, h6, h7] = parsed;
  if (h0 === 0 && h1 === 0 && h2 === 0 && h3 === 0 && h4 === 0 && (h5 === 65535 || h5 === 0)) {
    return isPrivateOrReservedIPv4(embeddedIpv4(h6, h7));
  }
  if (h0 === 100 && h1 === 65435) {
    return isPrivateOrReservedIPv4(embeddedIpv4(h6, h7));
  }
  if (h0 >= 65152 && h0 <= 65215) return true;
  if (h0 >= 64512 && h0 <= 65023) return true;
  if ((h0 & 65280) === 65280) return true;
  return false;
}
function embeddedIpv4(hi, lo) {
  return `${hi >> 8 & 255}.${hi & 255}.${lo >> 8 & 255}.${lo & 255}`;
}
function ipv6ToHextets(ip) {
  let s = (ip.split("%")[0] ?? "").toLowerCase();
  if (s.length === 0) return null;
  const dotted = /^(.*:)(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/.exec(s);
  if (dotted) {
    const [a, b, c, d] = [dotted[2], dotted[3], dotted[4], dotted[5]].map((n) => Number(n));
    if (a === void 0 || b === void 0 || c === void 0 || d === void 0) return null;
    if ([a, b, c, d].some((n) => Number.isNaN(n) || n > 255)) return null;
    const hi = (a << 8 | b).toString(16);
    const lo = (c << 8 | d).toString(16);
    s = `${dotted[1] ?? ""}${hi}:${lo}`;
  }
  const halves = s.split("::");
  if (halves.length > 2) return null;
  const head = halves[0] ? halves[0].split(":") : [];
  let hextets;
  if (halves.length === 1) {
    hextets = head;
    if (hextets.length !== 8) return null;
  } else {
    const tail = halves[1] ? halves[1].split(":") : [];
    const missing = 8 - head.length - tail.length;
    if (missing < 1) return null;
    hextets = [...head, ...Array(missing).fill("0"), ...tail];
  }
  const nums = hextets.map(
    (g) => /^[0-9a-f]{1,4}$/.test(g) ? Number.parseInt(g, 16) : Number.NaN
  );
  if (nums.length !== 8 || nums.some((n) => Number.isNaN(n))) return null;
  return nums;
}

// src/security/deep-secret-redactor.ts
var REDACTED = "[REDACTED]";
var SECRET_KEYS = [
  "password",
  "passwd",
  "secret",
  "clientsecret",
  "client_secret",
  "token",
  "accesstoken",
  "access_token",
  "refreshtoken",
  "refresh_token",
  "idtoken",
  "id_token",
  "apikey",
  "api_key",
  "apisecret",
  "api_secret",
  "privatekey",
  "private_key",
  "authorization",
  "credential",
  "credentials",
  "sessionsecret",
  "signingkey",
  "signing_key",
  "bearer"
];
var SECRET_KEY_SET = new Set(SECRET_KEYS);
function isSecretKey(key) {
  return SECRET_KEY_SET.has(key.toLowerCase());
}
function redactSecretsDeep(value) {
  return redact(value);
}
function redact(value) {
  if (Array.isArray(value)) return value.map(redact);
  if (typeof value === "object" && value !== null) {
    const out = {};
    for (const [key, inner] of Object.entries(value)) {
      out[key] = isSecretKey(key) ? REDACTED : redact(inner);
    }
    return out;
  }
  if (typeof value === "string") return redactSecrets(value);
  return value;
}

// src/security/operator-text.ts
var EMAIL_SHAPE = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
function sanitiseOperatorText(text) {
  return redactSecrets(text).replace(EMAIL_SHAPE, "[email]");
}
function isOperatorTextClean(text) {
  return sanitiseOperatorText(text) === text;
}
var FORENSIC_EVENT_CLASSES = [
  // auth — AuthGuard (apps/api/src/core/auth)
  "auth.success",
  "auth.failure",
  "auth.token-refresh",
  "auth.session-revoked",
  // refusal — refusal middleware (AF-337/AF-338 + output filter)
  "refusal.policy",
  "refusal.abuse-pattern",
  "refusal.output-filter",
  // abuse — tool-abuse detector + suspension ladder (AF-319/AF-324)
  "abuse.pattern-detected",
  "abuse.tool-rate-limit-hit",
  "abuse.suspended",
  "abuse.banned",
  // key — key-rotation + leak detector (AF-192/AF-298)
  "key.issued",
  "key.rotated",
  "key.revoked",
  "key.leaked-detected",
  // isolation — cross-tenant probe suite + live boundary detector (AF-282)
  "isolation.cross-tenant-probe-positive",
  "isolation.cross-tenant-probe-negative",
  "isolation.boundary-broken",
  // incident — security-incident runbook (AF-334)
  "incident.declared",
  "incident.contained",
  "incident.post-mortem-attached"
];
var ForensicEventClassSchema = /* @__PURE__ */ z.enum(FORENSIC_EVENT_CLASSES);
var FORENSIC_EVENT_FAMILIES = [
  "auth",
  "refusal",
  "abuse",
  "key",
  "isolation",
  "incident"
];
function forensicEventFamily(eventClass) {
  const prefix = eventClass.slice(0, eventClass.indexOf("."));
  return prefix;
}
var FORENSIC_ACTORS = ["user", "system", "probe", "external"];
var FORENSIC_OUTCOMES = ["allowed", "denied", "detected", "dropped"];
var FORENSIC_SEVERITIES = ["info", "warn", "critical"];
var ISO_8601_MS_Z = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
var ForensicAuditBaseEnvelopeSchema = /* @__PURE__ */ z.object({
  eventClass: ForensicEventClassSchema,
  /** `null` only for pre-authentication events (e.g. `auth.failure` on signature mismatch). */
  tenantId: z.string().min(1).nullable(),
  /** Auth0 `sub` once known; `null` under the same pre-auth rule as `tenantId`. */
  userId: z.string().min(1).nullable(),
  /** AWS request id from Lambda Powertools. */
  requestId: z.string().min(1),
  timestamp: z.string().regex(ISO_8601_MS_Z, "timestamp must be UTC ISO-8601 ms with Z suffix"),
  actor: z.enum(FORENSIC_ACTORS),
  /** Present for `user`/`external`; `null` for `system`/`probe` (enforced below). */
  actorIp: z.string().min(1).nullable(),
  eventOutcome: z.enum(FORENSIC_OUTCOMES),
  eventReason: z.string(),
  resourceAffected: z.string().min(1).nullable(),
  severity: z.enum(FORENSIC_SEVERITIES),
  /** Powertools correlation id joining to the general operational logs. */
  correlationId: z.string().min(1)
}).superRefine((env, ctx) => {
  const networkActor = env.actor === "user" || env.actor === "external";
  if (networkActor && env.actorIp === null) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["actorIp"],
      message: `actorIp is required when actor is "${env.actor}"`
    });
  }
  if (!networkActor && env.actorIp !== null) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["actorIp"],
      message: `actorIp must be null when actor is "${env.actor}"`
    });
  }
});
var nonNegInt = /* @__PURE__ */ z.number().int().nonnegative();
var AuthEventPayloadSchema = /* @__PURE__ */ z.object({
  authMethod: z.string().min(1).optional(),
  tokenScope: z.string().min(1).optional(),
  tokenLifetimeSec: nonNegInt.optional(),
  clientType: z.string().min(1).optional(),
  failureClass: z.enum(["signature", "expired", "audience", "issuer", "format"]).optional(),
  attemptCountIp24h: nonNegInt.optional(),
  refreshTokenAgeSec: nonNegInt.optional(),
  refreshChainDepth: nonNegInt.optional(),
  revokeReason: z.enum(["operator", "automated", "user-request", "policy"]).optional(),
  sessionAgeSec: nonNegInt.optional()
}).strict();
var RefusalEventPayloadSchema = /* @__PURE__ */ z.object({
  policyClass: z.string().min(1).optional(),
  policyVersion: z.string().min(1).optional(),
  requestSurface: z.string().min(1).optional(),
  inputHash: z.string().min(1).optional(),
  patternClass: z.string().min(1).optional(),
  patternConfidence: z.number().min(0).max(1).optional(),
  filterClass: z.string().min(1).optional(),
  outputHash: z.string().min(1).optional(),
  modelId: z.string().min(1).optional()
}).strict();
var AbuseEventPayloadSchema = /* @__PURE__ */ z.object({
  patternId: z.string().min(1).optional(),
  patternConfidence: z.number().min(0).max(1).optional(),
  toolName: z.string().min(1).optional(),
  requestCountWindow: nonNegInt.optional(),
  rateLimitBucket: z.string().min(1).optional(),
  windowSec: nonNegInt.optional(),
  actualRate: z.number().nonnegative().optional(),
  allowedRate: z.number().nonnegative().optional(),
  suspensionDurationSec: nonNegInt.optional(),
  suspensionLadderRung: nonNegInt.optional(),
  triggerEventIds: z.array(z.string().min(1)).optional(),
  banScope: z.enum(["tenant", "user", "ip"]).optional(),
  appealUri: z.string().min(1).optional()
}).strict();
var KeyEventPayloadSchema = /* @__PURE__ */ z.object({
  keyType: z.string().min(1).optional(),
  keyFingerprint: z.string().min(1).optional(),
  keyScope: z.string().min(1).optional(),
  issuerActor: z.string().min(1).optional(),
  oldKeyFingerprint: z.string().min(1).optional(),
  newKeyFingerprint: z.string().min(1).optional(),
  rotationReason: z.string().min(1).optional(),
  revokeReason: z.string().min(1).optional(),
  revokerActor: z.string().min(1).optional(),
  leakChannel: z.string().min(1).optional(),
  leakDetectorSource: z.string().min(1).optional()
}).strict();
var IsolationEventPayloadSchema = /* @__PURE__ */ z.object({
  probeId: z.string().min(1).optional(),
  probeClass: z.string().min(1).optional(),
  sourceTenant: z.string().min(1).optional(),
  targetTenant: z.string().min(1).optional(),
  bypassPath: z.string().min(1).optional(),
  boundaryType: z.string().min(1).optional(),
  detectionPath: z.string().min(1).optional(),
  liveTrafficVolume: nonNegInt.optional()
}).strict();
var IncidentEventPayloadSchema = /* @__PURE__ */ z.object({
  incidentId: z.string().min(1).optional(),
  severity: z.enum(["sev1", "sev2", "sev3", "sev4"]).optional(),
  triggerClass: z.string().min(1).optional(),
  incidentCommander: z.string().min(1).optional(),
  containmentSteps: z.array(z.string().min(1)).optional(),
  containmentDurationSec: nonNegInt.optional(),
  postMortemUri: z.string().min(1).optional(),
  lessonsLearnedIds: z.array(z.string().min(1)).optional()
}).strict();
var FORENSIC_PAYLOAD_SCHEMAS = {
  auth: AuthEventPayloadSchema,
  refusal: RefusalEventPayloadSchema,
  abuse: AbuseEventPayloadSchema,
  key: KeyEventPayloadSchema,
  isolation: IsolationEventPayloadSchema,
  incident: IncidentEventPayloadSchema
};

// src/forensic-audit/forensic-event.ts
function validateForensicAuditEvent(input) {
  if (typeof input !== "object" || input === null) {
    return { ok: false, errors: ["forensic event must be an object"] };
  }
  const envelopeResult = ForensicAuditBaseEnvelopeSchema.safeParse(input);
  if (!envelopeResult.success) {
    return {
      ok: false,
      errors: envelopeResult.error.issues.map((i) => `${i.path.join(".")}: ${i.message}`)
    };
  }
  const payload = input.payload;
  const family = forensicEventFamily(envelopeResult.data.eventClass);
  const payloadResult = FORENSIC_PAYLOAD_SCHEMAS[family].safeParse(payload);
  if (!payloadResult.success) {
    return {
      ok: false,
      errors: payloadResult.error.issues.map((i) => `payload.${i.path.join(".")}: ${i.message}`)
    };
  }
  return {
    ok: true,
    event: { ...envelopeResult.data, payload: payloadResult.data }
  };
}

// src/voice/samples.ts
var CANONICAL_RESPONSE_KEYS = [
  "greetingDevMode",
  "greetingBranded",
  "idk",
  "destructiveConfirm",
  "errorApology",
  "rateLimitHit",
  "streamingInterrupted",
  "outOfScope",
  "toolCallInProgress",
  "toolCallComplete"
];
var CANONICAL_RESPONSES_EN = {
  greetingDevMode: "Hi. Ask me anything about your docs, or paste a question to get started.",
  greetingBranded: "Hi, I'm {name}. How can I help today?",
  idk: "I don't have that. Want me to search the docs, or escalate to a human?",
  destructiveConfirm: "This will delete {count} conversations. They can't be recovered. Confirm to continue.",
  errorApology: "Something failed on our end. Retrying. If this keeps happening, the trace ID is {traceId} \u2014 paste it in support and we'll have context.",
  rateLimitHit: "You've hit your limit for this hour. It resets at {resetTime}. Upgrade plan or wait.",
  streamingInterrupted: "Generation stopped. Restart, or refine your question.",
  outOfScope: "That's outside what I'm trained on for this site. Try {helpLink}.",
  toolCallInProgress: "Looking that up.",
  toolCallComplete: "Done. Here's what I found:"
};
var CANONICAL_RESPONSES_ES = {
  greetingDevMode: "Hola. Preg\xFAntame lo que quieras sobre tus documentos, o pega una pregunta para empezar.",
  greetingBranded: "Hola, soy {name}. \xBFEn qu\xE9 puedo ayudarte hoy?",
  idk: "No tengo eso. \xBFQuieres que busque en los documentos o que lo derive a una persona?",
  destructiveConfirm: "Esto eliminar\xE1 {count} conversaciones. No se pueden recuperar. Confirma para continuar.",
  errorApology: "Algo fall\xF3 de nuestro lado. Reintentando. Si esto sigue ocurriendo, el ID de seguimiento es {traceId}: p\xE9galo en soporte y tendremos el contexto.",
  rateLimitHit: "Has alcanzado tu l\xEDmite de esta hora. Se restablece a las {resetTime}. Mejora tu plan o espera.",
  streamingInterrupted: "La generaci\xF3n se detuvo. Reinicia o precisa tu pregunta.",
  outOfScope: "Eso est\xE1 fuera de lo que s\xE9 sobre este sitio. Prueba {helpLink}.",
  toolCallInProgress: "Buscando eso.",
  toolCallComplete: "Listo. Esto es lo que encontr\xE9:"
};
var CANONICAL_RESPONSES_FR = {
  greetingDevMode: "Bonjour. Posez-moi vos questions sur votre documentation, ou collez une question pour commencer.",
  greetingBranded: "Bonjour, je suis {name}. Comment puis-je vous aider aujourd'hui ?",
  idk: "Je n'ai pas cette information. Voulez-vous que je cherche dans la documentation ou que je transmette \xE0 une personne ?",
  destructiveConfirm: "Cette action supprimera {count} conversations. Elles sont irr\xE9cup\xE9rables. Confirmez pour continuer.",
  errorApology: "Une erreur est survenue de notre c\xF4t\xE9. Nouvelle tentative en cours. Si cela persiste, l'identifiant de suivi est {traceId} \u2014 transmettez-le au support et nous aurons le contexte.",
  rateLimitHit: "Vous avez atteint votre limite pour cette heure. Elle se r\xE9initialise \xE0 {resetTime}. Am\xE9liorez votre offre ou patientez.",
  streamingInterrupted: "G\xE9n\xE9ration interrompue. Red\xE9marrez ou pr\xE9cisez votre question.",
  outOfScope: "Cela d\xE9passe ce pour quoi je suis form\xE9 sur ce site. Essayez {helpLink}.",
  toolCallInProgress: "Je cherche cela.",
  toolCallComplete: "Termin\xE9. Voici ce que j'ai trouv\xE9 :"
};
var CANONICAL_RESPONSES_DE = {
  greetingDevMode: "Hallo. Fragen Sie mich alles zu Ihrer Dokumentation, oder f\xFCgen Sie eine Frage ein, um zu beginnen.",
  greetingBranded: "Hallo, ich bin {name}. Wie kann ich Ihnen heute helfen?",
  idk: "Das habe ich nicht. Soll ich die Dokumentation durchsuchen oder an eine Person weiterleiten?",
  destructiveConfirm: "Dadurch werden {count} Konversationen gel\xF6scht. Sie k\xF6nnen nicht wiederhergestellt werden. Zum Fortfahren best\xE4tigen.",
  errorApology: "Auf unserer Seite ist ein Fehler aufgetreten. Es wird erneut versucht. Falls das weiterhin passiert, lautet die Trace-ID {traceId} \u2014 f\xFCgen Sie sie im Support ein, dann haben wir den Kontext.",
  rateLimitHit: "Sie haben Ihr Limit f\xFCr diese Stunde erreicht. Es wird um {resetTime} zur\xFCckgesetzt. Upgraden Sie Ihren Tarif oder warten Sie.",
  streamingInterrupted: "Generierung gestoppt. Starten Sie neu oder pr\xE4zisieren Sie Ihre Frage.",
  outOfScope: "Das liegt au\xDFerhalb dessen, wof\xFCr ich auf dieser Seite trainiert bin. Versuchen Sie {helpLink}.",
  toolCallInProgress: "Ich sehe das nach.",
  toolCallComplete: "Fertig. Das habe ich gefunden:"
};
var CANONICAL_RESPONSES_AR = {
  greetingDevMode: "\u0645\u0631\u062D\u0628\u064B\u0627. \u0627\u0633\u0623\u0644\u0646\u064A \u0623\u064A \u0634\u064A\u0621 \u0639\u0646 \u0645\u0633\u062A\u0646\u062F\u0627\u062A\u0643\u060C \u0623\u0648 \u0627\u0644\u0635\u0642 \u0633\u0624\u0627\u0644\u0627\u064B \u0644\u0644\u0628\u062F\u0621.",
  greetingBranded: "\u0645\u0631\u062D\u0628\u064B\u0627\u060C \u0623\u0646\u0627 {name}. \u0643\u064A\u0641 \u064A\u0645\u0643\u0646\u0646\u064A \u0645\u0633\u0627\u0639\u062F\u062A\u0643 \u0627\u0644\u064A\u0648\u0645\u061F",
  idk: "\u0644\u0627 \u0623\u0645\u0644\u0643 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0629. \u0647\u0644 \u062A\u0631\u064A\u062F \u0623\u0646 \u0623\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0645\u0633\u062A\u0646\u062F\u0627\u062A \u0623\u0645 \u0623\u062D\u064A\u0644 \u0627\u0644\u0623\u0645\u0631 \u0625\u0644\u0649 \u0634\u062E\u0635\u061F",
  destructiveConfirm: "\u0633\u064A\u0624\u062F\u064A \u0647\u0630\u0627 \u0625\u0644\u0649 \u062D\u0630\u0641 {count} \u0645\u062D\u0627\u062F\u062B\u0629. \u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0633\u062A\u0639\u0627\u062F\u062A\u0647\u0627. \u0623\u0643\u0650\u0651\u062F \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
  errorApology: "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0646 \u062C\u0647\u062A\u0646\u0627. \u062A\u062C\u0631\u064A \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629. \u0625\u0630\u0627 \u0627\u0633\u062A\u0645\u0631 \u0647\u0630\u0627\u060C \u0641\u0625\u0646 \u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062A\u062A\u0628\u0639 \u0647\u0648 {traceId} \u2014 \u0627\u0644\u0635\u0642\u0647 \u0641\u064A \u0627\u0644\u062F\u0639\u0645 \u0648\u0633\u064A\u0643\u0648\u0646 \u0644\u062F\u064A\u0646\u0627 \u0627\u0644\u0633\u064A\u0627\u0642.",
  rateLimitHit: "\u0644\u0642\u062F \u0628\u0644\u063A\u062A \u0627\u0644\u062D\u062F \u0627\u0644\u0645\u0633\u0645\u0648\u062D \u0644\u0647\u0630\u0647 \u0627\u0644\u0633\u0627\u0639\u0629. \u0633\u062A\u062A\u0645 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u0639\u064A\u064A\u0646 \u0639\u0646\u062F {resetTime}. \u0642\u0645 \u0628\u062A\u0631\u0642\u064A\u0629 \u062E\u0637\u062A\u0643 \u0623\u0648 \u0627\u0646\u062A\u0638\u0631.",
  streamingInterrupted: "\u062A\u0648\u0642\u0651\u0641 \u0627\u0644\u062A\u0648\u0644\u064A\u062F. \u0623\u0639\u062F \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0623\u0648 \u0646\u0642\u0651\u062D \u0633\u0624\u0627\u0644\u0643.",
  outOfScope: "\u0647\u0630\u0627 \u062E\u0627\u0631\u062C \u0646\u0637\u0627\u0642 \u0645\u0627 \u062F\u064F\u0631\u0651\u0628\u062A \u0639\u0644\u064A\u0647 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0648\u0642\u0639. \u062C\u0631\u0651\u0628 {helpLink}.",
  toolCallInProgress: "\u062C\u0627\u0631\u064D \u0627\u0644\u0628\u062D\u062B \u0639\u0646 \u0630\u0644\u0643.",
  toolCallComplete: "\u062A\u0645. \u0625\u0644\u064A\u0643 \u0645\u0627 \u0648\u062C\u062F\u062A:"
};
var CANONICAL_RESPONSES_HE = {
  greetingDevMode: "\u05E9\u05DC\u05D5\u05DD. \u05E9\u05D0\u05DC \u05D0\u05D5\u05EA\u05D9 \u05DB\u05DC \u05D3\u05D1\u05E8 \u05E2\u05DC \u05D4\u05DE\u05E1\u05DE\u05DB\u05D9\u05DD \u05E9\u05DC\u05DA, \u05D0\u05D5 \u05D4\u05D3\u05D1\u05E7 \u05E9\u05D0\u05DC\u05D4 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D9\u05DC.",
  greetingBranded: "\u05E9\u05DC\u05D5\u05DD, \u05D0\u05E0\u05D9 {name}. \u05D0\u05D9\u05DA \u05D0\u05E4\u05E9\u05E8 \u05DC\u05E2\u05D6\u05D5\u05E8 \u05D4\u05D9\u05D5\u05DD?",
  idk: "\u05D0\u05D9\u05DF \u05DC\u05D9 \u05D0\u05EA \u05D6\u05D4. \u05E9\u05D0\u05D7\u05E4\u05E9 \u05D1\u05DE\u05E1\u05DE\u05DB\u05D9\u05DD \u05D0\u05D5 \u05E9\u05D0\u05E2\u05D1\u05D9\u05E8 \u05DC\u05E0\u05E6\u05D9\u05D2 \u05D0\u05E0\u05D5\u05E9\u05D9?",
  destructiveConfirm: "\u05E4\u05E2\u05D5\u05DC\u05D4 \u05D6\u05D5 \u05EA\u05DE\u05D7\u05E7 {count} \u05E9\u05D9\u05D7\u05D5\u05EA. \u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05D7\u05D6\u05E8 \u05D0\u05D5\u05EA\u05DF. \u05D0\u05E9\u05E8 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA.",
  errorApology: "\u05DE\u05E9\u05D4\u05D5 \u05E0\u05DB\u05E9\u05DC \u05D0\u05E6\u05DC\u05E0\u05D5. \u05DE\u05E0\u05E1\u05D4 \u05E9\u05D5\u05D1. \u05D0\u05DD \u05D6\u05D4 \u05DE\u05DE\u05E9\u05D9\u05DA \u05DC\u05E7\u05E8\u05D5\u05EA, \u05DE\u05D6\u05D4\u05D4 \u05D4\u05DE\u05E2\u05E7\u05D1 \u05D4\u05D5\u05D0 {traceId} \u2014 \u05D4\u05D3\u05D1\u05E7 \u05D0\u05D5\u05EA\u05D5 \u05D1\u05E4\u05E0\u05D9\u05D9\u05D4 \u05DC\u05EA\u05DE\u05D9\u05DB\u05D4 \u05D5\u05D9\u05D4\u05D9\u05D4 \u05DC\u05E0\u05D5 \u05D4\u05E7\u05E9\u05E8.",
  rateLimitHit: "\u05D4\u05D2\u05E2\u05EA \u05DC\u05DE\u05D2\u05D1\u05DC\u05D4 \u05E9\u05DC\u05DA \u05DC\u05E9\u05E2\u05D4 \u05D4\u05D6\u05D5. \u05D4\u05D9\u05D0 \u05DE\u05EA\u05D0\u05E4\u05E1\u05EA \u05D1-{resetTime}. \u05E9\u05D3\u05E8\u05D2 \u05D0\u05EA \u05D4\u05EA\u05D5\u05DB\u05E0\u05D9\u05EA \u05D0\u05D5 \u05D4\u05DE\u05EA\u05DF.",
  streamingInterrupted: "\u05D4\u05D9\u05E6\u05D9\u05E8\u05D4 \u05D4\u05D5\u05E4\u05E1\u05E7\u05D4. \u05D4\u05E4\u05E2\u05DC \u05DE\u05D7\u05D3\u05E9 \u05D0\u05D5 \u05D3\u05D9\u05D9\u05E7 \u05D0\u05EA \u05D4\u05E9\u05D0\u05DC\u05D4.",
  outOfScope: "\u05D6\u05D4 \u05DE\u05D7\u05D5\u05E5 \u05DC\u05DE\u05D4 \u05E9\u05D0\u05D5\u05DE\u05E0\u05EA\u05D9 \u05E2\u05DC\u05D9\u05D5 \u05E2\u05D1\u05D5\u05E8 \u05D4\u05D0\u05EA\u05E8 \u05D4\u05D6\u05D4. \u05E0\u05E1\u05D4 {helpLink}.",
  toolCallInProgress: "\u05DE\u05D7\u05E4\u05E9 \u05D0\u05EA \u05D6\u05D4.",
  toolCallComplete: "\u05E1\u05D9\u05D9\u05DE\u05EA\u05D9. \u05D4\u05E0\u05D4 \u05DE\u05D4 \u05E9\u05DE\u05E6\u05D0\u05EA\u05D9:"
};
var CANONICAL_RESPONSES = {
  en: CANONICAL_RESPONSES_EN,
  es: CANONICAL_RESPONSES_ES,
  fr: CANONICAL_RESPONSES_FR,
  de: CANONICAL_RESPONSES_DE,
  ar: CANONICAL_RESPONSES_AR,
  he: CANONICAL_RESPONSES_HE
};
function getCanonicalResponses(locale) {
  if (!isSupportedLocale(locale) || locale === DEFAULT_LOCALE) {
    return CANONICAL_RESPONSES_EN;
  }
  return { ...CANONICAL_RESPONSES_EN, ...CANONICAL_RESPONSES[locale] };
}

// src/insights/topic-taxonomy.ts
var TOPIC_OTHER = "other";
var DEFAULT_TOPIC_TAXONOMY = [
  { key: "account_access", gloss: "Account, profile, login, or access management" },
  { key: "billing_payments", gloss: "Billing, invoices, payments, or subscription charges" },
  { key: "orders_shipping", gloss: "Placing, tracking, or changing an order or its delivery" },
  { key: "returns_refunds", gloss: "Returns, cancellations, or refunds" },
  { key: "product_howto", gloss: "How the product works, feature usage, or how-to guidance" },
  { key: "technical_issue", gloss: "A bug, error, outage, or something not working" },
  {
    key: "feature_request",
    gloss: "A request for a capability or feature that does not exist yet"
  },
  { key: "pricing_plans", gloss: "Pricing, plan comparison, quotas, or upgrades" },
  { key: "data_privacy", gloss: "Data, privacy, security, or compliance questions" }
];
var DEFAULT_TOPIC_KEYS = [
  ...DEFAULT_TOPIC_TAXONOMY.map((t) => t.key),
  TOPIC_OTHER
];
function coerceTopicKey(value, taxonomyKeys = DEFAULT_TOPIC_KEYS) {
  if (value === null || value === void 0) return null;
  const trimmed = value.trim();
  if (trimmed === "") return null;
  return taxonomyKeys.includes(trimmed) ? trimmed : TOPIC_OTHER;
}

// src/insights/topic-taxonomy-resolve.ts
var TOPIC_KEY_PATTERN = /^[a-z][a-z0-9_]{1,40}$/;
var MAX_CUSTOM_TOPICS = 24;
function isValidCustomTopicKey(key) {
  if (!TOPIC_KEY_PATTERN.test(key)) return false;
  return !DEFAULT_TOPIC_KEYS.includes(key);
}
function resolveEffectiveTaxonomy(overrides, defaults = DEFAULT_TOPIC_TAXONOMY) {
  const byKey = new Map(overrides.map((o) => [o.key, o]));
  const resolvedDefaults = defaults.map((d) => {
    const o = byKey.get(d.key);
    return {
      key: d.key,
      gloss: d.gloss,
      label: o?.label ?? null,
      isCustom: false,
      archived: o?.archived ?? false,
      mergedInto: o?.mergedInto ?? null
    };
  });
  const defaultKeys = new Set(defaults.map((d) => d.key));
  const customs = overrides.filter((o) => o.isCustom && !defaultKeys.has(o.key)).slice().sort((a, b) => a.sortOrder - b.sortOrder || a.key.localeCompare(b.key)).map((o) => ({
    key: o.key,
    gloss: o.gloss ?? "",
    label: o.label,
    isCustom: true,
    archived: o.archived,
    mergedInto: o.mergedInto
  }));
  return [...resolvedDefaults, ...customs];
}
function activeTaxonomyEntries(effective) {
  return effective.filter((e) => !e.archived && e.mergedInto === null && e.gloss.length > 0).map((e) => ({ key: e.key, gloss: e.gloss }));
}
function activeTaxonomyKeys(effective) {
  return [...activeTaxonomyEntries(effective).map((e) => e.key), TOPIC_OTHER];
}
function remapTopic(key, effective) {
  if (key === null) return null;
  const mergeTargets = /* @__PURE__ */ new Map();
  for (const e of effective) {
    if (e.mergedInto !== null) mergeTargets.set(e.key, e.mergedInto);
  }
  let current = key;
  const seen = /* @__PURE__ */ new Set();
  for (let next = mergeTargets.get(current); next !== void 0 && !seen.has(current); ) {
    seen.add(current);
    current = next;
    next = mergeTargets.get(current);
  }
  return current;
}

// src/packaging/published-packages.data.ts
var PUBLISHED_PACKAGES = [
  // ── npm: the headline CLI ──────────────────────────────────────────────
  {
    id: "cli",
    label: "Syncanix CLI",
    workspacePath: "packages/cli",
    registry: "npm",
    // The product's first command is `npx syncanix init`; npm resolves the bare
    // package literally named `syncanix`, so the CLI publishes UNSCOPED.
    publishName: "syncanix",
    installCommand: "npx syncanix init",
    customerFacing: true,
    status: "live",
    liveVersion: "0.3.0"
  },
  // ── npm: customer-facing client libraries ──────────────────────────────
  {
    id: "sdk-node",
    label: "Syncanix Node SDK",
    workspacePath: "packages/sdk-node",
    registry: "npm",
    publishName: "@syncanix/sdk-node",
    installCommand: "npm install @syncanix/sdk-node",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "web-components",
    label: "Syncanix Web Components",
    workspacePath: "packages/web-components",
    registry: "npm",
    publishName: "@syncanix/web-components",
    installCommand: "npm install @syncanix/web-components",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "extractor-plugin-api",
    label: "Syncanix Extractor Plugin API",
    workspacePath: "packages/extractor-plugin-api",
    registry: "npm",
    publishName: "@syncanix/extractor-plugin-api",
    installCommand: "npm install @syncanix/extractor-plugin-api",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "extractor-plugins",
    label: "Syncanix First-Party Extractor Plugins",
    workspacePath: "packages/extractor-plugins",
    registry: "npm",
    publishName: "@syncanix/extractor-plugins",
    installCommand: "npm install @syncanix/extractor-plugins",
    customerFacing: true,
    status: "planned"
  },
  // ── npm: per-IdP auth adapters (drop-in for customer apps) ──────────────
  {
    id: "auth-adapter-auth0",
    label: "Syncanix Auth0 Adapter",
    workspacePath: "packages/auth-adapters/auth0",
    registry: "npm",
    publishName: "@syncanix/auth0",
    installCommand: "pnpm add @syncanix/auth0",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "auth-adapter-clerk",
    label: "Syncanix Clerk Adapter",
    workspacePath: "packages/auth-adapters/clerk",
    registry: "npm",
    publishName: "@syncanix/clerk",
    installCommand: "pnpm add @syncanix/clerk",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "auth-adapter-cognito",
    label: "Syncanix Cognito Adapter",
    workspacePath: "packages/auth-adapters/cognito",
    registry: "npm",
    publishName: "@syncanix/cognito",
    installCommand: "pnpm add @syncanix/cognito",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "auth-adapter-workos",
    label: "Syncanix WorkOS Adapter",
    workspacePath: "packages/auth-adapters/workos",
    registry: "npm",
    publishName: "@syncanix/workos",
    installCommand: "pnpm add @syncanix/workos",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "auth-adapter-oidc",
    label: "Syncanix OIDC Adapter",
    workspacePath: "packages/auth-adapters/oidc",
    registry: "npm",
    publishName: "@syncanix/oidc",
    installCommand: "pnpm add @syncanix/oidc",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "auth-adapter-custom-jwt",
    label: "Syncanix Custom-JWT Adapter",
    workspacePath: "packages/auth-adapters/custom-jwt",
    registry: "npm",
    publishName: "@syncanix/custom-jwt",
    installCommand: "pnpm add @syncanix/custom-jwt",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "auth-adapter-introspection",
    label: "Syncanix Introspection Adapter",
    workspacePath: "packages/auth-adapters/introspection",
    registry: "npm",
    publishName: "@syncanix/introspection",
    installCommand: "pnpm add @syncanix/introspection",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "auth-adapter-bff",
    label: "Syncanix BFF Adapter",
    workspacePath: "packages/auth-adapters/bff",
    registry: "npm",
    publishName: "@syncanix/bff",
    installCommand: "pnpm add @syncanix/bff",
    customerFacing: true,
    status: "planned"
  },
  // ── npm: P-06 auth-adapter expansion (seed→Series-B ICP IdPs) ────────────
  {
    id: "auth-adapter-firebase",
    label: "Syncanix Firebase Adapter",
    workspacePath: "packages/auth-adapters/firebase",
    registry: "npm",
    publishName: "@syncanix/firebase",
    installCommand: "pnpm add @syncanix/firebase",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "auth-adapter-supabase",
    label: "Syncanix Supabase Adapter",
    workspacePath: "packages/auth-adapters/supabase",
    registry: "npm",
    publishName: "@syncanix/supabase",
    installCommand: "pnpm add @syncanix/supabase",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "auth-adapter-keycloak",
    label: "Syncanix Keycloak Adapter",
    workspacePath: "packages/auth-adapters/keycloak",
    registry: "npm",
    publishName: "@syncanix/keycloak",
    installCommand: "pnpm add @syncanix/keycloak",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "auth-adapter-entra-external-id",
    label: "Syncanix Entra External ID Adapter",
    workspacePath: "packages/auth-adapters/entra-external-id",
    registry: "npm",
    publishName: "@syncanix/entra-external-id",
    installCommand: "pnpm add @syncanix/entra-external-id",
    customerFacing: true,
    status: "planned"
  },
  // NOTE: internal runtime deps (@syncanix/{shared,api-witness,auth-adapters-lib})
  // are VENDORED per ADR-0102, never published — see VENDORED_INTERNAL_PACKAGES below.
  // ── non-JS intent-verification SDKs ─────────────────────────────────────
  {
    id: "sdk-python",
    label: "Syncanix Python SDK",
    workspacePath: "packages/sdk-python",
    registry: "pypi",
    publishName: "syncanix-sdk",
    installCommand: "pip install syncanix-sdk",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "sdk-rust",
    label: "Syncanix Rust SDK",
    workspacePath: "packages/sdk-rust",
    registry: "crates",
    publishName: "syncanix-sdk-rust",
    installCommand: "cargo add syncanix-sdk-rust",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "sdk-go",
    label: "Syncanix Go SDK",
    workspacePath: "packages/sdk-go",
    registry: "go-modules",
    // Go modules are identified by their VCS path; published via a git tag,
    // not a registry upload (proxy.golang.org + pkg.go.dev serve from the tag).
    publishName: "github.com/syncanix-ai/syncanix-sdk-go",
    installCommand: "go get github.com/syncanix-ai/syncanix-sdk-go",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "sdk-ruby",
    label: "Syncanix Ruby SDK",
    workspacePath: "packages/sdk-ruby",
    registry: "rubygems",
    publishName: "syncanix-sdk-rails",
    installCommand: "bundle add syncanix-sdk-rails",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "sdk-php",
    label: "Syncanix PHP SDK",
    workspacePath: "packages/sdk-php",
    registry: "packagist",
    publishName: "syncanix/sdk-php",
    installCommand: "composer require syncanix/sdk-php",
    customerFacing: true,
    status: "planned"
  },
  {
    id: "sdk-jvm",
    label: "Syncanix Spring Boot SDK",
    workspacePath: "packages/sdk-jvm",
    registry: "maven-central",
    publishName: "ai.syncanix:syncanix-sdk-spring-boot",
    installCommand: 'implementation "ai.syncanix:syncanix-sdk-spring-boot"',
    customerFacing: true,
    status: "planned"
  },
  {
    id: "sdk-dotnet",
    label: "Syncanix ASP.NET Core SDK",
    workspacePath: "packages/sdk-dotnet",
    registry: "nuget",
    publishName: "Syncanix.Sdk.AspNetCore",
    installCommand: "dotnet add package Syncanix.Sdk.AspNetCore",
    customerFacing: true,
    status: "planned"
  },
  // ── VS Code Marketplace ─────────────────────────────────────────────────
  {
    id: "vscode-extension",
    label: "Syncanix Catalog (VS Code extension)",
    workspacePath: "packages/vscode-extension",
    registry: "vscode-marketplace",
    // Marketplace identity is `<publisher>.<name>`: publisher `syncanix`.
    publishName: "syncanix.syncanix-catalog",
    installCommand: "code --install-extension syncanix.syncanix-catalog",
    customerFacing: true,
    status: "planned"
  }
];
var VENDORED_INTERNAL_PACKAGES = [
  { id: "shared", packageName: "@syncanix/shared", workspacePath: "packages/shared" },
  {
    id: "api-witness",
    packageName: "@syncanix/api-witness",
    workspacePath: "packages/api-witness"
  },
  {
    id: "auth-adapters-lib",
    packageName: "@syncanix/auth-adapters-lib",
    workspacePath: "packages/auth-adapters/lib"
  }
];

// src/packaging/published-packages.ts
function getPublishedPackage(publishName) {
  return PUBLISHED_PACKAGES.find((pkg) => pkg.publishName === publishName);
}
function isPackageLive(publishName) {
  return getPublishedPackage(publishName)?.status === "live";
}
function livePackages() {
  return PUBLISHED_PACKAGES.filter((pkg) => pkg.status === "live");
}
function customerFacingPackages() {
  return PUBLISHED_PACKAGES.filter((pkg) => pkg.customerFacing);
}
var TURN_FRICTION_SIGNALS = ["rage_click", "dead_click", "repeat_failure"];
var FAILED_ACTION_ERROR_CLASSES = [
  "tool_error",
  "denied",
  "step_up_abandoned",
  "rate_limited",
  "not_found",
  "timeout",
  "unknown"
];
var MAX_ROUTES_VISITED = 10;
var MAX_DWELL_SECONDS = 3600;
var MAX_ID_CHARS = 256;
var RouteRefSchema = /* @__PURE__ */ z.string().min(1).max(MAX_ID_CHARS).refine((v) => !/[\s?#]/.test(v) && !v.includes("://"), {
  message: "route must be a normalized route id \u2014 no URLs, query strings, fragments, or whitespace"
});
var FailedActionRefSchema = /* @__PURE__ */ z.object({
  capabilityId: z.string().min(1).max(MAX_ID_CHARS),
  errorClass: z.enum(FAILED_ACTION_ERROR_CLASSES)
}).strict();
var TurnSessionContextSchema = /* @__PURE__ */ z.object({
  /** Normalized route ids touched this session (this session only), newest last. */
  routesVisited: z.array(RouteRefSchema).max(MAX_ROUTES_VISITED),
  /** Whole seconds of dwell on the current route (0..1h). */
  dwellSecondsOnCurrent: z.number().int().min(0).max(MAX_DWELL_SECONDS).optional(),
  /** The capability id + error class of the last failed action (no payloads). */
  lastFailedAction: FailedActionRefSchema.optional(),
  /** The friction signal that opened this turn, if any (ADR-0236). */
  frictionSignal: z.enum(TURN_FRICTION_SIGNALS).optional()
}).strict();
var TURN_PANEL_MODES = ["overlay", "side", "fullscreen-mobile"];
var TURN_HOST_ACTIVITY_STATES = ["editing", "engaged", "idle"];
var TurnPanelContextSchema = /* @__PURE__ */ z.object({
  /** How the chat is presented — see {@link TURN_PANEL_MODES}. */
  panelMode: z.enum(TURN_PANEL_MODES),
  /**
   * Whether the visitor can currently SEE the host page.
   *
   * Separate from `panelMode` rather than derived from it, because they can
   * disagree: a fullscreen panel that is closed leaves the page fully visible,
   * and a future presentation could cover the page without being
   * `fullscreen-mobile`. The producer owns the derivation; the consumer reads
   * the answer.
   */
  pageVisible: z.boolean(),
  /**
   * PLAN-2 §3.5 — what the visitor is doing on the host page; see
   * {@link TURN_HOST_ACTIVITY_STATES}.
   *
   * **Optional, and the two reasons are independent.** First, widget and API
   * deploys are not atomic — the widget ships through the CDN and the API
   * through Lambda — so under `.strict()` a REQUIRED third member would reject
   * the entire envelope coming from any build that predates it, taking the
   * working `panelMode`/`pageVisible` signal down with it in whichever deploy
   * order landed second. Second, `parsePersistedPanelContext` reads rows
   * written before this field existed back through this same schema on the
   * resume leg; a required member would make every one of those rows
   * unparseable and silently drop the panel block mid-tool-call.
   *
   * Absent therefore means "this build does not observe activity", and the
   * server composes no activity clause — the ladder behaves exactly as it did
   * before the field existed. An explicit `null` is refused rather than folded
   * into that, because it is a different and unsupported claim: a client
   * asserting a reading it does not have.
   */
  hostActivity: z.enum(TURN_HOST_ACTIVITY_STATES).optional()
}).strict();
var MAX_ASK_SELECTION_TEXT = 500;
var MAX_ASK_SELECTION_NAME = 160;
var MAX_ASK_SELECTION_ROLE = 64;
var MAX_ASK_SELECTION_TAG = 32;
var AskSelectionSchema = /* @__PURE__ */ z.object({
  /**
   * The visitor's selected text, HTML-stripped + PII-redacted + length-capped.
   * Optional so an element pick with no text (an icon button, an image) can
   * still carry a meaningful descriptor via {@link elementName}.
   */
  text: z.string().max(MAX_ASK_SELECTION_TEXT).optional(),
  /** The anchor element's bounded role token (from the widget's role vocabulary). */
  elementRole: z.string().max(MAX_ASK_SELECTION_ROLE).optional(),
  /** The anchor element's accessible name, redacted + capped. */
  elementName: z.string().max(MAX_ASK_SELECTION_NAME).optional(),
  /** The anchor element's lowercased tag name (structural token, no PII). */
  elementTag: z.string().max(MAX_ASK_SELECTION_TAG).optional()
}).strict().refine((v) => (v.text ?? "").trim().length > 0 || (v.elementName ?? "").trim().length > 0, {
  message: "ask selection must carry at least a non-empty `text` or `elementName` \u2014 an empty selection is never sent"
});
var conversationForwardingEntrySchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("assistant-text"),
    /** The assistant's natural-language text for this block. */
    content: z.string()
  }),
  z.object({
    kind: z.literal("tool-call"),
    /** Stable id correlating this call to its later `tool-result`. */
    toolCallId: z.string(),
    /** The catalog tool the assistant invoked. */
    toolName: z.string(),
    /** The arguments the assistant supplied to the tool. */
    args: z.record(z.unknown())
  }),
  z.object({
    kind: z.literal("tool-result"),
    /** Correlates back to the `tool-call` of the same id. */
    toolCallId: z.string(),
    /** Whatever the tool returned (already egress-redacted upstream). */
    result: z.unknown()
  })
]);
var conversationForwardingPayloadSchema = /* @__PURE__ */ z.object({
  /** Schema version — lets the customer's parser branch on future shape changes. */
  version: z.literal(1),
  /** The Syncanix tenant this conversation belongs to. */
  tenantId: z.string().uuid(),
  /** Which environment produced the turn. */
  environment: z.enum(["development", "production"]),
  /** Stable conversation id — every forward for one conversation shares it. */
  conversationId: z.string(),
  /**
   * The authenticated end-user this conversation belongs to, when known
   * (an end-user-authenticated chat surface). `null` for anonymous sessions.
   */
  userId: z.string().nullable(),
  /**
   * The user's message that opened this turn. `null` for a resumed turn (an
   * agent-loop continuation after a tool result carries no fresh user message).
   */
  userMessage: z.string().nullable(),
  /** The ordered assistant-text / tool-call / tool-result entries this turn produced. */
  entries: z.array(conversationForwardingEntrySchema),
  /** The LLM model that produced the turn, when reported. */
  model: z.string().optional(),
  /** ISO-8601 timestamp the turn completed (and the forward was emitted). */
  occurredAt: z.string().datetime()
});
var CONVERSATION_FORWARDING_PAYLOAD_VERSION = 1;
var SENTRY_FORWARDER_CLIENT = "syncanix-error-forwarder/1.0.0";
var SENTRY_FORWARDER_SDK = { name: "syncanix.error-forwarder", version: "1.0.0" };
var SENTRY_FORWARDING_PLATFORM = "other";
var SENTRY_ENVELOPE_ITEM_TYPE = "event";
var SENTRY_EVENT_LEVELS = ["fatal", "error", "warning", "info", "debug"];
var PUBLIC_KEY_PATTERN = /^[A-Za-z0-9]+$/u;
var PROJECT_ID_PATTERN = /^[0-9]+$/u;
var ENVELOPE_SUFFIX = "/envelope/";
function parseSentryDsn(dsn) {
  let url;
  try {
    url = new URL(dsn);
  } catch {
    return null;
  }
  if (url.protocol !== "https:") return null;
  const publicKey = url.username;
  if (publicKey.length === 0 || !PUBLIC_KEY_PATTERN.test(publicKey)) return null;
  const segments = url.pathname.split("/").filter((s) => s.length > 0);
  const projectId = segments.pop();
  if (projectId === void 0 || !PROJECT_ID_PATTERN.test(projectId)) return null;
  const prefix = segments.length > 0 ? `/${segments.join("/")}` : "";
  const ingestUrl = `https://${url.host}${prefix}/api/${projectId}${ENVELOPE_SUFFIX}`;
  return { publicKey, host: url.host, projectId, ingestUrl };
}
function isValidSentryDsn(dsn) {
  return parseSentryDsn(dsn) !== null;
}
function buildSentryAuthHeader(publicKey, client = SENTRY_FORWARDER_CLIENT) {
  return `Sentry sentry_version=7, sentry_client=${client}, sentry_key=${publicKey}`;
}
var sentryEventPayloadSchema = /* @__PURE__ */ z.object({
  event_id: z.string().regex(/^[0-9a-f]{32}$/u),
  timestamp: z.string().datetime(),
  platform: z.literal(SENTRY_FORWARDING_PLATFORM),
  level: z.enum(SENTRY_EVENT_LEVELS),
  logger: z.string().min(1),
  environment: z.enum(["development", "production"]),
  sdk: z.object({ name: z.string(), version: z.string() }),
  exception: z.object({
    values: z.array(z.object({ type: z.string(), value: z.string() })).min(1)
  }),
  tags: z.record(z.string()),
  extra: z.record(z.unknown()).optional()
});
function dsnString(parts) {
  const base = parts.ingestUrl.slice(0, -`/api/${parts.projectId}${ENVELOPE_SUFFIX}`.length);
  return `${base.replace("https://", `https://${parts.publicKey}@`)}/${parts.projectId}`;
}
function buildSentryEnvelope(parts, input) {
  const payload = {
    event_id: input.eventId,
    timestamp: input.sentAt,
    platform: SENTRY_FORWARDING_PLATFORM,
    level: input.level,
    logger: input.logger,
    environment: input.environment,
    sdk: { ...SENTRY_FORWARDER_SDK },
    exception: { values: [{ type: input.errorType, value: input.errorMessage }] },
    tags: input.tags ?? {},
    ...input.extra !== void 0 && { extra: input.extra }
  };
  const envelopeHeader = {
    event_id: input.eventId,
    sent_at: input.sentAt,
    dsn: dsnString(parts)
  };
  const itemHeader = { type: SENTRY_ENVELOPE_ITEM_TYPE, content_type: "application/json" };
  const body = [
    JSON.stringify(envelopeHeader),
    JSON.stringify(itemHeader),
    JSON.stringify(payload)
  ].join("\n");
  return { url: parts.ingestUrl, authHeader: buildSentryAuthHeader(parts.publicKey), body };
}
var RENDER_COMPONENT_TOOL_PREFIX = "render_component__";
var RENDER_COMPONENT_ID_PATTERN = /^[A-Za-z0-9_-]{1,46}$/;
var RENDER_COMPONENT_NAME_PATTERN = /^render_component__[A-Za-z0-9_-]{1,46}$/;
var MAX_COMPONENT_TOOLS = 50;
var MAX_COMPONENT_TOOL_DESCRIPTION_CHARS = 2e3;
var MAX_COMPONENT_TOOL_PARAMETERS_CHARS = 8e3;
function isRenderComponentToolName(name) {
  return RENDER_COMPONENT_NAME_PATTERN.test(name);
}
function isValidComponentId(id) {
  return RENDER_COMPONENT_ID_PATTERN.test(id);
}
function renderComponentToolName(componentId) {
  return `${RENDER_COMPONENT_TOOL_PREFIX}${componentId}`;
}
function componentIdFromToolName(name) {
  return name.startsWith(RENDER_COMPONENT_TOOL_PREFIX) ? name.slice(RENDER_COMPONENT_TOOL_PREFIX.length) : name;
}
var ComponentRenderDeclarationSchema = /* @__PURE__ */ z.object({
  name: z.string().regex(
    RENDER_COMPONENT_NAME_PATTERN,
    'A component-render tool name must be "render_component__" followed by 1\u201346 of [A-Za-z0-9_-].'
  ),
  description: z.string().min(1).max(MAX_COMPONENT_TOOL_DESCRIPTION_CHARS),
  parameters: z.record(z.unknown()).refine((p) => JSON.stringify(p).length <= MAX_COMPONENT_TOOL_PARAMETERS_CHARS, {
    message: `A component-render tool parameters object must serialize to \u2264 ${String(
      MAX_COMPONENT_TOOL_PARAMETERS_CHARS
    )} characters.`
  })
}).strict();
var ComponentToolsSchema = /* @__PURE__ */ z.array(ComponentRenderDeclarationSchema).max(MAX_COMPONENT_TOOLS);

// src/component-tools/use-when.ts
var HOST_COMPONENT_USE_WHEN_MAX = 240;
var HostComponentUseWhenSchema = customerTextSchema(HOST_COMPONENT_USE_WHEN_MAX);
function resolveComponentUseWhen(value, locale) {
  const parsed = HostComponentUseWhenSchema.safeParse(value);
  if (!parsed.success) return void 0;
  return resolveCustomerText(parsed.data, locale);
}
var notificationKindSchema = /* @__PURE__ */ z.string().min(1).max(64).regex(
  /^[a-z0-9]+(?:[._-][a-z0-9]+)*$/,
  "kind must be a lowercase slug (letters, digits, and . _ - separators)"
);
var notificationActionSchema = /* @__PURE__ */ z.object({
  /** Button label the widget renders. The customer localizes this string. */
  label: z.string().min(1).max(80),
  /**
   * Where the action points. `http(s)`-only — enforced at the boundary so a
   * `javascript:` / `data:` / `vbscript:` scheme is REJECTED here, not merely
   * neutralized by the widget's markdown sink downstream (defense in depth;
   * mirrors `logic/channels/teams-adaptive-card.ts`). The widget opens it on tap.
   */
  url: z.string().url().max(2048).refine((u) => /^https?:\/\//i.test(u), {
    message: "action.url must be an http(s) URL"
  })
});
var notificationIngestSchema = /* @__PURE__ */ z.object({
  /** The customer's stable id for the end-user this notification is for. */
  endUserId: z.string().min(1).max(256),
  /** Machine-readable category (slug). */
  kind: notificationKindSchema,
  /** Short headline shown in the badge/agent message. Customer-localized. */
  title: z.string().min(1).max(120),
  /** Body text. Customer-localized. */
  body: z.string().min(1).max(500),
  /** Optional labelled deep-link action. */
  action: notificationActionSchema.optional(),
  /**
   * Optional idempotency/coalesce key. Two ingests with the same
   * `(endUserId, dedupeKey)` collapse to one notification ("deploy 123 done"
   * sent twice = one). Absent ⇒ every ingest is a distinct notification.
   */
  dedupeKey: z.string().min(1).max(256).optional(),
  /**
   * Optional ISO-8601 expiry. After it passes, a still-undelivered notification
   * is expired (a stale "process done" never surfaces days later). Absent ⇒ the
   * service applies a default window.
   */
  expiresAt: z.string().datetime().optional()
});
var widgetNotificationViewSchema = /* @__PURE__ */ z.object({
  /** Stable notification id (used by the ack call). */
  id: z.string().uuid(),
  /** Machine-readable category (slug) — the widget may branch rendering on it. */
  kind: notificationKindSchema,
  /** Headline. */
  title: z.string(),
  /** Body text. */
  body: z.string(),
  /** Optional labelled deep-link action. */
  action: notificationActionSchema.optional(),
  /** ISO-8601 creation timestamp (for ordering / "x minutes ago"). */
  createdAt: z.string().datetime()
});
var widgetNotificationListSchema = /* @__PURE__ */ z.object({
  count: z.number().int().nonnegative(),
  items: z.array(widgetNotificationViewSchema)
});
var NOTIFICATION_DEFAULT_TTL_MS = 24 * 60 * 60 * 1e3;

// src/export/tabular.ts
function cellToString(value) {
  if (value === null || value === void 0) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean" || typeof value === "bigint") {
    return String(value);
  }
  if (value instanceof Date) return value.toISOString();
  return JSON.stringify(value);
}
function resolveColumns(rows, columns) {
  if (columns !== void 0 && columns.length > 0) return [...columns];
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const row2 of rows) {
    for (const key of Object.keys(row2)) {
      if (!seen.has(key)) {
        seen.add(key);
        out.push({ key });
      }
    }
  }
  return out;
}

// src/export/delimited.ts
var BOM = String.fromCharCode(65279);
var CRLF = "\r\n";
var FORMULA_TRIGGER = /^[=+\-@\t\r]/;
function neutralizeFormula(text) {
  return FORMULA_TRIGGER.test(text) ? `'${text}` : text;
}
function escapeField(value, delimiter) {
  if (value.includes('"') || value.includes("\n") || value.includes("\r") || value.includes(delimiter)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}
function guardedCell(raw) {
  const text = cellToString(raw);
  if (typeof raw === "string" && FORMULA_TRIGGER.test(text)) {
    return `'${text}`;
  }
  return text;
}
function toDelimited(rows, columns, delimiter) {
  const cols = resolveColumns(rows, columns);
  const lines = [];
  if (cols.length > 0) {
    lines.push(
      cols.map((c) => escapeField(guardedCell(c.header ?? c.key), delimiter)).join(delimiter)
    );
  }
  for (const row2 of rows) {
    lines.push(cols.map((c) => escapeField(guardedCell(row2[c.key]), delimiter)).join(delimiter));
  }
  return `${BOM}${lines.join(CRLF)}${CRLF}`;
}

// src/export/csv.ts
function toCsv(rows, columns) {
  return toDelimited(rows, columns, ",");
}

// src/export/tsv.ts
function toTsv(rows, columns) {
  return toDelimited(rows, columns, "	");
}

// src/export/text.ts
function toJson(data) {
  const serialized = JSON.stringify(data, null, 2);
  return typeof serialized === "string" ? serialized : "null";
}
function toTxt(value) {
  if (typeof value === "string") return value;
  if (value === null || value === void 0) return "";
  if (Array.isArray(value)) return value.map((line) => toTxt(line)).join("\n");
  if (typeof value === "number" || typeof value === "boolean" || typeof value === "bigint") {
    return String(value);
  }
  return toJson(value);
}

// src/provenance/ai-content-marking.ts
var AI_GENERATED_HEADER = "X-Syncanix-AI-Generated";
var AI_GENERATED_HEADER_VALUE = "true";
var AI_GENERATED_DATA_ATTRIBUTE = "data-syncanix-ai-generated";
var AI_PROVENANCE_SPEC_ID = "syncanix-content-provenance/v1";
var AI_PROVENANCE_SPEC_URL = "https://syncanix.com/.well-known/syncanix-content-provenance";

// src/export/transcript.ts
function roleLabel(role, labels) {
  switch (role) {
    case "user":
      return labels.roleUser;
    case "assistant":
      return labels.roleAssistant;
    case "system":
      return labels.roleSystem;
    case "tool":
      return labels.roleTool;
    default:
      return labels.roleUnknown;
  }
}
function speakerLine(message, labels, emphasizeRole) {
  const parts = [emphasizeRole(roleLabel(message.role, labels))];
  if (message.role === "tool") {
    if (message.toolName != null && message.toolName !== "") parts.push(message.toolName);
    if (message.toolOutcome != null && message.toolOutcome !== "") {
      parts.push(`${labels.outcomeLabel}: ${message.toolOutcome}`);
    }
  }
  if (message.createdAt != null && message.createdAt !== "") parts.push(message.createdAt);
  return parts.join(" \xB7 ");
}
function toTranscriptMarkdown(data, labels) {
  const meta = [
    `- **${labels.conversationLabel}:** ${data.conversationId}`,
    `- **${labels.exportedAtLabel}:** ${data.exportedAt}`
  ];
  if (data.environment != null && data.environment !== "") {
    meta.push(`- **${labels.environmentLabel}:** ${data.environment}`);
  }
  meta.push(
    `- **${labels.userLabel}:** ${data.endUserId != null && data.endUserId !== "" ? data.endUserId : labels.anonymousUser}`
  );
  const turns = data.messages.map((message) => {
    const body = message.content.trim() === "" ? labels.emptyContent : message.content;
    return `${speakerLine(message, labels, (role) => `**${role}**`)}

${body}`;
  });
  return [`# ${labels.title}`, "", meta.join("\n"), "", "---", "", turns.join("\n\n")].join("\n").trimEnd().concat("\n");
}
function toTranscriptText(data, labels) {
  const meta = [
    `${labels.conversationLabel}: ${data.conversationId}`,
    `${labels.exportedAtLabel}: ${data.exportedAt}`
  ];
  if (data.environment != null && data.environment !== "") {
    meta.push(`${labels.environmentLabel}: ${data.environment}`);
  }
  meta.push(
    `${labels.userLabel}: ${data.endUserId != null && data.endUserId !== "" ? data.endUserId : labels.anonymousUser}`
  );
  const turns = data.messages.map((message) => {
    const body = message.content.trim() === "" ? labels.emptyContent : message.content;
    return `${speakerLine(message, labels, (role) => role)}
${body}`;
  });
  const rule = "\u2500".repeat(40);
  return [labels.title, "", meta.join("\n"), "", rule, "", turns.join("\n\n")].join("\n").trimEnd().concat("\n");
}
function toTranscriptJson(data) {
  const envelope = {
    schemaVersion: 1,
    kind: "syncanix.conversation-transcript",
    conversationId: data.conversationId,
    ...data.environment != null && data.environment !== "" ? { environment: data.environment } : {},
    exportedAt: data.exportedAt,
    ...data.endUserId != null && data.endUserId !== "" ? { endUserId: data.endUserId } : {},
    provenance: {
      aiGenerated: { roles: ["assistant"] },
      marking: AI_PROVENANCE_SPEC_ID,
      spec: AI_PROVENANCE_SPEC_URL
    },
    messages: data.messages.map((message) => ({
      ...message.sequence !== void 0 ? { sequence: message.sequence } : {},
      role: message.role,
      content: message.content,
      ...message.toolName != null && message.toolName !== "" ? { toolName: message.toolName } : {},
      ...message.toolOutcome != null && message.toolOutcome !== "" ? { toolOutcome: message.toolOutcome } : {},
      ...message.createdAt != null && message.createdAt !== "" ? { createdAt: message.createdAt } : {}
    }))
  };
  return JSON.stringify(envelope, null, 2);
}

// src/export/filename.ts
var COMBINING_MARKS = new RegExp(
  `[${String.fromCharCode(768)}-${String.fromCharCode(879)}]`,
  "g"
);
function slugify(input) {
  return input.normalize("NFKD").replace(COMBINING_MARKS, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
}
function formatYmd(date) {
  const year = date.getUTCFullYear().toString().padStart(4, "0");
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = date.getUTCDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}
function buildExportFilename(surface, name, ext, date) {
  const stem = [slugify(surface), slugify(name), formatYmd(date)].filter((s) => s.length > 0).join("-");
  const safeExt = ext.replace(/^\.+/, "").toLowerCase();
  return `${stem}.${safeExt}`;
}

// src/export/export-artifact-tag.ts
var EXPORT_ARTIFACT_TAG_KEY = "syncanix-artifact";
var EXPORT_ARTIFACT_TAG_VALUE = "export";
var EXPORT_ARTIFACT_TAGGING = `${EXPORT_ARTIFACT_TAG_KEY}=${EXPORT_ARTIFACT_TAG_VALUE}`;
var EXPORT_ARTIFACT_EXPIRY_DAYS = 7;

// src/conversation-retention/anonymous-retention.ts
var ANONYMOUS_CONVERSATION_RETENTION_DAYS = 30;

// src/conversation-retention/retention-choice.ts
var CONVERSATION_RETENTION_CHOICES = [30, 90, 365];
function isConversationRetentionChoice(value) {
  return typeof value === "number" && CONVERSATION_RETENTION_CHOICES.includes(value);
}
function effectiveConversationRetentionDays(tierCeilingDays, choice) {
  if (choice === null) return tierCeilingDays;
  return Math.min(tierCeilingDays, choice);
}
var FEEDBACK_ISSUE_TYPES = [
  "incorrect",
  "not_helpful",
  "refused",
  "unsafe",
  "slow",
  "other"
];
var FeedbackIssueTypeSchema = /* @__PURE__ */ z.enum(FEEDBACK_ISSUE_TYPES);
function isFeedbackIssueType(value) {
  return FeedbackIssueTypeSchema.safeParse(value).success;
}
var FEEDBACK_COMMENT_MAX_CHARS = 1024;

// src/insight-digest-schedule/digest-schedule.ts
var DIGEST_INTERVALS = ["hourly", "daily", "weekly", "custom"];
var DEFAULT_DIGEST_ENABLED = true;
var DEFAULT_DIGEST_INTERVAL = "daily";
var DEFAULT_DIGEST_HOUR_UTC = 2;
var DEFAULT_DIGEST_WEEKDAY = 1;
var DIGEST_MIN_HOUR = 0;
var DIGEST_MAX_HOUR = 23;
var DIGEST_MIN_WEEKDAY = 0;
var DIGEST_MAX_WEEKDAY = 6;
var DIGEST_MAX_CUSTOM_HOURS = 24;
function isDigestInterval(value) {
  return typeof value === "string" && DIGEST_INTERVALS.includes(value);
}
function resolveDigestSchedule(stored) {
  const raw = stored?.customHoursUtc ?? [];
  const customHoursUtc = normalizeCustomHours(raw);
  return {
    enabled: stored?.enabled ?? DEFAULT_DIGEST_ENABLED,
    interval: stored?.interval ?? DEFAULT_DIGEST_INTERVAL,
    hourUtc: stored?.hourUtc ?? DEFAULT_DIGEST_HOUR_UTC,
    weekday: stored?.weekday ?? DEFAULT_DIGEST_WEEKDAY,
    customHoursUtc
  };
}
function normalizeCustomHours(hours) {
  return [...new Set(hours)].sort((a, b) => a - b);
}
function isDigestDue(schedule, now) {
  if (!schedule.enabled) return false;
  const hour = now.getUTCHours();
  switch (schedule.interval) {
    case "hourly":
      return true;
    case "daily":
      return hour === schedule.hourUtc;
    case "weekly":
      return now.getUTCDay() === schedule.weekday && hour === schedule.hourUtc;
    case "custom":
      return schedule.customHoursUtc.includes(hour);
    default: {
      const exhaustive = schedule.interval;
      return exhaustive;
    }
  }
}
var HOUR_MS2 = 60 * 60 * 1e3;
var INTERVAL_SPAN_MS = {
  hourly: HOUR_MS2,
  daily: 24 * HOUR_MS2,
  // custom fires ≥1×/day, so a >24h gap means every custom hour was missed.
  custom: 24 * HOUR_MS2,
  weekly: 7 * 24 * HOUR_MS2
};
function isDigestOverdue(schedule, now, lastPeriodEnd) {
  if (!schedule.enabled) return false;
  if (lastPeriodEnd === null) return false;
  return now.getTime() - lastPeriodEnd.getTime() >= INTERVAL_SPAN_MS[schedule.interval];
}
function nextDigestRunUtc(schedule, now) {
  if (!schedule.enabled) return null;
  if (schedule.interval === "hourly") {
    return startOfNextHour(now);
  }
  if (schedule.interval === "custom") {
    const hours = normalizeCustomHours(schedule.customHoursUtc);
    if (hours.length === 0) return null;
    return nextHourInSet(now, hours);
  }
  if (schedule.interval === "daily") {
    return nextDailyRun(now, schedule.hourUtc);
  }
  return nextWeeklyRun(now, schedule.weekday, schedule.hourUtc);
}
function startOfNextHour(now) {
  const next = new Date(now);
  next.setUTCMinutes(0, 0, 0);
  next.setUTCHours(next.getUTCHours() + 1);
  return next;
}
function startOfUtcHour(instant) {
  const floored = new Date(instant);
  floored.setUTCMinutes(0, 0, 0);
  return floored;
}
function nextDailyRun(now, hourUtc) {
  const candidate = new Date(now);
  candidate.setUTCMinutes(0, 0, 0);
  candidate.setUTCHours(hourUtc);
  if (candidate.getTime() <= now.getTime()) {
    candidate.setUTCDate(candidate.getUTCDate() + 1);
  }
  return candidate;
}
function nextWeeklyRun(now, weekday, hourUtc) {
  const candidate = new Date(now);
  candidate.setUTCMinutes(0, 0, 0);
  candidate.setUTCHours(hourUtc);
  for (let i = 0; i < 8; i += 1) {
    if (candidate.getUTCDay() === weekday && candidate.getTime() > now.getTime()) {
      return candidate;
    }
    candidate.setUTCDate(candidate.getUTCDate() + 1);
    candidate.setUTCHours(hourUtc, 0, 0, 0);
  }
  return candidate;
}
function nextHourInSet(now, hours) {
  const candidate = startOfNextHour(now);
  for (let i = 0; i < 24; i += 1) {
    if (hours.includes(candidate.getUTCHours())) return candidate;
    candidate.setUTCHours(candidate.getUTCHours() + 1);
  }
  return candidate;
}
var digestScheduleInputSchema = /* @__PURE__ */ z.object({
  enabled: z.boolean(),
  interval: z.enum(DIGEST_INTERVALS),
  hourUtc: z.number().int().min(DIGEST_MIN_HOUR).max(DIGEST_MAX_HOUR),
  weekday: z.number().int().min(DIGEST_MIN_WEEKDAY).max(DIGEST_MAX_WEEKDAY),
  customHoursUtc: z.array(z.number().int().min(DIGEST_MIN_HOUR).max(DIGEST_MAX_HOUR)).max(DIGEST_MAX_CUSTOM_HOURS)
}).superRefine((value, ctx) => {
  if (value.interval === "custom" && normalizeCustomHours(value.customHoursUtc).length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["customHoursUtc"],
      message: "A custom schedule needs at least one hour."
    });
  }
  if (value.interval !== "custom" && value.customHoursUtc.length > 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["customHoursUtc"],
      message: "Custom hours are only allowed when the interval is custom."
    });
  }
});
function parseDigestScheduleInput(input) {
  const parsed = digestScheduleInputSchema.parse(input);
  return {
    enabled: parsed.enabled,
    interval: parsed.interval,
    hourUtc: parsed.hourUtc,
    weekday: parsed.weekday,
    customHoursUtc: parsed.interval === "custom" ? normalizeCustomHours(parsed.customHoursUtc) : []
  };
}

// src/conversation-routing/execution-bias.ts
var EXECUTION_BIASES = ["action_first", "balanced", "read_only"];
var DEFAULT_EXECUTION_BIAS = "action_first";
function isExecutionBias(value) {
  return typeof value === "string" && EXECUTION_BIASES.includes(value);
}

// src/autonomy/autonomy-mode.ts
var AUTONOMY_MODES = ["sandbox", "approval-first", "free-roam"];
var DEFAULT_AUTONOMY_MODE = "approval-first";
var DIALS = {
  // Explains, shows, navigates, teaches — never executes a write. The posture a
  // regulated buyer or a first-week evaluator picks while their security team is
  // watching.
  sandbox: { runtimeTier: "reads", executionBias: "read_only", autoApproveWrites: false },
  // Reads flow freely; a write meets the existing ConfirmCard. The default.
  "approval-first": {
    runtimeTier: "writes",
    executionBias: "balanced",
    autoApproveWrites: false
  },
  // The agent executes without confirmation. A test or staging tenant, a demo,
  // or a customer who has decided the speed is worth it.
  //
  // Note this is the RUNTIME half only, where a visitor genuinely asked for the
  // outcome. §5's walk-side floor on irreversible-and-costly classes belongs to
  // the Phase-4 walk engine, where nobody has requested anything and a
  // destructive action has no requester and no beneficiary.
  "free-roam": {
    runtimeTier: "destructive",
    executionBias: "action_first",
    autoApproveWrites: true
  }
};
function autonomyDialsFor(mode) {
  return DIALS[mode];
}
function autonomyModeMatching(dials) {
  return AUTONOMY_MODES.find(
    (mode) => DIALS[mode].runtimeTier === dials.runtimeTier && DIALS[mode].executionBias === dials.executionBias
  ) ?? null;
}
function parseAutonomyMode(raw) {
  return AUTONOMY_MODES.find((m) => m === raw) ?? null;
}

// src/experimental/experimental-feature-ids.ts
var SITE_WALK_LABS_FEATURE_ID = "guided-site-walk";
var SCHEDULED_SITE_WALK_LABS_FEATURE_ID = "scheduled-site-walk";
var FRONTIER_LABS_FEATURE_ID = "frontier";
var TEACH_MODE_LABS_FEATURE_ID = "teach-mode";
var ADAPTIVE_COMPOSITIONS_LABS_FEATURE_ID = "adaptive-compositions";
var COMPOSITION_OPENERS_LABS_FEATURE_ID = "composition-openers";
var EXPERIENCES_LABS_FEATURE_ID = "experiences";
var AGENT_PAGE_CONTROL_LABS_FEATURE_ID = "agent-page-control";
var SITE_MANUAL_LABS_FEATURE_ID = "generated-manual";
var BEHAVIOR_INSIGHTS_LABS_FEATURE_ID = "behavior-insights";
var STABLE_CONTROL_IDENTITY_LABS_FEATURE_ID = "stable-control-identity";
var COVERAGE_METRICS_LABS_FEATURE_ID = "coverage-metrics";
var REVEAL_PROBE_LABS_FEATURE_ID = "reveal-probe";
var SEALED_DEEP_WALK_LABS_FEATURE_ID = "sealed-deep-walk";
var TOUR_AUTO_OPEN_LABS_FEATURE_ID = "tour-auto-open";
var GRAPHQL_INTROSPECTION_LABS_FEATURE_ID = "graphql-introspection";
var WALK_NOMINATIONS_LABS_FEATURE_ID = "walk-model-nominations";
var SEALED_FRAME_VISION_LABS_FEATURE_ID = "sealed-frame-vision";

// src/experimental/walk-live-writes-labs-feature-id.ts
var WALK_LIVE_WRITES_LABS_FEATURE_ID = "walk-live-writes";

// src/autonomy/walk-posture.ts
var WALK_POSTURES = ["read_only", "safe", "live"];
var DEFAULT_WALK_POSTURE = "safe";
var GRANTS = {
  read_only: { pressing: false, sealedDeep: false, liveWrites: false },
  safe: { pressing: true, sealedDeep: true, liveWrites: false },
  live: { pressing: true, sealedDeep: true, liveWrites: true }
};
var POLICY = {
  // Presses nothing during the walk, so the agent has no witnessed evidence
  // that a page act is harmless — it asks before each one.
  read_only: { pageActsAsk: "always", writesAsk: true },
  safe: { pageActsAsk: "never", writesAsk: true },
  live: { pageActsAsk: "never", writesAsk: true }
};
function walkGrantsFor(posture) {
  return GRANTS[posture];
}
function agentPolicyFor(posture) {
  return POLICY[posture];
}
function parseWalkPosture(raw) {
  return WALK_POSTURES.find((p) => p === raw) ?? null;
}
var WALK_DIALS = ["pressing", "sealedDeep", "liveWrites"];
var WALK_DIAL_LABS_IDS = {
  pressing: REVEAL_PROBE_LABS_FEATURE_ID,
  sealedDeep: SEALED_DEEP_WALK_LABS_FEATURE_ID,
  liveWrites: WALK_LIVE_WRITES_LABS_FEATURE_ID
};
function walkDialForLabsId(featureId) {
  return WALK_DIALS.find((dial) => WALK_DIAL_LABS_IDS[dial] === featureId) ?? null;
}
function resolveWalkDial(posture, dial, override) {
  const derived = GRANTS[posture][dial];
  return {
    dial,
    labsId: WALK_DIAL_LABS_IDS[dial],
    derived,
    override,
    effective: override ?? derived
  };
}

// src/conversation-routing/model-preference.ts
var CONVERSATION_MODEL_PREFERENCES = ["cost_saver", "balanced", "quality_first"];
var DEFAULT_CONVERSATION_MODEL_PREFERENCE = "balanced";
function isConversationModelPreference(value) {
  return typeof value === "string" && CONVERSATION_MODEL_PREFERENCES.includes(value);
}

// src/channels/whatsapp-terms.ts
var WHATSAPP_CHANNEL_TERMS_VERSION = 1;
var WHATSAPP_CHANNEL_TERMS_EN = `Enabling WhatsApp routes your end users' conversations through Meta (WhatsApp Business Platform) as a sub-processor. Message content is stored in the EU where Meta's Local Storage supports it, and may be processed outside the EU for up to 60 minutes in transit.

By enabling this channel you authorize Meta as a sub-processor for your workspace and confirm that, as the data controller, you will: (1) reflect WhatsApp in your own privacy notice; (2) obtain any opt-in your law requires before messaging users; (3) accept Meta's WhatsApp Business terms, which apply to your account.

Your workspace's agent answers on WhatsApp from your documentation and your declared scope only. Account linking is a separate setting with its own terms and is off until you turn it on.`;
var WHATSAPP_LINKING_TERMS_VERSION = 1;
var WHATSAPP_LINKING_TERMS_EN = `Turning on account linking lets a WhatsApp user connect to their account with you through the identity endpoint you provide. A stored link between a WhatsApp identity and a customer identity is personal data in your systems and ours. Links expire after 30 days without use and after 90 days at most; a change of the user's WhatsApp identity ends the link; turning this setting off removes every stored link. Linked users can read their own data through the agent; the agent cannot change anything on their behalf on this channel.`;
var WHATSAPP_TERMS_HISTORY = [
  {
    kind: "channel",
    version: 1,
    sha256: "9b3b625af05f6f9dd332445b434576461ecbe0fcf4d8773185b990b38654d682"
  },
  {
    kind: "linking",
    version: 1,
    sha256: "c5719419afa8fed1a50d3a7ac5feabc9e3f3d3951e47003a170b29d97c67052a"
  }
];
function whatsappSecretName(kind, environment) {
  return `whatsapp-${kind}-${environment}`;
}
var WHATSAPP_ID_PATTERN = /^\d{1,32}$/;
var WHATSAPP_BUSINESS_NAME_MAX_CHARS = 120;
var WHATSAPP_SCOPE_MAX_CHARS = 2e3;
var WHATSAPP_SECRET_MAX_LENGTH = 512;
var WHATSAPP_RESOLVER_URL_MAX_LENGTH = 2048;
var graphemeCapped = (maxChars) => z.string().trim().min(1).max(maxChars * 16).refine((value) => countGraphemes(value) <= maxChars, {
  message: `Must be at most ${String(maxChars)} characters`
});
var whatsappIdSchema = /* @__PURE__ */ z.string().trim().regex(WHATSAPP_ID_PATTERN);
var secretSchema = /* @__PURE__ */ z.string().trim().min(1).max(WHATSAPP_SECRET_MAX_LENGTH);
var EnableWhatsappChannelInputSchema = /* @__PURE__ */ z.object({
  environment: z.enum(["development", "production"]),
  phoneNumberId: whatsappIdSchema,
  wabaId: whatsappIdSchema,
  businessName: graphemeCapped(WHATSAPP_BUSINESS_NAME_MAX_CHARS),
  scopeDescription: graphemeCapped(WHATSAPP_SCOPE_MAX_CHARS),
  defaultLocale: z.enum(LOCALE_CODES).nullish(),
  systemUserToken: secretSchema,
  appSecret: secretSchema,
  acknowledgedTermsVersion: z.number().int().positive()
}).strict();
var SetWhatsappAccountLinkingInputSchema = /* @__PURE__ */ z.object({
  environment: z.enum(["development", "production"]),
  enabled: z.boolean(),
  resolverUrl: z.string().trim().max(WHATSAPP_RESOLVER_URL_MAX_LENGTH).nullish(),
  acknowledgedTermsVersion: z.number().int().positive().nullish()
}).strict();

// src/experimental/agent-labs-features.ts
var AGENT_LABS_FEATURES = [
  // WS4 — prompt-profile targeting. A tenant may hold many prompt profiles;
  // with this on, a profile can be scoped to audiences, to specific users, to
  // turns where particular tools are available, or to a share of visitors, and
  // the resolution simulator explains which one wins and why. **ON since
  // ADR-0521.** It changes WHICH prompt a visitor gets — the single most visible
  // thing about the agent — and a workspace that has authored no targeting rule
  // still resolves to its active profile, so ON and OFF are identical until
  // somebody deliberately targets something. A profile is a voice and never a
  // permission: no targeting rule can widen a turn's tool surface, grant a
  // capability, or relax the guardrail layer it composes beneath. Alpha.
  { id: "prompt-targeting", stage: "alpha", defaultEnabled: true },
  // W10 (ADR-0353) — customer-authored per-capability guidance reaching the
  // SERVED tool description on chat + MCP. The authoring surface (the Guidance
  // section on the capability detail page) ships ENABLED and unflagged; this
  // gates only the agent-facing composition, so an operator can revert a bad
  // clause set for one tenant without a deploy. `beta`, not `alpha`: a complete
  // feature shipped dark, not one still being built.
  // **Default ON since ADR-0521** — guidance changes what every
  // visitor's agent reads, which is exactly why it wants to be running where the
  // only visitors are the workspace's own people. It can never widen the tool
  // surface or grant a capability: a clause is operator-authored, sanitized at
  // the write boundary, bounded per capability, and its audience filter fails
  // closed. The dashboard still states plainly when the flag is off, so an
  // authored clause is never a silent no-op.
  { id: "capability-guidance", stage: "beta", defaultEnabled: true },
  // W9 (ADR-0351) — the SERVED-surface half of tool priority: near-tie emission
  // ordering plus the disambiguation clause. The dashboard priority control and
  // its display of which value is in force ship enabled and unflagged; only the
  // agent-facing steering is gated, because emission order and an injected
  // "prefer X over this" sentence change tool selection on every turn. `beta`,
  // **default ON since ADR-0521**, same reasoning as `capability-guidance`:
  // emission order and a "prefer X over this" sentence change tool selection
  // every turn, and neither can add a tool the turn had not already resolved.
  { id: "tool-priority-steering", stage: "beta", defaultEnabled: true },
  // The outbound read allowlist (`plan/agent-allowed-sites.md`). With this on,
  // the reserved `read_allowed_page` tool is advertised — but only where the
  // workspace has approved at least one destination, so an empty allowlist keeps
  // the agent exactly as confined as it is today. **Default ON since ADR-0521**,
  // and safe to default precisely BECAUSE it stays triple-gated (this flag AND
  // the env kill switch AND a non-empty allowlist): it is the only feature that
  // lets the agent read anything outside the tenant's own catalog, connectors
  // and indexed documentation, so a workspace that has approved no destination
  // is exactly as confined with this ON as with it OFF. The decision that
  // matters was never this flag — it is the first destination a workspace
  // approves, which is per-site, audited, and still ahead of every tenant.
  // `alpha`.
  { id: "agent-allowed-sites", stage: "alpha", defaultEnabled: true }
];

// src/experimental/whatsapp-channel-labs-feature-id.ts
var WHATSAPP_CHANNEL_LABS_FEATURE_ID = "whatsapp-channel";

// src/experimental/conversation-labs-features.ts
var CONVERSATION_LABS_FEATURES = [
  // Users-surface redesign E5 (ADR-0192) — the end-user memory endpoints: read
  // and self-service forget-me (DSAR erase of the caller's own learned data).
  // Both refuse when this flag is off, and it ALSO gates the
  // `/presentation-preferences/*` endpoints the composition surface dismisses
  // blocks through (`presentation-preferences.controller.ts` reuses this
  // FEATURE_ID) — so switching it off stops dismissals being remembered too.
  // Alpha, **default ON since ADR-0521.** It had been held for counsel's PR-15
  // review, and that gate was pointing the wrong way: `user_learning` is already
  // default-ON, so the workspace is ALREADY learning and this flag only decided
  // whether the end user could be told and given an erase button.
  //
  // 2026-08-27 — the widget "what the agent remembers about you" panel this
  // once delivered was REMOVED (operator instruction), so the flag no longer
  // produces any end-user surface. The endpoints are unchanged; a visitor now
  // exercises access/erasure through the operator. The Art 15/17 consequence is
  // banked as `docs/compliance/counsel-review-debt.md` CRD-17.
  { id: "end-user-memory-view", stage: "alpha", defaultEnabled: true },
  // CL-11 (Q8, plan/conversation-logs-perfection.md) — on-demand transcript
  // translation: the "Translate" control on the /conversation-logs/:id Inspector
  // that translates the REDACTED transcript into the operator's dashboard locale
  // on Bedrock-EU (cached). Alpha, **default ON since ADR-0521** — shipped and
  // live-verified against real Bedrock-EU (CL-11a); the server mutation is
  // `analytics:view`-gated regardless.
  { id: "conversation-transcript-translate", stage: "alpha", defaultEnabled: true },
  // CL-11 (Q4) — semantic "search by meaning" over the derived insight text: a
  // toggle on the /conversation-logs Explorer that ranks conversations by how
  // close their (LLM-derived, PII-free) insight is to a natural-language query,
  // via Bedrock-EU embeddings + pgvector. Alpha, **default ON since ADR-0521**
  // (shipped + live-verified, CL-11b); the `searchInsightsByMeaning` query is
  // `analytics:view`-gated regardless.
  { id: "conversation-semantic-search", stage: "alpha", defaultEnabled: true },
  // CL-11 (flagship) — NL "ask your conversations": a Pulse panel that answers a
  // natural-language question grounded on the tenant's DERIVED insight facts on
  // Bedrock-EU, citing the real conversations it used ("cites N conversations").
  // Alpha, **default ON since ADR-0521** (shipped + live-verified, CL-11c);
  // `askConversations` is `analytics:view`-gated + grounded (a hallucinated
  // citation is dropped) regardless.
  { id: "conversation-ask", stage: "alpha", defaultEnabled: true },
  // W-05 Slice 4 — end-user "email me my transcript": the widget lets a SIGNED-IN
  // end user email a link to their OWN conversation transcript to their OWN
  // IdP-verified address (never a typed one). Delivered to the widget through the
  // config channel only when this flag is on, and the POST
  // /conversations/:id/transcript-email endpoint refuses when off (defense in
  // depth). Alpha, **default ON since ADR-0521.** It reads as a new outbound flow
  // of end-user personal data, and the qualifier is what decides it: the
  // recipient is the data subject, at their OWN IdP-verified address, for their
  // OWN transcript. That is self-service Art 15 access wearing a feature's
  // clothes — the same posture that made `end-user-memory-view` a flip rather
  // than a wait. INERT until blocker C6 seeds an SMTP credential.
  { id: "end-user-transcript-email", stage: "alpha", defaultEnabled: true },
  // ADR-0796 — WhatsApp as a conversation channel. Alpha, **default OFF by
  // operator decision (2026-09-11)** until the first end-to-end Meta test, the
  // escalation-path decision and the judged scope eval — see the id's own doc
  // comment. Gates the tab, both write mutations, the webhook and the worker.
  { id: WHATSAPP_CHANNEL_LABS_FEATURE_ID, stage: "alpha", defaultEnabled: false }
];

// src/experimental/discovery-labs-features.ts
var DISCOVERY_LABS_FEATURES = [
  // ── Runtime discovery (OF-P1-3, ADR-0396) ──────────────────────────────
  //
  // The four authorised widget-only discovery mechanisms, one Labs entry each.
  //
  // Why per-tenant at all, when each already has a fleet env flag: the env flag
  // is the KILL SWITCH and this is the CHOICE. ADR-0396 D6 declined staged
  // *authorisation* and explicitly preserved staged *enablement* — "staged
  // enablement remains available and should be used" — which needs a per-workspace
  // dimension the env flag cannot express. The two compose (fleet AND tenant AND
  // `discoveryEvalGateOpen()`); neither weakens the other.
  //
  // **`defaultEnabled: true` on all four as of 2026-08-11 — ADR-0469**, which
  // carries the reasoning. In one line: `false` priced the cost of an UNWANTED
  // review queue and never priced the cost of an empty one, which is what every
  // workspace actually had — a per-tenant default nobody knows to flip is not
  // staged enablement, it is a program that does not run.
  //
  // What made the flip safe was ADR-0396 cl. 1 (promote → DISABLED → separate
  // enable) and ADR-0400's always-confirm floor — the first of which no longer
  // exists: ADR-0537 removed the drafter and the review queue, so a harvest can
  // no longer become a capability by any path. That is a NARROWING, and it
  // moves what these entries govern. They now decide whether a mechanism may
  // map the site at all — feeding the site manual, `find_controls`, control
  // presence and the `navigate_to` route set — and no longer gate a promotion
  // step, because there is none. The customer-facing descriptions were
  // corrected to match; a Labs card promising a review that cannot happen is
  // the same defect one document along.
  //
  // Still four entries rather than one "runtime-discovery" toggle: ADR-0396's
  // reversibility clause requires each mechanism to be separately revertible, and
  // the default flip does not weaken that — a workspace switches any one off, and
  // the fleet env flag remains the kill switch that outranks all of them.
  { id: "ui-form-harvest", stage: "alpha", defaultEnabled: true },
  { id: "ui-route-harvest", stage: "alpha", defaultEnabled: true },
  { id: "ui-anchor-harvest", stage: "alpha", defaultEnabled: true },
  { id: "ui-jsonld-harvest", stage: "alpha", defaultEnabled: true },
  // R5 — the service worker's precached page inventory. A fifth entry rather than a
  // fold into `ui-route-harvest`, on the same reversibility reasoning as the four
  // above: it is a distinct mechanism with distinct evidence (a build's asset list,
  // not a framework's route table) and must be separately revertible.
  //
  // **`defaultEnabled: true`, joining its four siblings** — the entry is the
  // workspace's opt-OUT. It was flipped off on 2026-08-20 when the agent legal
  // review found the harvest reading Cache Storage in an END USER's browser on an
  // ordinary chat turn (ePrivacy Art 5(3)), and is back on because the read moved
  // to the guided WALK, where an admin explicitly starts a banner-visible run on
  // their own site — "a service explicitly requested by the user", which is the
  // test the exemption applies. What a precached page can become is bounded by
  // the block above rather than by a promote step: post-ADR-0537 it joins the
  // route inventory the agent navigates from, subject to the operator's
  // per-control deny, and never becomes a callable capability.
  { id: "ui-precache-harvest", stage: "alpha", defaultEnabled: true },
  // WF-4.49c-ii — the routes a `<script type="speculationrules">` block names.
  //
  // Its OWN entry rather than a share of the anchor leg's, per ADR-0396's
  // reversibility clause and because the two know different things: an anchor
  // says a page LINKS somewhere, a speculation rule says the developer expects a
  // visitor to GO there — a priority signal, and the only free source of one.
  //
  // `defaultEnabled: true`, so this entry is the workspace's opt-OUT like its
  // siblings. It engages none of the ePrivacy question the precache entry above
  // records: this reads a `<script>` element in a document the walk already
  // loaded, not a browser store, so no terminal-equipment access arises and no
  // bind-time grant is needed. It is still walk-only at the SCREEN, for the
  // smaller reason that nothing on the chat path produces the leg.
  { id: "ui-speculation-harvest", stage: "alpha", defaultEnabled: true },
  // WF-4.35 remainder / ET-2 § A.2 — routes a site's own `.well-known` artifacts
  // declare.
  //
  // Its own entry, and this is the one in the family where the workspace switch
  // earns its keep for a reason beyond the reversibility clause: this leg issues
  // an UNCONDITIONAL same-origin request per origin (the AASA probe), where the
  // four before it read markup already in hand. A workspace that would rather
  // their site not be asked has to be able to say so without losing the free legs.
  //
  // `defaultEnabled: true` — an opt-OUT like its siblings. The artifact is a
  // document a site publishes precisely so that somebody will fetch it (D10 Tier
  // 1.5), requested from the operator's own browser during a run they started.
  { id: "ui-well-known-harvest", stage: "alpha", defaultEnabled: true },
  // WF-4.47 / ADR-0583 — endpoints read as literals out of the site's own
  // bundles during a walk, where no source map names the caller.
  //
  // Its own entry for the reversibility clause, and because this is the leg
  // with the widest recall and the thinnest rows: every proposal arrives with
  // no title and no schema, so a workspace that finds that queue too coarse to
  // review must be able to switch it off without losing the named tier beside
  // it. Nothing is read that the page did not already download — the bundle is
  // a `<script src>` the browser fetched to run — and no source text leaves the
  // browser (the D16 record).
  //
  // `defaultEnabled: true` — an opt-OUT like its siblings.
  { id: "ui-bundle-harvest", stage: "alpha", defaultEnabled: true },
  // The Guided Site Walk (`plan/onboarding-fast-scan/PLAN.md` § 4) — an operator
  // drives a bounded, visible, abortable walk of their own application in their
  // own browser, and the four harvests above run per route.
  //
  // **`defaultEnabled: true`, and this entry is the one exception in the block.**
  // Operator decision D2 (2026-08-07) applied ADR-0334's default-ON doctrine here,
  // against the recommendation, which was opt-in. Recorded rather than absorbed
  // because it changes what a gate means: with Labs on by default for an entitled
  // tenant, the walk is gated by a `catalog:edit`-minted single-use, origin-bound
  // token and by nothing else — the `data-site-walk` embed attribute that used to
  // be a second gate is retired (Z-1 / ADR-0596: the one-time deep link IS the
  // gate, and editing HTML is the cost the zero-touch contract forbids).
  //
  // The remaining gate is real and not passive — an admin mints the token — so a
  // visitor cannot reach this, which is the property the operator asked for. What
  // is gone is a further deliberate act, so a workspace can have the walk
  // reachable without anyone having decided to enable the surface. Named in
  // PLAN § 9 as the accepted residual, and the leaked-link window as SRD-44.
  //
  // **The entry is now actually READ.** Until 2026-08-07 it was registered and
  // consumed by nothing at all, so the "gated three times over" claim in three
  // separate comments described a control that did not exist — the BP § 7 C3 failure
  // class. `SiteWalkController` enforces it at bind and ingest, failing closed.
  // `defaultEnabled: true` means it is on unless an operator turns it off, which is
  // D2's decision and unchanged; what changed is that turning it off now does
  // something.
  { id: SITE_WALK_LABS_FEATURE_ID, stage: "alpha", defaultEnabled: true },
  // WS-D D1 — the scheduled re-walk rides its parent walk entry: cadence OFF
  // until the operator picks one (the FEATURE is on, the first schedule is one
  // click — plan §5 Rollout), so `defaultEnabled: true` exposes a control and
  // schedules nothing. The gate reads the flag itself and fails toward OFF
  // (the coverage-metrics shape), and the schedule can only ever say a walk is
  // DUE — the bind ceremony stays operator-in-the-loop, so no cadence value
  // can start a crawl.
  { id: SCHEDULED_SITE_WALK_LABS_FEATURE_ID, stage: "alpha", defaultEnabled: true },
  // W0-7 / OF-P4-2 — auto-promote the `read` proposals in the review queue.
  //
  // `defaultEnabled: false`, and unlike the entry above that is not a preference:
  // `auto-approve-policy.ts` names operator opt-in as the FIRST of its four
  // conditions, on the grounds that "a default-on relaxation is not a default". A
  // Labs entry is the opt-in mechanism because it is the one the product already
  // has — per-tenant, audited on change, and visible in the dashboard — rather
  // than a second settings surface that would have to be kept in step.
  //
  // What it relaxes is bounded to the PROMOTE gate. An auto-approved capability
  // lands DISABLED exactly as a hand-approved one does (FR-2 / SYN-120), and
  // enablement stays manual for every capability regardless of class (D3 / D6). A
  // `ui-discovery` proposal is never eligible whatever this says, because ADR-0400's
  // premise is that nobody labelled it — auto-approving one would stack two
  // absences of human judgement on the same capability.
  // W3-1 (ADR-0394, amended by ADR-0471) — teach mode: the authenticated,
  // operator-driven capture session that infers a value-free API schema from a
  // workspace's own site. Operator decision (2026-08-11).
  //
  // **`defaultEnabled: true`, and this entry is the ONLY control over the surface.**
  // The fleet `TEACH_MODE_ENABLED` env var was REMOVED rather than defaulted on: two
  // flags over one surface meant the Labs toggle an operator could see did nothing.
  // What still gates a capture is `catalog:edit`, a single-use bind token, and the
  // session's one allowlisted origin; a visitor reaches none of it.
  //
  // **Like `frontier` above, NOT read through `ExperimentalFeaturesService.isEnabled`**
  // — that method's fail direction is wrong for a default-ON gate. The reasoning lives
  // at the read site (`api/discovery-session/teach-mode-gate.ts`), so the two cannot
  // drift. ADR-0471 carries the data-protection consequence and the residual.
  { id: TEACH_MODE_LABS_FEATURE_ID, stage: "alpha", defaultEnabled: true },
  // ADR-0488 — runtime page control: the agent operating controls it discovers on
  // the LIVE page (`ui_scan` + `ui_click`/`select`/`set`/`focus`/`scroll`), as
  // opposed to the static `ui_navigate`/`highlight`/`fill` derived from the
  // authored catalog. Operator decision (2026-08-13).
  //
  // **`defaultEnabled: true`, and it exists because the DEFAULT moved.** The
  // per-surface `copilotMode.runtimeDiscovery` config flag flipped to ON in the
  // same change, and it is the one Frontier-adjacent default whose flip genuinely
  // widens the agent's reach: those verbs advertise on that flag ALONE (runtime
  // governance is allow-by-default-with-denies, so there is no per-unit rung
  // beneath it the way `copilotMode.enabled` has one). A default that widens reach
  // needs a switch the customer can FIND, which is what this entry is.
  //
  // Why a card of its own rather than leaning on the two switches that already
  // reach this: both cost more than the customer wants to pay. `frontier` above
  // darkens the entire layer; the Frontier `copilot_mode` family switch darkens the
  // STATIC ui.* family too. Neither expresses "keep the tools I authored, drop the
  // ones the agent finds", which is the distinction this feature is ABOUT — and the
  // `frontier` card's own copy already promises that "individual features can still
  // be turned off on their own cards", which for the flagship was not true.
  //
  // The Agent UI control page keeps the per-surface switch + the `runtimeTier`
  // ceiling; this is the workspace rung above it, in the same relationship as
  // `teach-mode` to a capture session. The two cannot present as one switch doing
  // nothing — the ADR-0471 defect — because that card states plainly when this is
  // off (the `capability-guidance` precedent).
  //
  // **NOT read through `ExperimentalFeaturesService.isEnabled`**, like `frontier`
  // and `teach-mode` — that method's fail direction is wrong for a default-ON gate.
  // The reasoning lives at the read site (`isAgentPageControlEnabled`) so the two
  // cannot drift.
  { id: AGENT_PAGE_CONTROL_LABS_FEATURE_ID, stage: "beta", defaultEnabled: true },
  // PLAN §3 PR-1 — the guided tour opening a concealed section itself.
  //
  // **Default ON since 2026-08-20 (operator decision), and this row is the
  // record of what moved.** It shipped default-OFF because this is the one
  // place the tour ACTS on the host page: `security.md` ASI09 has said since
  // the DAP overlays shipped that a tour "never prevents, stops, or redirects
  // the click", and this is the clause that changes. That is still true, and it
  // is why the entry is written out here rather than folded in with its
  // siblings.
  //
  // Two things held it OFF and both are discharged. The field figure this
  // feature exists to move is measured: **0.606** of everything reveal-shaped
  // across the five demo sites, against the ARIA-gated predicate's **0.122** on
  // the same ground truth in the same run (`qa/demo-fleet/tour-results.json`),
  // which is what lifting the allowlist was for. And the security-engineer
  // review has RUN, as the agent pass `pr-discipline.md` § "Review Gates Are
  // AGENT-Performed" defines, with its findings fixed in code rather than
  // filed — the quarantine bound, the page-control governance leg, the SPA
  // navigation refusal and the silent-refusal reporter all landed in the same
  // change as this flip.
  //
  // The operator's two binding constraints are unchanged and are still what
  // makes the default safe: no ARIA admission rule, and no activation that
  // makes an actual change — satisfied one layer down in `activation-policy.ts`
  // (structural refusals, incl. destructive and session-ending names in all six
  // locales) and `containment.ts` (non-GET writes, form submit and SPA
  // navigation refused for the activation's duration). Quarantine now fires on
  // EVERY activation, so the deferred-write residual `plan/DEBT.md` D-001
  // records costs at most one activation per control per run.
  //
  // `stage: 'beta'` now that the figure exists — `alpha` said the measurement
  // had not been taken, and it has.
  { id: TOUR_AUTO_OPEN_LABS_FEATURE_ID, stage: "beta", defaultEnabled: true },
  // WF-4.12 / ADR-0582 § 4, superseded on the DEFAULT by ADR-0601 (zero-touch
  // walk B7) — GraphQL introspection during a walk.
  //
  // `defaultEnabled: true`. ADR-0582 shipped it OFF on a METHOD argument, which
  // is unchanged and is now written where it can be checked rather than
  // defended by a default: the walk's non-GET surface is ONE conventional
  // same-site path reached by one module, and widening it to any other POST is
  // a superseding ADR rather than a reuse of this id.
  //
  // What changed is that OFF stopped buying anything. Z-12 made the SCHEMA the
  // point of the row, D's publish lane reads it out of `walk_served_specs`, and
  // a default-off probe leaves that lane with nothing to read on every
  // workspace that never found the toggle. ADR-0601 carries the security pass
  // (`docs/compliance/graphql-introspection-security-review.md`, SRD-49); the
  // fleet env var remains the kill. `stage: 'beta'`: complete, reviewed and on
  // — what is still unmeasured is what SHARE of walked sites answer
  // introspection at all, which is a coverage figure rather than a stage.
  { id: GRAPHQL_INTROSPECTION_LABS_FEATURE_ID, stage: "beta", defaultEnabled: true },
  // WF-4.16 / ADR-0579 — after the mechanical pass, the model nominates which
  // of the routes the walk already enumerated deserve the remaining visit
  // budget; the mechanical walker executes and vets them under every gate it
  // already applies. Never HOW: a nomination is a choice among enumerated
  // targets, and model output can never become a click.
  //
  // `defaultEnabled: false`, and OFF is the DECISION (ADR-0579): the row
  // spends per walk (one EU-resident model call), makes coverage partly
  // non-deterministic, and sends the workspace's own route templates to a
  // model — the toggle's copy says so. `stage: 'alpha'`: nothing has measured
  // the exhaustiveness floor it buys; F.1's sweep is where that comes from.
  { id: WALK_NOMINATIONS_LABS_FEATURE_ID, stage: "alpha", defaultEnabled: false }
];

// src/experimental/docs-engine-labs-features.ts
var DOCS_ENGINE_LABS_FEATURES = [
  // DE-102..106 — the generated WIKI: per-page, per-area and per-capability
  // articles drafted from what discovery already observed, reviewed in the
  // `/docs/articles` review queue, and published only by a human who read one.
  //
  // The sibling of `generated-manual` and deliberately separate from it: the manual
  // is ONE synthesized document a workspace can read; this is hundreds of
  // articles a workspace has to REVIEW, and a tenant may reasonably want the
  // first without taking on the second.
  //
  // **`defaultEnabled: false`, and it STAYS off now that DE-108 has landed.**
  //
  // The precondition this waited on is met — voice, glossary and the never-say
  // list exist, so a workspace's articles are written in its own register and a
  // prohibited phrase refuses the locale rather than reaching a reviewer — and
  // the fleet `WIKI_DRAFTER_ENABLED` switch flipped ON with it. This one does
  // not, because the two answer different questions. That one asks whether the
  // platform is willing to run the job; this asks whether a WORKSPACE wants
  // three hundred articles in their review queue.
  //
  // The distinction is the review burden rather than the risk. Nothing here
  // reaches a visitor without a human reading an article and approving it
  // (DE-105's render gate), so an accidental ON is not a safety event — it is
  // 60–120 decisions somebody did not ask for, on a queue that is the program's
  // own top UX risk. A feature whose cost to the customer is their attention
  // is one they opt into.
  //
  // Being default-OFF, it is read through the ORDINARY
  // `ExperimentalFeaturesService` path rather than `resolveLabsFlagFailClosed`:
  // that helper exists because a store failure resolving to a default-ON
  // entry's default re-opens a surface a workspace closed. For an opt-IN entry
  // the registry default IS off, so the ordinary read already fails closed.
  { id: "generated-wiki", stage: "alpha", defaultEnabled: false },
  // DE-014 / § 3.3 rung 3 — whether an APPROVED article may be projected into
  // the corpus an END USER reads, superseding the site manual's node prose for
  // that page.
  //
  // **`defaultEnabled: false`, by operator decision 2026-08-27** (recorded in
  // `plan/docs-engine/PLAN.md` § 13). § 13 already said publication should
  // "enable per-tenant, starting with a small cohort"; this is that sentence
  // made mechanical instead of procedural, because a rollout that lives only in
  // a plan is a rollout somebody has to remember.
  //
  // **What it does NOT govern, which is the half worth reading.** It is not an
  // audience control and it does not widen one. A rung-3 article projects at
  // `tenant-internal` — the SAME label the dossier's node prose already carries
  // and has carried since the manual shipped — so flipping this changes WHICH
  // generated prose a visitor reads about a page, never WHETHER generated prose
  // reaches them. Rung 2 is outside it entirely: an `internal` article projects
  // at `restricted`, which no anonymous reader resolves, and the audience it
  // does reach is the workspace's own team, who are the people that asked for
  // it.
  //
  // **The withhold is a PAIR, and `projectArticles` keeps the two together.**
  // OFF withholds the article's chunks AND the supersession of the node prose
  // it would have replaced. Withholding only the first would leave the page
  // documented by nothing at all — a switch whose whole purpose is to hold new
  // prose back silently deleting the prose that was already working.
  //
  // Opt-IN, so the ordinary `ExperimentalFeaturesService` read already fails
  // closed: a store failure resolves to the registry default, which is off.
  { id: "generated-wiki-publish", stage: "alpha", defaultEnabled: false }
];

// src/experimental/program-master-labs-features.ts
var PROGRAM_MASTER_LABS_FEATURES = [
  // ADR-0468 — the ONE customer switch over the WHOLE Frontier experience layer:
  // Copilot page-control, WebMCP, generative dashboards, and
  // the learning surfaces. Operator decision (2026-08-11).
  //
  // **`defaultEnabled: true`,** which is the point rather than an accident: ADR-0464
  // made the entitlement universal and ADR-0334 made every feature default-ON, so the
  // experience is the default and this switch is how a workspace declines it.
  //
  // Why Labs rather than a bespoke settings card: the product already has exactly the
  // surface this needs — per-tenant, audited on change, instant-apply with a toast,
  // ×6 localized, and one card per feature. A second settings surface would be a
  // second thing to keep in step, which is the failure the flag merge itself exists
  // to remove.
  //
  // **This entry is NOT read through `ExperimentalFeaturesService.isEnabled`** —
  // that method's fail direction is wrong for a default-ON gate. The reasoning
  // lives at the read site (`FrontierStateService.isCustomerSwitchOn`) rather
  // than being restated here, so the two cannot drift.
  { id: FRONTIER_LABS_FEATURE_ID, stage: "beta", defaultEnabled: true },
  // Adaptive Compositions B7 — the deterministic discoverability openers: chips
  // composed from the workspace's OWN enabled capabilities, filling an empty
  // chat panel so a first-time visitor can see what the agent is for. The
  // operator's own conversation starters always take precedence.
  //
  // **This entry was MISSING until ADR-0521, and its absence made the feature
  // unreachable** — a "built, tested, unreachable" defect of the class
  // `site-walk-security-review.md` names. Everything else shipped: the
  // `COMPOSITION_OPENERS_ENABLED` fleet flag, the `readCatalogOpeners` gate, and
  // the ×6 locale copy under `labs.feature.composition-openers.*`. Only the
  // registry row was dropped — and `ExperimentalFeaturesService.isEnabled`
  // returns `false` for an id the registry does not know (a correct
  // fail-safe, doing exactly its job here), so the per-tenant check
  // short-circuited to `false` for every workspace forever and the fleet flag
  // downstream of it could never be reached. Flipping that flag alone would have
  // read as an enablement and changed nothing.
  //
  // `defaultEnabled: true` per ADR-0521: the openers are DETERMINISTIC — no
  // composer, no model-authored block, no untrusted content — so they are not
  // covered by the Adaptive Compositions security review, and they are the one
  // part of that program useful before a single composition ships.
  { id: COMPOSITION_OPENERS_LABS_FEATURE_ID, stage: "alpha", defaultEnabled: true },
  // Adaptive Compositions (A5) — composed answers: the agent may reply with a
  // set of live components sized to the chat area, instead of only text and
  // single components.
  //
  // **`defaultEnabled: true` since ADR-0521**, and the reasoning is the rollout
  // ladder rather than a waiver of it. IMPLEMENTATION.md § 6 Stage B is "dogfood
  // tenants only — no third-party tenant before E3", and every tenant in the
  // fleet IS a dogfood tenant, so this default and that stage currently describe
  // the same set. **This is therefore the entry to re-decide at the first
  // external tenant**, alongside `mcp-apps-ui`: the E3 security review is still
  // owed on a surface where the model sees fetched data before choosing a
  // layout. What holds meanwhile is structural — the exclusion list enforced at
  // parse AND render, no `confirmCard` member for a block to project into,
  // server-side action re-derivation, and a clamp that only ever removes.
  //
  // The other two legs of the three-leg contract live outside this registry:
  // `ADAPTIVE_COMPOSITIONS_ENABLED` in the api's env config is the fleet kill
  // switch (an incident lever that never retires), and the turn-assembly gate is
  // what actually withholds the tool. There is deliberately no Frontier entry —
  // see the id's doc comment.
  { id: ADAPTIVE_COMPOSITIONS_LABS_FEATURE_ID, stage: "alpha", defaultEnabled: true },
  // On-page experiences (ADR-0556–0562) — persistent visitor-facing content on
  // the customer's own page, under one record, one governor and one funnel.
  //
  // `defaultEnabled: true`, and safe by CONSTRUCTION rather than by optimism: a
  // unit is born `draft` at zero rollout, so a workspace with this on and
  // nothing armed renders what it rendered before — nothing. An OFF default
  // would buy no exposure reduction and would cost an operator who arms a unit
  // and finds it does not appear because of a switch nobody mentioned.
  //
  // The other two legs live outside this registry: `EXPERIENCES_KILL` is the
  // fleet incident lever, and `ExperienceEligibilityService` is what withholds
  // a unit. See the id's doc comment for why this is Labs and not Frontier —
  // same reasoning as compositions above, and the same absence of a paid gate.
  { id: EXPERIENCES_LABS_FEATURE_ID, stage: "alpha", defaultEnabled: true }
];

// src/experimental/icon-crop-naming-labs-feature-id.ts
var ICON_CROP_NAMING_LABS_FEATURE_ID = "icon-crop-naming";

// src/experimental/surface-mapping-labs-features.ts
var SURFACE_MAPPING_LABS_FEATURES = [
  // The generated site manual (WS-C, widget-surface-mapping §4). With this on,
  // the manual is reachable — since DE-301 § 7.2 as a panel of `/docs/articles`
  // rather than its own `/site-manual` route — and the resolver's second
  // gate opens — the manual is a versioned, per-tenant dossier synthesized from
  // what discovery already stores, so a zero-docs tenant still gets an
  // agent-retrievable product manual. Deliberately two-gated (this Labs entry AND
  // the `SITE_DOSSIER_ENABLED` env kill switch), the same shape as
  // the nightly drafter builds this workspace's manual — a versioned, per-tenant
  // dossier synthesized from what discovery already stores and published into
  // docs-RAG, so a zero-docs tenant still gets an agent-retrievable product
  // manual. There is no dashboard surface: the manual is consumed by the agent. Deliberately two-gated (this Labs entry AND
  // the `SITE_DOSSIER_DRAFTER_ENABLED` env kill switch), the same shape as
  // `agent-allowed-sites` above and `guided-site-walk`. It SHIPPED default-OFF
  // under the new-flag policy — a brand-new surface stays inert until it is
  // verified end-to-end and an operator opts in. The plan's "Labs manual ON" is the
  // post-verification rollout target — and that verification is now DONE.
  //
  // **Default ON as of 2026-08-17 (WS-H, operator decision).** The new-flag
  // policy was right while the surface was unverified; it is now end-to-end
  // proven (real-Postgres integration + the operator dashboard) and the plan's
  // §4 rollout line named ON as the target. What the flip does NOT touch is the
  // second gate: `SITE_DOSSIER_DRAFTER_ENABLED` remains a separate fleet lever,
  // so a workspace's Labs entry being on still cannot spend money the operator
  // has not authorised. This entry is the per-workspace opt-OUT, resolved
  // fail-toward-OFF. It gates BOTH halves: the nightly BUILD, and the read
  // behind the manual panel in `/docs/articles`. ADR-0531 retired the
  // standalone `/site-manual` ROUTE, which is what the id was renamed off
  // (`site-manual` -> `generated-manual`, migration 455) — not the query and
  // mutation, which moved into the documentation hub with the panel. The manual
  // reaches the agent through docs-RAG either way.
  { id: SITE_MANUAL_LABS_FEATURE_ID, stage: "beta", defaultEnabled: true },
  // WS-G3 (widget-surface-mapping §8) — cross-lane capability confidence on the
  // review card. With this on, `CatalogDraftProposal.agreement` carries how many
  // independent discovery lanes (CLI scan / runtime witness / teach-inferred /
  // UI harvest) attest each endpoint plus a risk-class-disagreement flag, so the
  // operator's approve/dismiss decision is evidence-backed rather than blind.
  // Gates a READ-ONLY honesty surface over data §8.1/§8.3 already compute, so the
  // flag exists to stage the rollout and to keep the four-lane agreement map from
  // being computed for a workspace that never asked to see it — not to hide a
  // capability. Default OFF, the new-surface policy (the same shape as
  // `generated-manual` and `agent-allowed-sites`): ships inert until an operator opts
  // in.
  //
  // **Default ON as of 2026-08-17 (WS-H, operator decision).** It gates a
  // read-only HONESTY surface over data §8.1/§8.3 already compute — a lane-count
  // chip and a risk-mismatch warning on the review card — so leaving it off made
  // the operator's one remaining click (D-2's approve) blinder than it needed to
  // be. Turning it on adds evidence to a decision, never a capability. The
  // resolver still skips the four-lane compute and attaches null when a
  // workspace opts out (fail-closed), so the opt-out is a real cost saving and
  // not decoration.
  // WS-E (widget-surface-mapping §6) — visitor-behavior insights on /impact. With
  // this on, the Behavior panel mines the captured interaction stream for the
  // patterns visitors share (control sequences, route funnels, page engagement,
  // per-page top actions) and the resolver runs the scan; with it off the panel is
  // hidden and the resolver returns empty without scanning. Gates a READ-ONLY
  // analytics surface over data already captured (k-anonymity floor enforced
  // server-side, never one person's path), so the flag stages the rollout, not a
  // capability. Default OFF, the new-surface policy: ships inert until an operator
  // opts in.
  //
  // **Default ON as of 2026-08-17 (WS-H, operator decision).** It derives from
  // data the capture pipeline already holds and adds no collection whatsoever;
  // the consent boundary (`capture-consent.ts`) and the prod compliance gate are
  // untouched and still upstream of every event it reads. The k-anonymity floor
  // is enforced server-side and can only be RAISED by a caller, and the read
  // filters `origin = 'human_direct'` so the agent never mines its own scripted
  // sequences back in. Off, the resolver returns empty WITHOUT scanning and the
  // panel hides itself — so the opt-out remains a genuine kill, fail-closed.
  { id: BEHAVIOR_INSIGHTS_LABS_FEATURE_ID, stage: "beta", defaultEnabled: true },
  // WS-A (widget-surface-mapping §2) — the durable control-identity keystone.
  // With this on, each governed `ui_scan`'s controls bind to durable identities
  // (the certified `decideBinding` layer — 98.3 % rebind / 0.0 % false merge on
  // the calibration corpus) and the per-page lifecycle sweep tracks
  // active↔missing, so stored facts about a control survive a rename or
  // restyle. **Default ON — the D-1 knowledge-plane posture**: it observes and
  // never grants (bindings carry evidence, are re-derivable, and merge only
  // above the certified threshold), and the point of identity is continuity,
  // which an opt-in would hole for exactly the tenants who forget. This entry
  // is NOT read through `ExperimentalFeaturesService.isEnabled` — the
  // default-ON fail direction rule; the reasoning lives at the read site
  // (`identity-binding-gate.ts`). Fleet kill: `SYNCANIX_IDENTITY_V2=off`.
  { id: STABLE_CONTROL_IDENTITY_LABS_FEATURE_ID, stage: "beta", defaultEnabled: true },
  // WS-D (widget-surface-mapping §5 D2) — the honest coverage figure: distinct
  // routes found / Chao1-estimated total, per nav-disjoint subtree, with its
  // interval, plus the frontier ranking (where the next walk should go). A
  // READ-ONLY presentation over route-inventory data discovery already keeps
  // (`seen_count`) — it grants nothing and captures nothing new. **Default ON
  // per the §5 rollout line** (the D-1 knowledge-plane posture); the entry is
  // the per-workspace opt-out. NOT read through
  // `ExperimentalFeaturesService.isEnabled` — the default-ON fail-direction
  // rule; the gate resolves the flag itself and fails toward OFF.
  { id: COVERAGE_METRICS_LABS_FEATURE_ID, stage: "beta", defaultEnabled: true },
  // WS-B3 (widget-surface-mapping §3) — the reveal probe: during a guided site
  // walk, activate machine-signal-allowlisted revealers (menus, tabs,
  // accordions) on OFFSCREEN walk frames to discover interaction-revealed UI.
  // Default ON per the §3 rollout line, and as of 2026-08-17 the
  // `REVEAL_PROBE_ENABLED` fleet flag defaults ON beneath it too (WS-H,
  // operator decision) — so this is now LIVE rather than merely authorised.
  // What bounds it is unchanged and structural: the probe only ever runs inside
  // an operator-initiated walk session (banner + Stop), only on OFFSCREEN walk
  // frames and never the operator's live document, only on controls whose own
  // machine attributes declare they open an in-page surface, and every
  // activation — the close-click included, since the 2026-08-17 security review
  // — runs under the write sentinel that quarantines the control and discards
  // its result on any observed non-GET. This entry is the per-workspace opt-out
  // underneath both. NOT read through
  // `ExperimentalFeaturesService.isEnabled` — the default-ON fail-direction
  // rule; the bind gate resolves the flag itself and fails toward OFF.
  { id: REVEAL_PROBE_LABS_FEATURE_ID, stage: "beta", defaultEnabled: true },
  // WF-4.5b / ADR-0584 — the Sealed Deep Walk: the reveal probe's widening.
  // Where the probe presses only controls whose ARIA DECLARES a reveal (0.316
  // of everything reveal-shaped on the demo fleet), the sealed pass presses
  // what the shared activation policy admits — undeclared menus, drawers, tabs
  // — chains reveals to depth, and fills wizard fields with marked synthetic
  // values, inside a frame whose realm is SEALED for its lifetime: non-GET
  // requests refused, storage and cookies shadowed copy-on-write, IndexedDB
  // deletes refused, sockets sealed, service-worker registration denied, SPA
  // navigation refused. Default ON (the three preconditions of
  // `security.md` § "Reviews Are Performed" met in-session: tested, finished,
  // security + legal self-review filed), the `SITE_WALK_DEEP_ENABLED` fleet
  // flag being the kill; this entry is the per-workspace opt-out. Granted only
  // WITH the reveal probe's grant — a workspace that opted out of pressing
  // declared revealers has opted out of pressing undeclared ones. NOT read
  // through `ExperimentalFeaturesService.isEnabled`; the bind gate resolves the
  // flag itself and fails toward OFF.
  { id: SEALED_DEEP_WALK_LABS_FEATURE_ID, stage: "beta", defaultEnabled: true },
  // WF-4.13 / ADR-0579 + ADR-0586 — vision on the sealed frames. OFF is a
  // BLOCKER, not a stage: the pictures are of PAINTED surfaces only (a canvas,
  // an inline svg, a drawn icon — never the page), which shrinks what leaves
  // the browser to the class no DOM technique reads, and a painted chart is
  // still a picture of the customer's data. Sent EU-resident, classified and
  // discarded in one invocation, never persisted; what is kept is the derived
  // control name as an identity row. The lawful basis wants counsel's word
  // (CRD-24), so the default stays OFF until it is given. Granted only WITH
  // `sealed-deep-walk`; the `SITE_WALK_VISION_ENABLED` fleet flag is the kill.
  { id: SEALED_FRAME_VISION_LABS_FEATURE_ID, stage: "beta", defaultEnabled: false },
  // WF-4.9 / WF-4.71 / ADR-0576 — the live-write ENTITLEMENT. ON by default
  // because D29 decided the operator is entitled to write to their own
  // product with their own session; what stays OFF by default is the RUN —
  // every walk is sealed unless the operator chooses live for that run in
  // Advanced mode, so this entry alone changes nothing about any walk. The
  // destructive floor (`discovery/live-writes.ts`) is not reachable from
  // here or from the run choice. Granted only WITH `sealed-deep-walk`, because
  // the seal is the mechanism that decides per write; the
  // `SITE_WALK_LIVE_WRITES_ENABLED` fleet flag is the kill. NOT read through
  // `isEnabled`; the bind gate resolves the flag itself and fails toward OFF.
  { id: WALK_LIVE_WRITES_LABS_FEATURE_ID, stage: "beta", defaultEnabled: true },
  // Zero-touch walk R-3 / E5 (ADR-0635) — icon-crop naming. OFF by default and
  // OFF means OPT-IN, not blocked: the `SITE_WALK_ICON_CROP_ENABLED` fleet flag
  // is ON, so switching this on runs the feature the same day. What is sent is
  // a 64-pixel crop of ONE icon-only control whose box the widget proved
  // carries no rendered text, plus a closed vocabulary of what the control was
  // observed to do; what comes back is a NAME, and the response type has
  // nowhere to put a safety class. Sent EU-resident and dropped with the
  // request. Granted only WITH `sealed-deep-walk`.
  { id: ICON_CROP_NAMING_LABS_FEATURE_ID, stage: "beta", defaultEnabled: false }
];

// src/experimental/experimental-features.ts
var EXPERIMENTAL_FEATURES = [
  // SYN-206 — the widget's multi-step flow (wizard) primitive: the reserved
  // `present_user_flow` agent tool is advertised only when this flag is on
  // (the conversation controller resolves it per turn). Alpha, **default ON
  // since ADR-0521** — complete and tested on both ends, so the Labs card is now
  // how a workspace declines it rather than how it obtains it.
  { id: "widget-flow-primitive", stage: "alpha", defaultEnabled: true },
  // SYN-207 (ADR-0176) — MCP-Apps interactive UI from the tenant MCP server:
  // the `resources` capability + `ui://` tool-output template + tool-result
  // decoration are exposed only when this flag is on (the MCP lifecycle +
  // resources + tools handlers resolve it per session tenant). Alpha, default
  // **ON since ADR-0521.** The exposure this default guarded is third-party-host
  // rendering, and there is no third-party tenant to expose (checkout cannot
  // complete — blocker C5), so on today's fleet default-ON is dogfood-only. It
  // is the entry to re-decide FIRST at the first external tenant: the surface
  // renders customer-authored UI in a sandboxed iframe under a strict CSP, and
  // ADR-0169 § 4 is honest that navigation-class egress is neutralised by the
  // render-only frame's no-op wiring rather than by CSP.
  { id: "mcp-apps-ui", stage: "alpha", defaultEnabled: true },
  // SYN-357 (ADR-0202) — auto-detected in-site actions: the widget's
  // `exposePageActions(config)` hook registers the routes a customer DECLARED and
  // the elements they tagged `data-syncanix-action` as auto-detected commands,
  // delivered through the config channel.
  //
  // **`defaultEnabled: true` since 2026-08-22, and the flip is a STALE-REASON
  // correction rather than a new decision.** The entry read "auto-detected commands
  // are reported for review but NOT agent-callable in B1 (governance/enable is
  // SYN-358)" — describing a state that has not held for some time. SYN-372
  // (ADR-0202 §4) shipped that governance: `HostActionAuthorityService` default-DROPS
  // every auto-detected declaration unless its id is in the operator's ACTIVE set,
  // as a SERVER backstop that holds against a hand-rolled client, and the config
  // channel delivers `enabledAutoDetectedActionIds` only for ids an operator turned
  // on. So the fact the OFF default rested on was superseded, which is the phantom
  // gate `pr-discipline.md` names — a sentence holding a feature dark with nothing
  // behind it.
  //
  // **What it cost meanwhile is why this is worth correcting rather than tidying.**
  // `registerNavCommands` is the only producer of the nav routes `navigate_to`
  // advertises (ADR-0456's enum), so with this off a customer who had DONE the
  // integration work got nothing registered: an empty destination enum, cross-page
  // guided tours (PLAN §3 PR-2) unable to cross, and a Task Guide's `navigate` step
  // dropped at materialization. Silently, and only for tenants who had opted in.
  //
  // **Why ON is safe.** Neither lane harvests anything: one reads routes the
  // customer PASSED in a config object, the other reads elements they explicitly
  // TAGGED — both affirmative integration acts, not arbitrary DOM. A tenant that
  // never calls `exposePageActions` sees no change at all. And nothing becomes
  // agent-callable by this flip: the SYN-372 backstop above still requires a
  // per-ability operator enable, and every auto-detected command remains
  // confirm-gated.
  { id: "auto-detect-actions", stage: "alpha", defaultEnabled: true },
  // NOTE: `conversation-logs-pulse` (CL-7 P5) GRADUATED — the tabbed
  // Conversation Logs IA (Conversations / Insights / Needs attention) is now the
  // only layout, so the flag was retired from the registry (stale per-tenant
  // `feature_flags` rows are inert: the resolver only surfaces registry ids).
  // NOTE: `handoff-inbox` (ADR-0219) is GONE — ADR-0575 removed the whole
  // human-handoff surface it gated, so the entry went with it. Stale per-tenant
  // `feature_flags` rows are inert: the resolver only surfaces registry ids.
  ...CONVERSATION_LABS_FEATURES,
  // W-31 — the assistant-led onboarding checklist: the reserved
  // `present_onboarding_checklist` agent tool is advertised only when this flag
  // is on (the conversation controller resolves it per turn), the widget renders
  // the checklist card + per-step walkthroughs, and the widget-channel
  // /onboarding-checklist endpoints (read progress / mark complete) refuse when
  // off (defense in depth). Persistent per-verified-end-user completion is a new
  // store of end-user data, so per-tenant enablement is the operator's call.
  // Alpha, **default ON since ADR-0521** — the "new store of end-user data" is a
  // set of completion booleans per verified user, which is proportionate on its
  // face.
  { id: "onboarding-checklist", stage: "alpha", defaultEnabled: true },
  // W-12 — knowledge-base browse & search on the widget channel: the
  // knowledge-base read endpoints (`/v1/widget/kb/*`: list + search the tenant's
  // docs-RAG corpus, read a full article). They refuse (enabled:false) when this
  // flag is off. Visibility reuses the SAME access-label seam as chat retrieval,
  // so the surface can never expose a document the agent would not already
  // ground an answer on. Alpha, **default ON since ADR-0521** — the exposure
  // argument is answered by that mechanism rather than by the default.
  //
  // 2026-08-27 — the in-widget browse panel this fed was REMOVED (operator
  // instruction), and 2026-08-30 the LAST door closed with it: ADR-0569's
  // `AGENT_INTERNALS_VISIBLE` withholds the citation title that opened the
  // reader (DE-004), which was the only remaining way in. The claim that
  // "NOTHING in the shipped widget calls them" was therefore premature when it
  // was written and is true now.
  //
  // The endpoints are unchanged and still reachable with a publishable key, so
  // this flag now gates an API surface rather than a user-facing one — which is
  // also why ADR-0569 does not close `security-review-debt.md` SRD-12.
  //
  // **default OFF since ADR-0570** (operator decision, 2026-08-30), reversing the
  // ADR-0521 flip. That flip's reasoning was about a USER-FACING panel — "the
  // exposure argument is answered by the access-label mechanism rather than by
  // the default" — and the panel is gone. What is left is an integrator API with
  // no consumer, on by default across the whole fleet, whose access-label seam
  // resolves `tenant-internal` to "anonymous visitors included" (ADR-0567). ON
  // was buying nobody anything and costing every workspace SRD-12's exposure, so
  // the default now matches who the surface is for: a customer building their own
  // reader switches it on.
  { id: "docs-browse", stage: "alpha", defaultEnabled: false },
  // M-04 (ADR-0308) — structured tool output schemas on the MCP surface: every
  // advertised catalog tool carries a JSON Schema 2020-12 response schema (built
  // from its catalog + witness-inferred response shape) on
  // `_meta['syncanix/outputSchema']` in `tools/list`. **ON since ADR-0521**: its
  // cost is per-turn tool-list TOKENS rather than dollars, and knowing whether
  // structured output actually helps an agent is worth more than the tokens it
  // spends finding out. SDK-safe (the SDK-unpoliced `_meta` channel, never the
  // reserved `outputSchema` field — advertising that while `tools/call` returns
  // text-only would break SDK clients, SYN-89). Alpha.
  { id: "mcp-output-schemas", stage: "alpha", defaultEnabled: true },
  // /monitoring redesign: the health-verdict band, the headline KPIs with trend
  // and target, plain-language copy, and the five-tab restructure. Gates a
  // presentation change over data the page ALREADY has (no new store, no new
  // egress), so the flag exists to stage the rollout, not to hide a capability:
  // while it is off the page renders exactly as it did before the redesign.
  // Beta, **default ON since ADR-0521** — it is a presentation change over data
  // the page already has, and a staged rollout needs someone to stage it for.
  { id: "monitoring-redesign", stage: "beta", defaultEnabled: true },
  ...DOCS_ENGINE_LABS_FEATURES,
  // The agent-behaviour family — prompt targeting, capability guidance, tool
  // priority steering and the outbound read allowlist — spread in place so this
  // stays ONE registry in ONE order. See `agent-labs-features.ts` for why those
  // four live in their own file.
  ...AGENT_LABS_FEATURES,
  ...SURFACE_MAPPING_LABS_FEATURES,
  // The runtime-discovery family (ADR-0396/0469/0471/0488), spread in place so
  // this stays ONE registry in ONE order — see `discovery-labs-features.ts` for
  // why those entries live in their own file.
  ...DISCOVERY_LABS_FEATURES,
  // The four PROGRAM masters — one switch each over a whole experience layer,
  // spread in place so this stays ONE registry in ONE order. See
  // `program-master-labs-features.ts` for why they live in their own file.
  ...PROGRAM_MASTER_LABS_FEATURES
];
function findExperimentalFeature(id) {
  return EXPERIMENTAL_FEATURES.find((feature) => feature.id === id);
}
function isKnownExperimentalFeature(id) {
  return findExperimentalFeature(id) !== void 0;
}
var EXPERIMENTAL_FEATURE_STAGES = ["alpha", "beta"];
var EXPERIMENTAL_FEATURE_ID_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
var EXPERIMENTAL_FEATURE_ID_MAX_LENGTH = 64;
var experimentalFeatureDefinitionSchema = /* @__PURE__ */ z.object({
  /** Stable kebab-case id — the flag key in `feature_flags` and the i18n key stem. */
  id: z.string().min(1).max(EXPERIMENTAL_FEATURE_ID_MAX_LENGTH).regex(EXPERIMENTAL_FEATURE_ID_PATTERN),
  /** Maturity badge shown on the Labs card. */
  stage: z.enum(EXPERIMENTAL_FEATURE_STAGES),
  /** Effective state for a tenant that never toggled the feature. */
  defaultEnabled: z.boolean()
});
var MAX_ATTRIBUTE_KEYS = 64;
var MAX_ATTRIBUTE_KEY_LENGTH = 64;
var MAX_ATTRIBUTE_VALUE_LENGTH = 256;
var ATTRIBUTE_KEY_PATTERN = /^[a-z0-9_.-]+$/;
var RESERVED_ATTRIBUTE_PREFIX = "syncanix:";
function validateAttributeKey(key) {
  if (key.startsWith(RESERVED_ATTRIBUTE_PREFIX)) return "reserved_key";
  if (!ATTRIBUTE_KEY_PATTERN.test(key)) return "invalid_key_format";
  if (key.length > MAX_ATTRIBUTE_KEY_LENGTH) return "key_too_long";
  return null;
}
function classifyAttributeValue(raw) {
  if (typeof raw === "string") {
    if (raw.length > MAX_ATTRIBUTE_VALUE_LENGTH) return { reason: "value_too_long" };
    return { value: { type: "string", value: raw } };
  }
  if (typeof raw === "number") {
    if (!Number.isFinite(raw)) return { reason: "value_not_finite" };
    return { value: { type: "number", value: raw } };
  }
  if (typeof raw === "boolean") {
    return { value: { type: "boolean", value: raw } };
  }
  return { reason: "unsupported_type" };
}
var MAX_CAPTURED_CLAIM_KEYS = 32;
var MAX_PINNED_ATTRIBUTE_KEYS = 8;
function normalizeAttributeKeyList(keys, max, noun) {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const raw of keys) {
    const key = raw.trim();
    if (key === "") continue;
    const reason = validateAttributeKey(key);
    if (reason !== null) return { error: `invalid ${noun} "${key}": ${reason}` };
    if (!seen.has(key)) {
      seen.add(key);
      out.push(key);
    }
  }
  if (out.length > max) {
    return { error: `too many ${noun}s: ${out.length} exceeds ${max}` };
  }
  return { keys: out };
}
function normalizeClaimCaptureAllowlist(keys) {
  return normalizeAttributeKeyList(keys, MAX_CAPTURED_CLAIM_KEYS, "claim key");
}
function normalizePinnedAttributeKeys(keys) {
  return normalizeAttributeKeyList(keys, MAX_PINNED_ATTRIBUTE_KEYS, "pinned key");
}
var IDENTIFY_MODES = ["merge", "replace"];
var MAX_IDENTIFY_BATCH = 500;
var MAX_END_USER_SUB_LENGTH = 255;
var identifyBodySchema = /* @__PURE__ */ z.object({
  attributes: z.record(z.unknown()),
  mode: z.enum(IDENTIFY_MODES).optional()
});
var identifyBatchSchema = /* @__PURE__ */ z.object({
  items: z.array(
    z.object({
      sub: z.string().min(1).max(MAX_END_USER_SUB_LENGTH),
      attributes: z.record(z.unknown())
    })
  ).min(1).max(MAX_IDENTIFY_BATCH),
  mode: z.enum(IDENTIFY_MODES).optional()
});

// src/user-learning/match-rule-vocabulary.ts
var MAX_MATCH_RULE_CONDITIONS = 12;
var MAX_MATCH_RULE_IN_VALUES = 50;
var MAX_MATCH_RULE_KEY_LENGTH = 200;
var MATCH_RULE_VALUE_OPS = [
  "eq",
  "neq",
  "contains",
  "gt",
  "lt",
  "gte",
  "lte",
  "exists",
  "in"
];
var MATCH_RULE_ACTIVITY_METRICS = [
  "conversations",
  "frustrated_conversations",
  "flagged_conversations",
  "capability_calls"
];
var MATCH_RULE_PARAMETERISED_METRICS = [
  "capability_calls"
];
var MATCH_RULE_ACTIVITY_OPS = ["gte", "lte"];
var MAX_MATCH_RULE_ACTIVITY_VALUE = 1e4;
var MAX_MATCH_RULE_WINDOW_DAYS = 365;

// src/user-learning/match-rule.ts
var conditionValueSchema = /* @__PURE__ */ z.union([
  z.string().max(MAX_ATTRIBUTE_VALUE_LENGTH),
  z.number().finite(),
  z.boolean(),
  z.array(z.string().min(1).max(MAX_ATTRIBUTE_VALUE_LENGTH)).min(1).max(MAX_MATCH_RULE_IN_VALUES)
]);
function refineOpValue(condition, ctx) {
  const { op, value } = condition;
  const fail = (message) => {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message, path: ["value"] });
  };
  switch (op) {
    case "exists":
      if (value !== void 0) fail("exists takes no value");
      return;
    case "in":
      if (!Array.isArray(value)) fail("in requires a list of values");
      return;
    case "contains":
      if (typeof value !== "string") fail("contains requires a string value");
      return;
    case "gt":
    case "lt":
    case "gte":
    case "lte":
      if (typeof value !== "number") fail(`${op} requires a numeric value`);
      return;
    case "eq":
    case "neq":
      if (typeof value !== "string" && typeof value !== "number" && typeof value !== "boolean") {
        fail(`${op} requires a string, number, or boolean value`);
      }
  }
}
function valueConditionSchema(source) {
  return z.object({
    source: z.literal(source),
    key: z.string().min(1).max(MAX_MATCH_RULE_KEY_LENGTH),
    op: z.enum(MATCH_RULE_VALUE_OPS),
    value: conditionValueSchema.optional()
  }).strict().superRefine(refineOpValue);
}
var attrConditionSchema = valueConditionSchema("attr");
var claimConditionSchema = valueConditionSchema("claim");
var activityConditionSchema = /* @__PURE__ */ z.object({
  source: z.literal("activity"),
  metric: z.enum(MATCH_RULE_ACTIVITY_METRICS),
  op: z.enum(MATCH_RULE_ACTIVITY_OPS),
  // `0` is only reachable with `lte`, and is the whole point of it: "called it
  // zero times" is the unused-feature audience. The pairing is enforced below.
  value: z.number().int().min(0).max(MAX_MATCH_RULE_ACTIVITY_VALUE),
  windowDays: z.number().int().min(1).max(MAX_MATCH_RULE_WINDOW_DAYS),
  /**
   * The capability whose calls are counted — `capability_calls` only.
   *
   * Refused against the shared `CAPABILITY_ID_PATTERN` rather than cleaned
   * (ADR-0398): a repaired id counts a different capability than the operator
   * named, and the audience would be wrong in a way nothing surfaces.
   */
  capability: z.string().regex(CAPABILITY_ID_PATTERN).optional()
}).strict().superRefine((condition, ctx) => {
  const fail = (message, path) => {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message, path: [path] });
  };
  if (condition.metric === "capability_calls") {
    if (condition.capability === void 0) {
      fail("capability_calls requires a capability", "capability");
    }
  } else {
    if (condition.capability !== void 0) {
      fail(`${condition.metric} takes no capability`, "capability");
    }
    if (condition.op === "lte") {
      fail(`${condition.metric} supports gte only`, "op");
    }
  }
  if (condition.op === "gte" && condition.value < 1) {
    fail("gte requires at least 1", "value");
  }
});
var conditionSchema = /* @__PURE__ */ z.union([
  attrConditionSchema,
  claimConditionSchema,
  activityConditionSchema
]);
var nestedGroupSchema = /* @__PURE__ */ z.union([
  z.object({ all: z.array(conditionSchema).min(1) }).strict(),
  z.object({ any: z.array(conditionSchema).min(1) }).strict()
]);
var rootEntrySchema = /* @__PURE__ */ z.union([conditionSchema, nestedGroupSchema]);
function entryConditionCount(entry) {
  if ("source" in entry) return 1;
  return "all" in entry ? entry.all.length : entry.any.length;
}
function countMatchRuleConditions(rule) {
  const rootLists = [...rule.all ?? [], ...rule.any ?? []];
  return rootLists.reduce((total, entry) => total + entryConditionCount(entry), 0) + (rule.none?.length ?? 0);
}
function entryConditions(entry) {
  if ("source" in entry) return [entry];
  return "all" in entry ? entry.all : entry.any;
}
function matchRuleHasActivityCondition(rule) {
  const rootLists = [...rule.all ?? [], ...rule.any ?? []];
  return rootLists.some(
    (entry) => entryConditions(entry).some((condition) => condition.source === "activity")
  ) || (rule.none ?? []).some((condition) => condition.source === "activity");
}
var matchRuleSchema = /* @__PURE__ */ z.object({
  all: z.array(rootEntrySchema).optional(),
  any: z.array(rootEntrySchema).optional(),
  none: z.array(conditionSchema).optional()
}).strict().superRefine((rule, ctx) => {
  const total = countMatchRuleConditions(rule);
  if (total === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "a match rule needs at least one condition (use ALL_AUTHENTICATED instead)"
    });
  }
  if (total > MAX_MATCH_RULE_CONDITIONS) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `a match rule is capped at ${String(MAX_MATCH_RULE_CONDITIONS)} conditions (got ${String(total)})`
    });
  }
});
function attributeMatchToMatchRule(matchClaim, matchValues) {
  return { all: [{ source: "attr", key: matchClaim, op: "in", value: [...matchValues] }] };
}
var USER_INSIGHT_METRICS = [
  "users",
  "conversations",
  "frustrated_conversations",
  "flagged_conversations"
];
var USER_INSIGHT_GROUP_BYS = [
  "day",
  "audience",
  "outcome",
  "attribute",
  "identity"
];
var USER_INSIGHT_RANGES = ["LAST_7D", "LAST_30D", "LAST_90D"];
var USER_INSIGHT_RANGE_DAYS = {
  LAST_7D: 7,
  LAST_30D: 30,
  LAST_90D: 90
};
var MIN_COMPARE_AUDIENCES = 2;
var MAX_COMPARE_AUDIENCES = 4;
var MAX_USER_INSIGHT_BUCKETS = 100;
var userInsightQuerySchema = /* @__PURE__ */ z.object({
  metric: z.enum(USER_INSIGHT_METRICS),
  groupBy: z.enum(USER_INSIGHT_GROUP_BYS),
  range: z.enum(USER_INSIGHT_RANGES),
  /** Required exactly when `groupBy` is `attribute`; forbidden otherwise. */
  attributeKey: z.string().min(1).max(128).optional(),
  /**
   * Compare mode: 2–4 audience ids, each plotted as its own series. Absent =
   * the whole population as one series.
   */
  audienceIds: z.array(z.string().uuid()).min(MIN_COMPARE_AUDIENCES).max(MAX_COMPARE_AUDIENCES).optional()
}).superRefine((query, ctx) => {
  const needsKey = query.groupBy === "attribute";
  if (needsKey && query.attributeKey === void 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["attributeKey"],
      message: "attributeKey is required when grouping by attribute"
    });
  }
  if (!needsKey && query.attributeKey !== void 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["attributeKey"],
      message: "attributeKey is only valid when grouping by attribute"
    });
  }
  if (query.groupBy === "audience" && query.audienceIds !== void 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["audienceIds"],
      message: "audience comparison cannot be combined with grouping by audience"
    });
  }
});
var MAX_INSIGHT_VIEW_NAME_LENGTH = 80;
var userInsightViewInputSchema = /* @__PURE__ */ z.object({
  name: z.string().trim().min(1).max(MAX_INSIGHT_VIEW_NAME_LENGTH),
  query: userInsightQuerySchema
});

// src/user-learning/index.ts
var LEARNED_INSIGHT_KINDS = [
  "preference",
  "dislike",
  "behavior",
  "context",
  "correction"
];
var INSIGHT_PROVENANCES = ["extracted", "operator"];
var MAX_INSIGHT_CONTENT_LENGTH = 240;
var MAX_PROMPT_ADDITION_LENGTH = 2e3;
var MAX_SEGMENT_NAME_LENGTH = 100;
var MAX_SEGMENT_DESCRIPTION_LENGTH = 500;
var learnedInsightSchema = /* @__PURE__ */ z.object({
  id: z.string().uuid(),
  kind: z.enum(LEARNED_INSIGHT_KINDS),
  /** Short third-person fact ("Prefers concise answers", "Dislikes upsells"). */
  content: z.string().min(1).max(MAX_INSIGHT_CONTENT_LENGTH),
  confidence: z.number().min(0).max(1),
  provenance: z.enum(INSIGHT_PROVENANCES),
  /** Present for `extracted` insights — the conversation the fact came from. */
  sourceConversationId: z.string().uuid().optional(),
  /** ISO timestamps (JSONB-safe). */
  learnedAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  /**
   * UGL-202 (§ 5-A3) — muted facts stay ON THE RECORD but are skipped by the
   * digest compiler, so an operator can silence a wrong-but-true-looking fact
   * without destroying the evidence of what was learned (and without the
   * nightly merge simply re-learning it, which a delete invites).
   *
   * `.default(false)` is load-bearing: this array is re-validated on READ, so
   * a required field would degrade every stored profile to empty on the next
   * turn.
   */
  muted: z.boolean().default(false),
  /**
   * UGL-202 — the operator who last edited this fact (their `sub`). Absent on
   * extracted facts and on rows written before attribution existed; the UI
   * shows "edited by X" only when it is present rather than inventing one.
   */
  updatedBy: z.string().min(1).max(255).optional()
}).superRefine((value, ctx) => {
  if (value.kind === "correction" && value.sourceConversationId === void 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["sourceConversationId"],
      message: "A correction fact requires a sourceConversationId."
    });
  }
});
var learnedInsightListSchema = /* @__PURE__ */ z.array(learnedInsightSchema);
var CAPABILITY_OVERRIDE_MODES = ["allow", "deny"];
var capabilityOverridesSchema = /* @__PURE__ */ z.record(
  z.string().min(1).max(200),
  z.enum(CAPABILITY_OVERRIDE_MODES)
);
var USER_LEARNING_CONFIG_DEFAULTS = {
  injectionTokenBudget: 400,
  retentionDays: 180,
  maxInsightsPerUser: 24
};
var userLearningConfigSchema = /* @__PURE__ */ z.object({
  injectionTokenBudget: z.number().int().min(50).max(2e3),
  retentionDays: z.number().int().min(7).max(730),
  maxInsightsPerUser: z.number().int().min(4).max(100)
});
var REPORT_CADENCES = ["weekly", "monthly"];
var reportCadenceSchema = /* @__PURE__ */ z.enum(REPORT_CADENCES);
function reportPeriodKey(cadence, date) {
  return cadence === "monthly" ? isoMonthKey(date) : isoWeekKey(date);
}
function isoWeekKey(date) {
  const d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  const day = d.getUTCDay() === 0 ? 7 : d.getUTCDay();
  d.setUTCDate(d.getUTCDate() + 4 - day);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const week = Math.ceil(((d.getTime() - yearStart.getTime()) / 864e5 + 1) / 7);
  return `${String(d.getUTCFullYear())}-W${String(week).padStart(2, "0")}`;
}
function isoMonthKey(date) {
  return `${String(date.getUTCFullYear())}-${String(date.getUTCMonth() + 1).padStart(2, "0")}`;
}
var impactShareWindowSchema = /* @__PURE__ */ z.enum(ANALYTICS_WINDOWS);
var impactShareEnvironmentSchema = /* @__PURE__ */ z.enum(["development", "production"]);
var sharedDurationSchema = /* @__PURE__ */ z.object({
  measure: z.enum(DURATION_MEASURES),
  state: z.enum(DURATION_STATES),
  /** Null unless `state === 'measured'` — never a figure under the floor. */
  medianMs: z.number().nonnegative().nullable(),
  /** Null unless `state === 'measured'`. */
  p90Ms: z.number().nonnegative().nullable(),
  medianAtLeast: z.boolean(),
  p90AtLeast: z.boolean(),
  /** Observations behind the figures. Never hidden — the ADR-0422 doctrine. */
  samples: z.number().int().nonnegative(),
  /**
   * `YYYY-MM-DD` of the first measured day when the window STRADDLES the start
   * of measurement, so a partial figure renders as partial. The same shape as
   * `deflectionMeasuredSince`, so the page renders the two through one rule.
   */
  measuringSince: z.string().date().nullable()
});
var sharedImpactStatusSchema = /* @__PURE__ */ z.enum([
  "ok",
  "expired",
  "revoked",
  "not_found",
  "unavailable"
]);
var sharedImpactMetricsSchema = /* @__PURE__ */ z.object({
  conversations: z.number().int().nonnegative(),
  /** FULLY resolved only — `resolutionBasis` names the rubric that produced it. */
  resolvedCount: z.number().int().nonnegative(),
  /** Conversations the agent PARTLY helped with — never folded into `resolvedCount`. */
  partiallyResolvedCount: z.number().int().nonnegative(),
  /**
   * Which resolution rubric produced `resolvedCount`. A public page that shows a
   * rate MUST be able to say which formula produced it: this figure has already
   * changed once (it used to fold `partial` in), and a page that cannot name its
   * own basis restates history silently every time the formula moves.
   */
  resolutionBasis: z.string().min(1),
  failedCount: z.number().int().nonnegative(),
  containmentRate: z.number().min(0).max(1).nullable(),
  actionsExecuted: z.number().int().nonnegative(),
  deflectionEstimate: z.number().int().nonnegative().nullable(),
  /**
   * Which basis produced `deflectionEstimate` — the field whose ABSENCE was the
   * defect. The figure reached this public page under a Syncanix honesty label
   * while the page had no way to state what it measured. A stable machine code,
   * localized by the reader (never a baked sentence).
   */
  estimateBasis: z.string().min(1),
  /**
   * `YYYY-MM-DD` of the first measured day, when the window STRADDLES the day
   * measurement began — so a partial figure renders as partial rather than as a
   * whole-window total. Null when the whole window is measured, or none of it is.
   */
  deflectionMeasuredSince: z.string().date().nullable(),
  /** True when the figures are estimated from a representative sample (coverage < 100%). */
  sampled: z.boolean(),
  /**
   * How long things take — the three TIME measures, added to the PUBLIC subset
   * deliberately in Phase 1.4.
   *
   * They belong here for the reason per-audience breakdowns do not (audit M11):
   * a median is a POPULATION figure about the workspace's own agent, carrying no
   * cohort shape and describing no individual. "Answers in under a minute" is
   * also the single most legible thing a renewal reader can check against their
   * own experience, which is what a share link is for.
   *
   * ALWAYS three entries, one per measure, in registry order. A measure with
   * nothing behind it reports its own honest state rather than being omitted —
   * two workspaces then see the same page, and an absent tile never has to be
   * interpreted. `.default([])` so an api that predates the field degrades to
   * "no time section" rather than darking the whole report, the same tolerance
   * `period` and `review` take.
   */
  durations: z.array(sharedDurationSchema).default([])
});
var sharedImpactReportSchema = /* @__PURE__ */ z.object({
  status: sharedImpactStatusSchema,
  report: z.object({
    tenantName: z.string(),
    window: impactShareWindowSchema,
    generatedAt: z.string().datetime(),
    expiresAt: z.string().datetime(),
    /**
     * The exact days these numbers cover, when the link was FROZEN to a
     * period; `null` when the link is ROLLING and the figures are the window
     * as of `generatedAt`.
     *
     * The page must render the two differently. A rolling link is a live view
     * and says so; a frozen one names its days. Before this field existed the
     * page could say neither, so a pack forwarded three weeks later reported
     * a different month under the heading its email had given it — the
     * numbers were always real, and the PERIOD was fabricated by omission.
     *
     * **`.default(null)` rather than plain `.nullable()`, and the asymmetry is
     * the point.** The public page parses this body with THIS schema, so a
     * strictly-required field would take every shared report dark the moment
     * the api rolled back to a build that predates it — a public, unauth page
     * failing for readers who cannot be told why. Defaulting reads an older
     * server's silence as ROLLING, which is not a guess: that server WAS
     * rolling. Meanwhile the OUTPUT type stays required, so a producer on this
     * build still cannot omit it — the compiler says so at every construction
     * site, which is where the real risk of forgetting lives.
     */
    period: reportPeriodSchema.nullable().default(null),
    /**
     * The full Business Review pack (Phase 1.2b), or `null` for the headline
     * report.
     *
     * A pack is produced for a FROZEN link and only for one: it is a document
     * about a named period, and a rolling link has no period to be about. So
     * the two decisions are one decision rather than two flags that could
     * disagree — there is no state where a page must render "October's pack"
     * over figures that moved this morning.
     *
     * Defaulted like `period` and for the same reason: the page parses this
     * body with this schema, so a strictly-required field would take every
     * shared report dark the moment the api rolled back to a build that
     * predates it. Absent reads as "headline only", which is what an older
     * server served.
     */
    review: businessReviewWireSchema.nullable().default(null),
    metrics: sharedImpactMetricsSchema,
    aiDisclosure: z.literal(true)
  }).optional()
});

// src/impact-share/index.ts
var IMPACT_SHARE_TTL_DAYS_MIN = 1;
var IMPACT_SHARE_TTL_DAYS_MAX = 90;
var IMPACT_SHARE_TTL_DAYS_DEFAULT = 30;
var IMPACT_SHARE_LABEL_MAX = 80;
var impactShareCreateInputSchema = /* @__PURE__ */ z.object({
  environment: impactShareEnvironmentSchema.default("production"),
  window: impactShareWindowSchema.default("LAST_30_DAYS"),
  ttlDays: z.number().int().min(IMPACT_SHARE_TTL_DAYS_MIN).max(IMPACT_SHARE_TTL_DAYS_MAX).default(IMPACT_SHARE_TTL_DAYS_DEFAULT),
  label: z.string().trim().max(IMPACT_SHARE_LABEL_MAX).optional(),
  /**
   * Freeze the link to the days its window covers RIGHT NOW, instead of
   * re-deriving them from `now()` on every view (Phase 1.2).
   *
   * A BOOLEAN, deliberately, rather than an explicit day range. The days are
   * computed server-side from the window the caller already named, AFTER the
   * tier clamp — so there is no caller-supplied range to validate, no way to
   * name a period a workspace is not entitled to read, and no second place the
   * arithmetic could disagree with the reader that consumes it.
   *
   * Defaults FALSE: a link an operator mints by hand from the dashboard is a
   * live view of their own numbers, and silently freezing it would be its own
   * kind of lie. The scheduled sends set it, because those are the links an
   * email names a period for.
   */
  freezePeriod: z.boolean().default(false)
});
var IMPACT_SUBSCRIPTION_MAX_RECIPIENTS = 10;
var IMPACT_SUBSCRIPTION_SLACK_URL_MAX = 2048;
var impactReportSubscriptionInputSchema = /* @__PURE__ */ z.object({
  environment: impactShareEnvironmentSchema.default("production"),
  window: impactShareWindowSchema.default("LAST_30_DAYS"),
  cadence: reportCadenceSchema.default("weekly"),
  recipients: z.array(z.string().trim().email()).max(IMPACT_SUBSCRIPTION_MAX_RECIPIENTS).default([]),
  /**
   * A Slack (or Slack-compatible) incoming webhook the report also posts to —
   * an ADDITIONAL destination, never a replacement (Phase 1.4b).
   *
   * `null` is "no Slack connected", which is what almost every workspace is and
   * what must cost nothing. An empty string is normalised to `null` rather than
   * stored, so "not configured" and "configured to nowhere" cannot become two
   * states a dispatcher has to tell apart.
   *
   * **https ONLY, checked here as well as at the hop.** Zod's `.url()` alone
   * accepts `javascript:alert(1)` and `http://…` — measured, not assumed — and
   * an operator who saw either stored would reasonably conclude it was accepted
   * as a destination. The C28 chokepoint at DELIVERY time
   * (`createPinnedWebhookPort`: https-only, every resolved address checked, the
   * validated IP dialled) is what actually makes the hop safe and remains the
   * control; this is the boundary telling the operator NOW rather than letting
   * a scheduled job discover it silently a week later.
   *
   * So: shape and scheme at the boundary, reachability at the hop. A URL that
   * passes here can still be refused there — that ordering is correct, and it
   * is why this must not be read as the security control.
   */
  slackWebhookUrl: z.string().trim().max(IMPACT_SUBSCRIPTION_SLACK_URL_MAX).url().refine((value) => value.toLowerCase().startsWith("https://"), {
    message: "Webhook URL must use https"
  }).nullable().default(null).or(z.literal("").transform(() => null)),
  enabled: z.boolean().default(true)
});
var IMPACT_SHARE_TOKEN_BYTES = 20;
var IMPACT_SHARE_TOKEN_PREFIX = "shr_";
function buildImpactShareUrl(webAppUrl, token) {
  return `${webAppUrl.replace(/\/+$/, "")}/shared/impact/${token}`;
}

// src/interaction-capture/event-kinds.ts
var INTERACTION_ORIGINS = ["human_direct", "agent_driven", "system"];
var CAPTURE_PLANES = ["site", "chat", "function"];
var PLANE_SITE_KINDS = [
  "page_view",
  "page_leave",
  "navigation",
  "control_interaction",
  "form_step_reached",
  "form_step_completed",
  "form_abandoned",
  "friction_rage_click",
  "friction_dead_click",
  "friction_error_click",
  "friction_quickback",
  "web_vital",
  "visibility_change",
  "resize_breakpoint"
];
var PLANE_CHAT_KINDS = [
  "chat_opened",
  "chat_closed",
  "chat_minimized",
  "message_sent",
  "message_received",
  "stream_started",
  "stream_completed",
  "suggestion_shown",
  "suggestion_clicked",
  "nudge_shown",
  "nudge_accepted",
  "nudge_dismissed",
  "disclosure_shown",
  "refusal_shown",
  "feedback_given"
];
var PLANE_FUNCTION_KINDS = [
  "tool_call_started",
  "tool_call_succeeded",
  "tool_call_failed",
  "confirm_card_shown",
  "confirm_card_approved",
  "confirm_card_rejected",
  "host_action_invoked",
  "mcp_tool_call",
  "webmcp_call",
  "channel_b_execution"
];
var INTERACTION_EVENT_KINDS = [
  ...PLANE_SITE_KINDS,
  ...PLANE_CHAT_KINDS,
  ...PLANE_FUNCTION_KINDS
];
var A6_GATED_KINDS = [
  "friction_rage_click",
  "friction_dead_click",
  "friction_error_click",
  "friction_quickback"
];
var A6_GATED_SET = new Set(A6_GATED_KINDS);
function isA6Gated(kind) {
  return A6_GATED_SET.has(kind);
}
var PLANE_BY_KIND = new Map([
  ...PLANE_SITE_KINDS.map((k) => [k, "site"]),
  ...PLANE_CHAT_KINDS.map((k) => [k, "chat"]),
  ...PLANE_FUNCTION_KINDS.map((k) => [k, "function"])
]);
function planeOfKind(kind) {
  const plane = PLANE_BY_KIND.get(kind);
  if (plane === void 0) throw new Error(`unknown interaction kind: ${kind}`);
  return plane;
}
var KIND_SET = new Set(INTERACTION_EVENT_KINDS);
function isInteractionEventKind(value) {
  return KIND_SET.has(value);
}
var Empty = /* @__PURE__ */ z.object({}).strict();
var PageViewProps = /* @__PURE__ */ z.object({ referrerRoute: CaptureRouteRefSchema.optional() }).strict();
var PageLeaveProps = /* @__PURE__ */ z.object({
  dwellMs: z.number().int().min(0).max(864e5).optional(),
  maxScrollPct: z.number().int().min(0).max(100).optional()
}).strict();
var NavigationProps = /* @__PURE__ */ z.object({ fromRoute: CaptureRouteRefSchema.optional() }).strict();
var CONTROL_KINDS = ["link", "button", "submit", "nav", "toggle", "menuitem"];
var ControlInteractionProps = /* @__PURE__ */ z.object({ controlKind: z.enum(CONTROL_KINDS).optional() }).strict();
var FormStepProps = /* @__PURE__ */ z.object({ formRef: CaptureRefSchema, stepOrdinal: z.number().int().min(0).max(1e3) }).strict();
var FormAbandonedProps = /* @__PURE__ */ z.object({
  formRef: CaptureRefSchema,
  lastStepOrdinal: z.number().int().min(0).max(1e3).optional()
}).strict();
var FrictionProps = /* @__PURE__ */ z.object({ repeatCount: z.number().int().min(1).max(1e3).optional() }).strict();
var WEB_VITAL_METRICS = ["LCP", "INP", "CLS", "FCP", "TTFB"];
var WebVitalProps = /* @__PURE__ */ z.object({ metric: z.enum(WEB_VITAL_METRICS), value: z.number().min(0).max(36e5) }).strict();
var VisibilityProps = /* @__PURE__ */ z.object({ visible: z.boolean() }).strict();
var RESIZE_BREAKPOINTS = ["xs", "sm", "md", "lg", "xl", "2xl"];
var ResizeProps = /* @__PURE__ */ z.object({ breakpoint: z.enum(RESIZE_BREAKPOINTS) }).strict();
var MESSAGE_ROLES = ["user", "assistant"];
var MessageProps = /* @__PURE__ */ z.object({
  role: z.enum(MESSAGE_ROLES),
  length: z.number().int().min(0).max(1e6).optional()
}).strict();
var StreamCompletedProps = /* @__PURE__ */ z.object({
  durationMs: z.number().int().min(0).max(36e5).optional(),
  tokenCount: z.number().int().min(0).max(1e7).optional()
}).strict();
var SuggestionShownProps = /* @__PURE__ */ z.object({ count: z.number().int().min(0).max(100).optional() }).strict();
var SuggestionClickedProps = /* @__PURE__ */ z.object({ index: z.number().int().min(0).max(100).optional() }).strict();
var NudgeProps = /* @__PURE__ */ z.object({ nudgeRef: CaptureRefSchema.optional() }).strict();
var DisclosureProps = /* @__PURE__ */ z.object({ disclosureRef: CaptureRefSchema.optional() }).strict();
var RefusalProps = /* @__PURE__ */ z.object({ reasonClass: CaptureRefSchema.optional() }).strict();
var FEEDBACK_RATINGS = ["up", "down"];
var FeedbackProps = /* @__PURE__ */ z.object({ rating: z.enum(FEEDBACK_RATINGS) }).strict();
var ToolStartedProps = /* @__PURE__ */ z.object({ toolRef: CaptureRefSchema, toolCallId: CaptureRefSchema.optional() }).strict();
var ToolSucceededProps = /* @__PURE__ */ z.object({
  toolRef: CaptureRefSchema,
  toolCallId: CaptureRefSchema.optional(),
  latencyMs: z.number().int().min(0).max(36e5).optional()
}).strict();
var ToolFailedProps = /* @__PURE__ */ z.object({
  toolRef: CaptureRefSchema,
  toolCallId: CaptureRefSchema.optional(),
  errorClass: CaptureErrorClassSchema.optional(),
  latencyMs: z.number().int().min(0).max(36e5).optional()
}).strict();
var ConfirmCardProps = /* @__PURE__ */ z.object({ toolRef: CaptureRefSchema.optional() }).strict();
var HostActionProps = /* @__PURE__ */ z.object({ actionRef: CaptureRefSchema }).strict();
var MCP_CHANNELS = ["mcp", "webmcp"];
var McpCallProps = /* @__PURE__ */ z.object({
  toolRef: CaptureRefSchema,
  method: CaptureHttpMethodSchema.optional(),
  path: CaptureRouteRefSchema.optional(),
  channel: z.enum(MCP_CHANNELS).optional()
}).strict();
var ChannelBProps = /* @__PURE__ */ z.object({
  toolRef: CaptureRefSchema,
  method: CaptureHttpMethodSchema.optional(),
  path: CaptureRouteRefSchema.optional()
}).strict();
var INTERACTION_EVENT_PROPERTY_SCHEMAS = {
  // site
  page_view: PageViewProps,
  page_leave: PageLeaveProps,
  navigation: NavigationProps,
  control_interaction: ControlInteractionProps,
  form_step_reached: FormStepProps,
  form_step_completed: FormStepProps,
  form_abandoned: FormAbandonedProps,
  friction_rage_click: FrictionProps,
  friction_dead_click: FrictionProps,
  friction_error_click: FrictionProps,
  friction_quickback: FrictionProps,
  web_vital: WebVitalProps,
  visibility_change: VisibilityProps,
  resize_breakpoint: ResizeProps,
  // chat
  chat_opened: Empty,
  chat_closed: Empty,
  chat_minimized: Empty,
  message_sent: MessageProps,
  message_received: MessageProps,
  stream_started: Empty,
  stream_completed: StreamCompletedProps,
  suggestion_shown: SuggestionShownProps,
  suggestion_clicked: SuggestionClickedProps,
  nudge_shown: NudgeProps,
  nudge_accepted: NudgeProps,
  nudge_dismissed: NudgeProps,
  disclosure_shown: DisclosureProps,
  refusal_shown: RefusalProps,
  feedback_given: FeedbackProps,
  // function
  tool_call_started: ToolStartedProps,
  tool_call_succeeded: ToolSucceededProps,
  tool_call_failed: ToolFailedProps,
  confirm_card_shown: ConfirmCardProps,
  confirm_card_approved: ConfirmCardProps,
  confirm_card_rejected: ConfirmCardProps,
  host_action_invoked: HostActionProps,
  mcp_tool_call: McpCallProps,
  webmcp_call: McpCallProps,
  channel_b_execution: ChannelBProps
};

// src/interaction-capture/capture-leaf-redactor.ts
function redactCaptureLeaf(leaf) {
  return redactPiiInline(redactSecrets(leaf));
}

// src/interaction-capture/capture-headers.ts
var CAPTURE_HEADER_ALLOWLIST = [
  "content-type",
  "accept",
  "content-length"
];
var ALLOWED = new Set(CAPTURE_HEADER_ALLOWLIST);
function redactCaptureHeaders(input) {
  const out = {};
  for (const [name, value] of entriesOf(input)) {
    if (value == null) continue;
    const key = name.toLowerCase();
    if (ALLOWED.has(key)) out[key] = value;
  }
  return out;
}
function entriesOf(input) {
  if (input == null) return [];
  if (typeof Headers !== "undefined" && input instanceof Headers) {
    return [...input.entries()];
  }
  if (Symbol.iterator in Object(input)) {
    return input;
  }
  return Object.entries(input);
}
var INTERACTION_EVENT_SCHEMA_VERSION = 1;
var MAX_INTERACTION_BATCH_SIZE = 100;
var MIN_OCCURRED_AT = 15778368e5;
var MAX_OCCURRED_AT = 41024448e5;
var BaseEnvelope = /* @__PURE__ */ z.object({
  /** Schema version — a mismatch is rejected at the boundary. */
  v: z.literal(INTERACTION_EVENT_SCHEMA_VERSION),
  /** Client-stamped idempotency key (UUIDv7). Dedupes replayed beacons. */
  eventId: z.string().uuid(),
  /** Client session spine (UUIDv7, 30-min idle) — the `origin` + journey join. */
  sessionId: z.string().uuid(),
  /** Monotonic per-session ordinal — orders events under client clock skew. */
  seq: z.number().int().min(0).max(Number.MAX_SAFE_INTEGER),
  /** Client wall clock (epoch ms). Server also stamps `receivedAt` at ingest. */
  occurredAt: z.number().int().min(MIN_OCCURRED_AT).max(MAX_OCCURRED_AT),
  kind: z.enum(INTERACTION_EVENT_KINDS),
  origin: z.enum(INTERACTION_ORIGINS),
  /** Normalized route id (never a URL/query). */
  route: CaptureRouteRefSchema.optional(),
  /** Catalog capability coordinate (`orders.list`) — the vendor-unbeatable join. */
  capabilityId: CaptureRefSchema.optional(),
  /** Stable control signature (`uic_<hash>`) — never the element's text/value. */
  elementRef: CaptureRefSchema.optional(),
  /** Kind-specific bounded, redacted payload — validated below against the allowlist. */
  properties: z.record(z.unknown())
}).strict();
var InteractionEventSchema = BaseEnvelope.superRefine((event, ctx) => {
  const schema = INTERACTION_EVENT_PROPERTY_SCHEMAS[event.kind];
  const result = schema.safeParse(event.properties);
  if (!result.success) {
    for (const issue of result.error.issues) {
      ctx.addIssue({ ...issue, path: ["properties", ...issue.path] });
    }
  }
});
var InteractionEventBatchSchema = /* @__PURE__ */ z.object({
  /** The widget-supplied environment — server rebinds it via `bindRequestEnvironment`. */
  environment: z.enum(["development", "production"]),
  events: z.array(InteractionEventSchema).min(1).max(MAX_INTERACTION_BATCH_SIZE)
}).strict();
var CAPTURE_MODES = ["A", "B"];
var ConsentSignalSchema = /* @__PURE__ */ z.object({
  /** Grants Mode A (aggregate analytics capture). */
  analytics: z.boolean(),
  /** Grants Mode B (per-user personalization) — only effective with a verified sub. */
  personalization: z.boolean()
}).strict();
function resolveActiveLane({
  consent,
  hasVerifiedSub
}) {
  if (!consent?.analytics) return "off";
  if (consent.personalization && hasVerifiedSub) return "mode_b";
  return "mode_a";
}

// src/interaction-capture/session-idle.ts
var SESSION_IDLE_MS = 30 * 60 * 1e3;

// src/interaction-capture/capture-gate.ts
var CAPTURE_GATE_ITEMS = [
  /** BL-013 — counsel confirms the lawful-basis-per-mode table. */
  "lawfulBasisConfirmed",
  /** Q-PR15b — the consent-design fork re-decided for telemetry + transcripts. */
  "consentForkDecided",
  /** B4 — retention windows ratified by counsel/operator. */
  "retentionRatified",
  /** B3 / O6 — ROPA + DPIA additions counsel-reviewed and DPO-signed. */
  "ropaDpiaSigned",
  /** B5 — Art-50 fact pattern re-classified and re-signed (deadline 2026-08-02). */
  "art50Reclassified",
  /** B4 — privacy policy + published sub-processor list updated before first collection. */
  "privacyPolicyPublished",
  /** A11 — the PR-15 conversation-data-plane fixes deployed (MODE B ONLY). */
  "pr15FixesDeployed"
];
var CAPTURE_GATE_STATUS = {
  lawfulBasisConfirmed: false,
  consentForkDecided: false,
  retentionRatified: false,
  ropaDpiaSigned: false,
  art50Reclassified: false,
  privacyPolicyPublished: false,
  pr15FixesDeployed: false
};
var BASE_REQUIRED = [
  "lawfulBasisConfirmed",
  "consentForkDecided",
  "retentionRatified",
  "ropaDpiaSigned",
  "art50Reclassified",
  "privacyPolicyPublished"
];
var MODE_B_EXTRA = ["pr15FixesDeployed"];
function evaluateCaptureGate(input) {
  const status = input.status ?? CAPTURE_GATE_STATUS;
  if (!input.isProductionRuntime) {
    return { clear: true, blockedBy: [], exempt: true };
  }
  const required = input.mode === "B" ? [...BASE_REQUIRED, ...MODE_B_EXTRA] : BASE_REQUIRED;
  const blockedBy = required.filter((item) => !status[item]);
  return { clear: blockedBy.length === 0, blockedBy, exempt: false };
}
var CaptureGateNotClearedError = class extends Error {
  blockedBy;
  mode;
  constructor(mode, blockedBy) {
    super(
      `Interaction capture (mode ${mode}) is blocked in production by unmet compliance-gate items: ${blockedBy.join(", ")}. Close them in plan/BLOCKERS.md and record in CAPTURE_GATE_STATUS before enabling.`
    );
    this.name = "CaptureGateNotClearedError";
    this.blockedBy = blockedBy;
    this.mode = mode;
  }
};
function assertCaptureGateClear(input) {
  const decision = evaluateCaptureGate(input);
  if (!decision.clear) {
    throw new CaptureGateNotClearedError(input.mode, decision.blockedBy);
  }
}
var BEHAVIORAL_FACT_KINDS = [
  "power_user",
  "frequent_route",
  "form_abandoner",
  "prefers_agent",
  "prefers_direct",
  "friction_prone"
];
var MAX_BEHAVIORAL_SUBJECT_LENGTH = 256;
var behavioralFactSchema = /* @__PURE__ */ z.object({
  kind: z.enum(BEHAVIORAL_FACT_KINDS),
  subject: z.string().min(1).max(MAX_BEHAVIORAL_SUBJECT_LENGTH),
  metric: z.number().finite(),
  confidence: z.number().min(0).max(1),
  evidenceCount: z.number().int().min(0)
});
var behavioralFactListSchema = /* @__PURE__ */ z.array(behavioralFactSchema);
var ROI_CURRENCIES = ["USD", "EUR", "GBP", "ILS", "CAD", "AUD"];
var DEFAULT_ROI_CURRENCY = "USD";
var MAX_HUMAN_COST_PER_RESOLUTION = 1e5;
var RoiCurrencySchema = /* @__PURE__ */ z.enum(ROI_CURRENCIES);
var RoiSettingsInputSchema = /* @__PURE__ */ z.object({
  humanCostPerResolution: z.number().finite().min(0).max(MAX_HUMAN_COST_PER_RESOLUTION),
  currency: RoiCurrencySchema.default(DEFAULT_ROI_CURRENCY),
  /**
   * The same question in TIME (Phase 1.7) — how long a resolution takes a
   * person — and a different answer: a customer-success lead usually knows
   * roughly how long a ticket takes their team and rarely knows its
   * fully-loaded cost, so this is the assumption they can defend.
   *
   * `null` is a real value meaning NOT STATED, and it is `.nullable()` rather
   * than `.optional()` on purpose: an operator must be able to CLEAR a figure
   * they no longer stand behind, and an optional field cannot express the
   * difference between "leave it alone" and "remove it".
   *
   * Never derived from `humanCostPerResolution`. Dividing one by the other
   * would produce an hourly rate nobody stated and present it as though they
   * had.
   */
  humanMinutesPerResolution: z.number().finite().positive().max(MAX_HUMAN_MINUTES_PER_RESOLUTION).nullable().default(null)
}).strict();
var RESOLUTION_CONFIDENCE = ["confirmed", "assumed"];
var RESOLUTION_RUBRIC_VERSION = "v1";

// src/legal/terms-version.ts
var TERMS_VERSION = "2026-08-17";
var RETIRED_TERMS_VERSIONS = ["2026-06-04", "2026-07-02"];
var TERMS_VERSION_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

// src/text/markdown-to-plain-text.ts
var CODE_FENCE_LINE = /^[ \t]{0,3}(?:```|~~~).*$/gm;
var RULE_LINE = /^[ \t]{0,3}([-*_=])(?:[ \t]*\1){2,}[ \t]*$/gm;
var TABLE_DELIMITER_LINE = /^[ \t]{0,3}\|[-:| \t]*$/gm;
var BLOCKQUOTE_MARKER = /^[ \t]{0,3}(?:>[ \t]?)+/gm;
var ATX_HEADING = /^[ \t]{0,3}#{1,6}[ \t]+(.*?)(?:[ \t]+#+)?[ \t]*$/gm;
var LINK_REFERENCE_DEFINITION = /^[ \t]{0,3}\[[^\]]+\]:[ \t]*\S+.*$/gm;
var LIST_MARKER = /^[ \t]*(?:[-*+]|\d{1,9}[.)])[ \t]+/gm;
var MARKDOWN_LINK = /!?\[([^\]]*)\]\((?:[^()]|\([^()]*\))*\)/g;
var REFERENCE_LINK = /!?\[([^\]]*)\]\[[^\]]*\]/g;
var AUTOLINK = /<((?:https?|mailto):[^>\s]+)>/g;
var DOUBLE_BACKTICK_CODE = /``([\s\S]+?)``/g;
var BACKTICK_CODE = /`([^`]+)`/g;
var STRONG_ASTERISK = /(^|[^\\])\*\*(?=\S)([\s\S]*?\S)\*\*/g;
var STRONG_UNDERSCORE = /(^|[^\w\\])__(?=\S)([\s\S]*?\S)__(?!\w)/g;
var STRIKETHROUGH = /(^|[^\\])~~(?=\S)([\s\S]*?\S)~~/g;
var EMPHASIS_ASTERISK = /(^|[^*\w\\])\*(?=\S)([^*]*?\S)\*(?!\w)/g;
var EMPHASIS_UNDERSCORE = /(^|[^\w\\])_(?=\S)([^_]*?\S)_(?!\w)/g;
var BACKSLASH_ESCAPE = /\\([\\`*_{}[\]()#+\-.!>~|])/g;
var WHITESPACE_RUN = /\s+/g;
function markdownToPlainText(markdown) {
  if (typeof markdown !== "string" || markdown === "") {
    return "";
  }
  let text = markdown.replace(/\r\n?/g, "\n");
  text = text.replace(CODE_FENCE_LINE, "");
  text = text.replace(RULE_LINE, "");
  text = text.replace(TABLE_DELIMITER_LINE, "");
  text = text.replace(LINK_REFERENCE_DEFINITION, "");
  text = text.replace(BLOCKQUOTE_MARKER, "");
  text = text.replace(ATX_HEADING, "$1");
  text = text.replace(LIST_MARKER, "");
  text = text.replace(MARKDOWN_LINK, "$1");
  text = text.replace(REFERENCE_LINK, "$1");
  text = text.replace(AUTOLINK, "$1");
  text = text.replace(DOUBLE_BACKTICK_CODE, "$1");
  text = text.replace(BACKTICK_CODE, "$1");
  text = text.replace(STRONG_ASTERISK, "$1$2");
  text = text.replace(STRONG_UNDERSCORE, "$1$2");
  text = text.replace(STRIKETHROUGH, "$1$2");
  text = text.replace(EMPHASIS_ASTERISK, "$1$2");
  text = text.replace(EMPHASIS_UNDERSCORE, "$1$2");
  text = text.replace(BACKSLASH_ESCAPE, "$1");
  return text.replace(WHITESPACE_RUN, " ").trim();
}

// src/quick-replies/chip-shape.ts
var MAX_LABEL_CHARS = 48;
var MAX_LABEL_WORDS = 8;
var ITEM_DISQUALIFYING_SUBSTRINGS = ["`", "](", "|"];
var SEPARATOR_SUBSTRINGS = ["\u2014", "\u2013", ":", "\uFF1A"];
function hasSeparator(label) {
  return SEPARATOR_SUBSTRINGS.some((separator) => label.includes(separator));
}
var DATA_TOKEN_RE = /[$€£¥₪₹#]\s?\d/u;
var TITLED_ITEM_RE = /^(?:\*\*(.+?)\*\*|__(.+?)__)\s*[—–]\s*\S/;
var TITLED_AMBIGUOUS_ITEM_RE = /^(?:\*\*(.+?)\*\*|__(.+?)__)(?:\s*:|\s+-)\s+(\S.*)$/;
var MIN_AMBIGUOUS_DETAIL_WORDS = 3;
var TASK_ITEM_RE = /^\[[xX ]\]/;
var SENTENCE_END_RE = /[.!]$/;
function titledHead(rawItem) {
  const item = rawItem.trim();
  const dashed = TITLED_ITEM_RE.exec(item);
  if (dashed !== null) return dashed[1] ?? dashed[2] ?? null;
  const ambiguous = TITLED_AMBIGUOUS_ITEM_RE.exec(item);
  if (ambiguous === null) return null;
  if (countWords(ambiguous[3] ?? "") < MIN_AMBIGUOUS_DETAIL_WORDS) return null;
  return ambiguous[1] ?? ambiguous[2] ?? null;
}
function countWords(text) {
  return text.split(/\s+/).filter((word) => word !== "").length;
}
function isChipShaped(label, options) {
  if (label === "" || TASK_ITEM_RE.test(label)) return false;
  if (label.length > MAX_LABEL_CHARS) return false;
  if (SENTENCE_END_RE.test(label)) return false;
  if (DATA_TOKEN_RE.test(label)) return false;
  for (const bad of ITEM_DISQUALIFYING_SUBSTRINGS) {
    if (label.includes(bad)) return false;
  }
  if (options?.allowSeparators !== true && hasSeparator(label)) return false;
  const words = countWords(label);
  return words >= 1 && words <= MAX_LABEL_WORDS;
}
function stripInlineMarkdown(text) {
  return text.replace(/\*\*(.+?)\*\*/g, "$1").replace(/__(.+?)__/g, "$1").replace(/\*(.+?)\*/g, "$1").replace(/_(.+?)_/g, "$1").trim();
}

// src/quick-replies/quick-replies.types.ts
var MIN_ITEMS = 2;
var MAX_ITEMS = 8;
var QUICK_REPLY_SHAPE = Object.freeze({
  minItems: MIN_ITEMS,
  maxItems: MAX_ITEMS,
  maxLabelChars: MAX_LABEL_CHARS,
  maxLabelWords: MAX_LABEL_WORDS
});
var QUICK_REPLY_REJECTIONS = [
  "too-many",
  "mixed-shape",
  "item-shape",
  "deduped",
  "questions"
];

// src/quick-replies/quick-replies.ts
var LIST_ITEM_RE = /^\s*[-*+]\s+(.+?)\s*$/;
var CUE_TAIL_RE = /[:?？：؟]$/u;
var QUESTION_TAIL_RE = /[?？؟;]$/u;
var CUE_QUESTION_TAIL_RE = /[?？؟]$/u;
function extractQuickReplies(text) {
  return extractQuickReplyRun(text)?.replies ?? [];
}
function extractQuickReplyRun(text) {
  return bestRun(text);
}
function bestRun(text) {
  let first = null;
  for (const verdict of verdicts(text)) {
    if (!("run" in verdict)) continue;
    if (verdict.cueKind === "question") return verdict.run;
    first ??= verdict.run;
  }
  return first;
}
function explainQuickReplyRun(text) {
  const run = bestRun(text);
  if (run !== null) return { kind: "run", run };
  let firstRejection = null;
  for (const verdict of verdicts(text)) {
    if ("run" in verdict) continue;
    if (firstRejection === null && verdict.rejected !== null) firstRejection = verdict.rejected;
  }
  return firstRejection === null ? { kind: "none" } : { kind: "rejected", reason: firstRejection };
}
function* verdicts(text) {
  if (typeof text !== "string" || text.trim() === "") return;
  const lines = text.split("\n");
  let runStart = -1;
  const runItems = [];
  for (let i = 0; i <= lines.length; i += 1) {
    const match = i < lines.length ? LIST_ITEM_RE.exec(lines[i] ?? "") : null;
    if (match !== null) {
      if (runStart === -1) runStart = i;
      runItems.push(match[1] ?? "");
      continue;
    }
    if (runStart !== -1) {
      const judged = qualifyRun(runItems, lines, runStart);
      const cueKind = cueKindAbove(lines, runStart) ?? "colon";
      if ("labels" in judged) {
        yield {
          run: {
            replies: judged.labels,
            firstLine: runStart,
            lastLine: i - 1,
            detailsOmitted: judged.detailsOmitted,
            cueKind
          },
          cueKind
        };
      } else {
        yield judged;
      }
      runStart = -1;
      runItems.length = 0;
    }
  }
}
function qualifyRun(rawItems, lines, runStart) {
  if (rawItems.length < MIN_ITEMS) return { rejected: null };
  if (!hasOfferCueAbove(lines, runStart)) return { rejected: null };
  const questions = rawItems.filter(
    (item) => QUESTION_TAIL_RE.test(stripInlineMarkdown(item).trim())
  ).length;
  if (questions * 2 > rawItems.length) return { rejected: "questions" };
  if (rawItems.length > MAX_ITEMS) return { rejected: "too-many" };
  const heads = rawItems.map(titledHead);
  const titledCount = heads.filter((head) => head !== null).length;
  if (titledCount > 0 && titledCount < rawItems.length) return { rejected: "mixed-shape" };
  const detailsOmitted = titledCount === rawItems.length;
  const candidates = rawItems.map(
    (raw, index) => stripInlineMarkdown(detailsOmitted ? heads[index] ?? "" : raw)
  );
  const allowSeparators = !detailsOmitted && !candidates.every(hasSeparator);
  const labels = [];
  const seen = /* @__PURE__ */ new Set();
  for (const label of candidates) {
    if (!isChipShaped(label, { allowSeparators })) return { rejected: "item-shape" };
    const key = label.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    labels.push(label);
  }
  return labels.length >= MIN_ITEMS ? { labels, detailsOmitted } : { rejected: "deduped" };
}
function hasOfferCueAbove(lines, runStart) {
  return cueKindAbove(lines, runStart) !== null;
}
function cueKindAbove(lines, runStart) {
  for (let i = runStart - 1; i >= 0; i -= 1) {
    const line = lines[i] ?? "";
    if (line.trim() === "") continue;
    if (LIST_ITEM_RE.test(line)) return null;
    const cue = stripInlineMarkdown(line).replace(/\s+$/, "");
    if (!CUE_TAIL_RE.test(cue)) return null;
    return CUE_QUESTION_TAIL_RE.test(cue) ? "question" : "colon";
  }
  return null;
}

// src/audience-outcomes/reportability.ts
var AUDIENCE_MIN_MEMBERS = 5;
var AUDIENCE_MIN_CONVERSATIONS = 100;
function classifyAudienceReportability(sizes) {
  if (sizes.members < AUDIENCE_MIN_MEMBERS) return "suppressed";
  if (sizes.conversations < AUDIENCE_MIN_CONVERSATIONS) return "counts-only";
  return "full";
}
function mayShowCounts(reportability) {
  return reportability !== "suppressed";
}
function mayShowRates(reportability) {
  return reportability === "full";
}

// src/audience-outcomes/compose.ts
function composeAudienceOutcome(counts) {
  const reportability = classifyAudienceReportability({
    members: counts.members,
    conversations: counts.conversations
  });
  const counted = mayShowCounts(reportability);
  const rated = mayShowRates(reportability);
  const ratings = counts.ratingsUp + counts.ratingsDown;
  return {
    segmentId: counts.segmentId,
    name: counts.name,
    reportability,
    members: counted ? counts.members : null,
    conversations: counted ? counts.conversations : null,
    resolvedCount: counted ? counts.resolvedCount : null,
    gapConversations: counted ? counts.gapConversations : null,
    // The sample count travels with the counts rather than with the rate it
    // qualifies, deliberately: at `counts-only` it is what tells an operator
    // how close the segment is to being reportable, which is the one useful
    // thing to say about a segment whose rates are withheld.
    ratings: counted ? ratings : null,
    resolvedRate: rated && counts.conversations > 0 ? counts.resolvedCount / counts.conversations : null,
    satisfactionRate: rated && ratings > 0 ? counts.ratingsUp / ratings : null
  };
}
function isReported(outcome) {
  return outcome.reportability !== "suppressed";
}
function composeAudienceOutcomes(rows) {
  const measurable = rows.filter((r) => r.membership === "materialized");
  const composed = measurable.map(composeAudienceOutcome);
  return {
    outcomes: composed.filter(isReported),
    suppressedCount: composed.filter((o) => o.reportability === "suppressed").length,
    liveMembershipCount: rows.length - measurable.length
  };
}

// src/audience-outcomes/membership.ts
function audienceMembershipSource(segment) {
  if (segment.matchKind === "explicit") return "materialized";
  if (segment.membershipMode === "fixed") return "materialized";
  return "live";
}

// src/vocabulary/otel-vocabulary.ts
var ATTRIBUTE_ROLES = ["identifying", "descriptive"];
var REQUEST_SPAN_KINDS = ["client", "producer", "server", "consumer"];
var OBSERVABLE_SPAN_KINDS = ["client", "producer"];
var ROUTE_PROVENANCE = ["declared", "observed"];
function routeProvenanceOf(discovery) {
  return discovery === "manifest" ? "declared" : "observed";
}
var REGISTERED_DOMAIN_ATTRIBUTE = "url.registered_domain";
var ADOPTED_OTEL_TERMS = [
  "identifying",
  "descriptive",
  "http.route",
  "url.template",
  "url.registered_domain"
];

// src/widget-origin/origin-grammar.ts
var DEFAULT_PORTS = {
  "http:": "80",
  "https:": "443"
};
var LOCAL_HOSTS = /* @__PURE__ */ new Set(["localhost", "127.0.0.1", "[::1]"]);
var SCHEME_PREFIX = /^[a-z][a-z0-9+.-]*:\/\//i;
function isLocalWidgetOrigin(origin) {
  try {
    return LOCAL_HOSTS.has(new URL(origin).hostname.toLowerCase());
  } catch {
    return false;
  }
}
function parseWidgetOrigin(input) {
  return parse(input, false);
}
function parseTypedWidgetOrigin(input) {
  return parse(input, true);
}
function parse(input, coerceBareAuthority) {
  if (typeof input !== "string") return { ok: false, refusal: "empty" };
  const trimmed = input.trim();
  if (trimmed.length === 0) return { ok: false, refusal: "empty" };
  if (trimmed.toLowerCase() === "null") return { ok: false, refusal: "scheme" };
  if (trimmed.includes("*")) return { ok: false, refusal: "wildcard" };
  const hasScheme = SCHEME_PREFIX.test(trimmed);
  if (!hasScheme && !coerceBareAuthority) return { ok: false, refusal: "scheme" };
  const candidate = hasScheme ? trimmed : `https://${trimmed}`;
  let url;
  try {
    url = new URL(candidate);
  } catch {
    return { ok: false, refusal: "not-a-host" };
  }
  const scheme = url.protocol.toLowerCase();
  if (scheme !== "http:" && scheme !== "https:") return { ok: false, refusal: "scheme" };
  if (url.username !== "" || url.password !== "") return { ok: false, refusal: "credentials" };
  if (url.pathname !== "/" && url.pathname !== "") return { ok: false, refusal: "not-bare-origin" };
  if (url.search !== "" || url.hash !== "") return { ok: false, refusal: "not-bare-origin" };
  const host = url.hostname.toLowerCase();
  if (host.length === 0) return { ok: false, refusal: "missing-host" };
  if (host.startsWith(".") || host.includes("..")) return { ok: false, refusal: "not-a-host" };
  const local = LOCAL_HOSTS.has(host);
  const effectiveScheme = !hasScheme && local ? "http:" : scheme;
  if (effectiveScheme === "http:" && !local) return { ok: false, refusal: "https-required" };
  const port = url.port;
  const isDefaultPort = port === "" || port === DEFAULT_PORTS[effectiveScheme];
  const authority = isDefaultPort ? host : `${host}:${port}`;
  return { ok: true, origin: `${effectiveScheme}//${authority}`, local, coerced: !hasScheme };
}
function normalizeWidgetOrigin(input) {
  const parsed = parseWidgetOrigin(input);
  return parsed.ok ? parsed.origin : null;
}
function widgetOriginsMatch(requestOrigin, allowedEntry) {
  const a = normalizeWidgetOrigin(requestOrigin);
  const b = normalizeWidgetOrigin(allowedEntry);
  return a !== null && b !== null && a === b;
}
var PROCEDURE_ARG_SHAPES = [
  "text",
  "number",
  "integer",
  "boolean",
  "date",
  "time",
  "email",
  "tel",
  "url",
  "currency",
  "selection",
  "file",
  "unknown"
];
var PROCEDURE_INTENT_PATTERN = /^[a-z][a-z0-9_]{0,63}$/u;
var DIGIT_RUN = /[0-9]{4,}/u;
function isProcedureIntentKey(value) {
  return PROCEDURE_INTENT_PATTERN.test(value) && !DIGIT_RUN.test(value);
}
var MAX_PROCEDURE_STEPS = 24;
var MAX_PROCEDURE_PRECONDITIONS = 8;
var MAX_PROCEDURE_ARG_SHAPES = 24;
var argShape = /* @__PURE__ */ z.enum(PROCEDURE_ARG_SHAPES);
var intentKey = /* @__PURE__ */ z.string().refine(isProcedureIntentKey, {
  message: "intent must be a normalized identifier carrying no visitor text"
});
var routeTemplate = /* @__PURE__ */ z.string().min(1).max(400);
var expectedEvidence = ActionEvidenceListSchema;
var ProcedureStepSchema = /* @__PURE__ */ z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("navigate"), routeTemplate }).strict(),
  z.object({
    kind: z.literal("ui_click"),
    fingerprint: ControlFingerprintSchema,
    expectedEvidence
  }).strict(),
  z.object({
    kind: z.literal("ui_set"),
    fingerprint: ControlFingerprintSchema,
    argShape,
    expectedEvidence
  }).strict(),
  z.object({
    kind: z.literal("ui_select"),
    fingerprint: ControlFingerprintSchema,
    argShape,
    expectedEvidence
  }).strict(),
  z.object({
    kind: z.literal("capability"),
    /**
     * Constrained to the canonical `<domain>.<action>` shape at READ as well
     * as at write. `stepsFromCompletedPlan` already refuses a plan step whose
     * `toolId` is not a capability id, but that is the WRITE side only — and
     * the retrieval leg (ADR-0699) now interpolates this value into the
     * model's prompt, so a row written before that check, or by hand, would
     * carry 200 unconstrained characters there. A row that does not match is
     * DROPPED on read rather than repaired, which is the direction
     * `ProcedureRepository` already fails in.
     */
    capabilityId: z.string().regex(CAPABILITY_ID_PATTERN),
    /** Keyed by ARGUMENT NAME; the value is a shape, never the argument. */
    argShapes: z.record(z.string().min(1).max(120), argShape).refine((m) => Object.keys(m).length <= MAX_PROCEDURE_ARG_SHAPES, {
      message: "too many argument shapes"
    }),
    expectedEvidence
  }).strict()
]);
var ProcedureSchema = /* @__PURE__ */ z.object({
  id: z.string().min(1).max(64),
  /** The route template the procedure applies to (`:param` matches one segment). */
  urlPattern: routeTemplate,
  intent: intentKey,
  /** Bumped by a failed replay, which also re-learns (R-1). */
  version: z.number().int().min(1),
  /** Named conditions, never their values — e.g. `signed_in`, `cart_not_empty`. */
  preconditions: z.array(intentKey).max(MAX_PROCEDURE_PRECONDITIONS),
  steps: z.array(ProcedureStepSchema).min(2).max(MAX_PROCEDURE_STEPS),
  /** R-1: real successful runs only. The sealed walk can never be a source. */
  learnedFrom: z.literal("live-run"),
  successCount: z.number().int().min(0),
  failureCount: z.number().int().min(0)
}).strict();
function parseProcedure(value) {
  const parsed = ProcedureSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}

// src/procedures/procedure-match.ts
var MAX_KEY_CHARS = 64;
var DIGEST_LETTERS = 7;
var VALUE_DIGIT_RUN = /\p{Nd}{4,}/u;
function normalizeLabel(raw) {
  return raw.normalize("NFKC").toLowerCase().replace(/\s+/gu, " ").trim();
}
function foldToKey(raw) {
  const key = normalizeLabel(raw).replace(/[^a-z0-9]+/gu, "_").replace(/^_+|_+$/gu, "").slice(0, MAX_KEY_CHARS).replace(/_+$/u, "");
  if (key === "" || !isProcedureIntentKey(key)) return null;
  return key;
}
function digestKey(raw) {
  let hash = Number.parseInt(controlAxisDigest(normalizeLabel(raw)), 16);
  let letters = "";
  for (let i = 0; i < DIGEST_LETTERS; i += 1) {
    letters = String.fromCharCode(97 + hash % 26) + letters;
    hash = Math.floor(hash / 26);
  }
  return `label_${letters}`;
}
function keyFromLabel(raw) {
  if (VALUE_DIGIT_RUN.test(raw.normalize("NFKC"))) return null;
  return foldToKey(raw) ?? digestKey(raw);
}
function intentSources(steps) {
  const sources = [];
  for (let i = steps.length - 1; i >= 0; i -= 1) {
    const step = steps[i];
    if (step?.kind === "capability") {
      sources.push(step.capabilityId);
      break;
    }
  }
  for (let i = steps.length - 1; i >= 0; i -= 1) {
    const step = steps[i];
    if (step?.kind !== "ui_click" || step.fingerprint.role === void 0) continue;
    const { testId, domId, name } = step.fingerprint;
    if (testId !== void 0) sources.push(testId);
    const stable = domId === void 0 ? void 0 : stableId(domId);
    if (stable !== void 0) sources.push(stable);
    if (name !== void 0) sources.push(name);
    break;
  }
  return sources;
}
function deriveIntentKey(steps) {
  for (const raw of intentSources(steps)) {
    const key = keyFromLabel(raw);
    if (key !== null) return key;
  }
  return null;
}
function rank2(p) {
  if (p.successCount === 0) return null;
  if (p.failureCount >= p.successCount) return null;
  return (p.successCount - p.failureCount) * 1e3 + p.version;
}
function selectProcedure(candidates, lookup) {
  const path = clusterPathTemplate(lookup.path);
  let best = null;
  let bestRank = Number.NEGATIVE_INFINITY;
  for (const candidate of candidates) {
    if (candidate.intent !== lookup.intent) continue;
    if (!routeTemplatesMatch(candidate.urlPattern, path)) continue;
    const score = rank2(candidate);
    if (score === null || score <= bestRank) continue;
    best = candidate;
    bestRank = score;
  }
  return best;
}

// src/procedures/learn-procedure.ts
var LEARN_REFUSALS = [
  "walk-run",
  "too-few-steps",
  "too-many-steps",
  "step-unconfirmed",
  "invalid-step",
  "no-intent",
  "not-a-procedure"
];
function learnProcedure(input) {
  if (input.source !== "live-run") return { refused: "walk-run" };
  if (input.steps.length < 2) return { refused: "too-few-steps" };
  if (input.steps.length > MAX_PROCEDURE_STEPS) return { refused: "too-many-steps" };
  const steps = [];
  for (const entry of input.steps) {
    if (entry.outcome !== "confirmed") return { refused: "step-unconfirmed" };
    const parsed = ProcedureStepSchema.safeParse(entry.step);
    if (!parsed.success) return { refused: "invalid-step" };
    steps.push(parsed.data);
  }
  const intent = deriveIntentKey(steps);
  if (intent === null) return { refused: "no-intent" };
  const candidate = {
    id: input.id,
    urlPattern: input.urlPattern,
    intent,
    version: (input.previousVersion ?? 0) + 1,
    preconditions: [],
    steps,
    learnedFrom: "live-run",
    // A re-learn starts at zero on BOTH counters. Carrying the old procedure's
    // successes would let a version the page has outgrown inherit the standing
    // of the one it replaced, and `selectProcedure` reads exactly those two
    // numbers to decide whether a procedure has earned a replay.
    successCount: 0,
    failureCount: 0
  };
  const procedure = ProcedureSchema.safeParse(candidate);
  return procedure.success ? { learned: procedure.data } : { refused: "not-a-procedure" };
}

// src/procedures/replay-procedure.ts
var REPLAY_STOPS = [
  /** The step's control could not be re-resolved on this page (F6 abstained). */
  "fingerprint-abstained",
  /** The page did not tell us the step worked. Routine live; disqualifying here. */
  "evidence-absent",
  /** The page told us something else. */
  "evidence-contradicted",
  /** A named precondition the procedure declares was not met. */
  "precondition-unmet"
];
function stopFor(observed) {
  if (!observed.resolved) return "fingerprint-abstained";
  if (observed.outcome === "contradicted") return "evidence-contradicted";
  if (observed.outcome === "no-evidence") return "evidence-absent";
  return null;
}
function nextReplayStep(input) {
  const { procedure, performed } = input.state;
  const nextVersion = procedure.version + 1;
  if (performed === 0) {
    const met = new Set(input.metPreconditions ?? []);
    for (const precondition of procedure.preconditions) {
      if (!met.has(precondition)) {
        return { kind: "stop", reason: "precondition-unmet", nextVersion };
      }
    }
  } else if (input.observed !== void 0) {
    const stop = stopFor(input.observed);
    if (stop !== null) return { kind: "stop", reason: stop, nextVersion };
  } else {
    return { kind: "stop", reason: "evidence-absent", nextVersion };
  }
  const step = procedure.steps[performed];
  return step === void 0 ? { kind: "done" } : { kind: "step", step, index: performed };
}

// src/intake-spec/intake-spec-read.ts
function intakeFieldsOf(spec) {
  const out = [];
  const visit = (steps) => {
    for (const step of steps) {
      out.push(...step.fields);
      const { branch } = step;
      if (branch === void 0) continue;
      for (const branchCase of branch.cases) visit(branchCase.steps);
      visit(branch.default ?? []);
    }
  };
  visit(spec.steps);
  return out;
}
function intakeAskIfNames(spec) {
  return intakeFieldsOf(spec).filter((field) => field.askIf === "absent").map((field) => field.name);
}
function isIntakeFieldSensitive(field) {
  return field.sensitive === true;
}
function canPrefillIntakeField(field) {
  return !isIntakeFieldSensitive(field);
}
function resolveIntakeText(map, locale) {
  return map[locale ?? DEFAULT_LOCALE];
}

export { A6_GATED_KINDS, AASA_PATH, ACCOUNT_DELETE_SOLE_OWNER, ADAPTIVE_COMPOSITIONS_LABS_FEATURE_ID, ADJUST_STEER_REASON, ADOPTED_OTEL_TERMS, AGENT_PAGE_CONTROL_LABS_FEATURE_ID, AI_GENERATED_DATA_ATTRIBUTE, AI_GENERATED_HEADER, AI_GENERATED_HEADER_VALUE, AI_PROVENANCE_SPEC_ID, AI_PROVENANCE_SPEC_URL, ALARMING_VERDICT, ALL_DIRECTIVE_RELEASES, ALL_TOOLS, ANALYSIS_UC_MONTHLY_ALLOWANCE, ANALYTICS_APPS, ANALYTICS_EVENTS, ANALYTICS_ROOM_IDS, ANALYTICS_ROOM_PARAM, ANALYTICS_ROUTE, ANALYTICS_SOURCES, ANALYTICS_WINDOWS, ANALYTICS_WINDOW_DAYS, ANALYTICS_WINDOW_SUPPORT, ANCHOR_CANDIDATE_STATES, ANCHOR_MISS_REASONS, ANNUAL_PREPAY_DISCOUNT_FRACTION, ANONYMOUS_CONVERSATION_RETENTION_DAYS, ANONYMOUS_SUB_PREFIX, ANSWER_LENGTHS, ANSWER_SPEED_MIN_SAMPLES, APP_CONFIG, ARGUMENT_EXAMPLE_PROVENANCES, ASKING_SHAPES, ATTRIBUTE_KEY_PATTERN, ATTRIBUTE_ROLES, AUDIENCE_MIN_CONVERSATIONS, AUDIENCE_MIN_MEMBERS, AUDIT_CATEGORIES, AUDIT_EVENTS, AUDIT_SEVERITIES, AUTONOMY_MODES, AVOID_CHIPS, AbuseEventPayloadSchema, AccountDeleteSoleOwnerError, ActionInProgressPropsSchema, ActionOutcomeSchema, ActionPlanPropsSchema, ActionPlanStepSchema, ActionProgressStepSchema, ActionResultPropsSchema, ActionStepStatusSchema, AppConfigSchema, AskSelectionSchema, AuthEventPayloadSchema, AuthoredSurveyQuestionSchema, AuthoredSurveySchema, BACKEND_SPEC_PROBES, BASE_RADIUS_LG_REM, BASE_RADIUS_MD_REM, BASE_RADIUS_REM2 as BASE_RADIUS_REM, BASE_RADIUS_SM_REM, BEDROCK_EU_CRIS_MULTIPLIER, BEDROCK_EU_MODEL_ID_PREFIX, BEHAVIORAL_FACT_KINDS, BEHAVIOR_INSIGHTS_LABS_FEATURE_ID, BLOCK_BEGIN, BLOCK_END, BUILTIN_DESIGN_SEEDS, BUSINESS_CHANGE_ACTIONS, BUSINESS_CHANGE_ACTION_TYPES, BUSINESS_CHANGE_KINDS, BUSINESS_OUTCOME_VERDICT_IDS, BUSINESS_SIGNALS, BUSINESS_SIGNALS_REQUIRING_TARGET, BUSINESS_VERDICT_DESTINATIONS, BoundChartConfigSchema, BoundFunnelConfigSchema, BoundMetricConfigSchema, BoundPrimitivePayloadSchema, BoundTableConfigSchema, BundleSymbolsFactSchema, ButtonPropsSchema, ButtonVariantSchema, CACHE_READ_MULTIPLIER, CACHE_WRITE_MULTIPLIER, CACHE_WRITE_MULTIPLIER_1H, CANONICAL_RESPONSES_EN, CANONICAL_RESPONSE_KEYS, CAPABILITY_DOSSIER_CHAT_ONLY_FIELDS, CAPABILITY_DOSSIER_ENUM_VALUE_MAX, CAPABILITY_DOSSIER_FIELD_NAME_MAX, CAPABILITY_DOSSIER_GROUPS, CAPABILITY_DOSSIER_GROUP_FIELDS, CAPABILITY_DOSSIER_GUIDANCE_CLAUSE_KINDS, CAPABILITY_DOSSIER_GUIDANCE_MAX, CAPABILITY_DOSSIER_GUIDANCE_WEIGHT_BASE, CAPABILITY_DOSSIER_LOCALIZATION_INSTRUCTION, CAPABILITY_DOSSIER_MATCH_PHRASE_MAX, CAPABILITY_DOSSIER_PROMPT_MAX, CAPABILITY_DOSSIER_RESULT_SHAPES, CAPABILITY_DOSSIER_SLUG_PATTERN, CAPABILITY_DOSSIER_SYNTHETIC_INSTRUCTION, CAPABILITY_DOSSIER_TEXT_MAX, CAPABILITY_DOSSIER_TOOL_FIELDS, CAPABILITY_DOSSIER_TOOL_NAME, CAPABILITY_DOSSIER_WORD_MAX, CAPABILITY_OVERRIDE_MODES, CAPTURE_GATE_ITEMS, CAPTURE_GATE_STATUS, CAPTURE_HEADER_ALLOWLIST, CAPTURE_MODES, CAPTURE_PLANES, CHART_CONTRAST_FLOOR, CHART_PALETTE_PRESETS, CHART_PALETTE_PRESET_IDS, CHART_PALETTE_SLOTS, CHAT_COMPARE_ON_SELECT_REFUSED_LOG, CHAT_COMPARISON_EVIDENCE_EMPTY_LOG, CHAT_COMPARISON_UNGROUNDED_LOG, CHAT_COMPARISON_VERDICT_REPLACED_LOG, CHAT_ENGINE_METRICS, CHAT_PROACTIVE_OFFER_LOG, CHAT_REFUSAL_LOG, CHAT_VISITOR_ERROR_RENDERED_LOG, CHECKLIST_VERIFICATION_KINDS, CLAIM_SIGNALS, CLARIFY_CHIPS, CLIENT_LATENCY_MAX_MS, CMS_ASSET_HOSTS, CMS_ASSET_PATH_MARKERS, CMS_DOM_ATTRIBUTES, CMS_EVIDENCE, CMS_GENERATOR_MARKERS, CMS_INDEX_PATHS, CMS_KINDS, COMPARISON_TRIGGER, COMPETITOR_HANDLINGS, COMPLIANCE_CATEGORIES, COMPLIANCE_DETECTOR_IDS, COMPLIANCE_DISCLAIMER, COMPLIANCE_RUBRIC, COMPLIANCE_SCHEMA_VERSION, COMPLIANCE_SCORE_SEVERITIES, COMPLIANCE_SEVERITIES, COMPOSITION_CEILING_UNREADABLE_LOG, COMPOSITION_OPENERS_LABS_FEATURE_ID, COMPREHENSION_EVIDENCE, COMPREHENSION_LOCALES, CONDITIONAL_SEND_INTENTS, CONDITIONAL_SEND_KEYS, CONTROL_KINDS, CONVERSATION_FORWARDING_PAYLOAD_VERSION, CONVERSATION_MODEL_PREFERENCES, CONVERSATION_RETENTION_CHOICES, COVERAGE_METRICS_LABS_FEATURE_ID, CSS_STATE_KINDS, CUSTOM_METRIC_SIGNAL, CapabilityDossierArgumentExampleSchema, CapabilityDossierDisplayWordsSchema, CapabilityDossierDraftSchema, CapabilityDossierFollowUpSchema, CapabilityDossierIntakeRecordSchema, CapabilityDossierRecoveredEnumSchema, CapabilityDossierSchema, CapabilityDossierTemplateSchema, CapabilityDossierUnitDirectionSchema, CapabilityDossierUsageGuidanceSchema, CapabilityDossierWordsSchema, CaptureGateNotClearedError, CardImageSchema, CardPropsSchema, ChartPropsSchema, ChecklistItemSchema, ChecklistItemStateSchema, ChecklistVerificationSchema, CitationSchema, ClientActionsSchema, ClientLatencyReportSchema, CmsPresenceFactSchema, ComplianceDetectorIdSchema, ComplianceFindingSchema, ComplianceScoreSeveritySchema, ComplianceScorecardSchema, ComplianceSeveritySchema, ComponentPropsSchema, ComponentRenderDeclarationSchema, ComponentToolsSchema, CompositionBindingCallSchema, CompositionBindingsSchema, ConfirmCardPropsSchema, ConfirmationRequiredSchema, ConflictError, ConsentSignalSchema, ContextTruncatedSchema, DASHBOARD_LAYOUTS, DEFAULT_ANALYTICS_ROOM, DEFAULT_AUTONOMY_MODE, DEFAULT_CHART_RAMP_2_TO_8, DEFAULT_CONTEXT_TOKEN_BUDGET, DEFAULT_CONVERSATION_MODEL_PREFERENCE, DEFAULT_DIGEST_ENABLED, DEFAULT_DIGEST_HOUR_UTC, DEFAULT_DIGEST_INTERVAL, DEFAULT_DIGEST_WEEKDAY, DEFAULT_EMBED_HEIGHT_PX, DEFAULT_EXECUTION_BIAS, DEFAULT_HOME_SECTIONS, DEFAULT_MESSAGE_MAX_CHARS, DEFAULT_METRIC_ALARM, DEFAULT_PERSONA_LANGUAGE, DEFAULT_ROI_CURRENCY, DEFAULT_SCOPE_POLICY, DEFAULT_SITE_WALK_DRIVER, DEFAULT_STATE_EQUIVALENCE_THRESHOLD, DEFAULT_SURFACE_SETTINGS, DEFAULT_TOPIC_KEYS, DEFAULT_TOPIC_TAXONOMY, DEFAULT_WALK_POSTURE, DEFAULT_WIDGET_CONFIG, DEFAULT_WIDGET_DESIGN_CONTENT, DEFAULT_WIDGET_PAGE_RULE_MATCH, DEFAULT_WIDGET_SIZE, DEFAULT_WIKI_EDITORIAL_POLICY, DESIGN_LANGUAGE_FOLLOW_VISITOR, DESIGN_PARTS, DESIGN_PART_ATTRIBUTE, DETECTED_STYLE_DOMAINS, DETECTED_SUGGESTION_TOKEN_NAMES, DIGEST_INTERVALS, DIGEST_MAX_CUSTOM_HOURS, DIGEST_MAX_HOUR, DIGEST_MAX_WEEKDAY, DIGEST_MIN_HOUR, DIGEST_MIN_WEEKDAY, DIRECTIVE_RELEASES, DIRECTIVE_RELEASE_KEYS, DIRECTIVE_RELEASE_STATUSES, DISCOVERY_HARVEST_VOLUME_LOG, DISCOVERY_HARVEST_VOLUME_THRESHOLD, DISCOVERY_INVENTORY_FULL_LOG, DISCOVERY_SESSION_STATUSES, DOCS_SYNC_SWEEP_EVENT_KIND, DOC_FINDING_RESOLVED_REASONS, DOC_FINDING_STATUSES, DOC_FINDING_TYPES, DOC_REPORT_REASONS, DOM_STATE_KEPT_ATTRIBUTES, DOM_STATE_MAX_TEXT_CHARS, DOM_STATE_MIN_TOKENS_FOR_NEARNESS, DOM_STATE_OPAQUE_TAGS, DOWNLOAD_ONLY_MEDIA_TYPES, DRIFT_FINDING_TYPES, DURATION_MEASURES, DURATION_MIN_SAMPLES, DURATION_STATES, DashboardCompositionPropsSchema, DashboardLayoutSchema, DashboardPayloadSchema, DetailFieldSchema, DetailPropsSchema, DraftIntakeFieldSchema, DraftIntakeSchema, DraftIntakeStepSchema, DraftedUnitCopySchema, EMBED_CONFIG_LOAD_MODES, EMBED_ENVIRONMENTS, EMBED_KEY_MAX_LENGTH, EMBED_KEY_PATTERN, EMBED_LAUNCHER_POSITIONS, EMBED_MAX_HEIGHT_PX, EMPHASIS_CHIPS, EMPTY_CAPABILITY_DOSSIER, EMPTY_FUNNEL, EMPTY_GUIDANCE, ENGAGEMENT_ABANDON_MAX_SECONDS, ENGAGEMENT_DESKTOP_DISPLAYS, ENGAGEMENT_DWELL_MAX_SECONDS, ENGAGEMENT_EVENT_KEY_MAX, ENGAGEMENT_EVENT_KEY_PATTERN, ENGAGEMENT_EVENT_MATCH_MAX, ENGAGEMENT_EVENT_NAME_MAX, ENGAGEMENT_EVENT_VALUE_MAX, ENGAGEMENT_FATIGUE_DEFAULT_POLICY, ENGAGEMENT_FUNNEL_STAGES, ENGAGEMENT_GOALS, ENGAGEMENT_HOLDOUT_MAX_PCT, ENGAGEMENT_MAX_VARIANTS, ENGAGEMENT_MOBILE_DISPLAYS, ENGAGEMENT_NAME_MAX, ENGAGEMENT_PRIORITY_MAX, ENGAGEMENT_ROLLOUT_SALT_MAX, ENGAGEMENT_ROUTE_MAX, ENGAGEMENT_RULE_ID_PATTERN, ENGAGEMENT_RULE_KINDS, ENGAGEMENT_RULE_STATUSES, ENGAGEMENT_SURFACES, ENGAGEMENT_TEST_PARAM, ENGAGEMENT_TEXT_MAX, ENGAGEMENT_TRIGGER_TYPES, ENGAGEMENT_VARIANT_WEIGHT_MAX, ENGAGEMENT_VERDICT_IDS, ENRICHMENT_UC_MONTHLY_ALLOWANCE, ESCALATE_CHIPS, ESCALATION_KINDS, EXECUTION_BIASES, EXECUTION_MODE_FLOORED_VARIANTS, EXEC_METRIC_IDS, EXPERIENCES_KILL_ALL, EXPERIENCES_KILL_ENV_VAR, EXPERIENCES_LABS_FEATURE_ID, EXPERIENCE_ACTION_KINDS, EXPERIENCE_ACTION_LABEL_MAX, EXPERIENCE_ANCHOR_KINDS, EXPERIENCE_BODY_MAX, EXPERIENCE_BULLET_MAX, EXPERIENCE_CAPABILITY_ID_MAX, EXPERIENCE_CHAT_PREFILL_MAX, EXPERIENCE_CONTROL_MAX, EXPERIENCE_GUIDE_ID_PATTERN, EXPERIENCE_HEADING_MAX, EXPERIENCE_MAX_ACTIONS, EXPERIENCE_MAX_BULLETS, EXPERIENCE_MAX_PER_SESSION, EXPERIENCE_PLACEMENTS, EXPERIENCE_PRIORITY_MAX, EXPERIENCE_PROVENANCES, EXPERIENCE_ROUTE_ID_MAX, EXPERIENCE_ROUTE_ID_PATTERN, EXPERIENCE_SESSION_MAX, EXPERIENCE_SLOT_PATTERN, EXPERIENCE_SNOOZE_MAX_HOURS, EXPERIENCE_UNIT_EVENTS, EXPERIENCE_UNIT_KEY_PATTERN, EXPERIENCE_UNIT_NAME_MAX, EXPERIENCE_UNIT_STATUSES, EXPERIMENTAL_FEATURES, EXPERIMENTAL_FEATURE_ID_PATTERN, EXPERIMENTAL_FEATURE_STAGES, EXPORTED_FILE_LINK_TTL_SECONDS, EXPORTED_FILE_MAX_BYTES, EXPORTED_FILE_MAX_FILENAME, EXPORTED_FILE_MAX_PER_CONVERSATION_PER_HOUR, EXPORTED_TABLE_CONTENT_TYPE, EXPORTED_TABLE_NUMBER_FORMATS, EXPORT_ARTIFACT_EXPIRY_DAYS, EXPORT_ARTIFACT_TAGGING, EXPORT_ARTIFACT_TAG_KEY, EXPORT_ARTIFACT_TAG_VALUE, EXTENSION_BY_TYPE, EmbedOriginSchema, EmbedPropsSchema, EmptyStatePropsSchema, EnableWhatsappChannelInputSchema, EngagementAudienceSchema, EngagementDisplaySchema, EngagementEventMatchSchema, EngagementLimitsSchema, EngagementMessageSchema, EngagementRuleSchema, EngagementScheduleSchema, EngagementTriggerSchema, EngagementVariantSchema, EngagementVariantsSchema, ErrorEventSchema, ErrorLimitSchema, ExperienceActionSchema, ExperienceActionsSchema, ExperienceAnchorSchema, ExperienceContentSchema, ExperienceEventReportSchema, ExperienceGoalSchema, ExperienceLimitsSchema, ExperienceSessionRangeSchema, ExperienceTargetingSchema, ExperienceUnitKeySchema, ExperienceUnitSchema, ExperienceVariantsSchema, ExportedTableResultSchema, FAILED_ACTION_ERROR_CLASSES, FALLBACK_MEDIA_TYPE, FALLBACK_MODEL_LIMITS, FEEDBACK_COMMENT_MAX_CHARS, FEEDBACK_ISSUE_TYPES, FEEDBACK_RATINGS, FILE_REF_PATTERN, FILE_REF_PREFIX, FIXTURE_MAX_TOTAL_ROWS_DEFAULT, FIXTURE_ROWS_PER_MODEL_CEILING, FIXTURE_ROWS_PER_MODEL_DEFAULT, FORBIDDEN_SERVED_FIELDS, FORENSIC_ACTORS, FORENSIC_EVENT_CLASSES, FORENSIC_EVENT_FAMILIES, FORENSIC_OUTCOMES, FORENSIC_PAYLOAD_SCHEMAS, FORENSIC_SEVERITIES, FORMULA_TRIGGER, FORM_ERROR_STATES, FRAMEWORK_COVERAGE, FRONTIER_FEATURES, FRONTIER_FEATURE_CLASSES, FRONTIER_FEATURE_KEY_PATTERN, FRONTIER_KILL_ALL, FRONTIER_KILL_ENV_VAR, FRONTIER_LABS_FEATURE_ID, FRONTIER_NON_REGISTRY_KILL_KEYS, FRONTIER_OUTCOME_SURFACES, FULL_INTROSPECTION_QUERY, FUNNEL_MAX_STAGES, FUNNEL_MIN_STAGES, FUNNEL_STAGE_BY_EVENT_KIND, FailedActionRefSchema, FeedbackIssueTypeSchema, FileReadySchema, ForensicAuditBaseEnvelopeSchema, ForensicEventClassSchema, FrameRefusalFactSchema, FunnelPropsSchema, FunnelStageSchema, GATHERING_TOOL, GOAL_MIN_SAMPLES, GRAPHQL_INTROSPECTION_LABS_FEATURE_ID, GRAPHQL_SELECTION_FORBIDDEN, GRAPHQL_SELECTION_REQUIRED, GUIDE_LAUNCH_SOURCES, GUIDE_NAME_MAX, GUIDE_RECORDING_MESSAGE_TYPE, GraphqlIntrospectionFactSchema, GuideRecordingBindRequestSchema, GuideRecordingMessageSchema, GuideRunBatchSchema, GuideRunReportSchema, HOST_ACTION_ID_PATTERN, HOST_ACTION_NAME_PATTERN, HOST_ACTION_TOOL_PREFIX, HOST_COMPONENT_USE_WHEN_MAX, HOURS_SAVED_BAND_FACTORS, HostActionDeclarationSchema, HostComponentUseWhenSchema, I18N_KEY_SOURCE, ICON_CROP_ENDPOINT_METHODS, ICON_CROP_EVIDENCE_KINDS, ICON_CROP_NAMING_LABS_FEATURE_ID, ICON_CROP_REFUSALS, IDENTIFY_MODES, IDENTITY_HOME_SECTIONS, IDENTITY_IDPS, IMPACT_SHARE_LABEL_MAX, IMPACT_SHARE_TOKEN_BYTES, IMPACT_SHARE_TOKEN_PREFIX, IMPACT_SHARE_TTL_DAYS_DEFAULT, IMPACT_SHARE_TTL_DAYS_MAX, IMPACT_SHARE_TTL_DAYS_MIN, IMPACT_SUBSCRIPTION_MAX_RECIPIENTS, IMPACT_SUBSCRIPTION_SLACK_URL_MAX, IMPORTED_DESIGN_NAME, INSIGHT_FAILURE_REASONS, INSIGHT_OUTCOMES, INSIGHT_PROVENANCES, INSIGHT_RATIONALE_MAX, INSIGHT_SENTIMENTS, INTAKE_ASK_IF_CONDITIONS, INTAKE_CHOICE_MAX_OPTIONS, INTAKE_CHOICE_MIN_OPTIONS, INTAKE_DATE_PATTERN, INTAKE_DATE_TIME_PATTERN, INTAKE_FIELD_KINDS, INTAKE_READ_FILTER_THRESHOLD, INTAKE_SPEC_VERSION, INTAKE_STEP_ID_PATTERN, INTERACTION_EVENT_KINDS, INTERACTION_EVENT_PROPERTY_SCHEMAS, INTERACTION_EVENT_SCHEMA_VERSION, INTERACTION_LEDGER_WRITE_FAILED_LOG, INTERACTION_ORIGINS, IconCropEvidenceSchema, IconCropNameSchema, IconCropRequestSchema, IconCropResponseSchema, IconCropSchema, IframePropsSchema, IncidentEventPayloadSchema, InsightEvidenceSchema, InsightRecordSchema, IntakeFieldSchema, IntakeSpecSchema, IntakeStepSchema, IntegrationChangeKindSchema, IntegrationChangeSchema, IntegrationPlanSchema, IntentOperationSchema, IntentTransportSchema, InteractionEventBatchSchema, InteractionEventSchema, InternalError, IsolationEventPayloadSchema, KeyEventPayloadSchema, LAMBDA_HANDLERS, LANGUAGE_MODES, LATENCY_MIN_SAMPLES, LATEST_MCP_PROTOCOL_VERSION, LAZY_CHUNK_MECHANISMS, LEARNED_INSIGHT_KINDS, LEARN_REFUSALS, LIVE_DISCOVERY_SESSION_STATUSES, LIVE_WRITE_IDEMPOTENCY_HEADER, LIVE_WRITE_IDEMPOTENCY_PREFIX, LIVE_WRITE_MARKER_HEADER, LIVE_WRITE_MARKER_VALUE, LIVE_WRITE_REFUSALS, LLM_LIST_PRICING, LLM_MODEL_LIMITS, LLM_PRICING, LOCALIZED_COMPREHENSION_TOOL_NAME, LOCAL_DEV, ListItemSchema, ListPropsSchema, LiveWalkFactSchema, M0_COMPOSERS, M2_FALLBACK_REASONS, M2_FORCING_MODEL_PREFIXES, M2_ORDER_SENSITIVE_SHAPES, MALFORMED_MEDIA_TYPES, MANUAL_FINDINGS, MANUAL_PAGE_TYPES, MATCH_RULE_ACTIVITY_METRICS, MATCH_RULE_ACTIVITY_OPS, MATCH_RULE_PARAMETERISED_METRICS, MATCH_RULE_VALUE_OPS, MAX_ALLOWED_EMBED_ORIGINS, MAX_AMBIENT_UNITS_PER_VIEW, MAX_ASK_SELECTION_NAME, MAX_ASK_SELECTION_ROLE, MAX_ASK_SELECTION_TAG, MAX_ASK_SELECTION_TEXT, MAX_ATTRIBUTE_KEYS, MAX_ATTRIBUTE_KEY_LENGTH, MAX_ATTRIBUTE_VALUE_LENGTH, MAX_BEHAVIORAL_SUBJECT_LENGTH, MAX_BRAND_PHRASES, MAX_BUSINESS_DELTAS, MAX_BUSINESS_VERDICT_ISSUES, MAX_CAPABILITY_DOSSIER_ENUMS, MAX_CAPABILITY_DOSSIER_ENUM_VALUES, MAX_CAPABILITY_DOSSIER_FIELDS, MAX_CAPABILITY_DOSSIER_FOLLOW_UPS, MAX_CAPABILITY_DOSSIER_TEMPLATES, MAX_CAPTURED_CLAIM_KEYS, MAX_CHANGE_MARKERS, MAX_CHECKLIST_ITEMS, MAX_COMPARE_AUDIENCES, MAX_COMPONENT_TOOLS, MAX_COMPONENT_TOOL_DESCRIPTION_CHARS, MAX_COMPONENT_TOOL_PARAMETERS_CHARS, MAX_COMPREHENSION_DESCRIPTION, MAX_COMPREHENSION_NAME, MAX_CONTENT_TYPES, MAX_CUSTOM_TOPICS, MAX_DASHBOARD_ITEMS, MAX_DECLARED_ANCHOR_VIEWS_PER_PAGE, MAX_DECLARED_VARIANTS_PER_FORM, MAX_DECLARED_VARIANTS_PER_PAGE, MAX_DWELL_SECONDS, MAX_END_USER_SUB_LENGTH, MAX_ESCALATION_TARGET_GRAPHEMES, MAX_EVIDENCE_PER_FINDING, MAX_EXPERIENCE_GUIDES, MAX_EXPERIENCE_UNITS, MAX_FILENAME_LENGTH, MAX_FORM_ERROR_MESSAGES, MAX_FORM_ERROR_MESSAGE_CHARS, MAX_FORM_ERROR_VOCABULARIES, MAX_FORM_ERROR_VOCABULARIES_PER_ENVIRONMENT, MAX_FRAME_ORIGINS, MAX_GUIDE_RUN_REPORTS, MAX_HOST_ACTIONS, MAX_HOST_ACTION_DESCRIPTION_CHARS, MAX_HOST_ACTION_PARAMETERS_CHARS, MAX_HOST_ACTION_TITLE_CHARS, MAX_HUMAN_COST_PER_RESOLUTION, MAX_HUMAN_MINUTES_PER_RESOLUTION, MAX_ICON_CROPS_PER_REQUEST, MAX_ICON_CROPS_PER_RUN, MAX_ICON_CROP_BASE64_CHARS, MAX_ICON_CROP_BYTES, MAX_ICON_CROP_NAME_GRAPHEMES, MAX_ICON_CROP_SIDE_PX, MAX_IDENTIFY_BATCH, MAX_INGEST_EVENTS, MAX_INGEST_MISSES, MAX_INSIGHT_CONTENT_LENGTH, MAX_INSIGHT_VIEW_NAME_LENGTH, MAX_INTAKE_DEFAULT_CHARS, MAX_INTAKE_EXAMPLES, MAX_INTAKE_EXAMPLE_CHARS, MAX_INTAKE_FIELD_NAME_CHARS, MAX_INTAKE_HELP_CHARS, MAX_INTAKE_LABEL_CHARS, MAX_INTAKE_SUMMARY_CHARS, MAX_INTERACTION_BATCH_SIZE, MAX_INTROSPECTABLE_TYPES, MAX_JOURNEYS, MAX_JOURNEY_DEPTH, MAX_JOURNEY_NODES, MAX_LANGUAGE_PRIORITY, MAX_LIVE_WRITES_PER_PAGE, MAX_LIVE_WRITES_PER_RUN, MAX_LOCALIZED_COMPREHENSION_BATCH, MAX_MATCH_RULE_ACTIVITY_VALUE, MAX_MATCH_RULE_CONDITIONS, MAX_MATCH_RULE_IN_VALUES, MAX_MATCH_RULE_KEY_LENGTH, MAX_MATCH_RULE_WINDOW_DAYS, MAX_METRIC_NAME_CHARS, MAX_METRIC_NAME_UTF16, MAX_METRIC_PREDICATES, MAX_METRIC_VALUES, MAX_METRIC_VALUE_CHARS, MAX_NOMINATIONS, MAX_NOMINATION_CANDIDATES, MAX_OBSERVED_AUDIENCE_CHARS, MAX_OFFERED_FILES, MAX_OFFERED_FILE_BYTES, MAX_OFFERED_TOTAL_BYTES, MAX_PAGE_ENTITIES_PER_PAGE, MAX_PAGE_EVIDENCE_PAGES_PER_ENVIRONMENT, MAX_PAGE_FACTS_PER_PAGE, MAX_PAGE_FACT_ATTRIBUTE_CHARS, MAX_PAGE_FACT_ENTITY_CHARS, MAX_PAGE_FACT_UNIT_CHARS, MAX_PAGE_FACT_VALUE_CHARS, MAX_PAGE_MEDIA_PER_PAGE, MAX_PAGE_MEDIUM_ALT_CHARS, MAX_PERSONA_PROFILES, MAX_PINNED_ATTRIBUTE_KEYS, MAX_PREVIEW_BYTES, MAX_PROCEDURE_ARG_SHAPES, MAX_PROCEDURE_PRECONDITIONS, MAX_PROCEDURE_STEPS, MAX_PROFILE_DESCRIPTION_CHARS, MAX_PROFILE_NAME_CHARS, MAX_PROMPT_ADDITION_LENGTH, MAX_PROPOSED_AREAS, MAX_RECIPES_PER_RUN, MAX_RECIPE_ENTRIES, MAX_RECIPE_SOURCE_NAME_CHARS, MAX_RECORDED_GUIDE_STEPS, MAX_REFUSAL_INVALID_FIELDS, MAX_REFUSAL_MESSAGES, MAX_REFUSAL_MESSAGE_GRAPHEMES, MAX_REFUSAL_STYLES, MAX_REFUSAL_TOPICS, MAX_RELEASE_TENANT_IDS, MAX_REPORTED_OUTCOMES_PER_BATCH, MAX_ROUTES_VISITED, MAX_SAFE_PROBES_PER_PAGE, MAX_SAFE_PROBES_PER_RUN, MAX_SCOPE_TOPICS, MAX_SCOPE_TOPIC_GRAPHEMES, MAX_SEALED_DEPTH, MAX_SEALED_FILLS_PER_PAGE, MAX_SEALED_OPERATIONS_PER_PAGE, MAX_SEALED_OPTIONS_PER_CONTROL, MAX_SEALED_PRESSES_PER_PAGE, MAX_SEALED_PRESS_BUDGET, MAX_SEALED_SOCKETS_PER_PAGE, MAX_SEALED_SOCKET_PROTOCOLS, MAX_SEALED_SOCKET_PROTOCOL_CHARS, MAX_SEALED_VALIDATION_FORMS, MAX_SEGMENT_DESCRIPTION_LENGTH, MAX_SEGMENT_NAME_LENGTH, MAX_SELECT_OPTIONS, MAX_SEQUENCES_PER_FINDING, MAX_SITEMAP_LOCS_PER_DOCUMENT, MAX_SITEMAP_SEED_PER_GROUP, MAX_SITEMAP_SEED_TOTAL, MAX_SITEMAP_SUBSITEMAPS, MAX_SPEC_PROBES_PER_BACKEND, MAX_SPEC_VERSION_CHARS, MAX_SUCCESS_METRICS_PER_TENANT, MAX_SUGGESTED_QUESTION_GRAPHEMES, MAX_SUGGESTED_TERM_GRAPHEMES, MAX_SURVEY_QUESTIONS, MAX_TARGET_AUDIENCES, MAX_TARGET_END_USER_SUBS, MAX_TERM_VECTOR_TOKENS, MAX_TOOL_SCOPE_CAPABILITIES, MAX_TOOL_SCOPE_SERVICES, MAX_TURN_PLAN_CAPABILITY_GROUPS, MAX_TURN_PLAN_ENTITIES, MAX_TURN_PLAN_ENTITY_CHARS, MAX_TURN_PLAN_GROUP_CHARS, MAX_TURN_PLAN_MISSING_INPUTS, MAX_TURN_PLAN_NAME_CHARS, MAX_TURN_PLAN_OFFERS, MAX_USER_INSIGHT_BUCKETS, MAX_VARIANTS_PER_TEMPLATE, MAX_VISION_CONTROLS_PER_IMAGE, MAX_VISION_CONTROL_NAME_GRAPHEMES, MAX_VISION_IMAGES_PER_REQUEST, MAX_VISION_IMAGES_PER_RUN, MAX_VISION_IMAGE_BYTES, MAX_VISION_IMAGE_SIDE_PX, MAX_VISION_SURFACES_PER_PAGE, MAX_WALK_API_CALLS_PER_PAGE, MAX_WALK_BLOCKED_WRITES_PER_PAGE, MAX_WALK_HEADING_CHARS, MAX_WALK_PAGE_HEADINGS, MAX_WALK_PAGE_TEXT_CHARS, MAX_WALK_PAGE_TITLE_CHARS, MAX_WALK_SERVED_SPECS_PER_ENVIRONMENT, MAX_WALK_SERVED_SPECS_PER_RUN, MAX_WALK_SERVED_SPEC_BYTES, MAX_WALK_SERVED_SPEC_URL_CHARS, MAX_WALK_SERVED_SPEC_WIRE_BYTES, MAX_WALK_VARIANT_VISITS, MAX_WALK_WITNESSES_PER_PAGE, MAX_WELCOME_BINDINGS, MAX_WELL_KNOWN_ROUTES, MAX_WIDGET_PAGE_RULES, MAX_WIDGET_PAGE_RULES_PAYLOAD_BYTES, MAX_WIDGET_PAGE_RULE_DESCRIPTION_CHARS, MAX_WIDGET_PAGE_RULE_NAME_CHARS, MAX_WIDGET_PAGE_RULE_URL_PATTERN, MAX_WIDGET_STARTERS, MAX_WITNESSED_HEADER_VALUE_CHARS, MAX_WITNESS_KIND_CHARS, MAX_WITNESS_METHOD_CHARS, MAX_WITNESS_OPERATION_NAME_CHARS, MCPB_ENTRY_POINT, MCPB_FILENAME, MCP_APPS_THEME_META_KEY, MCP_APPS_UI_SCRIPT_SRC, MCP_APPS_VIEW_SPEC_SCRIPT_ID, MCP_CHANNELS, MCP_PROTOCOL_VERSION_LEGACY, MCP_PROTOCOL_VERSION_STATELESS, MCP_SERVER_ID, MCP_SERVER_LABEL, MESSAGE_MAX_CHARS_HARD_CAP, MESSAGE_MAX_CHARS_MIN, MESSAGE_ROLES, METRIC_ALARM_SNOOZES, METRIC_ALARM_VERDICTS, METRIC_CLOSED_VALUES, METRIC_DIRECTIONS, METRIC_FLAG_FIELDS, METRIC_MAX_ITEMS, METRIC_RATINGS, METRIC_SET_FIELDS, METRIC_SLOT_FIELDS, METRIC_TEMPLATES, METRIC_TEMPLATE_BY_ID, METRIC_TEMPLATE_IDS, MINIMAL_INTROSPECTION_QUERY, MIN_COMPARE_AUDIENCES, MIN_PROPOSED_AREAS, MIN_RECIPE_VALUE_BYTES, MIN_ROLLOUT_ARM_SIZE, MIN_SEALED_OPERATIONS_PER_PAGE, MIN_SEALED_PRESS_BUDGET, MIN_VARIANT_SAMPLE, MIN_VISION_SURFACE_PX, MODALITY_ALARM_FIELDS, MODALITY_ALARM_VALUES, MODALITY_CLASSES, MODALITY_TRACE_LOG, MODEL_CLASS_ELECTED_LOG, MONITORING_TARGET_METRICS, MONITORING_TARGET_SPECS, MOST_COMMON_SPEC_PROBES, MULTIPLICITY_BUCKETS, MarkdownPropsSchema, McpAppsThemeSchema, McpAppsViewSpecSchema, MessageDeltaSchema, MessageEndSchema, MessageProvenanceSchema, MessageStartSchema, MetricDeltaDirectionSchema, MetricItemSchema, MetricPropsSchema, NEGATIVE_SCOPES, NEW_TAB_SAFE_TYPES, NOTIFICATION_DEFAULT_TTL_MS, NO_CAPABILITY, NO_DIRECTIVE_RELEASE_ARMS, NO_DIRECTIVE_RELEASE_ROLLOUTS, NO_OPENER_SIGNALS, NO_TARGETING, NO_VARIANT, NPS_MAX, NPS_MIN, NUDGE_VARIANT_PATTERN, NavigatePropsSchema, NotFoundError, OBSERVABLE_SPAN_KINDS, OBSERVED_AUDIENCE_PATTERN, ONBOARDING_CHECKLIST_MAX_ITEMS, ONBOARDING_ID_MAX, OPENER_REASONS, OPENER_TONES, OUTPUT_CEILING_TOKENS, OfferedFileSchema, OnboardingChecklistItemSchema, OnboardingChecklistPropsSchema, OnboardingProgressSchema, OperationKindSchema, PADDLE_RAIL_FEE, PAGE_FACT_SOURCES, PAGE_MEDIUM_SOURCES, PAINTED_CONTROL_KINDS, PAINTED_SURFACE_CLASSES, PAINTED_SURFACE_KINDS, PERSONA_DIFF_FIELDS, PERSONA_ENTRY_MAX_CHARS, PERSONA_MAX_CHARS, PERSONA_PROFILE_REVISION_LIMIT, PLACEMENT_CLASSES, PLANE_CHAT_KINDS, PLANE_FUNCTION_KINDS, PLANE_SITE_KINDS, PLANNER_SCHEMA_VERSION, PLAN_ACT_FLOOR, PLAN_HIGH_CONFIDENCE, PLATFORM_SCOPE_RULE_IDS, POSTED_ACTED_AND_LOOKED_UP_UC, POSTED_ACTED_ONLY_UC, POSTED_ANSWER_UC, POSTED_BLENDED_AVERAGE_UC, POSTED_LOOKED_UP_ONLY_UC, POSTED_MIX_MEASURED_2026_09_10, POSTED_PRICE_SET, POSTED_PRICE_TABLE, POSTED_STANDALONE_TOOL_CALL_UC, PREVIEW_KIND_BY_TYPE, PRIMITIVE_SCHEMAS, PROACTIVE_OFFER_REASONS, PROCEDURE_ARG_SHAPES, PROCEDURE_INTENT_PATTERN, PROFILE_TRANSFER_KIND, PROFILE_TRANSFER_VERSION, PROMPT_CACHE_DEGRADED_LOG, PROSE_BUDGETS, PSEUDO_LOCALIZE_CLOSE_BRACKET, PSEUDO_LOCALIZE_OPEN_BRACKET, PUBLIC_AUDIENCE, PUBLIC_WIDGET_LOAD_BUDGET_KB, PUBLISHED_PACKAGES, PaintedControlSchema, PermissionError, PrimitivePayloadSchema, ProcedureSchema, ProcedureStepSchema, QUICK_REPLY_REJECTIONS, QUICK_REPLY_SHAPE, QuietHoursSchema, RADIUS_CAP_REM, RADIUS_LG_CAP_REM, RADIUS_MD_CAP_REM, RADIUS_SCALE_MAX, RADIUS_SCALE_MIN, RADIUS_SCALE_STEP, RADIUS_SM_CAP_REM, RAMPING_RELEASE_STATUSES, RATING_MAX, RATING_MIN, RECIPE_HEADER_NAME_PATTERN, RECIPE_JSON_POINTER_PATTERN, RECIPE_ORIGIN_PATTERN, RECIPE_QUERY_NAME_PATTERN, REDACTED, REFUSAL_CLASSES, REFUSAL_STYLE_CATEGORIES, REFUSED_MEDIA_TYPES, REFUSING_SCOPES, REGISTERED_DOMAIN_ATTRIBUTE, REGRESSION_DROP_POINTS, REGRESSION_MIN_SAMPLES, RENDER_COMPONENT_ID_PATTERN, RENDER_COMPONENT_NAME_PATTERN, RENDER_COMPONENT_TOOL_PREFIX, RENDER_SHAPES, REPLAY_STOPS, REPORTED_OUTCOME_CONVERSATION_PATTERN, REPORTED_OUTCOME_KEY_PATTERN, REPORT_CADENCES, REQUEST_SPAN_KINDS, RERANKER_UNAVAILABLE_LOG, RESERVED_ATTRIBUTE_PREFIX, RESIZE_BREAKPOINTS, RESOLUTION_BILLING_KIND, RESOLUTION_CONFIDENCE, RESOLUTION_MIN_CONVERSATIONS, RESOLUTION_RUBRIC_VERSION, RESTRICTED_TOPICS, RESUME_INVALID_PROVIDER_REQUEST_LOG, RETIRED_TERMS_VERSIONS, RETIRED_WIDGET_CLAIM_FIGURES, REVEAL_PROBE_LABS_FEATURE_ID, REVIEW_CUSTOM_METRIC_VERDICTS, REVIEW_GOALS, REVIEW_INCENTIVE, REVIEW_PLATFORMS, REVIEW_PROMPT_COOLDOWN_DAYS, REVIEW_PROMPT_MAX_DISMISSALS, REVIEW_PROMPT_RESOLUTION_THRESHOLD, REVIEW_TREND_BUCKET_DAYS, REVIEW_TREND_MIN_BUCKETS, ROI_CURRENCIES, ROLLOUT_BUCKETS, ROLLOUT_SIGNIFICANCE_P, ROLLOUT_VERDICT_IDS, ROUTE_PROVENANCE, RTL_ACCEPTANCES, RUBRIC_VERSION, RateLimitPolicySchema, RateLimitedError, RecipeEntrySchema, RecipeSourceSchema, RecipeTargetSchema, RecordedGuideStepSchema, RefusalEventPayloadSchema, RegisteredAbilityReportSchema, RegisteredAbilitySchema, RequestRecipeSchema, ReviewPlatformSchema, ReviewPromptStateSchema, RoiCurrencySchema, RoiSettingsInputSchema, RouteRefSchema, SAFE_PROBE_MARKER_HEADER, SAFE_PROBE_MARKER_VALUE, SAFE_PROBE_METHODS, SAFE_PROBE_TIMEOUT_MS, SATISFACTION_MIN_RATINGS, SATISFACTION_TARGET_DEFAULT, SATISFACTION_THRESHOLD, SCHEDULED_SITE_WALK_LABS_FEATURE_ID, SCRIPT_CAPABLE_MEDIA_TYPES, SEALED_DEEP_WALK_LABS_FEATURE_ID, SEALED_FRAME_VISION_LABS_FEATURE_ID, SEALED_OPERATIONS_PER_CONTROL, SEALED_OPERATION_KINDS, SEALED_PRESS_REASONS, SEALED_SOCKET_KINDS, SEALED_UNEXPLORED_REASONS, SECRET_BLOCK_BEGIN, SECRET_BLOCK_END, SECRET_ENV_SOURCES, SECRET_KEYS, SENSITIVE_DOMAINS, SENSITIVE_DOMAIN_HANDLINGS, SENSITIVE_VALUE_MASK, SENTRY_ENVELOPE_ITEM_TYPE, SENTRY_EVENT_LEVELS, SENTRY_FORWARDER_CLIENT, SENTRY_FORWARDER_SDK, SENTRY_FORWARDING_PLATFORM, SESSION_IDLE_MS, SEVERITY_PENALTY, SHA256_HEX_PATTERN, SHAPE_MECHANISMS, SHAPE_OUTPUT_BUDGET_BELOW_MEASURED, SHAPE_OUTPUT_MEASURED, SHAPE_OUTPUT_MEASURED_ON, SHAPE_TABLE, SHAPE_TEMPLATE, SITEMAP_ROOT_PATHS, SITE_MANUAL_LABS_FEATURE_ID, SITE_WALK_BACKGROUND_TIMEOUT_MULTIPLIER, SITE_WALK_CREDENTIAL_HEADER, SITE_WALK_CREDENTIAL_RENEWAL_MS, SITE_WALK_DEFAULT_CEILING_PAGES, SITE_WALK_DEFAULT_CEILING_SECONDS, SITE_WALK_DRIVERS, SITE_WALK_FLUSH_COALESCE_MS, SITE_WALK_FLUSH_COALESCE_PAGES, SITE_WALK_FRONTIER_LEASE_MS, SITE_WALK_FRONTIER_MAX_ATTEMPTS, SITE_WALK_HANDOFF_FRAGMENT_KEY, SITE_WALK_HEARTBEAT_INTERVAL_MS, SITE_WALK_HEARTBEAT_STALE_MS, SITE_WALK_HIGH_REFUSAL_LOG, SITE_WALK_LABS_FEATURE_ID, SITE_WALK_LOCK_GRACE_MS, SITE_WALK_MAX_API_BASE_URL_CHARS, SITE_WALK_MAX_CEILING_PAGES, SITE_WALK_MAX_CEILING_SECONDS, SITE_WALK_MAX_FLUSH_BYTES, SITE_WALK_MAX_FOUND_PER_REPORT, SITE_WALK_MAX_PAGES_PER_FLUSH, SITE_WALK_MAX_PAGE_TIMEOUT_MS, SITE_WALK_MAX_PATH_CHARS, SITE_WALK_MAX_QUEUED_ROUTES, SITE_WALK_MAX_REVEAL_EDGES_PER_PAGE, SITE_WALK_MAX_SIBLING_ORIGINS, SITE_WALK_MIN_CEILING_PAGES, SITE_WALK_MIN_CEILING_SECONDS, SITE_WALK_MIN_PAGE_TIMEOUT_MS, SITE_WALK_NEXT_LIMIT, SITE_WALK_NONCE_MAX_CHARS, SITE_WALK_NONCE_MIN_CHARS, SITE_WALK_NONCE_PATTERN, SITE_WALK_OPT_IN_HEADER, SITE_WALK_PAGES_LOST_LOG, SITE_WALK_PAGE_TIMEOUT_CEILING_MS, SITE_WALK_PAGE_TIMEOUT_FLOOR_MS, SITE_WALK_PAGE_TIMEOUT_MULTIPLIER, SITE_WALK_PAGE_TIMEOUT_SAMPLE, SITE_WALK_PAUSE_REASONS, SITE_WALK_REFUSAL_SHARE_THRESHOLD, SITE_WALK_REPORTABLE_PAUSE_REASONS, SITE_WALK_REPORTED_PHASES, SITE_WALK_ROUTE_TIMEOUT_MS, SITE_WALK_SCOPES, SITE_WALK_SESSION_SETUP_SLACK_MS, SITE_WALK_SKIP_REASONS, SITE_WALK_STARTABLE_SCOPE, SITE_WALK_TRUNCATED_LOG, SITE_WALK_UNREACHED_REASONS, STABLE_CONTROL_IDENTITY_LABS_FEATURE_ID, STARTER_TEMPLATES, STARTER_TEMPLATE_IDS, STATE_NEARNESS_STRATEGIES, STREAM_TRANSPORT_STAGES, SUCCESS_METRICS_ANCHOR, SUCCESS_METRIC_MIN_CONVERSATIONS, SUCCESS_METRIC_VERDICT_IDS, SUGGESTED_QUESTION_COUNT, SUPPORTED_MCP_PROTOCOL_VERSIONS, SURVEY_QUESTION_TYPES, SURVEY_TEXT_MAX, SWEEP_ONLY_STATUSES, SYNCANIX_CSP_ALLOWANCES, SYNCANIX_PUBLIC_API_DTS, SYNCANIX_QUEUEABLE_METHODS, SYNCANIX_QUEUEABLE_NON_VOID, SYSTEM_PROMPT_MAX_CHARS, SYSTEM_RELATIONS, SafeProbeFactSchema, SavedGuideSchema, SealedWalkFactSchema, ServedAnchorSchema, ServedChecklistSchema, ServedContentSchema, ServedExperienceUnitSchema, ServedExperienceUnitsSchema, ServedGoalSchema, ServedGuidesSchema, ServedSpecFactSchema, ServedSurveySchema, SetWhatsappAccountLinkingInputSchema, SignInCardPropsSchema, SiteWalkApiCallSchema, SiteWalkBindRequestSchema, SiteWalkBlockedWriteSchema, SiteWalkCssStatesSchema, SiteWalkDeclaredRevealsSchema, SiteWalkFormErrorVocabularySchema, SiteWalkFrontierPageOutcomeSchema, SiteWalkFrontierReportSchema, SiteWalkHeartbeatSchema, SiteWalkLivePageSchema, SiteWalkNextRequestSchema, SiteWalkNominateRequestSchema, SiteWalkNominateResponseSchema, SiteWalkPageBatchSchema, SiteWalkPageEvidenceRefusalsSchema, SiteWalkPageEvidenceSchema, SiteWalkPageFactSchema, SiteWalkPageMediumSchema, SiteWalkPageSchema, SiteWalkPageTextSchema, SiteWalkPaintedPageSchema, SiteWalkProbePageSchema, SiteWalkRevealEdgeSchema, SiteWalkRevealsSchema, SiteWalkSealedOperationsSchema, SiteWalkSealedPageSchema, SiteWalkSealedSocketSchema, SiteWalkSealedSocketsSchema, SiteWalkSealedUnexploredSchema, SiteWalkSummarySchema, SiteWalkValidationSchema, SiteWalkVisionFindingSchema, SiteWalkVisionImageSchema, SiteWalkVisionRequestSchema, SiteWalkVisionResponseSchema, SiteWalkWitnessSchema, StatusPropsSchema, StatusVariantSchema, SuggestionSchema, SuggestionsSchema, SurveyAnswerSchema, SurveyQuestionSchema, SurveyResponseSubmissionSchema, SyncanixError, TARGETING_SPECIFICITY, TARGET_OVERSHOOT_CRITICAL_RATIO, TARGET_SHORTFALL_CRITICAL_RATIO, TEACH_AFFORDANCE_NAME_MAX_CHARS, TEACH_CAPTURE_CREDENTIAL_HEADER, TEACH_CAPTURE_MAX_BATCH, TEACH_CAPTURE_MAX_PATH_CHARS, TEACH_MAX_AFFORDANCE_BINDINGS, TEACH_MODE_LABS_FEATURE_ID, TENANT_SPACING_DEFAULT_SECONDS, TERMS_VERSION, TERMS_VERSION_PATTERN, TIER_ENTITLEMENTS, TONE_NUDGES, TOOL_ERROR_MIN_CALLS, TOOL_RESULT_DEADLINE_LOG, TOOL_RESULT_DENIAL_REASONS, TOOL_RESULT_OUTCOMES, TOOL_RETRIEVAL_MISS_LOG, TOOL_SCOPE_SIDE_EFFECTS, TOPIC_KEY_PATTERN, TOPIC_OTHER, TOUR_AUTO_OPEN_LABS_FEATURE_ID, TOUR_MAX_REVEAL_EDGES, TURN_EXPLAIN_WRITE_FAILED_LOG, TURN_FRICTION_SIGNALS, TURN_HOST_ACTIVITY_STATES, TURN_INVALID_PROVIDER_REQUEST_LOG, TURN_MECHANISMS, TURN_ORIGINS, TURN_PANEL_MODES, TURN_PLAN_INTENTS, TURN_PLAN_MISSING_INPUT_REASONS, TURN_PLAN_REQUIRED_FIELDS, TURN_PLAN_SCOPES, TURN_PLAN_SHAPES, TURN_PLAN_SHAPE_BLOCK_CLASS, TURN_PLAN_TOOL_NAME, TURN_REFUSED_IN_FLIGHT_LOG, TURN_SHAPES, TURN_STREAM_EVENT_TYPES, TURN_STREAM_FIRST_BYTE_TIMEOUT_MS, TURN_STREAM_HEARTBEAT_MS, TURN_STREAM_INTER_FRAME_TIMEOUT_MS, TableCellSchema, TableColumnSchema, TablePropsSchema, TableRowSchema, TeachAffordanceBindingSchema, TeachBindRequestSchema, TeachCaptureBatchSchema, TeachCaptureSchema, ThinkingDeltaSchema, ThinkingEndSchema, ThinkingStartSchema, ToolCallArgsDeltaSchema, ToolCallDeferredNavigationSchema, ToolCallEndSchema, ToolCallExecuteSchema, ToolCallResultSchema, ToolCallStartSchema, ToolCallUndoAvailableSchema, ToolResultEnvelopeSchema, TourRevealEdgeSchema, TourRevealReportSchema, TurnEndSchema, TurnLanguageSchema, TurnPanelContextSchema, TurnPlanFrameSchema, TurnPlanSchema, TurnSessionContextSchema, TurnStartSchema, TurnStopReasonSchema, TurnStreamEventSchema, TurnUsageSchema, UC_FLOOR_RATE_USD, UC_INCLUDED_RATE_USD, UC_MARGIN_FLOOR, UC_MIN_COGS_MULTIPLE, UC_OVERAGE_SWEEP_CHARGED_UNRECORDED_LOG, UC_OVERAGE_SWEEP_FAILED_LOG, UC_OVERAGE_SWEEP_OVER_CAP_LOG, UC_PAYG_RATE_USD, UC_PER_ENDPOINT_CALL, UC_PER_ENRICHMENT, UC_PER_INSIGHT, UC_PER_MCP_CALL, UC_PER_MESSAGE, UC_TIERS, UC_TIER_IDS, UC_TOKEN_COGS_ANCHOR_USD, UNCLASSIFIED, UNDECLARED_AUDIENCE, UNIT_DIRECTIONS, UNJUDGED_VERDICTS, UNMET_ASK_THRESHOLD, UNSEGMENTED_AUDIENCE, UPDATE_USER_PROFILE_EMAIL_MAX, UPDATE_USER_PROFILE_NAME_MAX, UPDATE_USER_PROFILE_PICTURE_MAX, USER_INSIGHT_GROUP_BYS, USER_INSIGHT_METRICS, USER_INSIGHT_RANGES, USER_INSIGHT_RANGE_DAYS, USER_LEARNING_CONFIG_DEFAULTS, UnauthenticatedError, UnknownModelError, UpgradeRequiredError, VENDORED_INTERNAL_PACKAGES, VISITOR_ERROR_CODE_MAX_LENGTH, ValidationError, WALKTHROUGH_MAX_ANCHORS, WALKTHROUGH_MAX_DURATION_MS, WALKTHROUGH_MAX_PERFORMS, WALKTHROUGH_MAX_REVEALS, WALKTHROUGH_OUTCOMES, WALKTHROUGH_REVEAL_NAME_MAX, WALKTHROUGH_REVEAL_ROLE_PATTERN, WALK_CONTROLS_PER_PAGE, WALK_DIALS, WALK_DIAL_LABS_IDS, WALK_LIVE_WRITES_LABS_FEATURE_ID, WALK_NOMINATIONS_LABS_FEATURE_ID, WALK_POSTURES, WALK_SERVED_SPEC_FORMATS, WALK_SERVED_SPEC_KINDS, WEB_VITAL_METRICS, WELCOME_BINDING_TITLE_MAX, WELL_KNOWN_SPEC_PATHS, WHATSAPP_BUSINESS_NAME_MAX_CHARS, WHATSAPP_CHANNEL_LABS_FEATURE_ID, WHATSAPP_CHANNEL_TERMS_EN, WHATSAPP_CHANNEL_TERMS_VERSION, WHATSAPP_ID_PATTERN, WHATSAPP_LINKING_TERMS_EN, WHATSAPP_LINKING_TERMS_VERSION, WHATSAPP_RESOLVER_URL_MAX_LENGTH, WHATSAPP_SCOPE_MAX_CHARS, WHATSAPP_SECRET_MAX_LENGTH, WHATSAPP_TERMS_HISTORY, WIDGET_ANNOUNCEMENT_BODY_MAX, WIDGET_ANNOUNCEMENT_ID_PATTERN, WIDGET_ANNOUNCEMENT_TITLE_MAX, WIDGET_AVAILABILITY_MODES, WIDGET_DESIGN_KINDS, WIDGET_DESIGN_LANGUAGES, WIDGET_DEV_API_ORIGIN, WIDGET_DEV_SCRIPT_SRC, WIDGET_EMPTY_LOGO_KINDS, WIDGET_EMPTY_LOGO_SIZES, WIDGET_EXPAND_TARGETS, WIDGET_HEADER_LOGO_IMAGE_MAX_BYTES, WIDGET_HOME_SECTIONS, WIDGET_LAUNCHER_BLOCK_SIDES, WIDGET_LAUNCHER_ICONS, WIDGET_LAUNCHER_INLINE_SIDES, WIDGET_LAUNCHER_MARK_KINDS, WIDGET_LAUNCHER_POSITIONS, WIDGET_LAUNCHER_SHAPES, WIDGET_LOGO_IMAGE_DATA_URL_MAX_CHARS, WIDGET_LOGO_IMAGE_MAX_BYTES, WIDGET_LOGO_IMAGE_MIME_TYPES, WIDGET_MAX_ANNOUNCEMENTS, WIDGET_MAX_DISABLED_ACTIONS, WIDGET_PAGE_RULE_MATCH_OPERATORS, WIDGET_PROACTIVE_DWELL_MAX_SECONDS, WIDGET_PROACTIVE_EVENT_NAME_MAX, WIDGET_PROACTIVE_FRICTION_SIGNALS, WIDGET_PROACTIVE_FRUSTRATION_THRESHOLD_MAX, WIDGET_PROACTIVE_GOALS, WIDGET_PROACTIVE_LOCALES, WIDGET_PROACTIVE_MAX_CHIPS, WIDGET_PROACTIVE_MAX_RULES, WIDGET_PROACTIVE_PRESENTATIONS, WIDGET_PROACTIVE_RESERVED_EVENT_NAMES, WIDGET_PROACTIVE_ROUTE_MAX, WIDGET_PROACTIVE_RULE_ID_PATTERN, WIDGET_PROACTIVE_TEXT_MAX, WIDGET_PROACTIVE_TRIGGER_TYPES, WIDGET_PROACTIVE_VISITOR_TYPES, WIDGET_PROD_SCRIPT_SRC, WIDGET_SCRIPT_SRC, WIDGET_SIZES, WIDGET_SIZE_META, WIDGET_TEXT_DIRECTIONS, WIDGET_THEME_KEY_PATTERN, WIDGET_TOGGLE_DEFAULT_STATES, WIDGET_TOGGLE_SIZES, WIDGET_UNAVAILABLE_MESSAGE_MAX, WIKI_ARTICLE_STATUSES, WIKI_ARTICLE_TYPES, WIKI_LOCALE_REVIEW_STATES, WIKI_READING_LEVELS, WIKI_READING_ORDER, WIKI_START_HERE_TYPES, WIKI_VOICE_TONES, WINDOW_SCOPED_EXEC_METRICS, WIRE_WITNESS_METHODS, WITNESSED_RESPONSE_HEADERS, WITNESS_KINDS, WITNESS_OPERATION_NAME_PATTERN, WORKSPACE_GROUP_TYPE, WP_AJAX_METHOD, WalkNominationsFactSchema, WalkServedSpecKindSchema, WalkServedSpecPayloadSchema, WalkServedSpecSchema, WalkVisionFactSchema, WalkedPathSchema, WalkthroughAnchorSchema, WalkthroughOutcomeSchema, WalkthroughPayloadSchema, WalkthroughPerformDecisionSchema, WalkthroughRevealSchema, WelcomeDigestBindingSchema, WelcomeResponseSchema, WidgetAgentConfigSchema, WidgetAnnouncementSchema, WidgetAnnouncementsConfigSchema, WidgetAnonymousAccessConfigSchema, WidgetAnonymousSignInPromptSchema, WidgetAvailabilityConfigSchema, WidgetChromeConfigSchema, WidgetComponentOverrideSchema, WidgetComponentOverridesSchema, WidgetConfigDocumentSchema, WidgetCopilotModeConfigSchema, WidgetCopyConfigSchema, WidgetDesignBaseSchema, WidgetDesignContentSchema, WidgetDesignSchema, WidgetDisclosureConfigSchema, WidgetDraggableConfigSchema, WidgetEmptyLogoConfigSchema, WidgetExpandConfigSchema, WidgetFrameAgentConfigSchema, WidgetHeaderLogoImageSrcSchema, WidgetHeaderToggleConfigSchema, WidgetHomeConfigSchema, WidgetHostActionsConfigSchema, WidgetLauncherBadgeSchema, WidgetLauncherConfigSchema, WidgetLauncherMarkSchema, WidgetLauncherPlacementSchema, WidgetLocalizationConfigSchema, WidgetLogoImageSrcSchema, WidgetPageRuleInputSchema, WidgetPageRuleMatchSchema, WidgetPageRuleOverridesReadSchema, WidgetPageRuleOverridesSchema, WidgetPageRuleUrlPatternSchema, WidgetPaletteSchema, WidgetProactiveAudienceSchema, WidgetProactiveConfigSchema, WidgetProactiveLimitsSchema, WidgetProactiveMessageSchema, WidgetProactiveQuietHoursSchema, WidgetProactiveRuleSchema, WidgetProactiveTriggerSchema, WidgetRichComponentsConfigSchema, WidgetSessionsConfigSchema, WidgetSizeDesignAssignmentsSchema, WidgetSizeModeConfigSchema, WidgetSizeOverrideSchema, WidgetSizeOverridesSchema, WidgetSizingConfigSchema, WidgetStarterItemSchema, WidgetStartersConfigSchema, WidgetSurfaceSettingsSchema, WidgetThemeKeySchema, WidgetVizExpandConfigSchema, WitnessKindSchema, actionsAllowedForProvenance, activeTaxonomyEntries, activeTaxonomyKeys, admitServedSpecs, admitsMechanism, admittedMechanisms, adoptedStyleOverrideCss, agentPolicyFor, allowedBits, analyticsRoomPath, anchorPageScope, anchorResolvesElement, answerSpeedThresholdFor, applyComparisonTrigger, articleSlug, assertCaptureGateClear, assertProductionConfigReady, assignVariant, attributeMatchToMatchRule, audienceMembershipSource, auditActionTypes, auditActionTypesInCategory, auditAllChartPresets, auditCategoryKey, auditChartPaletteContrast, auditChartPreset, auditEvent, auditEventLabelKey, auditEventSentenceKey, auditSeverityKey, autonomyDialsFor, autonomyModeMatching, availableEvidence, behavioralFactListSchema, behavioralFactSchema, buildCapabilityDossierPrompt, buildClaudeCodeCommand, buildClaudeDesktopConfig, buildCompliancePostureReport, buildCursorInstallLink, buildDashboardInstallBlocks, buildEmbedSnippet, buildExportFilename, buildGooseInstallLink, buildGraphqlRequestBody, buildIdentitySnippet, buildImpactShareUrl, buildIntakeSpecFromDraft, buildIntegrationPlan, buildLocalEnvBlocks, buildLocalizedComprehensionPrompt, buildMcpbBundle, buildMcpbManifest, buildMcpbServerLauncher, buildMetricFromTemplate, buildProfileTransfer, buildScorecard, buildSecretsEnvBlock, buildSentryAuthHeader, buildSentryEnvelope, buildStoreZip, buildTypedGraphqlDocument, buildVsCodeInstallLink, buildWindsurfConfig, businessChangeKind, businessDeltaWireSchema, businessOutcomeVerdict, businessReviewWireSchema, businessSatisfactionThresholdFor, businessVerdictWireSchema, canPrefillIntakeField, canonicalExtension, canonicalRouteKey, canonicalRoutePath, capGraphemes, capabilityDossierGroupOf, capabilityDossierGroupsOf, capabilityDossierToolJsonSchema, capabilityOverridesSchema, cappedExtractedRadiusPx, carriesFreeText, cellToString, changedPersonaFields, chartRampMatchesPreset, checklistProgress, clamp, clampFunnel, classifyAttributeValue, classifyAudienceReportability, classifyGraphqlResponse, classifyPreview, coerceTopicKey, collectCustomerTextSchemaPaths, collectFlowSensitiveFields, collectSensitiveFieldNames, compareEngagementVerdicts, compareRolloutArms, compareRolloutVerdicts, compareSuccessMetricVerdicts, compareVariants, complianceCriterion, componentIdFromToolName, composeAudienceOutcome, composeAudienceOutcomes, composeGoalAttainment, composeReviewCustomMetrics, composeReviewVolume, composeSystemModel, computeBusinessDeltas, computeBusinessVerdict, computeCostUsd, computeDelta, computeHoursSaved, computeOverageUsd, computeTurnUsageCredits, conditionalSendAdmitsIntent, conditionalSendTableIsWellFormed, contentSearch, conversationForwardingEntrySchema, conversationForwardingPayloadSchema, conversionRate, cosineSimilarity, cosineThreshold, countGraphemes, countMatchRuleConditions, customCssDeclaresToken, customMetricContribution, customerFacingPackages, customerTextDefault, customerTextSchema, dayAfter, decideM2Force, decodeContentTypes, decodeNudgeRef, deriveIntentKey, designContentHash, designContentToThemeConfig, detectLocaleFromAcceptLanguage, detectRegression, detectWidgetInstallation, detectedDesignFromReport, detectedStyleDomain, detectedSuggestionsFromTokens, diffPersonaConfig, digestScheduleInputSchema, directiveReleaseIdentity, discriminatorOptionKeys, effectiveConversationRetentionDays, effectiveIncludedRateUsd, emptySealedOperations, encodeBase64Utf8, encodeNudgeRef, enforceChromeDisclosureFloor, engagementVerdict, entitlementsFor, entityKey, evaluateCaptureGate, evaluateEligibility, evaluateFatigue, evaluateReviewPrompt, evaluateSchedule, execMetricRawValues, expandFamily, experiencesKillableKeys, experimentalFeatureDefinitionSchema, explainQuickReplyRun, extractCalledKeys, extractDeclaredKeys, extractDynamicKeyFamilies, extractLiteralKeys, extractPluralKeys, extractQuickReplies, extractQuickReplyRun, extractTemplatePrefixes, findExperimentalFeature, findForbiddenServedFields, findFrontierFeature, findOfferedFiles, findOrphanKeys, findStarterTemplate, findUndefinedCalls, fingerprintBackend, flattenFlowSteps, foldEvents, forensicEventFamily, formatCurrency, formatDate, formatFileSize, formatHex, formatNumber, formatRelativeTime, formatReportPeriod, freeTextKeys, frontierFeatureDefinitionSchema, frontierKillableKeys, gatedSpecProbes, getCanonicalResponses, getPublishedPackage, getUcTier, goalAttainmentWireSchema, goalIsVerifiable, goalsMet, goalsWithTargets, governCollision, governUnits, gradeMetric, gradeRate, grantDaysLeft, graphqlArgsFullyTyped, graphqlOperationExecutable, grossMarginAtRate, guidanceSchema, guideIdsReferencedBy, guideRunBucket, hammingSimilarity64, harvestResponseSignals, hasAnyBranch, hasDetectedBrandAccent, hexContrast, hexToHsv, holdoutSalt, hostActionIdFromToolName, hostActionToolName, hslToHsv, hslToRgb, hsvToHex, hsvToHsl, hsvToRgb, identifyBatchSchema, identifyBodySchema, impactReportSubscriptionInputSchema, impactShareCreateInputSchema, impactShareEnvironmentSchema, impactShareWindowSchema, impressionsObserved, inferEntityModel, inferJsonSchema, inferJsonSchemaFromText, intakeAskIfNames, intakeFieldsOf, introspectableSurface, isA6Gated, isAcceptedExtension, isAdoptableHexColor, isAnalyticsEventName, isAskingShape, isBedrockEuPricedModelId, isBusinessSignal, isCapabilityDossierField, isCapabilityDossierGroup, isClassifiedPageType, isCompetitorHandling, isConversationModelPreference, isConversationRetentionChoice, isCustomerTextClean, isDesignPart, isDigestDue, isDigestInterval, isDigestOverdue, isDirectiveReleaseKey, isDriftFinding, isDurableAnchorMiss, isEmbedOriginAllowed, isEscalationKind, isExecutionBias, isExportableWikiStatus, isExportedTableResult, isFeedbackIssueType, isFlooredExecutionVariant, isFrontierKilled, isGradedReviewMetric, isGuidanceEmpty, isHostActionToolName, isIdentityBound, isInDismissalCooldown, isInHoldout, isInRollout, isIntakeFieldSensitive, isInteractionEventKind, isInterruptive, isKeyReachable, isKnownAuditAction, isKnownExperimentalFeature, isLocalWidgetOrigin, isLocaleHumanReviewed, isModalityClass, isMonitoringTargetMetric, isNegativeScope, isOfferedFile, isOpenFindingStatus, isOperationWitnessKind, isOperatorTextClean, isPackageLive, isPlacementAllowedOnMobile, isPlacementKilled, isPrivateOrReservedIPv4, isPrivateOrReservedIPv6, isProcedureIntentKey, isProfileInRollout, isProjectableWikiStatus, isPseudonymousSub, isRefusalClass, isRenderComponentToolName, isRenderShape, isResolutionBillingMetadata, isScreenAnchoredPlacement, isSecretKey, isSensitiveDomain, isSensitiveDomainHandling, isStreamTransportStage, isSyncanixError, isTurnPlanShape, isTurnShape, isUnscoped, isUntargeted, isValidComponentId, isValidCustomTopicKey, isValidFrameOrigin, isValidHostActionId, isValidMediaType, isValidSentryDsn, isVerifiedByEvidence, isVisitorSubShape, isWalkControlId, isWalkedPath, isWindowScopedExecMetric, isWordPressAjaxAction, isWordPressAjaxPath, isoMonthKey, isoWeekKey, joinWordPressAjaxPath, lambdaFunctionName, lambdaHandlerString, learnProcedure, learnedInsightListSchema, learnedInsightSchema, legacyConfigToDesignContent, legacyConfigToSizing, legacyFrontierKillVars, liveChatEngineMetrics, livePackages, loadCatalog, localizedComprehensionResponseSchema, localizedComprehensionToolJsonSchema, logoImageSrcSchema, longestServedWindow, m0ComposerFor, m2ForcesOnModel, mapProactiveRuleToEngagement, markdownToPlainText, maskSensitiveValues, matchRuleHasActivityCondition, matchRuleSchema, matchWidgetPageRule, matchWidgetPageRules, matchesWidgetPageRule, matchesWidgetPageRuleUrl, matchingChartPreset, mayOpenInNewTab, mayShowCounts, mayShowRates, mediaTypeForFilename, mergeLiveRefusals, mergeManagedBlock, mergeNamedReasons, mergeSealedOperations, mergeSealedSockets, mergeWidgetPageOverrides, mergedProjectionTokens, methodPathToOperation, metricNameSchema, metricPredicateSchema, missingAnswers, monitoringTargetOverrideSchema, multiplicityBucket, nearnessThreshold, neutralizeFormula, nextChecklistItem, nextDigestRunUtc, nextFiredVerdict, nextReplayStep, normalizeChartSeries, normalizeClaimCaptureAllowlist, normalizeCustomHours, normalizeEmbedKey, normalizeEmbedOrigin, normalizeFindings, normalizeMediaType, normalizeObservedAudience, normalizePinnedAttributeKeys, normalizeStateText, normalizeTurnPlanInput, normalizeWidgetOrigin, notificationActionSchema, notificationIngestSchema, notificationKindSchema, openedStreamTransportLegs, operationsEqual, operatorOnlyActionKinds, orderArticlesForReading, overageUsageCredits, pageTypeGroup, parseAbsoluteHttpUrl, parseAutonomyMode, parseCsp, parseDeliveredPageRules, parseDigestScheduleInput, parseDirectiveReleaseRollouts, parseDraftedUnitCopy, parseExperiencesKillPolicy, parseFrameOriginsCsv, parseFrontierKillPolicy, parseGuidanceJson, parseGuideRecordingMessage, parseHex, parseInsightRecord, parseIntakeSpec, parsePersonaLanguage, parsePersonaTargeting, parseProcedure, parseProfileTransfer, parseRadiusScale, parseRefusalStyleCategories, parseRestrictedTopics, parseSentryDsn, parseSitemapDocument, parseStreamTransportStage, parseSurfaceSettings, parseToolScope, parseTypedWidgetOrigin, parseWalkPosture, parseWidgetConfig, parseWidgetDesign, parseWidgetOrigin, patchCspForWidget, periodBounds, periodDayCount, personaLanguageFromLegacy, personaLanguageToLegacy, personaTargetingSchema, pickOpener, placementClass, planGathersInput, planIsActionable, planeOfKind, postedBlendedAverageUc, postedInteractionPrice, postedInteractionsForUsageCredits, postedRungId, prettifyActionType, previousPeriod, profileTransferSchema, projectFlowSubmission, projectionDigest, providerFamilyForModel, pseudoLocalize, railFeeUsd, rankOpeners, readAasaRoutes, readIntrospectionFact, readIntrospectionSchemaDocument, readJsonSpecDeclaration, readSiteWalkCeilingOverride, readWidgetPageRuleOverrides, readYamlSpecDeclaration, realizedShapeFor, recipeKey, redactCaptureHeaders, redactCaptureLeaf, redactSecretsDeep, refusalEvidenceOf, refusalMessageCost, refusalSentence, refusalStyleCategoriesSchema, refusedActionsForProvenance, remapTopic, renderComponentToolName, rendersOnHostPage, reportCadenceSchema, reportPeriodKey, reportPeriodSchema, reportedOutcomeBatchSchema, reportedOutcomeKeySchema, reportedOutcomeSchema, requiresElementAnchor, resolveActiveLane, resolveAgentAvatar, resolveAgentName, resolveAnalyticsRoom, resolveAppConfig, resolveBusinessTargets, resolveColumns, resolveComponentUseWhen, resolveCustomerText, resolveDigestSchedule, resolveDirectiveReleaseArms, resolveEffectivePageState, resolveEffectiveTaxonomy, resolveEffectiveWidgetConfig, resolveFlowPath, resolveGrantState, resolveHomeSections, resolveIntakeText, resolveLauncherMark, resolveModelLimits, resolveMonitoringTarget, resolveMonitoringTargets, resolvePriorityLocale, resolveShapeRow, resolveSurvey, resolveUcGateOutcome, resolveWalkDial, resolveWidgetEmbed, resolveWidgetPageRuleAxes, resolveWidgetPageRuleMatchOptions, resolveWorkspaceAccess, resolvedRateThresholdFor, restrictedTopicsSchema, reviewCustomMetricWireSchema, reviewVolumePeak, reviewVolumePointWireSchema, rgbToHsl, rgbToHsv, rolloutBucket, rolloutVerdict, routeFromSearchTemplate, routeProvenanceOf, safeParseSurfaceSettings, safeParseWidgetConfig, safeParseWidgetDesign, sanitiseOperatorText, sanitizeCustomerTextTree, sanitizeDownloadFilename, sanitizeFrameOrigins, satisfactionThresholdFor, scaledRadius, scaledRadiusRem, scanOfferedFiles, scoreFromFindings, screenComprehensionCorrection, screenComprehensionProposal, screenFormRefusals, screenLocalizedComprehensionProposal, screenSiteWalkDriver, sealedOperationBudget, sealedPressBudget, sealedSocketKey, segmentRoles, selectCapabilityTemplate, selectProcedure, selectSitemapSeeds, sentryEventPayloadSchema, serializeCsp, servesNewVersion, setCustomerTextDefault, severityAtLeast, severityRank, sharedDurationSchema, sharedImpactMetricsSchema, sharedImpactReportSchema, sharedImpactStatusSchema, shouldFireMetricAlarm, shouldProduceIntakeSpec, simhash64, siteWalkHandoffFragment, siteWalkHandoffLink, siteWalkPageTimeoutMs, siteWalkRunCeilings, siteWalkSessionWindowMs, sitemapLocOnOrigin, slugify, snoozeUntil, sortWidgetPageRulesByPrecedence, sourceServesWindow, specPathsForBackend, splitGraphemes, splitStartHere, splitWordPressAjaxPath, stableBucket, stableHash, startOfUtcHour, starterTemplatePatch, stateToken, statesEquivalent, statusCanServe, stopFor, structuralToken, subjectClass, successMetricDefinitionSchema, successMetricVerdict, suggestedQuestion, suggestedQuestions, synthesiseJourneys, synthesizeFixtures, templateForShape, tenantSecretPath, termVector, toCsv, toDelimited, toDocFindingResolvedReason, toDocFindingStatus, toDocFindingType, toDocReportReason, toEligiblePayload, toGraphqlLiteral, toJson, toLlmsTxt, toPageActionRoutes, toServedGoal, toTranscriptJson, toTranscriptMarkdown, toTranscriptText, toTsv, toTurnPlanPrediction, toTxt, toWikiArticleStatus, toWikiArticleType, toWikiLocaleReviewState, toWikiMarkdown, toWikiReadingLevel, toWikiVoiceTone, toolScopeMatches, toolScopeSchema, turnPlanJsonSchema, uniqueSecretNames, updateUserProfileInputSchema, userInsightQuerySchema, userInsightViewInputSchema, userLearningConfigSchema, utcDay, validateAnswer, validateAttributeKey, validateForensicAuditEvent, validateIntakeSpecTree, validateMonitoringTargetValue, validateScopeEscalation, validateScopePolicy, validateScopeTopics, variantKey, verdictDestinationPath, walkDialForLabsId, walkGrantsFor, walkedPageName, whatsappIdSchema, whatsappSecretName, widgetNotificationListSchema, widgetNotificationViewSchema, widgetOriginsMatch, widgetPageRulesPayloadBytes, wikiArticleRung, windowPeriod, withoutEndUserSub, witnessKindFromMethod, wordPressAjaxActionFloor };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map